/******/ (function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/ var installedModules = {};
  /******/
  /******/ // The require function
  /******/ function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/ if (installedModules[moduleId]) {
      /******/ return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/ var module = (installedModules[moduleId] = {
      /******/ i: moduleId,
      /******/ l: false,
      /******/ exports: {}
      /******/
    });
    /******/
    /******/ // Execute the module function
    /******/ modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/ module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/ return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/ __webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/ __webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/ __webpack_require__.d = function (exports, name, getter) {
    /******/ if (!__webpack_require__.o(exports, name)) {
      /******/ Object.defineProperty(exports, name, {
        /******/ configurable: false,
        /******/ enumerable: true,
        /******/ get: getter
        /******/
      });
      /******/
    }
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/ __webpack_require__.n = function (module) {
    /******/ var getter =
      module && module.__esModule
        ? /******/ function getDefault() {
            return module['default'];
          }
        : /******/ function getModuleExports() {
            return module;
          };
    /******/ __webpack_require__.d(getter, 'a', getter);
    /******/ return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/ __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/ __webpack_require__.p = '';
  /******/
  /******/ // Load entry module and return exports
  /******/ return __webpack_require__((__webpack_require__.s = 176));
  /******/
})(
  /************************************************************************/
  /******/ [
    /* 0 */
    /***/ function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var core = __webpack_require__(6);
      var hide = __webpack_require__(16);
      var redefine = __webpack_require__(13);
      var ctx = __webpack_require__(23);
      var PROTOTYPE = 'prototype';

      var $export = function (type, name, source) {
        var IS_FORCED = type & $export.F;
        var IS_GLOBAL = type & $export.G;
        var IS_STATIC = type & $export.S;
        var IS_PROTO = type & $export.P;
        var IS_BIND = type & $export.B;
        var target = IS_GLOBAL
          ? global
          : IS_STATIC
            ? global[name] || (global[name] = {})
            : (global[name] || {})[PROTOTYPE];
        var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
        var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
        var key, own, out, exp;
        if (IS_GLOBAL) source = name;
        for (key in source) {
          // contains in native
          own = !IS_FORCED && target && target[key] !== undefined;
          // export native or passed
          out = (own ? target : source)[key];
          // bind timers to global for call from export context
          exp =
            IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
          // extend global
          if (target) redefine(target, key, out, type & $export.U);
          // export
          if (exports[key] != out) hide(exports, key, exp);
          if (IS_PROTO && expProto[key] != out) expProto[key] = out;
        }
      };
      global.core = core;
      // type bitmap
      $export.F = 1; // forced
      $export.G = 2; // global
      $export.S = 4; // static
      $export.P = 8; // proto
      $export.B = 16; // bind
      $export.W = 32; // wrap
      $export.U = 64; // safe
      $export.R = 128; // real proto method for `library`
      module.exports = $export;

      /***/
    },
    /* 1 */
    /***/ function (module, exports) {
      module.exports = function (exec) {
        try {
          return !!exec();
        } catch (e) {
          return true;
        }
      };

      /***/
    },
    /* 2 */
    /***/ function (module, exports) {
      module.exports = function (it) {
        return typeof it === 'object' ? it !== null : typeof it === 'function';
      };

      /***/
    },
    /* 3 */
    /***/ function (module, exports) {
      // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
      var global = (module.exports =
        typeof window != 'undefined' && window.Math == Math
          ? window
          : typeof self != 'undefined' && self.Math == Math
            ? self
            : // eslint-disable-next-line no-new-func
              Function('return this')());
      if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

      /***/
    },
    /* 4 */
    /***/ function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(2);
      module.exports = function (it) {
        if (!isObject(it)) throw TypeError(it + ' is not an object!');
        return it;
      };

      /***/
    },
    /* 5 */
    /***/ function (module, exports, __webpack_require__) {
      var store = __webpack_require__(79)('wks');
      var uid = __webpack_require__(39);
      var Symbol = __webpack_require__(3).Symbol;
      var USE_SYMBOL = typeof Symbol == 'function';

      var $exports = (module.exports = function (name) {
        return (
          store[name] || (store[name] = (USE_SYMBOL && Symbol[name]) || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name))
        );
      });

      $exports.store = store;

      /***/
    },
    /* 6 */
    /***/ function (module, exports) {
      var core = (module.exports = { version: '2.5.1' });
      if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

      /***/
    },
    /* 7 */
    /***/ function (module, exports, __webpack_require__) {
      var anObject = __webpack_require__(4);
      var IE8_DOM_DEFINE = __webpack_require__(119);
      var toPrimitive = __webpack_require__(32);
      var dP = Object.defineProperty;

      exports.f = __webpack_require__(9)
        ? Object.defineProperty
        : function defineProperty(O, P, Attributes) {
            anObject(O);
            P = toPrimitive(P, true);
            anObject(Attributes);
            if (IE8_DOM_DEFINE)
              try {
                return dP(O, P, Attributes);
              } catch (e) {
                /* empty */
              }
            if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
            if ('value' in Attributes) O[P] = Attributes.value;
            return O;
          };

      /***/
    },
    /* 8 */
    /***/ function (module, exports, __webpack_require__) {
      // 7.1.15 ToLength
      var toInteger = __webpack_require__(30);
      var min = Math.min;
      module.exports = function (it) {
        return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
      };

      /***/
    },
    /* 9 */
    /***/ function (module, exports, __webpack_require__) {
      // Thank's IE8 for his funny defineProperty
      module.exports = !__webpack_require__(1)(function () {
        return (
          Object.defineProperty({}, 'a', {
            get: function () {
              return 7;
            }
          }).a != 7
        );
      });

      /***/
    },
    /* 10 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      exports.__esModule = true;

      exports.default = function (instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError('Cannot call a class as a function');
        }
      };

      /***/
    },
    /* 11 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      exports.__esModule = true;

      var _defineProperty = __webpack_require__(358);

      var _defineProperty2 = _interopRequireDefault(_defineProperty);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      exports.default = (function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            (0, _defineProperty2.default)(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      })();

      /***/
    },
    /* 12 */
    /***/ function (module, exports) {
      var hasOwnProperty = {}.hasOwnProperty;
      module.exports = function (it, key) {
        return hasOwnProperty.call(it, key);
      };

      /***/
    },
    /* 13 */
    /***/ function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var hide = __webpack_require__(16);
      var has = __webpack_require__(12);
      var SRC = __webpack_require__(39)('src');
      var TO_STRING = 'toString';
      var $toString = Function[TO_STRING];
      var TPL = ('' + $toString).split(TO_STRING);

      __webpack_require__(6).inspectSource = function (it) {
        return $toString.call(it);
      };

      (module.exports = function (O, key, val, safe) {
        var isFunction = typeof val == 'function';
        if (isFunction) has(val, 'name') || hide(val, 'name', key);
        if (O[key] === val) return;
        if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
        if (O === global) {
          O[key] = val;
        } else if (!safe) {
          delete O[key];
          hide(O, key, val);
        } else if (O[key]) {
          O[key] = val;
        } else {
          hide(O, key, val);
        }
        // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
      })(Function.prototype, TO_STRING, function toString() {
        return (typeof this == 'function' && this[SRC]) || $toString.call(this);
      });

      /***/
    },
    /* 14 */
    /***/ function (module, exports, __webpack_require__) {
      // 7.1.13 ToObject(argument)
      var defined = __webpack_require__(29);
      module.exports = function (it) {
        return Object(defined(it));
      };

      /***/
    },
    /* 15 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      var fails = __webpack_require__(1);
      var defined = __webpack_require__(29);
      var quot = /"/g;
      // B.2.3.2.1 CreateHTML(string, tag, attribute, value)
      var createHTML = function (string, tag, attribute, value) {
        var S = String(defined(string));
        var p1 = '<' + tag;
        if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
        return p1 + '>' + S + '</' + tag + '>';
      };
      module.exports = function (NAME, exec) {
        var O = {};
        O[NAME] = exec(createHTML);
        $export(
          $export.P +
            $export.F *
              fails(function () {
                var test = ''[NAME]('"');
                return test !== test.toLowerCase() || test.split('"').length > 3;
              }),
          'String',
          O
        );
      };

      /***/
    },
    /* 16 */
    /***/ function (module, exports, __webpack_require__) {
      var dP = __webpack_require__(7);
      var createDesc = __webpack_require__(38);
      module.exports = __webpack_require__(9)
        ? function (object, key, value) {
            return dP.f(object, key, createDesc(1, value));
          }
        : function (object, key, value) {
            object[key] = value;
            return object;
          };

      /***/
    },
    /* 17 */
    /***/ function (module, exports, __webpack_require__) {
      // to indexed object, toObject with fallback for non-array-like ES3 strings
      var IObject = __webpack_require__(59);
      var defined = __webpack_require__(29);
      module.exports = function (it) {
        return IObject(defined(it));
      };

      /***/
    },
    /* 18 */
    /***/ function (module, exports) {
      // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
      var global = (module.exports =
        typeof window != 'undefined' && window.Math == Math
          ? window
          : typeof self != 'undefined' && self.Math == Math
            ? self
            : // eslint-disable-next-line no-new-func
              Function('return this')());
      if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

      /***/
    },
    /* 19 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var bind = __webpack_require__(170);
      var isBuffer = __webpack_require__(432);

      /*global toString:true*/

      // utils is a library of generic helper functions non-specific to axios

      var toString = Object.prototype.toString;

      /**
       * Determine if a value is an Array
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is an Array, otherwise false
       */
      function isArray(val) {
        return toString.call(val) === '[object Array]';
      }

      /**
       * Determine if a value is an ArrayBuffer
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is an ArrayBuffer, otherwise false
       */
      function isArrayBuffer(val) {
        return toString.call(val) === '[object ArrayBuffer]';
      }

      /**
       * Determine if a value is a FormData
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is an FormData, otherwise false
       */
      function isFormData(val) {
        return typeof FormData !== 'undefined' && val instanceof FormData;
      }

      /**
       * Determine if a value is a view on an ArrayBuffer
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
       */
      function isArrayBufferView(val) {
        var result;
        if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
          result = ArrayBuffer.isView(val);
        } else {
          result = val && val.buffer && val.buffer instanceof ArrayBuffer;
        }
        return result;
      }

      /**
       * Determine if a value is a String
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a String, otherwise false
       */
      function isString(val) {
        return typeof val === 'string';
      }

      /**
       * Determine if a value is a Number
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Number, otherwise false
       */
      function isNumber(val) {
        return typeof val === 'number';
      }

      /**
       * Determine if a value is undefined
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if the value is undefined, otherwise false
       */
      function isUndefined(val) {
        return typeof val === 'undefined';
      }

      /**
       * Determine if a value is an Object
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is an Object, otherwise false
       */
      function isObject(val) {
        return val !== null && typeof val === 'object';
      }

      /**
       * Determine if a value is a Date
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Date, otherwise false
       */
      function isDate(val) {
        return toString.call(val) === '[object Date]';
      }

      /**
       * Determine if a value is a File
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a File, otherwise false
       */
      function isFile(val) {
        return toString.call(val) === '[object File]';
      }

      /**
       * Determine if a value is a Blob
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Blob, otherwise false
       */
      function isBlob(val) {
        return toString.call(val) === '[object Blob]';
      }

      /**
       * Determine if a value is a Function
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Function, otherwise false
       */
      function isFunction(val) {
        return toString.call(val) === '[object Function]';
      }

      /**
       * Determine if a value is a Stream
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Stream, otherwise false
       */
      function isStream(val) {
        return isObject(val) && isFunction(val.pipe);
      }

      /**
       * Determine if a value is a URLSearchParams object
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a URLSearchParams object, otherwise false
       */
      function isURLSearchParams(val) {
        return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
      }

      /**
       * Trim excess whitespace off the beginning and end of a string
       *
       * @param {String} str The String to trim
       * @returns {String} The String freed of excess whitespace
       */
      function trim(str) {
        return str.replace(/^\s*/, '').replace(/\s*$/, '');
      }

      /**
       * Determine if we're running in a standard browser environment
       *
       * This allows axios to run in a web worker, and react-native.
       * Both environments support XMLHttpRequest, but not fully standard globals.
       *
       * web workers:
       *  typeof window -> undefined
       *  typeof document -> undefined
       *
       * react-native:
       *  navigator.product -> 'ReactNative'
       */
      function isStandardBrowserEnv() {
        if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
          return false;
        }
        return typeof window !== 'undefined' && typeof document !== 'undefined';
      }

      /**
       * Iterate over an Array or an Object invoking a function for each item.
       *
       * If `obj` is an Array callback will be called passing
       * the value, index, and complete array for each item.
       *
       * If 'obj' is an Object callback will be called passing
       * the value, key, and complete object for each property.
       *
       * @param {Object|Array} obj The object to iterate
       * @param {Function} fn The callback to invoke for each item
       */
      function forEach(obj, fn) {
        // Don't bother if no value provided
        if (obj === null || typeof obj === 'undefined') {
          return;
        }

        // Force an array if not already something iterable
        if (typeof obj !== 'object') {
          /*eslint no-param-reassign:0*/
          obj = [obj];
        }

        if (isArray(obj)) {
          // Iterate over array values
          for (var i = 0, l = obj.length; i < l; i++) {
            fn.call(null, obj[i], i, obj);
          }
        } else {
          // Iterate over object keys
          for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
              fn.call(null, obj[key], key, obj);
            }
          }
        }
      }

      /**
       * Accepts varargs expecting each argument to be an object, then
       * immutably merges the properties of each object and returns result.
       *
       * When multiple objects contain the same key the later object in
       * the arguments list will take precedence.
       *
       * Example:
       *
       * ```js
       * var result = merge({foo: 123}, {foo: 456});
       * console.log(result.foo); // outputs 456
       * ```
       *
       * @param {Object} obj1 Object to merge
       * @returns {Object} Result of all merge properties
       */
      function merge(/* obj1, obj2, obj3, ... */) {
        var result = {};
        function assignValue(val, key) {
          if (typeof result[key] === 'object' && typeof val === 'object') {
            result[key] = merge(result[key], val);
          } else {
            result[key] = val;
          }
        }

        for (var i = 0, l = arguments.length; i < l; i++) {
          forEach(arguments[i], assignValue);
        }
        return result;
      }

      /**
       * Extends object a by mutably adding to it the properties of object b.
       *
       * @param {Object} a The object to be extended
       * @param {Object} b The object to copy properties from
       * @param {Object} thisArg The object to bind function to
       * @return {Object} The resulting value of object a
       */
      function extend(a, b, thisArg) {
        forEach(b, function assignValue(val, key) {
          if (thisArg && typeof val === 'function') {
            a[key] = bind(val, thisArg);
          } else {
            a[key] = val;
          }
        });
        return a;
      }

      module.exports = {
        isArray: isArray,
        isArrayBuffer: isArrayBuffer,
        isBuffer: isBuffer,
        isFormData: isFormData,
        isArrayBufferView: isArrayBufferView,
        isString: isString,
        isNumber: isNumber,
        isObject: isObject,
        isUndefined: isUndefined,
        isDate: isDate,
        isFile: isFile,
        isBlob: isBlob,
        isFunction: isFunction,
        isStream: isStream,
        isURLSearchParams: isURLSearchParams,
        isStandardBrowserEnv: isStandardBrowserEnv,
        forEach: forEach,
        merge: merge,
        extend: extend,
        trim: trim
      };

      /***/
    },
    /* 20 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var fails = __webpack_require__(1);

      module.exports = function (method, arg) {
        return (
          !!method &&
          fails(function () {
            // eslint-disable-next-line no-useless-call
            arg
              ? method.call(
                  null,
                  function () {
                    /* empty */
                  },
                  1
                )
              : method.call(null);
          })
        );
      };

      /***/
    },
    /* 21 */
    /***/ function (module, exports) {
      var core = (module.exports = { version: '2.5.1' });
      if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

      /***/
    },
    /* 22 */
    /***/ function (module, exports, __webpack_require__) {
      var store = __webpack_require__(156)('wks');
      var uid = __webpack_require__(157);
      var Symbol = __webpack_require__(18).Symbol;
      var USE_SYMBOL = typeof Symbol == 'function';

      var $exports = (module.exports = function (name) {
        return (
          store[name] || (store[name] = (USE_SYMBOL && Symbol[name]) || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name))
        );
      });

      $exports.store = store;

      /***/
    },
    /* 23 */
    /***/ function (module, exports, __webpack_require__) {
      // optional / simple context binding
      var aFunction = __webpack_require__(24);
      module.exports = function (fn, that, length) {
        aFunction(fn);
        if (that === undefined) return fn;
        switch (length) {
          case 1:
            return function (a) {
              return fn.call(that, a);
            };
          case 2:
            return function (a, b) {
              return fn.call(that, a, b);
            };
          case 3:
            return function (a, b, c) {
              return fn.call(that, a, b, c);
            };
        }
        return function (/* ...args */) {
          return fn.apply(that, arguments);
        };
      };

      /***/
    },
    /* 24 */
    /***/ function (module, exports) {
      module.exports = function (it) {
        if (typeof it != 'function') throw TypeError(it + ' is not a function!');
        return it;
      };

      /***/
    },
    /* 25 */
    /***/ function (module, exports, __webpack_require__) {
      var pIE = __webpack_require__(60);
      var createDesc = __webpack_require__(38);
      var toIObject = __webpack_require__(17);
      var toPrimitive = __webpack_require__(32);
      var has = __webpack_require__(12);
      var IE8_DOM_DEFINE = __webpack_require__(119);
      var gOPD = Object.getOwnPropertyDescriptor;

      exports.f = __webpack_require__(9)
        ? gOPD
        : function getOwnPropertyDescriptor(O, P) {
            O = toIObject(O);
            P = toPrimitive(P, true);
            if (IE8_DOM_DEFINE)
              try {
                return gOPD(O, P);
              } catch (e) {
                /* empty */
              }
            if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
          };

      /***/
    },
    /* 26 */
    /***/ function (module, exports, __webpack_require__) {
      // most Object methods by ES6 should accept primitives
      var $export = __webpack_require__(0);
      var core = __webpack_require__(6);
      var fails = __webpack_require__(1);
      module.exports = function (KEY, exec) {
        var fn = (core.Object || {})[KEY] || Object[KEY];
        var exp = {};
        exp[KEY] = exec(fn);
        $export(
          $export.S +
            $export.F *
              fails(function () {
                fn(1);
              }),
          'Object',
          exp
        );
      };

      /***/
    },
    /* 27 */
    /***/ function (module, exports, __webpack_require__) {
      // 0 -> Array#forEach
      // 1 -> Array#map
      // 2 -> Array#filter
      // 3 -> Array#some
      // 4 -> Array#every
      // 5 -> Array#find
      // 6 -> Array#findIndex
      var ctx = __webpack_require__(23);
      var IObject = __webpack_require__(59);
      var toObject = __webpack_require__(14);
      var toLength = __webpack_require__(8);
      var asc = __webpack_require__(135);
      module.exports = function (TYPE, $create) {
        var IS_MAP = TYPE == 1;
        var IS_FILTER = TYPE == 2;
        var IS_SOME = TYPE == 3;
        var IS_EVERY = TYPE == 4;
        var IS_FIND_INDEX = TYPE == 6;
        var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
        var create = $create || asc;
        return function ($this, callbackfn, that) {
          var O = toObject($this);
          var self = IObject(O);
          var f = ctx(callbackfn, that, 3);
          var length = toLength(self.length);
          var index = 0;
          var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
          var val, res;
          for (; length > index; index++)
            if (NO_HOLES || index in self) {
              val = self[index];
              res = f(val, index, O);
              if (TYPE) {
                if (IS_MAP)
                  result[index] = res; // map
                else if (res)
                  switch (TYPE) {
                    case 3:
                      return true; // some
                    case 5:
                      return val; // find
                    case 6:
                      return index; // findIndex
                    case 2:
                      result.push(val); // filter
                  }
                else if (IS_EVERY) return false; // every
              }
            }
          return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
        };
      };

      /***/
    },
    /* 28 */
    /***/ function (module, exports) {
      var toString = {}.toString;

      module.exports = function (it) {
        return toString.call(it).slice(8, -1);
      };

      /***/
    },
    /* 29 */
    /***/ function (module, exports) {
      // 7.2.1 RequireObjectCoercible(argument)
      module.exports = function (it) {
        if (it == undefined) throw TypeError("Can't call method on  " + it);
        return it;
      };

      /***/
    },
    /* 30 */
    /***/ function (module, exports) {
      // 7.1.4 ToInteger
      var ceil = Math.ceil;
      var floor = Math.floor;
      module.exports = function (it) {
        return isNaN((it = +it)) ? 0 : (it > 0 ? floor : ceil)(it);
      };

      /***/
    },
    /* 31 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      if (__webpack_require__(9)) {
        var LIBRARY = __webpack_require__(48);
        var global = __webpack_require__(3);
        var fails = __webpack_require__(1);
        var $export = __webpack_require__(0);
        var $typed = __webpack_require__(73);
        var $buffer = __webpack_require__(101);
        var ctx = __webpack_require__(23);
        var anInstance = __webpack_require__(52);
        var propertyDesc = __webpack_require__(38);
        var hide = __webpack_require__(16);
        var redefineAll = __webpack_require__(53);
        var toInteger = __webpack_require__(30);
        var toLength = __webpack_require__(8);
        var toIndex = __webpack_require__(145);
        var toAbsoluteIndex = __webpack_require__(41);
        var toPrimitive = __webpack_require__(32);
        var has = __webpack_require__(12);
        var classof = __webpack_require__(67);
        var isObject = __webpack_require__(2);
        var toObject = __webpack_require__(14);
        var isArrayIter = __webpack_require__(94);
        var create = __webpack_require__(42);
        var getPrototypeOf = __webpack_require__(44);
        var gOPN = __webpack_require__(43).f;
        var getIterFn = __webpack_require__(96);
        var uid = __webpack_require__(39);
        var wks = __webpack_require__(5);
        var createArrayMethod = __webpack_require__(27);
        var createArrayIncludes = __webpack_require__(64);
        var speciesConstructor = __webpack_require__(71);
        var ArrayIterators = __webpack_require__(98);
        var Iterators = __webpack_require__(50);
        var $iterDetect = __webpack_require__(68);
        var setSpecies = __webpack_require__(51);
        var arrayFill = __webpack_require__(97);
        var arrayCopyWithin = __webpack_require__(137);
        var $DP = __webpack_require__(7);
        var $GOPD = __webpack_require__(25);
        var dP = $DP.f;
        var gOPD = $GOPD.f;
        var RangeError = global.RangeError;
        var TypeError = global.TypeError;
        var Uint8Array = global.Uint8Array;
        var ARRAY_BUFFER = 'ArrayBuffer';
        var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
        var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
        var PROTOTYPE = 'prototype';
        var ArrayProto = Array[PROTOTYPE];
        var $ArrayBuffer = $buffer.ArrayBuffer;
        var $DataView = $buffer.DataView;
        var arrayForEach = createArrayMethod(0);
        var arrayFilter = createArrayMethod(2);
        var arraySome = createArrayMethod(3);
        var arrayEvery = createArrayMethod(4);
        var arrayFind = createArrayMethod(5);
        var arrayFindIndex = createArrayMethod(6);
        var arrayIncludes = createArrayIncludes(true);
        var arrayIndexOf = createArrayIncludes(false);
        var arrayValues = ArrayIterators.values;
        var arrayKeys = ArrayIterators.keys;
        var arrayEntries = ArrayIterators.entries;
        var arrayLastIndexOf = ArrayProto.lastIndexOf;
        var arrayReduce = ArrayProto.reduce;
        var arrayReduceRight = ArrayProto.reduceRight;
        var arrayJoin = ArrayProto.join;
        var arraySort = ArrayProto.sort;
        var arraySlice = ArrayProto.slice;
        var arrayToString = ArrayProto.toString;
        var arrayToLocaleString = ArrayProto.toLocaleString;
        var ITERATOR = wks('iterator');
        var TAG = wks('toStringTag');
        var TYPED_CONSTRUCTOR = uid('typed_constructor');
        var DEF_CONSTRUCTOR = uid('def_constructor');
        var ALL_CONSTRUCTORS = $typed.CONSTR;
        var TYPED_ARRAY = $typed.TYPED;
        var VIEW = $typed.VIEW;
        var WRONG_LENGTH = 'Wrong length!';

        var $map = createArrayMethod(1, function (O, length) {
          return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
        });

        var LITTLE_ENDIAN = fails(function () {
          // eslint-disable-next-line no-undef
          return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
        });

        var FORCED_SET =
          !!Uint8Array &&
          !!Uint8Array[PROTOTYPE].set &&
          fails(function () {
            new Uint8Array(1).set({});
          });

        var toOffset = function (it, BYTES) {
          var offset = toInteger(it);
          if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
          return offset;
        };

        var validate = function (it) {
          if (isObject(it) && TYPED_ARRAY in it) return it;
          throw TypeError(it + ' is not a typed array!');
        };

        var allocate = function (C, length) {
          if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
            throw TypeError('It is not a typed array constructor!');
          }
          return new C(length);
        };

        var speciesFromList = function (O, list) {
          return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
        };

        var fromList = function (C, list) {
          var index = 0;
          var length = list.length;
          var result = allocate(C, length);
          while (length > index) result[index] = list[index++];
          return result;
        };

        var addGetter = function (it, key, internal) {
          dP(it, key, {
            get: function () {
              return this._d[internal];
            }
          });
        };

        var $from = function from(source /* , mapfn, thisArg */) {
          var O = toObject(source);
          var aLen = arguments.length;
          var mapfn = aLen > 1 ? arguments[1] : undefined;
          var mapping = mapfn !== undefined;
          var iterFn = getIterFn(O);
          var i, length, values, result, step, iterator;
          if (iterFn != undefined && !isArrayIter(iterFn)) {
            for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
              values.push(step.value);
            }
            O = values;
          }
          if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
          for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
            result[i] = mapping ? mapfn(O[i], i) : O[i];
          }
          return result;
        };

        var $of = function of(/* ...items */) {
          var index = 0;
          var length = arguments.length;
          var result = allocate(this, length);
          while (length > index) result[index] = arguments[index++];
          return result;
        };

        // iOS Safari 6.x fails here
        var TO_LOCALE_BUG =
          !!Uint8Array &&
          fails(function () {
            arrayToLocaleString.call(new Uint8Array(1));
          });

        var $toLocaleString = function toLocaleString() {
          return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
        };

        var proto = {
          copyWithin: function copyWithin(target, start /* , end */) {
            return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
          },
          every: function every(callbackfn /* , thisArg */) {
            return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          },
          fill: function fill(value /* , start, end */) {
            // eslint-disable-line no-unused-vars
            return arrayFill.apply(validate(this), arguments);
          },
          filter: function filter(callbackfn /* , thisArg */) {
            return speciesFromList(
              this,
              arrayFilter(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined)
            );
          },
          find: function find(predicate /* , thisArg */) {
            return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
          },
          findIndex: function findIndex(predicate /* , thisArg */) {
            return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
          },
          forEach: function forEach(callbackfn /* , thisArg */) {
            arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          },
          indexOf: function indexOf(searchElement /* , fromIndex */) {
            return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
          },
          includes: function includes(searchElement /* , fromIndex */) {
            return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
          },
          join: function join(separator) {
            // eslint-disable-line no-unused-vars
            return arrayJoin.apply(validate(this), arguments);
          },
          lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) {
            // eslint-disable-line no-unused-vars
            return arrayLastIndexOf.apply(validate(this), arguments);
          },
          map: function map(mapfn /* , thisArg */) {
            return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
          },
          reduce: function reduce(callbackfn /* , initialValue */) {
            // eslint-disable-line no-unused-vars
            return arrayReduce.apply(validate(this), arguments);
          },
          reduceRight: function reduceRight(callbackfn /* , initialValue */) {
            // eslint-disable-line no-unused-vars
            return arrayReduceRight.apply(validate(this), arguments);
          },
          reverse: function reverse() {
            var that = this;
            var length = validate(that).length;
            var middle = Math.floor(length / 2);
            var index = 0;
            var value;
            while (index < middle) {
              value = that[index];
              that[index++] = that[--length];
              that[length] = value;
            }
            return that;
          },
          some: function some(callbackfn /* , thisArg */) {
            return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          },
          sort: function sort(comparefn) {
            return arraySort.call(validate(this), comparefn);
          },
          subarray: function subarray(begin, end) {
            var O = validate(this);
            var length = O.length;
            var $begin = toAbsoluteIndex(begin, length);
            return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
              O.buffer,
              O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
              toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
            );
          }
        };

        var $slice = function slice(start, end) {
          return speciesFromList(this, arraySlice.call(validate(this), start, end));
        };

        var $set = function set(arrayLike /* , offset */) {
          validate(this);
          var offset = toOffset(arguments[1], 1);
          var length = this.length;
          var src = toObject(arrayLike);
          var len = toLength(src.length);
          var index = 0;
          if (len + offset > length) throw RangeError(WRONG_LENGTH);
          while (index < len) this[offset + index] = src[index++];
        };

        var $iterators = {
          entries: function entries() {
            return arrayEntries.call(validate(this));
          },
          keys: function keys() {
            return arrayKeys.call(validate(this));
          },
          values: function values() {
            return arrayValues.call(validate(this));
          }
        };

        var isTAIndex = function (target, key) {
          return (
            isObject(target) &&
            target[TYPED_ARRAY] &&
            typeof key != 'symbol' &&
            key in target &&
            String(+key) == String(key)
          );
        };
        var $getDesc = function getOwnPropertyDescriptor(target, key) {
          return isTAIndex(target, (key = toPrimitive(key, true))) ? propertyDesc(2, target[key]) : gOPD(target, key);
        };
        var $setDesc = function defineProperty(target, key, desc) {
          if (
            isTAIndex(target, (key = toPrimitive(key, true))) &&
            isObject(desc) &&
            has(desc, 'value') &&
            !has(desc, 'get') &&
            !has(desc, 'set') &&
            // TODO: add validation descriptor w/o calling accessors
            !desc.configurable &&
            (!has(desc, 'writable') || desc.writable) &&
            (!has(desc, 'enumerable') || desc.enumerable)
          ) {
            target[key] = desc.value;
            return target;
          }
          return dP(target, key, desc);
        };

        if (!ALL_CONSTRUCTORS) {
          $GOPD.f = $getDesc;
          $DP.f = $setDesc;
        }

        $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
          getOwnPropertyDescriptor: $getDesc,
          defineProperty: $setDesc
        });

        if (
          fails(function () {
            arrayToString.call({});
          })
        ) {
          arrayToString = arrayToLocaleString = function toString() {
            return arrayJoin.call(this);
          };
        }

        var $TypedArrayPrototype$ = redefineAll({}, proto);
        redefineAll($TypedArrayPrototype$, $iterators);
        hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
        redefineAll($TypedArrayPrototype$, {
          slice: $slice,
          set: $set,
          constructor: function () {
            /* noop */
          },
          toString: arrayToString,
          toLocaleString: $toLocaleString
        });
        addGetter($TypedArrayPrototype$, 'buffer', 'b');
        addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
        addGetter($TypedArrayPrototype$, 'byteLength', 'l');
        addGetter($TypedArrayPrototype$, 'length', 'e');
        dP($TypedArrayPrototype$, TAG, {
          get: function () {
            return this[TYPED_ARRAY];
          }
        });

        // eslint-disable-next-line max-statements
        module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
          CLAMPED = !!CLAMPED;
          var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
          var GETTER = 'get' + KEY;
          var SETTER = 'set' + KEY;
          var TypedArray = global[NAME];
          var Base = TypedArray || {};
          var TAC = TypedArray && getPrototypeOf(TypedArray);
          var FORCED = !TypedArray || !$typed.ABV;
          var O = {};
          var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
          var getter = function (that, index) {
            var data = that._d;
            return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
          };
          var setter = function (that, index, value) {
            var data = that._d;
            if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
            data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
          };
          var addElement = function (that, index) {
            dP(that, index, {
              get: function () {
                return getter(this, index);
              },
              set: function (value) {
                return setter(this, index, value);
              },
              enumerable: true
            });
          };
          if (FORCED) {
            TypedArray = wrapper(function (that, data, $offset, $length) {
              anInstance(that, TypedArray, NAME, '_d');
              var index = 0;
              var offset = 0;
              var buffer, byteLength, length, klass;
              if (!isObject(data)) {
                length = toIndex(data);
                byteLength = length * BYTES;
                buffer = new $ArrayBuffer(byteLength);
              } else if (
                data instanceof $ArrayBuffer ||
                (klass = classof(data)) == ARRAY_BUFFER ||
                klass == SHARED_BUFFER
              ) {
                buffer = data;
                offset = toOffset($offset, BYTES);
                var $len = data.byteLength;
                if ($length === undefined) {
                  if ($len % BYTES) throw RangeError(WRONG_LENGTH);
                  byteLength = $len - offset;
                  if (byteLength < 0) throw RangeError(WRONG_LENGTH);
                } else {
                  byteLength = toLength($length) * BYTES;
                  if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
                }
                length = byteLength / BYTES;
              } else if (TYPED_ARRAY in data) {
                return fromList(TypedArray, data);
              } else {
                return $from.call(TypedArray, data);
              }
              hide(that, '_d', {
                b: buffer,
                o: offset,
                l: byteLength,
                e: length,
                v: new $DataView(buffer)
              });
              while (index < length) addElement(that, index++);
            });
            TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
            hide(TypedArrayPrototype, 'constructor', TypedArray);
          } else if (
            !fails(function () {
              TypedArray(1);
            }) ||
            !fails(function () {
              new TypedArray(-1); // eslint-disable-line no-new
            }) ||
            !$iterDetect(function (iter) {
              new TypedArray(); // eslint-disable-line no-new
              new TypedArray(null); // eslint-disable-line no-new
              new TypedArray(1.5); // eslint-disable-line no-new
              new TypedArray(iter); // eslint-disable-line no-new
            }, true)
          ) {
            TypedArray = wrapper(function (that, data, $offset, $length) {
              anInstance(that, TypedArray, NAME);
              var klass;
              // `ws` module bug, temporarily remove validation length for Uint8Array
              // https://github.com/websockets/ws/pull/645
              if (!isObject(data)) return new Base(toIndex(data));
              if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
                return $length !== undefined
                  ? new Base(data, toOffset($offset, BYTES), $length)
                  : $offset !== undefined
                    ? new Base(data, toOffset($offset, BYTES))
                    : new Base(data);
              }
              if (TYPED_ARRAY in data) return fromList(TypedArray, data);
              return $from.call(TypedArray, data);
            });
            arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
              if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
            });
            TypedArray[PROTOTYPE] = TypedArrayPrototype;
            if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
          }
          var $nativeIterator = TypedArrayPrototype[ITERATOR];
          var CORRECT_ITER_NAME =
            !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
          var $iterator = $iterators.values;
          hide(TypedArray, TYPED_CONSTRUCTOR, true);
          hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
          hide(TypedArrayPrototype, VIEW, true);
          hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

          if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
            dP(TypedArrayPrototype, TAG, {
              get: function () {
                return NAME;
              }
            });
          }

          O[NAME] = TypedArray;

          $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

          $export($export.S, NAME, {
            BYTES_PER_ELEMENT: BYTES
          });

          $export(
            $export.S +
              $export.F *
                fails(function () {
                  Base.of.call(TypedArray, 1);
                }),
            NAME,
            {
              from: $from,
              of: $of
            }
          );

          if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

          $export($export.P, NAME, proto);

          setSpecies(NAME);

          $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

          $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

          if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

          $export(
            $export.P +
              $export.F *
                fails(function () {
                  new TypedArray(1).slice();
                }),
            NAME,
            { slice: $slice }
          );

          $export(
            $export.P +
              $export.F *
                (fails(function () {
                  return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
                }) ||
                  !fails(function () {
                    TypedArrayPrototype.toLocaleString.call([1, 2]);
                  })),
            NAME,
            { toLocaleString: $toLocaleString }
          );

          Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
          if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
        };
      } else
        module.exports = function () {
          /* empty */
        };

      /***/
    },
    /* 32 */
    /***/ function (module, exports, __webpack_require__) {
      // 7.1.1 ToPrimitive(input [, PreferredType])
      var isObject = __webpack_require__(2);
      // instead of the ES6 spec version, we didn't implement @@toPrimitive case
      // and the second argument - flag - preferred type is a string
      module.exports = function (it, S) {
        if (!isObject(it)) return it;
        var fn, val;
        if (S && typeof (fn = it.toString) == 'function' && !isObject((val = fn.call(it)))) return val;
        if (typeof (fn = it.valueOf) == 'function' && !isObject((val = fn.call(it)))) return val;
        if (!S && typeof (fn = it.toString) == 'function' && !isObject((val = fn.call(it)))) return val;
        throw TypeError("Can't convert object to primitive value");
      };

      /***/
    },
    /* 33 */
    /***/ function (module, exports, __webpack_require__) {
      var META = __webpack_require__(39)('meta');
      var isObject = __webpack_require__(2);
      var has = __webpack_require__(12);
      var setDesc = __webpack_require__(7).f;
      var id = 0;
      var isExtensible =
        Object.isExtensible ||
        function () {
          return true;
        };
      var FREEZE = !__webpack_require__(1)(function () {
        return isExtensible(Object.preventExtensions({}));
      });
      var setMeta = function (it) {
        setDesc(it, META, {
          value: {
            i: 'O' + ++id, // object ID
            w: {} // weak collections IDs
          }
        });
      };
      var fastKey = function (it, create) {
        // return primitive with prefix
        if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
        if (!has(it, META)) {
          // can't set metadata to uncaught frozen object
          if (!isExtensible(it)) return 'F';
          // not necessary to add metadata
          if (!create) return 'E';
          // add missing metadata
          setMeta(it);
          // return object ID
        }
        return it[META].i;
      };
      var getWeak = function (it, create) {
        if (!has(it, META)) {
          // can't set metadata to uncaught frozen object
          if (!isExtensible(it)) return true;
          // not necessary to add metadata
          if (!create) return false;
          // add missing metadata
          setMeta(it);
          // return hash weak collections IDs
        }
        return it[META].w;
      };
      // add metadata on freeze-family methods calling
      var onFreeze = function (it) {
        if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
        return it;
      };
      var meta = (module.exports = {
        KEY: META,
        NEED: false,
        fastKey: fastKey,
        getWeak: getWeak,
        onFreeze: onFreeze
      });

      /***/
    },
    /* 34 */
    /***/ function (module, exports, __webpack_require__) {
      var global = __webpack_require__(18);
      var core = __webpack_require__(21);
      var ctx = __webpack_require__(61);
      var hide = __webpack_require__(55);
      var PROTOTYPE = 'prototype';

      var $export = function (type, name, source) {
        var IS_FORCED = type & $export.F;
        var IS_GLOBAL = type & $export.G;
        var IS_STATIC = type & $export.S;
        var IS_PROTO = type & $export.P;
        var IS_BIND = type & $export.B;
        var IS_WRAP = type & $export.W;
        var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
        var expProto = exports[PROTOTYPE];
        var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
        var key, own, out;
        if (IS_GLOBAL) source = name;
        for (key in source) {
          // contains in native
          own = !IS_FORCED && target && target[key] !== undefined;
          if (own && key in exports) continue;
          // export native or passed
          out = own ? target[key] : source[key];
          // prevent global pollution for namespaces
          exports[key] =
            IS_GLOBAL && typeof target[key] != 'function'
              ? source[key]
              : // bind timers to global for call from export context
                IS_BIND && own
                ? ctx(out, global)
                : // wrap global constructors for prevent change them in library
                  IS_WRAP && target[key] == out
                  ? (function (C) {
                      var F = function (a, b, c) {
                        if (this instanceof C) {
                          switch (arguments.length) {
                            case 0:
                              return new C();
                            case 1:
                              return new C(a);
                            case 2:
                              return new C(a, b);
                          }
                          return new C(a, b, c);
                        }
                        return C.apply(this, arguments);
                      };
                      F[PROTOTYPE] = C[PROTOTYPE];
                      return F;
                      // make static versions for prototype methods
                    })(out)
                  : IS_PROTO && typeof out == 'function'
                    ? ctx(Function.call, out)
                    : out;
          // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
          if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
          }
        }
      };
      // type bitmap
      $export.F = 1; // forced
      $export.G = 2; // global
      $export.S = 4; // static
      $export.P = 8; // proto
      $export.B = 16; // bind
      $export.W = 32; // wrap
      $export.U = 64; // safe
      $export.R = 128; // real proto method for `library`
      module.exports = $export;

      /***/
    },
    /* 35 */
    /***/ function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(62);
      module.exports = function (it) {
        if (!isObject(it)) throw TypeError(it + ' is not an object!');
        return it;
      };

      /***/
    },
    /* 36 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true
      });

      var _escshopify = __webpack_require__(357);

      var TAG = 'LogBootstrap';

      var log = new _escshopify.utils.Log();

      log.setLogPrefix('Theme');

      var logger = new _escshopify.utils.Log.loggers.ConsoleLogger();

      log.addLogger(logger);
      log.send(log.DEBUG, TAG, 'Initialized logging.');

      exports.default = log;

      /***/
    },
    /* 37 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /**
       * Fizzy UI utils v2.0.7
       * MIT license
       */

      /*jshint browser: true, undef: true, unused: true, strict: true */

      (function (window, factory) {
        // universal module definition
        /*jshint strict: false */ /*globals define, module, require */

        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(397)]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (matchesSelector) {
            return factory(window, matchesSelector);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof module == 'object' && module.exports) {
          // CommonJS
          module.exports = factory(window, require('desandro-matches-selector'));
        } else {
          // browser global
          window.fizzyUIUtils = factory(window, window.matchesSelector);
        }
      })(window, function factory(window, matchesSelector) {
        'use strict';

        var utils = {};

        // ----- extend ----- //

        // extends objects
        utils.extend = function (a, b) {
          for (var prop in b) {
            a[prop] = b[prop];
          }
          return a;
        };

        // ----- modulo ----- //

        utils.modulo = function (num, div) {
          return ((num % div) + div) % div;
        };

        // ----- makeArray ----- //

        var arraySlice = Array.prototype.slice;

        // turn element or nodeList into an array
        utils.makeArray = function (obj) {
          if (Array.isArray(obj)) {
            // use object if already an array
            return obj;
          }
          // return empty array if undefined or null. #6
          if (obj === null || obj === undefined) {
            return [];
          }

          var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
          if (isArrayLike) {
            // convert nodeList to array
            return arraySlice.call(obj);
          }

          // array of single index
          return [obj];
        };

        // ----- removeFrom ----- //

        utils.removeFrom = function (ary, obj) {
          var index = ary.indexOf(obj);
          if (index != -1) {
            ary.splice(index, 1);
          }
        };

        // ----- getParent ----- //

        utils.getParent = function (elem, selector) {
          while (elem.parentNode && elem != document.body) {
            elem = elem.parentNode;
            if (matchesSelector(elem, selector)) {
              return elem;
            }
          }
        };

        // ----- getQueryElement ----- //

        // use element as selector string
        utils.getQueryElement = function (elem) {
          if (typeof elem == 'string') {
            return document.querySelector(elem);
          }
          return elem;
        };

        // ----- handleEvent ----- //

        // enable .ontype to trigger from .addEventListener( elem, 'type' )
        utils.handleEvent = function (event) {
          var method = 'on' + event.type;
          if (this[method]) {
            this[method](event);
          }
        };

        // ----- filterFindElements ----- //

        utils.filterFindElements = function (elems, selector) {
          // make array of elems
          elems = utils.makeArray(elems);
          var ffElems = [];

          elems.forEach(function (elem) {
            // check that elem is an actual element
            if (!(elem instanceof HTMLElement)) {
              return;
            }
            // add elem if no selector
            if (!selector) {
              ffElems.push(elem);
              return;
            }
            // filter & find items if we have a selector
            // filter
            if (matchesSelector(elem, selector)) {
              ffElems.push(elem);
            }
            // find children
            var childElems = elem.querySelectorAll(selector);
            // concat childElems to filterFound array
            for (var i = 0; i < childElems.length; i++) {
              ffElems.push(childElems[i]);
            }
          });

          return ffElems;
        };

        // ----- debounceMethod ----- //

        utils.debounceMethod = function (_class, methodName, threshold) {
          threshold = threshold || 100;
          // original method
          var method = _class.prototype[methodName];
          var timeoutName = methodName + 'Timeout';

          _class.prototype[methodName] = function () {
            var timeout = this[timeoutName];
            clearTimeout(timeout);

            var args = arguments;
            var _this = this;
            this[timeoutName] = setTimeout(function () {
              method.apply(_this, args);
              delete _this[timeoutName];
            }, threshold);
          };
        };

        // ----- docReady ----- //

        utils.docReady = function (callback) {
          var readyState = document.readyState;
          if (readyState == 'complete' || readyState == 'interactive') {
            // do async to allow for other scripts to run. metafizzy/flickity#441
            setTimeout(callback);
          } else {
            document.addEventListener('DOMContentLoaded', callback);
          }
        };

        // ----- htmlInit ----- //

        // http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
        utils.toDashed = function (str) {
          return str
            .replace(/(.)([A-Z])/g, function (match, $1, $2) {
              return $1 + '-' + $2;
            })
            .toLowerCase();
        };

        var console = window.console;
        /**
         * allow user to initialize classes via [data-namespace] or .js-namespace class
         * htmlInit( Widget, 'widgetName' )
         * options are parsed from data-namespace-options
         */
        utils.htmlInit = function (WidgetClass, namespace) {
          utils.docReady(function () {
            var dashedNamespace = utils.toDashed(namespace);
            var dataAttr = 'data-' + dashedNamespace;
            var dataAttrElems = document.querySelectorAll('[' + dataAttr + ']');
            var jsDashElems = document.querySelectorAll('.js-' + dashedNamespace);
            var elems = utils.makeArray(dataAttrElems).concat(utils.makeArray(jsDashElems));
            var dataOptionsAttr = dataAttr + '-options';
            var jQuery = window.jQuery;

            elems.forEach(function (elem) {
              var attr = elem.getAttribute(dataAttr) || elem.getAttribute(dataOptionsAttr);
              var options;
              try {
                options = attr && JSON.parse(attr);
              } catch (error) {
                // log error, do not initialize
                if (console) {
                  console.error('Error parsing ' + dataAttr + ' on ' + elem.className + ': ' + error);
                }
                return;
              }
              // initialize
              var instance = new WidgetClass(elem, options);
              // make available via $().data('namespace')
              if (jQuery) {
                jQuery.data(elem, namespace, instance);
              }
            });
          });
        };

        // -----  ----- //

        return utils;
      });

      /***/
    },
    /* 38 */
    /***/ function (module, exports) {
      module.exports = function (bitmap, value) {
        return {
          enumerable: !(bitmap & 1),
          configurable: !(bitmap & 2),
          writable: !(bitmap & 4),
          value: value
        };
      };

      /***/
    },
    /* 39 */
    /***/ function (module, exports) {
      var id = 0;
      var px = Math.random();
      module.exports = function (key) {
        return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
      };

      /***/
    },
    /* 40 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.14 / 15.2.3.14 Object.keys(O)
      var $keys = __webpack_require__(121);
      var enumBugKeys = __webpack_require__(82);

      module.exports =
        Object.keys ||
        function keys(O) {
          return $keys(O, enumBugKeys);
        };

      /***/
    },
    /* 41 */
    /***/ function (module, exports, __webpack_require__) {
      var toInteger = __webpack_require__(30);
      var max = Math.max;
      var min = Math.min;
      module.exports = function (index, length) {
        index = toInteger(index);
        return index < 0 ? max(index + length, 0) : min(index, length);
      };

      /***/
    },
    /* 42 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
      var anObject = __webpack_require__(4);
      var dPs = __webpack_require__(122);
      var enumBugKeys = __webpack_require__(82);
      var IE_PROTO = __webpack_require__(81)('IE_PROTO');
      var Empty = function () {
        /* empty */
      };
      var PROTOTYPE = 'prototype';

      // Create object with fake `null` prototype: use iframe Object with cleared prototype
      var createDict = function () {
        // Thrash, waste and sodomy: IE GC bug
        var iframe = __webpack_require__(78)('iframe');
        var i = enumBugKeys.length;
        var lt = '<';
        var gt = '>';
        var iframeDocument;
        iframe.style.display = 'none';
        __webpack_require__(83).appendChild(iframe);
        iframe.src = 'javascript:'; // eslint-disable-line no-script-url
        // createDict = iframe.contentWindow.Object;
        // html.removeChild(iframe);
        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
        iframeDocument.close();
        createDict = iframeDocument.F;
        while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
        return createDict();
      };

      module.exports =
        Object.create ||
        function create(O, Properties) {
          var result;
          if (O !== null) {
            Empty[PROTOTYPE] = anObject(O);
            result = new Empty();
            Empty[PROTOTYPE] = null;
            // add "__proto__" for Object.getPrototypeOf polyfill
            result[IE_PROTO] = O;
          } else result = createDict();
          return Properties === undefined ? result : dPs(result, Properties);
        };

      /***/
    },
    /* 43 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
      var $keys = __webpack_require__(121);
      var hiddenKeys = __webpack_require__(82).concat('length', 'prototype');

      exports.f =
        Object.getOwnPropertyNames ||
        function getOwnPropertyNames(O) {
          return $keys(O, hiddenKeys);
        };

      /***/
    },
    /* 44 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
      var has = __webpack_require__(12);
      var toObject = __webpack_require__(14);
      var IE_PROTO = __webpack_require__(81)('IE_PROTO');
      var ObjectProto = Object.prototype;

      module.exports =
        Object.getPrototypeOf ||
        function (O) {
          O = toObject(O);
          if (has(O, IE_PROTO)) return O[IE_PROTO];
          if (typeof O.constructor == 'function' && O instanceof O.constructor) {
            return O.constructor.prototype;
          }
          return O instanceof Object ? ObjectProto : null;
        };

      /***/
    },
    /* 45 */
    /***/ function (module, exports, __webpack_require__) {
      // 22.1.3.31 Array.prototype[@@unscopables]
      var UNSCOPABLES = __webpack_require__(5)('unscopables');
      var ArrayProto = Array.prototype;
      if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(16)(ArrayProto, UNSCOPABLES, {});
      module.exports = function (key) {
        ArrayProto[UNSCOPABLES][key] = true;
      };

      /***/
    },
    /* 46 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // Flickity main
      /* eslint-disable max-params */
      (function (window, factory) {
        // universal module definition
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(114),
            __webpack_require__(165),
            __webpack_require__(37),
            __webpack_require__(398),
            __webpack_require__(399),
            __webpack_require__(400)
          ]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
            return factory(window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof module == 'object' && module.exports) {
          // CommonJS
          module.exports = factory(
            window,
            require('ev-emitter'),
            require('get-size'),
            require('fizzy-ui-utils'),
            require('./cell'),
            require('./slide'),
            require('./animate')
          );
        } else {
          // browser global
          var _Flickity = window.Flickity;

          window.Flickity = factory(
            window,
            window.EvEmitter,
            window.getSize,
            window.fizzyUIUtils,
            _Flickity.Cell,
            _Flickity.Slide,
            _Flickity.animatePrototype
          );
        }
      })(window, function factory(window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
        /* eslint-enable max-params */
        'use strict';

        // vars
        var jQuery = window.jQuery;
        var getComputedStyle = window.getComputedStyle;
        var console = window.console;

        function moveElements(elems, toElem) {
          elems = utils.makeArray(elems);
          while (elems.length) {
            toElem.appendChild(elems.shift());
          }
        }

        // -------------------------- Flickity -------------------------- //

        // globally unique identifiers
        var GUID = 0;
        // internal store of all Flickity intances
        var instances = {};

        function Flickity(element, options) {
          var queryElement = utils.getQueryElement(element);
          if (!queryElement) {
            if (console) {
              console.error('Bad element for Flickity: ' + (queryElement || element));
            }
            return;
          }
          this.element = queryElement;
          // do not initialize twice on same element
          if (this.element.flickityGUID) {
            var instance = instances[this.element.flickityGUID];
            if (instance) instance.option(options);
            return instance;
          }

          // add jQuery
          if (jQuery) {
            this.$element = jQuery(this.element);
          }
          // options
          this.options = utils.extend({}, this.constructor.defaults);
          this.option(options);

          // kick things off
          this._create();
        }

        Flickity.defaults = {
          accessibility: true,
          // adaptiveHeight: false,
          cellAlign: 'center',
          // cellSelector: undefined,
          // contain: false,
          freeScrollFriction: 0.075, // friction when free-scrolling
          friction: 0.28, // friction when selecting
          namespaceJQueryEvents: true,
          // initialIndex: 0,
          percentPosition: true,
          resize: true,
          selectedAttraction: 0.025,
          setGallerySize: true
          // watchCSS: false,
          // wrapAround: false
        };

        // hash of methods triggered on _create()
        Flickity.createMethods = [];

        var proto = Flickity.prototype;
        // inherit EventEmitter
        utils.extend(proto, EvEmitter.prototype);

        proto._create = function () {
          // add id for Flickity.data
          var id = (this.guid = ++GUID);
          this.element.flickityGUID = id; // expando
          instances[id] = this; // associate via id
          // initial properties
          this.selectedIndex = 0;
          // how many frames slider has been in same position
          this.restingFrames = 0;
          // initial physics properties
          this.x = 0;
          this.velocity = 0;
          this.originSide = this.options.rightToLeft ? 'right' : 'left';
          // create viewport & slider
          this.viewport = document.createElement('div');
          this.viewport.className = 'flickity-viewport';
          this._createSlider();

          if (this.options.resize || this.options.watchCSS) {
            window.addEventListener('resize', this);
          }

          // add listeners from on option
          for (var eventName in this.options.on) {
            var listener = this.options.on[eventName];
            this.on(eventName, listener);
          }

          Flickity.createMethods.forEach(function (method) {
            this[method]();
          }, this);

          if (this.options.watchCSS) {
            this.watchCSS();
          } else {
            this.activate();
          }
        };

        /**
         * set options
         * @param {Object} opts - options to extend
         */
        proto.option = function (opts) {
          utils.extend(this.options, opts);
        };

        proto.activate = function () {
          if (this.isActive) {
            return;
          }
          this.isActive = true;
          this.element.classList.add('flickity-enabled');
          if (this.options.rightToLeft) {
            this.element.classList.add('flickity-rtl');
          }

          this.getSize();
          // move initial cell elements so they can be loaded as cells
          var cellElems = this._filterFindCellElements(this.element.children);
          moveElements(cellElems, this.slider);
          this.viewport.appendChild(this.slider);
          this.element.appendChild(this.viewport);
          // get cells from children
          this.reloadCells();

          if (this.options.accessibility) {
            // allow element to focusable
            this.element.tabIndex = 0;
            // listen for key presses
            this.element.addEventListener('keydown', this);
          }

          this.emitEvent('activate');
          this.selectInitialIndex();
          // flag for initial activation, for using initialIndex
          this.isInitActivated = true;
          // ready event. #493
          this.dispatchEvent('ready');
        };

        // slider positions the cells
        proto._createSlider = function () {
          // slider element does all the positioning
          var slider = document.createElement('div');
          slider.className = 'flickity-slider';
          slider.style[this.originSide] = 0;
          this.slider = slider;
        };

        proto._filterFindCellElements = function (elems) {
          return utils.filterFindElements(elems, this.options.cellSelector);
        };

        // goes through all children
        proto.reloadCells = function () {
          // collection of item elements
          this.cells = this._makeCells(this.slider.children);
          this.positionCells();
          this._getWrapShiftCells();
          this.setGallerySize();
        };

        /**
         * turn elements into Flickity.Cells
         * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
         * @returns {Array} items - collection of new Flickity Cells
         */
        proto._makeCells = function (elems) {
          var cellElems = this._filterFindCellElements(elems);

          // create new Flickity for collection
          var cells = cellElems.map(function (cellElem) {
            return new Cell(cellElem, this);
          }, this);

          return cells;
        };

        proto.getLastCell = function () {
          return this.cells[this.cells.length - 1];
        };

        proto.getLastSlide = function () {
          return this.slides[this.slides.length - 1];
        };

        // positions all cells
        proto.positionCells = function () {
          // size all cells
          this._sizeCells(this.cells);
          // position all cells
          this._positionCells(0);
        };

        /**
         * position certain cells
         * @param {Integer} index - which cell to start with
         */
        proto._positionCells = function (index) {
          index = index || 0;
          // also measure maxCellHeight
          // start 0 if positioning all cells
          this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
          var cellX = 0;
          // get cellX
          if (index > 0) {
            var startCell = this.cells[index - 1];
            cellX = startCell.x + startCell.size.outerWidth;
          }
          var len = this.cells.length;
          for (var i = index; i < len; i++) {
            var cell = this.cells[i];
            cell.setPosition(cellX);
            cellX += cell.size.outerWidth;
            this.maxCellHeight = Math.max(cell.size.outerHeight, this.maxCellHeight);
          }
          // keep track of cellX for wrap-around
          this.slideableWidth = cellX;
          // slides
          this.updateSlides();
          // contain slides target
          this._containSlides();
          // update slidesWidth
          this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
        };

        /**
         * cell.getSize() on multiple cells
         * @param {Array} cells - cells to size
         */
        proto._sizeCells = function (cells) {
          cells.forEach(function (cell) {
            cell.getSize();
          });
        };

        // --------------------------  -------------------------- //

        proto.updateSlides = function () {
          this.slides = [];
          if (!this.cells.length) {
            return;
          }

          var slide = new Slide(this);
          this.slides.push(slide);
          var isOriginLeft = this.originSide == 'left';
          var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';

          var canCellFit = this._getCanCellFit();

          this.cells.forEach(function (cell, i) {
            // just add cell if first cell in slide
            if (!slide.cells.length) {
              slide.addCell(cell);
              return;
            }

            var slideWidth = slide.outerWidth - slide.firstMargin + (cell.size.outerWidth - cell.size[nextMargin]);

            if (canCellFit.call(this, i, slideWidth)) {
              slide.addCell(cell);
            } else {
              // doesn't fit, new slide
              slide.updateTarget();

              slide = new Slide(this);
              this.slides.push(slide);
              slide.addCell(cell);
            }
          }, this);
          // last slide
          slide.updateTarget();
          // update .selectedSlide
          this.updateSelectedSlide();
        };

        proto._getCanCellFit = function () {
          var groupCells = this.options.groupCells;
          if (!groupCells) {
            return function () {
              return false;
            };
          } else if (typeof groupCells == 'number') {
            // group by number. 3 -> [0,1,2], [3,4,5], ...
            var number = parseInt(groupCells, 10);
            return function (i) {
              return i % number !== 0;
            };
          }
          // default, group by width of slide
          // parse '75%
          var percentMatch = typeof groupCells == 'string' && groupCells.match(/^(\d+)%$/);
          var percent = percentMatch ? parseInt(percentMatch[1], 10) / 100 : 1;
          return function (i, slideWidth) {
            /* eslint-disable-next-line no-invalid-this */
            return slideWidth <= (this.size.innerWidth + 1) * percent;
          };
        };

        // alias _init for jQuery plugin .flickity()
        proto._init = proto.reposition = function () {
          this.positionCells();
          this.positionSliderAtSelected();
        };

        proto.getSize = function () {
          this.size = getSize(this.element);
          this.setCellAlign();
          this.cursorPosition = this.size.innerWidth * this.cellAlign;
        };

        var cellAlignShorthands = {
          // cell align, then based on origin side
          center: {
            left: 0.5,
            right: 0.5
          },
          left: {
            left: 0,
            right: 1
          },
          right: {
            right: 0,
            left: 1
          }
        };

        proto.setCellAlign = function () {
          var shorthand = cellAlignShorthands[this.options.cellAlign];
          this.cellAlign = shorthand ? shorthand[this.originSide] : this.options.cellAlign;
        };

        proto.setGallerySize = function () {
          if (this.options.setGallerySize) {
            var height =
              this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
            this.viewport.style.height = height + 'px';
          }
        };

        proto._getWrapShiftCells = function () {
          // only for wrap-around
          if (!this.options.wrapAround) {
            return;
          }
          // unshift previous cells
          this._unshiftCells(this.beforeShiftCells);
          this._unshiftCells(this.afterShiftCells);
          // get before cells
          // initial gap
          var gapX = this.cursorPosition;
          var cellIndex = this.cells.length - 1;
          this.beforeShiftCells = this._getGapCells(gapX, cellIndex, -1);
          // get after cells
          // ending gap between last cell and end of gallery viewport
          gapX = this.size.innerWidth - this.cursorPosition;
          // start cloning at first cell, working forwards
          this.afterShiftCells = this._getGapCells(gapX, 0, 1);
        };

        proto._getGapCells = function (gapX, cellIndex, increment) {
          // keep adding cells until the cover the initial gap
          var cells = [];
          while (gapX > 0) {
            var cell = this.cells[cellIndex];
            if (!cell) {
              break;
            }
            cells.push(cell);
            cellIndex += increment;
            gapX -= cell.size.outerWidth;
          }
          return cells;
        };

        // ----- contain ----- //

        // contain cell targets so no excess sliding
        proto._containSlides = function () {
          if (!this.options.contain || this.options.wrapAround || !this.cells.length) {
            return;
          }
          var isRightToLeft = this.options.rightToLeft;
          var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
          var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
          var contentWidth = this.slideableWidth - this.getLastCell().size[endMargin];
          // content is less than gallery size
          var isContentSmaller = contentWidth < this.size.innerWidth;
          // bounds
          var beginBound = this.cursorPosition + this.cells[0].size[beginMargin];
          var endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
          // contain each cell target
          this.slides.forEach(function (slide) {
            if (isContentSmaller) {
              // all cells fit inside gallery
              slide.target = contentWidth * this.cellAlign;
            } else {
              // contain to bounds
              slide.target = Math.max(slide.target, beginBound);
              slide.target = Math.min(slide.target, endBound);
            }
          }, this);
        };

        // -----  ----- //

        /**
         * emits events via eventEmitter and jQuery events
         * @param {String} type - name of event
         * @param {Event} event - original event
         * @param {Array} args - extra arguments
         */
        proto.dispatchEvent = function (type, event, args) {
          var emitArgs = event ? [event].concat(args) : args;
          this.emitEvent(type, emitArgs);

          if (jQuery && this.$element) {
            // default trigger with type if no event
            type += this.options.namespaceJQueryEvents ? '.flickity' : '';
            var $event = type;
            if (event) {
              // create jQuery event
              var jQEvent = new jQuery.Event(event);
              jQEvent.type = type;
              $event = jQEvent;
            }
            this.$element.trigger($event, args);
          }
        };

        // -------------------------- select -------------------------- //

        /**
         * @param {Integer} index - index of the slide
         * @param {Boolean} isWrap - will wrap-around to last/first if at the end
         * @param {Boolean} isInstant - will immediately set position at selected cell
         */
        proto.select = function (index, isWrap, isInstant) {
          if (!this.isActive) {
            return;
          }
          index = parseInt(index, 10);
          this._wrapSelect(index);

          if (this.options.wrapAround || isWrap) {
            index = utils.modulo(index, this.slides.length);
          }
          // bail if invalid index
          if (!this.slides[index]) {
            return;
          }
          var prevIndex = this.selectedIndex;
          this.selectedIndex = index;
          this.updateSelectedSlide();
          if (isInstant) {
            this.positionSliderAtSelected();
          } else {
            this.startAnimation();
          }
          if (this.options.adaptiveHeight) {
            this.setGallerySize();
          }
          // events
          this.dispatchEvent('select', null, [index]);
          // change event if new index
          if (index != prevIndex) {
            this.dispatchEvent('change', null, [index]);
          }
          // old v1 event name, remove in v3
          this.dispatchEvent('cellSelect');
        };

        // wraps position for wrapAround, to move to closest slide. #113
        proto._wrapSelect = function (index) {
          var len = this.slides.length;
          var isWrapping = this.options.wrapAround && len > 1;
          if (!isWrapping) {
            return index;
          }
          var wrapIndex = utils.modulo(index, len);
          // go to shortest
          var delta = Math.abs(wrapIndex - this.selectedIndex);
          var backWrapDelta = Math.abs(wrapIndex + len - this.selectedIndex);
          var forewardWrapDelta = Math.abs(wrapIndex - len - this.selectedIndex);
          if (!this.isDragSelect && backWrapDelta < delta) {
            index += len;
          } else if (!this.isDragSelect && forewardWrapDelta < delta) {
            index -= len;
          }
          // wrap position so slider is within normal area
          if (index < 0) {
            this.x -= this.slideableWidth;
          } else if (index >= len) {
            this.x += this.slideableWidth;
          }
        };

        proto.previous = function (isWrap, isInstant) {
          this.select(this.selectedIndex - 1, isWrap, isInstant);
        };

        proto.next = function (isWrap, isInstant) {
          this.select(this.selectedIndex + 1, isWrap, isInstant);
        };

        proto.updateSelectedSlide = function () {
          var slide = this.slides[this.selectedIndex];
          // selectedIndex could be outside of slides, if triggered before resize()
          if (!slide) {
            return;
          }
          // unselect previous selected slide
          this.unselectSelectedSlide();
          // update new selected slide
          this.selectedSlide = slide;
          slide.select();
          this.selectedCells = slide.cells;
          this.selectedElements = slide.getCellElements();
          // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
          // Remove in v3?
          this.selectedCell = slide.cells[0];
          this.selectedElement = this.selectedElements[0];
        };

        proto.unselectSelectedSlide = function () {
          if (this.selectedSlide) {
            this.selectedSlide.unselect();
          }
        };

        proto.selectInitialIndex = function () {
          var initialIndex = this.options.initialIndex;
          // already activated, select previous selectedIndex
          if (this.isInitActivated) {
            this.select(this.selectedIndex, false, true);
            return;
          }
          // select with selector string
          if (initialIndex && typeof initialIndex == 'string') {
            var cell = this.queryCell(initialIndex);
            if (cell) {
              this.selectCell(initialIndex, false, true);
              return;
            }
          }

          var index = 0;
          // select with number
          if (initialIndex && this.slides[initialIndex]) {
            index = initialIndex;
          }
          // select instantly
          this.select(index, false, true);
        };

        /**
         * select slide from number or cell element
         * @param {[Element, Number]} value - zero-based index or element to select
         * @param {Boolean} isWrap - enables wrapping around for extra index
         * @param {Boolean} isInstant - disables slide animation
         */
        proto.selectCell = function (value, isWrap, isInstant) {
          // get cell
          var cell = this.queryCell(value);
          if (!cell) {
            return;
          }

          var index = this.getCellSlideIndex(cell);
          this.select(index, isWrap, isInstant);
        };

        proto.getCellSlideIndex = function (cell) {
          // get index of slides that has cell
          for (var i = 0; i < this.slides.length; i++) {
            var slide = this.slides[i];
            var index = slide.cells.indexOf(cell);
            if (index != -1) {
              return i;
            }
          }
        };

        // -------------------------- get cells -------------------------- //

        /**
         * get Flickity.Cell, given an Element
         * @param {Element} elem - matching cell element
         * @returns {Flickity.Cell} cell - matching cell
         */
        proto.getCell = function (elem) {
          // loop through cells to get the one that matches
          for (var i = 0; i < this.cells.length; i++) {
            var cell = this.cells[i];
            if (cell.element == elem) {
              return cell;
            }
          }
        };

        /**
         * get collection of Flickity.Cells, given Elements
         * @param {[Element, Array, NodeList]} elems - multiple elements
         * @returns {Array} cells - Flickity.Cells
         */
        proto.getCells = function (elems) {
          elems = utils.makeArray(elems);
          var cells = [];
          elems.forEach(function (elem) {
            var cell = this.getCell(elem);
            if (cell) {
              cells.push(cell);
            }
          }, this);
          return cells;
        };

        /**
         * get cell elements
         * @returns {Array} cellElems
         */
        proto.getCellElements = function () {
          return this.cells.map(function (cell) {
            return cell.element;
          });
        };

        /**
         * get parent cell from an element
         * @param {Element} elem - child element
         * @returns {Flickit.Cell} cell - parent cell
         */
        proto.getParentCell = function (elem) {
          // first check if elem is cell
          var cell = this.getCell(elem);
          if (cell) {
            return cell;
          }
          // try to get parent cell elem
          elem = utils.getParent(elem, '.flickity-slider > *');
          return this.getCell(elem);
        };

        /**
         * get cells adjacent to a slide
         * @param {Integer} adjCount - number of adjacent slides
         * @param {Integer} index - index of slide to start
         * @returns {Array} cells - array of Flickity.Cells
         */
        proto.getAdjacentCellElements = function (adjCount, index) {
          if (!adjCount) {
            return this.selectedSlide.getCellElements();
          }
          index = index === undefined ? this.selectedIndex : index;

          var len = this.slides.length;
          if (1 + adjCount * 2 >= len) {
            return this.getCellElements();
          }

          var cellElems = [];
          for (var i = index - adjCount; i <= index + adjCount; i++) {
            var slideIndex = this.options.wrapAround ? utils.modulo(i, len) : i;
            var slide = this.slides[slideIndex];
            if (slide) {
              cellElems = cellElems.concat(slide.getCellElements());
            }
          }
          return cellElems;
        };

        /**
         * select slide from number or cell element
         * @param {[Element, String, Number]} selector - element, selector string, or index
         * @returns {Flickity.Cell} - matching cell
         */
        proto.queryCell = function (selector) {
          if (typeof selector == 'number') {
            // use number as index
            return this.cells[selector];
          }
          if (typeof selector == 'string') {
            // do not select invalid selectors from hash: #123, #/. #791
            if (selector.match(/^[#.]?[\d/]/)) {
              return;
            }
            // use string as selector, get element
            selector = this.element.querySelector(selector);
          }
          // get cell from element
          return this.getCell(selector);
        };

        // -------------------------- events -------------------------- //

        proto.uiChange = function () {
          this.emitEvent('uiChange');
        };

        // keep focus on element when child UI elements are clicked
        proto.childUIPointerDown = function (event) {
          // HACK iOS does not allow touch events to bubble up?!
          if (event.type != 'touchstart') {
            event.preventDefault();
          }
          this.focus();
        };

        // ----- resize ----- //

        proto.onresize = function () {
          this.watchCSS();
          this.resize();
        };

        utils.debounceMethod(Flickity, 'onresize', 150);

        proto.resize = function () {
          if (!this.isActive) {
            return;
          }
          this.getSize();
          // wrap values
          if (this.options.wrapAround) {
            this.x = utils.modulo(this.x, this.slideableWidth);
          }
          this.positionCells();
          this._getWrapShiftCells();
          this.setGallerySize();
          this.emitEvent('resize');
          // update selected index for group slides, instant
          // TODO: position can be lost between groups of various numbers
          var selectedElement = this.selectedElements && this.selectedElements[0];
          this.selectCell(selectedElement, false, true);
        };

        // watches the :after property, activates/deactivates
        proto.watchCSS = function () {
          var watchOption = this.options.watchCSS;
          if (!watchOption) {
            return;
          }

          var afterContent = getComputedStyle(this.element, ':after').content;
          // activate if :after { content: 'flickity' }
          if (afterContent.indexOf('flickity') != -1) {
            this.activate();
          } else {
            this.deactivate();
          }
        };

        // ----- keydown ----- //

        // go previous/next if left/right keys pressed
        proto.onkeydown = function (event) {
          // only work if element is in focus
          var isNotFocused = document.activeElement && document.activeElement != this.element;
          if (!this.options.accessibility || isNotFocused) {
            return;
          }

          var handler = Flickity.keyboardHandlers[event.keyCode];
          if (handler) {
            handler.call(this);
          }
        };

        Flickity.keyboardHandlers = {
          // left arrow
          37: function () {
            var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
            this.uiChange();
            this[leftMethod]();
          },
          // right arrow
          39: function () {
            var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
            this.uiChange();
            this[rightMethod]();
          }
        };

        // ----- focus ----- //

        proto.focus = function () {
          // TODO remove scrollTo once focus options gets more support
          // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus ...
          //    #Browser_compatibility
          var prevScrollY = window.pageYOffset;
          this.element.focus({ preventScroll: true });
          // hack to fix scroll jump after focus, #76
          if (window.pageYOffset != prevScrollY) {
            window.scrollTo(window.pageXOffset, prevScrollY);
          }
        };

        // -------------------------- destroy -------------------------- //

        // deactivate all Flickity functionality, but keep stuff available
        proto.deactivate = function () {
          if (!this.isActive) {
            return;
          }
          this.element.classList.remove('flickity-enabled');
          this.element.classList.remove('flickity-rtl');
          this.unselectSelectedSlide();
          // destroy cells
          this.cells.forEach(function (cell) {
            cell.destroy();
          });
          this.element.removeChild(this.viewport);
          // move child elements back into element
          moveElements(this.slider.children, this.element);
          if (this.options.accessibility) {
            this.element.removeAttribute('tabIndex');
            this.element.removeEventListener('keydown', this);
          }
          // set flags
          this.isActive = false;
          this.emitEvent('deactivate');
        };

        proto.destroy = function () {
          this.deactivate();
          window.removeEventListener('resize', this);
          this.allOff();
          this.emitEvent('destroy');
          if (jQuery && this.$element) {
            jQuery.removeData(this.element, 'flickity');
          }
          delete this.element.flickityGUID;
          delete instances[this.guid];
        };

        // -------------------------- prototype -------------------------- //

        utils.extend(proto, animatePrototype);

        // -------------------------- extras -------------------------- //

        /**
         * get Flickity instance from element
         * @param {[Element, String]} elem - element or selector string
         * @returns {Flickity} - Flickity instance
         */
        Flickity.data = function (elem) {
          elem = utils.getQueryElement(elem);
          var id = elem && elem.flickityGUID;
          return id && instances[id];
        };

        utils.htmlInit(Flickity, 'flickity');

        if (jQuery && jQuery.bridget) {
          jQuery.bridget('flickity', Flickity);
        }

        // set internal jQuery, for Webpack + jQuery v3, #478
        Flickity.setJQuery = function (jq) {
          jQuery = jq;
        };

        Flickity.Cell = Cell;
        Flickity.Slide = Slide;

        return Flickity;
      });

      /***/
    },
    /* 47 */
    /***/ function (module, exports, __webpack_require__) {
      var def = __webpack_require__(7).f;
      var has = __webpack_require__(12);
      var TAG = __webpack_require__(5)('toStringTag');

      module.exports = function (it, tag, stat) {
        if (it && !has((it = stat ? it : it.prototype), TAG)) def(it, TAG, { configurable: true, value: tag });
      };

      /***/
    },
    /* 48 */
    /***/ function (module, exports) {
      module.exports = false;

      /***/
    },
    /* 49 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      var defined = __webpack_require__(29);
      var fails = __webpack_require__(1);
      var spaces = __webpack_require__(85);
      var space = '[' + spaces + ']';
      var non = '\u200b\u0085';
      var ltrim = RegExp('^' + space + space + '*');
      var rtrim = RegExp(space + space + '*$');

      var exporter = function (KEY, exec, ALIAS) {
        var exp = {};
        var FORCE = fails(function () {
          return !!spaces[KEY]() || non[KEY]() != non;
        });
        var fn = (exp[KEY] = FORCE ? exec(trim) : spaces[KEY]);
        if (ALIAS) exp[ALIAS] = fn;
        $export($export.P + $export.F * FORCE, 'String', exp);
      };

      // 1 -> String#trimLeft
      // 2 -> String#trimRight
      // 3 -> String#trim
      var trim = (exporter.trim = function (string, TYPE) {
        string = String(defined(string));
        if (TYPE & 1) string = string.replace(ltrim, '');
        if (TYPE & 2) string = string.replace(rtrim, '');
        return string;
      });

      module.exports = exporter;

      /***/
    },
    /* 50 */
    /***/ function (module, exports) {
      module.exports = {};

      /***/
    },
    /* 51 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var global = __webpack_require__(3);
      var dP = __webpack_require__(7);
      var DESCRIPTORS = __webpack_require__(9);
      var SPECIES = __webpack_require__(5)('species');

      module.exports = function (KEY) {
        var C = global[KEY];
        if (DESCRIPTORS && C && !C[SPECIES])
          dP.f(C, SPECIES, {
            configurable: true,
            get: function () {
              return this;
            }
          });
      };

      /***/
    },
    /* 52 */
    /***/ function (module, exports) {
      module.exports = function (it, Constructor, name, forbiddenField) {
        if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
          throw TypeError(name + ': incorrect invocation!');
        }
        return it;
      };

      /***/
    },
    /* 53 */
    /***/ function (module, exports, __webpack_require__) {
      var redefine = __webpack_require__(13);
      module.exports = function (target, src, safe) {
        for (var key in src) redefine(target, key, src[key], safe);
        return target;
      };

      /***/
    },
    /* 54 */
    /***/ function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(2);
      module.exports = function (it, TYPE) {
        if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
        return it;
      };

      /***/
    },
    /* 55 */
    /***/ function (module, exports, __webpack_require__) {
      var dP = __webpack_require__(56);
      var createDesc = __webpack_require__(104);
      module.exports = __webpack_require__(57)
        ? function (object, key, value) {
            return dP.f(object, key, createDesc(1, value));
          }
        : function (object, key, value) {
            object[key] = value;
            return object;
          };

      /***/
    },
    /* 56 */
    /***/ function (module, exports, __webpack_require__) {
      var anObject = __webpack_require__(35);
      var IE8_DOM_DEFINE = __webpack_require__(353);
      var toPrimitive = __webpack_require__(354);
      var dP = Object.defineProperty;

      exports.f = __webpack_require__(57)
        ? Object.defineProperty
        : function defineProperty(O, P, Attributes) {
            anObject(O);
            P = toPrimitive(P, true);
            anObject(Attributes);
            if (IE8_DOM_DEFINE)
              try {
                return dP(O, P, Attributes);
              } catch (e) {
                /* empty */
              }
            if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
            if ('value' in Attributes) O[P] = Attributes.value;
            return O;
          };

      /***/
    },
    /* 57 */
    /***/ function (module, exports, __webpack_require__) {
      // Thank's IE8 for his funny defineProperty
      module.exports = !__webpack_require__(102)(function () {
        return (
          Object.defineProperty({}, 'a', {
            get: function () {
              return 7;
            }
          }).a != 7
        );
      });

      /***/
    },
    /* 58 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      exports.__esModule = true;

      var _assign = __webpack_require__(386);

      var _assign2 = _interopRequireDefault(_assign);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      exports.default =
        _assign2.default ||
        function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

      /***/
    },
    /* 59 */
    /***/ function (module, exports, __webpack_require__) {
      // fallback for non-array-like ES3 and non-enumerable old V8 strings
      var cof = __webpack_require__(28);
      // eslint-disable-next-line no-prototype-builtins
      module.exports = Object('z').propertyIsEnumerable(0)
        ? Object
        : function (it) {
            return cof(it) == 'String' ? it.split('') : Object(it);
          };

      /***/
    },
    /* 60 */
    /***/ function (module, exports) {
      exports.f = {}.propertyIsEnumerable;

      /***/
    },
    /* 61 */
    /***/ function (module, exports, __webpack_require__) {
      // optional / simple context binding
      var aFunction = __webpack_require__(74);
      module.exports = function (fn, that, length) {
        aFunction(fn);
        if (that === undefined) return fn;
        switch (length) {
          case 1:
            return function (a) {
              return fn.call(that, a);
            };
          case 2:
            return function (a, b) {
              return fn.call(that, a, b);
            };
          case 3:
            return function (a, b, c) {
              return fn.call(that, a, b, c);
            };
        }
        return function (/* ...args */) {
          return fn.apply(that, arguments);
        };
      };

      /***/
    },
    /* 62 */
    /***/ function (module, exports) {
      module.exports = function (it) {
        return typeof it === 'object' ? it !== null : typeof it === 'function';
      };

      /***/
    },
    /* 63 */
    /***/ function (module, exports) {
      module.exports = {};

      /***/
    },
    /* 64 */
    /***/ function (module, exports, __webpack_require__) {
      // false -> Array#indexOf
      // true  -> Array#includes
      var toIObject = __webpack_require__(17);
      var toLength = __webpack_require__(8);
      var toAbsoluteIndex = __webpack_require__(41);
      module.exports = function (IS_INCLUDES) {
        return function ($this, el, fromIndex) {
          var O = toIObject($this);
          var length = toLength(O.length);
          var index = toAbsoluteIndex(fromIndex, length);
          var value;
          // Array#includes uses SameValueZero equality algorithm
          // eslint-disable-next-line no-self-compare
          if (IS_INCLUDES && el != el)
            while (length > index) {
              value = O[index++];
              // eslint-disable-next-line no-self-compare
              if (value != value) return true;
              // Array#indexOf ignores holes, Array#includes - not
            }
          else
            for (; length > index; index++)
              if (IS_INCLUDES || index in O) {
                if (O[index] === el) return IS_INCLUDES || index || 0;
              }
          return !IS_INCLUDES && -1;
        };
      };

      /***/
    },
    /* 65 */
    /***/ function (module, exports) {
      exports.f = Object.getOwnPropertySymbols;

      /***/
    },
    /* 66 */
    /***/ function (module, exports, __webpack_require__) {
      // 7.2.2 IsArray(argument)
      var cof = __webpack_require__(28);
      module.exports =
        Array.isArray ||
        function isArray(arg) {
          return cof(arg) == 'Array';
        };

      /***/
    },
    /* 67 */
    /***/ function (module, exports, __webpack_require__) {
      // getting tag from 19.1.3.6 Object.prototype.toString()
      var cof = __webpack_require__(28);
      var TAG = __webpack_require__(5)('toStringTag');
      // ES3 wrong here
      var ARG =
        cof(
          (function () {
            return arguments;
          })()
        ) == 'Arguments';

      // fallback for IE11 Script Access Denied error
      var tryGet = function (it, key) {
        try {
          return it[key];
        } catch (e) {
          /* empty */
        }
      };

      module.exports = function (it) {
        var O, T, B;
        return it === undefined
          ? 'Undefined'
          : it === null
            ? 'Null'
            : // @@toStringTag case
              typeof (T = tryGet((O = Object(it)), TAG)) == 'string'
              ? T
              : // builtinTag case
                ARG
                ? cof(O)
                : // ES3 arguments fallback
                  (B = cof(O)) == 'Object' && typeof O.callee == 'function'
                  ? 'Arguments'
                  : B;
      };

      /***/
    },
    /* 68 */
    /***/ function (module, exports, __webpack_require__) {
      var ITERATOR = __webpack_require__(5)('iterator');
      var SAFE_CLOSING = false;

      try {
        var riter = [7][ITERATOR]();
        riter['return'] = function () {
          SAFE_CLOSING = true;
        };
        // eslint-disable-next-line no-throw-literal
        Array.from(riter, function () {
          throw 2;
        });
      } catch (e) {
        /* empty */
      }

      module.exports = function (exec, skipClosing) {
        if (!skipClosing && !SAFE_CLOSING) return false;
        var safe = false;
        try {
          var arr = [7];
          var iter = arr[ITERATOR]();
          iter.next = function () {
            return { done: (safe = true) };
          };
          arr[ITERATOR] = function () {
            return iter;
          };
          exec(arr);
        } catch (e) {
          /* empty */
        }
        return safe;
      };

      /***/
    },
    /* 69 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var hide = __webpack_require__(16);
      var redefine = __webpack_require__(13);
      var fails = __webpack_require__(1);
      var defined = __webpack_require__(29);
      var wks = __webpack_require__(5);

      module.exports = function (KEY, length, exec) {
        var SYMBOL = wks(KEY);
        var fns = exec(defined, SYMBOL, ''[KEY]);
        var strfn = fns[0];
        var rxfn = fns[1];
        if (
          fails(function () {
            var O = {};
            O[SYMBOL] = function () {
              return 7;
            };
            return ''[KEY](O) != 7;
          })
        ) {
          redefine(String.prototype, KEY, strfn);
          hide(
            RegExp.prototype,
            SYMBOL,
            length == 2
              ? // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
                // 21.2.5.11 RegExp.prototype[@@split](string, limit)
                function (string, arg) {
                  return rxfn.call(string, this, arg);
                }
              : // 21.2.5.6 RegExp.prototype[@@match](string)
                // 21.2.5.9 RegExp.prototype[@@search](string)
                function (string) {
                  return rxfn.call(string, this);
                }
          );
        }
      };

      /***/
    },
    /* 70 */
    /***/ function (module, exports, __webpack_require__) {
      var ctx = __webpack_require__(23);
      var call = __webpack_require__(134);
      var isArrayIter = __webpack_require__(94);
      var anObject = __webpack_require__(4);
      var toLength = __webpack_require__(8);
      var getIterFn = __webpack_require__(96);
      var BREAK = {};
      var RETURN = {};
      var exports = (module.exports = function (iterable, entries, fn, that, ITERATOR) {
        var iterFn = ITERATOR
          ? function () {
              return iterable;
            }
          : getIterFn(iterable);
        var f = ctx(fn, that, entries ? 2 : 1);
        var index = 0;
        var length, step, iterator, result;
        if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
        // fast case for arrays with default iterator
        if (isArrayIter(iterFn))
          for (length = toLength(iterable.length); length > index; index++) {
            result = entries ? f(anObject((step = iterable[index]))[0], step[1]) : f(iterable[index]);
            if (result === BREAK || result === RETURN) return result;
          }
        else
          for (iterator = iterFn.call(iterable); !(step = iterator.next()).done; ) {
            result = call(iterator, f, step.value, entries);
            if (result === BREAK || result === RETURN) return result;
          }
      });
      exports.BREAK = BREAK;
      exports.RETURN = RETURN;

      /***/
    },
    /* 71 */
    /***/ function (module, exports, __webpack_require__) {
      // 7.3.20 SpeciesConstructor(O, defaultConstructor)
      var anObject = __webpack_require__(4);
      var aFunction = __webpack_require__(24);
      var SPECIES = __webpack_require__(5)('species');
      module.exports = function (O, D) {
        var C = anObject(O).constructor;
        var S;
        return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
      };

      /***/
    },
    /* 72 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var global = __webpack_require__(3);
      var $export = __webpack_require__(0);
      var redefine = __webpack_require__(13);
      var redefineAll = __webpack_require__(53);
      var meta = __webpack_require__(33);
      var forOf = __webpack_require__(70);
      var anInstance = __webpack_require__(52);
      var isObject = __webpack_require__(2);
      var fails = __webpack_require__(1);
      var $iterDetect = __webpack_require__(68);
      var setToStringTag = __webpack_require__(47);
      var inheritIfRequired = __webpack_require__(86);

      module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
        var Base = global[NAME];
        var C = Base;
        var ADDER = IS_MAP ? 'set' : 'add';
        var proto = C && C.prototype;
        var O = {};
        var fixMethod = function (KEY) {
          var fn = proto[KEY];
          redefine(
            proto,
            KEY,
            KEY == 'delete'
              ? function (a) {
                  return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
                }
              : KEY == 'has'
                ? function has(a) {
                    return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
                  }
                : KEY == 'get'
                  ? function get(a) {
                      return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
                    }
                  : KEY == 'add'
                    ? function add(a) {
                        fn.call(this, a === 0 ? 0 : a);
                        return this;
                      }
                    : function set(a, b) {
                        fn.call(this, a === 0 ? 0 : a, b);
                        return this;
                      }
          );
        };
        if (
          typeof C != 'function' ||
          !(
            IS_WEAK ||
            (proto.forEach &&
              !fails(function () {
                new C().entries().next();
              }))
          )
        ) {
          // create collection constructor
          C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
          redefineAll(C.prototype, methods);
          meta.NEED = true;
        } else {
          var instance = new C();
          // early implementations not supports chaining
          var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
          // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
          var THROWS_ON_PRIMITIVES = fails(function () {
            instance.has(1);
          });
          // most early implementations doesn't supports iterables, most modern - not close it correctly
          var ACCEPT_ITERABLES = $iterDetect(function (iter) {
            new C(iter);
          }); // eslint-disable-line no-new
          // for early implementations -0 and +0 not the same
          var BUGGY_ZERO =
            !IS_WEAK &&
            fails(function () {
              // V8 ~ Chromium 42- fails only with 5+ elements
              var $instance = new C();
              var index = 5;
              while (index--) $instance[ADDER](index, index);
              return !$instance.has(-0);
            });
          if (!ACCEPT_ITERABLES) {
            C = wrapper(function (target, iterable) {
              anInstance(target, C, NAME);
              var that = inheritIfRequired(new Base(), target, C);
              if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
              return that;
            });
            C.prototype = proto;
            proto.constructor = C;
          }
          if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod('delete');
            fixMethod('has');
            IS_MAP && fixMethod('get');
          }
          if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
          // weak collections should not contains .clear method
          if (IS_WEAK && proto.clear) delete proto.clear;
        }

        setToStringTag(C, NAME);

        O[NAME] = C;
        $export($export.G + $export.W + $export.F * (C != Base), O);

        if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

        return C;
      };

      /***/
    },
    /* 73 */
    /***/ function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var hide = __webpack_require__(16);
      var uid = __webpack_require__(39);
      var TYPED = uid('typed_array');
      var VIEW = uid('view');
      var ABV = !!(global.ArrayBuffer && global.DataView);
      var CONSTR = ABV;
      var i = 0;
      var l = 9;
      var Typed;

      var TypedArrayConstructors =
        'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'.split(
          ','
        );

      while (i < l) {
        if ((Typed = global[TypedArrayConstructors[i++]])) {
          hide(Typed.prototype, TYPED, true);
          hide(Typed.prototype, VIEW, true);
        } else CONSTR = false;
      }

      module.exports = {
        ABV: ABV,
        CONSTR: CONSTR,
        TYPED: TYPED,
        VIEW: VIEW
      };

      /***/
    },
    /* 74 */
    /***/ function (module, exports) {
      module.exports = function (it) {
        if (typeof it != 'function') throw TypeError(it + ' is not a function!');
        return it;
      };

      /***/
    },
    /* 75 */
    /***/ function (module, exports) {
      var toString = {}.toString;

      module.exports = function (it) {
        return toString.call(it).slice(8, -1);
      };

      /***/
    },
    /* 76 */
    /***/ function (module, exports) {
      var hasOwnProperty = {}.hasOwnProperty;
      module.exports = function (it, key) {
        return hasOwnProperty.call(it, key);
      };

      /***/
    },
    /* 77 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      exports.__esModule = true;

      var _from = __webpack_require__(161);

      var _from2 = _interopRequireDefault(_from);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      exports.default = function (arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
          }

          return arr2;
        } else {
          return (0, _from2.default)(arr);
        }
      };

      /***/
    },
    /* 78 */
    /***/ function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(2);
      var document = __webpack_require__(3).document;
      // typeof document.createElement is 'object' in old IE
      var is = isObject(document) && isObject(document.createElement);
      module.exports = function (it) {
        return is ? document.createElement(it) : {};
      };

      /***/
    },
    /* 79 */
    /***/ function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var SHARED = '__core-js_shared__';
      var store = global[SHARED] || (global[SHARED] = {});
      module.exports = function (key) {
        return store[key] || (store[key] = {});
      };

      /***/
    },
    /* 80 */
    /***/ function (module, exports, __webpack_require__) {
      exports.f = __webpack_require__(5);

      /***/
    },
    /* 81 */
    /***/ function (module, exports, __webpack_require__) {
      var shared = __webpack_require__(79)('keys');
      var uid = __webpack_require__(39);
      module.exports = function (key) {
        return shared[key] || (shared[key] = uid(key));
      };

      /***/
    },
    /* 82 */
    /***/ function (module, exports) {
      // IE 8- don't enum bug keys
      module.exports =
        'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

      /***/
    },
    /* 83 */
    /***/ function (module, exports, __webpack_require__) {
      var document = __webpack_require__(3).document;
      module.exports = document && document.documentElement;

      /***/
    },
    /* 84 */
    /***/ function (module, exports, __webpack_require__) {
      // Works with __proto__ only. Old v8 can't work with null proto objects.
      /* eslint-disable no-proto */
      var isObject = __webpack_require__(2);
      var anObject = __webpack_require__(4);
      var check = function (O, proto) {
        anObject(O);
        if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
      };
      module.exports = {
        set:
          Object.setPrototypeOf ||
          ('__proto__' in {} // eslint-disable-line
            ? (function (test, buggy, set) {
                try {
                  set = __webpack_require__(23)(
                    Function.call,
                    __webpack_require__(25).f(Object.prototype, '__proto__').set,
                    2
                  );
                  set(test, []);
                  buggy = !(test instanceof Array);
                } catch (e) {
                  buggy = true;
                }
                return function setPrototypeOf(O, proto) {
                  check(O, proto);
                  if (buggy) O.__proto__ = proto;
                  else set(O, proto);
                  return O;
                };
              })({}, false)
            : undefined),
        check: check
      };

      /***/
    },
    /* 85 */
    /***/ function (module, exports) {
      module.exports =
        '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
        '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

      /***/
    },
    /* 86 */
    /***/ function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(2);
      var setPrototypeOf = __webpack_require__(84).set;
      module.exports = function (that, target, C) {
        var S = target.constructor;
        var P;
        if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
          setPrototypeOf(that, P);
        }
        return that;
      };

      /***/
    },
    /* 87 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var toInteger = __webpack_require__(30);
      var defined = __webpack_require__(29);

      module.exports = function repeat(count) {
        var str = String(defined(this));
        var res = '';
        var n = toInteger(count);
        if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
        for (; n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
        return res;
      };

      /***/
    },
    /* 88 */
    /***/ function (module, exports) {
      // 20.2.2.28 Math.sign(x)
      module.exports =
        Math.sign ||
        function sign(x) {
          // eslint-disable-next-line no-self-compare
          return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
        };

      /***/
    },
    /* 89 */
    /***/ function (module, exports) {
      // 20.2.2.14 Math.expm1(x)
      var $expm1 = Math.expm1;
      module.exports =
        !$expm1 ||
        // Old FF bug
        $expm1(10) > 22025.465794806719 ||
        $expm1(10) < 22025.4657948067165168 ||
        // Tor Browser bug
        $expm1(-2e-17) != -2e-17
          ? function expm1(x) {
              return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + (x * x) / 2 : Math.exp(x) - 1;
            }
          : $expm1;

      /***/
    },
    /* 90 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var LIBRARY = __webpack_require__(48);
      var $export = __webpack_require__(0);
      var redefine = __webpack_require__(13);
      var hide = __webpack_require__(16);
      var has = __webpack_require__(12);
      var Iterators = __webpack_require__(50);
      var $iterCreate = __webpack_require__(133);
      var setToStringTag = __webpack_require__(47);
      var getPrototypeOf = __webpack_require__(44);
      var ITERATOR = __webpack_require__(5)('iterator');
      var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
      var FF_ITERATOR = '@@iterator';
      var KEYS = 'keys';
      var VALUES = 'values';

      var returnThis = function () {
        return this;
      };

      module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
        $iterCreate(Constructor, NAME, next);
        var getMethod = function (kind) {
          if (!BUGGY && kind in proto) return proto[kind];
          switch (kind) {
            case KEYS:
              return function keys() {
                return new Constructor(this, kind);
              };
            case VALUES:
              return function values() {
                return new Constructor(this, kind);
              };
          }
          return function entries() {
            return new Constructor(this, kind);
          };
        };
        var TAG = NAME + ' Iterator';
        var DEF_VALUES = DEFAULT == VALUES;
        var VALUES_BUG = false;
        var proto = Base.prototype;
        var $native = proto[ITERATOR] || proto[FF_ITERATOR] || (DEFAULT && proto[DEFAULT]);
        var $default = $native || getMethod(DEFAULT);
        var $entries = DEFAULT ? (!DEF_VALUES ? $default : getMethod('entries')) : undefined;
        var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
        var methods, key, IteratorPrototype;
        // Fix native
        if ($anyNative) {
          IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
          if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            setToStringTag(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
          }
        }
        // fix Array#{values, @@iterator}.name in V8 / FF
        if (DEF_VALUES && $native && $native.name !== VALUES) {
          VALUES_BUG = true;
          $default = function values() {
            return $native.call(this);
          };
        }
        // Define iterator
        if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
          hide(proto, ITERATOR, $default);
        }
        // Plug for library
        Iterators[NAME] = $default;
        Iterators[TAG] = returnThis;
        if (DEFAULT) {
          methods = {
            values: DEF_VALUES ? $default : getMethod(VALUES),
            keys: IS_SET ? $default : getMethod(KEYS),
            entries: $entries
          };
          if (FORCED)
            for (key in methods) {
              if (!(key in proto)) redefine(proto, key, methods[key]);
            }
          else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
        }
        return methods;
      };

      /***/
    },
    /* 91 */
    /***/ function (module, exports, __webpack_require__) {
      // helper for String#{startsWith, endsWith, includes}
      var isRegExp = __webpack_require__(92);
      var defined = __webpack_require__(29);

      module.exports = function (that, searchString, NAME) {
        if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
        return String(defined(that));
      };

      /***/
    },
    /* 92 */
    /***/ function (module, exports, __webpack_require__) {
      // 7.2.8 IsRegExp(argument)
      var isObject = __webpack_require__(2);
      var cof = __webpack_require__(28);
      var MATCH = __webpack_require__(5)('match');
      module.exports = function (it) {
        var isRegExp;
        return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
      };

      /***/
    },
    /* 93 */
    /***/ function (module, exports, __webpack_require__) {
      var MATCH = __webpack_require__(5)('match');
      module.exports = function (KEY) {
        var re = /./;
        try {
          '/./'[KEY](re);
        } catch (e) {
          try {
            re[MATCH] = false;
            return !'/./'[KEY](re);
          } catch (f) {
            /* empty */
          }
        }
        return true;
      };

      /***/
    },
    /* 94 */
    /***/ function (module, exports, __webpack_require__) {
      // check on default Array iterator
      var Iterators = __webpack_require__(50);
      var ITERATOR = __webpack_require__(5)('iterator');
      var ArrayProto = Array.prototype;

      module.exports = function (it) {
        return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
      };

      /***/
    },
    /* 95 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var $defineProperty = __webpack_require__(7);
      var createDesc = __webpack_require__(38);

      module.exports = function (object, index, value) {
        if (index in object) $defineProperty.f(object, index, createDesc(0, value));
        else object[index] = value;
      };

      /***/
    },
    /* 96 */
    /***/ function (module, exports, __webpack_require__) {
      var classof = __webpack_require__(67);
      var ITERATOR = __webpack_require__(5)('iterator');
      var Iterators = __webpack_require__(50);
      module.exports = __webpack_require__(6).getIteratorMethod = function (it) {
        if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
      };

      /***/
    },
    /* 97 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';
      // 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

      var toObject = __webpack_require__(14);
      var toAbsoluteIndex = __webpack_require__(41);
      var toLength = __webpack_require__(8);
      module.exports = function fill(value /* , start = 0, end = @length */) {
        var O = toObject(this);
        var length = toLength(O.length);
        var aLen = arguments.length;
        var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
        var end = aLen > 2 ? arguments[2] : undefined;
        var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
        while (endPos > index) O[index++] = value;
        return O;
      };

      /***/
    },
    /* 98 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var addToUnscopables = __webpack_require__(45);
      var step = __webpack_require__(138);
      var Iterators = __webpack_require__(50);
      var toIObject = __webpack_require__(17);

      // 22.1.3.4 Array.prototype.entries()
      // 22.1.3.13 Array.prototype.keys()
      // 22.1.3.29 Array.prototype.values()
      // 22.1.3.30 Array.prototype[@@iterator]()
      module.exports = __webpack_require__(90)(
        Array,
        'Array',
        function (iterated, kind) {
          this._t = toIObject(iterated); // target
          this._i = 0; // next index
          this._k = kind; // kind
          // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
        },
        function () {
          var O = this._t;
          var kind = this._k;
          var index = this._i++;
          if (!O || index >= O.length) {
            this._t = undefined;
            return step(1);
          }
          if (kind == 'keys') return step(0, index);
          if (kind == 'values') return step(0, O[index]);
          return step(0, [index, O[index]]);
        },
        'values'
      );

      // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
      Iterators.Arguments = Iterators.Array;

      addToUnscopables('keys');
      addToUnscopables('values');
      addToUnscopables('entries');

      /***/
    },
    /* 99 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // 21.2.5.3 get RegExp.prototype.flags
      var anObject = __webpack_require__(4);
      module.exports = function () {
        var that = anObject(this);
        var result = '';
        if (that.global) result += 'g';
        if (that.ignoreCase) result += 'i';
        if (that.multiline) result += 'm';
        if (that.unicode) result += 'u';
        if (that.sticky) result += 'y';
        return result;
      };

      /***/
    },
    /* 100 */
    /***/ function (module, exports, __webpack_require__) {
      var ctx = __webpack_require__(23);
      var invoke = __webpack_require__(126);
      var html = __webpack_require__(83);
      var cel = __webpack_require__(78);
      var global = __webpack_require__(3);
      var process = global.process;
      var setTask = global.setImmediate;
      var clearTask = global.clearImmediate;
      var MessageChannel = global.MessageChannel;
      var Dispatch = global.Dispatch;
      var counter = 0;
      var queue = {};
      var ONREADYSTATECHANGE = 'onreadystatechange';
      var defer, channel, port;
      var run = function () {
        var id = +this;
        // eslint-disable-next-line no-prototype-builtins
        if (queue.hasOwnProperty(id)) {
          var fn = queue[id];
          delete queue[id];
          fn();
        }
      };
      var listener = function (event) {
        run.call(event.data);
      };
      // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
      if (!setTask || !clearTask) {
        setTask = function setImmediate(fn) {
          var args = [];
          var i = 1;
          while (arguments.length > i) args.push(arguments[i++]);
          queue[++counter] = function () {
            // eslint-disable-next-line no-new-func
            invoke(typeof fn == 'function' ? fn : Function(fn), args);
          };
          defer(counter);
          return counter;
        };
        clearTask = function clearImmediate(id) {
          delete queue[id];
        };
        // Node.js 0.8-
        if (__webpack_require__(28)(process) == 'process') {
          defer = function (id) {
            process.nextTick(ctx(run, id, 1));
          };
          // Sphere (JS game engine) Dispatch API
        } else if (Dispatch && Dispatch.now) {
          defer = function (id) {
            Dispatch.now(ctx(run, id, 1));
          };
          // Browsers with MessageChannel, includes WebWorkers
        } else if (MessageChannel) {
          channel = new MessageChannel();
          port = channel.port2;
          channel.port1.onmessage = listener;
          defer = ctx(port.postMessage, port, 1);
          // Browsers with postMessage, skip WebWorkers
          // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
        } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
          defer = function (id) {
            global.postMessage(id + '', '*');
          };
          global.addEventListener('message', listener, false);
          // IE8-
        } else if (ONREADYSTATECHANGE in cel('script')) {
          defer = function (id) {
            html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
              html.removeChild(this);
              run.call(id);
            };
          };
          // Rest old browsers
        } else {
          defer = function (id) {
            setTimeout(ctx(run, id, 1), 0);
          };
        }
      }
      module.exports = {
        set: setTask,
        clear: clearTask
      };

      /***/
    },
    /* 101 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var global = __webpack_require__(3);
      var DESCRIPTORS = __webpack_require__(9);
      var LIBRARY = __webpack_require__(48);
      var $typed = __webpack_require__(73);
      var hide = __webpack_require__(16);
      var redefineAll = __webpack_require__(53);
      var fails = __webpack_require__(1);
      var anInstance = __webpack_require__(52);
      var toInteger = __webpack_require__(30);
      var toLength = __webpack_require__(8);
      var toIndex = __webpack_require__(145);
      var gOPN = __webpack_require__(43).f;
      var dP = __webpack_require__(7).f;
      var arrayFill = __webpack_require__(97);
      var setToStringTag = __webpack_require__(47);
      var ARRAY_BUFFER = 'ArrayBuffer';
      var DATA_VIEW = 'DataView';
      var PROTOTYPE = 'prototype';
      var WRONG_LENGTH = 'Wrong length!';
      var WRONG_INDEX = 'Wrong index!';
      var $ArrayBuffer = global[ARRAY_BUFFER];
      var $DataView = global[DATA_VIEW];
      var Math = global.Math;
      var RangeError = global.RangeError;
      // eslint-disable-next-line no-shadow-restricted-names
      var Infinity = global.Infinity;
      var BaseBuffer = $ArrayBuffer;
      var abs = Math.abs;
      var pow = Math.pow;
      var floor = Math.floor;
      var log = Math.log;
      var LN2 = Math.LN2;
      var BUFFER = 'buffer';
      var BYTE_LENGTH = 'byteLength';
      var BYTE_OFFSET = 'byteOffset';
      var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
      var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
      var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

      // IEEE754 conversions based on https://github.com/feross/ieee754
      function packIEEE754(value, mLen, nBytes) {
        var buffer = Array(nBytes);
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
        var i = 0;
        var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;
        var e, m, c;
        value = abs(value);
        // eslint-disable-next-line no-self-compare
        if (value != value || value === Infinity) {
          // eslint-disable-next-line no-self-compare
          m = value != value ? 1 : 0;
          e = eMax;
        } else {
          e = floor(log(value) / LN2);
          if (value * (c = pow(2, -e)) < 1) {
            e--;
            c *= 2;
          }
          if (e + eBias >= 1) {
            value += rt / c;
          } else {
            value += rt * pow(2, 1 - eBias);
          }
          if (value * c >= 2) {
            e++;
            c /= 2;
          }
          if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
          } else if (e + eBias >= 1) {
            m = (value * c - 1) * pow(2, mLen);
            e = e + eBias;
          } else {
            m = value * pow(2, eBias - 1) * pow(2, mLen);
            e = 0;
          }
        }
        for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
        e = (e << mLen) | m;
        eLen += mLen;
        for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
        buffer[--i] |= s * 128;
        return buffer;
      }
      function unpackIEEE754(buffer, mLen, nBytes) {
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var nBits = eLen - 7;
        var i = nBytes - 1;
        var s = buffer[i--];
        var e = s & 127;
        var m;
        s >>= 7;
        for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
        m = e & ((1 << -nBits) - 1);
        e >>= -nBits;
        nBits += mLen;
        for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
        if (e === 0) {
          e = 1 - eBias;
        } else if (e === eMax) {
          return m ? NaN : s ? -Infinity : Infinity;
        } else {
          m = m + pow(2, mLen);
          e = e - eBias;
        }
        return (s ? -1 : 1) * m * pow(2, e - mLen);
      }

      function unpackI32(bytes) {
        return (bytes[3] << 24) | (bytes[2] << 16) | (bytes[1] << 8) | bytes[0];
      }
      function packI8(it) {
        return [it & 0xff];
      }
      function packI16(it) {
        return [it & 0xff, (it >> 8) & 0xff];
      }
      function packI32(it) {
        return [it & 0xff, (it >> 8) & 0xff, (it >> 16) & 0xff, (it >> 24) & 0xff];
      }
      function packF64(it) {
        return packIEEE754(it, 52, 8);
      }
      function packF32(it) {
        return packIEEE754(it, 23, 4);
      }

      function addGetter(C, key, internal) {
        dP(C[PROTOTYPE], key, {
          get: function () {
            return this[internal];
          }
        });
      }

      function get(view, bytes, index, isLittleEndian) {
        var numIndex = +index;
        var intIndex = toIndex(numIndex);
        if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
        var store = view[$BUFFER]._b;
        var start = intIndex + view[$OFFSET];
        var pack = store.slice(start, start + bytes);
        return isLittleEndian ? pack : pack.reverse();
      }
      function set(view, bytes, index, conversion, value, isLittleEndian) {
        var numIndex = +index;
        var intIndex = toIndex(numIndex);
        if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
        var store = view[$BUFFER]._b;
        var start = intIndex + view[$OFFSET];
        var pack = conversion(+value);
        for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
      }

      if (!$typed.ABV) {
        $ArrayBuffer = function ArrayBuffer(length) {
          anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
          var byteLength = toIndex(length);
          this._b = arrayFill.call(Array(byteLength), 0);
          this[$LENGTH] = byteLength;
        };

        $DataView = function DataView(buffer, byteOffset, byteLength) {
          anInstance(this, $DataView, DATA_VIEW);
          anInstance(buffer, $ArrayBuffer, DATA_VIEW);
          var bufferLength = buffer[$LENGTH];
          var offset = toInteger(byteOffset);
          if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
          byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
          if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
          this[$BUFFER] = buffer;
          this[$OFFSET] = offset;
          this[$LENGTH] = byteLength;
        };

        if (DESCRIPTORS) {
          addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
          addGetter($DataView, BUFFER, '_b');
          addGetter($DataView, BYTE_LENGTH, '_l');
          addGetter($DataView, BYTE_OFFSET, '_o');
        }

        redefineAll($DataView[PROTOTYPE], {
          getInt8: function getInt8(byteOffset) {
            return (get(this, 1, byteOffset)[0] << 24) >> 24;
          },
          getUint8: function getUint8(byteOffset) {
            return get(this, 1, byteOffset)[0];
          },
          getInt16: function getInt16(byteOffset /* , littleEndian */) {
            var bytes = get(this, 2, byteOffset, arguments[1]);
            return (((bytes[1] << 8) | bytes[0]) << 16) >> 16;
          },
          getUint16: function getUint16(byteOffset /* , littleEndian */) {
            var bytes = get(this, 2, byteOffset, arguments[1]);
            return (bytes[1] << 8) | bytes[0];
          },
          getInt32: function getInt32(byteOffset /* , littleEndian */) {
            return unpackI32(get(this, 4, byteOffset, arguments[1]));
          },
          getUint32: function getUint32(byteOffset /* , littleEndian */) {
            return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
          },
          getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
            return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
          },
          getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
            return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
          },
          setInt8: function setInt8(byteOffset, value) {
            set(this, 1, byteOffset, packI8, value);
          },
          setUint8: function setUint8(byteOffset, value) {
            set(this, 1, byteOffset, packI8, value);
          },
          setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
            set(this, 2, byteOffset, packI16, value, arguments[2]);
          },
          setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
            set(this, 2, byteOffset, packI16, value, arguments[2]);
          },
          setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
            set(this, 4, byteOffset, packI32, value, arguments[2]);
          },
          setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
            set(this, 4, byteOffset, packI32, value, arguments[2]);
          },
          setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
            set(this, 4, byteOffset, packF32, value, arguments[2]);
          },
          setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
            set(this, 8, byteOffset, packF64, value, arguments[2]);
          }
        });
      } else {
        if (
          !fails(function () {
            $ArrayBuffer(1);
          }) ||
          !fails(function () {
            new $ArrayBuffer(-1); // eslint-disable-line no-new
          }) ||
          fails(function () {
            new $ArrayBuffer(); // eslint-disable-line no-new
            new $ArrayBuffer(1.5); // eslint-disable-line no-new
            new $ArrayBuffer(NaN); // eslint-disable-line no-new
            return $ArrayBuffer.name != ARRAY_BUFFER;
          })
        ) {
          $ArrayBuffer = function ArrayBuffer(length) {
            anInstance(this, $ArrayBuffer);
            return new BaseBuffer(toIndex(length));
          };
          var ArrayBufferProto = ($ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE]);
          for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ) {
            if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
          }
          if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
        }
        // iOS Safari 7.x bug
        var view = new $DataView(new $ArrayBuffer(2));
        var $setInt8 = $DataView[PROTOTYPE].setInt8;
        view.setInt8(0, 2147483648);
        view.setInt8(1, 2147483649);
        if (view.getInt8(0) || !view.getInt8(1))
          redefineAll(
            $DataView[PROTOTYPE],
            {
              setInt8: function setInt8(byteOffset, value) {
                $setInt8.call(this, byteOffset, (value << 24) >> 24);
              },
              setUint8: function setUint8(byteOffset, value) {
                $setInt8.call(this, byteOffset, (value << 24) >> 24);
              }
            },
            true
          );
      }
      setToStringTag($ArrayBuffer, ARRAY_BUFFER);
      setToStringTag($DataView, DATA_VIEW);
      hide($DataView[PROTOTYPE], $typed.VIEW, true);
      exports[ARRAY_BUFFER] = $ArrayBuffer;
      exports[DATA_VIEW] = $DataView;

      /***/
    },
    /* 102 */
    /***/ function (module, exports) {
      module.exports = function (exec) {
        try {
          return !!exec();
        } catch (e) {
          return true;
        }
      };

      /***/
    },
    /* 103 */
    /***/ function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(62);
      var document = __webpack_require__(18).document;
      // typeof document.createElement is 'object' in old IE
      var is = isObject(document) && isObject(document.createElement);
      module.exports = function (it) {
        return is ? document.createElement(it) : {};
      };

      /***/
    },
    /* 104 */
    /***/ function (module, exports) {
      module.exports = function (bitmap, value) {
        return {
          enumerable: !(bitmap & 1),
          configurable: !(bitmap & 2),
          writable: !(bitmap & 4),
          value: value
        };
      };

      /***/
    },
    /* 105 */
    /***/ function (module, exports, __webpack_require__) {
      // to indexed object, toObject with fallback for non-array-like ES3 strings
      var IObject = __webpack_require__(152);
      var defined = __webpack_require__(106);
      module.exports = function (it) {
        return IObject(defined(it));
      };

      /***/
    },
    /* 106 */
    /***/ function (module, exports) {
      // 7.2.1 RequireObjectCoercible(argument)
      module.exports = function (it) {
        if (it == undefined) throw TypeError("Can't call method on  " + it);
        return it;
      };

      /***/
    },
    /* 107 */
    /***/ function (module, exports, __webpack_require__) {
      // 7.1.15 ToLength
      var toInteger = __webpack_require__(108);
      var min = Math.min;
      module.exports = function (it) {
        return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
      };

      /***/
    },
    /* 108 */
    /***/ function (module, exports) {
      // 7.1.4 ToInteger
      var ceil = Math.ceil;
      var floor = Math.floor;
      module.exports = function (it) {
        return isNaN((it = +it)) ? 0 : (it > 0 ? floor : ceil)(it);
      };

      /***/
    },
    /* 109 */
    /***/ function (module, exports, __webpack_require__) {
      var shared = __webpack_require__(156)('keys');
      var uid = __webpack_require__(157);
      module.exports = function (key) {
        return shared[key] || (shared[key] = uid(key));
      };

      /***/
    },
    /* 110 */
    /***/ function (module, exports, __webpack_require__) {
      var def = __webpack_require__(56).f;
      var has = __webpack_require__(76);
      var TAG = __webpack_require__(22)('toStringTag');

      module.exports = function (it, tag, stat) {
        if (it && !has((it = stat ? it : it.prototype), TAG)) def(it, TAG, { configurable: true, value: tag });
      };

      /***/
    },
    /* 111 */
    /***/ function (module, exports, __webpack_require__) {
      // 7.1.13 ToObject(argument)
      var defined = __webpack_require__(106);
      module.exports = function (it) {
        return Object(defined(it));
      };

      /***/
    },
    /* 112 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var $at = __webpack_require__(379)(true);

      // 21.1.3.27 String.prototype[@@iterator]()
      __webpack_require__(153)(
        String,
        'String',
        function (iterated) {
          this._t = String(iterated); // target
          this._i = 0; // next index
          // 21.1.5.2.1 %StringIteratorPrototype%.next()
        },
        function () {
          var O = this._t;
          var index = this._i;
          var point;
          if (index >= O.length) return { value: undefined, done: true };
          point = $at(O, index);
          this._i += point.length;
          return { value: point, done: false };
        }
      );

      /***/
    },
    /* 113 */
    /***/ function (module, exports, __webpack_require__) {
      var classof = __webpack_require__(160);
      var ITERATOR = __webpack_require__(22)('iterator');
      var Iterators = __webpack_require__(63);
      module.exports = __webpack_require__(21).getIteratorMethod = function (it) {
        if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
      };

      /***/
    },
    /* 114 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__; /**
       * EvEmitter v1.1.0
       * Lil' event emitter
       * MIT License
       */

      /* jshint unused: true, undef: true, strict: true */

      (function (global, factory) {
        // universal module definition
        /* jshint strict: false */ /* globals define, module, window */
        if (true) {
          // AMD - RequireJS
          !((__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function'
              ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof module == 'object' && module.exports) {
          // CommonJS - Browserify, Webpack
          module.exports = factory();
        } else {
          // Browser globals
          global.EvEmitter = factory();
        }
      })(typeof window != 'undefined' ? window : this, function () {
        'use strict';

        function EvEmitter() {}

        var proto = EvEmitter.prototype;

        proto.on = function (eventName, listener) {
          if (!eventName || !listener) {
            return;
          }
          // set events hash
          var events = (this._events = this._events || {});
          // set listeners array
          var listeners = (events[eventName] = events[eventName] || []);
          // only add once
          if (listeners.indexOf(listener) == -1) {
            listeners.push(listener);
          }

          return this;
        };

        proto.once = function (eventName, listener) {
          if (!eventName || !listener) {
            return;
          }
          // add event
          this.on(eventName, listener);
          // set once flag
          // set onceEvents hash
          var onceEvents = (this._onceEvents = this._onceEvents || {});
          // set onceListeners object
          var onceListeners = (onceEvents[eventName] = onceEvents[eventName] || {});
          // set flag
          onceListeners[listener] = true;

          return this;
        };

        proto.off = function (eventName, listener) {
          var listeners = this._events && this._events[eventName];
          if (!listeners || !listeners.length) {
            return;
          }
          var index = listeners.indexOf(listener);
          if (index != -1) {
            listeners.splice(index, 1);
          }

          return this;
        };

        proto.emitEvent = function (eventName, args) {
          var listeners = this._events && this._events[eventName];
          if (!listeners || !listeners.length) {
            return;
          }
          // copy over to avoid interference if .off() in listener
          listeners = listeners.slice(0);
          args = args || [];
          // once stuff
          var onceListeners = this._onceEvents && this._onceEvents[eventName];

          for (var i = 0; i < listeners.length; i++) {
            var listener = listeners[i];
            var isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
              // remove listener
              // remove before trigger to prevent recursion
              this.off(eventName, listener);
              // unset once flag
              delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
          }

          return this;
        };

        proto.allOff = function () {
          delete this._events;
          delete this._onceEvents;
        };

        return EvEmitter;
      });

      /***/
    },
    /* 115 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
       * Unipointer v2.3.0
       * base class for doing one thing with pointer event
       * MIT license
       */

      /*jshint browser: true, undef: true, unused: true, strict: true */

      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */ /*global define, module, require */
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(114)]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (EvEmitter) {
            return factory(window, EvEmitter);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof module == 'object' && module.exports) {
          // CommonJS
          module.exports = factory(window, require('ev-emitter'));
        } else {
          // browser global
          window.Unipointer = factory(window, window.EvEmitter);
        }
      })(window, function factory(window, EvEmitter) {
        'use strict';

        function noop() {}

        function Unipointer() {}

        // inherit EvEmitter
        var proto = (Unipointer.prototype = Object.create(EvEmitter.prototype));

        proto.bindStartEvent = function (elem) {
          this._bindStartEvent(elem, true);
        };

        proto.unbindStartEvent = function (elem) {
          this._bindStartEvent(elem, false);
        };

        /**
         * Add or remove start event
         * @param {Boolean} isAdd - remove if falsey
         */
        proto._bindStartEvent = function (elem, isAdd) {
          // munge isAdd, default to true
          isAdd = isAdd === undefined ? true : isAdd;
          var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';

          // default to mouse events
          var startEvent = 'mousedown';
          if (window.PointerEvent) {
            // Pointer Events
            startEvent = 'pointerdown';
          } else if ('ontouchstart' in window) {
            // Touch Events. iOS Safari
            startEvent = 'touchstart';
          }
          elem[bindMethod](startEvent, this);
        };

        // trigger handler methods for events
        proto.handleEvent = function (event) {
          var method = 'on' + event.type;
          if (this[method]) {
            this[method](event);
          }
        };

        // returns the touch that we're keeping track of
        proto.getTouch = function (touches) {
          for (var i = 0; i < touches.length; i++) {
            var touch = touches[i];
            if (touch.identifier == this.pointerIdentifier) {
              return touch;
            }
          }
        };

        // ----- start event ----- //

        proto.onmousedown = function (event) {
          // dismiss clicks from right or middle buttons
          var button = event.button;
          if (button && button !== 0 && button !== 1) {
            return;
          }
          this._pointerDown(event, event);
        };

        proto.ontouchstart = function (event) {
          this._pointerDown(event, event.changedTouches[0]);
        };

        proto.onpointerdown = function (event) {
          this._pointerDown(event, event);
        };

        /**
         * pointer start
         * @param {Event} event
         * @param {Event or Touch} pointer
         */
        proto._pointerDown = function (event, pointer) {
          // dismiss right click and other pointers
          // button = 0 is okay, 1-4 not
          if (event.button || this.isPointerDown) {
            return;
          }

          this.isPointerDown = true;
          // save pointer identifier to match up touch events
          this.pointerIdentifier =
            pointer.pointerId !== undefined
              ? // pointerId for pointer events, touch.indentifier for touch events
                pointer.pointerId
              : pointer.identifier;

          this.pointerDown(event, pointer);
        };

        proto.pointerDown = function (event, pointer) {
          this._bindPostStartEvents(event);
          this.emitEvent('pointerDown', [event, pointer]);
        };

        // hash of events to be bound after start event
        var postStartEvents = {
          mousedown: ['mousemove', 'mouseup'],
          touchstart: ['touchmove', 'touchend', 'touchcancel'],
          pointerdown: ['pointermove', 'pointerup', 'pointercancel']
        };

        proto._bindPostStartEvents = function (event) {
          if (!event) {
            return;
          }
          // get proper events to match start event
          var events = postStartEvents[event.type];
          // bind events to node
          events.forEach(function (eventName) {
            window.addEventListener(eventName, this);
          }, this);
          // save these arguments
          this._boundPointerEvents = events;
        };

        proto._unbindPostStartEvents = function () {
          // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
          if (!this._boundPointerEvents) {
            return;
          }
          this._boundPointerEvents.forEach(function (eventName) {
            window.removeEventListener(eventName, this);
          }, this);

          delete this._boundPointerEvents;
        };

        // ----- move event ----- //

        proto.onmousemove = function (event) {
          this._pointerMove(event, event);
        };

        proto.onpointermove = function (event) {
          if (event.pointerId == this.pointerIdentifier) {
            this._pointerMove(event, event);
          }
        };

        proto.ontouchmove = function (event) {
          var touch = this.getTouch(event.changedTouches);
          if (touch) {
            this._pointerMove(event, touch);
          }
        };

        /**
         * pointer move
         * @param {Event} event
         * @param {Event or Touch} pointer
         * @private
         */
        proto._pointerMove = function (event, pointer) {
          this.pointerMove(event, pointer);
        };

        // public
        proto.pointerMove = function (event, pointer) {
          this.emitEvent('pointerMove', [event, pointer]);
        };

        // ----- end event ----- //

        proto.onmouseup = function (event) {
          this._pointerUp(event, event);
        };

        proto.onpointerup = function (event) {
          if (event.pointerId == this.pointerIdentifier) {
            this._pointerUp(event, event);
          }
        };

        proto.ontouchend = function (event) {
          var touch = this.getTouch(event.changedTouches);
          if (touch) {
            this._pointerUp(event, touch);
          }
        };

        /**
         * pointer up
         * @param {Event} event
         * @param {Event or Touch} pointer
         * @private
         */
        proto._pointerUp = function (event, pointer) {
          this._pointerDone();
          this.pointerUp(event, pointer);
        };

        // public
        proto.pointerUp = function (event, pointer) {
          this.emitEvent('pointerUp', [event, pointer]);
        };

        // ----- pointer done ----- //

        // triggered on pointer up & pointer cancel
        proto._pointerDone = function () {
          this._pointerReset();
          this._unbindPostStartEvents();
          this.pointerDone();
        };

        proto._pointerReset = function () {
          // reset properties
          this.isPointerDown = false;
          delete this.pointerIdentifier;
        };

        proto.pointerDone = noop;

        // ----- pointer cancel ----- //

        proto.onpointercancel = function (event) {
          if (event.pointerId == this.pointerIdentifier) {
            this._pointerCancel(event, event);
          }
        };

        proto.ontouchcancel = function (event) {
          var touch = this.getTouch(event.changedTouches);
          if (touch) {
            this._pointerCancel(event, touch);
          }
        };

        /**
         * pointer cancel
         * @param {Event} event
         * @param {Event or Touch} pointer
         * @private
         */
        proto._pointerCancel = function (event, pointer) {
          this._pointerDone();
          this.pointerCancel(event, pointer);
        };

        // public
        proto.pointerCancel = function (event, pointer) {
          this.emitEvent('pointerCancel', [event, pointer]);
        };

        // -----  ----- //

        // utility function for getting x/y coords from event
        Unipointer.getPointerPoint = function (pointer) {
          return {
            x: pointer.pageX,
            y: pointer.pageY
          };
        };

        // -----  ----- //

        return Unipointer;
      });

      /***/
    },
    /* 116 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
       * jQuery JavaScript Library v3.6.0
       * https://jquery.com/
       *
       * Includes Sizzle.js
       * https://sizzlejs.com/
       *
       * Copyright OpenJS Foundation and other contributors
       * Released under the MIT license
       * https://jquery.org/license
       *
       * Date: 2021-03-02T17:08Z
       */
      (function (global, factory) {
        'use strict';

        if (typeof module === 'object' && typeof module.exports === 'object') {
          // For CommonJS and CommonJS-like environments where a proper `window`
          // is present, execute the factory and get jQuery.
          // For environments that do not have a `window` with a `document`
          // (such as Node.js), expose a factory as module.exports.
          // This accentuates the need for the creation of a real `window`.
          // e.g. var jQuery = require("jquery")(window);
          // See ticket #14549 for more info.
          module.exports = global.document
            ? factory(global, true)
            : function (w) {
                if (!w.document) {
                  throw new Error('jQuery requires a window with a document');
                }
                return factory(w);
              };
        } else {
          factory(global);
        }

        // Pass this if window is not defined yet
      })(typeof window !== 'undefined' ? window : this, function (window, noGlobal) {
        // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
        // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
        // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
        // enough that all such attempts are guarded in a try block.
        'use strict';

        var arr = [];

        var getProto = Object.getPrototypeOf;

        var slice = arr.slice;

        var flat = arr.flat
          ? function (array) {
              return arr.flat.call(array);
            }
          : function (array) {
              return arr.concat.apply([], array);
            };

        var push = arr.push;

        var indexOf = arr.indexOf;

        var class2type = {};

        var toString = class2type.toString;

        var hasOwn = class2type.hasOwnProperty;

        var fnToString = hasOwn.toString;

        var ObjectFunctionString = fnToString.call(Object);

        var support = {};

        var isFunction = function isFunction(obj) {
          // Support: Chrome <=57, Firefox <=52
          // In some browsers, typeof returns "function" for HTML <object> elements
          // (i.e., `typeof document.createElement( "object" ) === "function"`).
          // We don't want to classify *any* DOM node as a function.
          // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
          // Plus for old WebKit, typeof returns "function" for HTML collections
          // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
          return typeof obj === 'function' && typeof obj.nodeType !== 'number' && typeof obj.item !== 'function';
        };

        var isWindow = function isWindow(obj) {
          return obj != null && obj === obj.window;
        };

        var document = window.document;

        var preservedScriptAttributes = {
          type: true,
          src: true,
          nonce: true,
          noModule: true
        };

        function DOMEval(code, node, doc) {
          doc = doc || document;

          var i,
            val,
            script = doc.createElement('script');

          script.text = code;
          if (node) {
            for (i in preservedScriptAttributes) {
              // Support: Firefox 64+, Edge 18+
              // Some browsers don't support the "nonce" property on scripts.
              // On the other hand, just using `getAttribute` is not enough as
              // the `nonce` attribute is reset to an empty string whenever it
              // becomes browsing-context connected.
              // See https://github.com/whatwg/html/issues/2369
              // See https://html.spec.whatwg.org/#nonce-attributes
              // The `node.getAttribute` check was added for the sake of
              // `jQuery.globalEval` so that it can fake a nonce-containing node
              // via an object.
              val = node[i] || (node.getAttribute && node.getAttribute(i));
              if (val) {
                script.setAttribute(i, val);
              }
            }
          }
          doc.head.appendChild(script).parentNode.removeChild(script);
        }

        function toType(obj) {
          if (obj == null) {
            return obj + '';
          }

          // Support: Android <=2.3 only (functionish RegExp)
          return typeof obj === 'object' || typeof obj === 'function'
            ? class2type[toString.call(obj)] || 'object'
            : typeof obj;
        }
        /* global Symbol */
        // Defining this global in .eslintrc.json would create a danger of using the global
        // unguarded in another place, it seems safer to define global only for this module

        var version = '3.6.0',
          // Define a local copy of jQuery
          jQuery = function (selector, context) {
            // The jQuery object is actually just the init constructor 'enhanced'
            // Need init if jQuery is called (just allow error to be thrown if not included)
            return new jQuery.fn.init(selector, context);
          };

        jQuery.fn = jQuery.prototype = {
          // The current version of jQuery being used
          jquery: version,

          constructor: jQuery,

          // The default length of a jQuery object is 0
          length: 0,

          toArray: function () {
            return slice.call(this);
          },

          // Get the Nth element in the matched element set OR
          // Get the whole matched element set as a clean array
          get: function (num) {
            // Return all the elements in a clean array
            if (num == null) {
              return slice.call(this);
            }

            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
          },

          // Take an array of elements and push it onto the stack
          // (returning the new matched element set)
          pushStack: function (elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);

            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;

            // Return the newly-formed element set
            return ret;
          },

          // Execute a callback for every element in the matched set.
          each: function (callback) {
            return jQuery.each(this, callback);
          },

          map: function (callback) {
            return this.pushStack(
              jQuery.map(this, function (elem, i) {
                return callback.call(elem, i, elem);
              })
            );
          },

          slice: function () {
            return this.pushStack(slice.apply(this, arguments));
          },

          first: function () {
            return this.eq(0);
          },

          last: function () {
            return this.eq(-1);
          },

          even: function () {
            return this.pushStack(
              jQuery.grep(this, function (_elem, i) {
                return (i + 1) % 2;
              })
            );
          },

          odd: function () {
            return this.pushStack(
              jQuery.grep(this, function (_elem, i) {
                return i % 2;
              })
            );
          },

          eq: function (i) {
            var len = this.length,
              j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
          },

          end: function () {
            return this.prevObject || this.constructor();
          },

          // For internal use only.
          // Behaves like an Array's method, not like a jQuery method.
          push: push,
          sort: arr.sort,
          splice: arr.splice
        };

        jQuery.extend = jQuery.fn.extend = function () {
          var options,
            name,
            src,
            copy,
            copyIsArray,
            clone,
            target = arguments[0] || {},
            i = 1,
            length = arguments.length,
            deep = false;

          // Handle a deep copy situation
          if (typeof target === 'boolean') {
            deep = target;

            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
          }

          // Handle case when target is a string or something (possible in deep copy)
          if (typeof target !== 'object' && !isFunction(target)) {
            target = {};
          }

          // Extend jQuery itself if only one argument is passed
          if (i === length) {
            target = this;
            i--;
          }

          for (; i < length; i++) {
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) {
              // Extend the base object
              for (name in options) {
                copy = options[name];

                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === '__proto__' || target === copy) {
                  continue;
                }

                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                  src = target[name];

                  // Ensure proper type for the source value
                  if (copyIsArray && !Array.isArray(src)) {
                    clone = [];
                  } else if (!copyIsArray && !jQuery.isPlainObject(src)) {
                    clone = {};
                  } else {
                    clone = src;
                  }
                  copyIsArray = false;

                  // Never move original objects, clone them
                  target[name] = jQuery.extend(deep, clone, copy);

                  // Don't bring in undefined values
                } else if (copy !== undefined) {
                  target[name] = copy;
                }
              }
            }
          }

          // Return the modified object
          return target;
        };

        jQuery.extend({
          // Unique for each copy of jQuery on the page
          expando: 'jQuery' + (version + Math.random()).replace(/\D/g, ''),

          // Assume jQuery is ready without the ready module
          isReady: true,

          error: function (msg) {
            throw new Error(msg);
          },

          noop: function () {},

          isPlainObject: function (obj) {
            var proto, Ctor;

            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== '[object Object]') {
              return false;
            }

            proto = getProto(obj);

            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) {
              return true;
            }

            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor === 'function' && fnToString.call(Ctor) === ObjectFunctionString;
          },

          isEmptyObject: function (obj) {
            var name;

            for (name in obj) {
              return false;
            }
            return true;
          },

          // Evaluates a script in a provided context; falls back to the global one
          // if not specified.
          globalEval: function (code, options, doc) {
            DOMEval(code, { nonce: options && options.nonce }, doc);
          },

          each: function (obj, callback) {
            var length,
              i = 0;

            if (isArrayLike(obj)) {
              length = obj.length;
              for (; i < length; i++) {
                if (callback.call(obj[i], i, obj[i]) === false) {
                  break;
                }
              }
            } else {
              for (i in obj) {
                if (callback.call(obj[i], i, obj[i]) === false) {
                  break;
                }
              }
            }

            return obj;
          },

          // results is for internal usage only
          makeArray: function (arr, results) {
            var ret = results || [];

            if (arr != null) {
              if (isArrayLike(Object(arr))) {
                jQuery.merge(ret, typeof arr === 'string' ? [arr] : arr);
              } else {
                push.call(ret, arr);
              }
            }

            return ret;
          },

          inArray: function (elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
          },

          // Support: Android <=4.0 only, PhantomJS 1 only
          // push.apply(_, arraylike) throws on ancient WebKit
          merge: function (first, second) {
            var len = +second.length,
              j = 0,
              i = first.length;

            for (; j < len; j++) {
              first[i++] = second[j];
            }

            first.length = i;

            return first;
          },

          grep: function (elems, callback, invert) {
            var callbackInverse,
              matches = [],
              i = 0,
              length = elems.length,
              callbackExpect = !invert;

            // Go through the array, only saving the items
            // that pass the validator function
            for (; i < length; i++) {
              callbackInverse = !callback(elems[i], i);
              if (callbackInverse !== callbackExpect) {
                matches.push(elems[i]);
              }
            }

            return matches;
          },

          // arg is for internal usage only
          map: function (elems, callback, arg) {
            var length,
              value,
              i = 0,
              ret = [];

            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
              length = elems.length;
              for (; i < length; i++) {
                value = callback(elems[i], i, arg);

                if (value != null) {
                  ret.push(value);
                }
              }

              // Go through every key on the object,
            } else {
              for (i in elems) {
                value = callback(elems[i], i, arg);

                if (value != null) {
                  ret.push(value);
                }
              }
            }

            // Flatten any nested arrays
            return flat(ret);
          },

          // A global GUID counter for objects
          guid: 1,

          // jQuery.support is not used in Core but other projects attach their
          // properties to it so it needs to exist.
          support: support
        });

        if (typeof Symbol === 'function') {
          jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
        }

        // Populate the class2type map
        jQuery.each(
          'Boolean Number String Function Array Date RegExp Object Error Symbol'.split(' '),
          function (_i, name) {
            class2type['[object ' + name + ']'] = name.toLowerCase();
          }
        );

        function isArrayLike(obj) {
          // Support: real iOS 8.2 only (not reproducible in simulator)
          // `in` check used to prevent JIT error (gh-2145)
          // hasOwn isn't used here due to false negatives
          // regarding Nodelist length in IE
          var length = !!obj && 'length' in obj && obj.length,
            type = toType(obj);

          if (isFunction(obj) || isWindow(obj)) {
            return false;
          }

          return type === 'array' || length === 0 || (typeof length === 'number' && length > 0 && length - 1 in obj);
        }
        var Sizzle =
          /*!
           * Sizzle CSS Selector Engine v2.3.6
           * https://sizzlejs.com/
           *
           * Copyright JS Foundation and other contributors
           * Released under the MIT license
           * https://js.foundation/
           *
           * Date: 2021-02-16
           */
          (function (window) {
            var i,
              support,
              Expr,
              getText,
              isXML,
              tokenize,
              compile,
              select,
              outermostContext,
              sortInput,
              hasDuplicate,
              // Local document vars
              setDocument,
              document,
              docElem,
              documentIsHTML,
              rbuggyQSA,
              rbuggyMatches,
              matches,
              contains,
              // Instance-specific data
              expando = 'sizzle' + 1 * new Date(),
              preferredDoc = window.document,
              dirruns = 0,
              done = 0,
              classCache = createCache(),
              tokenCache = createCache(),
              compilerCache = createCache(),
              nonnativeSelectorCache = createCache(),
              sortOrder = function (a, b) {
                if (a === b) {
                  hasDuplicate = true;
                }
                return 0;
              },
              // Instance methods
              hasOwn = {}.hasOwnProperty,
              arr = [],
              pop = arr.pop,
              pushNative = arr.push,
              push = arr.push,
              slice = arr.slice,
              // Use a stripped-down indexOf as it's faster than native
              // https://jsperf.com/thor-indexof-vs-for/5
              indexOf = function (list, elem) {
                var i = 0,
                  len = list.length;
                for (; i < len; i++) {
                  if (list[i] === elem) {
                    return i;
                  }
                }
                return -1;
              },
              booleans =
                'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|' +
                'ismap|loop|multiple|open|readonly|required|scoped',
              // Regular expressions

              // http://www.w3.org/TR/css3-selectors/#whitespace
              whitespace = '[\\x20\\t\\r\\n\\f]',
              // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
              identifier = '(?:\\\\[\\da-fA-F]{1,6}' + whitespace + '?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+',
              // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
              attributes =
                '\\[' +
                whitespace +
                '*(' +
                identifier +
                ')(?:' +
                whitespace +
                // Operator (capture 2)
                '*([*^$|!~]?=)' +
                whitespace +
                // "Attribute values must be CSS identifiers [capture 5]
                // or strings [capture 3 or capture 4]"
                '*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' +
                identifier +
                '))|)' +
                whitespace +
                '*\\]',
              pseudos =
                ':(' +
                identifier +
                ')(?:\\((' +
                // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
                // 1. quoted (capture 3; capture 4 or capture 5)
                '(\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|' +
                // 2. simple (capture 6)
                '((?:\\\\.|[^\\\\()[\\]]|' +
                attributes +
                ')*)|' +
                // 3. anything else (capture 2)
                '.*' +
                ')\\)|)',
              // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
              rwhitespace = new RegExp(whitespace + '+', 'g'),
              rtrim = new RegExp('^' + whitespace + '+|((?:^|[^\\\\])(?:\\\\.)*)' + whitespace + '+$', 'g'),
              rcomma = new RegExp('^' + whitespace + '*,' + whitespace + '*'),
              rcombinators = new RegExp('^' + whitespace + '*([>+~]|' + whitespace + ')' + whitespace + '*'),
              rdescend = new RegExp(whitespace + '|>'),
              rpseudo = new RegExp(pseudos),
              ridentifier = new RegExp('^' + identifier + '$'),
              matchExpr = {
                ID: new RegExp('^#(' + identifier + ')'),
                CLASS: new RegExp('^\\.(' + identifier + ')'),
                TAG: new RegExp('^(' + identifier + '|[*])'),
                ATTR: new RegExp('^' + attributes),
                PSEUDO: new RegExp('^' + pseudos),
                CHILD: new RegExp(
                  '^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' +
                    whitespace +
                    '*(even|odd|(([+-]|)(\\d*)n|)' +
                    whitespace +
                    '*(?:([+-]|)' +
                    whitespace +
                    '*(\\d+)|))' +
                    whitespace +
                    '*\\)|)',
                  'i'
                ),
                bool: new RegExp('^(?:' + booleans + ')$', 'i'),

                // For use in libraries implementing .is()
                // We use this for POS matching in `select`
                needsContext: new RegExp(
                  '^' +
                    whitespace +
                    '*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' +
                    whitespace +
                    '*((?:-\\d)?\\d*)' +
                    whitespace +
                    '*\\)|)(?=[^-]|$)',
                  'i'
                )
              },
              rhtml = /HTML$/i,
              rinputs = /^(?:input|select|textarea|button)$/i,
              rheader = /^h\d$/i,
              rnative = /^[^{]+\{\s*\[native \w/,
              // Easily-parseable/retrievable ID or TAG or CLASS selectors
              rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
              rsibling = /[+~]/,
              // CSS escapes
              // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
              runescape = new RegExp('\\\\[\\da-fA-F]{1,6}' + whitespace + '?|\\\\([^\\r\\n\\f])', 'g'),
              funescape = function (escape, nonHex) {
                var high = '0x' + escape.slice(1) - 0x10000;

                return nonHex
                  ? // Strip the backslash prefix from a non-hex escape sequence
                    nonHex
                  : // Replace a hexadecimal escape sequence with the encoded Unicode code point
                    // Support: IE <=11+
                    // For values outside the Basic Multilingual Plane (BMP), manually construct a
                    // surrogate pair
                    high < 0
                    ? String.fromCharCode(high + 0x10000)
                    : String.fromCharCode((high >> 10) | 0xd800, (high & 0x3ff) | 0xdc00);
              },
              // CSS string/identifier serialization
              // https://drafts.csswg.org/cssom/#common-serializing-idioms
              rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
              fcssescape = function (ch, asCodePoint) {
                if (asCodePoint) {
                  // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                  if (ch === '\0') {
                    return '\uFFFD';
                  }

                  // Control characters and (dependent upon position) numbers get escaped as code points
                  return ch.slice(0, -1) + '\\' + ch.charCodeAt(ch.length - 1).toString(16) + ' ';
                }

                // Other potentially-special ASCII characters get backslash-escaped
                return '\\' + ch;
              },
              // Used for iframes
              // See setDocument()
              // Removing the function wrapper causes a "Permission Denied"
              // error in IE
              unloadHandler = function () {
                setDocument();
              },
              inDisabledFieldset = addCombinator(
                function (elem) {
                  return elem.disabled === true && elem.nodeName.toLowerCase() === 'fieldset';
                },
                { dir: 'parentNode', next: 'legend' }
              );

            // Optimize for push.apply( _, NodeList )
            try {
              push.apply((arr = slice.call(preferredDoc.childNodes)), preferredDoc.childNodes);

              // Support: Android<4.0
              // Detect silently failing push.apply
              // eslint-disable-next-line no-unused-expressions
              arr[preferredDoc.childNodes.length].nodeType;
            } catch (e) {
              push = {
                apply: arr.length
                  ? // Leverage slice if possible
                    function (target, els) {
                      pushNative.apply(target, slice.call(els));
                    }
                  : // Support: IE<9
                    // Otherwise append directly
                    function (target, els) {
                      var j = target.length,
                        i = 0;

                      // Can't trust NodeList.length
                      while ((target[j++] = els[i++])) {}
                      target.length = j - 1;
                    }
              };
            }

            function Sizzle(selector, context, results, seed) {
              var m,
                i,
                elem,
                nid,
                match,
                groups,
                newSelector,
                newContext = context && context.ownerDocument,
                // nodeType defaults to 9, since context defaults to document
                nodeType = context ? context.nodeType : 9;

              results = results || [];

              // Return early from calls with invalid selector or context
              if (typeof selector !== 'string' || !selector || (nodeType !== 1 && nodeType !== 9 && nodeType !== 11)) {
                return results;
              }

              // Try to shortcut find operations (as opposed to filters) in HTML documents
              if (!seed) {
                setDocument(context);
                context = context || document;

                if (documentIsHTML) {
                  // If the selector is sufficiently simple, try using a "get*By*" DOM method
                  // (excepting DocumentFragment context, where the methods don't exist)
                  if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                    // ID selector
                    if ((m = match[1])) {
                      // Document context
                      if (nodeType === 9) {
                        if ((elem = context.getElementById(m))) {
                          // Support: IE, Opera, Webkit
                          // TODO: identify versions
                          // getElementById can match elements by name instead of ID
                          if (elem.id === m) {
                            results.push(elem);
                            return results;
                          }
                        } else {
                          return results;
                        }

                        // Element context
                      } else {
                        // Support: IE, Opera, Webkit
                        // TODO: identify versions
                        // getElementById can match elements by name instead of ID
                        if (
                          newContext &&
                          (elem = newContext.getElementById(m)) &&
                          contains(context, elem) &&
                          elem.id === m
                        ) {
                          results.push(elem);
                          return results;
                        }
                      }

                      // Type selector
                    } else if (match[2]) {
                      push.apply(results, context.getElementsByTagName(selector));
                      return results;

                      // Class selector
                    } else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {
                      push.apply(results, context.getElementsByClassName(m));
                      return results;
                    }
                  }

                  // Take advantage of querySelectorAll
                  if (
                    support.qsa &&
                    !nonnativeSelectorCache[selector + ' '] &&
                    (!rbuggyQSA || !rbuggyQSA.test(selector)) &&
                    // Support: IE 8 only
                    // Exclude object elements
                    (nodeType !== 1 || context.nodeName.toLowerCase() !== 'object')
                  ) {
                    newSelector = selector;
                    newContext = context;

                    // qSA considers elements outside a scoping root when evaluating child or
                    // descendant combinators, which is not what we want.
                    // In such cases, we work around the behavior by prefixing every selector in the
                    // list with an ID selector referencing the scope context.
                    // The technique has to be used as well when a leading combinator is used
                    // as such selectors are not recognized by querySelectorAll.
                    // Thanks to Andrew Dupont for this technique.
                    if (nodeType === 1 && (rdescend.test(selector) || rcombinators.test(selector))) {
                      // Expand context for sibling selectors
                      newContext = (rsibling.test(selector) && testContext(context.parentNode)) || context;

                      // We can use :scope instead of the ID hack if the browser
                      // supports it & if we're not changing the context.
                      if (newContext !== context || !support.scope) {
                        // Capture the context ID, setting it first if necessary
                        if ((nid = context.getAttribute('id'))) {
                          nid = nid.replace(rcssescape, fcssescape);
                        } else {
                          context.setAttribute('id', (nid = expando));
                        }
                      }

                      // Prefix every selector in the list
                      groups = tokenize(selector);
                      i = groups.length;
                      while (i--) {
                        groups[i] = (nid ? '#' + nid : ':scope') + ' ' + toSelector(groups[i]);
                      }
                      newSelector = groups.join(',');
                    }

                    try {
                      push.apply(results, newContext.querySelectorAll(newSelector));
                      return results;
                    } catch (qsaError) {
                      nonnativeSelectorCache(selector, true);
                    } finally {
                      if (nid === expando) {
                        context.removeAttribute('id');
                      }
                    }
                  }
                }
              }

              // All others
              return select(selector.replace(rtrim, '$1'), context, results, seed);
            }

            /**
             * Create key-value caches of limited size
             * @returns {function(string, object)} Returns the Object data after storing it on itself with
             *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
             *	deleting the oldest entry
             */
            function createCache() {
              var keys = [];

              function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                if (keys.push(key + ' ') > Expr.cacheLength) {
                  // Only keep the most recent entries
                  delete cache[keys.shift()];
                }
                return (cache[key + ' '] = value);
              }
              return cache;
            }

            /**
             * Mark a function for special use by Sizzle
             * @param {Function} fn The function to mark
             */
            function markFunction(fn) {
              fn[expando] = true;
              return fn;
            }

            /**
             * Support testing using an element
             * @param {Function} fn Passed the created element and returns a boolean result
             */
            function assert(fn) {
              var el = document.createElement('fieldset');

              try {
                return !!fn(el);
              } catch (e) {
                return false;
              } finally {
                // Remove from its parent by default
                if (el.parentNode) {
                  el.parentNode.removeChild(el);
                }

                // release memory in IE
                el = null;
              }
            }

            /**
             * Adds the same handler for all of the specified attrs
             * @param {String} attrs Pipe-separated list of attributes
             * @param {Function} handler The method that will be applied
             */
            function addHandle(attrs, handler) {
              var arr = attrs.split('|'),
                i = arr.length;

              while (i--) {
                Expr.attrHandle[arr[i]] = handler;
              }
            }

            /**
             * Checks document order of two siblings
             * @param {Element} a
             * @param {Element} b
             * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
             */
            function siblingCheck(a, b) {
              var cur = b && a,
                diff = cur && a.nodeType === 1 && b.nodeType === 1 && a.sourceIndex - b.sourceIndex;

              // Use IE sourceIndex if available on both nodes
              if (diff) {
                return diff;
              }

              // Check if b follows a
              if (cur) {
                while ((cur = cur.nextSibling)) {
                  if (cur === b) {
                    return -1;
                  }
                }
              }

              return a ? 1 : -1;
            }

            /**
             * Returns a function to use in pseudos for input types
             * @param {String} type
             */
            function createInputPseudo(type) {
              return function (elem) {
                var name = elem.nodeName.toLowerCase();
                return name === 'input' && elem.type === type;
              };
            }

            /**
             * Returns a function to use in pseudos for buttons
             * @param {String} type
             */
            function createButtonPseudo(type) {
              return function (elem) {
                var name = elem.nodeName.toLowerCase();
                return (name === 'input' || name === 'button') && elem.type === type;
              };
            }

            /**
             * Returns a function to use in pseudos for :enabled/:disabled
             * @param {Boolean} disabled true for :disabled; false for :enabled
             */
            function createDisabledPseudo(disabled) {
              // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
              return function (elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ('form' in elem) {
                  // Check for inherited disabledness on relevant non-disabled elements:
                  // * listed form-associated elements in a disabled fieldset
                  //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                  //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                  // * option elements in a disabled optgroup
                  //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                  // All such elements have a "form" property.
                  if (elem.parentNode && elem.disabled === false) {
                    // Option elements defer to a parent optgroup if present
                    if ('label' in elem) {
                      if ('label' in elem.parentNode) {
                        return elem.parentNode.disabled === disabled;
                      } else {
                        return elem.disabled === disabled;
                      }
                    }

                    // Support: IE 6 - 11
                    // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                    return (
                      elem.isDisabled === disabled ||
                      // Where there is no isDisabled, check manually
                      /* jshint -W018 */
                      (elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled)
                    );
                  }

                  return elem.disabled === disabled;

                  // Try to winnow out elements that can't be disabled before trusting the disabled property.
                  // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                  // even exist on them, let alone have a boolean value.
                } else if ('label' in elem) {
                  return elem.disabled === disabled;
                }

                // Remaining elements are neither :enabled nor :disabled
                return false;
              };
            }

            /**
             * Returns a function to use in pseudos for positionals
             * @param {Function} fn
             */
            function createPositionalPseudo(fn) {
              return markFunction(function (argument) {
                argument = +argument;
                return markFunction(function (seed, matches) {
                  var j,
                    matchIndexes = fn([], seed.length, argument),
                    i = matchIndexes.length;

                  // Match elements found at the specified indexes
                  while (i--) {
                    if (seed[(j = matchIndexes[i])]) {
                      seed[j] = !(matches[j] = seed[j]);
                    }
                  }
                });
              });
            }

            /**
             * Checks a node for validity as a Sizzle context
             * @param {Element|Object=} context
             * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
             */
            function testContext(context) {
              return context && typeof context.getElementsByTagName !== 'undefined' && context;
            }

            // Expose support vars for convenience
            support = Sizzle.support = {};

            /**
             * Detects XML nodes
             * @param {Element|Object} elem An element or a document
             * @returns {Boolean} True iff elem is a non-HTML XML node
             */
            isXML = Sizzle.isXML = function (elem) {
              var namespace = elem && elem.namespaceURI,
                docElem = elem && (elem.ownerDocument || elem).documentElement;

              // Support: IE <=8
              // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
              // https://bugs.jquery.com/ticket/4833
              return !rhtml.test(namespace || (docElem && docElem.nodeName) || 'HTML');
            };

            /**
             * Sets document-related variables once based on the current document
             * @param {Element|Object} [doc] An element or document object to use to set the document
             * @returns {Object} Returns the current document
             */
            setDocument = Sizzle.setDocument = function (node) {
              var hasCompare,
                subWindow,
                doc = node ? node.ownerDocument || node : preferredDoc;

              // Return early if doc is invalid or already selected
              // Support: IE 11+, Edge 17 - 18+
              // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
              // two documents; shallow comparisons work.
              // eslint-disable-next-line eqeqeq
              if (doc == document || doc.nodeType !== 9 || !doc.documentElement) {
                return document;
              }

              // Update global variables
              document = doc;
              docElem = document.documentElement;
              documentIsHTML = !isXML(document);

              // Support: IE 9 - 11+, Edge 12 - 18+
              // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
              // Support: IE 11+, Edge 17 - 18+
              // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
              // two documents; shallow comparisons work.
              // eslint-disable-next-line eqeqeq
              if (preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {
                // Support: IE 11, Edge
                if (subWindow.addEventListener) {
                  subWindow.addEventListener('unload', unloadHandler, false);

                  // Support: IE 9 - 10 only
                } else if (subWindow.attachEvent) {
                  subWindow.attachEvent('onunload', unloadHandler);
                }
              }

              // Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
              // Safari 4 - 5 only, Opera <=11.6 - 12.x only
              // IE/Edge & older browsers don't support the :scope pseudo-class.
              // Support: Safari 6.0 only
              // Safari 6.0 supports :scope but it's an alias of :root there.
              support.scope = assert(function (el) {
                docElem.appendChild(el).appendChild(document.createElement('div'));
                return typeof el.querySelectorAll !== 'undefined' && !el.querySelectorAll(':scope fieldset div').length;
              });

              /* Attributes
	---------------------------------------------------------------------- */

              // Support: IE<8
              // Verify that getAttribute really returns attributes and not properties
              // (excepting IE8 booleans)
              support.attributes = assert(function (el) {
                el.className = 'i';
                return !el.getAttribute('className');
              });

              /* getElement(s)By*
	---------------------------------------------------------------------- */

              // Check if getElementsByTagName("*") returns only elements
              support.getElementsByTagName = assert(function (el) {
                el.appendChild(document.createComment(''));
                return !el.getElementsByTagName('*').length;
              });

              // Support: IE<9
              support.getElementsByClassName = rnative.test(document.getElementsByClassName);

              // Support: IE<10
              // Check if getElementById returns elements by name
              // The broken getElementById methods don't pick up programmatically-set names,
              // so use a roundabout getElementsByName test
              support.getById = assert(function (el) {
                docElem.appendChild(el).id = expando;
                return !document.getElementsByName || !document.getElementsByName(expando).length;
              });

              // ID filter and find
              if (support.getById) {
                Expr.filter['ID'] = function (id) {
                  var attrId = id.replace(runescape, funescape);
                  return function (elem) {
                    return elem.getAttribute('id') === attrId;
                  };
                };
                Expr.find['ID'] = function (id, context) {
                  if (typeof context.getElementById !== 'undefined' && documentIsHTML) {
                    var elem = context.getElementById(id);
                    return elem ? [elem] : [];
                  }
                };
              } else {
                Expr.filter['ID'] = function (id) {
                  var attrId = id.replace(runescape, funescape);
                  return function (elem) {
                    var node = typeof elem.getAttributeNode !== 'undefined' && elem.getAttributeNode('id');
                    return node && node.value === attrId;
                  };
                };

                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find['ID'] = function (id, context) {
                  if (typeof context.getElementById !== 'undefined' && documentIsHTML) {
                    var node,
                      i,
                      elems,
                      elem = context.getElementById(id);

                    if (elem) {
                      // Verify the id attribute
                      node = elem.getAttributeNode('id');
                      if (node && node.value === id) {
                        return [elem];
                      }

                      // Fall back on getElementsByName
                      elems = context.getElementsByName(id);
                      i = 0;
                      while ((elem = elems[i++])) {
                        node = elem.getAttributeNode('id');
                        if (node && node.value === id) {
                          return [elem];
                        }
                      }
                    }

                    return [];
                  }
                };
              }

              // Tag
              Expr.find['TAG'] = support.getElementsByTagName
                ? function (tag, context) {
                    if (typeof context.getElementsByTagName !== 'undefined') {
                      return context.getElementsByTagName(tag);

                      // DocumentFragment nodes don't have gEBTN
                    } else if (support.qsa) {
                      return context.querySelectorAll(tag);
                    }
                  }
                : function (tag, context) {
                    var elem,
                      tmp = [],
                      i = 0,
                      // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                      results = context.getElementsByTagName(tag);

                    // Filter out possible comments
                    if (tag === '*') {
                      while ((elem = results[i++])) {
                        if (elem.nodeType === 1) {
                          tmp.push(elem);
                        }
                      }

                      return tmp;
                    }
                    return results;
                  };

              // Class
              Expr.find['CLASS'] =
                support.getElementsByClassName &&
                function (className, context) {
                  if (typeof context.getElementsByClassName !== 'undefined' && documentIsHTML) {
                    return context.getElementsByClassName(className);
                  }
                };

              /* QSA/matchesSelector
	---------------------------------------------------------------------- */

              // QSA and matchesSelector support

              // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
              rbuggyMatches = [];

              // qSa(:focus) reports false when true (Chrome 21)
              // We allow this because of a bug in IE8/9 that throws an error
              // whenever `document.activeElement` is accessed on an iframe
              // So, we allow :focus to pass through QSA all the time to avoid the IE error
              // See https://bugs.jquery.com/ticket/13378
              rbuggyQSA = [];

              if ((support.qsa = rnative.test(document.querySelectorAll))) {
                // Build QSA regex
                // Regex strategy adopted from Diego Perini
                assert(function (el) {
                  var input;

                  // Select is set to empty string on purpose
                  // This is to test IE's treatment of not explicitly
                  // setting a boolean content attribute,
                  // since its presence should be enough
                  // https://bugs.jquery.com/ticket/12359
                  docElem.appendChild(el).innerHTML =
                    "<a id='" +
                    expando +
                    "'></a>" +
                    "<select id='" +
                    expando +
                    "-\r\\' msallowcapture=''>" +
                    "<option selected=''></option></select>";

                  // Support: IE8, Opera 11-12.16
                  // Nothing should be selected when empty strings follow ^= or $= or *=
                  // The test attribute must be unknown in Opera but "safe" for WinRT
                  // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                  if (el.querySelectorAll("[msallowcapture^='']").length) {
                    rbuggyQSA.push('[*^$]=' + whitespace + '*(?:\'\'|"")');
                  }

                  // Support: IE8
                  // Boolean attributes and "value" are not treated correctly
                  if (!el.querySelectorAll('[selected]').length) {
                    rbuggyQSA.push('\\[' + whitespace + '*(?:value|' + booleans + ')');
                  }

                  // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                  if (!el.querySelectorAll('[id~=' + expando + '-]').length) {
                    rbuggyQSA.push('~=');
                  }

                  // Support: IE 11+, Edge 15 - 18+
                  // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                  // Adding a temporary attribute to the document before the selection works
                  // around the issue.
                  // Interestingly, IE 10 & older don't seem to have the issue.
                  input = document.createElement('input');
                  input.setAttribute('name', '');
                  el.appendChild(input);
                  if (!el.querySelectorAll("[name='']").length) {
                    rbuggyQSA.push('\\[' + whitespace + '*name' + whitespace + '*=' + whitespace + '*(?:\'\'|"")');
                  }

                  // Webkit/Opera - :checked should return selected option elements
                  // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                  // IE8 throws error here and will not see later tests
                  if (!el.querySelectorAll(':checked').length) {
                    rbuggyQSA.push(':checked');
                  }

                  // Support: Safari 8+, iOS 8+
                  // https://bugs.webkit.org/show_bug.cgi?id=136851
                  // In-page `selector#id sibling-combinator selector` fails
                  if (!el.querySelectorAll('a#' + expando + '+*').length) {
                    rbuggyQSA.push('.#.+[+~]');
                  }

                  // Support: Firefox <=3.6 - 5 only
                  // Old Firefox doesn't throw on a badly-escaped identifier.
                  el.querySelectorAll('\\\f');
                  rbuggyQSA.push('[\\r\\n\\f]');
                });

                assert(function (el) {
                  el.innerHTML =
                    "<a href='' disabled='disabled'></a>" + "<select disabled='disabled'><option/></select>";

                  // Support: Windows 8 Native Apps
                  // The type and name attributes are restricted during .innerHTML assignment
                  var input = document.createElement('input');
                  input.setAttribute('type', 'hidden');
                  el.appendChild(input).setAttribute('name', 'D');

                  // Support: IE8
                  // Enforce case-sensitivity of name attribute
                  if (el.querySelectorAll('[name=d]').length) {
                    rbuggyQSA.push('name' + whitespace + '*[*^$|!~]?=');
                  }

                  // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                  // IE8 throws error here and will not see later tests
                  if (el.querySelectorAll(':enabled').length !== 2) {
                    rbuggyQSA.push(':enabled', ':disabled');
                  }

                  // Support: IE9-11+
                  // IE's :disabled selector does not pick up the children of disabled fieldsets
                  docElem.appendChild(el).disabled = true;
                  if (el.querySelectorAll(':disabled').length !== 2) {
                    rbuggyQSA.push(':enabled', ':disabled');
                  }

                  // Support: Opera 10 - 11 only
                  // Opera 10-11 does not throw on post-comma invalid pseudos
                  el.querySelectorAll('*,:x');
                  rbuggyQSA.push(',.*:');
                });
              }

              if (
                (support.matchesSelector = rnative.test(
                  (matches =
                    docElem.matches ||
                    docElem.webkitMatchesSelector ||
                    docElem.mozMatchesSelector ||
                    docElem.oMatchesSelector ||
                    docElem.msMatchesSelector)
                ))
              ) {
                assert(function (el) {
                  // Check to see if it's possible to do matchesSelector
                  // on a disconnected node (IE 9)
                  support.disconnectedMatch = matches.call(el, '*');

                  // This should fail with an exception
                  // Gecko does not error, returns false instead
                  matches.call(el, "[s!='']:x");
                  rbuggyMatches.push('!=', pseudos);
                });
              }

              rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join('|'));
              rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join('|'));

              /* Contains
	---------------------------------------------------------------------- */
              hasCompare = rnative.test(docElem.compareDocumentPosition);

              // Element contains another
              // Purposefully self-exclusive
              // As in, an element does not contain itself
              contains =
                hasCompare || rnative.test(docElem.contains)
                  ? function (a, b) {
                      var adown = a.nodeType === 9 ? a.documentElement : a,
                        bup = b && b.parentNode;
                      return (
                        a === bup ||
                        !!(
                          bup &&
                          bup.nodeType === 1 &&
                          (adown.contains
                            ? adown.contains(bup)
                            : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16)
                        )
                      );
                    }
                  : function (a, b) {
                      if (b) {
                        while ((b = b.parentNode)) {
                          if (b === a) {
                            return true;
                          }
                        }
                      }
                      return false;
                    };

              /* Sorting
	---------------------------------------------------------------------- */

              // Document order sorting
              sortOrder = hasCompare
                ? function (a, b) {
                    // Flag for duplicate removal
                    if (a === b) {
                      hasDuplicate = true;
                      return 0;
                    }

                    // Sort on method existence if only one input has compareDocumentPosition
                    var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                    if (compare) {
                      return compare;
                    }

                    // Calculate position if both inputs belong to the same document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    compare =
                      (a.ownerDocument || a) == (b.ownerDocument || b)
                        ? a.compareDocumentPosition(b)
                        : // Otherwise we know they are disconnected
                          1;

                    // Disconnected nodes
                    if (compare & 1 || (!support.sortDetached && b.compareDocumentPosition(a) === compare)) {
                      // Choose the first element that is related to our preferred document
                      // Support: IE 11+, Edge 17 - 18+
                      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                      // two documents; shallow comparisons work.
                      // eslint-disable-next-line eqeqeq
                      if (a == document || (a.ownerDocument == preferredDoc && contains(preferredDoc, a))) {
                        return -1;
                      }

                      // Support: IE 11+, Edge 17 - 18+
                      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                      // two documents; shallow comparisons work.
                      // eslint-disable-next-line eqeqeq
                      if (b == document || (b.ownerDocument == preferredDoc && contains(preferredDoc, b))) {
                        return 1;
                      }

                      // Maintain original order
                      return sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                    }

                    return compare & 4 ? -1 : 1;
                  }
                : function (a, b) {
                    // Exit early if the nodes are identical
                    if (a === b) {
                      hasDuplicate = true;
                      return 0;
                    }

                    var cur,
                      i = 0,
                      aup = a.parentNode,
                      bup = b.parentNode,
                      ap = [a],
                      bp = [b];

                    // Parentless nodes are either documents or disconnected
                    if (!aup || !bup) {
                      // Support: IE 11+, Edge 17 - 18+
                      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                      // two documents; shallow comparisons work.
                      /* eslint-disable eqeqeq */
                      return a == document
                        ? -1
                        : b == document
                          ? 1
                          : /* eslint-enable eqeqeq */
                            aup
                            ? -1
                            : bup
                              ? 1
                              : sortInput
                                ? indexOf(sortInput, a) - indexOf(sortInput, b)
                                : 0;

                      // If the nodes are siblings, we can do a quick check
                    } else if (aup === bup) {
                      return siblingCheck(a, b);
                    }

                    // Otherwise we need full lists of their ancestors for comparison
                    cur = a;
                    while ((cur = cur.parentNode)) {
                      ap.unshift(cur);
                    }
                    cur = b;
                    while ((cur = cur.parentNode)) {
                      bp.unshift(cur);
                    }

                    // Walk down the tree looking for a discrepancy
                    while (ap[i] === bp[i]) {
                      i++;
                    }

                    return i
                      ? // Do a sibling check if the nodes have a common ancestor
                        siblingCheck(ap[i], bp[i])
                      : // Otherwise nodes in our document sort first
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        /* eslint-disable eqeqeq */
                        ap[i] == preferredDoc
                        ? -1
                        : bp[i] == preferredDoc
                          ? 1
                          : /* eslint-enable eqeqeq */
                            0;
                  };

              return document;
            };

            Sizzle.matches = function (expr, elements) {
              return Sizzle(expr, null, null, elements);
            };

            Sizzle.matchesSelector = function (elem, expr) {
              setDocument(elem);

              if (
                support.matchesSelector &&
                documentIsHTML &&
                !nonnativeSelectorCache[expr + ' '] &&
                (!rbuggyMatches || !rbuggyMatches.test(expr)) &&
                (!rbuggyQSA || !rbuggyQSA.test(expr))
              ) {
                try {
                  var ret = matches.call(elem, expr);

                  // IE 9's matchesSelector returns false on disconnected nodes
                  if (
                    ret ||
                    support.disconnectedMatch ||
                    // As well, disconnected nodes are said to be in a document
                    // fragment in IE 9
                    (elem.document && elem.document.nodeType !== 11)
                  ) {
                    return ret;
                  }
                } catch (e) {
                  nonnativeSelectorCache(expr, true);
                }
              }

              return Sizzle(expr, document, null, [elem]).length > 0;
            };

            Sizzle.contains = function (context, elem) {
              // Set document vars if needed
              // Support: IE 11+, Edge 17 - 18+
              // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
              // two documents; shallow comparisons work.
              // eslint-disable-next-line eqeqeq
              if ((context.ownerDocument || context) != document) {
                setDocument(context);
              }
              return contains(context, elem);
            };

            Sizzle.attr = function (elem, name) {
              // Set document vars if needed
              // Support: IE 11+, Edge 17 - 18+
              // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
              // two documents; shallow comparisons work.
              // eslint-disable-next-line eqeqeq
              if ((elem.ownerDocument || elem) != document) {
                setDocument(elem);
              }

              var fn = Expr.attrHandle[name.toLowerCase()],
                // Don't get fooled by Object.prototype properties (jQuery #13807)
                val =
                  fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;

              return val !== undefined
                ? val
                : support.attributes || !documentIsHTML
                  ? elem.getAttribute(name)
                  : (val = elem.getAttributeNode(name)) && val.specified
                    ? val.value
                    : null;
            };

            Sizzle.escape = function (sel) {
              return (sel + '').replace(rcssescape, fcssescape);
            };

            Sizzle.error = function (msg) {
              throw new Error('Syntax error, unrecognized expression: ' + msg);
            };

            /**
             * Document sorting and removing duplicates
             * @param {ArrayLike} results
             */
            Sizzle.uniqueSort = function (results) {
              var elem,
                duplicates = [],
                j = 0,
                i = 0;

              // Unless we *know* we can detect duplicates, assume their presence
              hasDuplicate = !support.detectDuplicates;
              sortInput = !support.sortStable && results.slice(0);
              results.sort(sortOrder);

              if (hasDuplicate) {
                while ((elem = results[i++])) {
                  if (elem === results[i]) {
                    j = duplicates.push(i);
                  }
                }
                while (j--) {
                  results.splice(duplicates[j], 1);
                }
              }

              // Clear input after sorting to release objects
              // See https://github.com/jquery/sizzle/pull/225
              sortInput = null;

              return results;
            };

            /**
             * Utility function for retrieving the text value of an array of DOM nodes
             * @param {Array|Element} elem
             */
            getText = Sizzle.getText = function (elem) {
              var node,
                ret = '',
                i = 0,
                nodeType = elem.nodeType;

              if (!nodeType) {
                // If no nodeType, this is expected to be an array
                while ((node = elem[i++])) {
                  // Do not traverse comment nodes
                  ret += getText(node);
                }
              } else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
                // Use textContent for elements
                // innerText usage removed for consistency of new lines (jQuery #11153)
                if (typeof elem.textContent === 'string') {
                  return elem.textContent;
                } else {
                  // Traverse its children
                  for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
                    ret += getText(elem);
                  }
                }
              } else if (nodeType === 3 || nodeType === 4) {
                return elem.nodeValue;
              }

              // Do not include comment or processing instruction nodes

              return ret;
            };

            Expr = Sizzle.selectors = {
              // Can be adjusted by the user
              cacheLength: 50,

              createPseudo: markFunction,

              match: matchExpr,

              attrHandle: {},

              find: {},

              relative: {
                '>': { dir: 'parentNode', first: true },
                ' ': { dir: 'parentNode' },
                '+': { dir: 'previousSibling', first: true },
                '~': { dir: 'previousSibling' }
              },

              preFilter: {
                ATTR: function (match) {
                  match[1] = match[1].replace(runescape, funescape);

                  // Move the given value to match[3] whether quoted or unquoted
                  match[3] = (match[3] || match[4] || match[5] || '').replace(runescape, funescape);

                  if (match[2] === '~=') {
                    match[3] = ' ' + match[3] + ' ';
                  }

                  return match.slice(0, 4);
                },

                CHILD: function (match) {
                  /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
                  match[1] = match[1].toLowerCase();

                  if (match[1].slice(0, 3) === 'nth') {
                    // nth-* requires argument
                    if (!match[3]) {
                      Sizzle.error(match[0]);
                    }

                    // numeric x and y parameters for Expr.filter.CHILD
                    // remember that false/true cast respectively to 0/1
                    match[4] = +(match[4]
                      ? match[5] + (match[6] || 1)
                      : 2 * (match[3] === 'even' || match[3] === 'odd'));
                    match[5] = +(match[7] + match[8] || match[3] === 'odd');

                    // other types prohibit arguments
                  } else if (match[3]) {
                    Sizzle.error(match[0]);
                  }

                  return match;
                },

                PSEUDO: function (match) {
                  var excess,
                    unquoted = !match[6] && match[2];

                  if (matchExpr['CHILD'].test(match[0])) {
                    return null;
                  }

                  // Accept quoted arguments as-is
                  if (match[3]) {
                    match[2] = match[4] || match[5] || '';

                    // Strip excess characters from unquoted arguments
                  } else if (
                    unquoted &&
                    rpseudo.test(unquoted) &&
                    // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) &&
                    // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(')', unquoted.length - excess) - unquoted.length)
                  ) {
                    // excess is a negative index
                    match[0] = match[0].slice(0, excess);
                    match[2] = unquoted.slice(0, excess);
                  }

                  // Return only captures needed by the pseudo filter method (type and argument)
                  return match.slice(0, 3);
                }
              },

              filter: {
                TAG: function (nodeNameSelector) {
                  var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                  return nodeNameSelector === '*'
                    ? function () {
                        return true;
                      }
                    : function (elem) {
                        return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                      };
                },

                CLASS: function (className) {
                  var pattern = classCache[className + ' '];

                  return (
                    pattern ||
                    ((pattern = new RegExp('(^|' + whitespace + ')' + className + '(' + whitespace + '|$)')) &&
                      classCache(className, function (elem) {
                        return pattern.test(
                          (typeof elem.className === 'string' && elem.className) ||
                            (typeof elem.getAttribute !== 'undefined' && elem.getAttribute('class')) ||
                            ''
                        );
                      }))
                  );
                },

                ATTR: function (name, operator, check) {
                  return function (elem) {
                    var result = Sizzle.attr(elem, name);

                    if (result == null) {
                      return operator === '!=';
                    }
                    if (!operator) {
                      return true;
                    }

                    result += '';

                    /* eslint-disable max-len */

                    return operator === '='
                      ? result === check
                      : operator === '!='
                        ? result !== check
                        : operator === '^='
                          ? check && result.indexOf(check) === 0
                          : operator === '*='
                            ? check && result.indexOf(check) > -1
                            : operator === '$='
                              ? check && result.slice(-check.length) === check
                              : operator === '~='
                                ? (' ' + result.replace(rwhitespace, ' ') + ' ').indexOf(check) > -1
                                : operator === '|='
                                  ? result === check || result.slice(0, check.length + 1) === check + '-'
                                  : false;
                    /* eslint-enable max-len */
                  };
                },

                CHILD: function (type, what, _argument, first, last) {
                  var simple = type.slice(0, 3) !== 'nth',
                    forward = type.slice(-4) !== 'last',
                    ofType = what === 'of-type';

                  return first === 1 && last === 0
                    ? // Shortcut for :nth-*(n)
                      function (elem) {
                        return !!elem.parentNode;
                      }
                    : function (elem, _context, xml) {
                        var cache,
                          uniqueCache,
                          outerCache,
                          node,
                          nodeIndex,
                          start,
                          dir = simple !== forward ? 'nextSibling' : 'previousSibling',
                          parent = elem.parentNode,
                          name = ofType && elem.nodeName.toLowerCase(),
                          useCache = !xml && !ofType,
                          diff = false;

                        if (parent) {
                          // :(first|last|only)-(child|of-type)
                          if (simple) {
                            while (dir) {
                              node = elem;
                              while ((node = node[dir])) {
                                if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {
                                  return false;
                                }
                              }

                              // Reverse direction for :only-* (if we haven't yet done so)
                              start = dir = type === 'only' && !start && 'nextSibling';
                            }
                            return true;
                          }

                          start = [forward ? parent.firstChild : parent.lastChild];

                          // non-xml :nth-child(...) stores cache data on `parent`
                          if (forward && useCache) {
                            // Seek `elem` from a previously-cached index

                            // ...in a gzip-friendly way
                            node = parent;
                            outerCache = node[expando] || (node[expando] = {});

                            // Support: IE <9 only
                            // Defend against cloned attroperties (jQuery gh-1709)
                            uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});

                            cache = uniqueCache[type] || [];
                            nodeIndex = cache[0] === dirruns && cache[1];
                            diff = nodeIndex && cache[2];
                            node = nodeIndex && parent.childNodes[nodeIndex];

                            while (
                              (node =
                                (++nodeIndex && node && node[dir]) ||
                                // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) ||
                                start.pop())
                            ) {
                              // When found, cache indexes on `parent` and break
                              if (node.nodeType === 1 && ++diff && node === elem) {
                                uniqueCache[type] = [dirruns, nodeIndex, diff];
                                break;
                              }
                            }
                          } else {
                            // Use previously-cached element index if available
                            if (useCache) {
                              // ...in a gzip-friendly way
                              node = elem;
                              outerCache = node[expando] || (node[expando] = {});

                              // Support: IE <9 only
                              // Defend against cloned attroperties (jQuery gh-1709)
                              uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});

                              cache = uniqueCache[type] || [];
                              nodeIndex = cache[0] === dirruns && cache[1];
                              diff = nodeIndex;
                            }

                            // xml :nth-child(...)
                            // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                            if (diff === false) {
                              // Use the same loop as above to seek `elem` from the start
                              while (
                                (node = (++nodeIndex && node && node[dir]) || (diff = nodeIndex = 0) || start.pop())
                              ) {
                                if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                                  // Cache the index of each encountered element
                                  if (useCache) {
                                    outerCache = node[expando] || (node[expando] = {});

                                    // Support: IE <9 only
                                    // Defend against cloned attroperties (jQuery gh-1709)
                                    uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});

                                    uniqueCache[type] = [dirruns, diff];
                                  }

                                  if (node === elem) {
                                    break;
                                  }
                                }
                              }
                            }
                          }

                          // Incorporate the offset, then check against cycle size
                          diff -= last;
                          return diff === first || (diff % first === 0 && diff / first >= 0);
                        }
                      };
                },

                PSEUDO: function (pseudo, argument) {
                  // pseudo-class names are case-insensitive
                  // http://www.w3.org/TR/selectors/#pseudo-classes
                  // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                  // Remember that setFilters inherits from pseudos
                  var args,
                    fn =
                      Expr.pseudos[pseudo] ||
                      Expr.setFilters[pseudo.toLowerCase()] ||
                      Sizzle.error('unsupported pseudo: ' + pseudo);

                  // The user may use createPseudo to indicate that
                  // arguments are needed to create the filter function
                  // just as Sizzle does
                  if (fn[expando]) {
                    return fn(argument);
                  }

                  // But maintain support for old signatures
                  if (fn.length > 1) {
                    args = [pseudo, pseudo, '', argument];
                    return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase())
                      ? markFunction(function (seed, matches) {
                          var idx,
                            matched = fn(seed, argument),
                            i = matched.length;
                          while (i--) {
                            idx = indexOf(seed, matched[i]);
                            seed[idx] = !(matches[idx] = matched[i]);
                          }
                        })
                      : function (elem) {
                          return fn(elem, 0, args);
                        };
                  }

                  return fn;
                }
              },

              pseudos: {
                // Potentially complex pseudos
                not: markFunction(function (selector) {
                  // Trim the selector passed to compile
                  // to avoid treating leading and trailing
                  // spaces as combinators
                  var input = [],
                    results = [],
                    matcher = compile(selector.replace(rtrim, '$1'));

                  return matcher[expando]
                    ? markFunction(function (seed, matches, _context, xml) {
                        var elem,
                          unmatched = matcher(seed, null, xml, []),
                          i = seed.length;

                        // Match elements unmatched by `matcher`
                        while (i--) {
                          if ((elem = unmatched[i])) {
                            seed[i] = !(matches[i] = elem);
                          }
                        }
                      })
                    : function (elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);

                        // Don't keep the element (issue #299)
                        input[0] = null;
                        return !results.pop();
                      };
                }),

                has: markFunction(function (selector) {
                  return function (elem) {
                    return Sizzle(selector, elem).length > 0;
                  };
                }),

                contains: markFunction(function (text) {
                  text = text.replace(runescape, funescape);
                  return function (elem) {
                    return (elem.textContent || getText(elem)).indexOf(text) > -1;
                  };
                }),

                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // http://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function (lang) {
                  // lang value must be a valid identifier
                  if (!ridentifier.test(lang || '')) {
                    Sizzle.error('unsupported lang: ' + lang);
                  }
                  lang = lang.replace(runescape, funescape).toLowerCase();
                  return function (elem) {
                    var elemLang;
                    do {
                      if (
                        (elemLang = documentIsHTML
                          ? elem.lang
                          : elem.getAttribute('xml:lang') || elem.getAttribute('lang'))
                      ) {
                        elemLang = elemLang.toLowerCase();
                        return elemLang === lang || elemLang.indexOf(lang + '-') === 0;
                      }
                    } while ((elem = elem.parentNode) && elem.nodeType === 1);
                    return false;
                  };
                }),

                // Miscellaneous
                target: function (elem) {
                  var hash = window.location && window.location.hash;
                  return hash && hash.slice(1) === elem.id;
                },

                root: function (elem) {
                  return elem === docElem;
                },

                focus: function (elem) {
                  return (
                    elem === document.activeElement &&
                    (!document.hasFocus || document.hasFocus()) &&
                    !!(elem.type || elem.href || ~elem.tabIndex)
                  );
                },

                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),

                checked: function (elem) {
                  // In CSS3, :checked should return both checked and selected elements
                  // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                  var nodeName = elem.nodeName.toLowerCase();
                  return (nodeName === 'input' && !!elem.checked) || (nodeName === 'option' && !!elem.selected);
                },

                selected: function (elem) {
                  // Accessing this property makes selected-by-default
                  // options in Safari work properly
                  if (elem.parentNode) {
                    // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                  }

                  return elem.selected === true;
                },

                // Contents
                empty: function (elem) {
                  // http://www.w3.org/TR/selectors/#empty-pseudo
                  // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                  //   but not by others (comment: 8; processing instruction: 7; etc.)
                  // nodeType < 6 works because attributes (2) do not appear as children
                  for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
                    if (elem.nodeType < 6) {
                      return false;
                    }
                  }
                  return true;
                },

                parent: function (elem) {
                  return !Expr.pseudos['empty'](elem);
                },

                // Element/input types
                header: function (elem) {
                  return rheader.test(elem.nodeName);
                },

                input: function (elem) {
                  return rinputs.test(elem.nodeName);
                },

                button: function (elem) {
                  var name = elem.nodeName.toLowerCase();
                  return (name === 'input' && elem.type === 'button') || name === 'button';
                },

                text: function (elem) {
                  var attr;
                  return (
                    elem.nodeName.toLowerCase() === 'input' &&
                    elem.type === 'text' &&
                    // Support: IE<8
                    // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                    ((attr = elem.getAttribute('type')) == null || attr.toLowerCase() === 'text')
                  );
                },

                // Position-in-collection
                first: createPositionalPseudo(function () {
                  return [0];
                }),

                last: createPositionalPseudo(function (_matchIndexes, length) {
                  return [length - 1];
                }),

                eq: createPositionalPseudo(function (_matchIndexes, length, argument) {
                  return [argument < 0 ? argument + length : argument];
                }),

                even: createPositionalPseudo(function (matchIndexes, length) {
                  var i = 0;
                  for (; i < length; i += 2) {
                    matchIndexes.push(i);
                  }
                  return matchIndexes;
                }),

                odd: createPositionalPseudo(function (matchIndexes, length) {
                  var i = 1;
                  for (; i < length; i += 2) {
                    matchIndexes.push(i);
                  }
                  return matchIndexes;
                }),

                lt: createPositionalPseudo(function (matchIndexes, length, argument) {
                  var i = argument < 0 ? argument + length : argument > length ? length : argument;
                  for (; --i >= 0; ) {
                    matchIndexes.push(i);
                  }
                  return matchIndexes;
                }),

                gt: createPositionalPseudo(function (matchIndexes, length, argument) {
                  var i = argument < 0 ? argument + length : argument;
                  for (; ++i < length; ) {
                    matchIndexes.push(i);
                  }
                  return matchIndexes;
                })
              }
            };

            Expr.pseudos['nth'] = Expr.pseudos['eq'];

            // Add button/input type pseudos
            for (i in { radio: true, checkbox: true, file: true, password: true, image: true }) {
              Expr.pseudos[i] = createInputPseudo(i);
            }
            for (i in { submit: true, reset: true }) {
              Expr.pseudos[i] = createButtonPseudo(i);
            }

            // Easy API for creating new setFilters
            function setFilters() {}
            setFilters.prototype = Expr.filters = Expr.pseudos;
            Expr.setFilters = new setFilters();

            tokenize = Sizzle.tokenize = function (selector, parseOnly) {
              var matched,
                match,
                tokens,
                type,
                soFar,
                groups,
                preFilters,
                cached = tokenCache[selector + ' '];

              if (cached) {
                return parseOnly ? 0 : cached.slice(0);
              }

              soFar = selector;
              groups = [];
              preFilters = Expr.preFilter;

              while (soFar) {
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                  if (match) {
                    // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                  }
                  groups.push((tokens = []));
                }

                matched = false;

                // Combinators
                if ((match = rcombinators.exec(soFar))) {
                  matched = match.shift();
                  tokens.push({
                    value: matched,

                    // Cast descendant combinators to space
                    type: match[0].replace(rtrim, ' ')
                  });
                  soFar = soFar.slice(matched.length);
                }

                // Filters
                for (type in Expr.filter) {
                  if (
                    (match = matchExpr[type].exec(soFar)) &&
                    (!preFilters[type] || (match = preFilters[type](match)))
                  ) {
                    matched = match.shift();
                    tokens.push({
                      value: matched,
                      type: type,
                      matches: match
                    });
                    soFar = soFar.slice(matched.length);
                  }
                }

                if (!matched) {
                  break;
                }
              }

              // Return the length of the invalid excess
              // if we're just parsing
              // Otherwise, throw an error or return tokens
              return parseOnly
                ? soFar.length
                : soFar
                  ? Sizzle.error(selector)
                  : // Cache the tokens
                    tokenCache(selector, groups).slice(0);
            };

            function toSelector(tokens) {
              var i = 0,
                len = tokens.length,
                selector = '';
              for (; i < len; i++) {
                selector += tokens[i].value;
              }
              return selector;
            }

            function addCombinator(matcher, combinator, base) {
              var dir = combinator.dir,
                skip = combinator.next,
                key = skip || dir,
                checkNonElements = base && key === 'parentNode',
                doneName = done++;

              return combinator.first
                ? // Check against closest ancestor/preceding element
                  function (elem, context, xml) {
                    while ((elem = elem[dir])) {
                      if (elem.nodeType === 1 || checkNonElements) {
                        return matcher(elem, context, xml);
                      }
                    }
                    return false;
                  }
                : // Check against all ancestor/preceding elements
                  function (elem, context, xml) {
                    var oldCache,
                      uniqueCache,
                      outerCache,
                      newCache = [dirruns, doneName];

                    // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                    if (xml) {
                      while ((elem = elem[dir])) {
                        if (elem.nodeType === 1 || checkNonElements) {
                          if (matcher(elem, context, xml)) {
                            return true;
                          }
                        }
                      }
                    } else {
                      while ((elem = elem[dir])) {
                        if (elem.nodeType === 1 || checkNonElements) {
                          outerCache = elem[expando] || (elem[expando] = {});

                          // Support: IE <9 only
                          // Defend against cloned attroperties (jQuery gh-1709)
                          uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});

                          if (skip && skip === elem.nodeName.toLowerCase()) {
                            elem = elem[dir] || elem;
                          } else if (
                            (oldCache = uniqueCache[key]) &&
                            oldCache[0] === dirruns &&
                            oldCache[1] === doneName
                          ) {
                            // Assign to newCache so results back-propagate to previous elements
                            return (newCache[2] = oldCache[2]);
                          } else {
                            // Reuse newcache so results back-propagate to previous elements
                            uniqueCache[key] = newCache;

                            // A match means we're done; a fail means we have to keep checking
                            if ((newCache[2] = matcher(elem, context, xml))) {
                              return true;
                            }
                          }
                        }
                      }
                    }
                    return false;
                  };
            }

            function elementMatcher(matchers) {
              return matchers.length > 1
                ? function (elem, context, xml) {
                    var i = matchers.length;
                    while (i--) {
                      if (!matchers[i](elem, context, xml)) {
                        return false;
                      }
                    }
                    return true;
                  }
                : matchers[0];
            }

            function multipleContexts(selector, contexts, results) {
              var i = 0,
                len = contexts.length;
              for (; i < len; i++) {
                Sizzle(selector, contexts[i], results);
              }
              return results;
            }

            function condense(unmatched, map, filter, context, xml) {
              var elem,
                newUnmatched = [],
                i = 0,
                len = unmatched.length,
                mapped = map != null;

              for (; i < len; i++) {
                if ((elem = unmatched[i])) {
                  if (!filter || filter(elem, context, xml)) {
                    newUnmatched.push(elem);
                    if (mapped) {
                      map.push(i);
                    }
                  }
                }
              }

              return newUnmatched;
            }

            function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
              if (postFilter && !postFilter[expando]) {
                postFilter = setMatcher(postFilter);
              }
              if (postFinder && !postFinder[expando]) {
                postFinder = setMatcher(postFinder, postSelector);
              }
              return markFunction(function (seed, results, context, xml) {
                var temp,
                  i,
                  elem,
                  preMap = [],
                  postMap = [],
                  preexisting = results.length,
                  // Get initial elements from seed or context
                  elems = seed || multipleContexts(selector || '*', context.nodeType ? [context] : context, []),
                  // Prefilter to get matcher input, preserving a map for seed-results synchronization
                  matcherIn =
                    preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems,
                  matcherOut = matcher
                    ? // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                      postFinder || (seed ? preFilter : preexisting || postFilter)
                      ? // ...intermediate processing is necessary
                        []
                      : // ...otherwise use results directly
                        results
                    : matcherIn;

                // Find primary matches
                if (matcher) {
                  matcher(matcherIn, matcherOut, context, xml);
                }

                // Apply postFilter
                if (postFilter) {
                  temp = condense(matcherOut, postMap);
                  postFilter(temp, [], context, xml);

                  // Un-match failing elements by moving them back to matcherIn
                  i = temp.length;
                  while (i--) {
                    if ((elem = temp[i])) {
                      matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                    }
                  }
                }

                if (seed) {
                  if (postFinder || preFilter) {
                    if (postFinder) {
                      // Get the final matcherOut by condensing this intermediate into postFinder contexts
                      temp = [];
                      i = matcherOut.length;
                      while (i--) {
                        if ((elem = matcherOut[i])) {
                          // Restore matcherIn since elem is not yet a final match
                          temp.push((matcherIn[i] = elem));
                        }
                      }
                      postFinder(null, (matcherOut = []), temp, xml);
                    }

                    // Move matched elements from seed to results to keep them synchronized
                    i = matcherOut.length;
                    while (i--) {
                      if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) {
                        seed[temp] = !(results[temp] = elem);
                      }
                    }
                  }

                  // Add elements to results, through postFinder if defined
                } else {
                  matcherOut = condense(
                    matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut
                  );
                  if (postFinder) {
                    postFinder(null, results, matcherOut, xml);
                  } else {
                    push.apply(results, matcherOut);
                  }
                }
              });
            }

            function matcherFromTokens(tokens) {
              var checkContext,
                matcher,
                j,
                len = tokens.length,
                leadingRelative = Expr.relative[tokens[0].type],
                implicitRelative = leadingRelative || Expr.relative[' '],
                i = leadingRelative ? 1 : 0,
                // The foundational matcher ensures that elements are reachable from top-level context(s)
                matchContext = addCombinator(
                  function (elem) {
                    return elem === checkContext;
                  },
                  implicitRelative,
                  true
                ),
                matchAnyContext = addCombinator(
                  function (elem) {
                    return indexOf(checkContext, elem) > -1;
                  },
                  implicitRelative,
                  true
                ),
                matchers = [
                  function (elem, context, xml) {
                    var ret =
                      (!leadingRelative && (xml || context !== outermostContext)) ||
                      ((checkContext = context).nodeType
                        ? matchContext(elem, context, xml)
                        : matchAnyContext(elem, context, xml));

                    // Avoid hanging onto element (issue #299)
                    checkContext = null;
                    return ret;
                  }
                ];

              for (; i < len; i++) {
                if ((matcher = Expr.relative[tokens[i].type])) {
                  matchers = [addCombinator(elementMatcher(matchers), matcher)];
                } else {
                  matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);

                  // Return special upon seeing a positional matcher
                  if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for (; j < len; j++) {
                      if (Expr.relative[tokens[j].type]) {
                        break;
                      }
                    }
                    return setMatcher(
                      i > 1 && elementMatcher(matchers),
                      i > 1 &&
                        toSelector(
                          // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                          tokens.slice(0, i - 1).concat({ value: tokens[i - 2].type === ' ' ? '*' : '' })
                        ).replace(rtrim, '$1'),
                      matcher,
                      i < j && matcherFromTokens(tokens.slice(i, j)),
                      j < len && matcherFromTokens((tokens = tokens.slice(j))),
                      j < len && toSelector(tokens)
                    );
                  }
                  matchers.push(matcher);
                }
              }

              return elementMatcher(matchers);
            }

            function matcherFromGroupMatchers(elementMatchers, setMatchers) {
              var bySet = setMatchers.length > 0,
                byElement = elementMatchers.length > 0,
                superMatcher = function (seed, context, xml, results, outermost) {
                  var elem,
                    j,
                    matcher,
                    matchedCount = 0,
                    i = '0',
                    unmatched = seed && [],
                    setMatched = [],
                    contextBackup = outermostContext,
                    // We must always have either seed elements or outermost context
                    elems = seed || (byElement && Expr.find['TAG']('*', outermost)),
                    // Use integer dirruns iff this is the outermost matcher
                    dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
                    len = elems.length;

                  if (outermost) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    outermostContext = context == document || context || outermost;
                  }

                  // Add elements passing elementMatchers directly to results
                  // Support: IE<9, Safari
                  // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                  for (; i !== len && (elem = elems[i]) != null; i++) {
                    if (byElement && elem) {
                      j = 0;

                      // Support: IE 11+, Edge 17 - 18+
                      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                      // two documents; shallow comparisons work.
                      // eslint-disable-next-line eqeqeq
                      if (!context && elem.ownerDocument != document) {
                        setDocument(elem);
                        xml = !documentIsHTML;
                      }
                      while ((matcher = elementMatchers[j++])) {
                        if (matcher(elem, context || document, xml)) {
                          results.push(elem);
                          break;
                        }
                      }
                      if (outermost) {
                        dirruns = dirrunsUnique;
                      }
                    }

                    // Track unmatched elements for set filters
                    if (bySet) {
                      // They will have gone through all possible matchers
                      if ((elem = !matcher && elem)) {
                        matchedCount--;
                      }

                      // Lengthen the array for every element, matched or not
                      if (seed) {
                        unmatched.push(elem);
                      }
                    }
                  }

                  // `i` is now the count of elements visited above, and adding it to `matchedCount`
                  // makes the latter nonnegative.
                  matchedCount += i;

                  // Apply set filters to unmatched elements
                  // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                  // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                  // no element matchers and no seed.
                  // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                  // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                  // numerically zero.
                  if (bySet && i !== matchedCount) {
                    j = 0;
                    while ((matcher = setMatchers[j++])) {
                      matcher(unmatched, setMatched, context, xml);
                    }

                    if (seed) {
                      // Reintegrate element matches to eliminate the need for sorting
                      if (matchedCount > 0) {
                        while (i--) {
                          if (!(unmatched[i] || setMatched[i])) {
                            setMatched[i] = pop.call(results);
                          }
                        }
                      }

                      // Discard index placeholder values to get only actual matches
                      setMatched = condense(setMatched);
                    }

                    // Add matches to results
                    push.apply(results, setMatched);

                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {
                      Sizzle.uniqueSort(results);
                    }
                  }

                  // Override manipulation of globals by nested matchers
                  if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                  }

                  return unmatched;
                };

              return bySet ? markFunction(superMatcher) : superMatcher;
            }

            compile = Sizzle.compile = function (selector, match /* Internal Use Only */) {
              var i,
                setMatchers = [],
                elementMatchers = [],
                cached = compilerCache[selector + ' '];

              if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) {
                  match = tokenize(selector);
                }
                i = match.length;
                while (i--) {
                  cached = matcherFromTokens(match[i]);
                  if (cached[expando]) {
                    setMatchers.push(cached);
                  } else {
                    elementMatchers.push(cached);
                  }
                }

                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));

                // Save selector and tokenization
                cached.selector = selector;
              }
              return cached;
            };

            /**
             * A low-level selection function that works with Sizzle's compiled
             *  selector functions
             * @param {String|Function} selector A selector or a pre-compiled
             *  selector function built with Sizzle.compile
             * @param {Element} context
             * @param {Array} [results]
             * @param {Array} [seed] A set of elements to match against
             */
            select = Sizzle.select = function (selector, context, results, seed) {
              var i,
                tokens,
                token,
                type,
                find,
                compiled = typeof selector === 'function' && selector,
                match = !seed && tokenize((selector = compiled.selector || selector));

              results = results || [];

              // Try to minimize operations if there is only one selector in the list and no seed
              // (the latter of which guarantees us context)
              if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (
                  tokens.length > 2 &&
                  (token = tokens[0]).type === 'ID' &&
                  context.nodeType === 9 &&
                  documentIsHTML &&
                  Expr.relative[tokens[1].type]
                ) {
                  context = (Expr.find['ID'](token.matches[0].replace(runescape, funescape), context) || [])[0];
                  if (!context) {
                    return results;

                    // Precompiled matchers will still verify ancestry, so step up a level
                  } else if (compiled) {
                    context = context.parentNode;
                  }

                  selector = selector.slice(tokens.shift().value.length);
                }

                // Fetch a seed set for right-to-left matching
                i = matchExpr['needsContext'].test(selector) ? 0 : tokens.length;
                while (i--) {
                  token = tokens[i];

                  // Abort if we hit a combinator
                  if (Expr.relative[(type = token.type)]) {
                    break;
                  }
                  if ((find = Expr.find[type])) {
                    // Search, expanding context for leading sibling combinators
                    if (
                      (seed = find(
                        token.matches[0].replace(runescape, funescape),
                        (rsibling.test(tokens[0].type) && testContext(context.parentNode)) || context
                      ))
                    ) {
                      // If seed is empty or no tokens remain, we can return early
                      tokens.splice(i, 1);
                      selector = seed.length && toSelector(tokens);
                      if (!selector) {
                        push.apply(results, seed);
                        return results;
                      }

                      break;
                    }
                  }
                }
              }

              // Compile and execute a filtering function if one is not provided
              // Provide `match` to avoid retokenization if we modified the selector above
              (compiled || compile(selector, match))(
                seed,
                context,
                !documentIsHTML,
                results,
                !context || (rsibling.test(selector) && testContext(context.parentNode)) || context
              );
              return results;
            };

            // One-time assignments

            // Sort stability
            support.sortStable = expando.split('').sort(sortOrder).join('') === expando;

            // Support: Chrome 14-35+
            // Always assume duplicates if they aren't passed to the comparison function
            support.detectDuplicates = !!hasDuplicate;

            // Initialize against the default document
            setDocument();

            // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
            // Detached nodes confoundingly follow *each other*
            support.sortDetached = assert(function (el) {
              // Should return 1, but returns 4 (following)
              return el.compareDocumentPosition(document.createElement('fieldset')) & 1;
            });

            // Support: IE<8
            // Prevent attribute/property "interpolation"
            // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
            if (
              !assert(function (el) {
                el.innerHTML = "<a href='#'></a>";
                return el.firstChild.getAttribute('href') === '#';
              })
            ) {
              addHandle('type|href|height|width', function (elem, name, isXML) {
                if (!isXML) {
                  return elem.getAttribute(name, name.toLowerCase() === 'type' ? 1 : 2);
                }
              });
            }

            // Support: IE<9
            // Use defaultValue in place of getAttribute("value")
            if (
              !support.attributes ||
              !assert(function (el) {
                el.innerHTML = '<input/>';
                el.firstChild.setAttribute('value', '');
                return el.firstChild.getAttribute('value') === '';
              })
            ) {
              addHandle('value', function (elem, _name, isXML) {
                if (!isXML && elem.nodeName.toLowerCase() === 'input') {
                  return elem.defaultValue;
                }
              });
            }

            // Support: IE<9
            // Use getAttributeNode to fetch booleans when getAttribute lies
            if (
              !assert(function (el) {
                return el.getAttribute('disabled') == null;
              })
            ) {
              addHandle(booleans, function (elem, name, isXML) {
                var val;
                if (!isXML) {
                  return elem[name] === true
                    ? name.toLowerCase()
                    : (val = elem.getAttributeNode(name)) && val.specified
                      ? val.value
                      : null;
                }
              });
            }

            return Sizzle;
          })(window);

        jQuery.find = Sizzle;
        jQuery.expr = Sizzle.selectors;

        // Deprecated
        jQuery.expr[':'] = jQuery.expr.pseudos;
        jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
        jQuery.text = Sizzle.getText;
        jQuery.isXMLDoc = Sizzle.isXML;
        jQuery.contains = Sizzle.contains;
        jQuery.escapeSelector = Sizzle.escape;

        var dir = function (elem, dir, until) {
          var matched = [],
            truncate = until !== undefined;

          while ((elem = elem[dir]) && elem.nodeType !== 9) {
            if (elem.nodeType === 1) {
              if (truncate && jQuery(elem).is(until)) {
                break;
              }
              matched.push(elem);
            }
          }
          return matched;
        };

        var siblings = function (n, elem) {
          var matched = [];

          for (; n; n = n.nextSibling) {
            if (n.nodeType === 1 && n !== elem) {
              matched.push(n);
            }
          }

          return matched;
        };

        var rneedsContext = jQuery.expr.match.needsContext;

        function nodeName(elem, name) {
          return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
        }
        var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

        // Implement the identical functionality for filter and not
        function winnow(elements, qualifier, not) {
          if (isFunction(qualifier)) {
            return jQuery.grep(elements, function (elem, i) {
              return !!qualifier.call(elem, i, elem) !== not;
            });
          }

          // Single element
          if (qualifier.nodeType) {
            return jQuery.grep(elements, function (elem) {
              return (elem === qualifier) !== not;
            });
          }

          // Arraylike of elements (jQuery, arguments, Array)
          if (typeof qualifier !== 'string') {
            return jQuery.grep(elements, function (elem) {
              return indexOf.call(qualifier, elem) > -1 !== not;
            });
          }

          // Filtered directly for both simple and complex selectors
          return jQuery.filter(qualifier, elements, not);
        }

        jQuery.filter = function (expr, elems, not) {
          var elem = elems[0];

          if (not) {
            expr = ':not(' + expr + ')';
          }

          if (elems.length === 1 && elem.nodeType === 1) {
            return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
          }

          return jQuery.find.matches(
            expr,
            jQuery.grep(elems, function (elem) {
              return elem.nodeType === 1;
            })
          );
        };

        jQuery.fn.extend({
          find: function (selector) {
            var i,
              ret,
              len = this.length,
              self = this;

            if (typeof selector !== 'string') {
              return this.pushStack(
                jQuery(selector).filter(function () {
                  for (i = 0; i < len; i++) {
                    if (jQuery.contains(self[i], this)) {
                      return true;
                    }
                  }
                })
              );
            }

            ret = this.pushStack([]);

            for (i = 0; i < len; i++) {
              jQuery.find(selector, self[i], ret);
            }

            return len > 1 ? jQuery.uniqueSort(ret) : ret;
          },
          filter: function (selector) {
            return this.pushStack(winnow(this, selector || [], false));
          },
          not: function (selector) {
            return this.pushStack(winnow(this, selector || [], true));
          },
          is: function (selector) {
            return !!winnow(
              this,

              // If this is a positional/relative selector, check membership in the returned set
              // so $("p:first").is("p:last") won't return true for a doc with two "p".
              typeof selector === 'string' && rneedsContext.test(selector) ? jQuery(selector) : selector || [],
              false
            ).length;
          }
        });

        // Initialize a jQuery object

        // A central reference to the root jQuery(document)
        var rootjQuery,
          // A simple way to check for HTML strings
          // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
          // Strict HTML recognition (#11290: must start with <)
          // Shortcut simple #id case for speed
          rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
          init = (jQuery.fn.init = function (selector, context, root) {
            var match, elem;

            // HANDLE: $(""), $(null), $(undefined), $(false)
            if (!selector) {
              return this;
            }

            // Method init() accepts an alternate rootjQuery
            // so migrate can support jQuery.sub (gh-2101)
            root = root || rootjQuery;

            // Handle HTML strings
            if (typeof selector === 'string') {
              if (selector[0] === '<' && selector[selector.length - 1] === '>' && selector.length >= 3) {
                // Assume that strings that start and end with <> are HTML and skip the regex check
                match = [null, selector, null];
              } else {
                match = rquickExpr.exec(selector);
              }

              // Match html or make sure no context is specified for #id
              if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                  context = context instanceof jQuery ? context[0] : context;

                  // Option to run scripts is true for back-compat
                  // Intentionally let the error be thrown if parseHTML is not present
                  jQuery.merge(
                    this,
                    jQuery.parseHTML(
                      match[1],
                      context && context.nodeType ? context.ownerDocument || context : document,
                      true
                    )
                  );

                  // HANDLE: $(html, props)
                  if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                    for (match in context) {
                      // Properties of context are called as methods if possible
                      if (isFunction(this[match])) {
                        this[match](context[match]);

                        // ...and otherwise set as attributes
                      } else {
                        this.attr(match, context[match]);
                      }
                    }
                  }

                  return this;

                  // HANDLE: $(#id)
                } else {
                  elem = document.getElementById(match[2]);

                  if (elem) {
                    // Inject the element directly into the jQuery object
                    this[0] = elem;
                    this.length = 1;
                  }
                  return this;
                }

                // HANDLE: $(expr, $(...))
              } else if (!context || context.jquery) {
                return (context || root).find(selector);

                // HANDLE: $(expr, context)
                // (which is just equivalent to: $(context).find(expr)
              } else {
                return this.constructor(context).find(selector);
              }

              // HANDLE: $(DOMElement)
            } else if (selector.nodeType) {
              this[0] = selector;
              this.length = 1;
              return this;

              // HANDLE: $(function)
              // Shortcut for document ready
            } else if (isFunction(selector)) {
              return root.ready !== undefined
                ? root.ready(selector)
                : // Execute immediately if ready is not present
                  selector(jQuery);
            }

            return jQuery.makeArray(selector, this);
          });

        // Give the init function the jQuery prototype for later instantiation
        init.prototype = jQuery.fn;

        // Initialize central reference
        rootjQuery = jQuery(document);

        var rparentsprev = /^(?:parents|prev(?:Until|All))/,
          // Methods guaranteed to produce a unique set when starting from a unique set
          guaranteedUnique = {
            children: true,
            contents: true,
            next: true,
            prev: true
          };

        jQuery.fn.extend({
          has: function (target) {
            var targets = jQuery(target, this),
              l = targets.length;

            return this.filter(function () {
              var i = 0;
              for (; i < l; i++) {
                if (jQuery.contains(this, targets[i])) {
                  return true;
                }
              }
            });
          },

          closest: function (selectors, context) {
            var cur,
              i = 0,
              l = this.length,
              matched = [],
              targets = typeof selectors !== 'string' && jQuery(selectors);

            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) {
              for (; i < l; i++) {
                for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {
                  // Always skip document fragments
                  if (
                    cur.nodeType < 11 &&
                    (targets
                      ? targets.index(cur) > -1
                      : // Don't pass non-elements to Sizzle
                        cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))
                  ) {
                    matched.push(cur);
                    break;
                  }
                }
              }
            }

            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
          },

          // Determine the position of an element within the set
          index: function (elem) {
            // No argument, return index in parent
            if (!elem) {
              return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            }

            // Index in selector
            if (typeof elem === 'string') {
              return indexOf.call(jQuery(elem), this[0]);
            }

            // Locate the position of the desired element
            return indexOf.call(
              this,

              // If it receives a jQuery object, the first element is used
              elem.jquery ? elem[0] : elem
            );
          },

          add: function (selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
          },

          addBack: function (selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
          }
        });

        function sibling(cur, dir) {
          while ((cur = cur[dir]) && cur.nodeType !== 1) {}
          return cur;
        }

        jQuery.each(
          {
            parent: function (elem) {
              var parent = elem.parentNode;
              return parent && parent.nodeType !== 11 ? parent : null;
            },
            parents: function (elem) {
              return dir(elem, 'parentNode');
            },
            parentsUntil: function (elem, _i, until) {
              return dir(elem, 'parentNode', until);
            },
            next: function (elem) {
              return sibling(elem, 'nextSibling');
            },
            prev: function (elem) {
              return sibling(elem, 'previousSibling');
            },
            nextAll: function (elem) {
              return dir(elem, 'nextSibling');
            },
            prevAll: function (elem) {
              return dir(elem, 'previousSibling');
            },
            nextUntil: function (elem, _i, until) {
              return dir(elem, 'nextSibling', until);
            },
            prevUntil: function (elem, _i, until) {
              return dir(elem, 'previousSibling', until);
            },
            siblings: function (elem) {
              return siblings((elem.parentNode || {}).firstChild, elem);
            },
            children: function (elem) {
              return siblings(elem.firstChild);
            },
            contents: function (elem) {
              if (
                elem.contentDocument != null &&
                // Support: IE 11+
                // <object> elements with no `data` attribute has an object
                // `contentDocument` with a `null` prototype.
                getProto(elem.contentDocument)
              ) {
                return elem.contentDocument;
              }

              // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
              // Treat the template element as a regular one in browsers that
              // don't support it.
              if (nodeName(elem, 'template')) {
                elem = elem.content || elem;
              }

              return jQuery.merge([], elem.childNodes);
            }
          },
          function (name, fn) {
            jQuery.fn[name] = function (until, selector) {
              var matched = jQuery.map(this, fn, until);

              if (name.slice(-5) !== 'Until') {
                selector = until;
              }

              if (selector && typeof selector === 'string') {
                matched = jQuery.filter(selector, matched);
              }

              if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) {
                  jQuery.uniqueSort(matched);
                }

                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) {
                  matched.reverse();
                }
              }

              return this.pushStack(matched);
            };
          }
        );
        var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;

        // Convert String-formatted options into Object-formatted ones
        function createOptions(options) {
          var object = {};
          jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
            object[flag] = true;
          });
          return object;
        }

        /*
         * Create a callback list using the following parameters:
         *
         *	options: an optional list of space-separated options that will change how
         *			the callback list behaves or a more traditional option object
         *
         * By default a callback list will act like an event callback list and can be
         * "fired" multiple times.
         *
         * Possible options:
         *
         *	once:			will ensure the callback list can only be fired once (like a Deferred)
         *
         *	memory:			will keep track of previous values and will call any callback added
         *					after the list has been fired right away with the latest "memorized"
         *					values (like a Deferred)
         *
         *	unique:			will ensure a callback can only be added once (no duplicate in the list)
         *
         *	stopOnFalse:	interrupt callings when a callback returns false
         *
         */
        jQuery.Callbacks = function (options) {
          // Convert options from String-formatted to Object-formatted if needed
          // (we check in cache first)
          options = typeof options === 'string' ? createOptions(options) : jQuery.extend({}, options);

          var // Flag to know if list is currently firing
            firing,
            // Last fire value for non-forgettable lists
            memory,
            // Flag to know if list was already fired
            fired,
            // Flag to prevent firing
            locked,
            // Actual callback list
            list = [],
            // Queue of execution data for repeatable lists
            queue = [],
            // Index of currently firing callback (modified by add/remove as needed)
            firingIndex = -1,
            // Fire callbacks
            fire = function () {
              // Enforce single-firing
              locked = locked || options.once;

              // Execute callbacks for all pending executions,
              // respecting firingIndex overrides and runtime changes
              fired = firing = true;
              for (; queue.length; firingIndex = -1) {
                memory = queue.shift();
                while (++firingIndex < list.length) {
                  // Run callback and check for early termination
                  if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                  }
                }
              }

              // Forget the data if we're done with it
              if (!options.memory) {
                memory = false;
              }

              firing = false;

              // Clean up if we're done firing for good
              if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) {
                  list = [];

                  // Otherwise, this object is spent
                } else {
                  list = '';
                }
              }
            },
            // Actual Callbacks object
            self = {
              // Add a callback or a collection of callbacks to the list
              add: function () {
                if (list) {
                  // If we have memory from a past run, we should fire after adding
                  if (memory && !firing) {
                    firingIndex = list.length - 1;
                    queue.push(memory);
                  }

                  (function add(args) {
                    jQuery.each(args, function (_, arg) {
                      if (isFunction(arg)) {
                        if (!options.unique || !self.has(arg)) {
                          list.push(arg);
                        }
                      } else if (arg && arg.length && toType(arg) !== 'string') {
                        // Inspect recursively
                        add(arg);
                      }
                    });
                  })(arguments);

                  if (memory && !firing) {
                    fire();
                  }
                }
                return this;
              },

              // Remove a callback from the list
              remove: function () {
                jQuery.each(arguments, function (_, arg) {
                  var index;
                  while ((index = jQuery.inArray(arg, list, index)) > -1) {
                    list.splice(index, 1);

                    // Handle firing indexes
                    if (index <= firingIndex) {
                      firingIndex--;
                    }
                  }
                });
                return this;
              },

              // Check if a given callback is in the list.
              // If no argument is given, return whether or not list has callbacks attached.
              has: function (fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
              },

              // Remove all callbacks from the list
              empty: function () {
                if (list) {
                  list = [];
                }
                return this;
              },

              // Disable .fire and .add
              // Abort any current/pending executions
              // Clear all callbacks and values
              disable: function () {
                locked = queue = [];
                list = memory = '';
                return this;
              },
              disabled: function () {
                return !list;
              },

              // Disable .fire
              // Also disable .add unless we have memory (since it would have no effect)
              // Abort any pending executions
              lock: function () {
                locked = queue = [];
                if (!memory && !firing) {
                  list = memory = '';
                }
                return this;
              },
              locked: function () {
                return !!locked;
              },

              // Call all callbacks with the given context and arguments
              fireWith: function (context, args) {
                if (!locked) {
                  args = args || [];
                  args = [context, args.slice ? args.slice() : args];
                  queue.push(args);
                  if (!firing) {
                    fire();
                  }
                }
                return this;
              },

              // Call all the callbacks with the given arguments
              fire: function () {
                self.fireWith(this, arguments);
                return this;
              },

              // To know if the callbacks have already been called at least once
              fired: function () {
                return !!fired;
              }
            };

          return self;
        };

        function Identity(v) {
          return v;
        }
        function Thrower(ex) {
          throw ex;
        }

        function adoptValue(value, resolve, reject, noValue) {
          var method;

          try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction((method = value.promise))) {
              method.call(value).done(resolve).fail(reject);

              // Other thenables
            } else if (value && isFunction((method = value.then))) {
              method.call(value, resolve, reject);

              // Other non-thenables
            } else {
              // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
              // * false: [ value ].slice( 0 ) => resolve( value )
              // * true: [ value ].slice( 1 ) => resolve()
              resolve.apply(undefined, [value].slice(noValue));
            }

            // For Promises/A+, convert exceptions into rejections
            // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
            // Deferred#then to conditionally suppress rejection.
          } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [value]);
          }
        }

        jQuery.extend({
          Deferred: function (func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                ['notify', 'progress', jQuery.Callbacks('memory'), jQuery.Callbacks('memory'), 2],
                ['resolve', 'done', jQuery.Callbacks('once memory'), jQuery.Callbacks('once memory'), 0, 'resolved'],
                ['reject', 'fail', jQuery.Callbacks('once memory'), jQuery.Callbacks('once memory'), 1, 'rejected']
              ],
              state = 'pending',
              promise = {
                state: function () {
                  return state;
                },
                always: function () {
                  deferred.done(arguments).fail(arguments);
                  return this;
                },
                catch: function (fn) {
                  return promise.then(null, fn);
                },

                // Keep pipe for back-compat
                pipe: function (/* fnDone, fnFail, fnProgress */) {
                  var fns = arguments;

                  return jQuery
                    .Deferred(function (newDefer) {
                      jQuery.each(tuples, function (_i, tuple) {
                        // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                        var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];

                        // deferred.progress(function() { bind to newDefer or newDefer.notify })
                        // deferred.done(function() { bind to newDefer or newDefer.resolve })
                        // deferred.fail(function() { bind to newDefer or newDefer.reject })
                        deferred[tuple[1]](function () {
                          var returned = fn && fn.apply(this, arguments);
                          if (returned && isFunction(returned.promise)) {
                            returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                          } else {
                            newDefer[tuple[0] + 'With'](this, fn ? [returned] : arguments);
                          }
                        });
                      });
                      fns = null;
                    })
                    .promise();
                },
                then: function (onFulfilled, onRejected, onProgress) {
                  var maxDepth = 0;
                  function resolve(depth, deferred, handler, special) {
                    return function () {
                      var that = this,
                        args = arguments,
                        mightThrow = function () {
                          var returned, then;

                          // Support: Promises/A+ section 2.3.3.3.3
                          // https://promisesaplus.com/#point-59
                          // Ignore double-resolution attempts
                          if (depth < maxDepth) {
                            return;
                          }

                          returned = handler.apply(that, args);

                          // Support: Promises/A+ section 2.3.1
                          // https://promisesaplus.com/#point-48
                          if (returned === deferred.promise()) {
                            throw new TypeError('Thenable self-resolution');
                          }

                          // Support: Promises/A+ sections 2.3.3.1, 3.5
                          // https://promisesaplus.com/#point-54
                          // https://promisesaplus.com/#point-75
                          // Retrieve `then` only once
                          then =
                            returned &&
                            // Support: Promises/A+ section 2.3.4
                            // https://promisesaplus.com/#point-64
                            // Only check objects and functions for thenability
                            (typeof returned === 'object' || typeof returned === 'function') &&
                            returned.then;

                          // Handle a returned thenable
                          if (isFunction(then)) {
                            // Special processors (notify) just wait for resolution
                            if (special) {
                              then.call(
                                returned,
                                resolve(maxDepth, deferred, Identity, special),
                                resolve(maxDepth, deferred, Thrower, special)
                              );

                              // Normal processors (resolve) also hook into progress
                            } else {
                              // ...and disregard older resolution values
                              maxDepth++;

                              then.call(
                                returned,
                                resolve(maxDepth, deferred, Identity, special),
                                resolve(maxDepth, deferred, Thrower, special),
                                resolve(maxDepth, deferred, Identity, deferred.notifyWith)
                              );
                            }

                            // Handle all other returned values
                          } else {
                            // Only substitute handlers pass on context
                            // and multiple values (non-spec behavior)
                            if (handler !== Identity) {
                              that = undefined;
                              args = [returned];
                            }

                            // Process the value(s)
                            // Default process is resolve
                            (special || deferred.resolveWith)(that, args);
                          }
                        },
                        // Only normal processors (resolve) catch and reject exceptions
                        process = special
                          ? mightThrow
                          : function () {
                              try {
                                mightThrow();
                              } catch (e) {
                                if (jQuery.Deferred.exceptionHook) {
                                  jQuery.Deferred.exceptionHook(e, process.stackTrace);
                                }

                                // Support: Promises/A+ section 2.3.3.3.4.1
                                // https://promisesaplus.com/#point-61
                                // Ignore post-resolution exceptions
                                if (depth + 1 >= maxDepth) {
                                  // Only substitute handlers pass on context
                                  // and multiple values (non-spec behavior)
                                  if (handler !== Thrower) {
                                    that = undefined;
                                    args = [e];
                                  }

                                  deferred.rejectWith(that, args);
                                }
                              }
                            };

                      // Support: Promises/A+ section 2.3.3.3.1
                      // https://promisesaplus.com/#point-57
                      // Re-resolve promises immediately to dodge false rejection from
                      // subsequent errors
                      if (depth) {
                        process();
                      } else {
                        // Call an optional hook to record the stack, in case of exception
                        // since it's otherwise lost when execution goes async
                        if (jQuery.Deferred.getStackHook) {
                          process.stackTrace = jQuery.Deferred.getStackHook();
                        }
                        window.setTimeout(process);
                      }
                    };
                  }

                  return jQuery
                    .Deferred(function (newDefer) {
                      // progress_handlers.add( ... )
                      tuples[0][3].add(
                        resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith)
                      );

                      // fulfilled_handlers.add( ... )
                      tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));

                      // rejected_handlers.add( ... )
                      tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    })
                    .promise();
                },

                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function (obj) {
                  return obj != null ? jQuery.extend(obj, promise) : promise;
                }
              },
              deferred = {};

            // Add list-specific methods
            jQuery.each(tuples, function (i, tuple) {
              var list = tuple[2],
                stateString = tuple[5];

              // promise.progress = list.add
              // promise.done = list.add
              // promise.fail = list.add
              promise[tuple[1]] = list.add;

              // Handle state
              if (stateString) {
                list.add(
                  function () {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                  },

                  // rejected_callbacks.disable
                  // fulfilled_callbacks.disable
                  tuples[3 - i][2].disable,

                  // rejected_handlers.disable
                  // fulfilled_handlers.disable
                  tuples[3 - i][3].disable,

                  // progress_callbacks.lock
                  tuples[0][2].lock,

                  // progress_handlers.lock
                  tuples[0][3].lock
                );
              }

              // progress_handlers.fire
              // fulfilled_handlers.fire
              // rejected_handlers.fire
              list.add(tuple[3].fire);

              // deferred.notify = function() { deferred.notifyWith(...) }
              // deferred.resolve = function() { deferred.resolveWith(...) }
              // deferred.reject = function() { deferred.rejectWith(...) }
              deferred[tuple[0]] = function () {
                deferred[tuple[0] + 'With'](this === deferred ? undefined : this, arguments);
                return this;
              };

              // deferred.notifyWith = list.fireWith
              // deferred.resolveWith = list.fireWith
              // deferred.rejectWith = list.fireWith
              deferred[tuple[0] + 'With'] = list.fireWith;
            });

            // Make the deferred a promise
            promise.promise(deferred);

            // Call given func if any
            if (func) {
              func.call(deferred, deferred);
            }

            // All done!
            return deferred;
          },

          // Deferred helper
          when: function (singleValue) {
            var // count of uncompleted subordinates
              remaining = arguments.length,
              // count of unprocessed arguments
              i = remaining,
              // subordinate fulfillment data
              resolveContexts = Array(i),
              resolveValues = slice.call(arguments),
              // the primary Deferred
              primary = jQuery.Deferred(),
              // subordinate callback factory
              updateFunc = function (i) {
                return function (value) {
                  resolveContexts[i] = this;
                  resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                  if (!--remaining) {
                    primary.resolveWith(resolveContexts, resolveValues);
                  }
                };
              };

            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
              adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);

              // Use .then() to unwrap secondary thenables (cf. gh-3000)
              if (primary.state() === 'pending' || isFunction(resolveValues[i] && resolveValues[i].then)) {
                return primary.then();
              }
            }

            // Multiple arguments are aggregated like Promise.all array elements
            while (i--) {
              adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            }

            return primary.promise();
          }
        });

        // These usually indicate a programmer mistake during development,
        // warn about them ASAP rather than swallowing them by default.
        var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

        jQuery.Deferred.exceptionHook = function (error, stack) {
          // Support: IE 8 - 9 only
          // Console exists when dev tools are open, which can happen at any time
          if (window.console && window.console.warn && error && rerrorNames.test(error.name)) {
            window.console.warn('jQuery.Deferred exception: ' + error.message, error.stack, stack);
          }
        };

        jQuery.readyException = function (error) {
          window.setTimeout(function () {
            throw error;
          });
        };

        // The deferred used on DOM ready
        var readyList = jQuery.Deferred();

        jQuery.fn.ready = function (fn) {
          readyList
            .then(fn)

            // Wrap jQuery.readyException in a function so that the lookup
            // happens at the time of error handling instead of callback
            // registration.
            .catch(function (error) {
              jQuery.readyException(error);
            });

          return this;
        };

        jQuery.extend({
          // Is the DOM ready to be used? Set to true once it occurs.
          isReady: false,

          // A counter to track how many items to wait for before
          // the ready event fires. See #6781
          readyWait: 1,

          // Handle when the DOM is ready
          ready: function (wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
              return;
            }

            // Remember that the DOM is ready
            jQuery.isReady = true;

            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) {
              return;
            }

            // If there are functions bound, to execute
            readyList.resolveWith(document, [jQuery]);
          }
        });

        jQuery.ready.then = readyList.then;

        // The ready event handler and self cleanup method
        function completed() {
          document.removeEventListener('DOMContentLoaded', completed);
          window.removeEventListener('load', completed);
          jQuery.ready();
        }

        // Catch cases where $(document).ready() is called
        // after the browser event has already occurred.
        // Support: IE <=9 - 10 only
        // Older IE sometimes signals "interactive" too soon
        if (
          document.readyState === 'complete' ||
          (document.readyState !== 'loading' && !document.documentElement.doScroll)
        ) {
          // Handle it asynchronously to allow scripts the opportunity to delay ready
          window.setTimeout(jQuery.ready);
        } else {
          // Use the handy event callback
          document.addEventListener('DOMContentLoaded', completed);

          // A fallback to window.onload, that will always work
          window.addEventListener('load', completed);
        }

        // Multifunctional method to get and set values of a collection
        // The value/s can optionally be executed if it's a function
        var access = function (elems, fn, key, value, chainable, emptyGet, raw) {
          var i = 0,
            len = elems.length,
            bulk = key == null;

          // Sets many values
          if (toType(key) === 'object') {
            chainable = true;
            for (i in key) {
              access(elems, fn, i, key[i], true, emptyGet, raw);
            }

            // Sets one value
          } else if (value !== undefined) {
            chainable = true;

            if (!isFunction(value)) {
              raw = true;
            }

            if (bulk) {
              // Bulk operations run against the entire set
              if (raw) {
                fn.call(elems, value);
                fn = null;

                // ...except when executing function values
              } else {
                bulk = fn;
                fn = function (elem, _key, value) {
                  return bulk.call(jQuery(elem), value);
                };
              }
            }

            if (fn) {
              for (; i < len; i++) {
                fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
              }
            }
          }

          if (chainable) {
            return elems;
          }

          // Gets
          if (bulk) {
            return fn.call(elems);
          }

          return len ? fn(elems[0], key) : emptyGet;
        };

        // Matches dashed string for camelizing
        var rmsPrefix = /^-ms-/,
          rdashAlpha = /-([a-z])/g;

        // Used by camelCase as callback to replace()
        function fcamelCase(_all, letter) {
          return letter.toUpperCase();
        }

        // Convert dashed to camelCase; used by the css and data modules
        // Support: IE <=9 - 11, Edge 12 - 15
        // Microsoft forgot to hump their vendor prefix (#9572)
        function camelCase(string) {
          return string.replace(rmsPrefix, 'ms-').replace(rdashAlpha, fcamelCase);
        }
        var acceptData = function (owner) {
          // Accepts only:
          //  - Node
          //    - Node.ELEMENT_NODE
          //    - Node.DOCUMENT_NODE
          //  - Object
          //    - Any
          return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
        };

        function Data() {
          this.expando = jQuery.expando + Data.uid++;
        }

        Data.uid = 1;

        Data.prototype = {
          cache: function (owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];

            // If not, create one
            if (!value) {
              value = {};

              // We can accept data for non-element nodes in modern browsers,
              // but we should not, see #8335.
              // Always return an empty object.
              if (acceptData(owner)) {
                // If it is a node unlikely to be stringify-ed or looped over
                // use plain assignment
                if (owner.nodeType) {
                  owner[this.expando] = value;

                  // Otherwise secure it in a non-enumerable property
                  // configurable must be true to allow the property to be
                  // deleted when data is removed
                } else {
                  Object.defineProperty(owner, this.expando, {
                    value: value,
                    configurable: true
                  });
                }
              }
            }

            return value;
          },
          set: function (owner, data, value) {
            var prop,
              cache = this.cache(owner);

            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === 'string') {
              cache[camelCase(data)] = value;

              // Handle: [ owner, { properties } ] args
            } else {
              // Copy the properties one-by-one to the cache object
              for (prop in data) {
                cache[camelCase(prop)] = data[prop];
              }
            }
            return cache;
          },
          get: function (owner, key) {
            return key === undefined
              ? this.cache(owner)
              : // Always use camelCase key (gh-2257)
                owner[this.expando] && owner[this.expando][camelCase(key)];
          },
          access: function (owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || (key && typeof key === 'string' && value === undefined)) {
              return this.get(owner, key);
            }

            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);

            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
          },
          remove: function (owner, key) {
            var i,
              cache = owner[this.expando];

            if (cache === undefined) {
              return;
            }

            if (key !== undefined) {
              // Support array or space separated string of keys
              if (Array.isArray(key)) {
                // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
              } else {
                key = camelCase(key);

                // If a key with the spaces exists, use it.
                // Otherwise, create an array by matching non-whitespace
                key = key in cache ? [key] : key.match(rnothtmlwhite) || [];
              }

              i = key.length;

              while (i--) {
                delete cache[key[i]];
              }
            }

            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
              // Support: Chrome <=35 - 45
              // Webkit & Blink performance suffers when deleting properties
              // from DOM nodes, so set to undefined instead
              // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
              if (owner.nodeType) {
                owner[this.expando] = undefined;
              } else {
                delete owner[this.expando];
              }
            }
          },
          hasData: function (owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
          }
        };
        var dataPriv = new Data();

        var dataUser = new Data();

        //	Implementation Summary
        //
        //	1. Enforce API surface and semantic compatibility with 1.9.x branch
        //	2. Improve the module's maintainability by reducing the storage
        //		paths to a single mechanism.
        //	3. Use the same single mechanism to support "private" and "user" data.
        //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
        //	5. Avoid exposing implementation details on user objects (eg. expando properties)
        //	6. Provide a clear path for implementation upgrade to WeakMap in 2014

        var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
          rmultiDash = /[A-Z]/g;

        function getData(data) {
          if (data === 'true') {
            return true;
          }

          if (data === 'false') {
            return false;
          }

          if (data === 'null') {
            return null;
          }

          // Only convert to a number if it doesn't change the string
          if (data === +data + '') {
            return +data;
          }

          if (rbrace.test(data)) {
            return JSON.parse(data);
          }

          return data;
        }

        function dataAttr(elem, key, data) {
          var name;

          // If nothing was found internally, try to fetch any
          // data from the HTML5 data-* attribute
          if (data === undefined && elem.nodeType === 1) {
            name = 'data-' + key.replace(rmultiDash, '-$&').toLowerCase();
            data = elem.getAttribute(name);

            if (typeof data === 'string') {
              try {
                data = getData(data);
              } catch (e) {}

              // Make sure we set the data so it isn't changed later
              dataUser.set(elem, key, data);
            } else {
              data = undefined;
            }
          }
          return data;
        }

        jQuery.extend({
          hasData: function (elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
          },

          data: function (elem, name, data) {
            return dataUser.access(elem, name, data);
          },

          removeData: function (elem, name) {
            dataUser.remove(elem, name);
          },

          // TODO: Now that all calls to _data and _removeData have been replaced
          // with direct calls to dataPriv methods, these can be deprecated.
          _data: function (elem, name, data) {
            return dataPriv.access(elem, name, data);
          },

          _removeData: function (elem, name) {
            dataPriv.remove(elem, name);
          }
        });

        jQuery.fn.extend({
          data: function (key, value) {
            var i,
              name,
              data,
              elem = this[0],
              attrs = elem && elem.attributes;

            // Gets all values
            if (key === undefined) {
              if (this.length) {
                data = dataUser.get(elem);

                if (elem.nodeType === 1 && !dataPriv.get(elem, 'hasDataAttrs')) {
                  i = attrs.length;
                  while (i--) {
                    // Support: IE 11 only
                    // The attrs elements can be null (#14894)
                    if (attrs[i]) {
                      name = attrs[i].name;
                      if (name.indexOf('data-') === 0) {
                        name = camelCase(name.slice(5));
                        dataAttr(elem, name, data[name]);
                      }
                    }
                  }
                  dataPriv.set(elem, 'hasDataAttrs', true);
                }
              }

              return data;
            }

            // Sets multiple values
            if (typeof key === 'object') {
              return this.each(function () {
                dataUser.set(this, key);
              });
            }

            return access(
              this,
              function (value) {
                var data;

                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                  // Attempt to get data from the cache
                  // The key will always be camelCased in Data
                  data = dataUser.get(elem, key);
                  if (data !== undefined) {
                    return data;
                  }

                  // Attempt to "discover" the data in
                  // HTML5 custom data-* attrs
                  data = dataAttr(elem, key);
                  if (data !== undefined) {
                    return data;
                  }

                  // We tried really hard, but the data doesn't exist.
                  return;
                }

                // Set the data...
                this.each(function () {
                  // We always store the camelCased key
                  dataUser.set(this, key, value);
                });
              },
              null,
              value,
              arguments.length > 1,
              null,
              true
            );
          },

          removeData: function (key) {
            return this.each(function () {
              dataUser.remove(this, key);
            });
          }
        });

        jQuery.extend({
          queue: function (elem, type, data) {
            var queue;

            if (elem) {
              type = (type || 'fx') + 'queue';
              queue = dataPriv.get(elem, type);

              // Speed up dequeue by getting out quickly if this is just a lookup
              if (data) {
                if (!queue || Array.isArray(data)) {
                  queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                } else {
                  queue.push(data);
                }
              }
              return queue || [];
            }
          },

          dequeue: function (elem, type) {
            type = type || 'fx';

            var queue = jQuery.queue(elem, type),
              startLength = queue.length,
              fn = queue.shift(),
              hooks = jQuery._queueHooks(elem, type),
              next = function () {
                jQuery.dequeue(elem, type);
              };

            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === 'inprogress') {
              fn = queue.shift();
              startLength--;
            }

            if (fn) {
              // Add a progress sentinel to prevent the fx queue from being
              // automatically dequeued
              if (type === 'fx') {
                queue.unshift('inprogress');
              }

              // Clear up the last queue stop function
              delete hooks.stop;
              fn.call(elem, next, hooks);
            }

            if (!startLength && hooks) {
              hooks.empty.fire();
            }
          },

          // Not public - generate a queueHooks object, or return the current one
          _queueHooks: function (elem, type) {
            var key = type + 'queueHooks';
            return (
              dataPriv.get(elem, key) ||
              dataPriv.access(elem, key, {
                empty: jQuery.Callbacks('once memory').add(function () {
                  dataPriv.remove(elem, [type + 'queue', key]);
                })
              })
            );
          }
        });

        jQuery.fn.extend({
          queue: function (type, data) {
            var setter = 2;

            if (typeof type !== 'string') {
              data = type;
              type = 'fx';
              setter--;
            }

            if (arguments.length < setter) {
              return jQuery.queue(this[0], type);
            }

            return data === undefined
              ? this
              : this.each(function () {
                  var queue = jQuery.queue(this, type, data);

                  // Ensure a hooks for this queue
                  jQuery._queueHooks(this, type);

                  if (type === 'fx' && queue[0] !== 'inprogress') {
                    jQuery.dequeue(this, type);
                  }
                });
          },
          dequeue: function (type) {
            return this.each(function () {
              jQuery.dequeue(this, type);
            });
          },
          clearQueue: function (type) {
            return this.queue(type || 'fx', []);
          },

          // Get a promise resolved when queues of a certain type
          // are emptied (fx is the type by default)
          promise: function (type, obj) {
            var tmp,
              count = 1,
              defer = jQuery.Deferred(),
              elements = this,
              i = this.length,
              resolve = function () {
                if (!--count) {
                  defer.resolveWith(elements, [elements]);
                }
              };

            if (typeof type !== 'string') {
              obj = type;
              type = undefined;
            }
            type = type || 'fx';

            while (i--) {
              tmp = dataPriv.get(elements[i], type + 'queueHooks');
              if (tmp && tmp.empty) {
                count++;
                tmp.empty.add(resolve);
              }
            }
            resolve();
            return defer.promise(obj);
          }
        });
        var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;

        var rcssNum = new RegExp('^(?:([+-])=|)(' + pnum + ')([a-z%]*)$', 'i');

        var cssExpand = ['Top', 'Right', 'Bottom', 'Left'];

        var documentElement = document.documentElement;

        var isAttached = function (elem) {
            return jQuery.contains(elem.ownerDocument, elem);
          },
          composed = { composed: true };

        // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
        // Check attachment across shadow DOM boundaries when possible (gh-3504)
        // Support: iOS 10.0-10.2 only
        // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
        // leading to errors. We need to check for `getRootNode`.
        if (documentElement.getRootNode) {
          isAttached = function (elem) {
            return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
          };
        }
        var isHiddenWithinTree = function (elem, el) {
          // isHiddenWithinTree might be called from jQuery#filter function;
          // in that case, element will be second argument
          elem = el || elem;

          // Inline style trumps all
          return (
            elem.style.display === 'none' ||
            (elem.style.display === '' &&
              // Otherwise, check computed style
              // Support: Firefox <=43 - 45
              // Disconnected elements can have computed display: none, so first confirm that elem is
              // in the document.
              isAttached(elem) &&
              jQuery.css(elem, 'display') === 'none')
          );
        };

        function adjustCSS(elem, prop, valueParts, tween) {
          var adjusted,
            scale,
            maxIterations = 20,
            currentValue = tween
              ? function () {
                  return tween.cur();
                }
              : function () {
                  return jQuery.css(elem, prop, '');
                },
            initial = currentValue(),
            unit = (valueParts && valueParts[3]) || (jQuery.cssNumber[prop] ? '' : 'px'),
            // Starting value computation is required for potential unit mismatches
            initialInUnit =
              elem.nodeType &&
              (jQuery.cssNumber[prop] || (unit !== 'px' && +initial)) &&
              rcssNum.exec(jQuery.css(elem, prop));

          if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;

            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];

            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;

            while (maxIterations--) {
              // Evaluate and update our best guess (doubling guesses that zero out).
              // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
              jQuery.style(elem, prop, initialInUnit + unit);
              if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
                maxIterations = 0;
              }
              initialInUnit = initialInUnit / scale;
            }

            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);

            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
          }

          if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;

            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
              tween.unit = unit;
              tween.start = initialInUnit;
              tween.end = adjusted;
            }
          }
          return adjusted;
        }

        var defaultDisplayMap = {};

        function getDefaultDisplay(elem) {
          var temp,
            doc = elem.ownerDocument,
            nodeName = elem.nodeName,
            display = defaultDisplayMap[nodeName];

          if (display) {
            return display;
          }

          temp = doc.body.appendChild(doc.createElement(nodeName));
          display = jQuery.css(temp, 'display');

          temp.parentNode.removeChild(temp);

          if (display === 'none') {
            display = 'block';
          }
          defaultDisplayMap[nodeName] = display;

          return display;
        }

        function showHide(elements, show) {
          var display,
            elem,
            values = [],
            index = 0,
            length = elements.length;

          // Determine new display value for elements that need to change
          for (; index < length; index++) {
            elem = elements[index];
            if (!elem.style) {
              continue;
            }

            display = elem.style.display;
            if (show) {
              // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
              // check is required in this first loop unless we have a nonempty display value (either
              // inline or about-to-be-restored)
              if (display === 'none') {
                values[index] = dataPriv.get(elem, 'display') || null;
                if (!values[index]) {
                  elem.style.display = '';
                }
              }
              if (elem.style.display === '' && isHiddenWithinTree(elem)) {
                values[index] = getDefaultDisplay(elem);
              }
            } else {
              if (display !== 'none') {
                values[index] = 'none';

                // Remember what we're overwriting
                dataPriv.set(elem, 'display', display);
              }
            }
          }

          // Set the display of the elements in a second loop to avoid constant reflow
          for (index = 0; index < length; index++) {
            if (values[index] != null) {
              elements[index].style.display = values[index];
            }
          }

          return elements;
        }

        jQuery.fn.extend({
          show: function () {
            return showHide(this, true);
          },
          hide: function () {
            return showHide(this);
          },
          toggle: function (state) {
            if (typeof state === 'boolean') {
              return state ? this.show() : this.hide();
            }

            return this.each(function () {
              if (isHiddenWithinTree(this)) {
                jQuery(this).show();
              } else {
                jQuery(this).hide();
              }
            });
          }
        });
        var rcheckableType = /^(?:checkbox|radio)$/i;

        var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;

        var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;

        (function () {
          var fragment = document.createDocumentFragment(),
            div = fragment.appendChild(document.createElement('div')),
            input = document.createElement('input');

          // Support: Android 4.0 - 4.3 only
          // Check state lost if the name is set (#11217)
          // Support: Windows Web Apps (WWA)
          // `name` and `type` must use .setAttribute for WWA (#14901)
          input.setAttribute('type', 'radio');
          input.setAttribute('checked', 'checked');
          input.setAttribute('name', 't');

          div.appendChild(input);

          // Support: Android <=4.1 only
          // Older WebKit doesn't clone checked state correctly in fragments
          support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;

          // Support: IE <=11 only
          // Make sure textarea (and checkbox) defaultValue is properly cloned
          div.innerHTML = '<textarea>x</textarea>';
          support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;

          // Support: IE <=9 only
          // IE <=9 replaces <option> tags with their contents when inserted outside of
          // the select element.
          div.innerHTML = '<option></option>';
          support.option = !!div.lastChild;
        })();

        // We have to close these tags to support XHTML (#13200)
        var wrapMap = {
          // XHTML parsers do not magically insert elements in the
          // same way that tag soup parsers do. So we cannot shorten
          // this by omitting <tbody> or other required elements.
          thead: [1, '<table>', '</table>'],
          col: [2, '<table><colgroup>', '</colgroup></table>'],
          tr: [2, '<table><tbody>', '</tbody></table>'],
          td: [3, '<table><tbody><tr>', '</tr></tbody></table>'],

          _default: [0, '', '']
        };

        wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
        wrapMap.th = wrapMap.td;

        // Support: IE <=9 only
        if (!support.option) {
          wrapMap.optgroup = wrapMap.option = [1, "<select multiple='multiple'>", '</select>'];
        }

        function getAll(context, tag) {
          // Support: IE <=9 - 11 only
          // Use typeof to avoid zero-argument method invocation on host objects (#15151)
          var ret;

          if (typeof context.getElementsByTagName !== 'undefined') {
            ret = context.getElementsByTagName(tag || '*');
          } else if (typeof context.querySelectorAll !== 'undefined') {
            ret = context.querySelectorAll(tag || '*');
          } else {
            ret = [];
          }

          if (tag === undefined || (tag && nodeName(context, tag))) {
            return jQuery.merge([context], ret);
          }

          return ret;
        }

        // Mark scripts as having already been evaluated
        function setGlobalEval(elems, refElements) {
          var i = 0,
            l = elems.length;

          for (; i < l; i++) {
            dataPriv.set(elems[i], 'globalEval', !refElements || dataPriv.get(refElements[i], 'globalEval'));
          }
        }

        var rhtml = /<|&#?\w+;/;

        function buildFragment(elems, context, scripts, selection, ignored) {
          var elem,
            tmp,
            tag,
            wrap,
            attached,
            j,
            fragment = context.createDocumentFragment(),
            nodes = [],
            i = 0,
            l = elems.length;

          for (; i < l; i++) {
            elem = elems[i];

            if (elem || elem === 0) {
              // Add nodes directly
              if (toType(elem) === 'object') {
                // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [elem] : elem);

                // Convert non-html into a text node
              } else if (!rhtml.test(elem)) {
                nodes.push(context.createTextNode(elem));

                // Convert html into DOM nodes
              } else {
                tmp = tmp || fragment.appendChild(context.createElement('div'));

                // Deserialize a standard representation
                tag = (rtagName.exec(elem) || ['', ''])[1].toLowerCase();
                wrap = wrapMap[tag] || wrapMap._default;
                tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];

                // Descend through wrappers to the right content
                j = wrap[0];
                while (j--) {
                  tmp = tmp.lastChild;
                }

                // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, tmp.childNodes);

                // Remember the top-level container
                tmp = fragment.firstChild;

                // Ensure the created nodes are orphaned (#12392)
                tmp.textContent = '';
              }
            }
          }

          // Remove wrapper from fragment
          fragment.textContent = '';

          i = 0;
          while ((elem = nodes[i++])) {
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
              if (ignored) {
                ignored.push(elem);
              }
              continue;
            }

            attached = isAttached(elem);

            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), 'script');

            // Preserve script evaluation history
            if (attached) {
              setGlobalEval(tmp);
            }

            // Capture executables
            if (scripts) {
              j = 0;
              while ((elem = tmp[j++])) {
                if (rscriptType.test(elem.type || '')) {
                  scripts.push(elem);
                }
              }
            }
          }

          return fragment;
        }

        var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

        function returnTrue() {
          return true;
        }

        function returnFalse() {
          return false;
        }

        // Support: IE <=9 - 11+
        // focus() and blur() are asynchronous, except when they are no-op.
        // So expect focus to be synchronous when the element is already active,
        // and blur to be synchronous when the element is not already active.
        // (focus and blur are always synchronous in other supported browsers,
        // this just defines when we can count on it).
        function expectSync(elem, type) {
          return (elem === safeActiveElement()) === (type === 'focus');
        }

        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
          try {
            return document.activeElement;
          } catch (err) {}
        }

        function on(elem, types, selector, data, fn, one) {
          var origFn, type;

          // Types can be a map of types/handlers
          if (typeof types === 'object') {
            // ( types-Object, selector, data )
            if (typeof selector !== 'string') {
              // ( types-Object, data )
              data = data || selector;
              selector = undefined;
            }
            for (type in types) {
              on(elem, type, selector, data, types[type], one);
            }
            return elem;
          }

          if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
          } else if (fn == null) {
            if (typeof selector === 'string') {
              // ( types, selector, fn )
              fn = data;
              data = undefined;
            } else {
              // ( types, data, fn )
              fn = data;
              data = selector;
              selector = undefined;
            }
          }
          if (fn === false) {
            fn = returnFalse;
          } else if (!fn) {
            return elem;
          }

          if (one === 1) {
            origFn = fn;
            fn = function (event) {
              // Can use an empty set, since event contains the info
              jQuery().off(event);
              return origFn.apply(this, arguments);
            };

            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
          }
          return elem.each(function () {
            jQuery.event.add(this, types, fn, data, selector);
          });
        }

        /*
         * Helper functions for managing events -- not part of the public interface.
         * Props to Dean Edwards' addEvent library for many of the ideas.
         */
        jQuery.event = {
          global: {},

          add: function (elem, types, handler, data, selector) {
            var handleObjIn,
              eventHandle,
              tmp,
              events,
              t,
              handleObj,
              special,
              handlers,
              type,
              namespaces,
              origType,
              elemData = dataPriv.get(elem);

            // Only attach events to objects that accept data
            if (!acceptData(elem)) {
              return;
            }

            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
              handleObjIn = handler;
              handler = handleObjIn.handler;
              selector = handleObjIn.selector;
            }

            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) {
              jQuery.find.matchesSelector(documentElement, selector);
            }

            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) {
              handler.guid = jQuery.guid++;
            }

            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) {
              events = elemData.events = Object.create(null);
            }
            if (!(eventHandle = elemData.handle)) {
              eventHandle = elemData.handle = function (e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== 'undefined' && jQuery.event.triggered !== e.type
                  ? jQuery.event.dispatch.apply(elem, arguments)
                  : undefined;
              };
            }

            // Handle multiple events separated by a space
            types = (types || '').match(rnothtmlwhite) || [''];
            t = types.length;
            while (t--) {
              tmp = rtypenamespace.exec(types[t]) || [];
              type = origType = tmp[1];
              namespaces = (tmp[2] || '').split('.').sort();

              // There *must* be a type, no attaching namespace-only handlers
              if (!type) {
                continue;
              }

              // If event changes its type, use the special event handlers for the changed type
              special = jQuery.event.special[type] || {};

              // If selector defined, determine special event api type, otherwise given type
              type = (selector ? special.delegateType : special.bindType) || type;

              // Update special based on newly reset type
              special = jQuery.event.special[type] || {};

              // handleObj is passed to all event handlers
              handleObj = jQuery.extend(
                {
                  type: type,
                  origType: origType,
                  data: data,
                  handler: handler,
                  guid: handler.guid,
                  selector: selector,
                  needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                  namespace: namespaces.join('.')
                },
                handleObjIn
              );

              // Init the event handler queue if we're the first
              if (!(handlers = events[type])) {
                handlers = events[type] = [];
                handlers.delegateCount = 0;

                // Only use addEventListener if the special events handler returns false
                if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                  if (elem.addEventListener) {
                    elem.addEventListener(type, eventHandle);
                  }
                }
              }

              if (special.add) {
                special.add.call(elem, handleObj);

                if (!handleObj.handler.guid) {
                  handleObj.handler.guid = handler.guid;
                }
              }

              // Add to the element's handler list, delegates in front
              if (selector) {
                handlers.splice(handlers.delegateCount++, 0, handleObj);
              } else {
                handlers.push(handleObj);
              }

              // Keep track of which events have ever been used, for event optimization
              jQuery.event.global[type] = true;
            }
          },

          // Detach an event or set of events from an element
          remove: function (elem, types, handler, selector, mappedTypes) {
            var j,
              origCount,
              tmp,
              events,
              t,
              handleObj,
              special,
              handlers,
              type,
              namespaces,
              origType,
              elemData = dataPriv.hasData(elem) && dataPriv.get(elem);

            if (!elemData || !(events = elemData.events)) {
              return;
            }

            // Once for each type.namespace in types; type may be omitted
            types = (types || '').match(rnothtmlwhite) || [''];
            t = types.length;
            while (t--) {
              tmp = rtypenamespace.exec(types[t]) || [];
              type = origType = tmp[1];
              namespaces = (tmp[2] || '').split('.').sort();

              // Unbind all events (on this namespace, if provided) for the element
              if (!type) {
                for (type in events) {
                  jQuery.event.remove(elem, type + types[t], handler, selector, true);
                }
                continue;
              }

              special = jQuery.event.special[type] || {};
              type = (selector ? special.delegateType : special.bindType) || type;
              handlers = events[type] || [];
              tmp = tmp[2] && new RegExp('(^|\\.)' + namespaces.join('\\.(?:.*\\.|)') + '(\\.|$)');

              // Remove matching events
              origCount = j = handlers.length;
              while (j--) {
                handleObj = handlers[j];

                if (
                  (mappedTypes || origType === handleObj.origType) &&
                  (!handler || handler.guid === handleObj.guid) &&
                  (!tmp || tmp.test(handleObj.namespace)) &&
                  (!selector || selector === handleObj.selector || (selector === '**' && handleObj.selector))
                ) {
                  handlers.splice(j, 1);

                  if (handleObj.selector) {
                    handlers.delegateCount--;
                  }
                  if (special.remove) {
                    special.remove.call(elem, handleObj);
                  }
                }
              }

              // Remove generic event handler if we removed something and no more handlers exist
              // (avoids potential for endless recursion during removal of special event handlers)
              if (origCount && !handlers.length) {
                if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {
                  jQuery.removeEvent(elem, type, elemData.handle);
                }

                delete events[type];
              }
            }

            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) {
              dataPriv.remove(elem, 'handle events');
            }
          },

          dispatch: function (nativeEvent) {
            var i,
              j,
              ret,
              matched,
              handleObj,
              handlerQueue,
              args = new Array(arguments.length),
              // Make a writable jQuery.Event from the native event object
              event = jQuery.event.fix(nativeEvent),
              handlers = (dataPriv.get(this, 'events') || Object.create(null))[event.type] || [],
              special = jQuery.event.special[event.type] || {};

            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;

            for (i = 1; i < arguments.length; i++) {
              args[i] = arguments[i];
            }

            event.delegateTarget = this;

            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) {
              return;
            }

            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);

            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
              event.currentTarget = matched.elem;

              j = 0;
              while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {
                // If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                  event.handleObj = handleObj;
                  event.data = handleObj.data;

                  ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(
                    matched.elem,
                    args
                  );

                  if (ret !== undefined) {
                    if ((event.result = ret) === false) {
                      event.preventDefault();
                      event.stopPropagation();
                    }
                  }
                }
              }
            }

            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) {
              special.postDispatch.call(this, event);
            }

            return event.result;
          },

          handlers: function (event, handlers) {
            var i,
              handleObj,
              sel,
              matchedHandlers,
              matchedSelectors,
              handlerQueue = [],
              delegateCount = handlers.delegateCount,
              cur = event.target;

            // Find delegate handlers
            if (
              delegateCount &&
              // Support: IE <=9
              // Black-hole SVG <use> instance trees (trac-13180)
              cur.nodeType &&
              // Support: Firefox <=42
              // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
              // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
              // Support: IE 11 only
              // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
              !(event.type === 'click' && event.button >= 1)
            ) {
              for (; cur !== this; cur = cur.parentNode || this) {
                // Don't check non-elements (#13208)
                // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
                if (cur.nodeType === 1 && !(event.type === 'click' && cur.disabled === true)) {
                  matchedHandlers = [];
                  matchedSelectors = {};
                  for (i = 0; i < delegateCount; i++) {
                    handleObj = handlers[i];

                    // Don't conflict with Object.prototype properties (#13203)
                    sel = handleObj.selector + ' ';

                    if (matchedSelectors[sel] === undefined) {
                      matchedSelectors[sel] = handleObj.needsContext
                        ? jQuery(sel, this).index(cur) > -1
                        : jQuery.find(sel, this, null, [cur]).length;
                    }
                    if (matchedSelectors[sel]) {
                      matchedHandlers.push(handleObj);
                    }
                  }
                  if (matchedHandlers.length) {
                    handlerQueue.push({ elem: cur, handlers: matchedHandlers });
                  }
                }
              }
            }

            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) {
              handlerQueue.push({ elem: cur, handlers: handlers.slice(delegateCount) });
            }

            return handlerQueue;
          },

          addProp: function (name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
              enumerable: true,
              configurable: true,

              get: isFunction(hook)
                ? function () {
                    if (this.originalEvent) {
                      return hook(this.originalEvent);
                    }
                  }
                : function () {
                    if (this.originalEvent) {
                      return this.originalEvent[name];
                    }
                  },

              set: function (value) {
                Object.defineProperty(this, name, {
                  enumerable: true,
                  configurable: true,
                  writable: true,
                  value: value
                });
              }
            });
          },

          fix: function (originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
          },

          special: {
            load: {
              // Prevent triggered image.load events from bubbling to window.load
              noBubble: true
            },
            click: {
              // Utilize native event to ensure correct state for checkable inputs
              setup: function (data) {
                // For mutual compressibility with _default, replace `this` access with a local var.
                // `|| data` is dead code meant only to preserve the variable through minification.
                var el = this || data;

                // Claim the first handler
                if (rcheckableType.test(el.type) && el.click && nodeName(el, 'input')) {
                  // dataPriv.set( el, "click", ... )
                  leverageNative(el, 'click', returnTrue);
                }

                // Return false to allow normal processing in the caller
                return false;
              },
              trigger: function (data) {
                // For mutual compressibility with _default, replace `this` access with a local var.
                // `|| data` is dead code meant only to preserve the variable through minification.
                var el = this || data;

                // Force setup before triggering a click
                if (rcheckableType.test(el.type) && el.click && nodeName(el, 'input')) {
                  leverageNative(el, 'click');
                }

                // Return non-false to allow normal event-path propagation
                return true;
              },

              // For cross-browser consistency, suppress native .click() on links
              // Also prevent it if we're currently inside a leveraged native-event stack
              _default: function (event) {
                var target = event.target;
                return (
                  (rcheckableType.test(target.type) &&
                    target.click &&
                    nodeName(target, 'input') &&
                    dataPriv.get(target, 'click')) ||
                  nodeName(target, 'a')
                );
              }
            },

            beforeunload: {
              postDispatch: function (event) {
                // Support: Firefox 20+
                // Firefox doesn't alert if the returnValue field is not set.
                if (event.result !== undefined && event.originalEvent) {
                  event.originalEvent.returnValue = event.result;
                }
              }
            }
          }
        };

        // Ensure the presence of an event listener that handles manually-triggered
        // synthetic events by interrupting progress until reinvoked in response to
        // *native* events that it fires directly, ensuring that state changes have
        // already occurred before other listeners are invoked.
        function leverageNative(el, type, expectSync) {
          // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
          if (!expectSync) {
            if (dataPriv.get(el, type) === undefined) {
              jQuery.event.add(el, type, returnTrue);
            }
            return;
          }

          // Register the controller as a special universal handler for all event namespaces
          dataPriv.set(el, type, false);
          jQuery.event.add(el, type, {
            namespace: false,
            handler: function (event) {
              var notAsync,
                result,
                saved = dataPriv.get(this, type);

              if (event.isTrigger & 1 && this[type]) {
                // Interrupt processing of the outer synthetic .trigger()ed event
                // Saved data should be false in such cases, but might be a leftover capture object
                // from an async native handler (gh-4350)
                if (!saved.length) {
                  // Store arguments for use when handling the inner native event
                  // There will always be at least one argument (an event object), so this array
                  // will not be confused with a leftover capture object.
                  saved = slice.call(arguments);
                  dataPriv.set(this, type, saved);

                  // Trigger the native event and capture its result
                  // Support: IE <=9 - 11+
                  // focus() and blur() are asynchronous
                  notAsync = expectSync(this, type);
                  this[type]();
                  result = dataPriv.get(this, type);
                  if (saved !== result || notAsync) {
                    dataPriv.set(this, type, false);
                  } else {
                    result = {};
                  }
                  if (saved !== result) {
                    // Cancel the outer synthetic event
                    event.stopImmediatePropagation();
                    event.preventDefault();

                    // Support: Chrome 86+
                    // In Chrome, if an element having a focusout handler is blurred by
                    // clicking outside of it, it invokes the handler synchronously. If
                    // that handler calls `.remove()` on the element, the data is cleared,
                    // leaving `result` undefined. We need to guard against this.
                    return result && result.value;
                  }

                  // If this is an inner synthetic event for an event with a bubbling surrogate
                  // (focus or blur), assume that the surrogate already propagated from triggering the
                  // native event and prevent that from happening again here.
                  // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                  // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                  // less bad than duplication.
                } else if ((jQuery.event.special[type] || {}).delegateType) {
                  event.stopPropagation();
                }

                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
              } else if (saved.length) {
                // ...and capture the result
                dataPriv.set(this, type, {
                  value: jQuery.event.trigger(
                    // Support: IE <=9 - 11+
                    // Extend with the prototype to reset the above stopImmediatePropagation()
                    jQuery.extend(saved[0], jQuery.Event.prototype),
                    saved.slice(1),
                    this
                  )
                });

                // Abort handling of the native event
                event.stopImmediatePropagation();
              }
            }
          });
        }

        jQuery.removeEvent = function (elem, type, handle) {
          // This "if" is needed for plain objects
          if (elem.removeEventListener) {
            elem.removeEventListener(type, handle);
          }
        };

        jQuery.Event = function (src, props) {
          // Allow instantiation without the 'new' keyword
          if (!(this instanceof jQuery.Event)) {
            return new jQuery.Event(src, props);
          }

          // Event object
          if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;

            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented =
              src.defaultPrevented ||
              (src.defaultPrevented === undefined &&
                // Support: Android <=2.3 only
                src.returnValue === false)
                ? returnTrue
                : returnFalse;

            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (#504, #13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;

            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;

            // Event type
          } else {
            this.type = src;
          }

          // Put explicitly provided properties onto the event object
          if (props) {
            jQuery.extend(this, props);
          }

          // Create a timestamp if incoming event doesn't have one
          this.timeStamp = (src && src.timeStamp) || Date.now();

          // Mark it as fixed
          this[jQuery.expando] = true;
        };

        // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
        // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
        jQuery.Event.prototype = {
          constructor: jQuery.Event,
          isDefaultPrevented: returnFalse,
          isPropagationStopped: returnFalse,
          isImmediatePropagationStopped: returnFalse,
          isSimulated: false,

          preventDefault: function () {
            var e = this.originalEvent;

            this.isDefaultPrevented = returnTrue;

            if (e && !this.isSimulated) {
              e.preventDefault();
            }
          },
          stopPropagation: function () {
            var e = this.originalEvent;

            this.isPropagationStopped = returnTrue;

            if (e && !this.isSimulated) {
              e.stopPropagation();
            }
          },
          stopImmediatePropagation: function () {
            var e = this.originalEvent;

            this.isImmediatePropagationStopped = returnTrue;

            if (e && !this.isSimulated) {
              e.stopImmediatePropagation();
            }

            this.stopPropagation();
          }
        };

        // Includes all common event props including KeyEvent and MouseEvent specific props
        jQuery.each(
          {
            altKey: true,
            bubbles: true,
            cancelable: true,
            changedTouches: true,
            ctrlKey: true,
            detail: true,
            eventPhase: true,
            metaKey: true,
            pageX: true,
            pageY: true,
            shiftKey: true,
            view: true,
            char: true,
            code: true,
            charCode: true,
            key: true,
            keyCode: true,
            button: true,
            buttons: true,
            clientX: true,
            clientY: true,
            offsetX: true,
            offsetY: true,
            pointerId: true,
            pointerType: true,
            screenX: true,
            screenY: true,
            targetTouches: true,
            toElement: true,
            touches: true,
            which: true
          },
          jQuery.event.addProp
        );

        jQuery.each({ focus: 'focusin', blur: 'focusout' }, function (type, delegateType) {
          jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function () {
              // Claim the first handler
              // dataPriv.set( this, "focus", ... )
              // dataPriv.set( this, "blur", ... )
              leverageNative(this, type, expectSync);

              // Return false to allow normal processing in the caller
              return false;
            },
            trigger: function () {
              // Force setup before trigger
              leverageNative(this, type);

              // Return non-false to allow normal event-path propagation
              return true;
            },

            // Suppress native focus or blur as it's already being fired
            // in leverageNative.
            _default: function () {
              return true;
            },

            delegateType: delegateType
          };
        });

        // Create mouseenter/leave events using mouseover/out and event-time checks
        // so that event delegation works in jQuery.
        // Do the same for pointerenter/pointerleave and pointerover/pointerout
        //
        // Support: Safari 7 only
        // Safari sends mouseenter too often; see:
        // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
        // for the description of the bug (it existed in older Chrome versions as well).
        jQuery.each(
          {
            mouseenter: 'mouseover',
            mouseleave: 'mouseout',
            pointerenter: 'pointerover',
            pointerleave: 'pointerout'
          },
          function (orig, fix) {
            jQuery.event.special[orig] = {
              delegateType: fix,
              bindType: fix,

              handle: function (event) {
                var ret,
                  target = this,
                  related = event.relatedTarget,
                  handleObj = event.handleObj;

                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || (related !== target && !jQuery.contains(target, related))) {
                  event.type = handleObj.origType;
                  ret = handleObj.handler.apply(this, arguments);
                  event.type = fix;
                }
                return ret;
              }
            };
          }
        );

        jQuery.fn.extend({
          on: function (types, selector, data, fn) {
            return on(this, types, selector, data, fn);
          },
          one: function (types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
          },
          off: function (types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
              // ( event )  dispatched jQuery.Event
              handleObj = types.handleObj;
              jQuery(types.delegateTarget).off(
                handleObj.namespace ? handleObj.origType + '.' + handleObj.namespace : handleObj.origType,
                handleObj.selector,
                handleObj.handler
              );
              return this;
            }
            if (typeof types === 'object') {
              // ( types-object [, selector] )
              for (type in types) {
                this.off(type, selector, types[type]);
              }
              return this;
            }
            if (selector === false || typeof selector === 'function') {
              // ( types [, fn] )
              fn = selector;
              selector = undefined;
            }
            if (fn === false) {
              fn = returnFalse;
            }
            return this.each(function () {
              jQuery.event.remove(this, types, fn, selector);
            });
          }
        });

        var // Support: IE <=10 - 11, Edge 12 - 13 only
          // In IE/Edge using regex groups here causes severe slowdowns.
          // See https://connect.microsoft.com/IE/feedback/details/1736512/
          rnoInnerhtml = /<script|<style|<link/i,
          // checked="checked" or checked
          rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
          rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

        // Prefer a tbody over its parent table for containing new rows
        function manipulationTarget(elem, content) {
          if (nodeName(elem, 'table') && nodeName(content.nodeType !== 11 ? content : content.firstChild, 'tr')) {
            return jQuery(elem).children('tbody')[0] || elem;
          }

          return elem;
        }

        // Replace/restore the type attribute of script elements for safe DOM manipulation
        function disableScript(elem) {
          elem.type = (elem.getAttribute('type') !== null) + '/' + elem.type;
          return elem;
        }
        function restoreScript(elem) {
          if ((elem.type || '').slice(0, 5) === 'true/') {
            elem.type = elem.type.slice(5);
          } else {
            elem.removeAttribute('type');
          }

          return elem;
        }

        function cloneCopyEvent(src, dest) {
          var i, l, type, pdataOld, udataOld, udataCur, events;

          if (dest.nodeType !== 1) {
            return;
          }

          // 1. Copy private data: events, handlers, etc.
          if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;

            if (events) {
              dataPriv.remove(dest, 'handle events');

              for (type in events) {
                for (i = 0, l = events[type].length; i < l; i++) {
                  jQuery.event.add(dest, type, events[type][i]);
                }
              }
            }
          }

          // 2. Copy user data
          if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);

            dataUser.set(dest, udataCur);
          }
        }

        // Fix IE bugs, see support tests
        function fixInput(src, dest) {
          var nodeName = dest.nodeName.toLowerCase();

          // Fails to persist the checked state of a cloned checkbox or radio button.
          if (nodeName === 'input' && rcheckableType.test(src.type)) {
            dest.checked = src.checked;

            // Fails to return the selected option to the default selected state when cloning options
          } else if (nodeName === 'input' || nodeName === 'textarea') {
            dest.defaultValue = src.defaultValue;
          }
        }

        function domManip(collection, args, callback, ignored) {
          // Flatten any nested arrays
          args = flat(args);

          var fragment,
            first,
            scripts,
            hasScripts,
            node,
            doc,
            i = 0,
            l = collection.length,
            iNoClone = l - 1,
            value = args[0],
            valueIsFunction = isFunction(value);

          // We can't cloneNode fragments that contain checked, in WebKit
          if (valueIsFunction || (l > 1 && typeof value === 'string' && !support.checkClone && rchecked.test(value))) {
            return collection.each(function (index) {
              var self = collection.eq(index);
              if (valueIsFunction) {
                args[0] = value.call(this, index, self.html());
              }
              domManip(self, args, callback, ignored);
            });
          }

          if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;

            if (fragment.childNodes.length === 1) {
              fragment = first;
            }

            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
              scripts = jQuery.map(getAll(fragment, 'script'), disableScript);
              hasScripts = scripts.length;

              // Use the original fragment for the last item
              // instead of the first because it can end up
              // being emptied incorrectly in certain situations (#8070).
              for (; i < l; i++) {
                node = fragment;

                if (i !== iNoClone) {
                  node = jQuery.clone(node, true, true);

                  // Keep references to cloned scripts for later restoration
                  if (hasScripts) {
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(scripts, getAll(node, 'script'));
                  }
                }

                callback.call(collection[i], node, i);
              }

              if (hasScripts) {
                doc = scripts[scripts.length - 1].ownerDocument;

                // Reenable scripts
                jQuery.map(scripts, restoreScript);

                // Evaluate executable scripts on first document insertion
                for (i = 0; i < hasScripts; i++) {
                  node = scripts[i];
                  if (
                    rscriptType.test(node.type || '') &&
                    !dataPriv.access(node, 'globalEval') &&
                    jQuery.contains(doc, node)
                  ) {
                    if (node.src && (node.type || '').toLowerCase() !== 'module') {
                      // Optional AJAX dependency, but won't run scripts if not present
                      if (jQuery._evalUrl && !node.noModule) {
                        jQuery._evalUrl(
                          node.src,
                          {
                            nonce: node.nonce || node.getAttribute('nonce')
                          },
                          doc
                        );
                      }
                    } else {
                      DOMEval(node.textContent.replace(rcleanScript, ''), node, doc);
                    }
                  }
                }
              }
            }
          }

          return collection;
        }

        function remove(elem, selector, keepData) {
          var node,
            nodes = selector ? jQuery.filter(selector, elem) : elem,
            i = 0;

          for (; (node = nodes[i]) != null; i++) {
            if (!keepData && node.nodeType === 1) {
              jQuery.cleanData(getAll(node));
            }

            if (node.parentNode) {
              if (keepData && isAttached(node)) {
                setGlobalEval(getAll(node, 'script'));
              }
              node.parentNode.removeChild(node);
            }
          }

          return elem;
        }

        jQuery.extend({
          htmlPrefilter: function (html) {
            return html;
          },

          clone: function (elem, dataAndEvents, deepDataAndEvents) {
            var i,
              l,
              srcElements,
              destElements,
              clone = elem.cloneNode(true),
              inPage = isAttached(elem);

            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
              // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
              destElements = getAll(clone);
              srcElements = getAll(elem);

              for (i = 0, l = srcElements.length; i < l; i++) {
                fixInput(srcElements[i], destElements[i]);
              }
            }

            // Copy the events from the original to the clone
            if (dataAndEvents) {
              if (deepDataAndEvents) {
                srcElements = srcElements || getAll(elem);
                destElements = destElements || getAll(clone);

                for (i = 0, l = srcElements.length; i < l; i++) {
                  cloneCopyEvent(srcElements[i], destElements[i]);
                }
              } else {
                cloneCopyEvent(elem, clone);
              }
            }

            // Preserve script evaluation history
            destElements = getAll(clone, 'script');
            if (destElements.length > 0) {
              setGlobalEval(destElements, !inPage && getAll(elem, 'script'));
            }

            // Return the cloned set
            return clone;
          },

          cleanData: function (elems) {
            var data,
              elem,
              type,
              special = jQuery.event.special,
              i = 0;

            for (; (elem = elems[i]) !== undefined; i++) {
              if (acceptData(elem)) {
                if ((data = elem[dataPriv.expando])) {
                  if (data.events) {
                    for (type in data.events) {
                      if (special[type]) {
                        jQuery.event.remove(elem, type);

                        // This is a shortcut to avoid jQuery.event.remove's overhead
                      } else {
                        jQuery.removeEvent(elem, type, data.handle);
                      }
                    }
                  }

                  // Support: Chrome <=35 - 45+
                  // Assign undefined instead of using delete, see Data#remove
                  elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) {
                  // Support: Chrome <=35 - 45+
                  // Assign undefined instead of using delete, see Data#remove
                  elem[dataUser.expando] = undefined;
                }
              }
            }
          }
        });

        jQuery.fn.extend({
          detach: function (selector) {
            return remove(this, selector, true);
          },

          remove: function (selector) {
            return remove(this, selector);
          },

          text: function (value) {
            return access(
              this,
              function (value) {
                return value === undefined
                  ? jQuery.text(this)
                  : this.empty().each(function () {
                      if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                        this.textContent = value;
                      }
                    });
              },
              null,
              value,
              arguments.length
            );
          },

          append: function () {
            return domManip(this, arguments, function (elem) {
              if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                var target = manipulationTarget(this, elem);
                target.appendChild(elem);
              }
            });
          },

          prepend: function () {
            return domManip(this, arguments, function (elem) {
              if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                var target = manipulationTarget(this, elem);
                target.insertBefore(elem, target.firstChild);
              }
            });
          },

          before: function () {
            return domManip(this, arguments, function (elem) {
              if (this.parentNode) {
                this.parentNode.insertBefore(elem, this);
              }
            });
          },

          after: function () {
            return domManip(this, arguments, function (elem) {
              if (this.parentNode) {
                this.parentNode.insertBefore(elem, this.nextSibling);
              }
            });
          },

          empty: function () {
            var elem,
              i = 0;

            for (; (elem = this[i]) != null; i++) {
              if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));

                // Remove any remaining nodes
                elem.textContent = '';
              }
            }

            return this;
          },

          clone: function (dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

            return this.map(function () {
              return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
          },

          html: function (value) {
            return access(
              this,
              function (value) {
                var elem = this[0] || {},
                  i = 0,
                  l = this.length;

                if (value === undefined && elem.nodeType === 1) {
                  return elem.innerHTML;
                }

                // See if we can take a shortcut and just use innerHTML
                if (
                  typeof value === 'string' &&
                  !rnoInnerhtml.test(value) &&
                  !wrapMap[(rtagName.exec(value) || ['', ''])[1].toLowerCase()]
                ) {
                  value = jQuery.htmlPrefilter(value);

                  try {
                    for (; i < l; i++) {
                      elem = this[i] || {};

                      // Remove element nodes and prevent memory leaks
                      if (elem.nodeType === 1) {
                        jQuery.cleanData(getAll(elem, false));
                        elem.innerHTML = value;
                      }
                    }

                    elem = 0;

                    // If using innerHTML throws an exception, use the fallback method
                  } catch (e) {}
                }

                if (elem) {
                  this.empty().append(value);
                }
              },
              null,
              value,
              arguments.length
            );
          },

          replaceWith: function () {
            var ignored = [];

            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(
              this,
              arguments,
              function (elem) {
                var parent = this.parentNode;

                if (jQuery.inArray(this, ignored) < 0) {
                  jQuery.cleanData(getAll(this));
                  if (parent) {
                    parent.replaceChild(elem, this);
                  }
                }

                // Force callback invocation
              },
              ignored
            );
          }
        });

        jQuery.each(
          {
            appendTo: 'append',
            prependTo: 'prepend',
            insertBefore: 'before',
            insertAfter: 'after',
            replaceAll: 'replaceWith'
          },
          function (name, original) {
            jQuery.fn[name] = function (selector) {
              var elems,
                ret = [],
                insert = jQuery(selector),
                last = insert.length - 1,
                i = 0;

              for (; i <= last; i++) {
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);

                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
              }

              return this.pushStack(ret);
            };
          }
        );
        var rnumnonpx = new RegExp('^(' + pnum + ')(?!px)[a-z%]+$', 'i');

        var getStyles = function (elem) {
          // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
          // IE throws on elements created in popups
          // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
          var view = elem.ownerDocument.defaultView;

          if (!view || !view.opener) {
            view = window;
          }

          return view.getComputedStyle(elem);
        };

        var swap = function (elem, options, callback) {
          var ret,
            name,
            old = {};

          // Remember the old values, and insert the new ones
          for (name in options) {
            old[name] = elem.style[name];
            elem.style[name] = options[name];
          }

          ret = callback.call(elem);

          // Revert the old values
          for (name in options) {
            elem.style[name] = old[name];
          }

          return ret;
        };

        var rboxStyle = new RegExp(cssExpand.join('|'), 'i');

        (function () {
          // Executing both pixelPosition & boxSizingReliable tests require only one layout
          // so they're executed at the same time to save the second computation.
          function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) {
              return;
            }

            container.style.cssText =
              'position:absolute;left:-11111px;width:60px;' + 'margin-top:1px;padding:0;border:0';
            div.style.cssText =
              'position:relative;display:block;box-sizing:border-box;overflow:scroll;' +
              'margin:auto;border:1px;padding:1px;' +
              'width:60%;top:1%';
            documentElement.appendChild(container).appendChild(div);

            var divStyle = window.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== '1%';

            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;

            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = '60%';
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;

            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;

            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = 'absolute';
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;

            documentElement.removeChild(container);

            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
          }

          function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
          }

          var pixelPositionVal,
            boxSizingReliableVal,
            scrollboxSizeVal,
            pixelBoxStylesVal,
            reliableTrDimensionsVal,
            reliableMarginLeftVal,
            container = document.createElement('div'),
            div = document.createElement('div');

          // Finish early in limited (non-browser) environments
          if (!div.style) {
            return;
          }

          // Support: IE <=9 - 11 only
          // Style of cloned element affects source element cloned (#8908)
          div.style.backgroundClip = 'content-box';
          div.cloneNode(true).style.backgroundClip = '';
          support.clearCloneStyle = div.style.backgroundClip === 'content-box';

          jQuery.extend(support, {
            boxSizingReliable: function () {
              computeStyleTests();
              return boxSizingReliableVal;
            },
            pixelBoxStyles: function () {
              computeStyleTests();
              return pixelBoxStylesVal;
            },
            pixelPosition: function () {
              computeStyleTests();
              return pixelPositionVal;
            },
            reliableMarginLeft: function () {
              computeStyleTests();
              return reliableMarginLeftVal;
            },
            scrollboxSize: function () {
              computeStyleTests();
              return scrollboxSizeVal;
            },

            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function () {
              var table, tr, trChild, trStyle;
              if (reliableTrDimensionsVal == null) {
                table = document.createElement('table');
                tr = document.createElement('tr');
                trChild = document.createElement('div');

                table.style.cssText = 'position:absolute;left:-11111px;border-collapse:separate';
                tr.style.cssText = 'border:1px solid';

                // Support: Chrome 86+
                // Height set through cssText does not get applied.
                // Computed height then comes back as 0.
                tr.style.height = '1px';
                trChild.style.height = '9px';

                // Support: Android 8 Chrome 86+
                // In our bodyBackground.html iframe,
                // display for all div elements is set to "inline",
                // which causes a problem only in Android 8 Chrome 86.
                // Ensuring the div is display: block
                // gets around this issue.
                trChild.style.display = 'block';

                documentElement.appendChild(table).appendChild(tr).appendChild(trChild);

                trStyle = window.getComputedStyle(tr);
                reliableTrDimensionsVal =
                  parseInt(trStyle.height, 10) +
                    parseInt(trStyle.borderTopWidth, 10) +
                    parseInt(trStyle.borderBottomWidth, 10) ===
                  tr.offsetHeight;

                documentElement.removeChild(table);
              }
              return reliableTrDimensionsVal;
            }
          });
        })();

        function curCSS(elem, name, computed) {
          var width,
            minWidth,
            maxWidth,
            ret,
            // Support: Firefox 51+
            // Retrieving style before computed somehow
            // fixes an issue with getting wrong values
            // on detached elements
            style = elem.style;

          computed = computed || getStyles(elem);

          // getPropertyValue is needed for:
          //   .css('filter') (IE 9 only, #12537)
          //   .css('--customProperty) (#3144)
          if (computed) {
            ret = computed.getPropertyValue(name) || computed[name];

            if (ret === '' && !isAttached(elem)) {
              ret = jQuery.style(elem, name);
            }

            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
              // Remember the original values
              width = style.width;
              minWidth = style.minWidth;
              maxWidth = style.maxWidth;

              // Put in the new values to get a computed value out
              style.minWidth = style.maxWidth = style.width = ret;
              ret = computed.width;

              // Revert the changed values
              style.width = width;
              style.minWidth = minWidth;
              style.maxWidth = maxWidth;
            }
          }

          return ret !== undefined
            ? // Support: IE <=9 - 11 only
              // IE returns zIndex value as an integer.
              ret + ''
            : ret;
        }

        function addGetHookIf(conditionFn, hookFn) {
          // Define the hook, we'll check on the first run if it's really needed.
          return {
            get: function () {
              if (conditionFn()) {
                // Hook not needed (or it's not possible to use it due
                // to missing dependency), remove it.
                delete this.get;
                return;
              }

              // Hook needed; redefine it so that the support test is not executed again.
              return (this.get = hookFn).apply(this, arguments);
            }
          };
        }

        var cssPrefixes = ['Webkit', 'Moz', 'ms'],
          emptyStyle = document.createElement('div').style,
          vendorProps = {};

        // Return a vendor-prefixed property or undefined
        function vendorPropName(name) {
          // Check for vendor prefixed names
          var capName = name[0].toUpperCase() + name.slice(1),
            i = cssPrefixes.length;

          while (i--) {
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) {
              return name;
            }
          }
        }

        // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
        function finalPropName(name) {
          var final = jQuery.cssProps[name] || vendorProps[name];

          if (final) {
            return final;
          }
          if (name in emptyStyle) {
            return name;
          }
          return (vendorProps[name] = vendorPropName(name) || name);
        }

        var // Swappable if display is none or starts with table
          // except "table", "table-cell", or "table-caption"
          // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
          rdisplayswap = /^(none|table(?!-c[ea]).+)/,
          rcustomProp = /^--/,
          cssShow = { position: 'absolute', visibility: 'hidden', display: 'block' },
          cssNormalTransform = {
            letterSpacing: '0',
            fontWeight: '400'
          };

        function setPositiveNumber(_elem, value, subtract) {
          // Any relative (+/-) values have already been
          // normalized at this point
          var matches = rcssNum.exec(value);
          return matches
            ? // Guard against undefined "subtract", e.g., when used as in cssHooks
              Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || 'px')
            : value;
        }

        function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
          var i = dimension === 'width' ? 1 : 0,
            extra = 0,
            delta = 0;

          // Adjustment may not be necessary
          if (box === (isBorderBox ? 'border' : 'content')) {
            return 0;
          }

          for (; i < 4; i += 2) {
            // Both box models exclude margin
            if (box === 'margin') {
              delta += jQuery.css(elem, box + cssExpand[i], true, styles);
            }

            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
              // Add padding
              delta += jQuery.css(elem, 'padding' + cssExpand[i], true, styles);

              // For "border" or "margin", add border
              if (box !== 'padding') {
                delta += jQuery.css(elem, 'border' + cssExpand[i] + 'Width', true, styles);

                // But still keep track of it otherwise
              } else {
                extra += jQuery.css(elem, 'border' + cssExpand[i] + 'Width', true, styles);
              }

              // If we get here with a border-box (content + padding + border), we're seeking "content" or
              // "padding" or "margin"
            } else {
              // For "content", subtract padding
              if (box === 'content') {
                delta -= jQuery.css(elem, 'padding' + cssExpand[i], true, styles);
              }

              // For "content" or "padding", subtract border
              if (box !== 'margin') {
                delta -= jQuery.css(elem, 'border' + cssExpand[i] + 'Width', true, styles);
              }
            }
          }

          // Account for positive content-box scroll gutter when requested by providing computedVal
          if (!isBorderBox && computedVal >= 0) {
            // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
            // Assuming integer scroll gutter, subtract the rest and round down
            delta +=
              Math.max(
                0,
                Math.ceil(
                  elem['offset' + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5

                  // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
                  // Use an explicit zero to avoid NaN (gh-3964)
                )
              ) || 0;
          }

          return delta;
        }

        function getWidthOrHeight(elem, dimension, extra) {
          // Start with computed style
          var styles = getStyles(elem),
            // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
            // Fake content-box until we know it's needed to know the true value.
            boxSizingNeeded = !support.boxSizingReliable() || extra,
            isBorderBox = boxSizingNeeded && jQuery.css(elem, 'boxSizing', false, styles) === 'border-box',
            valueIsBorderBox = isBorderBox,
            val = curCSS(elem, dimension, styles),
            offsetProp = 'offset' + dimension[0].toUpperCase() + dimension.slice(1);

          // Support: Firefox <=54
          // Return a confounding non-pixel value or feign ignorance, as appropriate.
          if (rnumnonpx.test(val)) {
            if (!extra) {
              return val;
            }
            val = 'auto';
          }

          // Support: IE 9 - 11 only
          // Use offsetWidth/offsetHeight for when box sizing is unreliable.
          // In those cases, the computed value can be trusted to be border-box.
          if (
            ((!support.boxSizingReliable() && isBorderBox) ||
              // Support: IE 10 - 11+, Edge 15 - 18+
              // IE/Edge misreport `getComputedStyle` of table rows with width/height
              // set in CSS while `offset*` properties report correct values.
              // Interestingly, in some cases IE 9 doesn't suffer from this issue.
              (!support.reliableTrDimensions() && nodeName(elem, 'tr')) ||
              // Fall back to offsetWidth/offsetHeight when value is "auto"
              // This happens for inline elements with no explicit setting (gh-3571)
              val === 'auto' ||
              // Support: Android <=4.1 - 4.3 only
              // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
              (!parseFloat(val) && jQuery.css(elem, 'display', false, styles) === 'inline')) &&
            // Make sure the element is visible & connected
            elem.getClientRects().length
          ) {
            isBorderBox = jQuery.css(elem, 'boxSizing', false, styles) === 'border-box';

            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) {
              val = elem[offsetProp];
            }
          }

          // Normalize "" and auto
          val = parseFloat(val) || 0;

          // Adjust for the element's box model
          return (
            val +
            boxModelAdjustment(
              elem,
              dimension,
              extra || (isBorderBox ? 'border' : 'content'),
              valueIsBorderBox,
              styles,

              // Provide the current computed size to request scroll gutter calculation (gh-3589)
              val
            ) +
            'px'
          );
        }

        jQuery.extend({
          // Add in style property hooks for overriding the default
          // behavior of getting and setting a style property
          cssHooks: {
            opacity: {
              get: function (elem, computed) {
                if (computed) {
                  // We should always get a number back from opacity
                  var ret = curCSS(elem, 'opacity');
                  return ret === '' ? '1' : ret;
                }
              }
            }
          },

          // Don't automatically add "px" to these possibly-unitless properties
          cssNumber: {
            animationIterationCount: true,
            columnCount: true,
            fillOpacity: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            widows: true,
            zIndex: true,
            zoom: true
          },

          // Add in properties whose names you wish to fix before
          // setting or getting the value
          cssProps: {},

          // Get and set the style property on a DOM Node
          style: function (elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
              return;
            }

            // Make sure that we're working with the right name
            var ret,
              type,
              hooks,
              origName = camelCase(name),
              isCustomProp = rcustomProp.test(name),
              style = elem.style;

            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) {
              name = finalPropName(origName);
            }

            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

            // Check if we're setting a value
            if (value !== undefined) {
              type = typeof value;

              // Convert "+=" or "-=" to relative numbers (#7345)
              if (type === 'string' && (ret = rcssNum.exec(value)) && ret[1]) {
                value = adjustCSS(elem, name, ret);

                // Fixes bug #9237
                type = 'number';
              }

              // Make sure that null and NaN values aren't set (#7116)
              if (value == null || value !== value) {
                return;
              }

              // If a number was passed in, add the unit (except for certain CSS properties)
              // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
              // "px" to a few hardcoded values.
              if (type === 'number' && !isCustomProp) {
                value += (ret && ret[3]) || (jQuery.cssNumber[origName] ? '' : 'px');
              }

              // background-* props affect original clone's values
              if (!support.clearCloneStyle && value === '' && name.indexOf('background') === 0) {
                style[name] = 'inherit';
              }

              // If a hook was provided, use that value, otherwise just set the specified value
              if (!hooks || !('set' in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                if (isCustomProp) {
                  style.setProperty(name, value);
                } else {
                  style[name] = value;
                }
              }
            } else {
              // If a hook was provided get the non-computed value from there
              if (hooks && 'get' in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) {
                return ret;
              }

              // Otherwise just get the value from the style object
              return style[name];
            }
          },

          css: function (elem, name, extra, styles) {
            var val,
              num,
              hooks,
              origName = camelCase(name),
              isCustomProp = rcustomProp.test(name);

            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) {
              name = finalPropName(origName);
            }

            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

            // If a hook was provided get the computed value from there
            if (hooks && 'get' in hooks) {
              val = hooks.get(elem, true, extra);
            }

            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) {
              val = curCSS(elem, name, styles);
            }

            // Convert "normal" to computed value
            if (val === 'normal' && name in cssNormalTransform) {
              val = cssNormalTransform[name];
            }

            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === '' || extra) {
              num = parseFloat(val);
              return extra === true || isFinite(num) ? num || 0 : val;
            }

            return val;
          }
        });

        jQuery.each(['height', 'width'], function (_i, dimension) {
          jQuery.cssHooks[dimension] = {
            get: function (elem, computed, extra) {
              if (computed) {
                // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, 'display')) &&
                  // Support: Safari 8+
                  // Table columns in Safari have non-zero offsetWidth & zero
                  // getBoundingClientRect().width unless display is changed.
                  // Support: IE <=11 only
                  // Running getBoundingClientRect on a disconnected node
                  // in IE throws an error.
                  (!elem.getClientRects().length || !elem.getBoundingClientRect().width)
                  ? swap(elem, cssShow, function () {
                      return getWidthOrHeight(elem, dimension, extra);
                    })
                  : getWidthOrHeight(elem, dimension, extra);
              }
            },

            set: function (elem, value, extra) {
              var matches,
                styles = getStyles(elem),
                // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === 'absolute',
                // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra,
                isBorderBox = boxSizingNeeded && jQuery.css(elem, 'boxSizing', false, styles) === 'border-box',
                subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;

              // Account for unreliable border-box dimensions by comparing offset* to computed and
              // faking a content-box to get border and padding (gh-3699)
              if (isBorderBox && scrollboxSizeBuggy) {
                subtract -= Math.ceil(
                  elem['offset' + dimension[0].toUpperCase() + dimension.slice(1)] -
                    parseFloat(styles[dimension]) -
                    boxModelAdjustment(elem, dimension, 'border', false, styles) -
                    0.5
                );
              }

              // Convert to pixels if value adjustment is needed
              if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || 'px') !== 'px') {
                elem.style[dimension] = value;
                value = jQuery.css(elem, dimension);
              }

              return setPositiveNumber(elem, value, subtract);
            }
          };
        });

        jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function (elem, computed) {
          if (computed) {
            return (
              (parseFloat(curCSS(elem, 'marginLeft')) ||
                elem.getBoundingClientRect().left -
                  swap(elem, { marginLeft: 0 }, function () {
                    return elem.getBoundingClientRect().left;
                  })) + 'px'
            );
          }
        });

        // These hooks are used by animate to expand properties
        jQuery.each(
          {
            margin: '',
            padding: '',
            border: 'Width'
          },
          function (prefix, suffix) {
            jQuery.cssHooks[prefix + suffix] = {
              expand: function (value) {
                var i = 0,
                  expanded = {},
                  // Assumes a single number if not a string
                  parts = typeof value === 'string' ? value.split(' ') : [value];

                for (; i < 4; i++) {
                  expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                }

                return expanded;
              }
            };

            if (prefix !== 'margin') {
              jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
            }
          }
        );

        jQuery.fn.extend({
          css: function (name, value) {
            return access(
              this,
              function (elem, name, value) {
                var styles,
                  len,
                  map = {},
                  i = 0;

                if (Array.isArray(name)) {
                  styles = getStyles(elem);
                  len = name.length;

                  for (; i < len; i++) {
                    map[name[i]] = jQuery.css(elem, name[i], false, styles);
                  }

                  return map;
                }

                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
              },
              name,
              value,
              arguments.length > 1
            );
          }
        });

        function Tween(elem, options, prop, end, easing) {
          return new Tween.prototype.init(elem, options, prop, end, easing);
        }
        jQuery.Tween = Tween;

        Tween.prototype = {
          constructor: Tween,
          init: function (elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? '' : 'px');
          },
          cur: function () {
            var hooks = Tween.propHooks[this.prop];

            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
          },
          run: function (percent) {
            var eased,
              hooks = Tween.propHooks[this.prop];

            if (this.options.duration) {
              this.pos = eased = jQuery.easing[this.easing](
                percent,
                this.options.duration * percent,
                0,
                1,
                this.options.duration
              );
            } else {
              this.pos = eased = percent;
            }
            this.now = (this.end - this.start) * eased + this.start;

            if (this.options.step) {
              this.options.step.call(this.elem, this.now, this);
            }

            if (hooks && hooks.set) {
              hooks.set(this);
            } else {
              Tween.propHooks._default.set(this);
            }
            return this;
          }
        };

        Tween.prototype.init.prototype = Tween.prototype;

        Tween.propHooks = {
          _default: {
            get: function (tween) {
              var result;

              // Use a property on the element directly when it is not a DOM element,
              // or when there is no matching style property that exists.
              if (
                tween.elem.nodeType !== 1 ||
                (tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null)
              ) {
                return tween.elem[tween.prop];
              }

              // Passing an empty string as a 3rd parameter to .css will automatically
              // attempt a parseFloat and fallback to a string if the parse fails.
              // Simple values such as "10px" are parsed to Float;
              // complex values such as "rotate(1rad)" are returned as-is.
              result = jQuery.css(tween.elem, tween.prop, '');

              // Empty strings, null, undefined and "auto" are converted to 0.
              return !result || result === 'auto' ? 0 : result;
            },
            set: function (tween) {
              // Use step hook for back compat.
              // Use cssHook if its there.
              // Use .style if available and use plain properties where available.
              if (jQuery.fx.step[tween.prop]) {
                jQuery.fx.step[tween.prop](tween);
              } else if (
                tween.elem.nodeType === 1 &&
                (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)
              ) {
                jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
              } else {
                tween.elem[tween.prop] = tween.now;
              }
            }
          }
        };

        // Support: IE <=9 only
        // Panic based approach to setting things on disconnected nodes
        Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
          set: function (tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) {
              tween.elem[tween.prop] = tween.now;
            }
          }
        };

        jQuery.easing = {
          linear: function (p) {
            return p;
          },
          swing: function (p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
          },
          _default: 'swing'
        };

        jQuery.fx = Tween.prototype.init;

        // Back compat <1.8 extension point
        jQuery.fx.step = {};

        var fxNow,
          inProgress,
          rfxtypes = /^(?:toggle|show|hide)$/,
          rrun = /queueHooks$/;

        function schedule() {
          if (inProgress) {
            if (document.hidden === false && window.requestAnimationFrame) {
              window.requestAnimationFrame(schedule);
            } else {
              window.setTimeout(schedule, jQuery.fx.interval);
            }

            jQuery.fx.tick();
          }
        }

        // Animations created synchronously will run synchronously
        function createFxNow() {
          window.setTimeout(function () {
            fxNow = undefined;
          });
          return (fxNow = Date.now());
        }

        // Generate parameters to create a standard animation
        function genFx(type, includeWidth) {
          var which,
            i = 0,
            attrs = { height: type };

          // If we include width, step value is 1 to do all cssExpand values,
          // otherwise step value is 2 to skip over Left and Right
          includeWidth = includeWidth ? 1 : 0;
          for (; i < 4; i += 2 - includeWidth) {
            which = cssExpand[i];
            attrs['margin' + which] = attrs['padding' + which] = type;
          }

          if (includeWidth) {
            attrs.opacity = attrs.width = type;
          }

          return attrs;
        }

        function createTween(value, prop, animation) {
          var tween,
            collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners['*']),
            index = 0,
            length = collection.length;
          for (; index < length; index++) {
            if ((tween = collection[index].call(animation, prop, value))) {
              // We're done with this property
              return tween;
            }
          }
        }

        function defaultPrefilter(elem, props, opts) {
          var prop,
            value,
            toggle,
            hooks,
            oldfire,
            propTween,
            restoreDisplay,
            display,
            isBox = 'width' in props || 'height' in props,
            anim = this,
            orig = {},
            style = elem.style,
            hidden = elem.nodeType && isHiddenWithinTree(elem),
            dataShow = dataPriv.get(elem, 'fxshow');

          // Queue-skipping animations hijack the fx hooks
          if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, 'fx');
            if (hooks.unqueued == null) {
              hooks.unqueued = 0;
              oldfire = hooks.empty.fire;
              hooks.empty.fire = function () {
                if (!hooks.unqueued) {
                  oldfire();
                }
              };
            }
            hooks.unqueued++;

            anim.always(function () {
              // Ensure the complete handler is called before this completes
              anim.always(function () {
                hooks.unqueued--;
                if (!jQuery.queue(elem, 'fx').length) {
                  hooks.empty.fire();
                }
              });
            });
          }

          // Detect show/hide animations
          for (prop in props) {
            value = props[prop];
            if (rfxtypes.test(value)) {
              delete props[prop];
              toggle = toggle || value === 'toggle';
              if (value === (hidden ? 'hide' : 'show')) {
                // Pretend to be hidden if this is a "show" and
                // there is still data from a stopped show/hide
                if (value === 'show' && dataShow && dataShow[prop] !== undefined) {
                  hidden = true;

                  // Ignore all other no-op show/hide data
                } else {
                  continue;
                }
              }
              orig[prop] = (dataShow && dataShow[prop]) || jQuery.style(elem, prop);
            }
          }

          // Bail out if this is a no-op like .hide().hide()
          propTween = !jQuery.isEmptyObject(props);
          if (!propTween && jQuery.isEmptyObject(orig)) {
            return;
          }

          // Restrict "overflow" and "display" styles during box animations
          if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [style.overflow, style.overflowX, style.overflowY];

            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) {
              restoreDisplay = dataPriv.get(elem, 'display');
            }
            display = jQuery.css(elem, 'display');
            if (display === 'none') {
              if (restoreDisplay) {
                display = restoreDisplay;
              } else {
                // Get nonempty value(s) by temporarily forcing visibility
                showHide([elem], true);
                restoreDisplay = elem.style.display || restoreDisplay;
                display = jQuery.css(elem, 'display');
                showHide([elem]);
              }
            }

            // Animate inline elements as inline-block
            if (display === 'inline' || (display === 'inline-block' && restoreDisplay != null)) {
              if (jQuery.css(elem, 'float') === 'none') {
                // Restore the original display value at the end of pure show/hide animations
                if (!propTween) {
                  anim.done(function () {
                    style.display = restoreDisplay;
                  });
                  if (restoreDisplay == null) {
                    display = style.display;
                    restoreDisplay = display === 'none' ? '' : display;
                  }
                }
                style.display = 'inline-block';
              }
            }
          }

          if (opts.overflow) {
            style.overflow = 'hidden';
            anim.always(function () {
              style.overflow = opts.overflow[0];
              style.overflowX = opts.overflow[1];
              style.overflowY = opts.overflow[2];
            });
          }

          // Implement show/hide animations
          propTween = false;
          for (prop in orig) {
            // General show/hide setup for this element animation
            if (!propTween) {
              if (dataShow) {
                if ('hidden' in dataShow) {
                  hidden = dataShow.hidden;
                }
              } else {
                dataShow = dataPriv.access(elem, 'fxshow', { display: restoreDisplay });
              }

              // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
              if (toggle) {
                dataShow.hidden = !hidden;
              }

              // Show elements before animating them
              if (hidden) {
                showHide([elem], true);
              }

              /* eslint-disable no-loop-func */

              anim.done(function () {
                /* eslint-enable no-loop-func */

                // The final step of a "hide" animation is actually hiding the element
                if (!hidden) {
                  showHide([elem]);
                }
                dataPriv.remove(elem, 'fxshow');
                for (prop in orig) {
                  jQuery.style(elem, prop, orig[prop]);
                }
              });
            }

            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
              dataShow[prop] = propTween.start;
              if (hidden) {
                propTween.end = propTween.start;
                propTween.start = 0;
              }
            }
          }
        }

        function propFilter(props, specialEasing) {
          var index, name, easing, value, hooks;

          // camelCase, specialEasing and expand cssHook pass
          for (index in props) {
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
              easing = value[1];
              value = props[index] = value[0];
            }

            if (index !== name) {
              props[name] = value;
              delete props[index];
            }

            hooks = jQuery.cssHooks[name];
            if (hooks && 'expand' in hooks) {
              value = hooks.expand(value);
              delete props[name];

              // Not quite $.extend, this won't overwrite existing keys.
              // Reusing 'index' because we have the correct "name"
              for (index in value) {
                if (!(index in props)) {
                  props[index] = value[index];
                  specialEasing[index] = easing;
                }
              }
            } else {
              specialEasing[name] = easing;
            }
          }
        }

        function Animation(elem, properties, options) {
          var result,
            stopped,
            index = 0,
            length = Animation.prefilters.length,
            deferred = jQuery.Deferred().always(function () {
              // Don't match elem in the :animated selector
              delete tick.elem;
            }),
            tick = function () {
              if (stopped) {
                return false;
              }
              var currentTime = fxNow || createFxNow(),
                remaining = Math.max(0, animation.startTime + animation.duration - currentTime),
                // Support: Android 2.3 only
                // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
                temp = remaining / animation.duration || 0,
                percent = 1 - temp,
                index = 0,
                length = animation.tweens.length;

              for (; index < length; index++) {
                animation.tweens[index].run(percent);
              }

              deferred.notifyWith(elem, [animation, percent, remaining]);

              // If there's more to do, yield
              if (percent < 1 && length) {
                return remaining;
              }

              // If this was an empty animation, synthesize a final progress notification
              if (!length) {
                deferred.notifyWith(elem, [animation, 1, 0]);
              }

              // Resolve the animation and report its conclusion
              deferred.resolveWith(elem, [animation]);
              return false;
            },
            animation = deferred.promise({
              elem: elem,
              props: jQuery.extend({}, properties),
              opts: jQuery.extend(
                true,
                {
                  specialEasing: {},
                  easing: jQuery.easing._default
                },
                options
              ),
              originalProperties: properties,
              originalOptions: options,
              startTime: fxNow || createFxNow(),
              duration: options.duration,
              tweens: [],
              createTween: function (prop, end) {
                var tween = jQuery.Tween(
                  elem,
                  animation.opts,
                  prop,
                  end,
                  animation.opts.specialEasing[prop] || animation.opts.easing
                );
                animation.tweens.push(tween);
                return tween;
              },
              stop: function (gotoEnd) {
                var index = 0,
                  // If we are going to the end, we want to run all the tweens
                  // otherwise we skip this part
                  length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) {
                  return this;
                }
                stopped = true;
                for (; index < length; index++) {
                  animation.tweens[index].run(1);
                }

                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                  deferred.notifyWith(elem, [animation, 1, 0]);
                  deferred.resolveWith(elem, [animation, gotoEnd]);
                } else {
                  deferred.rejectWith(elem, [animation, gotoEnd]);
                }
                return this;
              }
            }),
            props = animation.props;

          propFilter(props, animation.opts.specialEasing);

          for (; index < length; index++) {
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
              if (isFunction(result.stop)) {
                jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
              }
              return result;
            }
          }

          jQuery.map(props, createTween, animation);

          if (isFunction(animation.opts.start)) {
            animation.opts.start.call(elem, animation);
          }

          // Attach callbacks from options
          animation
            .progress(animation.opts.progress)
            .done(animation.opts.done, animation.opts.complete)
            .fail(animation.opts.fail)
            .always(animation.opts.always);

          jQuery.fx.timer(
            jQuery.extend(tick, {
              elem: elem,
              anim: animation,
              queue: animation.opts.queue
            })
          );

          return animation;
        }

        jQuery.Animation = jQuery.extend(Animation, {
          tweeners: {
            '*': [
              function (prop, value) {
                var tween = this.createTween(prop, value);
                adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                return tween;
              }
            ]
          },

          tweener: function (props, callback) {
            if (isFunction(props)) {
              callback = props;
              props = ['*'];
            } else {
              props = props.match(rnothtmlwhite);
            }

            var prop,
              index = 0,
              length = props.length;

            for (; index < length; index++) {
              prop = props[index];
              Animation.tweeners[prop] = Animation.tweeners[prop] || [];
              Animation.tweeners[prop].unshift(callback);
            }
          },

          prefilters: [defaultPrefilter],

          prefilter: function (callback, prepend) {
            if (prepend) {
              Animation.prefilters.unshift(callback);
            } else {
              Animation.prefilters.push(callback);
            }
          }
        });

        jQuery.speed = function (speed, easing, fn) {
          var opt =
            speed && typeof speed === 'object'
              ? jQuery.extend({}, speed)
              : {
                  complete: fn || (!fn && easing) || (isFunction(speed) && speed),
                  duration: speed,
                  easing: (fn && easing) || (easing && !isFunction(easing) && easing)
                };

          // Go to the end state if fx are off
          if (jQuery.fx.off) {
            opt.duration = 0;
          } else {
            if (typeof opt.duration !== 'number') {
              if (opt.duration in jQuery.fx.speeds) {
                opt.duration = jQuery.fx.speeds[opt.duration];
              } else {
                opt.duration = jQuery.fx.speeds._default;
              }
            }
          }

          // Normalize opt.queue - true/undefined/null -> "fx"
          if (opt.queue == null || opt.queue === true) {
            opt.queue = 'fx';
          }

          // Queueing
          opt.old = opt.complete;

          opt.complete = function () {
            if (isFunction(opt.old)) {
              opt.old.call(this);
            }

            if (opt.queue) {
              jQuery.dequeue(this, opt.queue);
            }
          };

          return opt;
        };

        jQuery.fn.extend({
          fadeTo: function (speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return (
              this.filter(isHiddenWithinTree)
                .css('opacity', 0)
                .show()

                // Animate to the value specified
                .end()
                .animate({ opacity: to }, speed, easing, callback)
            );
          },
          animate: function (prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop),
              optall = jQuery.speed(speed, easing, callback),
              doAnimation = function () {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);

                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, 'finish')) {
                  anim.stop(true);
                }
              };

            doAnimation.finish = doAnimation;

            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
          },
          stop: function (type, clearQueue, gotoEnd) {
            var stopQueue = function (hooks) {
              var stop = hooks.stop;
              delete hooks.stop;
              stop(gotoEnd);
            };

            if (typeof type !== 'string') {
              gotoEnd = clearQueue;
              clearQueue = type;
              type = undefined;
            }
            if (clearQueue) {
              this.queue(type || 'fx', []);
            }

            return this.each(function () {
              var dequeue = true,
                index = type != null && type + 'queueHooks',
                timers = jQuery.timers,
                data = dataPriv.get(this);

              if (index) {
                if (data[index] && data[index].stop) {
                  stopQueue(data[index]);
                }
              } else {
                for (index in data) {
                  if (data[index] && data[index].stop && rrun.test(index)) {
                    stopQueue(data[index]);
                  }
                }
              }

              for (index = timers.length; index--; ) {
                if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                  timers[index].anim.stop(gotoEnd);
                  dequeue = false;
                  timers.splice(index, 1);
                }
              }

              // Start the next in the queue if the last step wasn't forced.
              // Timers currently will call their complete callbacks, which
              // will dequeue but only if they were gotoEnd.
              if (dequeue || !gotoEnd) {
                jQuery.dequeue(this, type);
              }
            });
          },
          finish: function (type) {
            if (type !== false) {
              type = type || 'fx';
            }
            return this.each(function () {
              var index,
                data = dataPriv.get(this),
                queue = data[type + 'queue'],
                hooks = data[type + 'queueHooks'],
                timers = jQuery.timers,
                length = queue ? queue.length : 0;

              // Enable finishing flag on private data
              data.finish = true;

              // Empty the queue first
              jQuery.queue(this, type, []);

              if (hooks && hooks.stop) {
                hooks.stop.call(this, true);
              }

              // Look for any active animations, and finish them
              for (index = timers.length; index--; ) {
                if (timers[index].elem === this && timers[index].queue === type) {
                  timers[index].anim.stop(true);
                  timers.splice(index, 1);
                }
              }

              // Look for any animations in the old queue and finish them
              for (index = 0; index < length; index++) {
                if (queue[index] && queue[index].finish) {
                  queue[index].finish.call(this);
                }
              }

              // Turn off finishing flag
              delete data.finish;
            });
          }
        });

        jQuery.each(['toggle', 'show', 'hide'], function (_i, name) {
          var cssFn = jQuery.fn[name];
          jQuery.fn[name] = function (speed, easing, callback) {
            return speed == null || typeof speed === 'boolean'
              ? cssFn.apply(this, arguments)
              : this.animate(genFx(name, true), speed, easing, callback);
          };
        });

        // Generate shortcuts for custom animations
        jQuery.each(
          {
            slideDown: genFx('show'),
            slideUp: genFx('hide'),
            slideToggle: genFx('toggle'),
            fadeIn: { opacity: 'show' },
            fadeOut: { opacity: 'hide' },
            fadeToggle: { opacity: 'toggle' }
          },
          function (name, props) {
            jQuery.fn[name] = function (speed, easing, callback) {
              return this.animate(props, speed, easing, callback);
            };
          }
        );

        jQuery.timers = [];
        jQuery.fx.tick = function () {
          var timer,
            i = 0,
            timers = jQuery.timers;

          fxNow = Date.now();

          for (; i < timers.length; i++) {
            timer = timers[i];

            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) {
              timers.splice(i--, 1);
            }
          }

          if (!timers.length) {
            jQuery.fx.stop();
          }
          fxNow = undefined;
        };

        jQuery.fx.timer = function (timer) {
          jQuery.timers.push(timer);
          jQuery.fx.start();
        };

        jQuery.fx.interval = 13;
        jQuery.fx.start = function () {
          if (inProgress) {
            return;
          }

          inProgress = true;
          schedule();
        };

        jQuery.fx.stop = function () {
          inProgress = null;
        };

        jQuery.fx.speeds = {
          slow: 600,
          fast: 200,

          // Default speed
          _default: 400
        };

        // Based off of the plugin by Clint Helfers, with permission.
        // https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
        jQuery.fn.delay = function (time, type) {
          time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
          type = type || 'fx';

          return this.queue(type, function (next, hooks) {
            var timeout = window.setTimeout(next, time);
            hooks.stop = function () {
              window.clearTimeout(timeout);
            };
          });
        };

        (function () {
          var input = document.createElement('input'),
            select = document.createElement('select'),
            opt = select.appendChild(document.createElement('option'));

          input.type = 'checkbox';

          // Support: Android <=4.3 only
          // Default value for a checkbox should be "on"
          support.checkOn = input.value !== '';

          // Support: IE <=11 only
          // Must access selectedIndex to make default options select
          support.optSelected = opt.selected;

          // Support: IE <=11 only
          // An input loses its value after becoming a radio
          input = document.createElement('input');
          input.value = 't';
          input.type = 'radio';
          support.radioValue = input.value === 't';
        })();

        var boolHook,
          attrHandle = jQuery.expr.attrHandle;

        jQuery.fn.extend({
          attr: function (name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
          },

          removeAttr: function (name) {
            return this.each(function () {
              jQuery.removeAttr(this, name);
            });
          }
        });

        jQuery.extend({
          attr: function (elem, name, value) {
            var ret,
              hooks,
              nType = elem.nodeType;

            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) {
              return;
            }

            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === 'undefined') {
              return jQuery.prop(elem, name, value);
            }

            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
              hooks =
                jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            }

            if (value !== undefined) {
              if (value === null) {
                jQuery.removeAttr(elem, name);
                return;
              }

              if (hooks && 'set' in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
                return ret;
              }

              elem.setAttribute(name, value + '');
              return value;
            }

            if (hooks && 'get' in hooks && (ret = hooks.get(elem, name)) !== null) {
              return ret;
            }

            ret = jQuery.find.attr(elem, name);

            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
          },

          attrHooks: {
            type: {
              set: function (elem, value) {
                if (!support.radioValue && value === 'radio' && nodeName(elem, 'input')) {
                  var val = elem.value;
                  elem.setAttribute('type', value);
                  if (val) {
                    elem.value = val;
                  }
                  return value;
                }
              }
            }
          },

          removeAttr: function (elem, value) {
            var name,
              i = 0,
              // Attribute names can contain non-HTML whitespace characters
              // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
              attrNames = value && value.match(rnothtmlwhite);

            if (attrNames && elem.nodeType === 1) {
              while ((name = attrNames[i++])) {
                elem.removeAttribute(name);
              }
            }
          }
        });

        // Hooks for boolean attributes
        boolHook = {
          set: function (elem, value, name) {
            if (value === false) {
              // Remove boolean attributes when set to false
              jQuery.removeAttr(elem, name);
            } else {
              elem.setAttribute(name, name);
            }
            return name;
          }
        };

        jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function (_i, name) {
          var getter = attrHandle[name] || jQuery.find.attr;

          attrHandle[name] = function (elem, name, isXML) {
            var ret,
              handle,
              lowercaseName = name.toLowerCase();

            if (!isXML) {
              // Avoid an infinite loop by temporarily removing this function from the getter
              handle = attrHandle[lowercaseName];
              attrHandle[lowercaseName] = ret;
              ret = getter(elem, name, isXML) != null ? lowercaseName : null;
              attrHandle[lowercaseName] = handle;
            }
            return ret;
          };
        });

        var rfocusable = /^(?:input|select|textarea|button)$/i,
          rclickable = /^(?:a|area)$/i;

        jQuery.fn.extend({
          prop: function (name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
          },

          removeProp: function (name) {
            return this.each(function () {
              delete this[jQuery.propFix[name] || name];
            });
          }
        });

        jQuery.extend({
          prop: function (elem, name, value) {
            var ret,
              hooks,
              nType = elem.nodeType;

            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) {
              return;
            }

            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
              // Fix name and attach hooks
              name = jQuery.propFix[name] || name;
              hooks = jQuery.propHooks[name];
            }

            if (value !== undefined) {
              if (hooks && 'set' in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
                return ret;
              }

              return (elem[name] = value);
            }

            if (hooks && 'get' in hooks && (ret = hooks.get(elem, name)) !== null) {
              return ret;
            }

            return elem[name];
          },

          propHooks: {
            tabIndex: {
              get: function (elem) {
                // Support: IE <=9 - 11 only
                // elem.tabIndex doesn't always return the
                // correct value when it hasn't been explicitly set
                // https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
                // Use proper attribute retrieval(#12072)
                var tabindex = jQuery.find.attr(elem, 'tabindex');

                if (tabindex) {
                  return parseInt(tabindex, 10);
                }

                if (rfocusable.test(elem.nodeName) || (rclickable.test(elem.nodeName) && elem.href)) {
                  return 0;
                }

                return -1;
              }
            }
          },

          propFix: {
            for: 'htmlFor',
            class: 'className'
          }
        });

        // Support: IE <=11 only
        // Accessing the selectedIndex property
        // forces the browser to respect setting selected
        // on the option
        // The getter ensures a default option is selected
        // when in an optgroup
        // eslint rule "no-unused-expressions" is disabled for this code
        // since it considers such accessions noop
        if (!support.optSelected) {
          jQuery.propHooks.selected = {
            get: function (elem) {
              /* eslint no-unused-expressions: "off" */

              var parent = elem.parentNode;
              if (parent && parent.parentNode) {
                parent.parentNode.selectedIndex;
              }
              return null;
            },
            set: function (elem) {
              /* eslint no-unused-expressions: "off" */

              var parent = elem.parentNode;
              if (parent) {
                parent.selectedIndex;

                if (parent.parentNode) {
                  parent.parentNode.selectedIndex;
                }
              }
            }
          };
        }

        jQuery.each(
          [
            'tabIndex',
            'readOnly',
            'maxLength',
            'cellSpacing',
            'cellPadding',
            'rowSpan',
            'colSpan',
            'useMap',
            'frameBorder',
            'contentEditable'
          ],
          function () {
            jQuery.propFix[this.toLowerCase()] = this;
          }
        );

        // Strip and collapse whitespace according to HTML spec
        // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
        function stripAndCollapse(value) {
          var tokens = value.match(rnothtmlwhite) || [];
          return tokens.join(' ');
        }

        function getClass(elem) {
          return (elem.getAttribute && elem.getAttribute('class')) || '';
        }

        function classesToArray(value) {
          if (Array.isArray(value)) {
            return value;
          }
          if (typeof value === 'string') {
            return value.match(rnothtmlwhite) || [];
          }
          return [];
        }

        jQuery.fn.extend({
          addClass: function (value) {
            var classes,
              elem,
              cur,
              curValue,
              clazz,
              j,
              finalValue,
              i = 0;

            if (isFunction(value)) {
              return this.each(function (j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
              });
            }

            classes = classesToArray(value);

            if (classes.length) {
              while ((elem = this[i++])) {
                curValue = getClass(elem);
                cur = elem.nodeType === 1 && ' ' + stripAndCollapse(curValue) + ' ';

                if (cur) {
                  j = 0;
                  while ((clazz = classes[j++])) {
                    if (cur.indexOf(' ' + clazz + ' ') < 0) {
                      cur += clazz + ' ';
                    }
                  }

                  // Only assign if different to avoid unneeded rendering.
                  finalValue = stripAndCollapse(cur);
                  if (curValue !== finalValue) {
                    elem.setAttribute('class', finalValue);
                  }
                }
              }
            }

            return this;
          },

          removeClass: function (value) {
            var classes,
              elem,
              cur,
              curValue,
              clazz,
              j,
              finalValue,
              i = 0;

            if (isFunction(value)) {
              return this.each(function (j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
              });
            }

            if (!arguments.length) {
              return this.attr('class', '');
            }

            classes = classesToArray(value);

            if (classes.length) {
              while ((elem = this[i++])) {
                curValue = getClass(elem);

                // This expression is here for better compressibility (see addClass)
                cur = elem.nodeType === 1 && ' ' + stripAndCollapse(curValue) + ' ';

                if (cur) {
                  j = 0;
                  while ((clazz = classes[j++])) {
                    // Remove *all* instances
                    while (cur.indexOf(' ' + clazz + ' ') > -1) {
                      cur = cur.replace(' ' + clazz + ' ', ' ');
                    }
                  }

                  // Only assign if different to avoid unneeded rendering.
                  finalValue = stripAndCollapse(cur);
                  if (curValue !== finalValue) {
                    elem.setAttribute('class', finalValue);
                  }
                }
              }
            }

            return this;
          },

          toggleClass: function (value, stateVal) {
            var type = typeof value,
              isValidValue = type === 'string' || Array.isArray(value);

            if (typeof stateVal === 'boolean' && isValidValue) {
              return stateVal ? this.addClass(value) : this.removeClass(value);
            }

            if (isFunction(value)) {
              return this.each(function (i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
              });
            }

            return this.each(function () {
              var className, i, self, classNames;

              if (isValidValue) {
                // Toggle individual class names
                i = 0;
                self = jQuery(this);
                classNames = classesToArray(value);

                while ((className = classNames[i++])) {
                  // Check each className given, space separated list
                  if (self.hasClass(className)) {
                    self.removeClass(className);
                  } else {
                    self.addClass(className);
                  }
                }

                // Toggle whole class name
              } else if (value === undefined || type === 'boolean') {
                className = getClass(this);
                if (className) {
                  // Store className if set
                  dataPriv.set(this, '__className__', className);
                }

                // If the element has a class name or if we're passed `false`,
                // then remove the whole classname (if there was one, the above saved it).
                // Otherwise bring back whatever was previously saved (if anything),
                // falling back to the empty string if nothing was stored.
                if (this.setAttribute) {
                  this.setAttribute(
                    'class',
                    className || value === false ? '' : dataPriv.get(this, '__className__') || ''
                  );
                }
              }
            });
          },

          hasClass: function (selector) {
            var className,
              elem,
              i = 0;

            className = ' ' + selector + ' ';
            while ((elem = this[i++])) {
              if (elem.nodeType === 1 && (' ' + stripAndCollapse(getClass(elem)) + ' ').indexOf(className) > -1) {
                return true;
              }
            }

            return false;
          }
        });

        var rreturn = /\r/g;

        jQuery.fn.extend({
          val: function (value) {
            var hooks,
              ret,
              valueIsFunction,
              elem = this[0];

            if (!arguments.length) {
              if (elem) {
                hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];

                if (hooks && 'get' in hooks && (ret = hooks.get(elem, 'value')) !== undefined) {
                  return ret;
                }

                ret = elem.value;

                // Handle most common string cases
                if (typeof ret === 'string') {
                  return ret.replace(rreturn, '');
                }

                // Handle cases where value is null/undef or number
                return ret == null ? '' : ret;
              }

              return;
            }

            valueIsFunction = isFunction(value);

            return this.each(function (i) {
              var val;

              if (this.nodeType !== 1) {
                return;
              }

              if (valueIsFunction) {
                val = value.call(this, i, jQuery(this).val());
              } else {
                val = value;
              }

              // Treat null/undefined as ""; convert numbers to string
              if (val == null) {
                val = '';
              } else if (typeof val === 'number') {
                val += '';
              } else if (Array.isArray(val)) {
                val = jQuery.map(val, function (value) {
                  return value == null ? '' : value + '';
                });
              }

              hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];

              // If set returns undefined, fall back to normal setting
              if (!hooks || !('set' in hooks) || hooks.set(this, val, 'value') === undefined) {
                this.value = val;
              }
            });
          }
        });

        jQuery.extend({
          valHooks: {
            option: {
              get: function (elem) {
                var val = jQuery.find.attr(elem, 'value');
                return val != null
                  ? val
                  : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (#14686, #14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
              }
            },
            select: {
              get: function (elem) {
                var value,
                  option,
                  i,
                  options = elem.options,
                  index = elem.selectedIndex,
                  one = elem.type === 'select-one',
                  values = one ? null : [],
                  max = one ? index + 1 : options.length;

                if (index < 0) {
                  i = max;
                } else {
                  i = one ? index : 0;
                }

                // Loop through all the selected options
                for (; i < max; i++) {
                  option = options[i];

                  // Support: IE <=9 only
                  // IE8-9 doesn't update selected after form reset (#2551)
                  if (
                    (option.selected || i === index) &&
                    // Don't return options that are disabled or in a disabled optgroup
                    !option.disabled &&
                    (!option.parentNode.disabled || !nodeName(option.parentNode, 'optgroup'))
                  ) {
                    // Get the specific value for the option
                    value = jQuery(option).val();

                    // We don't need an array for one selects
                    if (one) {
                      return value;
                    }

                    // Multi-Selects return an array
                    values.push(value);
                  }
                }

                return values;
              },

              set: function (elem, value) {
                var optionSet,
                  option,
                  options = elem.options,
                  values = jQuery.makeArray(value),
                  i = options.length;

                while (i--) {
                  option = options[i];

                  /* eslint-disable no-cond-assign */

                  if ((option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1)) {
                    optionSet = true;
                  }

                  /* eslint-enable no-cond-assign */
                }

                // Force browsers to behave consistently when non-matching value is set
                if (!optionSet) {
                  elem.selectedIndex = -1;
                }
                return values;
              }
            }
          }
        });

        // Radios and checkboxes getter/setter
        jQuery.each(['radio', 'checkbox'], function () {
          jQuery.valHooks[this] = {
            set: function (elem, value) {
              if (Array.isArray(value)) {
                return (elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1);
              }
            }
          };
          if (!support.checkOn) {
            jQuery.valHooks[this].get = function (elem) {
              return elem.getAttribute('value') === null ? 'on' : elem.value;
            };
          }
        });

        // Return jQuery for attributes-only inclusion

        support.focusin = 'onfocusin' in window;

        var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
          stopPropagationCallback = function (e) {
            e.stopPropagation();
          };

        jQuery.extend(jQuery.event, {
          trigger: function (event, data, elem, onlyHandlers) {
            var i,
              cur,
              tmp,
              bubbleType,
              ontype,
              handle,
              special,
              lastElement,
              eventPath = [elem || document],
              type = hasOwn.call(event, 'type') ? event.type : event,
              namespaces = hasOwn.call(event, 'namespace') ? event.namespace.split('.') : [];

            cur = lastElement = tmp = elem = elem || document;

            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) {
              return;
            }

            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) {
              return;
            }

            if (type.indexOf('.') > -1) {
              // Namespaced trigger; create a regexp to match event type in handle()
              namespaces = type.split('.');
              type = namespaces.shift();
              namespaces.sort();
            }
            ontype = type.indexOf(':') < 0 && 'on' + type;

            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === 'object' && event);

            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join('.');
            event.rnamespace = event.namespace
              ? new RegExp('(^|\\.)' + namespaces.join('\\.(?:.*\\.|)') + '(\\.|$)')
              : null;

            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) {
              event.target = elem;
            }

            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [event] : jQuery.makeArray(data, [event]);

            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
              return;
            }

            // Determine event propagation path in advance, per W3C events spec (#9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
              bubbleType = special.delegateType || type;
              if (!rfocusMorph.test(bubbleType + type)) {
                cur = cur.parentNode;
              }
              for (; cur; cur = cur.parentNode) {
                eventPath.push(cur);
                tmp = cur;
              }

              // Only add window if we got to document (e.g., not plain obj or detached DOM)
              if (tmp === (elem.ownerDocument || document)) {
                eventPath.push(tmp.defaultView || tmp.parentWindow || window);
              }
            }

            // Fire handlers on the event path
            i = 0;
            while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
              lastElement = cur;
              event.type = i > 1 ? bubbleType : special.bindType || type;

              // jQuery handler
              handle = (dataPriv.get(cur, 'events') || Object.create(null))[event.type] && dataPriv.get(cur, 'handle');
              if (handle) {
                handle.apply(cur, data);
              }

              // Native handler
              handle = ontype && cur[ontype];
              if (handle && handle.apply && acceptData(cur)) {
                event.result = handle.apply(cur, data);
                if (event.result === false) {
                  event.preventDefault();
                }
              }
            }
            event.type = type;

            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
              if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) {
                // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (#6170)
                if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                  // Don't re-trigger an onFOO event when we call its FOO() method
                  tmp = elem[ontype];

                  if (tmp) {
                    elem[ontype] = null;
                  }

                  // Prevent re-triggering of the same event, since we already bubbled it above
                  jQuery.event.triggered = type;

                  if (event.isPropagationStopped()) {
                    lastElement.addEventListener(type, stopPropagationCallback);
                  }

                  elem[type]();

                  if (event.isPropagationStopped()) {
                    lastElement.removeEventListener(type, stopPropagationCallback);
                  }

                  jQuery.event.triggered = undefined;

                  if (tmp) {
                    elem[ontype] = tmp;
                  }
                }
              }
            }

            return event.result;
          },

          // Piggyback on a donor event to simulate a different one
          // Used only for `focus(in | out)` events
          simulate: function (type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
              type: type,
              isSimulated: true
            });

            jQuery.event.trigger(e, null, elem);
          }
        });

        jQuery.fn.extend({
          trigger: function (type, data) {
            return this.each(function () {
              jQuery.event.trigger(type, data, this);
            });
          },
          triggerHandler: function (type, data) {
            var elem = this[0];
            if (elem) {
              return jQuery.event.trigger(type, data, elem, true);
            }
          }
        });

        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        if (!support.focusin) {
          jQuery.each({ focus: 'focusin', blur: 'focusout' }, function (orig, fix) {
            // Attach a single capturing handler on the document while someone wants focusin/focusout
            var handler = function (event) {
              jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
            };

            jQuery.event.special[fix] = {
              setup: function () {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this,
                  attaches = dataPriv.access(doc, fix);

                if (!attaches) {
                  doc.addEventListener(orig, handler, true);
                }
                dataPriv.access(doc, fix, (attaches || 0) + 1);
              },
              teardown: function () {
                var doc = this.ownerDocument || this.document || this,
                  attaches = dataPriv.access(doc, fix) - 1;

                if (!attaches) {
                  doc.removeEventListener(orig, handler, true);
                  dataPriv.remove(doc, fix);
                } else {
                  dataPriv.access(doc, fix, attaches);
                }
              }
            };
          });
        }
        var location = window.location;

        var nonce = { guid: Date.now() };

        var rquery = /\?/;

        // Cross-browser xml parsing
        jQuery.parseXML = function (data) {
          var xml, parserErrorElem;
          if (!data || typeof data !== 'string') {
            return null;
          }

          // Support: IE 9 - 11 only
          // IE throws on parseFromString with invalid input.
          try {
            xml = new window.DOMParser().parseFromString(data, 'text/xml');
          } catch (e) {}

          parserErrorElem = xml && xml.getElementsByTagName('parsererror')[0];
          if (!xml || parserErrorElem) {
            jQuery.error(
              'Invalid XML: ' +
                (parserErrorElem
                  ? jQuery
                      .map(parserErrorElem.childNodes, function (el) {
                        return el.textContent;
                      })
                      .join('\n')
                  : data)
            );
          }
          return xml;
        };

        var rbracket = /\[\]$/,
          rCRLF = /\r?\n/g,
          rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
          rsubmittable = /^(?:input|select|textarea|keygen)/i;

        function buildParams(prefix, obj, traditional, add) {
          var name;

          if (Array.isArray(obj)) {
            // Serialize array item.
            jQuery.each(obj, function (i, v) {
              if (traditional || rbracket.test(prefix)) {
                // Treat each array item as a scalar.
                add(prefix, v);
              } else {
                // Item is non-scalar (array or object), encode its numeric index.
                buildParams(prefix + '[' + (typeof v === 'object' && v != null ? i : '') + ']', v, traditional, add);
              }
            });
          } else if (!traditional && toType(obj) === 'object') {
            // Serialize object item.
            for (name in obj) {
              buildParams(prefix + '[' + name + ']', obj[name], traditional, add);
            }
          } else {
            // Serialize scalar item.
            add(prefix, obj);
          }
        }

        // Serialize an array of form elements or a set of
        // key/values into a query string
        jQuery.param = function (a, traditional) {
          var prefix,
            s = [],
            add = function (key, valueOrFunction) {
              // If value is a function, invoke it and use its return value
              var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;

              s[s.length] = encodeURIComponent(key) + '=' + encodeURIComponent(value == null ? '' : value);
            };

          if (a == null) {
            return '';
          }

          // If an array was passed in, assume that it is an array of form elements.
          if (Array.isArray(a) || (a.jquery && !jQuery.isPlainObject(a))) {
            // Serialize the form elements
            jQuery.each(a, function () {
              add(this.name, this.value);
            });
          } else {
            // If traditional, encode the "old" way (the way 1.3.2 or older
            // did it), otherwise encode params recursively.
            for (prefix in a) {
              buildParams(prefix, a[prefix], traditional, add);
            }
          }

          // Return the resulting serialization
          return s.join('&');
        };

        jQuery.fn.extend({
          serialize: function () {
            return jQuery.param(this.serializeArray());
          },
          serializeArray: function () {
            return this.map(function () {
              // Can add propHook for "elements" to filter or add form elements
              var elements = jQuery.prop(this, 'elements');
              return elements ? jQuery.makeArray(elements) : this;
            })
              .filter(function () {
                var type = this.type;

                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return (
                  this.name &&
                  !jQuery(this).is(':disabled') &&
                  rsubmittable.test(this.nodeName) &&
                  !rsubmitterTypes.test(type) &&
                  (this.checked || !rcheckableType.test(type))
                );
              })
              .map(function (_i, elem) {
                var val = jQuery(this).val();

                if (val == null) {
                  return null;
                }

                if (Array.isArray(val)) {
                  return jQuery.map(val, function (val) {
                    return { name: elem.name, value: val.replace(rCRLF, '\r\n') };
                  });
                }

                return { name: elem.name, value: val.replace(rCRLF, '\r\n') };
              })
              .get();
          }
        });

        var r20 = /%20/g,
          rhash = /#.*$/,
          rantiCache = /([?&])_=[^&]*/,
          rheaders = /^(.*?):[ \t]*([^\r\n]*)$/gm,
          // #7653, #8125, #8152: local protocol detection
          rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
          rnoContent = /^(?:GET|HEAD)$/,
          rprotocol = /^\/\//,
          /* Prefilters
           * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
           * 2) These are called:
           *    - BEFORE asking for a transport
           *    - AFTER param serialization (s.data is a string if s.processData is true)
           * 3) key is the dataType
           * 4) the catchall symbol "*" can be used
           * 5) execution will start with transport dataType and THEN continue down to "*" if needed
           */
          prefilters = {},
          /* Transports bindings
           * 1) key is the dataType
           * 2) the catchall symbol "*" can be used
           * 3) selection will start with transport dataType and THEN go to "*" if needed
           */
          transports = {},
          // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
          allTypes = '*/'.concat('*'),
          // Anchor tag for parsing the document origin
          originAnchor = document.createElement('a');

        originAnchor.href = location.href;

        // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
        function addToPrefiltersOrTransports(structure) {
          // dataTypeExpression is optional and defaults to "*"
          return function (dataTypeExpression, func) {
            if (typeof dataTypeExpression !== 'string') {
              func = dataTypeExpression;
              dataTypeExpression = '*';
            }

            var dataType,
              i = 0,
              dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];

            if (isFunction(func)) {
              // For each dataType in the dataTypeExpression
              while ((dataType = dataTypes[i++])) {
                // Prepend if requested
                if (dataType[0] === '+') {
                  dataType = dataType.slice(1) || '*';
                  (structure[dataType] = structure[dataType] || []).unshift(func);

                  // Otherwise append
                } else {
                  (structure[dataType] = structure[dataType] || []).push(func);
                }
              }
            }
          };
        }

        // Base inspection function for prefilters and transports
        function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
          var inspected = {},
            seekingTransport = structure === transports;

          function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function (_, prefilterOrFactory) {
              var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
              if (typeof dataTypeOrTransport === 'string' && !seekingTransport && !inspected[dataTypeOrTransport]) {
                options.dataTypes.unshift(dataTypeOrTransport);
                inspect(dataTypeOrTransport);
                return false;
              } else if (seekingTransport) {
                return !(selected = dataTypeOrTransport);
              }
            });
            return selected;
          }

          return inspect(options.dataTypes[0]) || (!inspected['*'] && inspect('*'));
        }

        // A special extend for ajax options
        // that takes "flat" options (not to be deep extended)
        // Fixes #9887
        function ajaxExtend(target, src) {
          var key,
            deep,
            flatOptions = jQuery.ajaxSettings.flatOptions || {};

          for (key in src) {
            if (src[key] !== undefined) {
              (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
            }
          }
          if (deep) {
            jQuery.extend(true, target, deep);
          }

          return target;
        }

        /* Handles responses to an ajax request:
         * - finds the right dataType (mediates between content-type and expected dataType)
         * - returns the corresponding response
         */
        function ajaxHandleResponses(s, jqXHR, responses) {
          var ct,
            type,
            finalDataType,
            firstDataType,
            contents = s.contents,
            dataTypes = s.dataTypes;

          // Remove auto dataType and get content-type in the process
          while (dataTypes[0] === '*') {
            dataTypes.shift();
            if (ct === undefined) {
              ct = s.mimeType || jqXHR.getResponseHeader('Content-Type');
            }
          }

          // Check if we're dealing with a known content-type
          if (ct) {
            for (type in contents) {
              if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
              }
            }
          }

          // Check to see if we have a response for the expected dataType
          if (dataTypes[0] in responses) {
            finalDataType = dataTypes[0];
          } else {
            // Try convertible dataTypes
            for (type in responses) {
              if (!dataTypes[0] || s.converters[type + ' ' + dataTypes[0]]) {
                finalDataType = type;
                break;
              }
              if (!firstDataType) {
                firstDataType = type;
              }
            }

            // Or just use first one
            finalDataType = finalDataType || firstDataType;
          }

          // If we found a dataType
          // We add the dataType to the list if needed
          // and return the corresponding response
          if (finalDataType) {
            if (finalDataType !== dataTypes[0]) {
              dataTypes.unshift(finalDataType);
            }
            return responses[finalDataType];
          }
        }

        /* Chain conversions given the request and the original response
         * Also sets the responseXXX fields on the jqXHR instance
         */
        function ajaxConvert(s, response, jqXHR, isSuccess) {
          var conv2,
            current,
            conv,
            tmp,
            prev,
            converters = {},
            // Work with a copy of dataTypes in case we need to modify it for conversion
            dataTypes = s.dataTypes.slice();

          // Create converters map with lowercased keys
          if (dataTypes[1]) {
            for (conv in s.converters) {
              converters[conv.toLowerCase()] = s.converters[conv];
            }
          }

          current = dataTypes.shift();

          // Convert to each sequential dataType
          while (current) {
            if (s.responseFields[current]) {
              jqXHR[s.responseFields[current]] = response;
            }

            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) {
              response = s.dataFilter(response, s.dataType);
            }

            prev = current;
            current = dataTypes.shift();

            if (current) {
              // There's only work to do if current dataType is non-auto
              if (current === '*') {
                current = prev;

                // Convert response if prev dataType is non-auto and differs from current
              } else if (prev !== '*' && prev !== current) {
                // Seek a direct converter
                conv = converters[prev + ' ' + current] || converters['* ' + current];

                // If none found, seek a pair
                if (!conv) {
                  for (conv2 in converters) {
                    // If conv2 outputs current
                    tmp = conv2.split(' ');
                    if (tmp[1] === current) {
                      // If prev can be converted to accepted input
                      conv = converters[prev + ' ' + tmp[0]] || converters['* ' + tmp[0]];
                      if (conv) {
                        // Condense equivalence converters
                        if (conv === true) {
                          conv = converters[conv2];

                          // Otherwise, insert the intermediate dataType
                        } else if (converters[conv2] !== true) {
                          current = tmp[0];
                          dataTypes.unshift(tmp[1]);
                        }
                        break;
                      }
                    }
                  }
                }

                // Apply converter (if not an equivalence)
                if (conv !== true) {
                  // Unless errors are allowed to bubble, catch and return them
                  if (conv && s.throws) {
                    response = conv(response);
                  } else {
                    try {
                      response = conv(response);
                    } catch (e) {
                      return {
                        state: 'parsererror',
                        error: conv ? e : 'No conversion from ' + prev + ' to ' + current
                      };
                    }
                  }
                }
              }
            }
          }

          return { state: 'success', data: response };
        }

        jQuery.extend({
          // Counter for holding the number of active queries
          active: 0,

          // Last-Modified header cache for next request
          lastModified: {},
          etag: {},

          ajaxSettings: {
            url: location.href,
            type: 'GET',
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: 'application/x-www-form-urlencoded; charset=UTF-8',

            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

            accepts: {
              '*': allTypes,
              text: 'text/plain',
              html: 'text/html',
              xml: 'application/xml, text/xml',
              json: 'application/json, text/javascript'
            },

            contents: {
              xml: /\bxml\b/,
              html: /\bhtml/,
              json: /\bjson\b/
            },

            responseFields: {
              xml: 'responseXML',
              text: 'responseText',
              json: 'responseJSON'
            },

            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
              // Convert anything to text
              '* text': String,

              // Text to html (true = no transformation)
              'text html': true,

              // Evaluate text as a json expression
              'text json': JSON.parse,

              // Parse text as xml
              'text xml': jQuery.parseXML
            },

            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
              url: true,
              context: true
            }
          },

          // Creates a full fledged settings object into target
          // with both ajaxSettings and settings fields.
          // If target is omitted, writes into ajaxSettings.
          ajaxSetup: function (target, settings) {
            return settings
              ? // Building a settings object
                ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings)
              : // Extending ajaxSettings
                ajaxExtend(jQuery.ajaxSettings, target);
          },

          ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
          ajaxTransport: addToPrefiltersOrTransports(transports),

          // Main method
          ajax: function (url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === 'object') {
              options = url;
              url = undefined;
            }

            // Force options to be an object
            options = options || {};

            var transport,
              // URL without anti-cache param
              cacheURL,
              // Response headers
              responseHeadersString,
              responseHeaders,
              // timeout handle
              timeoutTimer,
              // Url cleanup var
              urlAnchor,
              // Request state (becomes false upon send and true upon completion)
              completed,
              // To know if global events are to be dispatched
              fireGlobals,
              // Loop variable
              i,
              // uncached part of the url
              uncached,
              // Create the final options object
              s = jQuery.ajaxSetup({}, options),
              // Callbacks context
              callbackContext = s.context || s,
              // Context for global events is callbackContext if it is a DOM node or jQuery collection
              globalEventContext =
                s.context && (callbackContext.nodeType || callbackContext.jquery)
                  ? jQuery(callbackContext)
                  : jQuery.event,
              // Deferreds
              deferred = jQuery.Deferred(),
              completeDeferred = jQuery.Callbacks('once memory'),
              // Status-dependent callbacks
              statusCode = s.statusCode || {},
              // Headers (they are sent all at once)
              requestHeaders = {},
              requestHeadersNames = {},
              // Default abort message
              strAbort = 'canceled',
              // Fake xhr
              jqXHR = {
                readyState: 0,

                // Builds headers hashtable if needed
                getResponseHeader: function (key) {
                  var match;
                  if (completed) {
                    if (!responseHeaders) {
                      responseHeaders = {};
                      while ((match = rheaders.exec(responseHeadersString))) {
                        responseHeaders[match[1].toLowerCase() + ' '] = (
                          responseHeaders[match[1].toLowerCase() + ' '] || []
                        ).concat(match[2]);
                      }
                    }
                    match = responseHeaders[key.toLowerCase() + ' '];
                  }
                  return match == null ? null : match.join(', ');
                },

                // Raw string
                getAllResponseHeaders: function () {
                  return completed ? responseHeadersString : null;
                },

                // Caches the header
                setRequestHeader: function (name, value) {
                  if (completed == null) {
                    name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                    requestHeaders[name] = value;
                  }
                  return this;
                },

                // Overrides response content-type header
                overrideMimeType: function (type) {
                  if (completed == null) {
                    s.mimeType = type;
                  }
                  return this;
                },

                // Status-dependent callbacks
                statusCode: function (map) {
                  var code;
                  if (map) {
                    if (completed) {
                      // Execute the appropriate callbacks
                      jqXHR.always(map[jqXHR.status]);
                    } else {
                      // Lazy-add the new callbacks in a way that preserves old ones
                      for (code in map) {
                        statusCode[code] = [statusCode[code], map[code]];
                      }
                    }
                  }
                  return this;
                },

                // Cancel the request
                abort: function (statusText) {
                  var finalText = statusText || strAbort;
                  if (transport) {
                    transport.abort(finalText);
                  }
                  done(0, finalText);
                  return this;
                }
              };

            // Attach deferreds
            deferred.promise(jqXHR);

            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (#10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + '').replace(rprotocol, location.protocol + '//');

            // Alias method option to type as per ticket #12004
            s.type = options.method || options.type || s.method || s.type;

            // Extract dataTypes list
            s.dataTypes = (s.dataType || '*').toLowerCase().match(rnothtmlwhite) || [''];

            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
              urlAnchor = document.createElement('a');

              // Support: IE <=8 - 11, Edge 12 - 15
              // IE throws exception on accessing the href property if url is malformed,
              // e.g. http://example.com:80x/
              try {
                urlAnchor.href = s.url;

                // Support: IE <=8 - 11 only
                // Anchor's host property isn't correctly set when s.url is relative
                urlAnchor.href = urlAnchor.href;
                s.crossDomain =
                  originAnchor.protocol + '//' + originAnchor.host !== urlAnchor.protocol + '//' + urlAnchor.host;
              } catch (e) {
                // If there is an error parsing the URL, assume it is crossDomain,
                // it can be rejected by the transport if it is invalid
                s.crossDomain = true;
              }
            }

            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== 'string') {
              s.data = jQuery.param(s.data, s.traditional);
            }

            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);

            // If request was aborted inside a prefilter, stop there
            if (completed) {
              return jqXHR;
            }

            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
            fireGlobals = jQuery.event && s.global;

            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) {
              jQuery.event.trigger('ajaxStart');
            }

            // Uppercase the type
            s.type = s.type.toUpperCase();

            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);

            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, '');

            // More options handling for requests with no content
            if (!s.hasContent) {
              // Remember the hash so we can put it back
              uncached = s.url.slice(cacheURL.length);

              // If data is available and should be processed, append data to url
              if (s.data && (s.processData || typeof s.data === 'string')) {
                cacheURL += (rquery.test(cacheURL) ? '&' : '?') + s.data;

                // #9682: remove data so that it's not used in an eventual retry
                delete s.data;
              }

              // Add or update anti-cache param if needed
              if (s.cache === false) {
                cacheURL = cacheURL.replace(rantiCache, '$1');
                uncached = (rquery.test(cacheURL) ? '&' : '?') + '_=' + nonce.guid++ + uncached;
              }

              // Put hash and anti-cache on the URL that will be requested (gh-1732)
              s.url = cacheURL + uncached;

              // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (
              s.data &&
              s.processData &&
              (s.contentType || '').indexOf('application/x-www-form-urlencoded') === 0
            ) {
              s.data = s.data.replace(r20, '+');
            }

            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
              if (jQuery.lastModified[cacheURL]) {
                jqXHR.setRequestHeader('If-Modified-Since', jQuery.lastModified[cacheURL]);
              }
              if (jQuery.etag[cacheURL]) {
                jqXHR.setRequestHeader('If-None-Match', jQuery.etag[cacheURL]);
              }
            }

            // Set the correct header, if data is being sent
            if ((s.data && s.hasContent && s.contentType !== false) || options.contentType) {
              jqXHR.setRequestHeader('Content-Type', s.contentType);
            }

            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader(
              'Accept',
              s.dataTypes[0] && s.accepts[s.dataTypes[0]]
                ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== '*' ? ', ' + allTypes + '; q=0.01' : '')
                : s.accepts['*']
            );

            // Check for headers option
            for (i in s.headers) {
              jqXHR.setRequestHeader(i, s.headers[i]);
            }

            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) {
              // Abort if not done already and return
              return jqXHR.abort();
            }

            // Aborting is no longer a cancellation
            strAbort = 'abort';

            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);

            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);

            // If no transport, we auto-abort
            if (!transport) {
              done(-1, 'No Transport');
            } else {
              jqXHR.readyState = 1;

              // Send global event
              if (fireGlobals) {
                globalEventContext.trigger('ajaxSend', [jqXHR, s]);
              }

              // If request was aborted inside ajaxSend, stop there
              if (completed) {
                return jqXHR;
              }

              // Timeout
              if (s.async && s.timeout > 0) {
                timeoutTimer = window.setTimeout(function () {
                  jqXHR.abort('timeout');
                }, s.timeout);
              }

              try {
                completed = false;
                transport.send(requestHeaders, done);
              } catch (e) {
                // Rethrow post-completion exceptions
                if (completed) {
                  throw e;
                }

                // Propagate others as results
                done(-1, e);
              }
            }

            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
              var isSuccess,
                success,
                error,
                response,
                modified,
                statusText = nativeStatusText;

              // Ignore repeat invocations
              if (completed) {
                return;
              }

              completed = true;

              // Clear timeout if it exists
              if (timeoutTimer) {
                window.clearTimeout(timeoutTimer);
              }

              // Dereference transport for early garbage collection
              // (no matter how long the jqXHR object will be used)
              transport = undefined;

              // Cache response headers
              responseHeadersString = headers || '';

              // Set readyState
              jqXHR.readyState = status > 0 ? 4 : 0;

              // Determine if successful
              isSuccess = (status >= 200 && status < 300) || status === 304;

              // Get response data
              if (responses) {
                response = ajaxHandleResponses(s, jqXHR, responses);
              }

              // Use a noop converter for missing script but not if jsonp
              if (!isSuccess && jQuery.inArray('script', s.dataTypes) > -1 && jQuery.inArray('json', s.dataTypes) < 0) {
                s.converters['text script'] = function () {};
              }

              // Convert no matter what (that way responseXXX fields are always set)
              response = ajaxConvert(s, response, jqXHR, isSuccess);

              // If successful, handle type chaining
              if (isSuccess) {
                // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                if (s.ifModified) {
                  modified = jqXHR.getResponseHeader('Last-Modified');
                  if (modified) {
                    jQuery.lastModified[cacheURL] = modified;
                  }
                  modified = jqXHR.getResponseHeader('etag');
                  if (modified) {
                    jQuery.etag[cacheURL] = modified;
                  }
                }

                // if no content
                if (status === 204 || s.type === 'HEAD') {
                  statusText = 'nocontent';

                  // if not modified
                } else if (status === 304) {
                  statusText = 'notmodified';

                  // If we have data, let's convert it
                } else {
                  statusText = response.state;
                  success = response.data;
                  error = response.error;
                  isSuccess = !error;
                }
              } else {
                // Extract error from statusText and normalize for non-aborts
                error = statusText;
                if (status || !statusText) {
                  statusText = 'error';
                  if (status < 0) {
                    status = 0;
                  }
                }
              }

              // Set data for the fake xhr object
              jqXHR.status = status;
              jqXHR.statusText = (nativeStatusText || statusText) + '';

              // Success/Error
              if (isSuccess) {
                deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
              } else {
                deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
              }

              // Status-dependent callbacks
              jqXHR.statusCode(statusCode);
              statusCode = undefined;

              if (fireGlobals) {
                globalEventContext.trigger(isSuccess ? 'ajaxSuccess' : 'ajaxError', [
                  jqXHR,
                  s,
                  isSuccess ? success : error
                ]);
              }

              // Complete
              completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);

              if (fireGlobals) {
                globalEventContext.trigger('ajaxComplete', [jqXHR, s]);

                // Handle the global AJAX counter
                if (!--jQuery.active) {
                  jQuery.event.trigger('ajaxStop');
                }
              }
            }

            return jqXHR;
          },

          getJSON: function (url, data, callback) {
            return jQuery.get(url, data, callback, 'json');
          },

          getScript: function (url, callback) {
            return jQuery.get(url, undefined, callback, 'script');
          }
        });

        jQuery.each(['get', 'post'], function (_i, method) {
          jQuery[method] = function (url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
              type = type || callback;
              callback = data;
              data = undefined;
            }

            // The url can be an options object (which then must have .url)
            return jQuery.ajax(
              jQuery.extend(
                {
                  url: url,
                  type: method,
                  dataType: type,
                  data: data,
                  success: callback
                },
                jQuery.isPlainObject(url) && url
              )
            );
          };
        });

        jQuery.ajaxPrefilter(function (s) {
          var i;
          for (i in s.headers) {
            if (i.toLowerCase() === 'content-type') {
              s.contentType = s.headers[i] || '';
            }
          }
        });

        jQuery._evalUrl = function (url, options, doc) {
          return jQuery.ajax({
            url: url,

            // Make this explicit, since user can override this through ajaxSetup (#11264)
            type: 'GET',
            dataType: 'script',
            cache: true,
            async: false,
            global: false,

            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
              'text script': function () {}
            },
            dataFilter: function (response) {
              jQuery.globalEval(response, options, doc);
            }
          });
        };

        jQuery.fn.extend({
          wrapAll: function (html) {
            var wrap;

            if (this[0]) {
              if (isFunction(html)) {
                html = html.call(this[0]);
              }

              // The elements to wrap the target around
              wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);

              if (this[0].parentNode) {
                wrap.insertBefore(this[0]);
              }

              wrap
                .map(function () {
                  var elem = this;

                  while (elem.firstElementChild) {
                    elem = elem.firstElementChild;
                  }

                  return elem;
                })
                .append(this);
            }

            return this;
          },

          wrapInner: function (html) {
            if (isFunction(html)) {
              return this.each(function (i) {
                jQuery(this).wrapInner(html.call(this, i));
              });
            }

            return this.each(function () {
              var self = jQuery(this),
                contents = self.contents();

              if (contents.length) {
                contents.wrapAll(html);
              } else {
                self.append(html);
              }
            });
          },

          wrap: function (html) {
            var htmlIsFunction = isFunction(html);

            return this.each(function (i) {
              jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
          },

          unwrap: function (selector) {
            this.parent(selector)
              .not('body')
              .each(function () {
                jQuery(this).replaceWith(this.childNodes);
              });
            return this;
          }
        });

        jQuery.expr.pseudos.hidden = function (elem) {
          return !jQuery.expr.pseudos.visible(elem);
        };
        jQuery.expr.pseudos.visible = function (elem) {
          return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
        };

        jQuery.ajaxSettings.xhr = function () {
          try {
            return new window.XMLHttpRequest();
          } catch (e) {}
        };

        var xhrSuccessStatus = {
            // File protocol always yields status code 0, assume 200
            0: 200,

            // Support: IE <=9 only
            // #1450: sometimes IE returns 1223 when it should be 204
            1223: 204
          },
          xhrSupported = jQuery.ajaxSettings.xhr();

        support.cors = !!xhrSupported && 'withCredentials' in xhrSupported;
        support.ajax = xhrSupported = !!xhrSupported;

        jQuery.ajaxTransport(function (options) {
          var callback, errorCallback;

          // Cross domain only allowed if supported through XMLHttpRequest
          if (support.cors || (xhrSupported && !options.crossDomain)) {
            return {
              send: function (headers, complete) {
                var i,
                  xhr = options.xhr();

                xhr.open(options.type, options.url, options.async, options.username, options.password);

                // Apply custom fields if provided
                if (options.xhrFields) {
                  for (i in options.xhrFields) {
                    xhr[i] = options.xhrFields[i];
                  }
                }

                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) {
                  xhr.overrideMimeType(options.mimeType);
                }

                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers['X-Requested-With']) {
                  headers['X-Requested-With'] = 'XMLHttpRequest';
                }

                // Set headers
                for (i in headers) {
                  xhr.setRequestHeader(i, headers[i]);
                }

                // Callback
                callback = function (type) {
                  return function () {
                    if (callback) {
                      callback =
                        errorCallback =
                        xhr.onload =
                        xhr.onerror =
                        xhr.onabort =
                        xhr.ontimeout =
                        xhr.onreadystatechange =
                          null;

                      if (type === 'abort') {
                        xhr.abort();
                      } else if (type === 'error') {
                        // Support: IE <=9 only
                        // On a manual native abort, IE9 throws
                        // errors on any property access that is not readyState
                        if (typeof xhr.status !== 'number') {
                          complete(0, 'error');
                        } else {
                          complete(
                            // File: protocol always yields status 0; see #8605, #14207
                            xhr.status,
                            xhr.statusText
                          );
                        }
                      } else {
                        complete(
                          xhrSuccessStatus[xhr.status] || xhr.status,
                          xhr.statusText,

                          // Support: IE <=9 only
                          // IE9 has no XHR2 but throws on binary (trac-11426)
                          // For XHR2 non-text, let the caller handle it (gh-2498)
                          (xhr.responseType || 'text') !== 'text' || typeof xhr.responseText !== 'string'
                            ? { binary: xhr.response }
                            : { text: xhr.responseText },
                          xhr.getAllResponseHeaders()
                        );
                      }
                    }
                  };
                };

                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback('error');

                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) {
                  xhr.onabort = errorCallback;
                } else {
                  xhr.onreadystatechange = function () {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) {
                      // Allow onerror to be called first,
                      // but that will not handle a native abort
                      // Also, save errorCallback to a variable
                      // as xhr.onerror cannot be accessed
                      window.setTimeout(function () {
                        if (callback) {
                          errorCallback();
                        }
                      });
                    }
                  };
                }

                // Create the abort callback
                callback = callback('abort');

                try {
                  // Do send the request (this may raise an exception)
                  xhr.send((options.hasContent && options.data) || null);
                } catch (e) {
                  // #14683: Only rethrow if this hasn't been notified as an error yet
                  if (callback) {
                    throw e;
                  }
                }
              },

              abort: function () {
                if (callback) {
                  callback();
                }
              }
            };
          }
        });

        // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
        jQuery.ajaxPrefilter(function (s) {
          if (s.crossDomain) {
            s.contents.script = false;
          }
        });

        // Install script dataType
        jQuery.ajaxSetup({
          accepts: {
            script: 'text/javascript, application/javascript, ' + 'application/ecmascript, application/x-ecmascript'
          },
          contents: {
            script: /\b(?:java|ecma)script\b/
          },
          converters: {
            'text script': function (text) {
              jQuery.globalEval(text);
              return text;
            }
          }
        });

        // Handle cache's special case and crossDomain
        jQuery.ajaxPrefilter('script', function (s) {
          if (s.cache === undefined) {
            s.cache = false;
          }
          if (s.crossDomain) {
            s.type = 'GET';
          }
        });

        // Bind script tag hack transport
        jQuery.ajaxTransport('script', function (s) {
          // This transport only deals with cross domain or forced-by-attrs requests
          if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
              send: function (_, complete) {
                script = jQuery('<script>')
                  .attr(s.scriptAttrs || {})
                  .prop({ charset: s.scriptCharset, src: s.url })
                  .on(
                    'load error',
                    (callback = function (evt) {
                      script.remove();
                      callback = null;
                      if (evt) {
                        complete(evt.type === 'error' ? 404 : 200, evt.type);
                      }
                    })
                  );

                // Use native DOM manipulation to avoid our domManip AJAX trickery
                document.head.appendChild(script[0]);
              },
              abort: function () {
                if (callback) {
                  callback();
                }
              }
            };
          }
        });

        var oldCallbacks = [],
          rjsonp = /(=)\?(?=&|$)|\?\?/;

        // Default jsonp settings
        jQuery.ajaxSetup({
          jsonp: 'callback',
          jsonpCallback: function () {
            var callback = oldCallbacks.pop() || jQuery.expando + '_' + nonce.guid++;
            this[callback] = true;
            return callback;
          }
        });

        // Detect, normalize options and install callbacks for jsonp requests
        jQuery.ajaxPrefilter('json jsonp', function (s, originalSettings, jqXHR) {
          var callbackName,
            overwritten,
            responseContainer,
            jsonProp =
              s.jsonp !== false &&
              (rjsonp.test(s.url)
                ? 'url'
                : typeof s.data === 'string' &&
                  (s.contentType || '').indexOf('application/x-www-form-urlencoded') === 0 &&
                  rjsonp.test(s.data) &&
                  'data');

          // Handle iff the expected data type is "jsonp" or we have a parameter to set
          if (jsonProp || s.dataTypes[0] === 'jsonp') {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;

            // Insert callback into url or form data
            if (jsonProp) {
              s[jsonProp] = s[jsonProp].replace(rjsonp, '$1' + callbackName);
            } else if (s.jsonp !== false) {
              s.url += (rquery.test(s.url) ? '&' : '?') + s.jsonp + '=' + callbackName;
            }

            // Use data converter to retrieve json after script execution
            s.converters['script json'] = function () {
              if (!responseContainer) {
                jQuery.error(callbackName + ' was not called');
              }
              return responseContainer[0];
            };

            // Force json dataType
            s.dataTypes[0] = 'json';

            // Install callback
            overwritten = window[callbackName];
            window[callbackName] = function () {
              responseContainer = arguments;
            };

            // Clean-up function (fires after converters)
            jqXHR.always(function () {
              // If previous value didn't exist - remove it
              if (overwritten === undefined) {
                jQuery(window).removeProp(callbackName);

                // Otherwise restore preexisting value
              } else {
                window[callbackName] = overwritten;
              }

              // Save back as free
              if (s[callbackName]) {
                // Make sure that re-using the options doesn't screw things around
                s.jsonpCallback = originalSettings.jsonpCallback;

                // Save the callback name for future use
                oldCallbacks.push(callbackName);
              }

              // Call if it was a function and we have a response
              if (responseContainer && isFunction(overwritten)) {
                overwritten(responseContainer[0]);
              }

              responseContainer = overwritten = undefined;
            });

            // Delegate to script
            return 'script';
          }
        });

        // Support: Safari 8 only
        // In Safari 8 documents created via document.implementation.createHTMLDocument
        // collapse sibling forms: the second one becomes a child of the first one.
        // Because of that, this security measure has to be disabled in Safari 8.
        // https://bugs.webkit.org/show_bug.cgi?id=137337
        support.createHTMLDocument = (function () {
          var body = document.implementation.createHTMLDocument('').body;
          body.innerHTML = '<form></form><form></form>';
          return body.childNodes.length === 2;
        })();

        // Argument "data" should be string of html
        // context (optional): If specified, the fragment will be created in this context,
        // defaults to document
        // keepScripts (optional): If true, will include scripts passed in the html string
        jQuery.parseHTML = function (data, context, keepScripts) {
          if (typeof data !== 'string') {
            return [];
          }
          if (typeof context === 'boolean') {
            keepScripts = context;
            context = false;
          }

          var base, parsed, scripts;

          if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
              context = document.implementation.createHTMLDocument('');

              // Set the base href for the created document
              // so any parsed elements with URLs
              // are based on the document's URL (gh-2965)
              base = context.createElement('base');
              base.href = document.location.href;
              context.head.appendChild(base);
            } else {
              context = document;
            }
          }

          parsed = rsingleTag.exec(data);
          scripts = !keepScripts && [];

          // Single tag
          if (parsed) {
            return [context.createElement(parsed[1])];
          }

          parsed = buildFragment([data], context, scripts);

          if (scripts && scripts.length) {
            jQuery(scripts).remove();
          }

          return jQuery.merge([], parsed.childNodes);
        };

        /**
         * Load a url into a page
         */
        jQuery.fn.load = function (url, params, callback) {
          var selector,
            type,
            response,
            self = this,
            off = url.indexOf(' ');

          if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
          }

          // If it's a function
          if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;

            // Otherwise, build a param string
          } else if (params && typeof params === 'object') {
            type = 'POST';
          }

          // If we have elements to modify, make the request
          if (self.length > 0) {
            jQuery
              .ajax({
                url: url,

                // If "type" variable is undefined, then "GET" method will be used.
                // Make value of this field explicit since
                // user can override it through ajaxSetup method
                type: type || 'GET',
                dataType: 'html',
                data: params
              })
              .done(function (responseText) {
                // Save response for use in complete callback
                response = arguments;

                self.html(
                  selector
                    ? // If a selector was specified, locate the right elements in a dummy div
                      // Exclude scripts to avoid IE 'Permission Denied' errors
                      jQuery('<div>').append(jQuery.parseHTML(responseText)).find(selector)
                    : // Otherwise use the full result
                      responseText
                );

                // If the request succeeds, this function gets "data", "status", "jqXHR"
                // but they are ignored because response was set above.
                // If it fails, this function gets "jqXHR", "status", "error"
              })
              .always(
                callback &&
                  function (jqXHR, status) {
                    self.each(function () {
                      callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
                    });
                  }
              );
          }

          return this;
        };

        jQuery.expr.pseudos.animated = function (elem) {
          return jQuery.grep(jQuery.timers, function (fn) {
            return elem === fn.elem;
          }).length;
        };

        jQuery.offset = {
          setOffset: function (elem, options, i) {
            var curPosition,
              curLeft,
              curCSSTop,
              curTop,
              curOffset,
              curCSSLeft,
              calculatePosition,
              position = jQuery.css(elem, 'position'),
              curElem = jQuery(elem),
              props = {};

            // Set position first, in-case top/left are set even on static elem
            if (position === 'static') {
              elem.style.position = 'relative';
            }

            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, 'top');
            curCSSLeft = jQuery.css(elem, 'left');
            calculatePosition =
              (position === 'absolute' || position === 'fixed') && (curCSSTop + curCSSLeft).indexOf('auto') > -1;

            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
              curPosition = curElem.position();
              curTop = curPosition.top;
              curLeft = curPosition.left;
            } else {
              curTop = parseFloat(curCSSTop) || 0;
              curLeft = parseFloat(curCSSLeft) || 0;
            }

            if (isFunction(options)) {
              // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
              options = options.call(elem, i, jQuery.extend({}, curOffset));
            }

            if (options.top != null) {
              props.top = options.top - curOffset.top + curTop;
            }
            if (options.left != null) {
              props.left = options.left - curOffset.left + curLeft;
            }

            if ('using' in options) {
              options.using.call(elem, props);
            } else {
              curElem.css(props);
            }
          }
        };

        jQuery.fn.extend({
          // offset() relates an element's border box to the document origin
          offset: function (options) {
            // Preserve chaining for setter
            if (arguments.length) {
              return options === undefined
                ? this
                : this.each(function (i) {
                    jQuery.offset.setOffset(this, options, i);
                  });
            }

            var rect,
              win,
              elem = this[0];

            if (!elem) {
              return;
            }

            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) {
              return { top: 0, left: 0 };
            }

            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
              top: rect.top + win.pageYOffset,
              left: rect.left + win.pageXOffset
            };
          },

          // position() relates an element's margin box to its offset parent's padding box
          // This corresponds to the behavior of CSS absolute positioning
          position: function () {
            if (!this[0]) {
              return;
            }

            var offsetParent,
              offset,
              doc,
              elem = this[0],
              parentOffset = { top: 0, left: 0 };

            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, 'position') === 'fixed') {
              // Assume position:fixed implies availability of getBoundingClientRect
              offset = elem.getBoundingClientRect();
            } else {
              offset = this.offset();

              // Account for the *real* offset parent, which can be the document or its root element
              // when a statically positioned element is identified
              doc = elem.ownerDocument;
              offsetParent = elem.offsetParent || doc.documentElement;
              while (
                offsetParent &&
                (offsetParent === doc.body || offsetParent === doc.documentElement) &&
                jQuery.css(offsetParent, 'position') === 'static'
              ) {
                offsetParent = offsetParent.parentNode;
              }
              if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                // Incorporate borders into its offset, since they are outside its content origin
                parentOffset = jQuery(offsetParent).offset();
                parentOffset.top += jQuery.css(offsetParent, 'borderTopWidth', true);
                parentOffset.left += jQuery.css(offsetParent, 'borderLeftWidth', true);
              }
            }

            // Subtract parent offsets and element margins
            return {
              top: offset.top - parentOffset.top - jQuery.css(elem, 'marginTop', true),
              left: offset.left - parentOffset.left - jQuery.css(elem, 'marginLeft', true)
            };
          },

          // This method will return documentElement in the following cases:
          // 1) For the element inside the iframe without offsetParent, this method will return
          //    documentElement of the parent window
          // 2) For the hidden or detached element
          // 3) For body or html element, i.e. in case of the html node - it will return itself
          //
          // but those exceptions were never presented as a real life use-cases
          // and might be considered as more preferable results.
          //
          // This logic, however, is not guaranteed and can change at any point in the future
          offsetParent: function () {
            return this.map(function () {
              var offsetParent = this.offsetParent;

              while (offsetParent && jQuery.css(offsetParent, 'position') === 'static') {
                offsetParent = offsetParent.offsetParent;
              }

              return offsetParent || documentElement;
            });
          }
        });

        // Create scrollLeft and scrollTop methods
        jQuery.each({ scrollLeft: 'pageXOffset', scrollTop: 'pageYOffset' }, function (method, prop) {
          var top = 'pageYOffset' === prop;

          jQuery.fn[method] = function (val) {
            return access(
              this,
              function (elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) {
                  win = elem;
                } else if (elem.nodeType === 9) {
                  win = elem.defaultView;
                }

                if (val === undefined) {
                  return win ? win[prop] : elem[method];
                }

                if (win) {
                  win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                } else {
                  elem[method] = val;
                }
              },
              method,
              val,
              arguments.length
            );
          };
        });

        // Support: Safari <=7 - 9.1, Chrome <=37 - 49
        // Add the top/left cssHooks using jQuery.fn.position
        // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
        // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
        // getComputedStyle returns percent when specified for top/left/bottom/right;
        // rather than make the css module depend on the offset module, just check for it here
        jQuery.each(['top', 'left'], function (_i, prop) {
          jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function (elem, computed) {
            if (computed) {
              computed = curCSS(elem, prop);

              // If curCSS returns percentage, fallback to offset
              return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + 'px' : computed;
            }
          });
        });

        // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
        jQuery.each({ Height: 'height', Width: 'width' }, function (name, type) {
          jQuery.each(
            {
              padding: 'inner' + name,
              content: type,
              '': 'outer' + name
            },
            function (defaultExtra, funcName) {
              // Margin is only for outerHeight, outerWidth
              jQuery.fn[funcName] = function (margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== 'boolean'),
                  extra = defaultExtra || (margin === true || value === true ? 'margin' : 'border');

                return access(
                  this,
                  function (elem, type, value) {
                    var doc;

                    if (isWindow(elem)) {
                      // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                      return funcName.indexOf('outer') === 0
                        ? elem['inner' + name]
                        : elem.document.documentElement['client' + name];
                    }

                    // Get document width or height
                    if (elem.nodeType === 9) {
                      doc = elem.documentElement;

                      // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                      // whichever is greatest
                      return Math.max(
                        elem.body['scroll' + name],
                        doc['scroll' + name],
                        elem.body['offset' + name],
                        doc['offset' + name],
                        doc['client' + name]
                      );
                    }

                    return value === undefined
                      ? // Get width or height on the element, requesting but not forcing parseFloat
                        jQuery.css(elem, type, extra)
                      : // Set width or height on the element
                        jQuery.style(elem, type, value, extra);
                  },
                  type,
                  chainable ? margin : undefined,
                  chainable
                );
              };
            }
          );
        });

        jQuery.each(
          ['ajaxStart', 'ajaxStop', 'ajaxComplete', 'ajaxError', 'ajaxSuccess', 'ajaxSend'],
          function (_i, type) {
            jQuery.fn[type] = function (fn) {
              return this.on(type, fn);
            };
          }
        );

        jQuery.fn.extend({
          bind: function (types, data, fn) {
            return this.on(types, null, data, fn);
          },
          unbind: function (types, fn) {
            return this.off(types, null, fn);
          },

          delegate: function (selector, types, data, fn) {
            return this.on(types, selector, data, fn);
          },
          undelegate: function (selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, '**') : this.off(types, selector || '**', fn);
          },

          hover: function (fnOver, fnOut) {
            return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
          }
        });

        jQuery.each(
          (
            'blur focus focusin focusout resize scroll click dblclick ' +
            'mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave ' +
            'change select submit keydown keypress keyup contextmenu'
          ).split(' '),
          function (_i, name) {
            // Handle event binding
            jQuery.fn[name] = function (data, fn) {
              return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
            };
          }
        );

        // Support: Android <=4.0 only
        // Make sure we trim BOM and NBSP
        var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

        // Bind a function to a context, optionally partially applying any
        // arguments.
        // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
        // However, it is not slated for removal any time soon
        jQuery.proxy = function (fn, context) {
          var tmp, args, proxy;

          if (typeof context === 'string') {
            tmp = fn[context];
            context = fn;
            fn = tmp;
          }

          // Quick check to determine if target is callable, in the spec
          // this throws a TypeError, but we will just return undefined.
          if (!isFunction(fn)) {
            return undefined;
          }

          // Simulated bind
          args = slice.call(arguments, 2);
          proxy = function () {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
          };

          // Set the guid of unique handler to the same of original handler, so it can be removed
          proxy.guid = fn.guid = fn.guid || jQuery.guid++;

          return proxy;
        };

        jQuery.holdReady = function (hold) {
          if (hold) {
            jQuery.readyWait++;
          } else {
            jQuery.ready(true);
          }
        };
        jQuery.isArray = Array.isArray;
        jQuery.parseJSON = JSON.parse;
        jQuery.nodeName = nodeName;
        jQuery.isFunction = isFunction;
        jQuery.isWindow = isWindow;
        jQuery.camelCase = camelCase;
        jQuery.type = toType;

        jQuery.now = Date.now;

        jQuery.isNumeric = function (obj) {
          // As of jQuery 3.0, isNumeric is limited to
          // strings and numbers (primitives or objects)
          // that can be coerced to finite numbers (gh-2662)
          var type = jQuery.type(obj);
          return (
            (type === 'number' || type === 'string') &&
            // parseFloat NaNs numeric-cast false positives ("")
            // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
            // subtraction forces infinities to NaN
            !isNaN(obj - parseFloat(obj))
          );
        };

        jQuery.trim = function (text) {
          return text == null ? '' : (text + '').replace(rtrim, '');
        };

        // Register as a named AMD module, since jQuery can be concatenated with other
        // files that may use define, but not via a proper concatenation script that
        // understands anonymous AMD modules. A named AMD is safest and most robust
        // way to register. Lowercase jquery is used because AMD module names are
        // derived from file names, and jQuery is normally delivered in a lowercase
        // file name. Do this after creating the global so that if an AMD module wants
        // to call noConflict to hide this version of jQuery, it will work.

        // Note that for maximum portability, libraries that are not jQuery should
        // declare themselves as anonymous modules, and avoid setting a global if an
        // AMD loader is present. jQuery is a special case. For more information, see
        // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

        if (true) {
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = []),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return jQuery;
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        }

        var // Map over jQuery in case of overwrite
          _jQuery = window.jQuery,
          // Map over the $ in case of overwrite
          _$ = window.$;

        jQuery.noConflict = function (deep) {
          if (window.$ === jQuery) {
            window.$ = _$;
          }

          if (deep && window.jQuery === jQuery) {
            window.jQuery = _jQuery;
          }

          return jQuery;
        };

        // Expose jQuery and $ identifiers, even in AMD
        // (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
        // and CommonJS for browser emulators (#13566)
        if (typeof noGlobal === 'undefined') {
          window.jQuery = window.$ = jQuery;
        }

        return jQuery;
      });

      /***/
    },
    /* 117 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // 25.4.1.5 NewPromiseCapability(C)
      var aFunction = __webpack_require__(74);

      function PromiseCapability(C) {
        var resolve, reject;
        this.promise = new C(function ($$resolve, $$reject) {
          if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
          resolve = $$resolve;
          reject = $$reject;
        });
        this.resolve = aFunction(resolve);
        this.reject = aFunction(reject);
      }

      module.exports.f = function (C) {
        return new PromiseCapability(C);
      };

      /***/
    },
    /* 118 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';
      /* WEBPACK VAR INJECTION */ (function (process) {
        var utils = __webpack_require__(19);
        var normalizeHeaderName = __webpack_require__(434);

        var DEFAULT_CONTENT_TYPE = {
          'Content-Type': 'application/x-www-form-urlencoded'
        };

        function setContentTypeIfUnset(headers, value) {
          if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
            headers['Content-Type'] = value;
          }
        }

        function getDefaultAdapter() {
          var adapter;
          if (typeof XMLHttpRequest !== 'undefined') {
            // For browsers use XHR adapter
            adapter = __webpack_require__(172);
          } else if (typeof process !== 'undefined') {
            // For node use HTTP adapter
            adapter = __webpack_require__(172);
          }
          return adapter;
        }

        var defaults = {
          adapter: getDefaultAdapter(),

          transformRequest: [
            function transformRequest(data, headers) {
              normalizeHeaderName(headers, 'Content-Type');
              if (
                utils.isFormData(data) ||
                utils.isArrayBuffer(data) ||
                utils.isBuffer(data) ||
                utils.isStream(data) ||
                utils.isFile(data) ||
                utils.isBlob(data)
              ) {
                return data;
              }
              if (utils.isArrayBufferView(data)) {
                return data.buffer;
              }
              if (utils.isURLSearchParams(data)) {
                setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
              }
              if (utils.isObject(data)) {
                setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
                return JSON.stringify(data);
              }
              return data;
            }
          ],

          transformResponse: [
            function transformResponse(data) {
              /*eslint no-param-reassign:0*/
              if (typeof data === 'string') {
                try {
                  data = JSON.parse(data);
                } catch (e) {
                  /* Ignore */
                }
              }
              return data;
            }
          ],

          timeout: 0,

          xsrfCookieName: 'XSRF-TOKEN',
          xsrfHeaderName: 'X-XSRF-TOKEN',

          maxContentLength: -1,

          validateStatus: function validateStatus(status) {
            return status >= 200 && status < 300;
          }
        };

        defaults.headers = {
          common: {
            Accept: 'application/json, text/plain, */*'
          }
        };

        utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
          defaults.headers[method] = {};
        });

        utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
          defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
        });

        module.exports = defaults;

        /* WEBPACK VAR INJECTION */
      }).call(exports, __webpack_require__(171));

      /***/
    },
    /* 119 */
    /***/ function (module, exports, __webpack_require__) {
      module.exports =
        !__webpack_require__(9) &&
        !__webpack_require__(1)(function () {
          return (
            Object.defineProperty(__webpack_require__(78)('div'), 'a', {
              get: function () {
                return 7;
              }
            }).a != 7
          );
        });

      /***/
    },
    /* 120 */
    /***/ function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var core = __webpack_require__(6);
      var LIBRARY = __webpack_require__(48);
      var wksExt = __webpack_require__(80);
      var defineProperty = __webpack_require__(7).f;
      module.exports = function (name) {
        var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
        if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
      };

      /***/
    },
    /* 121 */
    /***/ function (module, exports, __webpack_require__) {
      var has = __webpack_require__(12);
      var toIObject = __webpack_require__(17);
      var arrayIndexOf = __webpack_require__(64)(false);
      var IE_PROTO = __webpack_require__(81)('IE_PROTO');

      module.exports = function (object, names) {
        var O = toIObject(object);
        var i = 0;
        var result = [];
        var key;
        for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
        // Don't enum bug & hidden keys
        while (names.length > i)
          if (has(O, (key = names[i++]))) {
            ~arrayIndexOf(result, key) || result.push(key);
          }
        return result;
      };

      /***/
    },
    /* 122 */
    /***/ function (module, exports, __webpack_require__) {
      var dP = __webpack_require__(7);
      var anObject = __webpack_require__(4);
      var getKeys = __webpack_require__(40);

      module.exports = __webpack_require__(9)
        ? Object.defineProperties
        : function defineProperties(O, Properties) {
            anObject(O);
            var keys = getKeys(Properties);
            var length = keys.length;
            var i = 0;
            var P;
            while (length > i) dP.f(O, (P = keys[i++]), Properties[P]);
            return O;
          };

      /***/
    },
    /* 123 */
    /***/ function (module, exports, __webpack_require__) {
      // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
      var toIObject = __webpack_require__(17);
      var gOPN = __webpack_require__(43).f;
      var toString = {}.toString;

      var windowNames =
        typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

      var getWindowNames = function (it) {
        try {
          return gOPN(it);
        } catch (e) {
          return windowNames.slice();
        }
      };

      module.exports.f = function getOwnPropertyNames(it) {
        return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
      };

      /***/
    },
    /* 124 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // 19.1.2.1 Object.assign(target, source, ...)
      var getKeys = __webpack_require__(40);
      var gOPS = __webpack_require__(65);
      var pIE = __webpack_require__(60);
      var toObject = __webpack_require__(14);
      var IObject = __webpack_require__(59);
      var $assign = Object.assign;

      // should work with symbols and should have deterministic property order (V8 bug)
      module.exports =
        !$assign ||
        __webpack_require__(1)(function () {
          var A = {};
          var B = {};
          // eslint-disable-next-line no-undef
          var S = Symbol();
          var K = 'abcdefghijklmnopqrst';
          A[S] = 7;
          K.split('').forEach(function (k) {
            B[k] = k;
          });
          return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
        })
          ? function assign(target, source) {
              // eslint-disable-line no-unused-vars
              var T = toObject(target);
              var aLen = arguments.length;
              var index = 1;
              var getSymbols = gOPS.f;
              var isEnum = pIE.f;
              while (aLen > index) {
                var S = IObject(arguments[index++]);
                var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
                var length = keys.length;
                var j = 0;
                var key;
                while (length > j) if (isEnum.call(S, (key = keys[j++]))) T[key] = S[key];
              }
              return T;
            }
          : $assign;

      /***/
    },
    /* 125 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var aFunction = __webpack_require__(24);
      var isObject = __webpack_require__(2);
      var invoke = __webpack_require__(126);
      var arraySlice = [].slice;
      var factories = {};

      var construct = function (F, len, args) {
        if (!(len in factories)) {
          for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
          // eslint-disable-next-line no-new-func
          factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
        }
        return factories[len](F, args);
      };

      module.exports =
        Function.bind ||
        function bind(that /* , ...args */) {
          var fn = aFunction(this);
          var partArgs = arraySlice.call(arguments, 1);
          var bound = function (/* args... */) {
            var args = partArgs.concat(arraySlice.call(arguments));
            return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
          };
          if (isObject(fn.prototype)) bound.prototype = fn.prototype;
          return bound;
        };

      /***/
    },
    /* 126 */
    /***/ function (module, exports) {
      // fast apply, http://jsperf.lnkit.com/fast-apply/5
      module.exports = function (fn, args, that) {
        var un = that === undefined;
        switch (args.length) {
          case 0:
            return un ? fn() : fn.call(that);
          case 1:
            return un ? fn(args[0]) : fn.call(that, args[0]);
          case 2:
            return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
          case 3:
            return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
          case 4:
            return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
        }
        return fn.apply(that, args);
      };

      /***/
    },
    /* 127 */
    /***/ function (module, exports, __webpack_require__) {
      var $parseInt = __webpack_require__(3).parseInt;
      var $trim = __webpack_require__(49).trim;
      var ws = __webpack_require__(85);
      var hex = /^[-+]?0[xX]/;

      module.exports =
        $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22
          ? function parseInt(str, radix) {
              var string = $trim(String(str), 3);
              return $parseInt(string, radix >>> 0 || (hex.test(string) ? 16 : 10));
            }
          : $parseInt;

      /***/
    },
    /* 128 */
    /***/ function (module, exports, __webpack_require__) {
      var $parseFloat = __webpack_require__(3).parseFloat;
      var $trim = __webpack_require__(49).trim;

      module.exports =
        1 / $parseFloat(__webpack_require__(85) + '-0') !== -Infinity
          ? function parseFloat(str) {
              var string = $trim(String(str), 3);
              var result = $parseFloat(string);
              return result === 0 && string.charAt(0) == '-' ? -0 : result;
            }
          : $parseFloat;

      /***/
    },
    /* 129 */
    /***/ function (module, exports, __webpack_require__) {
      var cof = __webpack_require__(28);
      module.exports = function (it, msg) {
        if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
        return +it;
      };

      /***/
    },
    /* 130 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.1.2.3 Number.isInteger(number)
      var isObject = __webpack_require__(2);
      var floor = Math.floor;
      module.exports = function isInteger(it) {
        return !isObject(it) && isFinite(it) && floor(it) === it;
      };

      /***/
    },
    /* 131 */
    /***/ function (module, exports) {
      // 20.2.2.20 Math.log1p(x)
      module.exports =
        Math.log1p ||
        function log1p(x) {
          return (x = +x) > -1e-8 && x < 1e-8 ? x - (x * x) / 2 : Math.log(1 + x);
        };

      /***/
    },
    /* 132 */
    /***/ function (module, exports, __webpack_require__) {
      var toInteger = __webpack_require__(30);
      var defined = __webpack_require__(29);
      // true  -> String#at
      // false -> String#codePointAt
      module.exports = function (TO_STRING) {
        return function (that, pos) {
          var s = String(defined(that));
          var i = toInteger(pos);
          var l = s.length;
          var a, b;
          if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
          a = s.charCodeAt(i);
          return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
            ? TO_STRING
              ? s.charAt(i)
              : a
            : TO_STRING
              ? s.slice(i, i + 2)
              : ((a - 0xd800) << 10) + (b - 0xdc00) + 0x10000;
        };
      };

      /***/
    },
    /* 133 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var create = __webpack_require__(42);
      var descriptor = __webpack_require__(38);
      var setToStringTag = __webpack_require__(47);
      var IteratorPrototype = {};

      // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
      __webpack_require__(16)(IteratorPrototype, __webpack_require__(5)('iterator'), function () {
        return this;
      });

      module.exports = function (Constructor, NAME, next) {
        Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
        setToStringTag(Constructor, NAME + ' Iterator');
      };

      /***/
    },
    /* 134 */
    /***/ function (module, exports, __webpack_require__) {
      // call something on iterator step with safe closing on error
      var anObject = __webpack_require__(4);
      module.exports = function (iterator, fn, value, entries) {
        try {
          return entries ? fn(anObject(value)[0], value[1]) : fn(value);
          // 7.4.6 IteratorClose(iterator, completion)
        } catch (e) {
          var ret = iterator['return'];
          if (ret !== undefined) anObject(ret.call(iterator));
          throw e;
        }
      };

      /***/
    },
    /* 135 */
    /***/ function (module, exports, __webpack_require__) {
      // 9.4.2.3 ArraySpeciesCreate(originalArray, length)
      var speciesConstructor = __webpack_require__(273);

      module.exports = function (original, length) {
        return new (speciesConstructor(original))(length);
      };

      /***/
    },
    /* 136 */
    /***/ function (module, exports, __webpack_require__) {
      var aFunction = __webpack_require__(24);
      var toObject = __webpack_require__(14);
      var IObject = __webpack_require__(59);
      var toLength = __webpack_require__(8);

      module.exports = function (that, callbackfn, aLen, memo, isRight) {
        aFunction(callbackfn);
        var O = toObject(that);
        var self = IObject(O);
        var length = toLength(O.length);
        var index = isRight ? length - 1 : 0;
        var i = isRight ? -1 : 1;
        if (aLen < 2)
          for (;;) {
            if (index in self) {
              memo = self[index];
              index += i;
              break;
            }
            index += i;
            if (isRight ? index < 0 : length <= index) {
              throw TypeError('Reduce of empty array with no initial value');
            }
          }
        for (; isRight ? index >= 0 : length > index; index += i)
          if (index in self) {
            memo = callbackfn(memo, self[index], index, O);
          }
        return memo;
      };

      /***/
    },
    /* 137 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';
      // 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

      var toObject = __webpack_require__(14);
      var toAbsoluteIndex = __webpack_require__(41);
      var toLength = __webpack_require__(8);

      module.exports =
        [].copyWithin ||
        function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
          var O = toObject(this);
          var len = toLength(O.length);
          var to = toAbsoluteIndex(target, len);
          var from = toAbsoluteIndex(start, len);
          var end = arguments.length > 2 ? arguments[2] : undefined;
          var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
          var inc = 1;
          if (from < to && to < from + count) {
            inc = -1;
            from += count - 1;
            to += count - 1;
          }
          while (count-- > 0) {
            if (from in O) O[to] = O[from];
            else delete O[to];
            to += inc;
            from += inc;
          }
          return O;
        };

      /***/
    },
    /* 138 */
    /***/ function (module, exports) {
      module.exports = function (done, value) {
        return { value: value, done: !!done };
      };

      /***/
    },
    /* 139 */
    /***/ function (module, exports, __webpack_require__) {
      // 21.2.5.3 get RegExp.prototype.flags()
      if (__webpack_require__(9) && /./g.flags != 'g')
        __webpack_require__(7).f(RegExp.prototype, 'flags', {
          configurable: true,
          get: __webpack_require__(99)
        });

      /***/
    },
    /* 140 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var LIBRARY = __webpack_require__(48);
      var global = __webpack_require__(3);
      var ctx = __webpack_require__(23);
      var classof = __webpack_require__(67);
      var $export = __webpack_require__(0);
      var isObject = __webpack_require__(2);
      var aFunction = __webpack_require__(24);
      var anInstance = __webpack_require__(52);
      var forOf = __webpack_require__(70);
      var speciesConstructor = __webpack_require__(71);
      var task = __webpack_require__(100).set;
      var microtask = __webpack_require__(293)();
      var newPromiseCapabilityModule = __webpack_require__(141);
      var perform = __webpack_require__(294);
      var promiseResolve = __webpack_require__(142);
      var PROMISE = 'Promise';
      var TypeError = global.TypeError;
      var process = global.process;
      var $Promise = global[PROMISE];
      var isNode = classof(process) == 'process';
      var empty = function () {
        /* empty */
      };
      var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
      var newPromiseCapability = (newGenericPromiseCapability = newPromiseCapabilityModule.f);

      var USE_NATIVE = !!(function () {
        try {
          // correct subclassing with @@species support
          var promise = $Promise.resolve(1);
          var FakePromise = ((promise.constructor = {})[__webpack_require__(5)('species')] = function (exec) {
            exec(empty, empty);
          });
          // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
          return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
        } catch (e) {
          /* empty */
        }
      })();

      // helpers
      var isThenable = function (it) {
        var then;
        return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
      };
      var notify = function (promise, isReject) {
        if (promise._n) return;
        promise._n = true;
        var chain = promise._c;
        microtask(function () {
          var value = promise._v;
          var ok = promise._s == 1;
          var i = 0;
          var run = function (reaction) {
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then;
            try {
              if (handler) {
                if (!ok) {
                  if (promise._h == 2) onHandleUnhandled(promise);
                  promise._h = 1;
                }
                if (handler === true) result = value;
                else {
                  if (domain) domain.enter();
                  result = handler(value);
                  if (domain) domain.exit();
                }
                if (result === reaction.promise) {
                  reject(TypeError('Promise-chain cycle'));
                } else if ((then = isThenable(result))) {
                  then.call(result, resolve, reject);
                } else resolve(result);
              } else reject(value);
            } catch (e) {
              reject(e);
            }
          };
          while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
          promise._c = [];
          promise._n = false;
          if (isReject && !promise._h) onUnhandled(promise);
        });
      };
      var onUnhandled = function (promise) {
        task.call(global, function () {
          var value = promise._v;
          var unhandled = isUnhandled(promise);
          var result, handler, console;
          if (unhandled) {
            result = perform(function () {
              if (isNode) {
                process.emit('unhandledRejection', value, promise);
              } else if ((handler = global.onunhandledrejection)) {
                handler({ promise: promise, reason: value });
              } else if ((console = global.console) && console.error) {
                console.error('Unhandled promise rejection', value);
              }
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            promise._h = isNode || isUnhandled(promise) ? 2 : 1;
          }
          promise._a = undefined;
          if (unhandled && result.e) throw result.v;
        });
      };
      var isUnhandled = function (promise) {
        if (promise._h == 1) return false;
        var chain = promise._a || promise._c;
        var i = 0;
        var reaction;
        while (chain.length > i) {
          reaction = chain[i++];
          if (reaction.fail || !isUnhandled(reaction.promise)) return false;
        }
        return true;
      };
      var onHandleUnhandled = function (promise) {
        task.call(global, function () {
          var handler;
          if (isNode) {
            process.emit('rejectionHandled', promise);
          } else if ((handler = global.onrejectionhandled)) {
            handler({ promise: promise, reason: promise._v });
          }
        });
      };
      var $reject = function (value) {
        var promise = this;
        if (promise._d) return;
        promise._d = true;
        promise = promise._w || promise; // unwrap
        promise._v = value;
        promise._s = 2;
        if (!promise._a) promise._a = promise._c.slice();
        notify(promise, true);
      };
      var $resolve = function (value) {
        var promise = this;
        var then;
        if (promise._d) return;
        promise._d = true;
        promise = promise._w || promise; // unwrap
        try {
          if (promise === value) throw TypeError("Promise can't be resolved itself");
          if ((then = isThenable(value))) {
            microtask(function () {
              var wrapper = { _w: promise, _d: false }; // wrap
              try {
                then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
              } catch (e) {
                $reject.call(wrapper, e);
              }
            });
          } else {
            promise._v = value;
            promise._s = 1;
            notify(promise, false);
          }
        } catch (e) {
          $reject.call({ _w: promise, _d: false }, e); // wrap
        }
      };

      // constructor polyfill
      if (!USE_NATIVE) {
        // 25.4.3.1 Promise(executor)
        $Promise = function Promise(executor) {
          anInstance(this, $Promise, PROMISE, '_h');
          aFunction(executor);
          Internal.call(this);
          try {
            executor(ctx($resolve, this, 1), ctx($reject, this, 1));
          } catch (err) {
            $reject.call(this, err);
          }
        };
        // eslint-disable-next-line no-unused-vars
        Internal = function Promise(executor) {
          this._c = []; // <- awaiting reactions
          this._a = undefined; // <- checked in isUnhandled reactions
          this._s = 0; // <- state
          this._d = false; // <- done
          this._v = undefined; // <- value
          this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
          this._n = false; // <- notify
        };
        Internal.prototype = __webpack_require__(53)($Promise.prototype, {
          // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
          then: function then(onFulfilled, onRejected) {
            var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
            reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
            reaction.fail = typeof onRejected == 'function' && onRejected;
            reaction.domain = isNode ? process.domain : undefined;
            this._c.push(reaction);
            if (this._a) this._a.push(reaction);
            if (this._s) notify(this, false);
            return reaction.promise;
          },
          // 25.4.5.1 Promise.prototype.catch(onRejected)
          catch: function (onRejected) {
            return this.then(undefined, onRejected);
          }
        });
        OwnPromiseCapability = function () {
          var promise = new Internal();
          this.promise = promise;
          this.resolve = ctx($resolve, promise, 1);
          this.reject = ctx($reject, promise, 1);
        };
        newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
          return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
        };
      }

      $export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
      __webpack_require__(47)($Promise, PROMISE);
      __webpack_require__(51)(PROMISE);
      Wrapper = __webpack_require__(6)[PROMISE];

      // statics
      $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
        // 25.4.4.5 Promise.reject(r)
        reject: function reject(r) {
          var capability = newPromiseCapability(this);
          var $$reject = capability.reject;
          $$reject(r);
          return capability.promise;
        }
      });
      $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
        // 25.4.4.6 Promise.resolve(x)
        resolve: function resolve(x) {
          return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
        }
      });
      $export(
        $export.S +
          $export.F *
            !(
              USE_NATIVE &&
              __webpack_require__(68)(function (iter) {
                $Promise.all(iter)['catch'](empty);
              })
            ),
        PROMISE,
        {
          // 25.4.4.1 Promise.all(iterable)
          all: function all(iterable) {
            var C = this;
            var capability = newPromiseCapability(C);
            var resolve = capability.resolve;
            var reject = capability.reject;
            var result = perform(function () {
              var values = [];
              var index = 0;
              var remaining = 1;
              forOf(iterable, false, function (promise) {
                var $index = index++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                C.resolve(promise).then(function (value) {
                  if (alreadyCalled) return;
                  alreadyCalled = true;
                  values[$index] = value;
                  --remaining || resolve(values);
                }, reject);
              });
              --remaining || resolve(values);
            });
            if (result.e) reject(result.v);
            return capability.promise;
          },
          // 25.4.4.4 Promise.race(iterable)
          race: function race(iterable) {
            var C = this;
            var capability = newPromiseCapability(C);
            var reject = capability.reject;
            var result = perform(function () {
              forOf(iterable, false, function (promise) {
                C.resolve(promise).then(capability.resolve, reject);
              });
            });
            if (result.e) reject(result.v);
            return capability.promise;
          }
        }
      );

      /***/
    },
    /* 141 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // 25.4.1.5 NewPromiseCapability(C)
      var aFunction = __webpack_require__(24);

      function PromiseCapability(C) {
        var resolve, reject;
        this.promise = new C(function ($$resolve, $$reject) {
          if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
          resolve = $$resolve;
          reject = $$reject;
        });
        this.resolve = aFunction(resolve);
        this.reject = aFunction(reject);
      }

      module.exports.f = function (C) {
        return new PromiseCapability(C);
      };

      /***/
    },
    /* 142 */
    /***/ function (module, exports, __webpack_require__) {
      var anObject = __webpack_require__(4);
      var isObject = __webpack_require__(2);
      var newPromiseCapability = __webpack_require__(141);

      module.exports = function (C, x) {
        anObject(C);
        if (isObject(x) && x.constructor === C) return x;
        var promiseCapability = newPromiseCapability.f(C);
        var resolve = promiseCapability.resolve;
        resolve(x);
        return promiseCapability.promise;
      };

      /***/
    },
    /* 143 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var dP = __webpack_require__(7).f;
      var create = __webpack_require__(42);
      var redefineAll = __webpack_require__(53);
      var ctx = __webpack_require__(23);
      var anInstance = __webpack_require__(52);
      var forOf = __webpack_require__(70);
      var $iterDefine = __webpack_require__(90);
      var step = __webpack_require__(138);
      var setSpecies = __webpack_require__(51);
      var DESCRIPTORS = __webpack_require__(9);
      var fastKey = __webpack_require__(33).fastKey;
      var validate = __webpack_require__(54);
      var SIZE = DESCRIPTORS ? '_s' : 'size';

      var getEntry = function (that, key) {
        // fast case
        var index = fastKey(key);
        var entry;
        if (index !== 'F') return that._i[index];
        // frozen object case
        for (entry = that._f; entry; entry = entry.n) {
          if (entry.k == key) return entry;
        }
      };

      module.exports = {
        getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
          var C = wrapper(function (that, iterable) {
            anInstance(that, C, NAME, '_i');
            that._t = NAME; // collection type
            that._i = create(null); // index
            that._f = undefined; // first entry
            that._l = undefined; // last entry
            that[SIZE] = 0; // size
            if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
          });
          redefineAll(C.prototype, {
            // 23.1.3.1 Map.prototype.clear()
            // 23.2.3.2 Set.prototype.clear()
            clear: function clear() {
              for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
                entry.r = true;
                if (entry.p) entry.p = entry.p.n = undefined;
                delete data[entry.i];
              }
              that._f = that._l = undefined;
              that[SIZE] = 0;
            },
            // 23.1.3.3 Map.prototype.delete(key)
            // 23.2.3.4 Set.prototype.delete(value)
            delete: function (key) {
              var that = validate(this, NAME);
              var entry = getEntry(that, key);
              if (entry) {
                var next = entry.n;
                var prev = entry.p;
                delete that._i[entry.i];
                entry.r = true;
                if (prev) prev.n = next;
                if (next) next.p = prev;
                if (that._f == entry) that._f = next;
                if (that._l == entry) that._l = prev;
                that[SIZE]--;
              }
              return !!entry;
            },
            // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
            // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
            forEach: function forEach(callbackfn /* , that = undefined */) {
              validate(this, NAME);
              var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
              var entry;
              while ((entry = entry ? entry.n : this._f)) {
                f(entry.v, entry.k, this);
                // revert to the last existing entry
                while (entry && entry.r) entry = entry.p;
              }
            },
            // 23.1.3.7 Map.prototype.has(key)
            // 23.2.3.7 Set.prototype.has(value)
            has: function has(key) {
              return !!getEntry(validate(this, NAME), key);
            }
          });
          if (DESCRIPTORS)
            dP(C.prototype, 'size', {
              get: function () {
                return validate(this, NAME)[SIZE];
              }
            });
          return C;
        },
        def: function (that, key, value) {
          var entry = getEntry(that, key);
          var prev, index;
          // change existing entry
          if (entry) {
            entry.v = value;
            // create new entry
          } else {
            that._l = entry = {
              i: (index = fastKey(key, true)), // <- index
              k: key, // <- key
              v: value, // <- value
              p: (prev = that._l), // <- previous entry
              n: undefined, // <- next entry
              r: false // <- removed
            };
            if (!that._f) that._f = entry;
            if (prev) prev.n = entry;
            that[SIZE]++;
            // add to index
            if (index !== 'F') that._i[index] = entry;
          }
          return that;
        },
        getEntry: getEntry,
        setStrong: function (C, NAME, IS_MAP) {
          // add .keys, .values, .entries, [@@iterator]
          // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
          $iterDefine(
            C,
            NAME,
            function (iterated, kind) {
              this._t = validate(iterated, NAME); // target
              this._k = kind; // kind
              this._l = undefined; // previous
            },
            function () {
              var that = this;
              var kind = that._k;
              var entry = that._l;
              // revert to the last existing entry
              while (entry && entry.r) entry = entry.p;
              // get next entry
              if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
                // or finish the iteration
                that._t = undefined;
                return step(1);
              }
              // return step by kind
              if (kind == 'keys') return step(0, entry.k);
              if (kind == 'values') return step(0, entry.v);
              return step(0, [entry.k, entry.v]);
            },
            IS_MAP ? 'entries' : 'values',
            !IS_MAP,
            true
          );

          // add [@@species], 23.1.2.2, 23.2.2.2
          setSpecies(NAME);
        }
      };

      /***/
    },
    /* 144 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var redefineAll = __webpack_require__(53);
      var getWeak = __webpack_require__(33).getWeak;
      var anObject = __webpack_require__(4);
      var isObject = __webpack_require__(2);
      var anInstance = __webpack_require__(52);
      var forOf = __webpack_require__(70);
      var createArrayMethod = __webpack_require__(27);
      var $has = __webpack_require__(12);
      var validate = __webpack_require__(54);
      var arrayFind = createArrayMethod(5);
      var arrayFindIndex = createArrayMethod(6);
      var id = 0;

      // fallback for uncaught frozen keys
      var uncaughtFrozenStore = function (that) {
        return that._l || (that._l = new UncaughtFrozenStore());
      };
      var UncaughtFrozenStore = function () {
        this.a = [];
      };
      var findUncaughtFrozen = function (store, key) {
        return arrayFind(store.a, function (it) {
          return it[0] === key;
        });
      };
      UncaughtFrozenStore.prototype = {
        get: function (key) {
          var entry = findUncaughtFrozen(this, key);
          if (entry) return entry[1];
        },
        has: function (key) {
          return !!findUncaughtFrozen(this, key);
        },
        set: function (key, value) {
          var entry = findUncaughtFrozen(this, key);
          if (entry) entry[1] = value;
          else this.a.push([key, value]);
        },
        delete: function (key) {
          var index = arrayFindIndex(this.a, function (it) {
            return it[0] === key;
          });
          if (~index) this.a.splice(index, 1);
          return !!~index;
        }
      };

      module.exports = {
        getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
          var C = wrapper(function (that, iterable) {
            anInstance(that, C, NAME, '_i');
            that._t = NAME; // collection type
            that._i = id++; // collection id
            that._l = undefined; // leak store for uncaught frozen objects
            if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
          });
          redefineAll(C.prototype, {
            // 23.3.3.2 WeakMap.prototype.delete(key)
            // 23.4.3.3 WeakSet.prototype.delete(value)
            delete: function (key) {
              if (!isObject(key)) return false;
              var data = getWeak(key);
              if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
              return data && $has(data, this._i) && delete data[this._i];
            },
            // 23.3.3.4 WeakMap.prototype.has(key)
            // 23.4.3.4 WeakSet.prototype.has(value)
            has: function has(key) {
              if (!isObject(key)) return false;
              var data = getWeak(key);
              if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
              return data && $has(data, this._i);
            }
          });
          return C;
        },
        def: function (that, key, value) {
          var data = getWeak(anObject(key), true);
          if (data === true) uncaughtFrozenStore(that).set(key, value);
          else data[that._i] = value;
          return that;
        },
        ufstore: uncaughtFrozenStore
      };

      /***/
    },
    /* 145 */
    /***/ function (module, exports, __webpack_require__) {
      // https://tc39.github.io/ecma262/#sec-toindex
      var toInteger = __webpack_require__(30);
      var toLength = __webpack_require__(8);
      module.exports = function (it) {
        if (it === undefined) return 0;
        var number = toInteger(it);
        var length = toLength(number);
        if (number !== length) throw RangeError('Wrong length!');
        return length;
      };

      /***/
    },
    /* 146 */
    /***/ function (module, exports, __webpack_require__) {
      // all object keys, includes non-enumerable and symbols
      var gOPN = __webpack_require__(43);
      var gOPS = __webpack_require__(65);
      var anObject = __webpack_require__(4);
      var Reflect = __webpack_require__(3).Reflect;
      module.exports =
        (Reflect && Reflect.ownKeys) ||
        function ownKeys(it) {
          var keys = gOPN.f(anObject(it));
          var getSymbols = gOPS.f;
          return getSymbols ? keys.concat(getSymbols(it)) : keys;
        };

      /***/
    },
    /* 147 */
    /***/ function (module, exports, __webpack_require__) {
      // https://github.com/tc39/proposal-string-pad-start-end
      var toLength = __webpack_require__(8);
      var repeat = __webpack_require__(87);
      var defined = __webpack_require__(29);

      module.exports = function (that, maxLength, fillString, left) {
        var S = String(defined(that));
        var stringLength = S.length;
        var fillStr = fillString === undefined ? ' ' : String(fillString);
        var intMaxLength = toLength(maxLength);
        if (intMaxLength <= stringLength || fillStr == '') return S;
        var fillLen = intMaxLength - stringLength;
        var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
        if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
        return left ? stringFiller + S : S + stringFiller;
      };

      /***/
    },
    /* 148 */
    /***/ function (module, exports, __webpack_require__) {
      var getKeys = __webpack_require__(40);
      var toIObject = __webpack_require__(17);
      var isEnum = __webpack_require__(60).f;
      module.exports = function (isEntries) {
        return function (it) {
          var O = toIObject(it);
          var keys = getKeys(O);
          var length = keys.length;
          var i = 0;
          var result = [];
          var key;
          while (length > i)
            if (isEnum.call(O, (key = keys[i++]))) {
              result.push(isEntries ? [key, O[key]] : O[key]);
            }
          return result;
        };
      };

      /***/
    },
    /* 149 */
    /***/ function (module, exports) {
      /**
       * Copyright (c) 2014-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      !(function (global) {
        'use strict';

        var Op = Object.prototype;
        var hasOwn = Op.hasOwnProperty;
        var undefined; // More compressible than void 0.
        var $Symbol = typeof Symbol === 'function' ? Symbol : {};
        var iteratorSymbol = $Symbol.iterator || '@@iterator';
        var asyncIteratorSymbol = $Symbol.asyncIterator || '@@asyncIterator';
        var toStringTagSymbol = $Symbol.toStringTag || '@@toStringTag';

        var inModule = typeof module === 'object';
        var runtime = global.regeneratorRuntime;
        if (runtime) {
          if (inModule) {
            // If regeneratorRuntime is defined globally and we're in a module,
            // make the exports object identical to regeneratorRuntime.
            module.exports = runtime;
          }
          // Don't bother evaluating the rest of this file if the runtime was
          // already defined globally.
          return;
        }

        // Define the runtime globally (as expected by generated code) as either
        // module.exports (if we're in a module) or a new, empty object.
        runtime = global.regeneratorRuntime = inModule ? module.exports : {};

        function wrap(innerFn, outerFn, self, tryLocsList) {
          // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
          var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
          var generator = Object.create(protoGenerator.prototype);
          var context = new Context(tryLocsList || []);

          // The ._invoke method unifies the implementations of the .next,
          // .throw, and .return methods.
          generator._invoke = makeInvokeMethod(innerFn, self, context);

          return generator;
        }
        runtime.wrap = wrap;

        // Try/catch helper to minimize deoptimizations. Returns a completion
        // record like context.tryEntries[i].completion. This interface could
        // have been (and was previously) designed to take a closure to be
        // invoked without arguments, but in all the cases we care about we
        // already have an existing method we want to call, so there's no need
        // to create a new function object. We can even get away with assuming
        // the method takes exactly one argument, since that happens to be true
        // in every case, so we don't have to touch the arguments object. The
        // only additional allocation required is the completion record, which
        // has a stable shape and so hopefully should be cheap to allocate.
        function tryCatch(fn, obj, arg) {
          try {
            return { type: 'normal', arg: fn.call(obj, arg) };
          } catch (err) {
            return { type: 'throw', arg: err };
          }
        }

        var GenStateSuspendedStart = 'suspendedStart';
        var GenStateSuspendedYield = 'suspendedYield';
        var GenStateExecuting = 'executing';
        var GenStateCompleted = 'completed';

        // Returning this object from the innerFn has the same effect as
        // breaking out of the dispatch switch statement.
        var ContinueSentinel = {};

        // Dummy constructor functions that we use as the .constructor and
        // .constructor.prototype properties for functions that return Generator
        // objects. For full spec compliance, you may wish to configure your
        // minifier not to mangle the names of these two functions.
        function Generator() {}
        function GeneratorFunction() {}
        function GeneratorFunctionPrototype() {}

        // This is a polyfill for %IteratorPrototype% for environments that
        // don't natively support it.
        var IteratorPrototype = {};
        IteratorPrototype[iteratorSymbol] = function () {
          return this;
        };

        var getProto = Object.getPrototypeOf;
        var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
        if (
          NativeIteratorPrototype &&
          NativeIteratorPrototype !== Op &&
          hasOwn.call(NativeIteratorPrototype, iteratorSymbol)
        ) {
          // This environment has a native %IteratorPrototype%; use it instead
          // of the polyfill.
          IteratorPrototype = NativeIteratorPrototype;
        }

        var Gp = (GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype));
        GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
        GeneratorFunctionPrototype.constructor = GeneratorFunction;
        GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = 'GeneratorFunction';

        // Helper for defining the .next, .throw, and .return methods of the
        // Iterator interface in terms of a single ._invoke method.
        function defineIteratorMethods(prototype) {
          ['next', 'throw', 'return'].forEach(function (method) {
            prototype[method] = function (arg) {
              return this._invoke(method, arg);
            };
          });
        }

        runtime.isGeneratorFunction = function (genFun) {
          var ctor = typeof genFun === 'function' && genFun.constructor;
          return ctor
            ? ctor === GeneratorFunction ||
                // For the native GeneratorFunction constructor, the best we can
                // do is to check its .name property.
                (ctor.displayName || ctor.name) === 'GeneratorFunction'
            : false;
        };

        runtime.mark = function (genFun) {
          if (Object.setPrototypeOf) {
            Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
          } else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            if (!(toStringTagSymbol in genFun)) {
              genFun[toStringTagSymbol] = 'GeneratorFunction';
            }
          }
          genFun.prototype = Object.create(Gp);
          return genFun;
        };

        // Within the body of any async function, `await x` is transformed to
        // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
        // `hasOwn.call(value, "__await")` to determine if the yielded value is
        // meant to be awaited.
        runtime.awrap = function (arg) {
          return { __await: arg };
        };

        function AsyncIterator(generator) {
          function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === 'throw') {
              reject(record.arg);
            } else {
              var result = record.arg;
              var value = result.value;
              if (value && typeof value === 'object' && hasOwn.call(value, '__await')) {
                return Promise.resolve(value.__await).then(
                  function (value) {
                    invoke('next', value, resolve, reject);
                  },
                  function (err) {
                    invoke('throw', err, resolve, reject);
                  }
                );
              }

              return Promise.resolve(value).then(function (unwrapped) {
                // When a yielded Promise is resolved, its final value becomes
                // the .value of the Promise<{value,done}> result for the
                // current iteration. If the Promise is rejected, however, the
                // result for this iteration will be rejected with the same
                // reason. Note that rejections of yielded Promises are not
                // thrown back into the generator function, as is the case
                // when an awaited Promise is rejected. This difference in
                // behavior between yield and await is important, because it
                // allows the consumer to decide what to do with the yielded
                // rejection (swallow it and continue, manually .throw it back
                // into the generator, abandon iteration, whatever). With
                // await, by contrast, there is no opportunity to examine the
                // rejection reason outside the generator function, so the
                // only option is to throw it from the await expression, and
                // let the generator function handle the exception.
                result.value = unwrapped;
                resolve(result);
              }, reject);
            }
          }

          var previousPromise;

          function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
              return new Promise(function (resolve, reject) {
                invoke(method, arg, resolve, reject);
              });
            }

            return (previousPromise =
              // If enqueue has been called before, then we want to wait until
              // all previous Promises have been resolved before calling invoke,
              // so that results are always delivered in the correct order. If
              // enqueue has not been called before, then it is important to
              // call invoke immediately, without waiting on a callback to fire,
              // so that the async generator function has the opportunity to do
              // any necessary setup in a predictable way. This predictability
              // is why the Promise constructor synchronously invokes its
              // executor callback, and why async functions synchronously
              // execute code before the first await. Since we implement simple
              // async functions in terms of async generators, it is especially
              // important to get this right, even though it requires care.
              previousPromise
                ? previousPromise.then(
                    callInvokeWithMethodAndArg,
                    // Avoid propagating failures to Promises returned by later
                    // invocations of the iterator.
                    callInvokeWithMethodAndArg
                  )
                : callInvokeWithMethodAndArg());
          }

          // Define the unified helper method that is used to implement .next,
          // .throw, and .return (see defineIteratorMethods).
          this._invoke = enqueue;
        }

        defineIteratorMethods(AsyncIterator.prototype);
        AsyncIterator.prototype[asyncIteratorSymbol] = function () {
          return this;
        };
        runtime.AsyncIterator = AsyncIterator;

        // Note that simple async functions are implemented on top of
        // AsyncIterator objects; they just return a Promise for the value of
        // the final result produced by the iterator.
        runtime.async = function (innerFn, outerFn, self, tryLocsList) {
          var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));

          return runtime.isGeneratorFunction(outerFn)
            ? iter // If outerFn is a generator, return the full iterator.
            : iter.next().then(function (result) {
                return result.done ? result.value : iter.next();
              });
        };

        function makeInvokeMethod(innerFn, self, context) {
          var state = GenStateSuspendedStart;

          return function invoke(method, arg) {
            if (state === GenStateExecuting) {
              throw new Error('Generator is already running');
            }

            if (state === GenStateCompleted) {
              if (method === 'throw') {
                throw arg;
              }

              // Be forgiving, per 25.3.3.3.3 of the spec:
              // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
              return doneResult();
            }

            context.method = method;
            context.arg = arg;

            while (true) {
              var delegate = context.delegate;
              if (delegate) {
                var delegateResult = maybeInvokeDelegate(delegate, context);
                if (delegateResult) {
                  if (delegateResult === ContinueSentinel) continue;
                  return delegateResult;
                }
              }

              if (context.method === 'next') {
                // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
              } else if (context.method === 'throw') {
                if (state === GenStateSuspendedStart) {
                  state = GenStateCompleted;
                  throw context.arg;
                }

                context.dispatchException(context.arg);
              } else if (context.method === 'return') {
                context.abrupt('return', context.arg);
              }

              state = GenStateExecuting;

              var record = tryCatch(innerFn, self, context);
              if (record.type === 'normal') {
                // If an exception is thrown from innerFn, we leave state ===
                // GenStateExecuting and loop back for another invocation.
                state = context.done ? GenStateCompleted : GenStateSuspendedYield;

                if (record.arg === ContinueSentinel) {
                  continue;
                }

                return {
                  value: record.arg,
                  done: context.done
                };
              } else if (record.type === 'throw') {
                state = GenStateCompleted;
                // Dispatch the exception by looping back around to the
                // context.dispatchException(context.arg) call above.
                context.method = 'throw';
                context.arg = record.arg;
              }
            }
          };
        }

        // Call delegate.iterator[context.method](context.arg) and handle the
        // result, either by returning a { value, done } result from the
        // delegate iterator, or by modifying context.method and context.arg,
        // setting context.delegate to null, and returning the ContinueSentinel.
        function maybeInvokeDelegate(delegate, context) {
          var method = delegate.iterator[context.method];
          if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method always terminates the yield* loop.
            context.delegate = null;

            if (context.method === 'throw') {
              if (delegate.iterator.return) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = 'return';
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);

                if (context.method === 'throw') {
                  // If maybeInvokeDelegate(context) changed context.method from
                  // "return" to "throw", let that override the TypeError below.
                  return ContinueSentinel;
                }
              }

              context.method = 'throw';
              context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return ContinueSentinel;
          }

          var record = tryCatch(method, delegate.iterator, context.arg);

          if (record.type === 'throw') {
            context.method = 'throw';
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
          }

          var info = record.arg;

          if (!info) {
            context.method = 'throw';
            context.arg = new TypeError('iterator result is not an object');
            context.delegate = null;
            return ContinueSentinel;
          }

          if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;

            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;

            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== 'return') {
              context.method = 'next';
              context.arg = undefined;
            }
          } else {
            // Re-yield the result returned by the delegate method.
            return info;
          }

          // The delegate iterator is finished, so forget it and continue with
          // the outer generator.
          context.delegate = null;
          return ContinueSentinel;
        }

        // Define Generator.prototype.{next,throw,return} in terms of the
        // unified ._invoke helper method.
        defineIteratorMethods(Gp);

        Gp[toStringTagSymbol] = 'Generator';

        // A Generator should always return itself as the iterator object when the
        // @@iterator function is called on it. Some browsers' implementations of the
        // iterator prototype chain incorrectly implement this, causing the Generator
        // object to not be returned from this call. This ensures that doesn't happen.
        // See https://github.com/facebook/regenerator/issues/274 for more details.
        Gp[iteratorSymbol] = function () {
          return this;
        };

        Gp.toString = function () {
          return '[object Generator]';
        };

        function pushTryEntry(locs) {
          var entry = { tryLoc: locs[0] };

          if (1 in locs) {
            entry.catchLoc = locs[1];
          }

          if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
          }

          this.tryEntries.push(entry);
        }

        function resetTryEntry(entry) {
          var record = entry.completion || {};
          record.type = 'normal';
          delete record.arg;
          entry.completion = record;
        }

        function Context(tryLocsList) {
          // The root entry object (effectively a try statement without a catch
          // or a finally block) gives us a place to store values thrown from
          // locations where there is no enclosing try statement.
          this.tryEntries = [{ tryLoc: 'root' }];
          tryLocsList.forEach(pushTryEntry, this);
          this.reset(true);
        }

        runtime.keys = function (object) {
          var keys = [];
          for (var key in object) {
            keys.push(key);
          }
          keys.reverse();

          // Rather than returning an object with a next method, we keep
          // things simple and return the next function itself.
          return function next() {
            while (keys.length) {
              var key = keys.pop();
              if (key in object) {
                next.value = key;
                next.done = false;
                return next;
              }
            }

            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
          };
        };

        function values(iterable) {
          if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) {
              return iteratorMethod.call(iterable);
            }

            if (typeof iterable.next === 'function') {
              return iterable;
            }

            if (!isNaN(iterable.length)) {
              var i = -1,
                next = function next() {
                  while (++i < iterable.length) {
                    if (hasOwn.call(iterable, i)) {
                      next.value = iterable[i];
                      next.done = false;
                      return next;
                    }
                  }

                  next.value = undefined;
                  next.done = true;

                  return next;
                };

              return (next.next = next);
            }
          }

          // Return an iterator with no values.
          return { next: doneResult };
        }
        runtime.values = values;

        function doneResult() {
          return { value: undefined, done: true };
        }

        Context.prototype = {
          constructor: Context,

          reset: function (skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;

            this.method = 'next';
            this.arg = undefined;

            this.tryEntries.forEach(resetTryEntry);

            if (!skipTempReset) {
              for (var name in this) {
                // Not sure about the optimal order of these conditions:
                if (name.charAt(0) === 't' && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                  this[name] = undefined;
                }
              }
            }
          },

          stop: function () {
            this.done = true;

            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === 'throw') {
              throw rootRecord.arg;
            }

            return this.rval;
          },

          dispatchException: function (exception) {
            if (this.done) {
              throw exception;
            }

            var context = this;
            function handle(loc, caught) {
              record.type = 'throw';
              record.arg = exception;
              context.next = loc;

              if (caught) {
                // If the dispatched exception was caught by a catch block,
                // then let that catch block handle the exception normally.
                context.method = 'next';
                context.arg = undefined;
              }

              return !!caught;
            }

            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              var record = entry.completion;

              if (entry.tryLoc === 'root') {
                // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle('end');
              }

              if (entry.tryLoc <= this.prev) {
                var hasCatch = hasOwn.call(entry, 'catchLoc');
                var hasFinally = hasOwn.call(entry, 'finallyLoc');

                if (hasCatch && hasFinally) {
                  if (this.prev < entry.catchLoc) {
                    return handle(entry.catchLoc, true);
                  } else if (this.prev < entry.finallyLoc) {
                    return handle(entry.finallyLoc);
                  }
                } else if (hasCatch) {
                  if (this.prev < entry.catchLoc) {
                    return handle(entry.catchLoc, true);
                  }
                } else if (hasFinally) {
                  if (this.prev < entry.finallyLoc) {
                    return handle(entry.finallyLoc);
                  }
                } else {
                  throw new Error('try statement without catch or finally');
                }
              }
            }
          },

          abrupt: function (type, arg) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              if (entry.tryLoc <= this.prev && hasOwn.call(entry, 'finallyLoc') && this.prev < entry.finallyLoc) {
                var finallyEntry = entry;
                break;
              }
            }

            if (
              finallyEntry &&
              (type === 'break' || type === 'continue') &&
              finallyEntry.tryLoc <= arg &&
              arg <= finallyEntry.finallyLoc
            ) {
              // Ignore the finally entry if control is not jumping to a
              // location outside the try/catch block.
              finallyEntry = null;
            }

            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;

            if (finallyEntry) {
              this.method = 'next';
              this.next = finallyEntry.finallyLoc;
              return ContinueSentinel;
            }

            return this.complete(record);
          },

          complete: function (record, afterLoc) {
            if (record.type === 'throw') {
              throw record.arg;
            }

            if (record.type === 'break' || record.type === 'continue') {
              this.next = record.arg;
            } else if (record.type === 'return') {
              this.rval = this.arg = record.arg;
              this.method = 'return';
              this.next = 'end';
            } else if (record.type === 'normal' && afterLoc) {
              this.next = afterLoc;
            }

            return ContinueSentinel;
          },

          finish: function (finallyLoc) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              if (entry.finallyLoc === finallyLoc) {
                this.complete(entry.completion, entry.afterLoc);
                resetTryEntry(entry);
                return ContinueSentinel;
              }
            }
          },

          catch: function (tryLoc) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              if (entry.tryLoc === tryLoc) {
                var record = entry.completion;
                if (record.type === 'throw') {
                  var thrown = record.arg;
                  resetTryEntry(entry);
                }
                return thrown;
              }
            }

            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error('illegal catch attempt');
          },

          delegateYield: function (iterable, resultName, nextLoc) {
            this.delegate = {
              iterator: values(iterable),
              resultName: resultName,
              nextLoc: nextLoc
            };

            if (this.method === 'next') {
              // Deliberately forget the last sent value so that we don't
              // accidentally pass it on to the delegate.
              this.arg = undefined;
            }

            return ContinueSentinel;
          }
        };
      })(
        // In sloppy mode, unbound `this` refers to the global object, fallback to
        // Function constructor if we're in global strict mode. That is sadly a form
        // of indirect eval which violates Content Security Policy.
        (function () {
          return this;
        })() || Function('return this')()
      );

      /***/
    },
    /* 150 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true
      });

      var _classCallCheck2 = __webpack_require__(10);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(11);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _queryString = __webpack_require__(361);

      var _queryString2 = _interopRequireDefault(_queryString);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var PageContext = (function () {
        function PageContext() {
          (0, _classCallCheck3.default)(this, PageContext);

          this.location = window.location;
          this.templateHandle = 'unknown';
          this.templateType = 'unknown';
        }

        (0, _createClass3.default)(PageContext, [
          {
            key: 'setTemplate',
            value: function setTemplate(templateName) {
              this.templateHandle = templateName;
              this.templateType = this.determineTemplateType(this.templateHandle);
            }
          },
          {
            key: 'onPathname',
            value: function onPathname(pathname) {
              return this.location.pathname.toLowerCase() === pathname.toLowerCase();
            }
          },
          {
            key: 'onTemplate',
            value: function onTemplate(templateName) {
              return this.templateHandle === templateName;
            }
          },
          {
            key: 'onTemplateType',
            value: function onTemplateType(templateType) {
              return this.templateType === templateType;
            }
          },
          {
            key: 'getPathname',
            value: function getPathname() {
              return this.location.pathname;
            }
          },
          {
            key: 'getFragment',
            value: function getFragment() {
              return this.location.hash;
            }
          },
          {
            key: 'getQueryString',
            value: function getQueryString() {
              return this.location.search;
            }
          },
          {
            key: 'getQueryParam',
            value: function getQueryParam(key) {
              return _queryString2.default.parse(this.location.search)[key];
            }

            /**
             * Returns name of the current page template, i.e. 'customers/account.esc'
             */
          },
          {
            key: 'getTemplate',
            value: function getTemplate() {
              return this.templateHandle;
            }

            /**
             * Returns type of current page template, i.e. 'customers/account'
             */
          },
          {
            key: 'getTemplateType',
            value: function getTemplateType() {
              return this.templateType;
            }
          },
          {
            key: 'determineTemplateType',
            value: function determineTemplateType(templateName) {
              return templateName.split('.')[0];
            }
          }
        ]);
        return PageContext;
      })();

      exports.default = new PageContext();

      /***/
    },
    /* 151 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(368);
      var global = __webpack_require__(18);
      var hide = __webpack_require__(55);
      var Iterators = __webpack_require__(63);
      var TO_STRING_TAG = __webpack_require__(22)('toStringTag');

      var DOMIterables = (
        'CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
        'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
        'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
        'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
        'TextTrackList,TouchList'
      ).split(',');

      for (var i = 0; i < DOMIterables.length; i++) {
        var NAME = DOMIterables[i];
        var Collection = global[NAME];
        var proto = Collection && Collection.prototype;
        if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
        Iterators[NAME] = Iterators.Array;
      }

      /***/
    },
    /* 152 */
    /***/ function (module, exports, __webpack_require__) {
      // fallback for non-array-like ES3 and non-enumerable old V8 strings
      var cof = __webpack_require__(75);
      // eslint-disable-next-line no-prototype-builtins
      module.exports = Object('z').propertyIsEnumerable(0)
        ? Object
        : function (it) {
            return cof(it) == 'String' ? it.split('') : Object(it);
          };

      /***/
    },
    /* 153 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var LIBRARY = __webpack_require__(154);
      var $export = __webpack_require__(34);
      var redefine = __webpack_require__(371);
      var hide = __webpack_require__(55);
      var has = __webpack_require__(76);
      var Iterators = __webpack_require__(63);
      var $iterCreate = __webpack_require__(372);
      var setToStringTag = __webpack_require__(110);
      var getPrototypeOf = __webpack_require__(378);
      var ITERATOR = __webpack_require__(22)('iterator');
      var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
      var FF_ITERATOR = '@@iterator';
      var KEYS = 'keys';
      var VALUES = 'values';

      var returnThis = function () {
        return this;
      };

      module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
        $iterCreate(Constructor, NAME, next);
        var getMethod = function (kind) {
          if (!BUGGY && kind in proto) return proto[kind];
          switch (kind) {
            case KEYS:
              return function keys() {
                return new Constructor(this, kind);
              };
            case VALUES:
              return function values() {
                return new Constructor(this, kind);
              };
          }
          return function entries() {
            return new Constructor(this, kind);
          };
        };
        var TAG = NAME + ' Iterator';
        var DEF_VALUES = DEFAULT == VALUES;
        var VALUES_BUG = false;
        var proto = Base.prototype;
        var $native = proto[ITERATOR] || proto[FF_ITERATOR] || (DEFAULT && proto[DEFAULT]);
        var $default = $native || getMethod(DEFAULT);
        var $entries = DEFAULT ? (!DEF_VALUES ? $default : getMethod('entries')) : undefined;
        var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
        var methods, key, IteratorPrototype;
        // Fix native
        if ($anyNative) {
          IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
          if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            setToStringTag(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
          }
        }
        // fix Array#{values, @@iterator}.name in V8 / FF
        if (DEF_VALUES && $native && $native.name !== VALUES) {
          VALUES_BUG = true;
          $default = function values() {
            return $native.call(this);
          };
        }
        // Define iterator
        if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
          hide(proto, ITERATOR, $default);
        }
        // Plug for library
        Iterators[NAME] = $default;
        Iterators[TAG] = returnThis;
        if (DEFAULT) {
          methods = {
            values: DEF_VALUES ? $default : getMethod(VALUES),
            keys: IS_SET ? $default : getMethod(KEYS),
            entries: $entries
          };
          if (FORCED)
            for (key in methods) {
              if (!(key in proto)) redefine(proto, key, methods[key]);
            }
          else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
        }
        return methods;
      };

      /***/
    },
    /* 154 */
    /***/ function (module, exports) {
      module.exports = true;

      /***/
    },
    /* 155 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.14 / 15.2.3.14 Object.keys(O)
      var $keys = __webpack_require__(375);
      var enumBugKeys = __webpack_require__(158);

      module.exports =
        Object.keys ||
        function keys(O) {
          return $keys(O, enumBugKeys);
        };

      /***/
    },
    /* 156 */
    /***/ function (module, exports, __webpack_require__) {
      var global = __webpack_require__(18);
      var SHARED = '__core-js_shared__';
      var store = global[SHARED] || (global[SHARED] = {});
      module.exports = function (key) {
        return store[key] || (store[key] = {});
      };

      /***/
    },
    /* 157 */
    /***/ function (module, exports) {
      var id = 0;
      var px = Math.random();
      module.exports = function (key) {
        return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
      };

      /***/
    },
    /* 158 */
    /***/ function (module, exports) {
      // IE 8- don't enum bug keys
      module.exports =
        'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

      /***/
    },
    /* 159 */
    /***/ function (module, exports, __webpack_require__) {
      var document = __webpack_require__(18).document;
      module.exports = document && document.documentElement;

      /***/
    },
    /* 160 */
    /***/ function (module, exports, __webpack_require__) {
      // getting tag from 19.1.3.6 Object.prototype.toString()
      var cof = __webpack_require__(75);
      var TAG = __webpack_require__(22)('toStringTag');
      // ES3 wrong here
      var ARG =
        cof(
          (function () {
            return arguments;
          })()
        ) == 'Arguments';

      // fallback for IE11 Script Access Denied error
      var tryGet = function (it, key) {
        try {
          return it[key];
        } catch (e) {
          /* empty */
        }
      };

      module.exports = function (it) {
        var O, T, B;
        return it === undefined
          ? 'Undefined'
          : it === null
            ? 'Null'
            : // @@toStringTag case
              typeof (T = tryGet((O = Object(it)), TAG)) == 'string'
              ? T
              : // builtinTag case
                ARG
                ? cof(O)
                : // ES3 arguments fallback
                  (B = cof(O)) == 'Object' && typeof O.callee == 'function'
                  ? 'Arguments'
                  : B;
      };

      /***/
    },
    /* 161 */
    /***/ function (module, exports, __webpack_require__) {
      module.exports = { default: __webpack_require__(382), __esModule: true };

      /***/
    },
    /* 162 */
    /***/ function (module, exports, __webpack_require__) {
      // call something on iterator step with safe closing on error
      var anObject = __webpack_require__(35);
      module.exports = function (iterator, fn, value, entries) {
        try {
          return entries ? fn(anObject(value)[0], value[1]) : fn(value);
          // 7.4.6 IteratorClose(iterator, completion)
        } catch (e) {
          var ret = iterator['return'];
          if (ret !== undefined) anObject(ret.call(iterator));
          throw e;
        }
      };

      /***/
    },
    /* 163 */
    /***/ function (module, exports, __webpack_require__) {
      // check on default Array iterator
      var Iterators = __webpack_require__(63);
      var ITERATOR = __webpack_require__(22)('iterator');
      var ArrayProto = Array.prototype;

      module.exports = function (it) {
        return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
      };

      /***/
    },
    /* 164 */
    /***/ function (module, exports, __webpack_require__) {
      var ITERATOR = __webpack_require__(22)('iterator');
      var SAFE_CLOSING = false;

      try {
        var riter = [7][ITERATOR]();
        riter['return'] = function () {
          SAFE_CLOSING = true;
        };
        // eslint-disable-next-line no-throw-literal
        Array.from(riter, function () {
          throw 2;
        });
      } catch (e) {
        /* empty */
      }

      module.exports = function (exec, skipClosing) {
        if (!skipClosing && !SAFE_CLOSING) return false;
        var safe = false;
        try {
          var arr = [7];
          var iter = arr[ITERATOR]();
          iter.next = function () {
            return { done: (safe = true) };
          };
          arr[ITERATOR] = function () {
            return iter;
          };
          exec(arr);
        } catch (e) {
          /* empty */
        }
        return safe;
      };

      /***/
    },
    /* 165 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
       * getSize v2.0.3
       * measure size of elements
       * MIT license
       */

      /* jshint browser: true, strict: true, undef: true, unused: true */
      /* globals console: false */

      (function (window, factory) {
        /* jshint strict: false */ /* globals define, module */
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function'
              ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof module == 'object' && module.exports) {
          // CommonJS
          module.exports = factory();
        } else {
          // browser global
          window.getSize = factory();
        }
      })(window, function factory() {
        'use strict';

        // -------------------------- helpers -------------------------- //

        // get a number from a string, not a percentage
        function getStyleSize(value) {
          var num = parseFloat(value);
          // not a percent like '100%', and a number
          var isValid = value.indexOf('%') == -1 && !isNaN(num);
          return isValid && num;
        }

        function noop() {}

        var logError =
          typeof console == 'undefined'
            ? noop
            : function (message) {
                console.error(message);
              };

        // -------------------------- measurements -------------------------- //

        var measurements = [
          'paddingLeft',
          'paddingRight',
          'paddingTop',
          'paddingBottom',
          'marginLeft',
          'marginRight',
          'marginTop',
          'marginBottom',
          'borderLeftWidth',
          'borderRightWidth',
          'borderTopWidth',
          'borderBottomWidth'
        ];

        var measurementsLength = measurements.length;

        function getZeroSize() {
          var size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
          };
          for (var i = 0; i < measurementsLength; i++) {
            var measurement = measurements[i];
            size[measurement] = 0;
          }
          return size;
        }

        // -------------------------- getStyle -------------------------- //

        /**
         * getStyle, get style of element, check for Firefox bug
         * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
         */
        function getStyle(elem) {
          var style = getComputedStyle(elem);
          if (!style) {
            logError(
              'Style returned ' +
                style +
                '. Are you running this code in a hidden iframe on Firefox? ' +
                'See https://bit.ly/getsizebug1'
            );
          }
          return style;
        }

        // -------------------------- setup -------------------------- //

        var isSetup = false;

        var isBoxSizeOuter;

        /**
         * setup
         * check isBoxSizerOuter
         * do on first getSize() rather than on page load for Firefox bug
         */
        function setup() {
          // setup once
          if (isSetup) {
            return;
          }
          isSetup = true;

          // -------------------------- box sizing -------------------------- //

          /**
           * Chrome & Safari measure the outer-width on style.width on border-box elems
           * IE11 & Firefox<29 measures the inner-width
           */
          var div = document.createElement('div');
          div.style.width = '200px';
          div.style.padding = '1px 2px 3px 4px';
          div.style.borderStyle = 'solid';
          div.style.borderWidth = '1px 2px 3px 4px';
          div.style.boxSizing = 'border-box';

          var body = document.body || document.documentElement;
          body.appendChild(div);
          var style = getStyle(div);
          // round value for browser zoom. desandro/masonry#928
          isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
          getSize.isBoxSizeOuter = isBoxSizeOuter;

          body.removeChild(div);
        }

        // -------------------------- getSize -------------------------- //

        function getSize(elem) {
          setup();

          // use querySeletor if elem is string
          if (typeof elem == 'string') {
            elem = document.querySelector(elem);
          }

          // do not proceed on non-objects
          if (!elem || typeof elem != 'object' || !elem.nodeType) {
            return;
          }

          var style = getStyle(elem);

          // if hidden, everything is 0
          if (style.display == 'none') {
            return getZeroSize();
          }

          var size = {};
          size.width = elem.offsetWidth;
          size.height = elem.offsetHeight;

          var isBorderBox = (size.isBorderBox = style.boxSizing == 'border-box');

          // get all measurements
          for (var i = 0; i < measurementsLength; i++) {
            var measurement = measurements[i];
            var value = style[measurement];
            var num = parseFloat(value);
            // any 'auto', 'medium' value will be 0
            size[measurement] = !isNaN(num) ? num : 0;
          }

          var paddingWidth = size.paddingLeft + size.paddingRight;
          var paddingHeight = size.paddingTop + size.paddingBottom;
          var marginWidth = size.marginLeft + size.marginRight;
          var marginHeight = size.marginTop + size.marginBottom;
          var borderWidth = size.borderLeftWidth + size.borderRightWidth;
          var borderHeight = size.borderTopWidth + size.borderBottomWidth;

          var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

          // overwrite width and height if we can get it from style
          var styleWidth = getStyleSize(style.width);
          if (styleWidth !== false) {
            size.width =
              styleWidth +
              // add padding and border unless it's already including it
              (isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
          }

          var styleHeight = getStyleSize(style.height);
          if (styleHeight !== false) {
            size.height =
              styleHeight +
              // add padding and border unless it's already including it
              (isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
          }

          size.innerWidth = size.width - (paddingWidth + borderWidth);
          size.innerHeight = size.height - (paddingHeight + borderHeight);

          size.outerWidth = size.width + marginWidth;
          size.outerHeight = size.height + marginHeight;

          return size;
        }

        return getSize;
      });

      /***/
    },
    /* 166 */
    /***/ function (module, exports, __webpack_require__) {
      // 7.3.20 SpeciesConstructor(O, defaultConstructor)
      var anObject = __webpack_require__(35);
      var aFunction = __webpack_require__(74);
      var SPECIES = __webpack_require__(22)('species');
      module.exports = function (O, D) {
        var C = anObject(O).constructor;
        var S;
        return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
      };

      /***/
    },
    /* 167 */
    /***/ function (module, exports, __webpack_require__) {
      var ctx = __webpack_require__(61);
      var invoke = __webpack_require__(424);
      var html = __webpack_require__(159);
      var cel = __webpack_require__(103);
      var global = __webpack_require__(18);
      var process = global.process;
      var setTask = global.setImmediate;
      var clearTask = global.clearImmediate;
      var MessageChannel = global.MessageChannel;
      var Dispatch = global.Dispatch;
      var counter = 0;
      var queue = {};
      var ONREADYSTATECHANGE = 'onreadystatechange';
      var defer, channel, port;
      var run = function () {
        var id = +this;
        // eslint-disable-next-line no-prototype-builtins
        if (queue.hasOwnProperty(id)) {
          var fn = queue[id];
          delete queue[id];
          fn();
        }
      };
      var listener = function (event) {
        run.call(event.data);
      };
      // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
      if (!setTask || !clearTask) {
        setTask = function setImmediate(fn) {
          var args = [];
          var i = 1;
          while (arguments.length > i) args.push(arguments[i++]);
          queue[++counter] = function () {
            // eslint-disable-next-line no-new-func
            invoke(typeof fn == 'function' ? fn : Function(fn), args);
          };
          defer(counter);
          return counter;
        };
        clearTask = function clearImmediate(id) {
          delete queue[id];
        };
        // Node.js 0.8-
        if (__webpack_require__(75)(process) == 'process') {
          defer = function (id) {
            process.nextTick(ctx(run, id, 1));
          };
          // Sphere (JS game engine) Dispatch API
        } else if (Dispatch && Dispatch.now) {
          defer = function (id) {
            Dispatch.now(ctx(run, id, 1));
          };
          // Browsers with MessageChannel, includes WebWorkers
        } else if (MessageChannel) {
          channel = new MessageChannel();
          port = channel.port2;
          channel.port1.onmessage = listener;
          defer = ctx(port.postMessage, port, 1);
          // Browsers with postMessage, skip WebWorkers
          // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
        } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
          defer = function (id) {
            global.postMessage(id + '', '*');
          };
          global.addEventListener('message', listener, false);
          // IE8-
        } else if (ONREADYSTATECHANGE in cel('script')) {
          defer = function (id) {
            html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
              html.removeChild(this);
              run.call(id);
            };
          };
          // Rest old browsers
        } else {
          defer = function (id) {
            setTimeout(ctx(run, id, 1), 0);
          };
        }
      }
      module.exports = {
        set: setTask,
        clear: clearTask
      };

      /***/
    },
    /* 168 */
    /***/ function (module, exports) {
      module.exports = function (exec) {
        try {
          return { e: false, v: exec() };
        } catch (e) {
          return { e: true, v: e };
        }
      };

      /***/
    },
    /* 169 */
    /***/ function (module, exports, __webpack_require__) {
      var anObject = __webpack_require__(35);
      var isObject = __webpack_require__(62);
      var newPromiseCapability = __webpack_require__(117);

      module.exports = function (C, x) {
        anObject(C);
        if (isObject(x) && x.constructor === C) return x;
        var promiseCapability = newPromiseCapability.f(C);
        var resolve = promiseCapability.resolve;
        resolve(x);
        return promiseCapability.promise;
      };

      /***/
    },
    /* 170 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      module.exports = function bind(fn, thisArg) {
        return function wrap() {
          var args = new Array(arguments.length);
          for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i];
          }
          return fn.apply(thisArg, args);
        };
      };

      /***/
    },
    /* 171 */
    /***/ function (module, exports) {
      // shim for using process in browser
      var process = (module.exports = {});

      // cached from whatever global is present so that test runners that stub it
      // don't break things.  But we need to wrap it in a try catch in case it is
      // wrapped in strict mode code which doesn't define any globals.  It's inside a
      // function because try/catches deoptimize in certain engines.

      var cachedSetTimeout;
      var cachedClearTimeout;

      function defaultSetTimout() {
        throw new Error('setTimeout has not been defined');
      }
      function defaultClearTimeout() {
        throw new Error('clearTimeout has not been defined');
      }
      (function () {
        try {
          if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
          } else {
            cachedSetTimeout = defaultSetTimout;
          }
        } catch (e) {
          cachedSetTimeout = defaultSetTimout;
        }
        try {
          if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
          } else {
            cachedClearTimeout = defaultClearTimeout;
          }
        } catch (e) {
          cachedClearTimeout = defaultClearTimeout;
        }
      })();
      function runTimeout(fun) {
        if (cachedSetTimeout === setTimeout) {
          //normal enviroments in sane situations
          return setTimeout(fun, 0);
        }
        // if setTimeout wasn't available but was latter defined
        if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
          cachedSetTimeout = setTimeout;
          return setTimeout(fun, 0);
        }
        try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedSetTimeout(fun, 0);
        } catch (e) {
          try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
          } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
          }
        }
      }
      function runClearTimeout(marker) {
        if (cachedClearTimeout === clearTimeout) {
          //normal enviroments in sane situations
          return clearTimeout(marker);
        }
        // if clearTimeout wasn't available but was latter defined
        if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
          cachedClearTimeout = clearTimeout;
          return clearTimeout(marker);
        }
        try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedClearTimeout(marker);
        } catch (e) {
          try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
          } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
          }
        }
      }
      var queue = [];
      var draining = false;
      var currentQueue;
      var queueIndex = -1;

      function cleanUpNextTick() {
        if (!draining || !currentQueue) {
          return;
        }
        draining = false;
        if (currentQueue.length) {
          queue = currentQueue.concat(queue);
        } else {
          queueIndex = -1;
        }
        if (queue.length) {
          drainQueue();
        }
      }

      function drainQueue() {
        if (draining) {
          return;
        }
        var timeout = runTimeout(cleanUpNextTick);
        draining = true;

        var len = queue.length;
        while (len) {
          currentQueue = queue;
          queue = [];
          while (++queueIndex < len) {
            if (currentQueue) {
              currentQueue[queueIndex].run();
            }
          }
          queueIndex = -1;
          len = queue.length;
        }
        currentQueue = null;
        draining = false;
        runClearTimeout(timeout);
      }

      process.nextTick = function (fun) {
        var args = new Array(arguments.length - 1);
        if (arguments.length > 1) {
          for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
          }
        }
        queue.push(new Item(fun, args));
        if (queue.length === 1 && !draining) {
          runTimeout(drainQueue);
        }
      };

      // v8 likes predictible objects
      function Item(fun, array) {
        this.fun = fun;
        this.array = array;
      }
      Item.prototype.run = function () {
        this.fun.apply(null, this.array);
      };
      process.title = 'browser';
      process.browser = true;
      process.env = {};
      process.argv = [];
      process.version = ''; // empty string to avoid regexp issues
      process.versions = {};

      function noop() {}

      process.on = noop;
      process.addListener = noop;
      process.once = noop;
      process.off = noop;
      process.removeListener = noop;
      process.removeAllListeners = noop;
      process.emit = noop;
      process.prependListener = noop;
      process.prependOnceListener = noop;

      process.listeners = function (name) {
        return [];
      };

      process.binding = function (name) {
        throw new Error('process.binding is not supported');
      };

      process.cwd = function () {
        return '/';
      };
      process.chdir = function (dir) {
        throw new Error('process.chdir is not supported');
      };
      process.umask = function () {
        return 0;
      };

      /***/
    },
    /* 172 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';
      /* WEBPACK VAR INJECTION */ (function (process) {
        var utils = __webpack_require__(19);
        var settle = __webpack_require__(435);
        var buildURL = __webpack_require__(437);
        var parseHeaders = __webpack_require__(438);
        var isURLSameOrigin = __webpack_require__(439);
        var createError = __webpack_require__(173);
        var btoa =
          (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(440);

        module.exports = function xhrAdapter(config) {
          return new Promise(function dispatchXhrRequest(resolve, reject) {
            var requestData = config.data;
            var requestHeaders = config.headers;

            if (utils.isFormData(requestData)) {
              delete requestHeaders['Content-Type']; // Let the browser set it
            }

            var request = new XMLHttpRequest();
            var loadEvent = 'onreadystatechange';
            var xDomain = false;

            // For IE 8/9 CORS support
            // Only supports POST and GET calls and doesn't returns the response headers.
            // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
            if (
              process.env.NODE_ENV !== 'test' &&
              typeof window !== 'undefined' &&
              window.XDomainRequest &&
              !('withCredentials' in request) &&
              !isURLSameOrigin(config.url)
            ) {
              request = new window.XDomainRequest();
              loadEvent = 'onload';
              xDomain = true;
              request.onprogress = function handleProgress() {};
              request.ontimeout = function handleTimeout() {};
            }

            // HTTP basic authentication
            if (config.auth) {
              var username = config.auth.username || '';
              var password = config.auth.password || '';
              requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
            }

            request.open(
              config.method.toUpperCase(),
              buildURL(config.url, config.params, config.paramsSerializer),
              true
            );

            // Set the request timeout in MS
            request.timeout = config.timeout;

            // Listen for ready state
            request[loadEvent] = function handleLoad() {
              if (!request || (request.readyState !== 4 && !xDomain)) {
                return;
              }

              // The request errored out and we didn't get a response, this will be
              // handled by onerror instead
              // With one exception: request that using file: protocol, most browsers
              // will return status as 0 even though it's a successful request
              if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
                return;
              }

              // Prepare the response
              var responseHeaders =
                'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
              var responseData =
                !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
              var response = {
                data: responseData,
                // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
                status: request.status === 1223 ? 204 : request.status,
                statusText: request.status === 1223 ? 'No Content' : request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
              };

              settle(resolve, reject, response);

              // Clean up request
              request = null;
            };

            // Handle low level network errors
            request.onerror = function handleError() {
              // Real errors are hidden from us by the browser
              // onerror should only fire if it's a network error
              reject(createError('Network Error', config, null, request));

              // Clean up request
              request = null;
            };

            // Handle timeout
            request.ontimeout = function handleTimeout() {
              reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED', request));

              // Clean up request
              request = null;
            };

            // Add xsrf header
            // This is only done if running in a standard browser environment.
            // Specifically not if we're in a web worker, or react-native.
            if (utils.isStandardBrowserEnv()) {
              var cookies = __webpack_require__(441);

              // Add xsrf header
              var xsrfValue =
                (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName
                  ? cookies.read(config.xsrfCookieName)
                  : undefined;

              if (xsrfValue) {
                requestHeaders[config.xsrfHeaderName] = xsrfValue;
              }
            }

            // Add headers to the request
            if ('setRequestHeader' in request) {
              utils.forEach(requestHeaders, function setRequestHeader(val, key) {
                if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
                  // Remove Content-Type if data is undefined
                  delete requestHeaders[key];
                } else {
                  // Otherwise add header to the request
                  request.setRequestHeader(key, val);
                }
              });
            }

            // Add withCredentials to request if needed
            if (config.withCredentials) {
              request.withCredentials = true;
            }

            // Add responseType to request if needed
            if (config.responseType) {
              try {
                request.responseType = config.responseType;
              } catch (e) {
                // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
                // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
                if (config.responseType !== 'json') {
                  throw e;
                }
              }
            }

            // Handle progress if needed
            if (typeof config.onDownloadProgress === 'function') {
              request.addEventListener('progress', config.onDownloadProgress);
            }

            // Not all browsers support upload events
            if (typeof config.onUploadProgress === 'function' && request.upload) {
              request.upload.addEventListener('progress', config.onUploadProgress);
            }

            if (config.cancelToken) {
              // Handle cancellation
              config.cancelToken.promise.then(function onCanceled(cancel) {
                if (!request) {
                  return;
                }

                request.abort();
                reject(cancel);
                // Clean up request
                request = null;
              });
            }

            if (requestData === undefined) {
              requestData = null;
            }

            // Send the request
            request.send(requestData);
          });
        };

        /* WEBPACK VAR INJECTION */
      }).call(exports, __webpack_require__(171));

      /***/
    },
    /* 173 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var enhanceError = __webpack_require__(436);

      /**
       * Create an Error with the specified message, config, error code, request and response.
       *
       * @param {string} message The error message.
       * @param {Object} config The config.
       * @param {string} [code] The error code (for example, 'ECONNABORTED').
       * @param {Object} [request] The request.
       * @param {Object} [response] The response.
       * @returns {Error} The created error.
       */
      module.exports = function createError(message, config, code, request, response) {
        var error = new Error(message);
        return enhanceError(error, config, code, request, response);
      };

      /***/
    },
    /* 174 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      module.exports = function isCancel(value) {
        return !!(value && value.__CANCEL__);
      };

      /***/
    },
    /* 175 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      /**
       * A `Cancel` is an object that is thrown when an operation is canceled.
       *
       * @class
       * @param {string=} message The message.
       */
      function Cancel(message) {
        this.message = message;
      }

      Cancel.prototype.toString = function toString() {
        return 'Cancel' + (this.message ? ': ' + this.message : '');
      };

      Cancel.prototype.__CANCEL__ = true;

      module.exports = Cancel;

      /***/
    },
    /* 176 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(177);
      module.exports = __webpack_require__(355);

      /***/
    },
    /* 177 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';
      /* WEBPACK VAR INJECTION */ (function (global) {
        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        exports.idempotentBabelPolyfill = idempotentBabelPolyfill;
        exports.default = void 0;

        function idempotentBabelPolyfill() {
          if (
            !global._babelPolyfill && // eslint-disable-next-line no-undef
            (typeof window === 'undefined' || !window._babelPolyfill)
          ) {
            return __webpack_require__(179);
          }

          return null;
        }

        var _default = idempotentBabelPolyfill();

        exports.default = _default;
        /* WEBPACK VAR INJECTION */
      }).call(exports, __webpack_require__(178));

      /***/
    },
    /* 178 */
    /***/ function (module, exports) {
      var g;

      // This works in non-strict mode
      g = (function () {
        return this;
      })();

      try {
        // This works if eval is allowed (see CSP)
        g = g || Function('return this')() || (1, eval)('this');
      } catch (e) {
        // This works if the window reference is available
        if (typeof window === 'object') g = window;
      }

      // g can still be undefined, but nothing to do about it...
      // We return undefined, instead of nothing here, so it's
      // easier to handle this case. if(!global) { ...}

      module.exports = g;

      /***/
    },
    /* 179 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      __webpack_require__(180);

      var _global = _interopRequireDefault(__webpack_require__(351));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      if (_global.default._babelPolyfill && typeof console !== 'undefined' && console.warn) {
        console.warn(
          '@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended ' +
            'and may have consequences if different versions of the polyfills are applied sequentially. ' +
            'If you do need to load the polyfill more than once, use @babel/polyfill/noConflict ' +
            'instead to bypass the warning.'
        );
      }

      _global.default._babelPolyfill = true;

      /***/
    },
    /* 180 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      __webpack_require__(181);

      __webpack_require__(324);

      __webpack_require__(326);

      __webpack_require__(329);

      __webpack_require__(331);

      __webpack_require__(333);

      __webpack_require__(335);

      __webpack_require__(337);

      __webpack_require__(339);

      __webpack_require__(341);

      __webpack_require__(343);

      __webpack_require__(345);

      __webpack_require__(347);

      __webpack_require__(149);

      /***/
    },
    /* 181 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(182);
      __webpack_require__(184);
      __webpack_require__(185);
      __webpack_require__(186);
      __webpack_require__(187);
      __webpack_require__(188);
      __webpack_require__(189);
      __webpack_require__(190);
      __webpack_require__(191);
      __webpack_require__(192);
      __webpack_require__(193);
      __webpack_require__(194);
      __webpack_require__(195);
      __webpack_require__(196);
      __webpack_require__(197);
      __webpack_require__(198);
      __webpack_require__(200);
      __webpack_require__(201);
      __webpack_require__(202);
      __webpack_require__(203);
      __webpack_require__(204);
      __webpack_require__(205);
      __webpack_require__(206);
      __webpack_require__(207);
      __webpack_require__(208);
      __webpack_require__(209);
      __webpack_require__(210);
      __webpack_require__(211);
      __webpack_require__(212);
      __webpack_require__(213);
      __webpack_require__(214);
      __webpack_require__(215);
      __webpack_require__(216);
      __webpack_require__(217);
      __webpack_require__(218);
      __webpack_require__(219);
      __webpack_require__(220);
      __webpack_require__(221);
      __webpack_require__(222);
      __webpack_require__(223);
      __webpack_require__(224);
      __webpack_require__(225);
      __webpack_require__(226);
      __webpack_require__(228);
      __webpack_require__(229);
      __webpack_require__(230);
      __webpack_require__(231);
      __webpack_require__(232);
      __webpack_require__(233);
      __webpack_require__(234);
      __webpack_require__(235);
      __webpack_require__(236);
      __webpack_require__(237);
      __webpack_require__(238);
      __webpack_require__(239);
      __webpack_require__(240);
      __webpack_require__(241);
      __webpack_require__(242);
      __webpack_require__(243);
      __webpack_require__(244);
      __webpack_require__(245);
      __webpack_require__(246);
      __webpack_require__(247);
      __webpack_require__(248);
      __webpack_require__(249);
      __webpack_require__(250);
      __webpack_require__(251);
      __webpack_require__(252);
      __webpack_require__(253);
      __webpack_require__(254);
      __webpack_require__(255);
      __webpack_require__(256);
      __webpack_require__(257);
      __webpack_require__(258);
      __webpack_require__(259);
      __webpack_require__(260);
      __webpack_require__(261);
      __webpack_require__(263);
      __webpack_require__(264);
      __webpack_require__(266);
      __webpack_require__(267);
      __webpack_require__(268);
      __webpack_require__(269);
      __webpack_require__(270);
      __webpack_require__(271);
      __webpack_require__(272);
      __webpack_require__(274);
      __webpack_require__(275);
      __webpack_require__(276);
      __webpack_require__(277);
      __webpack_require__(278);
      __webpack_require__(279);
      __webpack_require__(280);
      __webpack_require__(281);
      __webpack_require__(282);
      __webpack_require__(283);
      __webpack_require__(284);
      __webpack_require__(285);
      __webpack_require__(286);
      __webpack_require__(98);
      __webpack_require__(287);
      __webpack_require__(288);
      __webpack_require__(139);
      __webpack_require__(289);
      __webpack_require__(290);
      __webpack_require__(291);
      __webpack_require__(292);
      __webpack_require__(140);
      __webpack_require__(295);
      __webpack_require__(296);
      __webpack_require__(297);
      __webpack_require__(298);
      __webpack_require__(299);
      __webpack_require__(300);
      __webpack_require__(301);
      __webpack_require__(302);
      __webpack_require__(303);
      __webpack_require__(304);
      __webpack_require__(305);
      __webpack_require__(306);
      __webpack_require__(307);
      __webpack_require__(308);
      __webpack_require__(309);
      __webpack_require__(310);
      __webpack_require__(311);
      __webpack_require__(312);
      __webpack_require__(313);
      __webpack_require__(314);
      __webpack_require__(315);
      __webpack_require__(316);
      __webpack_require__(317);
      __webpack_require__(318);
      __webpack_require__(319);
      __webpack_require__(320);
      __webpack_require__(321);
      __webpack_require__(322);
      __webpack_require__(323);
      module.exports = __webpack_require__(6);

      /***/
    },
    /* 182 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // ECMAScript 6 symbols shim
      var global = __webpack_require__(3);
      var has = __webpack_require__(12);
      var DESCRIPTORS = __webpack_require__(9);
      var $export = __webpack_require__(0);
      var redefine = __webpack_require__(13);
      var META = __webpack_require__(33).KEY;
      var $fails = __webpack_require__(1);
      var shared = __webpack_require__(79);
      var setToStringTag = __webpack_require__(47);
      var uid = __webpack_require__(39);
      var wks = __webpack_require__(5);
      var wksExt = __webpack_require__(80);
      var wksDefine = __webpack_require__(120);
      var enumKeys = __webpack_require__(183);
      var isArray = __webpack_require__(66);
      var anObject = __webpack_require__(4);
      var toIObject = __webpack_require__(17);
      var toPrimitive = __webpack_require__(32);
      var createDesc = __webpack_require__(38);
      var _create = __webpack_require__(42);
      var gOPNExt = __webpack_require__(123);
      var $GOPD = __webpack_require__(25);
      var $DP = __webpack_require__(7);
      var $keys = __webpack_require__(40);
      var gOPD = $GOPD.f;
      var dP = $DP.f;
      var gOPN = gOPNExt.f;
      var $Symbol = global.Symbol;
      var $JSON = global.JSON;
      var _stringify = $JSON && $JSON.stringify;
      var PROTOTYPE = 'prototype';
      var HIDDEN = wks('_hidden');
      var TO_PRIMITIVE = wks('toPrimitive');
      var isEnum = {}.propertyIsEnumerable;
      var SymbolRegistry = shared('symbol-registry');
      var AllSymbols = shared('symbols');
      var OPSymbols = shared('op-symbols');
      var ObjectProto = Object[PROTOTYPE];
      var USE_NATIVE = typeof $Symbol == 'function';
      var QObject = global.QObject;
      // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
      var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

      // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
      var setSymbolDesc =
        DESCRIPTORS &&
        $fails(function () {
          return (
            _create(
              dP({}, 'a', {
                get: function () {
                  return dP(this, 'a', { value: 7 }).a;
                }
              })
            ).a != 7
          );
        })
          ? function (it, key, D) {
              var protoDesc = gOPD(ObjectProto, key);
              if (protoDesc) delete ObjectProto[key];
              dP(it, key, D);
              if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
            }
          : dP;

      var wrap = function (tag) {
        var sym = (AllSymbols[tag] = _create($Symbol[PROTOTYPE]));
        sym._k = tag;
        return sym;
      };

      var isSymbol =
        USE_NATIVE && typeof $Symbol.iterator == 'symbol'
          ? function (it) {
              return typeof it == 'symbol';
            }
          : function (it) {
              return it instanceof $Symbol;
            };

      var $defineProperty = function defineProperty(it, key, D) {
        if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
        anObject(it);
        key = toPrimitive(key, true);
        anObject(D);
        if (has(AllSymbols, key)) {
          if (!D.enumerable) {
            if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
            it[HIDDEN][key] = true;
          } else {
            if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
            D = _create(D, { enumerable: createDesc(0, false) });
          }
          return setSymbolDesc(it, key, D);
        }
        return dP(it, key, D);
      };
      var $defineProperties = function defineProperties(it, P) {
        anObject(it);
        var keys = enumKeys((P = toIObject(P)));
        var i = 0;
        var l = keys.length;
        var key;
        while (l > i) $defineProperty(it, (key = keys[i++]), P[key]);
        return it;
      };
      var $create = function create(it, P) {
        return P === undefined ? _create(it) : $defineProperties(_create(it), P);
      };
      var $propertyIsEnumerable = function propertyIsEnumerable(key) {
        var E = isEnum.call(this, (key = toPrimitive(key, true)));
        if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
        return E || !has(this, key) || !has(AllSymbols, key) || (has(this, HIDDEN) && this[HIDDEN][key]) ? E : true;
      };
      var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
        it = toIObject(it);
        key = toPrimitive(key, true);
        if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
        var D = gOPD(it, key);
        if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
        return D;
      };
      var $getOwnPropertyNames = function getOwnPropertyNames(it) {
        var names = gOPN(toIObject(it));
        var result = [];
        var i = 0;
        var key;
        while (names.length > i) {
          if (!has(AllSymbols, (key = names[i++])) && key != HIDDEN && key != META) result.push(key);
        }
        return result;
      };
      var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
        var IS_OP = it === ObjectProto;
        var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
        var result = [];
        var i = 0;
        var key;
        while (names.length > i) {
          if (has(AllSymbols, (key = names[i++])) && (IS_OP ? has(ObjectProto, key) : true))
            result.push(AllSymbols[key]);
        }
        return result;
      };

      // 19.4.1.1 Symbol([description])
      if (!USE_NATIVE) {
        $Symbol = function Symbol() {
          if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
          var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
          var $set = function (value) {
            if (this === ObjectProto) $set.call(OPSymbols, value);
            if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
            setSymbolDesc(this, tag, createDesc(1, value));
          };
          if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
          return wrap(tag);
        };
        redefine($Symbol[PROTOTYPE], 'toString', function toString() {
          return this._k;
        });

        $GOPD.f = $getOwnPropertyDescriptor;
        $DP.f = $defineProperty;
        __webpack_require__(43).f = gOPNExt.f = $getOwnPropertyNames;
        __webpack_require__(60).f = $propertyIsEnumerable;
        __webpack_require__(65).f = $getOwnPropertySymbols;

        if (DESCRIPTORS && !__webpack_require__(48)) {
          redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
        }

        wksExt.f = function (name) {
          return wrap(wks(name));
        };
      }

      $export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

      for (
        var es6Symbols =
            // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
            'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(
              ','
            ),
          j = 0;
        es6Symbols.length > j;

      )
        wks(es6Symbols[j++]);

      for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k; )
        wksDefine(wellKnownSymbols[k++]);

      $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
        // 19.4.2.1 Symbol.for(key)
        for: function (key) {
          return has(SymbolRegistry, (key += '')) ? SymbolRegistry[key] : (SymbolRegistry[key] = $Symbol(key));
        },
        // 19.4.2.5 Symbol.keyFor(sym)
        keyFor: function keyFor(sym) {
          if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
          for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
        },
        useSetter: function () {
          setter = true;
        },
        useSimple: function () {
          setter = false;
        }
      });

      $export($export.S + $export.F * !USE_NATIVE, 'Object', {
        // 19.1.2.2 Object.create(O [, Properties])
        create: $create,
        // 19.1.2.4 Object.defineProperty(O, P, Attributes)
        defineProperty: $defineProperty,
        // 19.1.2.3 Object.defineProperties(O, Properties)
        defineProperties: $defineProperties,
        // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
        getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
        // 19.1.2.7 Object.getOwnPropertyNames(O)
        getOwnPropertyNames: $getOwnPropertyNames,
        // 19.1.2.8 Object.getOwnPropertySymbols(O)
        getOwnPropertySymbols: $getOwnPropertySymbols
      });

      // 24.3.2 JSON.stringify(value [, replacer [, space]])
      $JSON &&
        $export(
          $export.S +
            $export.F *
              (!USE_NATIVE ||
                $fails(function () {
                  var S = $Symbol();
                  // MS Edge converts symbol values to JSON as {}
                  // WebKit converts symbol values to JSON as null
                  // V8 throws on boxed symbols
                  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
                })),
          'JSON',
          {
            stringify: function stringify(it) {
              if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
              var args = [it];
              var i = 1;
              var replacer, $replacer;
              while (arguments.length > i) args.push(arguments[i++]);
              replacer = args[1];
              if (typeof replacer == 'function') $replacer = replacer;
              if ($replacer || !isArray(replacer))
                replacer = function (key, value) {
                  if ($replacer) value = $replacer.call(this, key, value);
                  if (!isSymbol(value)) return value;
                };
              args[1] = replacer;
              return _stringify.apply($JSON, args);
            }
          }
        );

      // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
      $Symbol[PROTOTYPE][TO_PRIMITIVE] ||
        __webpack_require__(16)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
      // 19.4.3.5 Symbol.prototype[@@toStringTag]
      setToStringTag($Symbol, 'Symbol');
      // 20.2.1.9 Math[@@toStringTag]
      setToStringTag(Math, 'Math', true);
      // 24.3.3 JSON[@@toStringTag]
      setToStringTag(global.JSON, 'JSON', true);

      /***/
    },
    /* 183 */
    /***/ function (module, exports, __webpack_require__) {
      // all enumerable object keys, includes symbols
      var getKeys = __webpack_require__(40);
      var gOPS = __webpack_require__(65);
      var pIE = __webpack_require__(60);
      module.exports = function (it) {
        var result = getKeys(it);
        var getSymbols = gOPS.f;
        if (getSymbols) {
          var symbols = getSymbols(it);
          var isEnum = pIE.f;
          var i = 0;
          var key;
          while (symbols.length > i) if (isEnum.call(it, (key = symbols[i++]))) result.push(key);
        }
        return result;
      };

      /***/
    },
    /* 184 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
      $export($export.S, 'Object', { create: __webpack_require__(42) });

      /***/
    },
    /* 185 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
      $export($export.S + $export.F * !__webpack_require__(9), 'Object', { defineProperty: __webpack_require__(7).f });

      /***/
    },
    /* 186 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      // 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
      $export($export.S + $export.F * !__webpack_require__(9), 'Object', {
        defineProperties: __webpack_require__(122)
      });

      /***/
    },
    /* 187 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
      var toIObject = __webpack_require__(17);
      var $getOwnPropertyDescriptor = __webpack_require__(25).f;

      __webpack_require__(26)('getOwnPropertyDescriptor', function () {
        return function getOwnPropertyDescriptor(it, key) {
          return $getOwnPropertyDescriptor(toIObject(it), key);
        };
      });

      /***/
    },
    /* 188 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.9 Object.getPrototypeOf(O)
      var toObject = __webpack_require__(14);
      var $getPrototypeOf = __webpack_require__(44);

      __webpack_require__(26)('getPrototypeOf', function () {
        return function getPrototypeOf(it) {
          return $getPrototypeOf(toObject(it));
        };
      });

      /***/
    },
    /* 189 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.14 Object.keys(O)
      var toObject = __webpack_require__(14);
      var $keys = __webpack_require__(40);

      __webpack_require__(26)('keys', function () {
        return function keys(it) {
          return $keys(toObject(it));
        };
      });

      /***/
    },
    /* 190 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.7 Object.getOwnPropertyNames(O)
      __webpack_require__(26)('getOwnPropertyNames', function () {
        return __webpack_require__(123).f;
      });

      /***/
    },
    /* 191 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.5 Object.freeze(O)
      var isObject = __webpack_require__(2);
      var meta = __webpack_require__(33).onFreeze;

      __webpack_require__(26)('freeze', function ($freeze) {
        return function freeze(it) {
          return $freeze && isObject(it) ? $freeze(meta(it)) : it;
        };
      });

      /***/
    },
    /* 192 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.17 Object.seal(O)
      var isObject = __webpack_require__(2);
      var meta = __webpack_require__(33).onFreeze;

      __webpack_require__(26)('seal', function ($seal) {
        return function seal(it) {
          return $seal && isObject(it) ? $seal(meta(it)) : it;
        };
      });

      /***/
    },
    /* 193 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.15 Object.preventExtensions(O)
      var isObject = __webpack_require__(2);
      var meta = __webpack_require__(33).onFreeze;

      __webpack_require__(26)('preventExtensions', function ($preventExtensions) {
        return function preventExtensions(it) {
          return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
        };
      });

      /***/
    },
    /* 194 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.12 Object.isFrozen(O)
      var isObject = __webpack_require__(2);

      __webpack_require__(26)('isFrozen', function ($isFrozen) {
        return function isFrozen(it) {
          return isObject(it) ? ($isFrozen ? $isFrozen(it) : false) : true;
        };
      });

      /***/
    },
    /* 195 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.13 Object.isSealed(O)
      var isObject = __webpack_require__(2);

      __webpack_require__(26)('isSealed', function ($isSealed) {
        return function isSealed(it) {
          return isObject(it) ? ($isSealed ? $isSealed(it) : false) : true;
        };
      });

      /***/
    },
    /* 196 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.11 Object.isExtensible(O)
      var isObject = __webpack_require__(2);

      __webpack_require__(26)('isExtensible', function ($isExtensible) {
        return function isExtensible(it) {
          return isObject(it) ? ($isExtensible ? $isExtensible(it) : true) : false;
        };
      });

      /***/
    },
    /* 197 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.3.1 Object.assign(target, source)
      var $export = __webpack_require__(0);

      $export($export.S + $export.F, 'Object', { assign: __webpack_require__(124) });

      /***/
    },
    /* 198 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.3.10 Object.is(value1, value2)
      var $export = __webpack_require__(0);
      $export($export.S, 'Object', { is: __webpack_require__(199) });

      /***/
    },
    /* 199 */
    /***/ function (module, exports) {
      // 7.2.9 SameValue(x, y)
      module.exports =
        Object.is ||
        function is(x, y) {
          // eslint-disable-next-line no-self-compare
          return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
        };

      /***/
    },
    /* 200 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.3.19 Object.setPrototypeOf(O, proto)
      var $export = __webpack_require__(0);
      $export($export.S, 'Object', { setPrototypeOf: __webpack_require__(84).set });

      /***/
    },
    /* 201 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // 19.1.3.6 Object.prototype.toString()
      var classof = __webpack_require__(67);
      var test = {};
      test[__webpack_require__(5)('toStringTag')] = 'z';
      if (test + '' != '[object z]') {
        __webpack_require__(13)(
          Object.prototype,
          'toString',
          function toString() {
            return '[object ' + classof(this) + ']';
          },
          true
        );
      }

      /***/
    },
    /* 202 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
      var $export = __webpack_require__(0);

      $export($export.P, 'Function', { bind: __webpack_require__(125) });

      /***/
    },
    /* 203 */
    /***/ function (module, exports, __webpack_require__) {
      var dP = __webpack_require__(7).f;
      var FProto = Function.prototype;
      var nameRE = /^\s*function ([^ (]*)/;
      var NAME = 'name';

      // 19.2.4.2 name
      NAME in FProto ||
        (__webpack_require__(9) &&
          dP(FProto, NAME, {
            configurable: true,
            get: function () {
              try {
                return ('' + this).match(nameRE)[1];
              } catch (e) {
                return '';
              }
            }
          }));

      /***/
    },
    /* 204 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var isObject = __webpack_require__(2);
      var getPrototypeOf = __webpack_require__(44);
      var HAS_INSTANCE = __webpack_require__(5)('hasInstance');
      var FunctionProto = Function.prototype;
      // 19.2.3.6 Function.prototype[@@hasInstance](V)
      if (!(HAS_INSTANCE in FunctionProto))
        __webpack_require__(7).f(FunctionProto, HAS_INSTANCE, {
          value: function (O) {
            if (typeof this != 'function' || !isObject(O)) return false;
            if (!isObject(this.prototype)) return O instanceof this;
            // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
            while ((O = getPrototypeOf(O))) if (this.prototype === O) return true;
            return false;
          }
        });

      /***/
    },
    /* 205 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      var $parseInt = __webpack_require__(127);
      // 18.2.5 parseInt(string, radix)
      $export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });

      /***/
    },
    /* 206 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      var $parseFloat = __webpack_require__(128);
      // 18.2.4 parseFloat(string)
      $export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });

      /***/
    },
    /* 207 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var global = __webpack_require__(3);
      var has = __webpack_require__(12);
      var cof = __webpack_require__(28);
      var inheritIfRequired = __webpack_require__(86);
      var toPrimitive = __webpack_require__(32);
      var fails = __webpack_require__(1);
      var gOPN = __webpack_require__(43).f;
      var gOPD = __webpack_require__(25).f;
      var dP = __webpack_require__(7).f;
      var $trim = __webpack_require__(49).trim;
      var NUMBER = 'Number';
      var $Number = global[NUMBER];
      var Base = $Number;
      var proto = $Number.prototype;
      // Opera ~12 has broken Object#toString
      var BROKEN_COF = cof(__webpack_require__(42)(proto)) == NUMBER;
      var TRIM = 'trim' in String.prototype;

      // 7.1.3 ToNumber(argument)
      var toNumber = function (argument) {
        var it = toPrimitive(argument, false);
        if (typeof it == 'string' && it.length > 2) {
          it = TRIM ? it.trim() : $trim(it, 3);
          var first = it.charCodeAt(0);
          var third, radix, maxCode;
          if (first === 43 || first === 45) {
            third = it.charCodeAt(2);
            if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
          } else if (first === 48) {
            switch (it.charCodeAt(1)) {
              case 66:
              case 98:
                radix = 2;
                maxCode = 49;
                break; // fast equal /^0b[01]+$/i
              case 79:
              case 111:
                radix = 8;
                maxCode = 55;
                break; // fast equal /^0o[0-7]+$/i
              default:
                return +it;
            }
            for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
              code = digits.charCodeAt(i);
              // parseInt parses a string to a first unavailable symbol
              // but ToNumber should return NaN if a string contains unavailable symbols
              if (code < 48 || code > maxCode) return NaN;
            }
            return parseInt(digits, radix);
          }
        }
        return +it;
      };

      if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
        $Number = function Number(value) {
          var it = arguments.length < 1 ? 0 : value;
          var that = this;
          return that instanceof $Number &&
            // check on 1..constructor(foo) case
            (BROKEN_COF
              ? fails(function () {
                  proto.valueOf.call(that);
                })
              : cof(that) != NUMBER)
            ? inheritIfRequired(new Base(toNumber(it)), that, $Number)
            : toNumber(it);
        };
        for (
          var keys = __webpack_require__(9)
              ? gOPN(Base)
              : // ES3:
                (
                  'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
                  // ES6 (in case, if modules with ES6 Number statics required before):
                  'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
                  'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
                ).split(','),
            j = 0,
            key;
          keys.length > j;
          j++
        ) {
          if (has(Base, (key = keys[j])) && !has($Number, key)) {
            dP($Number, key, gOPD(Base, key));
          }
        }
        $Number.prototype = proto;
        proto.constructor = $Number;
        __webpack_require__(13)(global, NUMBER, $Number);
      }

      /***/
    },
    /* 208 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var $export = __webpack_require__(0);
      var toInteger = __webpack_require__(30);
      var aNumberValue = __webpack_require__(129);
      var repeat = __webpack_require__(87);
      var $toFixed = (1.0).toFixed;
      var floor = Math.floor;
      var data = [0, 0, 0, 0, 0, 0];
      var ERROR = 'Number.toFixed: incorrect invocation!';
      var ZERO = '0';

      var multiply = function (n, c) {
        var i = -1;
        var c2 = c;
        while (++i < 6) {
          c2 += n * data[i];
          data[i] = c2 % 1e7;
          c2 = floor(c2 / 1e7);
        }
      };
      var divide = function (n) {
        var i = 6;
        var c = 0;
        while (--i >= 0) {
          c += data[i];
          data[i] = floor(c / n);
          c = (c % n) * 1e7;
        }
      };
      var numToString = function () {
        var i = 6;
        var s = '';
        while (--i >= 0) {
          if (s !== '' || i === 0 || data[i] !== 0) {
            var t = String(data[i]);
            s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
          }
        }
        return s;
      };
      var pow = function (x, n, acc) {
        return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
      };
      var log = function (x) {
        var n = 0;
        var x2 = x;
        while (x2 >= 4096) {
          n += 12;
          x2 /= 4096;
        }
        while (x2 >= 2) {
          n += 1;
          x2 /= 2;
        }
        return n;
      };

      $export(
        $export.P +
          $export.F *
            ((!!$toFixed &&
              ((0.00008).toFixed(3) !== '0.000' ||
                (0.9).toFixed(0) !== '1' ||
                (1.255).toFixed(2) !== '1.25' ||
                (1000000000000000128.0).toFixed(0) !== '1000000000000000128')) ||
              !__webpack_require__(1)(function () {
                // V8 ~ Android 4.3-
                $toFixed.call({});
              })),
        'Number',
        {
          toFixed: function toFixed(fractionDigits) {
            var x = aNumberValue(this, ERROR);
            var f = toInteger(fractionDigits);
            var s = '';
            var m = ZERO;
            var e, z, j, k;
            if (f < 0 || f > 20) throw RangeError(ERROR);
            // eslint-disable-next-line no-self-compare
            if (x != x) return 'NaN';
            if (x <= -1e21 || x >= 1e21) return String(x);
            if (x < 0) {
              s = '-';
              x = -x;
            }
            if (x > 1e-21) {
              e = log(x * pow(2, 69, 1)) - 69;
              z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
              z *= 0x10000000000000;
              e = 52 - e;
              if (e > 0) {
                multiply(0, z);
                j = f;
                while (j >= 7) {
                  multiply(1e7, 0);
                  j -= 7;
                }
                multiply(pow(10, j, 1), 0);
                j = e - 1;
                while (j >= 23) {
                  divide(1 << 23);
                  j -= 23;
                }
                divide(1 << j);
                multiply(1, 1);
                divide(2);
                m = numToString();
              } else {
                multiply(0, z);
                multiply(1 << -e, 0);
                m = numToString() + repeat.call(ZERO, f);
              }
            }
            if (f > 0) {
              k = m.length;
              m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
            } else {
              m = s + m;
            }
            return m;
          }
        }
      );

      /***/
    },
    /* 209 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var $export = __webpack_require__(0);
      var $fails = __webpack_require__(1);
      var aNumberValue = __webpack_require__(129);
      var $toPrecision = (1.0).toPrecision;

      $export(
        $export.P +
          $export.F *
            ($fails(function () {
              // IE7-
              return $toPrecision.call(1, undefined) !== '1';
            }) ||
              !$fails(function () {
                // V8 ~ Android 4.3-
                $toPrecision.call({});
              })),
        'Number',
        {
          toPrecision: function toPrecision(precision) {
            var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
            return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
          }
        }
      );

      /***/
    },
    /* 210 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.1.2.1 Number.EPSILON
      var $export = __webpack_require__(0);

      $export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });

      /***/
    },
    /* 211 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.1.2.2 Number.isFinite(number)
      var $export = __webpack_require__(0);
      var _isFinite = __webpack_require__(3).isFinite;

      $export($export.S, 'Number', {
        isFinite: function isFinite(it) {
          return typeof it == 'number' && _isFinite(it);
        }
      });

      /***/
    },
    /* 212 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.1.2.3 Number.isInteger(number)
      var $export = __webpack_require__(0);

      $export($export.S, 'Number', { isInteger: __webpack_require__(130) });

      /***/
    },
    /* 213 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.1.2.4 Number.isNaN(number)
      var $export = __webpack_require__(0);

      $export($export.S, 'Number', {
        isNaN: function isNaN(number) {
          // eslint-disable-next-line no-self-compare
          return number != number;
        }
      });

      /***/
    },
    /* 214 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.1.2.5 Number.isSafeInteger(number)
      var $export = __webpack_require__(0);
      var isInteger = __webpack_require__(130);
      var abs = Math.abs;

      $export($export.S, 'Number', {
        isSafeInteger: function isSafeInteger(number) {
          return isInteger(number) && abs(number) <= 0x1fffffffffffff;
        }
      });

      /***/
    },
    /* 215 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.1.2.6 Number.MAX_SAFE_INTEGER
      var $export = __webpack_require__(0);

      $export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });

      /***/
    },
    /* 216 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.1.2.10 Number.MIN_SAFE_INTEGER
      var $export = __webpack_require__(0);

      $export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });

      /***/
    },
    /* 217 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      var $parseFloat = __webpack_require__(128);
      // 20.1.2.12 Number.parseFloat(string)
      $export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });

      /***/
    },
    /* 218 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      var $parseInt = __webpack_require__(127);
      // 20.1.2.13 Number.parseInt(string, radix)
      $export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });

      /***/
    },
    /* 219 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.3 Math.acosh(x)
      var $export = __webpack_require__(0);
      var log1p = __webpack_require__(131);
      var sqrt = Math.sqrt;
      var $acosh = Math.acosh;

      $export(
        $export.S +
          $export.F *
            !(
              $acosh &&
              // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
              Math.floor($acosh(Number.MAX_VALUE)) == 710 &&
              // Tor Browser bug: Math.acosh(Infinity) -> NaN
              $acosh(Infinity) == Infinity
            ),
        'Math',
        {
          acosh: function acosh(x) {
            return (x = +x) < 1
              ? NaN
              : x > 94906265.62425156
                ? Math.log(x) + Math.LN2
                : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
          }
        }
      );

      /***/
    },
    /* 220 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.5 Math.asinh(x)
      var $export = __webpack_require__(0);
      var $asinh = Math.asinh;

      function asinh(x) {
        return !isFinite((x = +x)) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
      }

      // Tor Browser bug: Math.asinh(0) -> -0
      $export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });

      /***/
    },
    /* 221 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.7 Math.atanh(x)
      var $export = __webpack_require__(0);
      var $atanh = Math.atanh;

      // Tor Browser bug: Math.atanh(-0) -> 0
      $export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
        atanh: function atanh(x) {
          return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
        }
      });

      /***/
    },
    /* 222 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.9 Math.cbrt(x)
      var $export = __webpack_require__(0);
      var sign = __webpack_require__(88);

      $export($export.S, 'Math', {
        cbrt: function cbrt(x) {
          return sign((x = +x)) * Math.pow(Math.abs(x), 1 / 3);
        }
      });

      /***/
    },
    /* 223 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.11 Math.clz32(x)
      var $export = __webpack_require__(0);

      $export($export.S, 'Math', {
        clz32: function clz32(x) {
          return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
        }
      });

      /***/
    },
    /* 224 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.12 Math.cosh(x)
      var $export = __webpack_require__(0);
      var exp = Math.exp;

      $export($export.S, 'Math', {
        cosh: function cosh(x) {
          return (exp((x = +x)) + exp(-x)) / 2;
        }
      });

      /***/
    },
    /* 225 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.14 Math.expm1(x)
      var $export = __webpack_require__(0);
      var $expm1 = __webpack_require__(89);

      $export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });

      /***/
    },
    /* 226 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.16 Math.fround(x)
      var $export = __webpack_require__(0);

      $export($export.S, 'Math', { fround: __webpack_require__(227) });

      /***/
    },
    /* 227 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.16 Math.fround(x)
      var sign = __webpack_require__(88);
      var pow = Math.pow;
      var EPSILON = pow(2, -52);
      var EPSILON32 = pow(2, -23);
      var MAX32 = pow(2, 127) * (2 - EPSILON32);
      var MIN32 = pow(2, -126);

      var roundTiesToEven = function (n) {
        return n + 1 / EPSILON - 1 / EPSILON;
      };

      module.exports =
        Math.fround ||
        function fround(x) {
          var $abs = Math.abs(x);
          var $sign = sign(x);
          var a, result;
          if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
          a = (1 + EPSILON32 / EPSILON) * $abs;
          result = a - (a - $abs);
          // eslint-disable-next-line no-self-compare
          if (result > MAX32 || result != result) return $sign * Infinity;
          return $sign * result;
        };

      /***/
    },
    /* 228 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
      var $export = __webpack_require__(0);
      var abs = Math.abs;

      $export($export.S, 'Math', {
        hypot: function hypot(value1, value2) {
          // eslint-disable-line no-unused-vars
          var sum = 0;
          var i = 0;
          var aLen = arguments.length;
          var larg = 0;
          var arg, div;
          while (i < aLen) {
            arg = abs(arguments[i++]);
            if (larg < arg) {
              div = larg / arg;
              sum = sum * div * div + 1;
              larg = arg;
            } else if (arg > 0) {
              div = arg / larg;
              sum += div * div;
            } else sum += arg;
          }
          return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
        }
      });

      /***/
    },
    /* 229 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.18 Math.imul(x, y)
      var $export = __webpack_require__(0);
      var $imul = Math.imul;

      // some WebKit versions fails with big numbers, some has wrong arity
      $export(
        $export.S +
          $export.F *
            __webpack_require__(1)(function () {
              return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
            }),
        'Math',
        {
          imul: function imul(x, y) {
            var UINT16 = 0xffff;
            var xn = +x;
            var yn = +y;
            var xl = UINT16 & xn;
            var yl = UINT16 & yn;
            return 0 | (xl * yl + ((((UINT16 & (xn >>> 16)) * yl + xl * (UINT16 & (yn >>> 16))) << 16) >>> 0));
          }
        }
      );

      /***/
    },
    /* 230 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.21 Math.log10(x)
      var $export = __webpack_require__(0);

      $export($export.S, 'Math', {
        log10: function log10(x) {
          return Math.log(x) * Math.LOG10E;
        }
      });

      /***/
    },
    /* 231 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.20 Math.log1p(x)
      var $export = __webpack_require__(0);

      $export($export.S, 'Math', { log1p: __webpack_require__(131) });

      /***/
    },
    /* 232 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.22 Math.log2(x)
      var $export = __webpack_require__(0);

      $export($export.S, 'Math', {
        log2: function log2(x) {
          return Math.log(x) / Math.LN2;
        }
      });

      /***/
    },
    /* 233 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.28 Math.sign(x)
      var $export = __webpack_require__(0);

      $export($export.S, 'Math', { sign: __webpack_require__(88) });

      /***/
    },
    /* 234 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.30 Math.sinh(x)
      var $export = __webpack_require__(0);
      var expm1 = __webpack_require__(89);
      var exp = Math.exp;

      // V8 near Chromium 38 has a problem with very small numbers
      $export(
        $export.S +
          $export.F *
            __webpack_require__(1)(function () {
              return !Math.sinh(-2e-17) != -2e-17;
            }),
        'Math',
        {
          sinh: function sinh(x) {
            return Math.abs((x = +x)) < 1 ? (expm1(x) - expm1(-x)) / 2 : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
          }
        }
      );

      /***/
    },
    /* 235 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.33 Math.tanh(x)
      var $export = __webpack_require__(0);
      var expm1 = __webpack_require__(89);
      var exp = Math.exp;

      $export($export.S, 'Math', {
        tanh: function tanh(x) {
          var a = expm1((x = +x));
          var b = expm1(-x);
          return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
        }
      });

      /***/
    },
    /* 236 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.34 Math.trunc(x)
      var $export = __webpack_require__(0);

      $export($export.S, 'Math', {
        trunc: function trunc(it) {
          return (it > 0 ? Math.floor : Math.ceil)(it);
        }
      });

      /***/
    },
    /* 237 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      var toAbsoluteIndex = __webpack_require__(41);
      var fromCharCode = String.fromCharCode;
      var $fromCodePoint = String.fromCodePoint;

      // length should be 1, old FF problem
      $export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
        // 21.1.2.2 String.fromCodePoint(...codePoints)
        fromCodePoint: function fromCodePoint(x) {
          // eslint-disable-line no-unused-vars
          var res = [];
          var aLen = arguments.length;
          var i = 0;
          var code;
          while (aLen > i) {
            code = +arguments[i++];
            if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
            res.push(
              code < 0x10000
                ? fromCharCode(code)
                : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00)
            );
          }
          return res.join('');
        }
      });

      /***/
    },
    /* 238 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      var toIObject = __webpack_require__(17);
      var toLength = __webpack_require__(8);

      $export($export.S, 'String', {
        // 21.1.2.4 String.raw(callSite, ...substitutions)
        raw: function raw(callSite) {
          var tpl = toIObject(callSite.raw);
          var len = toLength(tpl.length);
          var aLen = arguments.length;
          var res = [];
          var i = 0;
          while (len > i) {
            res.push(String(tpl[i++]));
            if (i < aLen) res.push(String(arguments[i]));
          }
          return res.join('');
        }
      });

      /***/
    },
    /* 239 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // 21.1.3.25 String.prototype.trim()
      __webpack_require__(49)('trim', function ($trim) {
        return function trim() {
          return $trim(this, 3);
        };
      });

      /***/
    },
    /* 240 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var $at = __webpack_require__(132)(true);

      // 21.1.3.27 String.prototype[@@iterator]()
      __webpack_require__(90)(
        String,
        'String',
        function (iterated) {
          this._t = String(iterated); // target
          this._i = 0; // next index
          // 21.1.5.2.1 %StringIteratorPrototype%.next()
        },
        function () {
          var O = this._t;
          var index = this._i;
          var point;
          if (index >= O.length) return { value: undefined, done: true };
          point = $at(O, index);
          this._i += point.length;
          return { value: point, done: false };
        }
      );

      /***/
    },
    /* 241 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var $export = __webpack_require__(0);
      var $at = __webpack_require__(132)(false);
      $export($export.P, 'String', {
        // 21.1.3.3 String.prototype.codePointAt(pos)
        codePointAt: function codePointAt(pos) {
          return $at(this, pos);
        }
      });

      /***/
    },
    /* 242 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';
      // 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

      var $export = __webpack_require__(0);
      var toLength = __webpack_require__(8);
      var context = __webpack_require__(91);
      var ENDS_WITH = 'endsWith';
      var $endsWith = ''[ENDS_WITH];

      $export($export.P + $export.F * __webpack_require__(93)(ENDS_WITH), 'String', {
        endsWith: function endsWith(searchString /* , endPosition = @length */) {
          var that = context(this, searchString, ENDS_WITH);
          var endPosition = arguments.length > 1 ? arguments[1] : undefined;
          var len = toLength(that.length);
          var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
          var search = String(searchString);
          return $endsWith ? $endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
        }
      });

      /***/
    },
    /* 243 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';
      // 21.1.3.7 String.prototype.includes(searchString, position = 0)

      var $export = __webpack_require__(0);
      var context = __webpack_require__(91);
      var INCLUDES = 'includes';

      $export($export.P + $export.F * __webpack_require__(93)(INCLUDES), 'String', {
        includes: function includes(searchString /* , position = 0 */) {
          return !!~context(this, searchString, INCLUDES).indexOf(
            searchString,
            arguments.length > 1 ? arguments[1] : undefined
          );
        }
      });

      /***/
    },
    /* 244 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);

      $export($export.P, 'String', {
        // 21.1.3.13 String.prototype.repeat(count)
        repeat: __webpack_require__(87)
      });

      /***/
    },
    /* 245 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';
      // 21.1.3.18 String.prototype.startsWith(searchString [, position ])

      var $export = __webpack_require__(0);
      var toLength = __webpack_require__(8);
      var context = __webpack_require__(91);
      var STARTS_WITH = 'startsWith';
      var $startsWith = ''[STARTS_WITH];

      $export($export.P + $export.F * __webpack_require__(93)(STARTS_WITH), 'String', {
        startsWith: function startsWith(searchString /* , position = 0 */) {
          var that = context(this, searchString, STARTS_WITH);
          var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
          var search = String(searchString);
          return $startsWith
            ? $startsWith.call(that, search, index)
            : that.slice(index, index + search.length) === search;
        }
      });

      /***/
    },
    /* 246 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // B.2.3.2 String.prototype.anchor(name)
      __webpack_require__(15)('anchor', function (createHTML) {
        return function anchor(name) {
          return createHTML(this, 'a', 'name', name);
        };
      });

      /***/
    },
    /* 247 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // B.2.3.3 String.prototype.big()
      __webpack_require__(15)('big', function (createHTML) {
        return function big() {
          return createHTML(this, 'big', '', '');
        };
      });

      /***/
    },
    /* 248 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // B.2.3.4 String.prototype.blink()
      __webpack_require__(15)('blink', function (createHTML) {
        return function blink() {
          return createHTML(this, 'blink', '', '');
        };
      });

      /***/
    },
    /* 249 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // B.2.3.5 String.prototype.bold()
      __webpack_require__(15)('bold', function (createHTML) {
        return function bold() {
          return createHTML(this, 'b', '', '');
        };
      });

      /***/
    },
    /* 250 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // B.2.3.6 String.prototype.fixed()
      __webpack_require__(15)('fixed', function (createHTML) {
        return function fixed() {
          return createHTML(this, 'tt', '', '');
        };
      });

      /***/
    },
    /* 251 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // B.2.3.7 String.prototype.fontcolor(color)
      __webpack_require__(15)('fontcolor', function (createHTML) {
        return function fontcolor(color) {
          return createHTML(this, 'font', 'color', color);
        };
      });

      /***/
    },
    /* 252 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // B.2.3.8 String.prototype.fontsize(size)
      __webpack_require__(15)('fontsize', function (createHTML) {
        return function fontsize(size) {
          return createHTML(this, 'font', 'size', size);
        };
      });

      /***/
    },
    /* 253 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // B.2.3.9 String.prototype.italics()
      __webpack_require__(15)('italics', function (createHTML) {
        return function italics() {
          return createHTML(this, 'i', '', '');
        };
      });

      /***/
    },
    /* 254 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // B.2.3.10 String.prototype.link(url)
      __webpack_require__(15)('link', function (createHTML) {
        return function link(url) {
          return createHTML(this, 'a', 'href', url);
        };
      });

      /***/
    },
    /* 255 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // B.2.3.11 String.prototype.small()
      __webpack_require__(15)('small', function (createHTML) {
        return function small() {
          return createHTML(this, 'small', '', '');
        };
      });

      /***/
    },
    /* 256 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // B.2.3.12 String.prototype.strike()
      __webpack_require__(15)('strike', function (createHTML) {
        return function strike() {
          return createHTML(this, 'strike', '', '');
        };
      });

      /***/
    },
    /* 257 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // B.2.3.13 String.prototype.sub()
      __webpack_require__(15)('sub', function (createHTML) {
        return function sub() {
          return createHTML(this, 'sub', '', '');
        };
      });

      /***/
    },
    /* 258 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // B.2.3.14 String.prototype.sup()
      __webpack_require__(15)('sup', function (createHTML) {
        return function sup() {
          return createHTML(this, 'sup', '', '');
        };
      });

      /***/
    },
    /* 259 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.3.3.1 / 15.9.4.4 Date.now()
      var $export = __webpack_require__(0);

      $export($export.S, 'Date', {
        now: function () {
          return new Date().getTime();
        }
      });

      /***/
    },
    /* 260 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var $export = __webpack_require__(0);
      var toObject = __webpack_require__(14);
      var toPrimitive = __webpack_require__(32);

      $export(
        $export.P +
          $export.F *
            __webpack_require__(1)(function () {
              return (
                new Date(NaN).toJSON() !== null ||
                Date.prototype.toJSON.call({
                  toISOString: function () {
                    return 1;
                  }
                }) !== 1
              );
            }),
        'Date',
        {
          // eslint-disable-next-line no-unused-vars
          toJSON: function toJSON(key) {
            var O = toObject(this);
            var pv = toPrimitive(O);
            return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
          }
        }
      );

      /***/
    },
    /* 261 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
      var $export = __webpack_require__(0);
      var toISOString = __webpack_require__(262);

      // PhantomJS / old WebKit has a broken implementations
      $export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
        toISOString: toISOString
      });

      /***/
    },
    /* 262 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
      var fails = __webpack_require__(1);
      var getTime = Date.prototype.getTime;
      var $toISOString = Date.prototype.toISOString;

      var lz = function (num) {
        return num > 9 ? num : '0' + num;
      };

      // PhantomJS / old WebKit has a broken implementations
      module.exports =
        fails(function () {
          return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
        }) ||
        !fails(function () {
          $toISOString.call(new Date(NaN));
        })
          ? function toISOString() {
              if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
              var d = this;
              var y = d.getUTCFullYear();
              var m = d.getUTCMilliseconds();
              var s = y < 0 ? '-' : y > 9999 ? '+' : '';
              return (
                s +
                ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
                '-' +
                lz(d.getUTCMonth() + 1) +
                '-' +
                lz(d.getUTCDate()) +
                'T' +
                lz(d.getUTCHours()) +
                ':' +
                lz(d.getUTCMinutes()) +
                ':' +
                lz(d.getUTCSeconds()) +
                '.' +
                (m > 99 ? m : '0' + lz(m)) +
                'Z'
              );
            }
          : $toISOString;

      /***/
    },
    /* 263 */
    /***/ function (module, exports, __webpack_require__) {
      var DateProto = Date.prototype;
      var INVALID_DATE = 'Invalid Date';
      var TO_STRING = 'toString';
      var $toString = DateProto[TO_STRING];
      var getTime = DateProto.getTime;
      if (new Date(NaN) + '' != INVALID_DATE) {
        __webpack_require__(13)(DateProto, TO_STRING, function toString() {
          var value = getTime.call(this);
          // eslint-disable-next-line no-self-compare
          return value === value ? $toString.call(this) : INVALID_DATE;
        });
      }

      /***/
    },
    /* 264 */
    /***/ function (module, exports, __webpack_require__) {
      var TO_PRIMITIVE = __webpack_require__(5)('toPrimitive');
      var proto = Date.prototype;

      if (!(TO_PRIMITIVE in proto)) __webpack_require__(16)(proto, TO_PRIMITIVE, __webpack_require__(265));

      /***/
    },
    /* 265 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var anObject = __webpack_require__(4);
      var toPrimitive = __webpack_require__(32);
      var NUMBER = 'number';

      module.exports = function (hint) {
        if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
        return toPrimitive(anObject(this), hint != NUMBER);
      };

      /***/
    },
    /* 266 */
    /***/ function (module, exports, __webpack_require__) {
      // 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
      var $export = __webpack_require__(0);

      $export($export.S, 'Array', { isArray: __webpack_require__(66) });

      /***/
    },
    /* 267 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var ctx = __webpack_require__(23);
      var $export = __webpack_require__(0);
      var toObject = __webpack_require__(14);
      var call = __webpack_require__(134);
      var isArrayIter = __webpack_require__(94);
      var toLength = __webpack_require__(8);
      var createProperty = __webpack_require__(95);
      var getIterFn = __webpack_require__(96);

      $export(
        $export.S +
          $export.F *
            !__webpack_require__(68)(function (iter) {
              Array.from(iter);
            }),
        'Array',
        {
          // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
          from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
            var O = toObject(arrayLike);
            var C = typeof this == 'function' ? this : Array;
            var aLen = arguments.length;
            var mapfn = aLen > 1 ? arguments[1] : undefined;
            var mapping = mapfn !== undefined;
            var index = 0;
            var iterFn = getIterFn(O);
            var length, result, step, iterator;
            if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
            // if object isn't iterable or it's array with default iterator - use simple case
            if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
              for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
                createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
              }
            } else {
              length = toLength(O.length);
              for (result = new C(length); length > index; index++) {
                createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
              }
            }
            result.length = index;
            return result;
          }
        }
      );

      /***/
    },
    /* 268 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var $export = __webpack_require__(0);
      var createProperty = __webpack_require__(95);

      // WebKit Array.of isn't generic
      $export(
        $export.S +
          $export.F *
            __webpack_require__(1)(function () {
              function F() {
                /* empty */
              }
              return !(Array.of.call(F) instanceof F);
            }),
        'Array',
        {
          // 22.1.2.3 Array.of( ...items)
          of: function of(/* ...args */) {
            var index = 0;
            var aLen = arguments.length;
            var result = new (typeof this == 'function' ? this : Array)(aLen);
            while (aLen > index) createProperty(result, index, arguments[index++]);
            result.length = aLen;
            return result;
          }
        }
      );

      /***/
    },
    /* 269 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // 22.1.3.13 Array.prototype.join(separator)
      var $export = __webpack_require__(0);
      var toIObject = __webpack_require__(17);
      var arrayJoin = [].join;

      // fallback for not array-like strings
      $export(
        $export.P + $export.F * (__webpack_require__(59) != Object || !__webpack_require__(20)(arrayJoin)),
        'Array',
        {
          join: function join(separator) {
            return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
          }
        }
      );

      /***/
    },
    /* 270 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var $export = __webpack_require__(0);
      var html = __webpack_require__(83);
      var cof = __webpack_require__(28);
      var toAbsoluteIndex = __webpack_require__(41);
      var toLength = __webpack_require__(8);
      var arraySlice = [].slice;

      // fallback for not array-like ES3 strings and DOM objects
      $export(
        $export.P +
          $export.F *
            __webpack_require__(1)(function () {
              if (html) arraySlice.call(html);
            }),
        'Array',
        {
          slice: function slice(begin, end) {
            var len = toLength(this.length);
            var klass = cof(this);
            end = end === undefined ? len : end;
            if (klass == 'Array') return arraySlice.call(this, begin, end);
            var start = toAbsoluteIndex(begin, len);
            var upTo = toAbsoluteIndex(end, len);
            var size = toLength(upTo - start);
            var cloned = Array(size);
            var i = 0;
            for (; i < size; i++) cloned[i] = klass == 'String' ? this.charAt(start + i) : this[start + i];
            return cloned;
          }
        }
      );

      /***/
    },
    /* 271 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var $export = __webpack_require__(0);
      var aFunction = __webpack_require__(24);
      var toObject = __webpack_require__(14);
      var fails = __webpack_require__(1);
      var $sort = [].sort;
      var test = [1, 2, 3];

      $export(
        $export.P +
          $export.F *
            (fails(function () {
              // IE8-
              test.sort(undefined);
            }) ||
              !fails(function () {
                // V8 bug
                test.sort(null);
                // Old WebKit
              }) ||
              !__webpack_require__(20)($sort)),
        'Array',
        {
          // 22.1.3.25 Array.prototype.sort(comparefn)
          sort: function sort(comparefn) {
            return comparefn === undefined
              ? $sort.call(toObject(this))
              : $sort.call(toObject(this), aFunction(comparefn));
          }
        }
      );

      /***/
    },
    /* 272 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var $export = __webpack_require__(0);
      var $forEach = __webpack_require__(27)(0);
      var STRICT = __webpack_require__(20)([].forEach, true);

      $export($export.P + $export.F * !STRICT, 'Array', {
        // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
        forEach: function forEach(callbackfn /* , thisArg */) {
          return $forEach(this, callbackfn, arguments[1]);
        }
      });

      /***/
    },
    /* 273 */
    /***/ function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(2);
      var isArray = __webpack_require__(66);
      var SPECIES = __webpack_require__(5)('species');

      module.exports = function (original) {
        var C;
        if (isArray(original)) {
          C = original.constructor;
          // cross-realm fallback
          if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
          if (isObject(C)) {
            C = C[SPECIES];
            if (C === null) C = undefined;
          }
        }
        return C === undefined ? Array : C;
      };

      /***/
    },
    /* 274 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var $export = __webpack_require__(0);
      var $map = __webpack_require__(27)(1);

      $export($export.P + $export.F * !__webpack_require__(20)([].map, true), 'Array', {
        // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
        map: function map(callbackfn /* , thisArg */) {
          return $map(this, callbackfn, arguments[1]);
        }
      });

      /***/
    },
    /* 275 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var $export = __webpack_require__(0);
      var $filter = __webpack_require__(27)(2);

      $export($export.P + $export.F * !__webpack_require__(20)([].filter, true), 'Array', {
        // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
        filter: function filter(callbackfn /* , thisArg */) {
          return $filter(this, callbackfn, arguments[1]);
        }
      });

      /***/
    },
    /* 276 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var $export = __webpack_require__(0);
      var $some = __webpack_require__(27)(3);

      $export($export.P + $export.F * !__webpack_require__(20)([].some, true), 'Array', {
        // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
        some: function some(callbackfn /* , thisArg */) {
          return $some(this, callbackfn, arguments[1]);
        }
      });

      /***/
    },
    /* 277 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var $export = __webpack_require__(0);
      var $every = __webpack_require__(27)(4);

      $export($export.P + $export.F * !__webpack_require__(20)([].every, true), 'Array', {
        // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
        every: function every(callbackfn /* , thisArg */) {
          return $every(this, callbackfn, arguments[1]);
        }
      });

      /***/
    },
    /* 278 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var $export = __webpack_require__(0);
      var $reduce = __webpack_require__(136);

      $export($export.P + $export.F * !__webpack_require__(20)([].reduce, true), 'Array', {
        // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
        reduce: function reduce(callbackfn /* , initialValue */) {
          return $reduce(this, callbackfn, arguments.length, arguments[1], false);
        }
      });

      /***/
    },
    /* 279 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var $export = __webpack_require__(0);
      var $reduce = __webpack_require__(136);

      $export($export.P + $export.F * !__webpack_require__(20)([].reduceRight, true), 'Array', {
        // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
        reduceRight: function reduceRight(callbackfn /* , initialValue */) {
          return $reduce(this, callbackfn, arguments.length, arguments[1], true);
        }
      });

      /***/
    },
    /* 280 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var $export = __webpack_require__(0);
      var $indexOf = __webpack_require__(64)(false);
      var $native = [].indexOf;
      var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

      $export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(20)($native)), 'Array', {
        // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
        indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
          return NEGATIVE_ZERO
            ? // convert -0 to +0
              $native.apply(this, arguments) || 0
            : $indexOf(this, searchElement, arguments[1]);
        }
      });

      /***/
    },
    /* 281 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var $export = __webpack_require__(0);
      var toIObject = __webpack_require__(17);
      var toInteger = __webpack_require__(30);
      var toLength = __webpack_require__(8);
      var $native = [].lastIndexOf;
      var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

      $export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(20)($native)), 'Array', {
        // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
        lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
          // convert -0 to +0
          if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
          var O = toIObject(this);
          var length = toLength(O.length);
          var index = length - 1;
          if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
          if (index < 0) index = length + index;
          for (; index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
          return -1;
        }
      });

      /***/
    },
    /* 282 */
    /***/ function (module, exports, __webpack_require__) {
      // 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
      var $export = __webpack_require__(0);

      $export($export.P, 'Array', { copyWithin: __webpack_require__(137) });

      __webpack_require__(45)('copyWithin');

      /***/
    },
    /* 283 */
    /***/ function (module, exports, __webpack_require__) {
      // 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
      var $export = __webpack_require__(0);

      $export($export.P, 'Array', { fill: __webpack_require__(97) });

      __webpack_require__(45)('fill');

      /***/
    },
    /* 284 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
      var $export = __webpack_require__(0);
      var $find = __webpack_require__(27)(5);
      var KEY = 'find';
      var forced = true;
      // Shouldn't skip holes
      if (KEY in [])
        Array(1)[KEY](function () {
          forced = false;
        });
      $export($export.P + $export.F * forced, 'Array', {
        find: function find(callbackfn /* , that = undefined */) {
          return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        }
      });
      __webpack_require__(45)(KEY);

      /***/
    },
    /* 285 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
      var $export = __webpack_require__(0);
      var $find = __webpack_require__(27)(6);
      var KEY = 'findIndex';
      var forced = true;
      // Shouldn't skip holes
      if (KEY in [])
        Array(1)[KEY](function () {
          forced = false;
        });
      $export($export.P + $export.F * forced, 'Array', {
        findIndex: function findIndex(callbackfn /* , that = undefined */) {
          return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        }
      });
      __webpack_require__(45)(KEY);

      /***/
    },
    /* 286 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(51)('Array');

      /***/
    },
    /* 287 */
    /***/ function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var inheritIfRequired = __webpack_require__(86);
      var dP = __webpack_require__(7).f;
      var gOPN = __webpack_require__(43).f;
      var isRegExp = __webpack_require__(92);
      var $flags = __webpack_require__(99);
      var $RegExp = global.RegExp;
      var Base = $RegExp;
      var proto = $RegExp.prototype;
      var re1 = /a/g;
      var re2 = /a/g;
      // "new" creates a new object, old webkit buggy here
      var CORRECT_NEW = new $RegExp(re1) !== re1;

      if (
        __webpack_require__(9) &&
        (!CORRECT_NEW ||
          __webpack_require__(1)(function () {
            re2[__webpack_require__(5)('match')] = false;
            // RegExp constructor can alter flags and IsRegExp works correct with @@match
            return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
          }))
      ) {
        $RegExp = function RegExp(p, f) {
          var tiRE = this instanceof $RegExp;
          var piRE = isRegExp(p);
          var fiU = f === undefined;
          return !tiRE && piRE && p.constructor === $RegExp && fiU
            ? p
            : inheritIfRequired(
                CORRECT_NEW
                  ? new Base(piRE && !fiU ? p.source : p, f)
                  : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f),
                tiRE ? this : proto,
                $RegExp
              );
        };
        var proxy = function (key) {
          key in $RegExp ||
            dP($RegExp, key, {
              configurable: true,
              get: function () {
                return Base[key];
              },
              set: function (it) {
                Base[key] = it;
              }
            });
        };
        for (var keys = gOPN(Base), i = 0; keys.length > i; ) proxy(keys[i++]);
        proto.constructor = $RegExp;
        $RegExp.prototype = proto;
        __webpack_require__(13)(global, 'RegExp', $RegExp);
      }

      __webpack_require__(51)('RegExp');

      /***/
    },
    /* 288 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      __webpack_require__(139);
      var anObject = __webpack_require__(4);
      var $flags = __webpack_require__(99);
      var DESCRIPTORS = __webpack_require__(9);
      var TO_STRING = 'toString';
      var $toString = /./[TO_STRING];

      var define = function (fn) {
        __webpack_require__(13)(RegExp.prototype, TO_STRING, fn, true);
      };

      // 21.2.5.14 RegExp.prototype.toString()
      if (
        __webpack_require__(1)(function () {
          return $toString.call({ source: 'a', flags: 'b' }) != '/a/b';
        })
      ) {
        define(function toString() {
          var R = anObject(this);
          return '/'.concat(
            R.source,
            '/',
            'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined
          );
        });
        // FF44- RegExp#toString has a wrong name
      } else if ($toString.name != TO_STRING) {
        define(function toString() {
          return $toString.call(this);
        });
      }

      /***/
    },
    /* 289 */
    /***/ function (module, exports, __webpack_require__) {
      // @@match logic
      __webpack_require__(69)('match', 1, function (defined, MATCH, $match) {
        // 21.1.3.11 String.prototype.match(regexp)
        return [
          function match(regexp) {
            'use strict';
            var O = defined(this);
            var fn = regexp == undefined ? undefined : regexp[MATCH];
            return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
          },
          $match
        ];
      });

      /***/
    },
    /* 290 */
    /***/ function (module, exports, __webpack_require__) {
      // @@replace logic
      __webpack_require__(69)('replace', 2, function (defined, REPLACE, $replace) {
        // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
        return [
          function replace(searchValue, replaceValue) {
            'use strict';
            var O = defined(this);
            var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
            return fn !== undefined
              ? fn.call(searchValue, O, replaceValue)
              : $replace.call(String(O), searchValue, replaceValue);
          },
          $replace
        ];
      });

      /***/
    },
    /* 291 */
    /***/ function (module, exports, __webpack_require__) {
      // @@search logic
      __webpack_require__(69)('search', 1, function (defined, SEARCH, $search) {
        // 21.1.3.15 String.prototype.search(regexp)
        return [
          function search(regexp) {
            'use strict';
            var O = defined(this);
            var fn = regexp == undefined ? undefined : regexp[SEARCH];
            return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
          },
          $search
        ];
      });

      /***/
    },
    /* 292 */
    /***/ function (module, exports, __webpack_require__) {
      // @@split logic
      __webpack_require__(69)('split', 2, function (defined, SPLIT, $split) {
        'use strict';
        var isRegExp = __webpack_require__(92);
        var _split = $split;
        var $push = [].push;
        var $SPLIT = 'split';
        var LENGTH = 'length';
        var LAST_INDEX = 'lastIndex';
        if (
          'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
          'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
          'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
          '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
          '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
          ''[$SPLIT](/.?/)[LENGTH]
        ) {
          var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
          // based on es5-shim implementation, need to rework it
          $split = function (separator, limit) {
            var string = String(this);
            if (separator === undefined && limit === 0) return [];
            // If `separator` is not a regex, use native split
            if (!isRegExp(separator)) return _split.call(string, separator, limit);
            var output = [];
            var flags =
              (separator.ignoreCase ? 'i' : '') +
              (separator.multiline ? 'm' : '') +
              (separator.unicode ? 'u' : '') +
              (separator.sticky ? 'y' : '');
            var lastLastIndex = 0;
            var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
            // Make `global` and avoid `lastIndex` issues by working with a copy
            var separatorCopy = new RegExp(separator.source, flags + 'g');
            var separator2, match, lastIndex, lastLength, i;
            // Doesn't need flags gy, but they don't hurt
            if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
            while ((match = separatorCopy.exec(string))) {
              // `separatorCopy.lastIndex` is not reliable cross-browser
              lastIndex = match.index + match[0][LENGTH];
              if (lastIndex > lastLastIndex) {
                output.push(string.slice(lastLastIndex, match.index));
                // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
                // eslint-disable-next-line no-loop-func
                if (!NPCG && match[LENGTH] > 1)
                  match[0].replace(separator2, function () {
                    for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
                  });
                if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
                lastLength = match[0][LENGTH];
                lastLastIndex = lastIndex;
                if (output[LENGTH] >= splitLimit) break;
              }
              if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
            }
            if (lastLastIndex === string[LENGTH]) {
              if (lastLength || !separatorCopy.test('')) output.push('');
            } else output.push(string.slice(lastLastIndex));
            return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
          };
          // Chakra, V8
        } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
          $split = function (separator, limit) {
            return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
          };
        }
        // 21.1.3.17 String.prototype.split(separator, limit)
        return [
          function split(separator, limit) {
            var O = defined(this);
            var fn = separator == undefined ? undefined : separator[SPLIT];
            return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
          },
          $split
        ];
      });

      /***/
    },
    /* 293 */
    /***/ function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var macrotask = __webpack_require__(100).set;
      var Observer = global.MutationObserver || global.WebKitMutationObserver;
      var process = global.process;
      var Promise = global.Promise;
      var isNode = __webpack_require__(28)(process) == 'process';

      module.exports = function () {
        var head, last, notify;

        var flush = function () {
          var parent, fn;
          if (isNode && (parent = process.domain)) parent.exit();
          while (head) {
            fn = head.fn;
            head = head.next;
            try {
              fn();
            } catch (e) {
              if (head) notify();
              else last = undefined;
              throw e;
            }
          }
          last = undefined;
          if (parent) parent.enter();
        };

        // Node.js
        if (isNode) {
          notify = function () {
            process.nextTick(flush);
          };
          // browsers with MutationObserver
        } else if (Observer) {
          var toggle = true;
          var node = document.createTextNode('');
          new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
          notify = function () {
            node.data = toggle = !toggle;
          };
          // environments with maybe non-completely correct, but existent Promise
        } else if (Promise && Promise.resolve) {
          var promise = Promise.resolve();
          notify = function () {
            promise.then(flush);
          };
          // for other environments - macrotask based on:
          // - setImmediate
          // - MessageChannel
          // - window.postMessag
          // - onreadystatechange
          // - setTimeout
        } else {
          notify = function () {
            // strange IE + webpack dev server bug - use .call(global)
            macrotask.call(global, flush);
          };
        }

        return function (fn) {
          var task = { fn: fn, next: undefined };
          if (last) last.next = task;
          if (!head) {
            head = task;
            notify();
          }
          last = task;
        };
      };

      /***/
    },
    /* 294 */
    /***/ function (module, exports) {
      module.exports = function (exec) {
        try {
          return { e: false, v: exec() };
        } catch (e) {
          return { e: true, v: e };
        }
      };

      /***/
    },
    /* 295 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var strong = __webpack_require__(143);
      var validate = __webpack_require__(54);
      var MAP = 'Map';

      // 23.1 Map Objects
      module.exports = __webpack_require__(72)(
        MAP,
        function (get) {
          return function Map() {
            return get(this, arguments.length > 0 ? arguments[0] : undefined);
          };
        },
        {
          // 23.1.3.6 Map.prototype.get(key)
          get: function get(key) {
            var entry = strong.getEntry(validate(this, MAP), key);
            return entry && entry.v;
          },
          // 23.1.3.9 Map.prototype.set(key, value)
          set: function set(key, value) {
            return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
          }
        },
        strong,
        true
      );

      /***/
    },
    /* 296 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var strong = __webpack_require__(143);
      var validate = __webpack_require__(54);
      var SET = 'Set';

      // 23.2 Set Objects
      module.exports = __webpack_require__(72)(
        SET,
        function (get) {
          return function Set() {
            return get(this, arguments.length > 0 ? arguments[0] : undefined);
          };
        },
        {
          // 23.2.3.1 Set.prototype.add(value)
          add: function add(value) {
            return strong.def(validate(this, SET), (value = value === 0 ? 0 : value), value);
          }
        },
        strong
      );

      /***/
    },
    /* 297 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var each = __webpack_require__(27)(0);
      var redefine = __webpack_require__(13);
      var meta = __webpack_require__(33);
      var assign = __webpack_require__(124);
      var weak = __webpack_require__(144);
      var isObject = __webpack_require__(2);
      var fails = __webpack_require__(1);
      var validate = __webpack_require__(54);
      var WEAK_MAP = 'WeakMap';
      var getWeak = meta.getWeak;
      var isExtensible = Object.isExtensible;
      var uncaughtFrozenStore = weak.ufstore;
      var tmp = {};
      var InternalMap;

      var wrapper = function (get) {
        return function WeakMap() {
          return get(this, arguments.length > 0 ? arguments[0] : undefined);
        };
      };

      var methods = {
        // 23.3.3.3 WeakMap.prototype.get(key)
        get: function get(key) {
          if (isObject(key)) {
            var data = getWeak(key);
            if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
            return data ? data[this._i] : undefined;
          }
        },
        // 23.3.3.5 WeakMap.prototype.set(key, value)
        set: function set(key, value) {
          return weak.def(validate(this, WEAK_MAP), key, value);
        }
      };

      // 23.3 WeakMap Objects
      var $WeakMap = (module.exports = __webpack_require__(72)(WEAK_MAP, wrapper, methods, weak, true, true));

      // IE11 WeakMap frozen keys fix
      if (
        fails(function () {
          return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7;
        })
      ) {
        InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
        assign(InternalMap.prototype, methods);
        meta.NEED = true;
        each(['delete', 'has', 'get', 'set'], function (key) {
          var proto = $WeakMap.prototype;
          var method = proto[key];
          redefine(proto, key, function (a, b) {
            // store frozen objects on internal weakmap shim
            if (isObject(a) && !isExtensible(a)) {
              if (!this._f) this._f = new InternalMap();
              var result = this._f[key](a, b);
              return key == 'set' ? this : result;
              // store all the rest on native weakmap
            }
            return method.call(this, a, b);
          });
        });
      }

      /***/
    },
    /* 298 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var weak = __webpack_require__(144);
      var validate = __webpack_require__(54);
      var WEAK_SET = 'WeakSet';

      // 23.4 WeakSet Objects
      __webpack_require__(72)(
        WEAK_SET,
        function (get) {
          return function WeakSet() {
            return get(this, arguments.length > 0 ? arguments[0] : undefined);
          };
        },
        {
          // 23.4.3.1 WeakSet.prototype.add(value)
          add: function add(value) {
            return weak.def(validate(this, WEAK_SET), value, true);
          }
        },
        weak,
        false,
        true
      );

      /***/
    },
    /* 299 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var $export = __webpack_require__(0);
      var $typed = __webpack_require__(73);
      var buffer = __webpack_require__(101);
      var anObject = __webpack_require__(4);
      var toAbsoluteIndex = __webpack_require__(41);
      var toLength = __webpack_require__(8);
      var isObject = __webpack_require__(2);
      var ArrayBuffer = __webpack_require__(3).ArrayBuffer;
      var speciesConstructor = __webpack_require__(71);
      var $ArrayBuffer = buffer.ArrayBuffer;
      var $DataView = buffer.DataView;
      var $isView = $typed.ABV && ArrayBuffer.isView;
      var $slice = $ArrayBuffer.prototype.slice;
      var VIEW = $typed.VIEW;
      var ARRAY_BUFFER = 'ArrayBuffer';

      $export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

      $export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
        // 24.1.3.1 ArrayBuffer.isView(arg)
        isView: function isView(it) {
          return ($isView && $isView(it)) || (isObject(it) && VIEW in it);
        }
      });

      $export(
        $export.P +
          $export.U +
          $export.F *
            __webpack_require__(1)(function () {
              return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
            }),
        ARRAY_BUFFER,
        {
          // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
          slice: function slice(start, end) {
            if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
            var len = anObject(this).byteLength;
            var first = toAbsoluteIndex(start, len);
            var final = toAbsoluteIndex(end === undefined ? len : end, len);
            var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
            var viewS = new $DataView(this);
            var viewT = new $DataView(result);
            var index = 0;
            while (first < final) {
              viewT.setUint8(index++, viewS.getUint8(first++));
            }
            return result;
          }
        }
      );

      __webpack_require__(51)(ARRAY_BUFFER);

      /***/
    },
    /* 300 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      $export($export.G + $export.W + $export.F * !__webpack_require__(73).ABV, {
        DataView: __webpack_require__(101).DataView
      });

      /***/
    },
    /* 301 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(31)('Int8', 1, function (init) {
        return function Int8Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    },
    /* 302 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(31)('Uint8', 1, function (init) {
        return function Uint8Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    },
    /* 303 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(31)(
        'Uint8',
        1,
        function (init) {
          return function Uint8ClampedArray(data, byteOffset, length) {
            return init(this, data, byteOffset, length);
          };
        },
        true
      );

      /***/
    },
    /* 304 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(31)('Int16', 2, function (init) {
        return function Int16Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    },
    /* 305 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(31)('Uint16', 2, function (init) {
        return function Uint16Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    },
    /* 306 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(31)('Int32', 4, function (init) {
        return function Int32Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    },
    /* 307 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(31)('Uint32', 4, function (init) {
        return function Uint32Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    },
    /* 308 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(31)('Float32', 4, function (init) {
        return function Float32Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    },
    /* 309 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(31)('Float64', 8, function (init) {
        return function Float64Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    },
    /* 310 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
      var $export = __webpack_require__(0);
      var aFunction = __webpack_require__(24);
      var anObject = __webpack_require__(4);
      var rApply = (__webpack_require__(3).Reflect || {}).apply;
      var fApply = Function.apply;
      // MS Edge argumentsList argument is optional
      $export(
        $export.S +
          $export.F *
            !__webpack_require__(1)(function () {
              rApply(function () {
                /* empty */
              });
            }),
        'Reflect',
        {
          apply: function apply(target, thisArgument, argumentsList) {
            var T = aFunction(target);
            var L = anObject(argumentsList);
            return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
          }
        }
      );

      /***/
    },
    /* 311 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
      var $export = __webpack_require__(0);
      var create = __webpack_require__(42);
      var aFunction = __webpack_require__(24);
      var anObject = __webpack_require__(4);
      var isObject = __webpack_require__(2);
      var fails = __webpack_require__(1);
      var bind = __webpack_require__(125);
      var rConstruct = (__webpack_require__(3).Reflect || {}).construct;

      // MS Edge supports only 2 arguments and argumentsList argument is optional
      // FF Nightly sets third argument as `new.target`, but does not create `this` from it
      var NEW_TARGET_BUG = fails(function () {
        function F() {
          /* empty */
        }
        return !(
          rConstruct(
            function () {
              /* empty */
            },
            [],
            F
          ) instanceof F
        );
      });
      var ARGS_BUG = !fails(function () {
        rConstruct(function () {
          /* empty */
        });
      });

      $export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
        construct: function construct(Target, args /* , newTarget */) {
          aFunction(Target);
          anObject(args);
          var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
          if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
          if (Target == newTarget) {
            // w/o altered newTarget, optimization for 0-4 arguments
            switch (args.length) {
              case 0:
                return new Target();
              case 1:
                return new Target(args[0]);
              case 2:
                return new Target(args[0], args[1]);
              case 3:
                return new Target(args[0], args[1], args[2]);
              case 4:
                return new Target(args[0], args[1], args[2], args[3]);
            }
            // w/o altered newTarget, lot of arguments case
            var $args = [null];
            $args.push.apply($args, args);
            return new (bind.apply(Target, $args))();
          }
          // with altered newTarget, not support built-in constructors
          var proto = newTarget.prototype;
          var instance = create(isObject(proto) ? proto : Object.prototype);
          var result = Function.apply.call(Target, instance, args);
          return isObject(result) ? result : instance;
        }
      });

      /***/
    },
    /* 312 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
      var dP = __webpack_require__(7);
      var $export = __webpack_require__(0);
      var anObject = __webpack_require__(4);
      var toPrimitive = __webpack_require__(32);

      // MS Edge has broken Reflect.defineProperty - throwing instead of returning false
      $export(
        $export.S +
          $export.F *
            __webpack_require__(1)(function () {
              // eslint-disable-next-line no-undef
              Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
            }),
        'Reflect',
        {
          defineProperty: function defineProperty(target, propertyKey, attributes) {
            anObject(target);
            propertyKey = toPrimitive(propertyKey, true);
            anObject(attributes);
            try {
              dP.f(target, propertyKey, attributes);
              return true;
            } catch (e) {
              return false;
            }
          }
        }
      );

      /***/
    },
    /* 313 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.4 Reflect.deleteProperty(target, propertyKey)
      var $export = __webpack_require__(0);
      var gOPD = __webpack_require__(25).f;
      var anObject = __webpack_require__(4);

      $export($export.S, 'Reflect', {
        deleteProperty: function deleteProperty(target, propertyKey) {
          var desc = gOPD(anObject(target), propertyKey);
          return desc && !desc.configurable ? false : delete target[propertyKey];
        }
      });

      /***/
    },
    /* 314 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // 26.1.5 Reflect.enumerate(target)
      var $export = __webpack_require__(0);
      var anObject = __webpack_require__(4);
      var Enumerate = function (iterated) {
        this._t = anObject(iterated); // target
        this._i = 0; // next index
        var keys = (this._k = []); // keys
        var key;
        for (key in iterated) keys.push(key);
      };
      __webpack_require__(133)(Enumerate, 'Object', function () {
        var that = this;
        var keys = that._k;
        var key;
        do {
          if (that._i >= keys.length) return { value: undefined, done: true };
        } while (!((key = keys[that._i++]) in that._t));
        return { value: key, done: false };
      });

      $export($export.S, 'Reflect', {
        enumerate: function enumerate(target) {
          return new Enumerate(target);
        }
      });

      /***/
    },
    /* 315 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.6 Reflect.get(target, propertyKey [, receiver])
      var gOPD = __webpack_require__(25);
      var getPrototypeOf = __webpack_require__(44);
      var has = __webpack_require__(12);
      var $export = __webpack_require__(0);
      var isObject = __webpack_require__(2);
      var anObject = __webpack_require__(4);

      function get(target, propertyKey /* , receiver */) {
        var receiver = arguments.length < 3 ? target : arguments[2];
        var desc, proto;
        if (anObject(target) === receiver) return target[propertyKey];
        if ((desc = gOPD.f(target, propertyKey)))
          return has(desc, 'value') ? desc.value : desc.get !== undefined ? desc.get.call(receiver) : undefined;
        if (isObject((proto = getPrototypeOf(target)))) return get(proto, propertyKey, receiver);
      }

      $export($export.S, 'Reflect', { get: get });

      /***/
    },
    /* 316 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
      var gOPD = __webpack_require__(25);
      var $export = __webpack_require__(0);
      var anObject = __webpack_require__(4);

      $export($export.S, 'Reflect', {
        getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
          return gOPD.f(anObject(target), propertyKey);
        }
      });

      /***/
    },
    /* 317 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.8 Reflect.getPrototypeOf(target)
      var $export = __webpack_require__(0);
      var getProto = __webpack_require__(44);
      var anObject = __webpack_require__(4);

      $export($export.S, 'Reflect', {
        getPrototypeOf: function getPrototypeOf(target) {
          return getProto(anObject(target));
        }
      });

      /***/
    },
    /* 318 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.9 Reflect.has(target, propertyKey)
      var $export = __webpack_require__(0);

      $export($export.S, 'Reflect', {
        has: function has(target, propertyKey) {
          return propertyKey in target;
        }
      });

      /***/
    },
    /* 319 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.10 Reflect.isExtensible(target)
      var $export = __webpack_require__(0);
      var anObject = __webpack_require__(4);
      var $isExtensible = Object.isExtensible;

      $export($export.S, 'Reflect', {
        isExtensible: function isExtensible(target) {
          anObject(target);
          return $isExtensible ? $isExtensible(target) : true;
        }
      });

      /***/
    },
    /* 320 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.11 Reflect.ownKeys(target)
      var $export = __webpack_require__(0);

      $export($export.S, 'Reflect', { ownKeys: __webpack_require__(146) });

      /***/
    },
    /* 321 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.12 Reflect.preventExtensions(target)
      var $export = __webpack_require__(0);
      var anObject = __webpack_require__(4);
      var $preventExtensions = Object.preventExtensions;

      $export($export.S, 'Reflect', {
        preventExtensions: function preventExtensions(target) {
          anObject(target);
          try {
            if ($preventExtensions) $preventExtensions(target);
            return true;
          } catch (e) {
            return false;
          }
        }
      });

      /***/
    },
    /* 322 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
      var dP = __webpack_require__(7);
      var gOPD = __webpack_require__(25);
      var getPrototypeOf = __webpack_require__(44);
      var has = __webpack_require__(12);
      var $export = __webpack_require__(0);
      var createDesc = __webpack_require__(38);
      var anObject = __webpack_require__(4);
      var isObject = __webpack_require__(2);

      function set(target, propertyKey, V /* , receiver */) {
        var receiver = arguments.length < 4 ? target : arguments[3];
        var ownDesc = gOPD.f(anObject(target), propertyKey);
        var existingDescriptor, proto;
        if (!ownDesc) {
          if (isObject((proto = getPrototypeOf(target)))) {
            return set(proto, propertyKey, V, receiver);
          }
          ownDesc = createDesc(0);
        }
        if (has(ownDesc, 'value')) {
          if (ownDesc.writable === false || !isObject(receiver)) return false;
          existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
          existingDescriptor.value = V;
          dP.f(receiver, propertyKey, existingDescriptor);
          return true;
        }
        return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
      }

      $export($export.S, 'Reflect', { set: set });

      /***/
    },
    /* 323 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.14 Reflect.setPrototypeOf(target, proto)
      var $export = __webpack_require__(0);
      var setProto = __webpack_require__(84);

      if (setProto)
        $export($export.S, 'Reflect', {
          setPrototypeOf: function setPrototypeOf(target, proto) {
            setProto.check(target, proto);
            try {
              setProto.set(target, proto);
              return true;
            } catch (e) {
              return false;
            }
          }
        });

      /***/
    },
    /* 324 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(325);
      module.exports = __webpack_require__(6).Array.includes;

      /***/
    },
    /* 325 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // https://github.com/tc39/Array.prototype.includes
      var $export = __webpack_require__(0);
      var $includes = __webpack_require__(64)(true);

      $export($export.P, 'Array', {
        includes: function includes(el /* , fromIndex = 0 */) {
          return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
        }
      });

      __webpack_require__(45)('includes');

      /***/
    },
    /* 326 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(327);
      module.exports = __webpack_require__(6).Array.flatMap;

      /***/
    },
    /* 327 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
      var $export = __webpack_require__(0);
      var flattenIntoArray = __webpack_require__(328);
      var toObject = __webpack_require__(14);
      var toLength = __webpack_require__(8);
      var aFunction = __webpack_require__(24);
      var arraySpeciesCreate = __webpack_require__(135);

      $export($export.P, 'Array', {
        flatMap: function flatMap(callbackfn /* , thisArg */) {
          var O = toObject(this);
          var sourceLen, A;
          aFunction(callbackfn);
          sourceLen = toLength(O.length);
          A = arraySpeciesCreate(O, 0);
          flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
          return A;
        }
      });

      __webpack_require__(45)('flatMap');

      /***/
    },
    /* 328 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
      var isArray = __webpack_require__(66);
      var isObject = __webpack_require__(2);
      var toLength = __webpack_require__(8);
      var ctx = __webpack_require__(23);
      var IS_CONCAT_SPREADABLE = __webpack_require__(5)('isConcatSpreadable');

      function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
        var targetIndex = start;
        var sourceIndex = 0;
        var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
        var element, spreadable;

        while (sourceIndex < sourceLen) {
          if (sourceIndex in source) {
            element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

            spreadable = false;
            if (isObject(element)) {
              spreadable = element[IS_CONCAT_SPREADABLE];
              spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
            }

            if (spreadable && depth > 0) {
              targetIndex =
                flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
            } else {
              if (targetIndex >= 0x1fffffffffffff) throw TypeError();
              target[targetIndex] = element;
            }

            targetIndex++;
          }
          sourceIndex++;
        }
        return targetIndex;
      }

      module.exports = flattenIntoArray;

      /***/
    },
    /* 329 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(330);
      module.exports = __webpack_require__(6).String.padStart;

      /***/
    },
    /* 330 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // https://github.com/tc39/proposal-string-pad-start-end
      var $export = __webpack_require__(0);
      var $pad = __webpack_require__(147);

      $export($export.P, 'String', {
        padStart: function padStart(maxLength /* , fillString = ' ' */) {
          return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
        }
      });

      /***/
    },
    /* 331 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(332);
      module.exports = __webpack_require__(6).String.padEnd;

      /***/
    },
    /* 332 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // https://github.com/tc39/proposal-string-pad-start-end
      var $export = __webpack_require__(0);
      var $pad = __webpack_require__(147);

      $export($export.P, 'String', {
        padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
          return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
        }
      });

      /***/
    },
    /* 333 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(334);
      module.exports = __webpack_require__(6).String.trimLeft;

      /***/
    },
    /* 334 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // https://github.com/sebmarkbage/ecmascript-string-left-right-trim
      __webpack_require__(49)(
        'trimLeft',
        function ($trim) {
          return function trimLeft() {
            return $trim(this, 1);
          };
        },
        'trimStart'
      );

      /***/
    },
    /* 335 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(336);
      module.exports = __webpack_require__(6).String.trimRight;

      /***/
    },
    /* 336 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // https://github.com/sebmarkbage/ecmascript-string-left-right-trim
      __webpack_require__(49)(
        'trimRight',
        function ($trim) {
          return function trimRight() {
            return $trim(this, 2);
          };
        },
        'trimEnd'
      );

      /***/
    },
    /* 337 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(338);
      module.exports = __webpack_require__(80).f('asyncIterator');

      /***/
    },
    /* 338 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(120)('asyncIterator');

      /***/
    },
    /* 339 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(340);
      module.exports = __webpack_require__(6).Object.getOwnPropertyDescriptors;

      /***/
    },
    /* 340 */
    /***/ function (module, exports, __webpack_require__) {
      // https://github.com/tc39/proposal-object-getownpropertydescriptors
      var $export = __webpack_require__(0);
      var ownKeys = __webpack_require__(146);
      var toIObject = __webpack_require__(17);
      var gOPD = __webpack_require__(25);
      var createProperty = __webpack_require__(95);

      $export($export.S, 'Object', {
        getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
          var O = toIObject(object);
          var getDesc = gOPD.f;
          var keys = ownKeys(O);
          var result = {};
          var i = 0;
          var key, desc;
          while (keys.length > i) {
            desc = getDesc(O, (key = keys[i++]));
            if (desc !== undefined) createProperty(result, key, desc);
          }
          return result;
        }
      });

      /***/
    },
    /* 341 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(342);
      module.exports = __webpack_require__(6).Object.values;

      /***/
    },
    /* 342 */
    /***/ function (module, exports, __webpack_require__) {
      // https://github.com/tc39/proposal-object-values-entries
      var $export = __webpack_require__(0);
      var $values = __webpack_require__(148)(false);

      $export($export.S, 'Object', {
        values: function values(it) {
          return $values(it);
        }
      });

      /***/
    },
    /* 343 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(344);
      module.exports = __webpack_require__(6).Object.entries;

      /***/
    },
    /* 344 */
    /***/ function (module, exports, __webpack_require__) {
      // https://github.com/tc39/proposal-object-values-entries
      var $export = __webpack_require__(0);
      var $entries = __webpack_require__(148)(true);

      $export($export.S, 'Object', {
        entries: function entries(it) {
          return $entries(it);
        }
      });

      /***/
    },
    /* 345 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      __webpack_require__(140);
      __webpack_require__(346);
      module.exports = __webpack_require__(6).Promise['finally'];

      /***/
    },
    /* 346 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';
      // https://github.com/tc39/proposal-promise-finally

      var $export = __webpack_require__(0);
      var core = __webpack_require__(6);
      var global = __webpack_require__(3);
      var speciesConstructor = __webpack_require__(71);
      var promiseResolve = __webpack_require__(142);

      $export($export.P + $export.R, 'Promise', {
        finally: function (onFinally) {
          var C = speciesConstructor(this, core.Promise || global.Promise);
          var isFunction = typeof onFinally == 'function';
          return this.then(
            isFunction
              ? function (x) {
                  return promiseResolve(C, onFinally()).then(function () {
                    return x;
                  });
                }
              : onFinally,
            isFunction
              ? function (e) {
                  return promiseResolve(C, onFinally()).then(function () {
                    throw e;
                  });
                }
              : onFinally
          );
        }
      });

      /***/
    },
    /* 347 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(348);
      __webpack_require__(349);
      __webpack_require__(350);
      module.exports = __webpack_require__(6);

      /***/
    },
    /* 348 */
    /***/ function (module, exports, __webpack_require__) {
      // ie9- setTimeout & setInterval additional parameters fix
      var global = __webpack_require__(3);
      var $export = __webpack_require__(0);
      var navigator = global.navigator;
      var slice = [].slice;
      var MSIE = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
      var wrap = function (set) {
        return function (fn, time /* , ...args */) {
          var boundArgs = arguments.length > 2;
          var args = boundArgs ? slice.call(arguments, 2) : false;
          return set(
            boundArgs
              ? function () {
                  // eslint-disable-next-line no-new-func
                  (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
                }
              : fn,
            time
          );
        };
      };
      $export($export.G + $export.B + $export.F * MSIE, {
        setTimeout: wrap(global.setTimeout),
        setInterval: wrap(global.setInterval)
      });

      /***/
    },
    /* 349 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      var $task = __webpack_require__(100);
      $export($export.G + $export.B, {
        setImmediate: $task.set,
        clearImmediate: $task.clear
      });

      /***/
    },
    /* 350 */
    /***/ function (module, exports, __webpack_require__) {
      var $iterators = __webpack_require__(98);
      var getKeys = __webpack_require__(40);
      var redefine = __webpack_require__(13);
      var global = __webpack_require__(3);
      var hide = __webpack_require__(16);
      var Iterators = __webpack_require__(50);
      var wks = __webpack_require__(5);
      var ITERATOR = wks('iterator');
      var TO_STRING_TAG = wks('toStringTag');
      var ArrayValues = Iterators.Array;

      var DOMIterables = {
        CSSRuleList: true, // TODO: Not spec compliant, should be false.
        CSSStyleDeclaration: false,
        CSSValueList: false,
        ClientRectList: false,
        DOMRectList: false,
        DOMStringList: false,
        DOMTokenList: true,
        DataTransferItemList: false,
        FileList: false,
        HTMLAllCollection: false,
        HTMLCollection: false,
        HTMLFormElement: false,
        HTMLSelectElement: false,
        MediaList: true, // TODO: Not spec compliant, should be false.
        MimeTypeArray: false,
        NamedNodeMap: false,
        NodeList: true,
        PaintRequestList: false,
        Plugin: false,
        PluginArray: false,
        SVGLengthList: false,
        SVGNumberList: false,
        SVGPathSegList: false,
        SVGPointList: false,
        SVGStringList: false,
        SVGTransformList: false,
        SourceBufferList: false,
        StyleSheetList: true, // TODO: Not spec compliant, should be false.
        TextTrackCueList: false,
        TextTrackList: false,
        TouchList: false
      };

      for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
        var NAME = collections[i];
        var explicit = DOMIterables[NAME];
        var Collection = global[NAME];
        var proto = Collection && Collection.prototype;
        var key;
        if (proto) {
          if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
          if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
          Iterators[NAME] = ArrayValues;
          if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
        }
      }

      /***/
    },
    /* 351 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(352);
      module.exports = __webpack_require__(21).global;

      /***/
    },
    /* 352 */
    /***/ function (module, exports, __webpack_require__) {
      // https://github.com/tc39/proposal-global
      var $export = __webpack_require__(34);

      $export($export.G, { global: __webpack_require__(18) });

      /***/
    },
    /* 353 */
    /***/ function (module, exports, __webpack_require__) {
      module.exports =
        !__webpack_require__(57) &&
        !__webpack_require__(102)(function () {
          return (
            Object.defineProperty(__webpack_require__(103)('div'), 'a', {
              get: function () {
                return 7;
              }
            }).a != 7
          );
        });

      /***/
    },
    /* 354 */
    /***/ function (module, exports, __webpack_require__) {
      // 7.1.1 ToPrimitive(input [, PreferredType])
      var isObject = __webpack_require__(62);
      // instead of the ES6 spec version, we didn't implement @@toPrimitive case
      // and the second argument - flag - preferred type is a string
      module.exports = function (it, S) {
        if (!isObject(it)) return it;
        var fn, val;
        if (S && typeof (fn = it.toString) == 'function' && !isObject((val = fn.call(it)))) return val;
        if (typeof (fn = it.valueOf) == 'function' && !isObject((val = fn.call(it)))) return val;
        if (!S && typeof (fn = it.toString) == 'function' && !isObject((val = fn.call(it)))) return val;
        throw TypeError("Can't convert object to primitive value");
      };

      /***/
    },
    /* 355 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      __webpack_require__(356);

      var _log = __webpack_require__(36);

      var _log2 = _interopRequireDefault(_log);

      var _context = __webpack_require__(150);

      var _context2 = _interopRequireDefault(_context);

      var _Theme = __webpack_require__(365);

      var _Theme2 = _interopRequireDefault(_Theme);

      __webpack_require__(450);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      _context2.default.setTemplate(window.SALVO_BINDINGS.template);

      var theme = new _Theme2.default();

      theme.registerComponents();
      theme.registerPages();

      document.addEventListener('shopify:section:load', function (e) {
        theme = new _Theme2.default();
        theme.registerComponents();
        theme.registerPages();
      });

      // _log2.default.debug('Main', 'Ready!');

      /***/
    },
    /* 356 */
    /***/ function (module, exports, __webpack_require__) {
      module.exports = __webpack_require__.p + 'tmp_src/resources/styles/.css.liquid';

      /***/
    },
    /* 357 */
    /***/ function (module, exports, __webpack_require__) {
      (function webpackUniversalModuleDefinition(root, factory) {
        if (true) module.exports = factory();
        else if (typeof define === 'function' && define.amd) define('escshopify', [], factory);
        else if (typeof exports === 'object') exports['escshopify'] = factory();
        else root['escshopify'] = factory();
      })(typeof self !== 'undefined' ? self : this, function () {
        return /******/ (function (modules) {
          // webpackBootstrap
          /******/ // The module cache
          /******/ var installedModules = {};
          /******/
          /******/ // The require function
          /******/ function __webpack_require__(moduleId) {
            /******/
            /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) {
              /******/ return installedModules[moduleId].exports;
              /******/
            }
            /******/ // Create a new module (and put it into the cache)
            /******/ var module = (installedModules[moduleId] = {
              /******/ i: moduleId,
              /******/ l: false,
              /******/ exports: {}
              /******/
            });
            /******/
            /******/ // Execute the module function
            /******/ modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            /******/
            /******/ // Flag the module as loaded
            /******/ module.l = true;
            /******/
            /******/ // Return the exports of the module
            /******/ return module.exports;
            /******/
          }
          /******/
          /******/
          /******/ // expose the modules object (__webpack_modules__)
          /******/ __webpack_require__.m = modules;
          /******/
          /******/ // expose the module cache
          /******/ __webpack_require__.c = installedModules;
          /******/
          /******/ // define getter function for harmony exports
          /******/ __webpack_require__.d = function (exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) {
              /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
                /******/
              });
              /******/
            }
            /******/
          };
          /******/
          /******/ // getDefaultExport function for compatibility with non-harmony modules
          /******/ __webpack_require__.n = function (module) {
            /******/ var getter =
              module && module.__esModule
                ? /******/ function getDefault() {
                    return module['default'];
                  }
                : /******/ function getModuleExports() {
                    return module;
                  };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
            /******/
          };
          /******/
          /******/ // Object.prototype.hasOwnProperty.call
          /******/ __webpack_require__.o = function (object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
          };
          /******/
          /******/ // __webpack_public_path__
          /******/ __webpack_require__.p = '';
          /******/
          /******/ // Load entry module and return exports
          /******/ return __webpack_require__((__webpack_require__.s = 28));
          /******/
        })(
          /************************************************************************/
          /******/ [
            /* 0 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              exports.__esModule = true;

              exports.default = function (instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                  throw new TypeError('Cannot call a class as a function');
                }
              };

              /***/
            },
            /* 1 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              exports.__esModule = true;

              var _defineProperty = __webpack_require__(110);

              var _defineProperty2 = _interopRequireDefault(_defineProperty);

              function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : { default: obj };
              }

              exports.default = (function () {
                function defineProperties(target, props) {
                  for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ('value' in descriptor) descriptor.writable = true;
                    (0, _defineProperty2.default)(target, descriptor.key, descriptor);
                  }
                }

                return function (Constructor, protoProps, staticProps) {
                  if (protoProps) defineProperties(Constructor.prototype, protoProps);
                  if (staticProps) defineProperties(Constructor, staticProps);
                  return Constructor;
                };
              })();

              /***/
            },
            /* 2 */
            /***/ function (module, exports) {
              var core = (module.exports = { version: '2.5.1' });
              if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

              /***/
            },
            /* 3 */
            /***/ function (module, exports) {
              // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
              var global = (module.exports =
                typeof window != 'undefined' && window.Math == Math
                  ? window
                  : typeof self != 'undefined' && self.Math == Math
                    ? self
                    : // eslint-disable-next-line no-new-func
                      Function('return this')());
              if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

              /***/
            },
            /* 4 */
            /***/ function (module, exports, __webpack_require__) {
              var store = __webpack_require__(46)('wks');
              var uid = __webpack_require__(32);
              var Symbol = __webpack_require__(3).Symbol;
              var USE_SYMBOL = typeof Symbol == 'function';

              var $exports = (module.exports = function (name) {
                return (
                  store[name] ||
                  (store[name] = (USE_SYMBOL && Symbol[name]) || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name))
                );
              });

              $exports.store = store;

              /***/
            },
            /* 5 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              var bind = __webpack_require__(91);
              var isBuffer = __webpack_require__(169);

              /*global toString:true*/

              // utils is a library of generic helper functions non-specific to axios

              var toString = Object.prototype.toString;

              /**
               * Determine if a value is an Array
               *
               * @param {Object} val The value to test
               * @returns {boolean} True if value is an Array, otherwise false
               */
              function isArray(val) {
                return toString.call(val) === '[object Array]';
              }

              /**
               * Determine if a value is an ArrayBuffer
               *
               * @param {Object} val The value to test
               * @returns {boolean} True if value is an ArrayBuffer, otherwise false
               */
              function isArrayBuffer(val) {
                return toString.call(val) === '[object ArrayBuffer]';
              }

              /**
               * Determine if a value is a FormData
               *
               * @param {Object} val The value to test
               * @returns {boolean} True if value is an FormData, otherwise false
               */
              function isFormData(val) {
                return typeof FormData !== 'undefined' && val instanceof FormData;
              }

              /**
               * Determine if a value is a view on an ArrayBuffer
               *
               * @param {Object} val The value to test
               * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
               */
              function isArrayBufferView(val) {
                var result;
                if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
                  result = ArrayBuffer.isView(val);
                } else {
                  result = val && val.buffer && val.buffer instanceof ArrayBuffer;
                }
                return result;
              }

              /**
               * Determine if a value is a String
               *
               * @param {Object} val The value to test
               * @returns {boolean} True if value is a String, otherwise false
               */
              function isString(val) {
                return typeof val === 'string';
              }

              /**
               * Determine if a value is a Number
               *
               * @param {Object} val The value to test
               * @returns {boolean} True if value is a Number, otherwise false
               */
              function isNumber(val) {
                return typeof val === 'number';
              }

              /**
               * Determine if a value is undefined
               *
               * @param {Object} val The value to test
               * @returns {boolean} True if the value is undefined, otherwise false
               */
              function isUndefined(val) {
                return typeof val === 'undefined';
              }

              /**
               * Determine if a value is an Object
               *
               * @param {Object} val The value to test
               * @returns {boolean} True if value is an Object, otherwise false
               */
              function isObject(val) {
                return val !== null && typeof val === 'object';
              }

              /**
               * Determine if a value is a Date
               *
               * @param {Object} val The value to test
               * @returns {boolean} True if value is a Date, otherwise false
               */
              function isDate(val) {
                return toString.call(val) === '[object Date]';
              }

              /**
               * Determine if a value is a File
               *
               * @param {Object} val The value to test
               * @returns {boolean} True if value is a File, otherwise false
               */
              function isFile(val) {
                return toString.call(val) === '[object File]';
              }

              /**
               * Determine if a value is a Blob
               *
               * @param {Object} val The value to test
               * @returns {boolean} True if value is a Blob, otherwise false
               */
              function isBlob(val) {
                return toString.call(val) === '[object Blob]';
              }

              /**
               * Determine if a value is a Function
               *
               * @param {Object} val The value to test
               * @returns {boolean} True if value is a Function, otherwise false
               */
              function isFunction(val) {
                return toString.call(val) === '[object Function]';
              }

              /**
               * Determine if a value is a Stream
               *
               * @param {Object} val The value to test
               * @returns {boolean} True if value is a Stream, otherwise false
               */
              function isStream(val) {
                return isObject(val) && isFunction(val.pipe);
              }

              /**
               * Determine if a value is a URLSearchParams object
               *
               * @param {Object} val The value to test
               * @returns {boolean} True if value is a URLSearchParams object, otherwise false
               */
              function isURLSearchParams(val) {
                return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
              }

              /**
               * Trim excess whitespace off the beginning and end of a string
               *
               * @param {String} str The String to trim
               * @returns {String} The String freed of excess whitespace
               */
              function trim(str) {
                return str.replace(/^\s*/, '').replace(/\s*$/, '');
              }

              /**
               * Determine if we're running in a standard browser environment
               *
               * This allows axios to run in a web worker, and react-native.
               * Both environments support XMLHttpRequest, but not fully standard globals.
               *
               * web workers:
               *  typeof window -> undefined
               *  typeof document -> undefined
               *
               * react-native:
               *  navigator.product -> 'ReactNative'
               */
              function isStandardBrowserEnv() {
                if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
                  return false;
                }
                return typeof window !== 'undefined' && typeof document !== 'undefined';
              }

              /**
               * Iterate over an Array or an Object invoking a function for each item.
               *
               * If `obj` is an Array callback will be called passing
               * the value, index, and complete array for each item.
               *
               * If 'obj' is an Object callback will be called passing
               * the value, key, and complete object for each property.
               *
               * @param {Object|Array} obj The object to iterate
               * @param {Function} fn The callback to invoke for each item
               */
              function forEach(obj, fn) {
                // Don't bother if no value provided
                if (obj === null || typeof obj === 'undefined') {
                  return;
                }

                // Force an array if not already something iterable
                if (typeof obj !== 'object') {
                  /*eslint no-param-reassign:0*/
                  obj = [obj];
                }

                if (isArray(obj)) {
                  // Iterate over array values
                  for (var i = 0, l = obj.length; i < l; i++) {
                    fn.call(null, obj[i], i, obj);
                  }
                } else {
                  // Iterate over object keys
                  for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) {
                      fn.call(null, obj[key], key, obj);
                    }
                  }
                }
              }

              /**
               * Accepts varargs expecting each argument to be an object, then
               * immutably merges the properties of each object and returns result.
               *
               * When multiple objects contain the same key the later object in
               * the arguments list will take precedence.
               *
               * Example:
               *
               * ```js
               * var result = merge({foo: 123}, {foo: 456});
               * console.log(result.foo); // outputs 456
               * ```
               *
               * @param {Object} obj1 Object to merge
               * @returns {Object} Result of all merge properties
               */
              function merge(/* obj1, obj2, obj3, ... */) {
                var result = {};
                function assignValue(val, key) {
                  if (typeof result[key] === 'object' && typeof val === 'object') {
                    result[key] = merge(result[key], val);
                  } else {
                    result[key] = val;
                  }
                }

                for (var i = 0, l = arguments.length; i < l; i++) {
                  forEach(arguments[i], assignValue);
                }
                return result;
              }

              /**
               * Extends object a by mutably adding to it the properties of object b.
               *
               * @param {Object} a The object to be extended
               * @param {Object} b The object to copy properties from
               * @param {Object} thisArg The object to bind function to
               * @return {Object} The resulting value of object a
               */
              function extend(a, b, thisArg) {
                forEach(b, function assignValue(val, key) {
                  if (thisArg && typeof val === 'function') {
                    a[key] = bind(val, thisArg);
                  } else {
                    a[key] = val;
                  }
                });
                return a;
              }

              module.exports = {
                isArray: isArray,
                isArrayBuffer: isArrayBuffer,
                isBuffer: isBuffer,
                isFormData: isFormData,
                isArrayBufferView: isArrayBufferView,
                isString: isString,
                isNumber: isNumber,
                isObject: isObject,
                isUndefined: isUndefined,
                isDate: isDate,
                isFile: isFile,
                isBlob: isBlob,
                isFunction: isFunction,
                isStream: isStream,
                isURLSearchParams: isURLSearchParams,
                isStandardBrowserEnv: isStandardBrowserEnv,
                forEach: forEach,
                merge: merge,
                extend: extend,
                trim: trim
              };

              /***/
            },
            /* 6 */
            /***/ function (module, exports, __webpack_require__) {
              var global = __webpack_require__(3);
              var core = __webpack_require__(2);
              var ctx = __webpack_require__(23);
              var hide = __webpack_require__(10);
              var PROTOTYPE = 'prototype';

              var $export = function (type, name, source) {
                var IS_FORCED = type & $export.F;
                var IS_GLOBAL = type & $export.G;
                var IS_STATIC = type & $export.S;
                var IS_PROTO = type & $export.P;
                var IS_BIND = type & $export.B;
                var IS_WRAP = type & $export.W;
                var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
                var expProto = exports[PROTOTYPE];
                var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
                var key, own, out;
                if (IS_GLOBAL) source = name;
                for (key in source) {
                  // contains in native
                  own = !IS_FORCED && target && target[key] !== undefined;
                  if (own && key in exports) continue;
                  // export native or passed
                  out = own ? target[key] : source[key];
                  // prevent global pollution for namespaces
                  exports[key] =
                    IS_GLOBAL && typeof target[key] != 'function'
                      ? source[key]
                      : // bind timers to global for call from export context
                        IS_BIND && own
                        ? ctx(out, global)
                        : // wrap global constructors for prevent change them in library
                          IS_WRAP && target[key] == out
                          ? (function (C) {
                              var F = function (a, b, c) {
                                if (this instanceof C) {
                                  switch (arguments.length) {
                                    case 0:
                                      return new C();
                                    case 1:
                                      return new C(a);
                                    case 2:
                                      return new C(a, b);
                                  }
                                  return new C(a, b, c);
                                }
                                return C.apply(this, arguments);
                              };
                              F[PROTOTYPE] = C[PROTOTYPE];
                              return F;
                              // make static versions for prototype methods
                            })(out)
                          : IS_PROTO && typeof out == 'function'
                            ? ctx(Function.call, out)
                            : out;
                  // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
                  if (IS_PROTO) {
                    (exports.virtual || (exports.virtual = {}))[key] = out;
                    // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
                    if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
                  }
                }
              };
              // type bitmap
              $export.F = 1; // forced
              $export.G = 2; // global
              $export.S = 4; // static
              $export.P = 8; // proto
              $export.B = 16; // bind
              $export.W = 32; // wrap
              $export.U = 64; // safe
              $export.R = 128; // real proto method for `library`
              module.exports = $export;

              /***/
            },
            /* 7 */
            /***/ function (module, exports, __webpack_require__) {
              var isObject = __webpack_require__(11);
              module.exports = function (it) {
                if (!isObject(it)) throw TypeError(it + ' is not an object!');
                return it;
              };

              /***/
            },
            /* 8 */
            /***/ function (module, exports, __webpack_require__) {
              var anObject = __webpack_require__(7);
              var IE8_DOM_DEFINE = __webpack_require__(62);
              var toPrimitive = __webpack_require__(39);
              var dP = Object.defineProperty;

              exports.f = __webpack_require__(9)
                ? Object.defineProperty
                : function defineProperty(O, P, Attributes) {
                    anObject(O);
                    P = toPrimitive(P, true);
                    anObject(Attributes);
                    if (IE8_DOM_DEFINE)
                      try {
                        return dP(O, P, Attributes);
                      } catch (e) {
                        /* empty */
                      }
                    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
                    if ('value' in Attributes) O[P] = Attributes.value;
                    return O;
                  };

              /***/
            },
            /* 9 */
            /***/ function (module, exports, __webpack_require__) {
              // Thank's IE8 for his funny defineProperty
              module.exports = !__webpack_require__(17)(function () {
                return (
                  Object.defineProperty({}, 'a', {
                    get: function () {
                      return 7;
                    }
                  }).a != 7
                );
              });

              /***/
            },
            /* 10 */
            /***/ function (module, exports, __webpack_require__) {
              var dP = __webpack_require__(8);
              var createDesc = __webpack_require__(30);
              module.exports = __webpack_require__(9)
                ? function (object, key, value) {
                    return dP.f(object, key, createDesc(1, value));
                  }
                : function (object, key, value) {
                    object[key] = value;
                    return object;
                  };

              /***/
            },
            /* 11 */
            /***/ function (module, exports) {
              module.exports = function (it) {
                return typeof it === 'object' ? it !== null : typeof it === 'function';
              };

              /***/
            },
            /* 12 */
            /***/ function (module, exports, __webpack_require__) {
              // to indexed object, toObject with fallback for non-array-like ES3 strings
              var IObject = __webpack_require__(64);
              var defined = __webpack_require__(42);
              module.exports = function (it) {
                return IObject(defined(it));
              };

              /***/
            },
            /* 13 */
            /***/ function (module, exports) {
              var hasOwnProperty = {}.hasOwnProperty;
              module.exports = function (it, key) {
                return hasOwnProperty.call(it, key);
              };

              /***/
            },
            /* 14 */
            /***/ function (module, exports, __webpack_require__) {
              module.exports = { default: __webpack_require__(123), __esModule: true };

              /***/
            },
            /* 15 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              exports.__esModule = true;

              var _typeof2 = __webpack_require__(77);

              var _typeof3 = _interopRequireDefault(_typeof2);

              function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : { default: obj };
              }

              exports.default = function (self, call) {
                if (!self) {
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }

                return call &&
                  ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === 'object' ||
                    typeof call === 'function')
                  ? call
                  : self;
              };

              /***/
            },
            /* 16 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              exports.__esModule = true;

              var _setPrototypeOf = __webpack_require__(136);

              var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

              var _create = __webpack_require__(140);

              var _create2 = _interopRequireDefault(_create);

              var _typeof2 = __webpack_require__(77);

              var _typeof3 = _interopRequireDefault(_typeof2);

              function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : { default: obj };
              }

              exports.default = function (subClass, superClass) {
                if (typeof superClass !== 'function' && superClass !== null) {
                  throw new TypeError(
                    'Super expression must either be null or a function, not ' +
                      (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass))
                  );
                }

                subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
                  constructor: {
                    value: subClass,
                    enumerable: false,
                    writable: true,
                    configurable: true
                  }
                });
                if (superClass)
                  _setPrototypeOf2.default
                    ? (0, _setPrototypeOf2.default)(subClass, superClass)
                    : (subClass.__proto__ = superClass);
              };

              /***/
            },
            /* 17 */
            /***/ function (module, exports) {
              module.exports = function (exec) {
                try {
                  return !!exec();
                } catch (e) {
                  return true;
                }
              };

              /***/
            },
            /* 18 */
            /***/ function (module, exports, __webpack_require__) {
              // 19.1.2.14 / 15.2.3.14 Object.keys(O)
              var $keys = __webpack_require__(67);
              var enumBugKeys = __webpack_require__(47);

              module.exports =
                Object.keys ||
                function keys(O) {
                  return $keys(O, enumBugKeys);
                };

              /***/
            },
            /* 19 */
            /***/ function (module, exports, __webpack_require__) {
              module.exports = __webpack_require__(161);

              /***/
            },
            /* 20 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              exports.__esModule = true;

              var _promise = __webpack_require__(81);

              var _promise2 = _interopRequireDefault(_promise);

              function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : { default: obj };
              }

              exports.default = function (fn) {
                return function () {
                  var gen = fn.apply(this, arguments);
                  return new _promise2.default(function (resolve, reject) {
                    function step(key, arg) {
                      try {
                        var info = gen[key](arg);
                        var value = info.value;
                      } catch (error) {
                        reject(error);
                        return;
                      }

                      if (info.done) {
                        resolve(value);
                      } else {
                        return _promise2.default.resolve(value).then(
                          function (value) {
                            step('next', value);
                          },
                          function (err) {
                            step('throw', err);
                          }
                        );
                      }
                    }

                    return step('next');
                  });
                };
              };

              /***/
            },
            /* 21 */
            /***/ function (module, exports, __webpack_require__) {
              var Symbol = __webpack_require__(98),
                getRawTag = __webpack_require__(196),
                objectToString = __webpack_require__(197);

              /** `Object#toString` result references. */
              var nullTag = '[object Null]',
                undefinedTag = '[object Undefined]';

              /** Built-in value references. */
              var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

              /**
               * The base implementation of `getTag` without fallbacks for buggy environments.
               *
               * @private
               * @param {*} value The value to query.
               * @returns {string} Returns the `toStringTag`.
               */
              function baseGetTag(value) {
                if (value == null) {
                  return value === undefined ? undefinedTag : nullTag;
                }
                return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
              }

              module.exports = baseGetTag;

              /***/
            },
            /* 22 */
            /***/ function (module, exports) {
              /**
               * Checks if `value` is object-like. A value is object-like if it's not `null`
               * and has a `typeof` result of "object".
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
               * @example
               *
               * _.isObjectLike({});
               * // => true
               *
               * _.isObjectLike([1, 2, 3]);
               * // => true
               *
               * _.isObjectLike(_.noop);
               * // => false
               *
               * _.isObjectLike(null);
               * // => false
               */
              function isObjectLike(value) {
                return value != null && typeof value == 'object';
              }

              module.exports = isObjectLike;

              /***/
            },
            /* 23 */
            /***/ function (module, exports, __webpack_require__) {
              // optional / simple context binding
              var aFunction = __webpack_require__(29);
              module.exports = function (fn, that, length) {
                aFunction(fn);
                if (that === undefined) return fn;
                switch (length) {
                  case 1:
                    return function (a) {
                      return fn.call(that, a);
                    };
                  case 2:
                    return function (a, b) {
                      return fn.call(that, a, b);
                    };
                  case 3:
                    return function (a, b, c) {
                      return fn.call(that, a, b, c);
                    };
                }
                return function (/* ...args */) {
                  return fn.apply(that, arguments);
                };
              };

              /***/
            },
            /* 24 */
            /***/ function (module, exports) {
              module.exports = {};

              /***/
            },
            /* 25 */
            /***/ function (module, exports) {
              var toString = {}.toString;

              module.exports = function (it) {
                return toString.call(it).slice(8, -1);
              };

              /***/
            },
            /* 26 */
            /***/ function (module, exports) {
              exports.f = {}.propertyIsEnumerable;

              /***/
            },
            /* 27 */
            /***/ function (module, exports) {
              /**
               * Checks if `value` is the
               * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
               * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is an object, else `false`.
               * @example
               *
               * _.isObject({});
               * // => true
               *
               * _.isObject([1, 2, 3]);
               * // => true
               *
               * _.isObject(_.noop);
               * // => true
               *
               * _.isObject(null);
               * // => false
               */
              function isObject(value) {
                var type = typeof value;
                return value != null && (type == 'object' || type == 'function');
              }

              module.exports = isObject;

              /***/
            },
            /* 28 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              Object.defineProperty(__webpack_exports__, '__esModule', { value: true });
              /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, 'plugins', function () {
                return plugins;
              });
              /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, 'entities', function () {
                return entities;
              });
              /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, 'utils', function () {
                return utils;
              });
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(28);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_general__ = __webpack_require__(61);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__entities__ = __webpack_require__(143);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins__ = __webpack_require__(187);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__log_js__ = __webpack_require__(37);

              /** @ignore */
              var TAG = 'Bootstrap';

              /**
               * Plugins
               * @type {src/plugins/index.js~Plugins}
               */
              var plugins = __WEBPACK_IMPORTED_MODULE_3__plugins__;

              /**
               * Entities
               * @type {src/entities/index.js~Entities}
               */
              var entities = __WEBPACK_IMPORTED_MODULE_2__entities__;

              /**
               * General utilities
               * @type {src/utils/general.js~GeneralUtils}
               */
              var utils = __WEBPACK_IMPORTED_MODULE_1__utils_general__['a' /* default */];

              /**
               * Main libary entry point.
               */
              /* harmony default export */ __webpack_exports__['default'] = __WEBPACK_IMPORTED_MODULE_0__index__;

              __WEBPACK_IMPORTED_MODULE_4__log_js__['a' /* default */].send(
                __WEBPACK_IMPORTED_MODULE_4__log_js__['a' /* default */].DEBUG,
                TAG,
                'Initialized.'
              );

              // For docs
              /** @external {js-money} https://www.npmjs.com/package/js-money */
              /** @external {evee} https://www.npmjs.com/package/evee */
              /** @external {promise-queue} https://www.npmjs.com/package/promise-queue */

              /***/
            },
            /* 29 */
            /***/ function (module, exports) {
              module.exports = function (it) {
                if (typeof it != 'function') throw TypeError(it + ' is not a function!');
                return it;
              };

              /***/
            },
            /* 30 */
            /***/ function (module, exports) {
              module.exports = function (bitmap, value) {
                return {
                  enumerable: !(bitmap & 1),
                  configurable: !(bitmap & 2),
                  writable: !(bitmap & 4),
                  value: value
                };
              };

              /***/
            },
            /* 31 */
            /***/ function (module, exports) {
              module.exports = true;

              /***/
            },
            /* 32 */
            /***/ function (module, exports) {
              var id = 0;
              var px = Math.random();
              module.exports = function (key) {
                return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
              };

              /***/
            },
            /* 33 */
            /***/ function (module, exports, __webpack_require__) {
              var def = __webpack_require__(8).f;
              var has = __webpack_require__(13);
              var TAG = __webpack_require__(4)('toStringTag');

              module.exports = function (it, tag, stat) {
                if (it && !has((it = stat ? it : it.prototype), TAG)) def(it, TAG, { configurable: true, value: tag });
              };

              /***/
            },
            /* 34 */
            /***/ function (module, exports, __webpack_require__) {
              // 7.1.13 ToObject(argument)
              var defined = __webpack_require__(42);
              module.exports = function (it) {
                return Object(defined(it));
              };

              /***/
            },
            /* 35 */
            /***/ function (module, exports) {
              var _createClass = (function () {
                function defineProperties(target, props) {
                  for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ('value' in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                  }
                }
                return function (Constructor, protoProps, staticProps) {
                  if (protoProps) defineProperties(Constructor.prototype, protoProps);
                  if (staticProps) defineProperties(Constructor, staticProps);
                  return Constructor;
                };
              })();

              function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                  throw new TypeError('Cannot call a class as a function');
                }
              }

              var Evee = (function () {
                /**
                 * Construct a new Evee object.
                 */
                function Evee() {
                  _classCallCheck(this, Evee);

                  this.gid = 0;
                  this.receivers = [];
                }

                /**
                 * Subscribe to an event.
                 * @param {object} name - The event name
                 * @param {function} action - The event action
                 */

                _createClass(Evee, [
                  {
                    key: 'on',
                    value: function on(name, action) {
                      if (name.constructor !== String) {
                        throw new TypeError('name has to be of type string.');
                      }
                      if (action.constructor !== Function) {
                        throw new TypeError('action has to be of type function.');
                      }
                      var event = {
                        name: name,
                        action: action,
                        id: this.gid++
                      };
                      for (var i = 0; i < this.receivers.length; i++) {
                        var items = this.receivers[i];
                        if (items.length > 0 && items[0].name === name) {
                          items.push(event);
                          return event;
                        }
                      }
                      this.receivers.push([event]);
                      return event;
                    }

                    /**
                     * Subscribe to an event and fire only once.
                     * @param {object} name - The event name
                     * @param {function} action - The event action
                     */
                  },
                  {
                    key: 'once',
                    value: function once(name, _action) {
                      var _this = this;

                      if (name.constructor !== String) {
                        throw new TypeError('name has to be of type string.');
                      }
                      if (_action.constructor !== Function) {
                        throw new TypeError('action has to be of type function.');
                      }
                      var event = {
                        name: name,
                        id: this.gid++,
                        action: function action(e) {
                          _this.drop(e.sender);
                          return _action(e);
                        }
                      };
                      for (var i = 0; i < this.receivers.length; i++) {
                        var items = this.receivers[i];
                        if (items.length > 0 && items[0].name === name) {
                          items.push(event);
                          return event;
                        }
                      }
                      this.receivers.push([event]);
                      return event;
                    }

                    /**
                     * Drop an event.
                     * @param {Object} event - The event
                     * @returns {boolean} - Whether the event has been dropped
                     */
                  },
                  {
                    key: 'drop',
                    value: function drop(event) {
                      if (event === undefined || event.name === undefined) {
                        throw new TypeError('attempt to drop undefined event.');
                      }
                      for (var i = 0; i < this.receivers.length; i++) {
                        var items = this.receivers[i];
                        if (items.length === 0 || items[0].name !== event.name) {
                          continue;
                        }
                        for (var _i = 0; _i < items.length; _i++) {
                          if (items[_i].id === event.id) {
                            items.splice(_i, 1);
                            return true;
                          }
                        }
                      }
                      return false;
                    }

                    /**
                     * Emit an event.
                     * @param {string|array|object} target - The target(s)
                     * @param {object=} data - The event data
                     */
                  },
                  {
                    key: 'emit',
                    value: function emit(target, data) {
                      if (target === undefined && data === undefined) {
                        throw new Error('emit called without arguments.');
                      }
                      if (this.receivers.length === 0) {
                        return;
                      }
                      for (var i = 0; i < (target || []).length; i++) {
                        var o = target[i];
                        if (o.constructor === Object) {
                          for (var _i2 = 0; _i2 < this.receivers.length; _i2++) {
                            var items = this.receivers[_i2];
                            if (items.length > 0 && items[0].name === target) {
                              for (var _i3 = 0; _i3 < items.length; _i3++) {
                                var item = items[_i3];
                                item.action({
                                  sender: item,
                                  data: data
                                });
                              }
                              return;
                            }
                            if (items.length > 0 && items[0].name === o.name) {
                              for (var _i4 = 0; _i4 < items.length; _i4++) {
                                var item = items[_i4];
                                item.action({
                                  sender: item,
                                  data: o.data
                                });
                              }
                            }
                          }
                        } else if (o.constructor === String) {
                          for (var _i5 = 0; _i5 < this.receivers.length; _i5++) {
                            var items = this.receivers[_i5];
                            if (items.length > 0 && items[0].name === target) {
                              for (var _i6 = 0; _i6 < items.length; _i6++) {
                                var item = items[_i6];
                                item.action({
                                  sender: item,
                                  data: data
                                });
                              }
                              return;
                            }
                            if (items.length > 0 && items[0].name === o) {
                              for (var _i7 = 0; _i7 < items.length; _i7++) {
                                var item = items[_i7];
                                item.action({
                                  sender: item,
                                  data: data
                                });
                              }
                            }
                          }
                        } else {
                          throw new TypeError('target has to be of type string|object|array.');
                        }
                      }
                    }

                    /**
                     * Signal an event.
                     * @param {array} args - The names of the events
                     */
                  },
                  {
                    key: 'signal',
                    value: function signal() {
                      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                      }

                      if (args.length === 0) {
                        throw new Error('signal called without arguments.');
                      }
                      if (this.receivers.length === 0) {
                        return;
                      }
                      for (var i = 0; i < args.length; i++) {
                        var arg = args[i];
                        for (var _i8 = 0; _i8 < this.receivers.length; _i8++) {
                          var items = this.receivers[_i8];
                          if (items.length > 0 && items[0].name === arg) {
                            for (var _i9 = 0; _i9 < items.length; _i9++) {
                              var item = items[_i9];
                              item.action({
                                sender: item
                              });
                            }
                          }
                        }
                      }
                    }

                    /**
                     * Clear all receivers.
                     */
                  },
                  {
                    key: 'clear',
                    value: function clear() {
                      this.receivers = [];
                    }
                  }
                ]);

                return Evee;
              })();

              // Export the evee class

              module.exports = Evee;

              /***/
            },
            /* 36 */
            /***/ function (module, exports) {
              // shim for using process in browser
              var process = (module.exports = {});

              // cached from whatever global is present so that test runners that stub it
              // don't break things.  But we need to wrap it in a try catch in case it is
              // wrapped in strict mode code which doesn't define any globals.  It's inside a
              // function because try/catches deoptimize in certain engines.

              var cachedSetTimeout;
              var cachedClearTimeout;

              function defaultSetTimout() {
                throw new Error('setTimeout has not been defined');
              }
              function defaultClearTimeout() {
                throw new Error('clearTimeout has not been defined');
              }
              (function () {
                try {
                  if (typeof setTimeout === 'function') {
                    cachedSetTimeout = setTimeout;
                  } else {
                    cachedSetTimeout = defaultSetTimout;
                  }
                } catch (e) {
                  cachedSetTimeout = defaultSetTimout;
                }
                try {
                  if (typeof clearTimeout === 'function') {
                    cachedClearTimeout = clearTimeout;
                  } else {
                    cachedClearTimeout = defaultClearTimeout;
                  }
                } catch (e) {
                  cachedClearTimeout = defaultClearTimeout;
                }
              })();
              function runTimeout(fun) {
                if (cachedSetTimeout === setTimeout) {
                  //normal enviroments in sane situations
                  return setTimeout(fun, 0);
                }
                // if setTimeout wasn't available but was latter defined
                if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                  cachedSetTimeout = setTimeout;
                  return setTimeout(fun, 0);
                }
                try {
                  // when when somebody has screwed with setTimeout but no I.E. maddness
                  return cachedSetTimeout(fun, 0);
                } catch (e) {
                  try {
                    // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                    return cachedSetTimeout.call(null, fun, 0);
                  } catch (e) {
                    // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                    return cachedSetTimeout.call(this, fun, 0);
                  }
                }
              }
              function runClearTimeout(marker) {
                if (cachedClearTimeout === clearTimeout) {
                  //normal enviroments in sane situations
                  return clearTimeout(marker);
                }
                // if clearTimeout wasn't available but was latter defined
                if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                  cachedClearTimeout = clearTimeout;
                  return clearTimeout(marker);
                }
                try {
                  // when when somebody has screwed with setTimeout but no I.E. maddness
                  return cachedClearTimeout(marker);
                } catch (e) {
                  try {
                    // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                    return cachedClearTimeout.call(null, marker);
                  } catch (e) {
                    // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                    // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                    return cachedClearTimeout.call(this, marker);
                  }
                }
              }
              var queue = [];
              var draining = false;
              var currentQueue;
              var queueIndex = -1;

              function cleanUpNextTick() {
                if (!draining || !currentQueue) {
                  return;
                }
                draining = false;
                if (currentQueue.length) {
                  queue = currentQueue.concat(queue);
                } else {
                  queueIndex = -1;
                }
                if (queue.length) {
                  drainQueue();
                }
              }

              function drainQueue() {
                if (draining) {
                  return;
                }
                var timeout = runTimeout(cleanUpNextTick);
                draining = true;

                var len = queue.length;
                while (len) {
                  currentQueue = queue;
                  queue = [];
                  while (++queueIndex < len) {
                    if (currentQueue) {
                      currentQueue[queueIndex].run();
                    }
                  }
                  queueIndex = -1;
                  len = queue.length;
                }
                currentQueue = null;
                draining = false;
                runClearTimeout(timeout);
              }

              process.nextTick = function (fun) {
                var args = new Array(arguments.length - 1);
                if (arguments.length > 1) {
                  for (var i = 1; i < arguments.length; i++) {
                    args[i - 1] = arguments[i];
                  }
                }
                queue.push(new Item(fun, args));
                if (queue.length === 1 && !draining) {
                  runTimeout(drainQueue);
                }
              };

              // v8 likes predictible objects
              function Item(fun, array) {
                this.fun = fun;
                this.array = array;
              }
              Item.prototype.run = function () {
                this.fun.apply(null, this.array);
              };
              process.title = 'browser';
              process.browser = true;
              process.env = {};
              process.argv = [];
              process.version = ''; // empty string to avoid regexp issues
              process.versions = {};

              function noop() {}

              process.on = noop;
              process.addListener = noop;
              process.once = noop;
              process.off = noop;
              process.removeListener = noop;
              process.removeAllListeners = noop;
              process.emit = noop;
              process.prependListener = noop;
              process.prependOnceListener = noop;

              process.listeners = function (name) {
                return [];
              };

              process.binding = function (name) {
                throw new Error('process.binding is not supported');
              };

              process.cwd = function () {
                return '/';
              };
              process.chdir = function (dir) {
                throw new Error('process.chdir is not supported');
              };
              process.umask = function () {
                return 0;
              };

              /***/
            },
            /* 37 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(55);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Log__ = __webpack_require__(63);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_loggers_ConsoleLogger__ =
                __webpack_require__(75);

              /** @ignore */
              var TAG = 'LogBootstrap';

              // Setup library-level logging
              var log = new __WEBPACK_IMPORTED_MODULE_1__utils_Log__['a' /* default */]();

              log.setLogPrefix(__WEBPACK_IMPORTED_MODULE_0__config__['a' /* default */].logPrefix);

              /** @ignore */
              var logger = new __WEBPACK_IMPORTED_MODULE_2__utils_loggers_ConsoleLogger__['a' /* default */]();
              if (!__WEBPACK_IMPORTED_MODULE_0__config__['a' /* default */].debug) {
                logger.setLogLevel(log.WARN);
              }
              log.addLogger(logger);
              log.send(log.DEBUG, TAG, 'Initialized logging.');

              /** @type {src/utils/Log.js~Log} */
              /* harmony default export */ __webpack_exports__['a'] = log;

              /***/
            },
            /* 38 */
            /***/ function (module, exports, __webpack_require__) {
              var isObject = __webpack_require__(11);
              var document = __webpack_require__(3).document;
              // typeof document.createElement is 'object' in old IE
              var is = isObject(document) && isObject(document.createElement);
              module.exports = function (it) {
                return is ? document.createElement(it) : {};
              };

              /***/
            },
            /* 39 */
            /***/ function (module, exports, __webpack_require__) {
              // 7.1.1 ToPrimitive(input [, PreferredType])
              var isObject = __webpack_require__(11);
              // instead of the ES6 spec version, we didn't implement @@toPrimitive case
              // and the second argument - flag - preferred type is a string
              module.exports = function (it, S) {
                if (!isObject(it)) return it;
                var fn, val;
                if (S && typeof (fn = it.toString) == 'function' && !isObject((val = fn.call(it)))) return val;
                if (typeof (fn = it.valueOf) == 'function' && !isObject((val = fn.call(it)))) return val;
                if (!S && typeof (fn = it.toString) == 'function' && !isObject((val = fn.call(it)))) return val;
                throw TypeError("Can't convert object to primitive value");
              };

              /***/
            },
            /* 40 */
            /***/ function (module, exports, __webpack_require__) {
              module.exports = { default: __webpack_require__(113), __esModule: true };

              /***/
            },
            /* 41 */
            /***/ function (module, exports, __webpack_require__) {
              __webpack_require__(114);
              var global = __webpack_require__(3);
              var hide = __webpack_require__(10);
              var Iterators = __webpack_require__(24);
              var TO_STRING_TAG = __webpack_require__(4)('toStringTag');

              var DOMIterables = (
                'CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
                'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
                'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
                'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
                'TextTrackList,TouchList'
              ).split(',');

              for (var i = 0; i < DOMIterables.length; i++) {
                var NAME = DOMIterables[i];
                var Collection = global[NAME];
                var proto = Collection && Collection.prototype;
                if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
                Iterators[NAME] = Iterators.Array;
              }

              /***/
            },
            /* 42 */
            /***/ function (module, exports) {
              // 7.2.1 RequireObjectCoercible(argument)
              module.exports = function (it) {
                if (it == undefined) throw TypeError("Can't call method on  " + it);
                return it;
              };

              /***/
            },
            /* 43 */
            /***/ function (module, exports, __webpack_require__) {
              // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
              var anObject = __webpack_require__(7);
              var dPs = __webpack_require__(118);
              var enumBugKeys = __webpack_require__(47);
              var IE_PROTO = __webpack_require__(45)('IE_PROTO');
              var Empty = function () {
                /* empty */
              };
              var PROTOTYPE = 'prototype';

              // Create object with fake `null` prototype: use iframe Object with cleared prototype
              var createDict = function () {
                // Thrash, waste and sodomy: IE GC bug
                var iframe = __webpack_require__(38)('iframe');
                var i = enumBugKeys.length;
                var lt = '<';
                var gt = '>';
                var iframeDocument;
                iframe.style.display = 'none';
                __webpack_require__(69).appendChild(iframe);
                iframe.src = 'javascript:'; // eslint-disable-line no-script-url
                // createDict = iframe.contentWindow.Object;
                // html.removeChild(iframe);
                iframeDocument = iframe.contentWindow.document;
                iframeDocument.open();
                iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
                iframeDocument.close();
                createDict = iframeDocument.F;
                while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
                return createDict();
              };

              module.exports =
                Object.create ||
                function create(O, Properties) {
                  var result;
                  if (O !== null) {
                    Empty[PROTOTYPE] = anObject(O);
                    result = new Empty();
                    Empty[PROTOTYPE] = null;
                    // add "__proto__" for Object.getPrototypeOf polyfill
                    result[IE_PROTO] = O;
                  } else result = createDict();
                  return Properties === undefined ? result : dPs(result, Properties);
                };

              /***/
            },
            /* 44 */
            /***/ function (module, exports) {
              // 7.1.4 ToInteger
              var ceil = Math.ceil;
              var floor = Math.floor;
              module.exports = function (it) {
                return isNaN((it = +it)) ? 0 : (it > 0 ? floor : ceil)(it);
              };

              /***/
            },
            /* 45 */
            /***/ function (module, exports, __webpack_require__) {
              var shared = __webpack_require__(46)('keys');
              var uid = __webpack_require__(32);
              module.exports = function (key) {
                return shared[key] || (shared[key] = uid(key));
              };

              /***/
            },
            /* 46 */
            /***/ function (module, exports, __webpack_require__) {
              var global = __webpack_require__(3);
              var SHARED = '__core-js_shared__';
              var store = global[SHARED] || (global[SHARED] = {});
              module.exports = function (key) {
                return store[key] || (store[key] = {});
              };

              /***/
            },
            /* 47 */
            /***/ function (module, exports) {
              // IE 8- don't enum bug keys
              module.exports =
                'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(
                  ','
                );

              /***/
            },
            /* 48 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              var $at = __webpack_require__(121)(true);

              // 21.1.3.27 String.prototype[@@iterator]()
              __webpack_require__(65)(
                String,
                'String',
                function (iterated) {
                  this._t = String(iterated); // target
                  this._i = 0; // next index
                  // 21.1.5.2.1 %StringIteratorPrototype%.next()
                },
                function () {
                  var O = this._t;
                  var index = this._i;
                  var point;
                  if (index >= O.length) return { value: undefined, done: true };
                  point = $at(O, index);
                  this._i += point.length;
                  return { value: point, done: false };
                }
              );

              /***/
            },
            /* 49 */
            /***/ function (module, exports, __webpack_require__) {
              exports.f = __webpack_require__(4);

              /***/
            },
            /* 50 */
            /***/ function (module, exports, __webpack_require__) {
              var global = __webpack_require__(3);
              var core = __webpack_require__(2);
              var LIBRARY = __webpack_require__(31);
              var wksExt = __webpack_require__(49);
              var defineProperty = __webpack_require__(8).f;
              module.exports = function (name) {
                var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
                if (name.charAt(0) != '_' && !(name in $Symbol))
                  defineProperty($Symbol, name, { value: wksExt.f(name) });
              };

              /***/
            },
            /* 51 */
            /***/ function (module, exports) {
              exports.f = Object.getOwnPropertySymbols;

              /***/
            },
            /* 52 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              // 25.4.1.5 NewPromiseCapability(C)
              var aFunction = __webpack_require__(29);

              function PromiseCapability(C) {
                var resolve, reject;
                this.promise = new C(function ($$resolve, $$reject) {
                  if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
                  resolve = $$resolve;
                  reject = $$reject;
                });
                this.resolve = aFunction(resolve);
                this.reject = aFunction(reject);
              }

              module.exports.f = function (C) {
                return new PromiseCapability(C);
              };

              /***/
            },
            /* 53 */
            /***/ function (module, exports, __webpack_require__) {
              module.exports = { default: __webpack_require__(158), __esModule: true };

              /***/
            },
            /* 54 */
            /***/ function (module, exports) {
              module.exports = function (module) {
                if (!module.webpackPolyfill) {
                  module.deprecate = function () {};
                  module.paths = [];
                  // module.parent = undefined by default
                  if (!module.children) module.children = [];
                  Object.defineProperty(module, 'loaded', {
                    enumerable: true,
                    get: function () {
                      return module.l;
                    }
                  });
                  Object.defineProperty(module, 'id', {
                    enumerable: true,
                    get: function () {
                      return module.i;
                    }
                  });
                  module.webpackPolyfill = 1;
                }
                return module;
              };

              /***/
            },
            /* 55 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* WEBPACK VAR INJECTION */ (function (process) {
                /** @ignore */
                /* harmony default export */ __webpack_exports__['a'] = {
                  debug: process.env.NODE_ENV != 'production',
                  logPrefix: 'escshopify'
                };
                /* WEBPACK VAR INJECTION */
              }).call(__webpack_exports__, __webpack_require__(36));

              /***/
            },
            /* 56 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';
              /* WEBPACK VAR INJECTION */ (function (process) {
                var utils = __webpack_require__(5);
                var normalizeHeaderName = __webpack_require__(171);

                var DEFAULT_CONTENT_TYPE = {
                  'Content-Type': 'application/x-www-form-urlencoded'
                };

                function setContentTypeIfUnset(headers, value) {
                  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
                    headers['Content-Type'] = value;
                  }
                }

                function getDefaultAdapter() {
                  var adapter;
                  if (typeof XMLHttpRequest !== 'undefined') {
                    // For browsers use XHR adapter
                    adapter = __webpack_require__(92);
                  } else if (typeof process !== 'undefined') {
                    // For node use HTTP adapter
                    adapter = __webpack_require__(92);
                  }
                  return adapter;
                }

                var defaults = {
                  adapter: getDefaultAdapter(),

                  transformRequest: [
                    function transformRequest(data, headers) {
                      normalizeHeaderName(headers, 'Content-Type');
                      if (
                        utils.isFormData(data) ||
                        utils.isArrayBuffer(data) ||
                        utils.isBuffer(data) ||
                        utils.isStream(data) ||
                        utils.isFile(data) ||
                        utils.isBlob(data)
                      ) {
                        return data;
                      }
                      if (utils.isArrayBufferView(data)) {
                        return data.buffer;
                      }
                      if (utils.isURLSearchParams(data)) {
                        setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                        return data.toString();
                      }
                      if (utils.isObject(data)) {
                        setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
                        return JSON.stringify(data);
                      }
                      return data;
                    }
                  ],

                  transformResponse: [
                    function transformResponse(data) {
                      /*eslint no-param-reassign:0*/
                      if (typeof data === 'string') {
                        try {
                          data = JSON.parse(data);
                        } catch (e) {
                          /* Ignore */
                        }
                      }
                      return data;
                    }
                  ],

                  timeout: 0,

                  xsrfCookieName: 'XSRF-TOKEN',
                  xsrfHeaderName: 'X-XSRF-TOKEN',

                  maxContentLength: -1,

                  validateStatus: function validateStatus(status) {
                    return status >= 200 && status < 300;
                  }
                };

                defaults.headers = {
                  common: {
                    Accept: 'application/json, text/plain, */*'
                  }
                };

                utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
                  defaults.headers[method] = {};
                });

                utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
                  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
                });

                module.exports = defaults;

                /* WEBPACK VAR INJECTION */
              }).call(exports, __webpack_require__(36));

              /***/
            },
            /* 57 */
            /***/ function (module, exports, __webpack_require__) {
              /**
               * This file is part of the JS Money library
               *
               * Copyright (c) 2014 David Kalosi
               *
               * For the full copyright and license information, please view the LICENSE
               * file that was distributed with this source code.
               */

              module.exports = __webpack_require__(189);

              /***/
            },
            /* 58 */
            /***/ function (module, exports, __webpack_require__) {
              var baseGetTag = __webpack_require__(21),
                isObject = __webpack_require__(27);

              /** `Object#toString` result references. */
              var asyncTag = '[object AsyncFunction]',
                funcTag = '[object Function]',
                genTag = '[object GeneratorFunction]',
                proxyTag = '[object Proxy]';

              /**
               * Checks if `value` is classified as a `Function` object.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a function, else `false`.
               * @example
               *
               * _.isFunction(_);
               * // => true
               *
               * _.isFunction(/abc/);
               * // => false
               */
              function isFunction(value) {
                if (!isObject(value)) {
                  return false;
                }
                // The use of `Object#toString` avoids issues with the `typeof` operator
                // in Safari 9 which returns 'object' for typed arrays and other constructors.
                var tag = baseGetTag(value);
                return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
              }

              module.exports = isFunction;

              /***/
            },
            /* 59 */
            /***/ function (module, exports, __webpack_require__) {
              var freeGlobal = __webpack_require__(99);

              /** Detect free variable `self`. */
              var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

              /** Used as a reference to the global object. */
              var root = freeGlobal || freeSelf || Function('return this')();

              module.exports = root;

              /***/
            },
            /* 60 */
            /***/ function (module, exports) {
              /**
               * This file is part of the JS Money library
               *
               * Copyright (c) 2014 David Kalosi
               *
               * For the full copyright and license information, please view the LICENSE
               * file that was distributed with this source code.
               */

              var currencies = {
                USD: {
                  symbol: '$',
                  name: 'US Dollar',
                  symbol_native: '$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'USD',
                  name_plural: 'US dollars'
                },
                CAD: {
                  symbol: 'CA$',
                  name: 'Canadian Dollar',
                  symbol_native: '$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'CAD',
                  name_plural: 'Canadian dollars'
                },
                EUR: {
                  symbol: '€',
                  name: 'Euro',
                  symbol_native: '€',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'EUR',
                  name_plural: 'euros'
                },
                BTC: {
                  symbol: 'BTC',
                  name: 'Bitcoin',
                  symbol_native: '฿',
                  decimal_digits: 8,
                  rounding: 0,
                  code: 'BTC',
                  name_plural: 'Bitcoins'
                },
                AED: {
                  symbol: 'AED',
                  name: 'United Arab Emirates Dirham',
                  symbol_native: 'د.إ.‏',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'AED',
                  name_plural: 'UAE dirhams'
                },
                AFN: {
                  symbol: 'Af',
                  name: 'Afghan Afghani',
                  symbol_native: '؋',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'AFN',
                  name_plural: 'Afghan Afghanis'
                },
                ALL: {
                  symbol: 'ALL',
                  name: 'Albanian Lek',
                  symbol_native: 'Lek',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'ALL',
                  name_plural: 'Albanian lekë'
                },
                AMD: {
                  symbol: 'AMD',
                  name: 'Armenian Dram',
                  symbol_native: 'դր.',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'AMD',
                  name_plural: 'Armenian drams'
                },
                ARS: {
                  symbol: 'AR$',
                  name: 'Argentine Peso',
                  symbol_native: '$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'ARS',
                  name_plural: 'Argentine pesos'
                },
                AUD: {
                  symbol: 'AU$',
                  name: 'Australian Dollar',
                  symbol_native: '$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'AUD',
                  name_plural: 'Australian dollars'
                },
                AZN: {
                  symbol: 'man.',
                  name: 'Azerbaijani Manat',
                  symbol_native: 'ман.',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'AZN',
                  name_plural: 'Azerbaijani manats'
                },
                BAM: {
                  symbol: 'KM',
                  name: 'Bosnia-Herzegovina Convertible Mark',
                  symbol_native: 'KM',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'BAM',
                  name_plural: 'Bosnia-Herzegovina convertible marks'
                },
                BDT: {
                  symbol: 'Tk',
                  name: 'Bangladeshi Taka',
                  symbol_native: '৳',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'BDT',
                  name_plural: 'Bangladeshi takas'
                },
                BGN: {
                  symbol: 'BGN',
                  name: 'Bulgarian Lev',
                  symbol_native: 'лв.',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'BGN',
                  name_plural: 'Bulgarian leva'
                },
                BHD: {
                  symbol: 'BD',
                  name: 'Bahraini Dinar',
                  symbol_native: 'د.ب.‏',
                  decimal_digits: 3,
                  rounding: 0,
                  code: 'BHD',
                  name_plural: 'Bahraini dinars'
                },
                BIF: {
                  symbol: 'FBu',
                  name: 'Burundian Franc',
                  symbol_native: 'FBu',
                  decimal_digits: 0,
                  rounding: 0,
                  code: 'BIF',
                  name_plural: 'Burundian francs'
                },
                BND: {
                  symbol: 'BN$',
                  name: 'Brunei Dollar',
                  symbol_native: '$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'BND',
                  name_plural: 'Brunei dollars'
                },
                BOB: {
                  symbol: 'Bs',
                  name: 'Bolivian Boliviano',
                  symbol_native: 'Bs',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'BOB',
                  name_plural: 'Bolivian bolivianos'
                },
                BRL: {
                  symbol: 'R$',
                  name: 'Brazilian Real',
                  symbol_native: 'R$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'BRL',
                  name_plural: 'Brazilian reals'
                },
                BWP: {
                  symbol: 'BWP',
                  name: 'Botswanan Pula',
                  symbol_native: 'P',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'BWP',
                  name_plural: 'Botswanan pulas'
                },
                BYR: {
                  symbol: 'BYR',
                  name: 'Belarusian Ruble',
                  symbol_native: 'BYR',
                  decimal_digits: 0,
                  rounding: 0,
                  code: 'BYR',
                  name_plural: 'Belarusian rubles'
                },
                BZD: {
                  symbol: 'BZ$',
                  name: 'Belize Dollar',
                  symbol_native: '$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'BZD',
                  name_plural: 'Belize dollars'
                },
                CDF: {
                  symbol: 'CDF',
                  name: 'Congolese Franc',
                  symbol_native: 'FrCD',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'CDF',
                  name_plural: 'Congolese francs'
                },
                CHF: {
                  symbol: 'CHF',
                  name: 'Swiss Franc',
                  symbol_native: 'CHF',
                  decimal_digits: 2,
                  rounding: 0.05,
                  code: 'CHF',
                  name_plural: 'Swiss francs'
                },
                CLP: {
                  symbol: 'CL$',
                  name: 'Chilean Peso',
                  symbol_native: '$',
                  decimal_digits: 0,
                  rounding: 0,
                  code: 'CLP',
                  name_plural: 'Chilean pesos'
                },
                CNY: {
                  symbol: 'CN¥',
                  name: 'Chinese Yuan',
                  symbol_native: 'CN¥',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'CNY',
                  name_plural: 'Chinese yuan'
                },
                COP: {
                  symbol: 'CO$',
                  name: 'Colombian Peso',
                  symbol_native: '$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'COP',
                  name_plural: 'Colombian pesos'
                },
                CRC: {
                  symbol: '₡',
                  name: 'Costa Rican Colón',
                  symbol_native: '₡',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'CRC',
                  name_plural: 'Costa Rican colóns'
                },
                CVE: {
                  symbol: 'CV$',
                  name: 'Cape Verdean Escudo',
                  symbol_native: 'CV$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'CVE',
                  name_plural: 'Cape Verdean escudos'
                },
                CZK: {
                  symbol: 'Kč',
                  name: 'Czech Republic Koruna',
                  symbol_native: 'Kč',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'CZK',
                  name_plural: 'Czech Republic korunas'
                },
                DJF: {
                  symbol: 'Fdj',
                  name: 'Djiboutian Franc',
                  symbol_native: 'Fdj',
                  decimal_digits: 0,
                  rounding: 0,
                  code: 'DJF',
                  name_plural: 'Djiboutian francs'
                },
                DKK: {
                  symbol: 'Dkr',
                  name: 'Danish Krone',
                  symbol_native: 'kr',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'DKK',
                  name_plural: 'Danish kroner'
                },
                DOP: {
                  symbol: 'RD$',
                  name: 'Dominican Peso',
                  symbol_native: 'RD$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'DOP',
                  name_plural: 'Dominican pesos'
                },
                DZD: {
                  symbol: 'DA',
                  name: 'Algerian Dinar',
                  symbol_native: 'د.ج.‏',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'DZD',
                  name_plural: 'Algerian dinars'
                },
                EEK: {
                  symbol: 'Ekr',
                  name: 'Estonian Kroon',
                  symbol_native: 'kr',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'EEK',
                  name_plural: 'Estonian kroons'
                },
                EGP: {
                  symbol: 'EGP',
                  name: 'Egyptian Pound',
                  symbol_native: 'ج.م.‏',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'EGP',
                  name_plural: 'Egyptian pounds'
                },
                ERN: {
                  symbol: 'Nfk',
                  name: 'Eritrean Nakfa',
                  symbol_native: 'Nfk',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'ERN',
                  name_plural: 'Eritrean nakfas'
                },
                ETB: {
                  symbol: 'Br',
                  name: 'Ethiopian Birr',
                  symbol_native: 'Br',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'ETB',
                  name_plural: 'Ethiopian birrs'
                },
                GBP: {
                  symbol: '£',
                  name: 'British Pound Sterling',
                  symbol_native: '£',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'GBP',
                  name_plural: 'British pounds sterling'
                },
                GEL: {
                  symbol: 'GEL',
                  name: 'Georgian Lari',
                  symbol_native: 'GEL',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'GEL',
                  name_plural: 'Georgian laris'
                },
                GHS: {
                  symbol: 'GH₵',
                  name: 'Ghanaian Cedi',
                  symbol_native: 'GH₵',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'GHS',
                  name_plural: 'Ghanaian cedis'
                },
                GNF: {
                  symbol: 'FG',
                  name: 'Guinean Franc',
                  symbol_native: 'FG',
                  decimal_digits: 0,
                  rounding: 0,
                  code: 'GNF',
                  name_plural: 'Guinean francs'
                },
                GTQ: {
                  symbol: 'GTQ',
                  name: 'Guatemalan Quetzal',
                  symbol_native: 'Q',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'GTQ',
                  name_plural: 'Guatemalan quetzals'
                },
                HKD: {
                  symbol: 'HK$',
                  name: 'Hong Kong Dollar',
                  symbol_native: '$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'HKD',
                  name_plural: 'Hong Kong dollars'
                },
                HNL: {
                  symbol: 'HNL',
                  name: 'Honduran Lempira',
                  symbol_native: 'L',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'HNL',
                  name_plural: 'Honduran lempiras'
                },
                HRK: {
                  symbol: 'kn',
                  name: 'Croatian Kuna',
                  symbol_native: 'kn',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'HRK',
                  name_plural: 'Croatian kunas'
                },
                HUF: {
                  symbol: 'Ft',
                  name: 'Hungarian Forint',
                  symbol_native: 'Ft',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'HUF',
                  name_plural: 'Hungarian forints'
                },
                IDR: {
                  symbol: 'Rp',
                  name: 'Indonesian Rupiah',
                  symbol_native: 'Rp',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'IDR',
                  name_plural: 'Indonesian rupiahs'
                },
                ILS: {
                  symbol: '₪',
                  name: 'Israeli New Sheqel',
                  symbol_native: '₪',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'ILS',
                  name_plural: 'Israeli new sheqels'
                },
                INR: {
                  symbol: 'Rs',
                  name: 'Indian Rupee',
                  symbol_native: 'টকা',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'INR',
                  name_plural: 'Indian rupees'
                },
                IQD: {
                  symbol: 'IQD',
                  name: 'Iraqi Dinar',
                  symbol_native: 'د.ع.‏',
                  decimal_digits: 3,
                  rounding: 0,
                  code: 'IQD',
                  name_plural: 'Iraqi dinars'
                },
                IRR: {
                  symbol: 'IRR',
                  name: 'Iranian Rial',
                  symbol_native: '﷼',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'IRR',
                  name_plural: 'Iranian rials'
                },
                ISK: {
                  symbol: 'Ikr',
                  name: 'Icelandic Króna',
                  symbol_native: 'kr',
                  decimal_digits: 0,
                  rounding: 0,
                  code: 'ISK',
                  name_plural: 'Icelandic krónur'
                },
                JMD: {
                  symbol: 'J$',
                  name: 'Jamaican Dollar',
                  symbol_native: '$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'JMD',
                  name_plural: 'Jamaican dollars'
                },
                JOD: {
                  symbol: 'JD',
                  name: 'Jordanian Dinar',
                  symbol_native: 'د.أ.‏',
                  decimal_digits: 3,
                  rounding: 0,
                  code: 'JOD',
                  name_plural: 'Jordanian dinars'
                },
                JPY: {
                  symbol: '¥',
                  name: 'Japanese Yen',
                  symbol_native: '￥',
                  decimal_digits: 0,
                  rounding: 0,
                  code: 'JPY',
                  name_plural: 'Japanese yen'
                },
                KES: {
                  symbol: 'Ksh',
                  name: 'Kenyan Shilling',
                  symbol_native: 'Ksh',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'KES',
                  name_plural: 'Kenyan shillings'
                },
                KHR: {
                  symbol: 'KHR',
                  name: 'Cambodian Riel',
                  symbol_native: '៛',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'KHR',
                  name_plural: 'Cambodian riels'
                },
                KMF: {
                  symbol: 'CF',
                  name: 'Comorian Franc',
                  symbol_native: 'FC',
                  decimal_digits: 0,
                  rounding: 0,
                  code: 'KMF',
                  name_plural: 'Comorian francs'
                },
                KRW: {
                  symbol: '₩',
                  name: 'South Korean Won',
                  symbol_native: '₩',
                  decimal_digits: 0,
                  rounding: 0,
                  code: 'KRW',
                  name_plural: 'South Korean won'
                },
                KWD: {
                  symbol: 'KD',
                  name: 'Kuwaiti Dinar',
                  symbol_native: 'د.ك.‏',
                  decimal_digits: 3,
                  rounding: 0,
                  code: 'KWD',
                  name_plural: 'Kuwaiti dinars'
                },
                KZT: {
                  symbol: 'KZT',
                  name: 'Kazakhstani Tenge',
                  symbol_native: 'тңг.',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'KZT',
                  name_plural: 'Kazakhstani tenges'
                },
                LAK: {
                  symbol: '₭',
                  name: 'Lao kip',
                  symbol_native: 'ກີບ',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'LAK',
                  name_plural: 'Lao kips'
                },
                LBP: {
                  symbol: 'LB£',
                  name: 'Lebanese Pound',
                  symbol_native: 'ل.ل.‏',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'LBP',
                  name_plural: 'Lebanese pounds'
                },
                LKR: {
                  symbol: 'SLRs',
                  name: 'Sri Lankan Rupee',
                  symbol_native: 'SL Re',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'LKR',
                  name_plural: 'Sri Lankan rupees'
                },
                LTL: {
                  symbol: 'Lt',
                  name: 'Lithuanian Litas',
                  symbol_native: 'Lt',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'LTL',
                  name_plural: 'Lithuanian litai'
                },
                LVL: {
                  symbol: 'Ls',
                  name: 'Latvian Lats',
                  symbol_native: 'Ls',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'LVL',
                  name_plural: 'Latvian lati'
                },
                LYD: {
                  symbol: 'LD',
                  name: 'Libyan Dinar',
                  symbol_native: 'د.ل.‏',
                  decimal_digits: 3,
                  rounding: 0,
                  code: 'LYD',
                  name_plural: 'Libyan dinars'
                },
                MAD: {
                  symbol: 'MAD',
                  name: 'Moroccan Dirham',
                  symbol_native: 'د.م.‏',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'MAD',
                  name_plural: 'Moroccan dirhams'
                },
                MDL: {
                  symbol: 'MDL',
                  name: 'Moldovan Leu',
                  symbol_native: 'MDL',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'MDL',
                  name_plural: 'Moldovan lei'
                },
                MGA: {
                  symbol: 'MGA',
                  name: 'Malagasy Ariary',
                  symbol_native: 'MGA',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'MGA',
                  name_plural: 'Malagasy Ariaries'
                },
                MKD: {
                  symbol: 'MKD',
                  name: 'Macedonian Denar',
                  symbol_native: 'MKD',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'MKD',
                  name_plural: 'Macedonian denari'
                },
                MMK: {
                  symbol: 'MMK',
                  name: 'Myanma Kyat',
                  symbol_native: 'K',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'MMK',
                  name_plural: 'Myanma kyats'
                },
                MOP: {
                  symbol: 'MOP$',
                  name: 'Macanese Pataca',
                  symbol_native: 'MOP$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'MOP',
                  name_plural: 'Macanese patacas'
                },
                MUR: {
                  symbol: 'MURs',
                  name: 'Mauritian Rupee',
                  symbol_native: 'MURs',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'MUR',
                  name_plural: 'Mauritian rupees'
                },
                MXN: {
                  symbol: 'MX$',
                  name: 'Mexican Peso',
                  symbol_native: '$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'MXN',
                  name_plural: 'Mexican pesos'
                },
                MYR: {
                  symbol: 'RM',
                  name: 'Malaysian Ringgit',
                  symbol_native: 'RM',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'MYR',
                  name_plural: 'Malaysian ringgits'
                },
                MZN: {
                  symbol: 'MTn',
                  name: 'Mozambican Metical',
                  symbol_native: 'MTn',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'MZN',
                  name_plural: 'Mozambican meticals'
                },
                NAD: {
                  symbol: 'N$',
                  name: 'Namibian Dollar',
                  symbol_native: 'N$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'NAD',
                  name_plural: 'Namibian dollars'
                },
                NGN: {
                  symbol: '₦',
                  name: 'Nigerian Naira',
                  symbol_native: '₦',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'NGN',
                  name_plural: 'Nigerian nairas'
                },
                NIO: {
                  symbol: 'C$',
                  name: 'Nicaraguan Córdoba',
                  symbol_native: 'C$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'NIO',
                  name_plural: 'Nicaraguan córdobas'
                },
                NOK: {
                  symbol: 'Nkr',
                  name: 'Norwegian Krone',
                  symbol_native: 'kr',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'NOK',
                  name_plural: 'Norwegian kroner'
                },
                NPR: {
                  symbol: 'NPRs',
                  name: 'Nepalese Rupee',
                  symbol_native: 'नेरू',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'NPR',
                  name_plural: 'Nepalese rupees'
                },
                NZD: {
                  symbol: 'NZ$',
                  name: 'New Zealand Dollar',
                  symbol_native: '$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'NZD',
                  name_plural: 'New Zealand dollars'
                },
                OMR: {
                  symbol: 'OMR',
                  name: 'Omani Rial',
                  symbol_native: 'ر.ع.‏',
                  decimal_digits: 3,
                  rounding: 0,
                  code: 'OMR',
                  name_plural: 'Omani rials'
                },
                PAB: {
                  symbol: 'B/.',
                  name: 'Panamanian Balboa',
                  symbol_native: 'B/.',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'PAB',
                  name_plural: 'Panamanian balboas'
                },
                PEN: {
                  symbol: 'S/.',
                  name: 'Peruvian Nuevo Sol',
                  symbol_native: 'S/.',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'PEN',
                  name_plural: 'Peruvian nuevos soles'
                },
                PHP: {
                  symbol: '₱',
                  name: 'Philippine Peso',
                  symbol_native: '₱',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'PHP',
                  name_plural: 'Philippine pesos'
                },
                PKR: {
                  symbol: 'PKRs',
                  name: 'Pakistani Rupee',
                  symbol_native: '₨',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'PKR',
                  name_plural: 'Pakistani rupees'
                },
                PLN: {
                  symbol: 'zł',
                  name: 'Polish Zloty',
                  symbol_native: 'zł',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'PLN',
                  name_plural: 'Polish zlotys'
                },
                PYG: {
                  symbol: '₲',
                  name: 'Paraguayan Guarani',
                  symbol_native: '₲',
                  decimal_digits: 0,
                  rounding: 0,
                  code: 'PYG',
                  name_plural: 'Paraguayan guaranis'
                },
                QAR: {
                  symbol: 'QR',
                  name: 'Qatari Rial',
                  symbol_native: 'ر.ق.‏',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'QAR',
                  name_plural: 'Qatari rials'
                },
                RON: {
                  symbol: 'RON',
                  name: 'Romanian Leu',
                  symbol_native: 'RON',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'RON',
                  name_plural: 'Romanian lei'
                },
                RSD: {
                  symbol: 'din.',
                  name: 'Serbian Dinar',
                  symbol_native: 'дин.',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'RSD',
                  name_plural: 'Serbian dinars'
                },
                RUB: {
                  symbol: 'RUB',
                  name: 'Russian Ruble',
                  symbol_native: '₽',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'RUB',
                  name_plural: 'Russian rubles'
                },
                RWF: {
                  symbol: 'RWF',
                  name: 'Rwandan Franc',
                  symbol_native: 'FR',
                  decimal_digits: 0,
                  rounding: 0,
                  code: 'RWF',
                  name_plural: 'Rwandan francs'
                },
                SAR: {
                  symbol: 'SR',
                  name: 'Saudi Riyal',
                  symbol_native: 'ر.س.‏',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'SAR',
                  name_plural: 'Saudi riyals'
                },
                SDG: {
                  symbol: 'SDG',
                  name: 'Sudanese Pound',
                  symbol_native: 'SDG',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'SDG',
                  name_plural: 'Sudanese pounds'
                },
                SEK: {
                  symbol: 'Skr',
                  name: 'Swedish Krona',
                  symbol_native: 'kr',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'SEK',
                  name_plural: 'Swedish kronor'
                },
                SGD: {
                  symbol: 'S$',
                  name: 'Singapore Dollar',
                  symbol_native: '$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'SGD',
                  name_plural: 'Singapore dollars'
                },
                SOS: {
                  symbol: 'Ssh',
                  name: 'Somali Shilling',
                  symbol_native: 'Ssh',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'SOS',
                  name_plural: 'Somali shillings'
                },
                SYP: {
                  symbol: 'SY£',
                  name: 'Syrian Pound',
                  symbol_native: 'ل.س.‏',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'SYP',
                  name_plural: 'Syrian pounds'
                },
                THB: {
                  symbol: '฿',
                  name: 'Thai Baht',
                  symbol_native: '฿',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'THB',
                  name_plural: 'Thai baht'
                },
                TND: {
                  symbol: 'DT',
                  name: 'Tunisian Dinar',
                  symbol_native: 'د.ت.‏',
                  decimal_digits: 3,
                  rounding: 0,
                  code: 'TND',
                  name_plural: 'Tunisian dinars'
                },
                TOP: {
                  symbol: 'T$',
                  name: 'Tongan Paʻanga',
                  symbol_native: 'T$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'TOP',
                  name_plural: 'Tongan paʻanga'
                },
                TRY: {
                  symbol: 'TL',
                  name: 'Turkish Lira',
                  symbol_native: 'TL',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'TRY',
                  name_plural: 'Turkish Lira'
                },
                TTD: {
                  symbol: 'TT$',
                  name: 'Trinidad and Tobago Dollar',
                  symbol_native: '$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'TTD',
                  name_plural: 'Trinidad and Tobago dollars'
                },
                TWD: {
                  symbol: 'NT$',
                  name: 'New Taiwan Dollar',
                  symbol_native: 'NT$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'TWD',
                  name_plural: 'New Taiwan dollars'
                },
                TZS: {
                  symbol: 'TSh',
                  name: 'Tanzanian Shilling',
                  symbol_native: 'TSh',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'TZS',
                  name_plural: 'Tanzanian shillings'
                },
                UAH: {
                  symbol: '₴',
                  name: 'Ukrainian Hryvnia',
                  symbol_native: '₴',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'UAH',
                  name_plural: 'Ukrainian hryvnias'
                },
                UGX: {
                  symbol: 'USh',
                  name: 'Ugandan Shilling',
                  symbol_native: 'USh',
                  decimal_digits: 0,
                  rounding: 0,
                  code: 'UGX',
                  name_plural: 'Ugandan shillings'
                },
                UYU: {
                  symbol: '$U',
                  name: 'Uruguayan Peso',
                  symbol_native: '$',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'UYU',
                  name_plural: 'Uruguayan pesos'
                },
                UZS: {
                  symbol: 'UZS',
                  name: 'Uzbekistan Som',
                  symbol_native: 'UZS',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'UZS',
                  name_plural: 'Uzbekistan som'
                },
                VEF: {
                  symbol: 'Bs.F.',
                  name: 'Venezuelan Bolívar',
                  symbol_native: 'Bs.F.',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'VEF',
                  name_plural: 'Venezuelan bolívars'
                },
                VND: {
                  symbol: '₫',
                  name: 'Vietnamese Dong',
                  symbol_native: '₫',
                  decimal_digits: 0,
                  rounding: 0,
                  code: 'VND',
                  name_plural: 'Vietnamese dong'
                },
                XAF: {
                  symbol: 'FCFA',
                  name: 'CFA Franc BEAC',
                  symbol_native: 'FCFA',
                  decimal_digits: 0,
                  rounding: 0,
                  code: 'XAF',
                  name_plural: 'CFA francs BEAC'
                },
                XOF: {
                  symbol: 'CFA',
                  name: 'CFA Franc BCEAO',
                  symbol_native: 'CFA',
                  decimal_digits: 0,
                  rounding: 0,
                  code: 'XOF',
                  name_plural: 'CFA francs BCEAO'
                },
                YER: {
                  symbol: 'YR',
                  name: 'Yemeni Rial',
                  symbol_native: 'ر.ي.‏',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'YER',
                  name_plural: 'Yemeni rials'
                },
                ZAR: {
                  symbol: 'R',
                  name: 'South African Rand',
                  symbol_native: 'R',
                  decimal_digits: 2,
                  rounding: 0,
                  code: 'ZAR',
                  name_plural: 'South African rand'
                },
                ZMK: {
                  symbol: 'ZK',
                  name: 'Zambian Kwacha',
                  symbol_native: 'ZK',
                  decimal_digits: 0,
                  rounding: 0,
                  code: 'ZMK',
                  name_plural: 'Zambian kwachas'
                }
              };

              Object.keys(currencies).forEach(function (currency) {
                module.exports[currency] = currencies[currency];
              });

              /***/
            },
            /* 61 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ =
                __webpack_require__(1);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Log__ = __webpack_require__(63);

              /**
               * General-purpose utilties.
               */

              var GeneralUtils = (function () {
                function GeneralUtils() {
                  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GeneralUtils);

                  /** @type {src/utils/Log.js~Log} */
                  this.Log = __WEBPACK_IMPORTED_MODULE_2__Log__['a' /* default */];
                }

                /**
                 * Executes the given callback on DOMContentLoaded.
                 * @param {function(): void} callback
                 */

                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(GeneralUtils, [
                  {
                    key: 'onLoad',
                    value: function onLoad(callback) {
                      if (document.readyState != 'loading') {
                        callback();
                      } else {
                        document.addEventListener('DOMContentLoaded', function () {
                          callback();
                        });
                      }
                    }

                    /**
                     * Create a unique key suitable for storing in localStorage, etc.
                     * @param {String}	namespace
                     * @param {String}	key
                     * @return {String}
                     */
                  },
                  {
                    key: 'safeStorageKey',
                    value: function safeStorageKey(namespace, key) {
                      return '__' + namespace + '__' + key;
                    }
                  }
                ]);

                return GeneralUtils;
              })();

              /** @ignore */

              /* harmony default export */ __webpack_exports__['a'] = new GeneralUtils();

              /***/
            },
            /* 62 */
            /***/ function (module, exports, __webpack_require__) {
              module.exports =
                !__webpack_require__(9) &&
                !__webpack_require__(17)(function () {
                  return (
                    Object.defineProperty(__webpack_require__(38)('div'), 'a', {
                      get: function () {
                        return 7;
                      }
                    }).a != 7
                  );
                });

              /***/
            },
            /* 63 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ =
                __webpack_require__(40);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ =
                __webpack_require__(1);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loggers_logLevel_js__ = __webpack_require__(73);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loggers_Logger_js__ = __webpack_require__(74);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loggers_ConsoleLogger_js__ =
                __webpack_require__(75);

              /**
               * Provides well-formatted logging with log level filtering.
               */

              var Log = (function () {
                /**
                 * Create a new log.
                 */
                function Log() {
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Log);

                  /** @type {Logger[]} */
                  this.loggers = [];
                  /** @type {String} */
                  this._logPrefix = '';
                }

                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Log, [
                  {
                    key: 'setLogPrefix',
                    value: function setLogPrefix(prefix) {
                      this._logPrefix = prefix;
                      var _iteratorNormalCompletion = true;
                      var _didIteratorError = false;
                      var _iteratorError = undefined;

                      try {
                        for (
                          var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(
                              this.loggers
                            ),
                            _step;
                          !(_iteratorNormalCompletion = (_step = _iterator.next()).done);
                          _iteratorNormalCompletion = true
                        ) {
                          var logger = _step.value;

                          logger.setLogPrefix(prefix);
                        }
                      } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                          }
                        } finally {
                          if (_didIteratorError) {
                            throw _iteratorError;
                          }
                        }
                      }
                    }

                    /**
                     * Adds a new logger, which will process any log methods called.
                     * @param {Logger}	logger - A new logger to process log requests.
                     */
                  },
                  {
                    key: 'addLogger',
                    value: function addLogger(logger) {
                      this.loggers.push(logger);
                      logger.setLogPrefix(this._logPrefix);
                    }

                    /**
                     * Logs a message to the console
                     * @param {type}	level - Logging level
                     * @param {type}	tag - Logging tag
                     * @param {type}	text - Text to log
                     */
                  },
                  {
                    key: 'send',
                    value: function send(level, tag, text) {
                      var _iteratorNormalCompletion2 = true;
                      var _didIteratorError2 = false;
                      var _iteratorError2 = undefined;

                      try {
                        for (
                          var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(
                              this.loggers
                            ),
                            _step2;
                          !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done);
                          _iteratorNormalCompletion2 = true
                        ) {
                          var logger = _step2.value;

                          logger.send(level, tag, text);
                        }
                      } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                          }
                        } finally {
                          if (_didIteratorError2) {
                            throw _iteratorError2;
                          }
                        }
                      }
                    }

                    /**
                     * Log an object.
                     * @param {type}	level - Logging level
                     * @param {type}	tag - Logging tag
                     * @param {type}	text - Logging text
                     * @param {type}	object - Object to be logged
                     */
                  },
                  {
                    key: 'sendObject',
                    value: function sendObject(level, tag, text, object) {
                      var _iteratorNormalCompletion3 = true;
                      var _didIteratorError3 = false;
                      var _iteratorError3 = undefined;

                      try {
                        for (
                          var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(
                              this.loggers
                            ),
                            _step3;
                          !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done);
                          _iteratorNormalCompletion3 = true
                        ) {
                          var logger = _step3.value;

                          logger.sendObject(level, tag, text, object);
                        }
                      } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                          }
                        } finally {
                          if (_didIteratorError3) {
                            throw _iteratorError3;
                          }
                        }
                      }
                    }

                    /**
                     * Alias for .send(Log.DEBUG, ...) / .sendObject(Log.DEBUG, ...)
                     * @param {String} tag Log tag
                     * @param {String} text Log message
                     * @param {Object} [text] Optional object to debug
                     */
                  },
                  {
                    key: 'debug',
                    value: function debug(tag, text, object) {
                      if (object != undefined) {
                        this.sendObject(
                          __WEBPACK_IMPORTED_MODULE_3__loggers_logLevel_js__['a' /* default */].DEBUG,
                          tag,
                          text,
                          object
                        );
                      } else {
                        this.send(
                          __WEBPACK_IMPORTED_MODULE_3__loggers_logLevel_js__['a' /* default */].DEBUG,
                          tag,
                          text
                        );
                      }
                    }
                    /**
                     * Alias for .send(Log.INFO, ...) / .sendObject(Log.INFO, ...)
                     * @param {String} tag Log tag
                     * @param {String} text Log message
                     * @param {Object} [text] Optional object to debug
                     */
                  },
                  {
                    key: 'info',
                    value: function info(tag, text, object) {
                      if (object != undefined) {
                        this.sendObject(
                          __WEBPACK_IMPORTED_MODULE_3__loggers_logLevel_js__['a' /* default */].INFO,
                          tag,
                          text,
                          object
                        );
                      } else {
                        this.send(
                          __WEBPACK_IMPORTED_MODULE_3__loggers_logLevel_js__['a' /* default */].INFO,
                          tag,
                          text
                        );
                      }
                    }
                    /**
                     * Alias for .send(Log.WARN, ...) / .sendObject(Log.WARN, ...)
                     * @param {String} tag Log tag
                     * @param {String} text Log message
                     * @param {Object} [text] Optional object to debug
                     */
                  },
                  {
                    key: 'warn',
                    value: function warn(tag, text, object) {
                      if (object != undefined) {
                        this.sendObject(
                          __WEBPACK_IMPORTED_MODULE_3__loggers_logLevel_js__['a' /* default */].WARN,
                          tag,
                          text,
                          object
                        );
                      } else {
                        this.send(
                          __WEBPACK_IMPORTED_MODULE_3__loggers_logLevel_js__['a' /* default */].WARN,
                          tag,
                          text
                        );
                      }
                    }
                    /**
                     * Alias for .send(Log.ERROR, ...) / .sendObject(Log.ERROR, ...)
                     * @param {String} tag Log tag
                     * @param {String} text Log message
                     * @param {Object} [text] Optional object to debug
                     */
                  },
                  {
                    key: 'error',
                    value: function error(tag, text, object) {
                      if (object != undefined) {
                        this.sendObject(
                          __WEBPACK_IMPORTED_MODULE_3__loggers_logLevel_js__['a' /* default */].ERROR,
                          tag,
                          text,
                          object
                        );
                      } else {
                        this.send(
                          __WEBPACK_IMPORTED_MODULE_3__loggers_logLevel_js__['a' /* default */].ERROR,
                          tag,
                          text
                        );
                      }
                    }
                    /**
                     * Alias for .send(Log.FATAL, ...) / .sendObject(Log.FATAL, ...)
                     * @param {String} tag Log tag
                     * @param {String} text Log message
                     * @param {Object} [text] Optional object to debug
                     */
                  },
                  {
                    key: 'fatal',
                    value: function fatal(tag, text, object) {
                      if (object != undefined) {
                        this.sendObject(
                          __WEBPACK_IMPORTED_MODULE_3__loggers_logLevel_js__['a' /* default */].FATAL,
                          tag,
                          text,
                          object
                        );
                      } else {
                        this.send(
                          __WEBPACK_IMPORTED_MODULE_3__loggers_logLevel_js__['a' /* default */].FATAL,
                          tag,
                          text
                        );
                      }
                    }
                  }
                ]);

                return Log;
              })();

              // Expose log levels on Log
              /** @ignore */

              var levelMap = __WEBPACK_IMPORTED_MODULE_3__loggers_logLevel_js__['a' /* default */].getMap();
              for (var key in levelMap) {
                Log.prototype[levelMap[key]] = key;
              }

              Log.loggers = {
                Logger: __WEBPACK_IMPORTED_MODULE_4__loggers_Logger_js__['a' /* default */],
                ConsoleLogger: __WEBPACK_IMPORTED_MODULE_5__loggers_ConsoleLogger_js__['a' /* default */]
              };

              /* harmony default export */ __webpack_exports__['a'] = Log;

              /***/
            },
            /* 64 */
            /***/ function (module, exports, __webpack_require__) {
              // fallback for non-array-like ES3 and non-enumerable old V8 strings
              var cof = __webpack_require__(25);
              // eslint-disable-next-line no-prototype-builtins
              module.exports = Object('z').propertyIsEnumerable(0)
                ? Object
                : function (it) {
                    return cof(it) == 'String' ? it.split('') : Object(it);
                  };

              /***/
            },
            /* 65 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              var LIBRARY = __webpack_require__(31);
              var $export = __webpack_require__(6);
              var redefine = __webpack_require__(66);
              var hide = __webpack_require__(10);
              var has = __webpack_require__(13);
              var Iterators = __webpack_require__(24);
              var $iterCreate = __webpack_require__(117);
              var setToStringTag = __webpack_require__(33);
              var getPrototypeOf = __webpack_require__(70);
              var ITERATOR = __webpack_require__(4)('iterator');
              var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
              var FF_ITERATOR = '@@iterator';
              var KEYS = 'keys';
              var VALUES = 'values';

              var returnThis = function () {
                return this;
              };

              module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
                $iterCreate(Constructor, NAME, next);
                var getMethod = function (kind) {
                  if (!BUGGY && kind in proto) return proto[kind];
                  switch (kind) {
                    case KEYS:
                      return function keys() {
                        return new Constructor(this, kind);
                      };
                    case VALUES:
                      return function values() {
                        return new Constructor(this, kind);
                      };
                  }
                  return function entries() {
                    return new Constructor(this, kind);
                  };
                };
                var TAG = NAME + ' Iterator';
                var DEF_VALUES = DEFAULT == VALUES;
                var VALUES_BUG = false;
                var proto = Base.prototype;
                var $native = proto[ITERATOR] || proto[FF_ITERATOR] || (DEFAULT && proto[DEFAULT]);
                var $default = $native || getMethod(DEFAULT);
                var $entries = DEFAULT ? (!DEF_VALUES ? $default : getMethod('entries')) : undefined;
                var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
                var methods, key, IteratorPrototype;
                // Fix native
                if ($anyNative) {
                  IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
                  if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
                    // Set @@toStringTag to native iterators
                    setToStringTag(IteratorPrototype, TAG, true);
                    // fix for some old engines
                    if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
                  }
                }
                // fix Array#{values, @@iterator}.name in V8 / FF
                if (DEF_VALUES && $native && $native.name !== VALUES) {
                  VALUES_BUG = true;
                  $default = function values() {
                    return $native.call(this);
                  };
                }
                // Define iterator
                if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
                  hide(proto, ITERATOR, $default);
                }
                // Plug for library
                Iterators[NAME] = $default;
                Iterators[TAG] = returnThis;
                if (DEFAULT) {
                  methods = {
                    values: DEF_VALUES ? $default : getMethod(VALUES),
                    keys: IS_SET ? $default : getMethod(KEYS),
                    entries: $entries
                  };
                  if (FORCED)
                    for (key in methods) {
                      if (!(key in proto)) redefine(proto, key, methods[key]);
                    }
                  else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
                }
                return methods;
              };

              /***/
            },
            /* 66 */
            /***/ function (module, exports, __webpack_require__) {
              module.exports = __webpack_require__(10);

              /***/
            },
            /* 67 */
            /***/ function (module, exports, __webpack_require__) {
              var has = __webpack_require__(13);
              var toIObject = __webpack_require__(12);
              var arrayIndexOf = __webpack_require__(119)(false);
              var IE_PROTO = __webpack_require__(45)('IE_PROTO');

              module.exports = function (object, names) {
                var O = toIObject(object);
                var i = 0;
                var result = [];
                var key;
                for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
                // Don't enum bug & hidden keys
                while (names.length > i)
                  if (has(O, (key = names[i++]))) {
                    ~arrayIndexOf(result, key) || result.push(key);
                  }
                return result;
              };

              /***/
            },
            /* 68 */
            /***/ function (module, exports, __webpack_require__) {
              // 7.1.15 ToLength
              var toInteger = __webpack_require__(44);
              var min = Math.min;
              module.exports = function (it) {
                return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
              };

              /***/
            },
            /* 69 */
            /***/ function (module, exports, __webpack_require__) {
              var document = __webpack_require__(3).document;
              module.exports = document && document.documentElement;

              /***/
            },
            /* 70 */
            /***/ function (module, exports, __webpack_require__) {
              // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
              var has = __webpack_require__(13);
              var toObject = __webpack_require__(34);
              var IE_PROTO = __webpack_require__(45)('IE_PROTO');
              var ObjectProto = Object.prototype;

              module.exports =
                Object.getPrototypeOf ||
                function (O) {
                  O = toObject(O);
                  if (has(O, IE_PROTO)) return O[IE_PROTO];
                  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
                    return O.constructor.prototype;
                  }
                  return O instanceof Object ? ObjectProto : null;
                };

              /***/
            },
            /* 71 */
            /***/ function (module, exports, __webpack_require__) {
              var classof = __webpack_require__(72);
              var ITERATOR = __webpack_require__(4)('iterator');
              var Iterators = __webpack_require__(24);
              module.exports = __webpack_require__(2).getIteratorMethod = function (it) {
                if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
              };

              /***/
            },
            /* 72 */
            /***/ function (module, exports, __webpack_require__) {
              // getting tag from 19.1.3.6 Object.prototype.toString()
              var cof = __webpack_require__(25);
              var TAG = __webpack_require__(4)('toStringTag');
              // ES3 wrong here
              var ARG =
                cof(
                  (function () {
                    return arguments;
                  })()
                ) == 'Arguments';

              // fallback for IE11 Script Access Denied error
              var tryGet = function (it, key) {
                try {
                  return it[key];
                } catch (e) {
                  /* empty */
                }
              };

              module.exports = function (it) {
                var O, T, B;
                return it === undefined
                  ? 'Undefined'
                  : it === null
                    ? 'Null'
                    : // @@toStringTag case
                      typeof (T = tryGet((O = Object(it)), TAG)) == 'string'
                      ? T
                      : // builtinTag case
                        ARG
                        ? cof(O)
                        : // ES3 arguments fallback
                          (B = cof(O)) == 'Object' && typeof O.callee == 'function'
                          ? 'Arguments'
                          : B;
              };

              /***/
            },
            /* 73 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ =
                __webpack_require__(1);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);

              /** @ignore */
              var map = {
                0: 'DEBUG',
                1: 'INFO',
                2: 'WARN',
                3: 'ERROR',
                4: 'FATAL'
              };

              /**
               * Encapsulates logging levels
               */

              var LogLevel = (function () {
                function LogLevel() {
                  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LogLevel);
                }

                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(LogLevel, [
                  {
                    key: 'getMap',

                    /**
                     * Get a map of availble logging levels.
                     * @return {Object<Number, String>}
                     */
                    value: function getMap() {
                      return map;
                    }

                    /**
                     * Get level name by level identifier.
                     * @param {String}	level
                     * @return {Number}
                     */
                  },
                  {
                    key: 'levelToString',
                    value: function levelToString(level) {
                      return map[level];
                    }

                    /**
                     * Get level identifier by level name.
                     * @param {String}	level
                     * @return {Number}
                     */
                  },
                  {
                    key: 'stringToLevel',
                    value: function stringToLevel(str) {
                      for (var _key in map) {
                        if (map[_key] == str) {
                          return _key;
                        }
                      }
                      return null;
                    }
                  }
                ]);

                return LogLevel;
              })();

              for (var key in map) {
                LogLevel.prototype[map[key]] = key;
              }

              /** Instance of LogLevel */
              /* harmony default export */ __webpack_exports__['a'] = new LogLevel();

              /***/
            },
            /* 74 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ =
                __webpack_require__(1);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);

              /**
               * Abtstract class representing an object which can log debug messages.
               * Can be attached to a Log with addLogger().
               */
              var Logger = (function () {
                function Logger() {
                  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Logger);

                  this.logPrefix = '';
                }

                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Logger, [
                  {
                    key: 'setLogPrefix',
                    value: function setLogPrefix(prefix) {
                      this.logPrefix = prefix;
                    }

                    /**
                     * Logs a message to the console
                     * @param {type}	level - Logging level
                     * @param {type}	tag - Logging tag
                     * @param {type}	text - Text to log
                     */
                  },
                  {
                    key: 'send',
                    value: function send(level, tag, text) {
                      throw new Error('Logger should implement send()');
                    }

                    /**
                     * Log an object.
                     * @param {type}	level - Logging level
                     * @param {type}	tag - Logging tag
                     * @param {type}	text - Logging text
                     * @param {type}	object - Object to be logged
                     */
                  },
                  {
                    key: 'sendObject',
                    value: function sendObject(level, tag, text, object) {
                      throw new Error('Logger should implement sendObject()');
                    }
                  }
                ]);

                return Logger;
              })();

              /* harmony default export */ __webpack_exports__['a'] = Logger;

              /***/
            },
            /* 75 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ =
                __webpack_require__(14);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ =
                __webpack_require__(1);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ =
                __webpack_require__(15);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ =
                __webpack_require__(16);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logLevel_js__ = __webpack_require__(73);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Logger__ = __webpack_require__(74);

              /**
               * Basic logger that logs to the environment console.
               */

              var ConsoleLogger = (function (_Logger) {
                __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ConsoleLogger, _Logger);

                /**
                 * Create a new ConsoleLogger.
                 */
                function ConsoleLogger() {
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ConsoleLogger);

                  /** @type {Number} */
                  var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(
                    this,
                    (
                      ConsoleLogger.__proto__ ||
                      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(
                        ConsoleLogger
                      )
                    ).call(this)
                  );

                  _this.level = __WEBPACK_IMPORTED_MODULE_5__logLevel_js__['a' /* default */].DEBUG;
                  /** @type {Boolean} */
                  _this.useFancyStyling = _this._canUseFancyStyling();
                  return _this;
                }

                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ConsoleLogger, [
                  {
                    key: '_canUseFancyStyling',
                    value: function _canUseFancyStyling() {
                      var browser = {};
                      browser.isFirefox = /firefox/i.test(navigator.userAgent);
                      browser.isIE = document.documentMode;

                      var support = {};
                      support.consoleApply = !browser.isIE || (document.documentMode && document.documentMode > 9);
                      support.functionGetters = support.consoleApply;
                      support.console = !!window.console;
                      support.modifiedConsole =
                        !browser.isIE && support.console && console.log.toString().indexOf('apply') !== -1;
                      support.consoleStyles = !!window.chrome || !!browser.isFirefox;
                      support.consoleGroups = !!(window.console && console.group);
                      return support.consoleStyles;
                    }

                    /**
                     * Sets current logging level. Messages below this log level will be ignored.
                     * @param {Number}	level
                     */
                  },
                  {
                    key: 'setLogLevel',
                    value: function setLogLevel(level) {
                      this.level = level;
                    }

                    /**
                     * Logs a message to the console
                     * @param {type}	level - Logging level
                     * @param {type}	tag - Logging tag
                     * @param {type}	text - Text to log
                     */
                  },
                  {
                    key: 'send',
                    value: function send(level, tag, text) {
                      if (level < this.level) {
                        return;
                      }

                      var fn = console.log;
                      if (
                        (console.error &&
                          level == __WEBPACK_IMPORTED_MODULE_5__logLevel_js__['a' /* default */].ERROR) ||
                        (console.error && level == __WEBPACK_IMPORTED_MODULE_5__logLevel_js__['a' /* default */].FATAL)
                      ) {
                        fn = console.error;
                      }
                      if (console.warn && level == __WEBPACK_IMPORTED_MODULE_5__logLevel_js__['a' /* default */].WARN) {
                        fn = console.warn;
                      }
                      if (console.info && level == __WEBPACK_IMPORTED_MODULE_5__logLevel_js__['a' /* default */].INFO) {
                        fn = console.info;
                      }
                      if (
                        console.debug &&
                        level == __WEBPACK_IMPORTED_MODULE_5__logLevel_js__['a' /* default */].DEBUG
                      ) {
                        fn = console.debug;
                      }
                      // Binding back to console because iOS Safari is weird
                      if (this.useFancyStyling) {
                        var str =
                          '%c' +
                          this.logPrefix +
                          '%c' +
                          __WEBPACK_IMPORTED_MODULE_5__logLevel_js__['a' /* default */].levelToString(level);
                        str += '%c %c' + tag + '%c' + text;
                        var levelColor = {
                          DEBUG: '#454F5B; color: white;',
                          INFO: '#007ACE; color: white;',
                          WARN: '#EEC200; color: white;',
                          ERROR: '#BF0711; color: white;',
                          FATAL: 'linear-gradient(to top, #EEC200 0, #BF0711 100%); color: white;'
                        }[__WEBPACK_IMPORTED_MODULE_5__logLevel_js__['a' /* default */].levelToString(level)];
                        var styles = [
                          'background: #202E78; border-top-left-radius: 4px; border-bottom-left-radius: 4px; padding: 0 8px;color: white',
                          'width: 55px; text-align: center; padding: 0 8px; border-bottom-right-radius: 4px; border-top-right-radius: 4px;background:' +
                            levelColor,
                          'padding: 0 2px;',
                          'background: #084E8A;padding:0 8px; color: white;border-radius: 8px;',
                          'padding:0 8px;'
                        ];

                        fn.bind(console).apply(undefined, [str].concat(styles));
                      } else {
                        fn.bind(console)(
                          '[' +
                            this.logPrefix +
                            '] ' +
                            __WEBPACK_IMPORTED_MODULE_5__logLevel_js__['a' /* default */].levelToString(level) +
                            ': ' +
                            '[' +
                            tag +
                            '] ' +
                            text
                        );
                      }
                    }

                    /**
                     * Log an object.
                     * @param {type}	level - Logging level
                     * @param {type}	tag - Logging tag
                     * @param {type}	text - Logging text
                     * @param {type}	object - Object to be logged
                     */
                  },
                  {
                    key: 'sendObject',
                    value: function sendObject(level, tag, text, object) {
                      if (level < this.level) {
                        return;
                      }

                      var fn = console.log;
                      if (
                        (console.error &&
                          level == __WEBPACK_IMPORTED_MODULE_5__logLevel_js__['a' /* default */].ERROR) ||
                        (console.error && level == __WEBPACK_IMPORTED_MODULE_5__logLevel_js__['a' /* default */].FATAL)
                      ) {
                        fn = console.error;
                      }
                      if (console.warn && level == __WEBPACK_IMPORTED_MODULE_5__logLevel_js__['a' /* default */].WARN) {
                        fn = console.warn;
                      }
                      if (console.info && level == __WEBPACK_IMPORTED_MODULE_5__logLevel_js__['a' /* default */].INFO) {
                        fn = console.info;
                      }
                      if (console.debug && level == this.DEBUG) {
                        fn = console.debug;
                      }
                      // Binding back to console because iOS Safari is weird
                      if (this.useFancyStyling) {
                        var str =
                          '%c' +
                          this.logPrefix +
                          '%c' +
                          __WEBPACK_IMPORTED_MODULE_5__logLevel_js__['a' /* default */].levelToString(level);
                        str += '%c %c' + tag + '%c' + text + ' %o';
                        var levelColor = {
                          DEBUG: '#454F5B; color: white;',
                          INFO: '#007ACE; color: white;',
                          WARN: '#EEC200; color: white;',
                          ERROR: '#BF0711; color: white;',
                          FATAL: 'linear-gradient(to top, #EEC200 0, #BF0711 100%); color: white;'
                        }[__WEBPACK_IMPORTED_MODULE_5__logLevel_js__['a' /* default */].levelToString(level)];
                        var styles = [
                          'background: #202E78; border-top-left-radius: 4px; border-bottom-left-radius: 4px; padding: 0 8px;color: white',
                          'width: 55px; text-align: center; padding: 0 8px; border-bottom-right-radius: 4px; border-top-right-radius: 4px;background:' +
                            levelColor,
                          'padding: 0 2px;',
                          'background: #084E8A;padding:1px 8px; color: white;border-radius: 8px;',
                          'padding-left: 8px;'
                        ];

                        fn.bind(console).apply(undefined, [str].concat(styles, [object]));
                      } else {
                        fn.bind(console)(
                          '[' +
                            this.logPrefix +
                            '] ' +
                            __WEBPACK_IMPORTED_MODULE_5__logLevel_js__['a' /* default */].levelToString(level) +
                            ': ' +
                            '[' +
                            tag +
                            '] ' +
                            text,
                          object
                        );
                      }
                    }
                  }
                ]);

                return ConsoleLogger;
              })(__WEBPACK_IMPORTED_MODULE_6__Logger__['a' /* default */]);

              /* harmony default export */ __webpack_exports__['a'] = ConsoleLogger;

              /***/
            },
            /* 76 */
            /***/ function (module, exports, __webpack_require__) {
              // most Object methods by ES6 should accept primitives
              var $export = __webpack_require__(6);
              var core = __webpack_require__(2);
              var fails = __webpack_require__(17);
              module.exports = function (KEY, exec) {
                var fn = (core.Object || {})[KEY] || Object[KEY];
                var exp = {};
                exp[KEY] = exec(fn);
                $export(
                  $export.S +
                    $export.F *
                      fails(function () {
                        fn(1);
                      }),
                  'Object',
                  exp
                );
              };

              /***/
            },
            /* 77 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              exports.__esModule = true;

              var _iterator = __webpack_require__(125);

              var _iterator2 = _interopRequireDefault(_iterator);

              var _symbol = __webpack_require__(127);

              var _symbol2 = _interopRequireDefault(_symbol);

              var _typeof =
                typeof _symbol2.default === 'function' && typeof _iterator2.default === 'symbol'
                  ? function (obj) {
                      return typeof obj;
                    }
                  : function (obj) {
                      return obj &&
                        typeof _symbol2.default === 'function' &&
                        obj.constructor === _symbol2.default &&
                        obj !== _symbol2.default.prototype
                        ? 'symbol'
                        : typeof obj;
                    };

              function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : { default: obj };
              }

              exports.default =
                typeof _symbol2.default === 'function' && _typeof(_iterator2.default) === 'symbol'
                  ? function (obj) {
                      return typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
                    }
                  : function (obj) {
                      return obj &&
                        typeof _symbol2.default === 'function' &&
                        obj.constructor === _symbol2.default &&
                        obj !== _symbol2.default.prototype
                        ? 'symbol'
                        : typeof obj === 'undefined'
                          ? 'undefined'
                          : _typeof(obj);
                    };

              /***/
            },
            /* 78 */
            /***/ function (module, exports, __webpack_require__) {
              // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
              var $keys = __webpack_require__(67);
              var hiddenKeys = __webpack_require__(47).concat('length', 'prototype');

              exports.f =
                Object.getOwnPropertyNames ||
                function getOwnPropertyNames(O) {
                  return $keys(O, hiddenKeys);
                };

              /***/
            },
            /* 79 */
            /***/ function (module, exports, __webpack_require__) {
              var pIE = __webpack_require__(26);
              var createDesc = __webpack_require__(30);
              var toIObject = __webpack_require__(12);
              var toPrimitive = __webpack_require__(39);
              var has = __webpack_require__(13);
              var IE8_DOM_DEFINE = __webpack_require__(62);
              var gOPD = Object.getOwnPropertyDescriptor;

              exports.f = __webpack_require__(9)
                ? gOPD
                : function getOwnPropertyDescriptor(O, P) {
                    O = toIObject(O);
                    P = toPrimitive(P, true);
                    if (IE8_DOM_DEFINE)
                      try {
                        return gOPD(O, P);
                      } catch (e) {
                        /* empty */
                      }
                    if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
                  };

              /***/
            },
            /* 80 */
            /***/ function (module, exports) {
              /***/
            },
            /* 81 */
            /***/ function (module, exports, __webpack_require__) {
              module.exports = { default: __webpack_require__(145), __esModule: true };

              /***/
            },
            /* 82 */
            /***/ function (module, exports, __webpack_require__) {
              // 7.3.20 SpeciesConstructor(O, defaultConstructor)
              var anObject = __webpack_require__(7);
              var aFunction = __webpack_require__(29);
              var SPECIES = __webpack_require__(4)('species');
              module.exports = function (O, D) {
                var C = anObject(O).constructor;
                var S;
                return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
              };

              /***/
            },
            /* 83 */
            /***/ function (module, exports, __webpack_require__) {
              var ctx = __webpack_require__(23);
              var invoke = __webpack_require__(151);
              var html = __webpack_require__(69);
              var cel = __webpack_require__(38);
              var global = __webpack_require__(3);
              var process = global.process;
              var setTask = global.setImmediate;
              var clearTask = global.clearImmediate;
              var MessageChannel = global.MessageChannel;
              var Dispatch = global.Dispatch;
              var counter = 0;
              var queue = {};
              var ONREADYSTATECHANGE = 'onreadystatechange';
              var defer, channel, port;
              var run = function () {
                var id = +this;
                // eslint-disable-next-line no-prototype-builtins
                if (queue.hasOwnProperty(id)) {
                  var fn = queue[id];
                  delete queue[id];
                  fn();
                }
              };
              var listener = function (event) {
                run.call(event.data);
              };
              // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
              if (!setTask || !clearTask) {
                setTask = function setImmediate(fn) {
                  var args = [];
                  var i = 1;
                  while (arguments.length > i) args.push(arguments[i++]);
                  queue[++counter] = function () {
                    // eslint-disable-next-line no-new-func
                    invoke(typeof fn == 'function' ? fn : Function(fn), args);
                  };
                  defer(counter);
                  return counter;
                };
                clearTask = function clearImmediate(id) {
                  delete queue[id];
                };
                // Node.js 0.8-
                if (__webpack_require__(25)(process) == 'process') {
                  defer = function (id) {
                    process.nextTick(ctx(run, id, 1));
                  };
                  // Sphere (JS game engine) Dispatch API
                } else if (Dispatch && Dispatch.now) {
                  defer = function (id) {
                    Dispatch.now(ctx(run, id, 1));
                  };
                  // Browsers with MessageChannel, includes WebWorkers
                } else if (MessageChannel) {
                  channel = new MessageChannel();
                  port = channel.port2;
                  channel.port1.onmessage = listener;
                  defer = ctx(port.postMessage, port, 1);
                  // Browsers with postMessage, skip WebWorkers
                  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
                } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
                  defer = function (id) {
                    global.postMessage(id + '', '*');
                  };
                  global.addEventListener('message', listener, false);
                  // IE8-
                } else if (ONREADYSTATECHANGE in cel('script')) {
                  defer = function (id) {
                    html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
                      html.removeChild(this);
                      run.call(id);
                    };
                  };
                  // Rest old browsers
                } else {
                  defer = function (id) {
                    setTimeout(ctx(run, id, 1), 0);
                  };
                }
              }
              module.exports = {
                set: setTask,
                clear: clearTask
              };

              /***/
            },
            /* 84 */
            /***/ function (module, exports) {
              module.exports = function (exec) {
                try {
                  return { e: false, v: exec() };
                } catch (e) {
                  return { e: true, v: e };
                }
              };

              /***/
            },
            /* 85 */
            /***/ function (module, exports, __webpack_require__) {
              var anObject = __webpack_require__(7);
              var isObject = __webpack_require__(11);
              var newPromiseCapability = __webpack_require__(52);

              module.exports = function (C, x) {
                anObject(C);
                if (isObject(x) && x.constructor === C) return x;
                var promiseCapability = newPromiseCapability.f(C);
                var resolve = promiseCapability.resolve;
                resolve(x);
                return promiseCapability.promise;
              };

              /***/
            },
            /* 86 */
            /***/ function (module, exports, __webpack_require__) {
              /* WEBPACK VAR INJECTION */ (function (process) {
                module.exports = process.env.PROMISE_QUEUE_COVERAGE
                  ? __webpack_require__(163)
                  : __webpack_require__(164);

                /* WEBPACK VAR INJECTION */
              }).call(exports, __webpack_require__(36));

              /***/
            },
            /* 87 */
            /***/ function (module, exports, __webpack_require__) {
              var pSlice = Array.prototype.slice;
              var objectKeys = __webpack_require__(165);
              var isArguments = __webpack_require__(166);

              var deepEqual = (module.exports = function (actual, expected, opts) {
                if (!opts) opts = {};
                // 7.1. All identical values are equivalent, as determined by ===.
                if (actual === expected) {
                  return true;
                } else if (actual instanceof Date && expected instanceof Date) {
                  return actual.getTime() === expected.getTime();

                  // 7.3. Other pairs that do not both pass typeof value == 'object',
                  // equivalence is determined by ==.
                } else if (!actual || !expected || (typeof actual != 'object' && typeof expected != 'object')) {
                  return opts.strict ? actual === expected : actual == expected;

                  // 7.4. For all other Object pairs, including Array objects, equivalence is
                  // determined by having the same number of owned properties (as verified
                  // with Object.prototype.hasOwnProperty.call), the same set of keys
                  // (although not necessarily the same order), equivalent values for every
                  // corresponding key, and an identical 'prototype' property. Note: this
                  // accounts for both named and indexed properties on Arrays.
                } else {
                  return objEquiv(actual, expected, opts);
                }
              });

              function isUndefinedOrNull(value) {
                return value === null || value === undefined;
              }

              function isBuffer(x) {
                if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
                if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
                  return false;
                }
                if (x.length > 0 && typeof x[0] !== 'number') return false;
                return true;
              }

              function objEquiv(a, b, opts) {
                var i, key;
                if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) return false;
                // an identical 'prototype' property.
                if (a.prototype !== b.prototype) return false;
                //~~~I've managed to break Object.keys through screwy arguments passing.
                //   Converting to array solves the problem.
                if (isArguments(a)) {
                  if (!isArguments(b)) {
                    return false;
                  }
                  a = pSlice.call(a);
                  b = pSlice.call(b);
                  return deepEqual(a, b, opts);
                }
                if (isBuffer(a)) {
                  if (!isBuffer(b)) {
                    return false;
                  }
                  if (a.length !== b.length) return false;
                  for (i = 0; i < a.length; i++) {
                    if (a[i] !== b[i]) return false;
                  }
                  return true;
                }
                try {
                  var ka = objectKeys(a),
                    kb = objectKeys(b);
                } catch (e) {
                  //happens when one is a string literal and the other isn't
                  return false;
                }
                // having the same number of owned properties (keys incorporates
                // hasOwnProperty)
                if (ka.length != kb.length) return false;
                //the same set of keys (although not necessarily the same order),
                ka.sort();
                kb.sort();
                //~~~cheap key test
                for (i = ka.length - 1; i >= 0; i--) {
                  if (ka[i] != kb[i]) return false;
                }
                //equivalent values for every corresponding key, and
                //~~~possibly expensive deep test
                for (i = ka.length - 1; i >= 0; i--) {
                  key = ka[i];
                  if (!deepEqual(a[key], b[key], opts)) return false;
                }
                return typeof a === typeof b;
              }

              /***/
            },
            /* 88 */
            /***/ function (module, exports, __webpack_require__) {
              /* WEBPACK VAR INJECTION */ (function (global, module) {
                var __WEBPACK_AMD_DEFINE_RESULT__; /**
                 * @license
                 * Lodash <https://lodash.com/>
                 * Copyright JS Foundation and other contributors <https://js.foundation/>
                 * Released under MIT license <https://lodash.com/license>
                 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
                 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
                 */
                (function () {
                  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
                  var undefined;

                  /** Used as the semantic version number. */
                  var VERSION = '4.17.4';

                  /** Used as the size to enable large array optimizations. */
                  var LARGE_ARRAY_SIZE = 200;

                  /** Error message constants. */
                  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
                    FUNC_ERROR_TEXT = 'Expected a function';

                  /** Used to stand-in for `undefined` hash values. */
                  var HASH_UNDEFINED = '__lodash_hash_undefined__';

                  /** Used as the maximum memoize cache size. */
                  var MAX_MEMOIZE_SIZE = 500;

                  /** Used as the internal argument placeholder. */
                  var PLACEHOLDER = '__lodash_placeholder__';

                  /** Used to compose bitmasks for cloning. */
                  var CLONE_DEEP_FLAG = 1,
                    CLONE_FLAT_FLAG = 2,
                    CLONE_SYMBOLS_FLAG = 4;

                  /** Used to compose bitmasks for value comparisons. */
                  var COMPARE_PARTIAL_FLAG = 1,
                    COMPARE_UNORDERED_FLAG = 2;

                  /** Used to compose bitmasks for function metadata. */
                  var WRAP_BIND_FLAG = 1,
                    WRAP_BIND_KEY_FLAG = 2,
                    WRAP_CURRY_BOUND_FLAG = 4,
                    WRAP_CURRY_FLAG = 8,
                    WRAP_CURRY_RIGHT_FLAG = 16,
                    WRAP_PARTIAL_FLAG = 32,
                    WRAP_PARTIAL_RIGHT_FLAG = 64,
                    WRAP_ARY_FLAG = 128,
                    WRAP_REARG_FLAG = 256,
                    WRAP_FLIP_FLAG = 512;

                  /** Used as default options for `_.truncate`. */
                  var DEFAULT_TRUNC_LENGTH = 30,
                    DEFAULT_TRUNC_OMISSION = '...';

                  /** Used to detect hot functions by number of calls within a span of milliseconds. */
                  var HOT_COUNT = 800,
                    HOT_SPAN = 16;

                  /** Used to indicate the type of lazy iteratees. */
                  var LAZY_FILTER_FLAG = 1,
                    LAZY_MAP_FLAG = 2,
                    LAZY_WHILE_FLAG = 3;

                  /** Used as references for various `Number` constants. */
                  var INFINITY = 1 / 0,
                    MAX_SAFE_INTEGER = 9007199254740991,
                    MAX_INTEGER = 1.7976931348623157e308,
                    NAN = 0 / 0;

                  /** Used as references for the maximum length and index of an array. */
                  var MAX_ARRAY_LENGTH = 4294967295,
                    MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
                    HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

                  /** Used to associate wrap methods with their bit flags. */
                  var wrapFlags = [
                    ['ary', WRAP_ARY_FLAG],
                    ['bind', WRAP_BIND_FLAG],
                    ['bindKey', WRAP_BIND_KEY_FLAG],
                    ['curry', WRAP_CURRY_FLAG],
                    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
                    ['flip', WRAP_FLIP_FLAG],
                    ['partial', WRAP_PARTIAL_FLAG],
                    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
                    ['rearg', WRAP_REARG_FLAG]
                  ];

                  /** `Object#toString` result references. */
                  var argsTag = '[object Arguments]',
                    arrayTag = '[object Array]',
                    asyncTag = '[object AsyncFunction]',
                    boolTag = '[object Boolean]',
                    dateTag = '[object Date]',
                    domExcTag = '[object DOMException]',
                    errorTag = '[object Error]',
                    funcTag = '[object Function]',
                    genTag = '[object GeneratorFunction]',
                    mapTag = '[object Map]',
                    numberTag = '[object Number]',
                    nullTag = '[object Null]',
                    objectTag = '[object Object]',
                    promiseTag = '[object Promise]',
                    proxyTag = '[object Proxy]',
                    regexpTag = '[object RegExp]',
                    setTag = '[object Set]',
                    stringTag = '[object String]',
                    symbolTag = '[object Symbol]',
                    undefinedTag = '[object Undefined]',
                    weakMapTag = '[object WeakMap]',
                    weakSetTag = '[object WeakSet]';

                  var arrayBufferTag = '[object ArrayBuffer]',
                    dataViewTag = '[object DataView]',
                    float32Tag = '[object Float32Array]',
                    float64Tag = '[object Float64Array]',
                    int8Tag = '[object Int8Array]',
                    int16Tag = '[object Int16Array]',
                    int32Tag = '[object Int32Array]',
                    uint8Tag = '[object Uint8Array]',
                    uint8ClampedTag = '[object Uint8ClampedArray]',
                    uint16Tag = '[object Uint16Array]',
                    uint32Tag = '[object Uint32Array]';

                  /** Used to match empty string literals in compiled template source. */
                  var reEmptyStringLeading = /\b__p \+= '';/g,
                    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
                    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

                  /** Used to match HTML entities and HTML characters. */
                  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
                    reUnescapedHtml = /[&<>"']/g,
                    reHasEscapedHtml = RegExp(reEscapedHtml.source),
                    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

                  /** Used to match template delimiters. */
                  var reEscape = /<%-([\s\S]+?)%>/g,
                    reEvaluate = /<%([\s\S]+?)%>/g,
                    reInterpolate = /<%=([\s\S]+?)%>/g;

                  /** Used to match property names within property paths. */
                  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
                    reIsPlainProp = /^\w*$/,
                    reLeadingDot = /^\./,
                    rePropName =
                      /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

                  /**
                   * Used to match `RegExp`
                   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
                   */
                  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
                    reHasRegExpChar = RegExp(reRegExpChar.source);

                  /** Used to match leading and trailing whitespace. */
                  var reTrim = /^\s+|\s+$/g,
                    reTrimStart = /^\s+/,
                    reTrimEnd = /\s+$/;

                  /** Used to match wrap detail comments. */
                  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
                    reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
                    reSplitDetails = /,? & /;

                  /** Used to match words composed of alphanumeric characters. */
                  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

                  /** Used to match backslashes in property paths. */
                  var reEscapeChar = /\\(\\)?/g;

                  /**
                   * Used to match
                   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
                   */
                  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

                  /** Used to match `RegExp` flags from their coerced string values. */
                  var reFlags = /\w*$/;

                  /** Used to detect bad signed hexadecimal string values. */
                  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

                  /** Used to detect binary string values. */
                  var reIsBinary = /^0b[01]+$/i;

                  /** Used to detect host constructors (Safari). */
                  var reIsHostCtor = /^\[object .+?Constructor\]$/;

                  /** Used to detect octal string values. */
                  var reIsOctal = /^0o[0-7]+$/i;

                  /** Used to detect unsigned integer values. */
                  var reIsUint = /^(?:0|[1-9]\d*)$/;

                  /** Used to match Latin Unicode letters (excluding mathematical operators). */
                  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

                  /** Used to ensure capturing order of template delimiters. */
                  var reNoMatch = /($^)/;

                  /** Used to match unescaped characters in compiled string literals. */
                  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

                  /** Used to compose unicode character classes. */
                  var rsAstralRange = '\\ud800-\\udfff',
                    rsComboMarksRange = '\\u0300-\\u036f',
                    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
                    rsComboSymbolsRange = '\\u20d0-\\u20ff',
                    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
                    rsDingbatRange = '\\u2700-\\u27bf',
                    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
                    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
                    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
                    rsPunctuationRange = '\\u2000-\\u206f',
                    rsSpaceRange =
                      ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
                    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
                    rsVarRange = '\\ufe0e\\ufe0f',
                    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

                  /** Used to compose unicode capture groups. */
                  var rsApos = "['\u2019]",
                    rsAstral = '[' + rsAstralRange + ']',
                    rsBreak = '[' + rsBreakRange + ']',
                    rsCombo = '[' + rsComboRange + ']',
                    rsDigits = '\\d+',
                    rsDingbat = '[' + rsDingbatRange + ']',
                    rsLower = '[' + rsLowerRange + ']',
                    rsMisc =
                      '[^' +
                      rsAstralRange +
                      rsBreakRange +
                      rsDigits +
                      rsDingbatRange +
                      rsLowerRange +
                      rsUpperRange +
                      ']',
                    rsFitz = '\\ud83c[\\udffb-\\udfff]',
                    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
                    rsNonAstral = '[^' + rsAstralRange + ']',
                    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
                    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
                    rsUpper = '[' + rsUpperRange + ']',
                    rsZWJ = '\\u200d';

                  /** Used to compose unicode regexes. */
                  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
                    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
                    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
                    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
                    reOptMod = rsModifier + '?',
                    rsOptVar = '[' + rsVarRange + ']?',
                    rsOptJoin =
                      '(?:' +
                      rsZWJ +
                      '(?:' +
                      [rsNonAstral, rsRegional, rsSurrPair].join('|') +
                      ')' +
                      rsOptVar +
                      reOptMod +
                      ')*',
                    rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
                    rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
                    rsSeq = rsOptVar + reOptMod + rsOptJoin,
                    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
                    rsSymbol =
                      '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

                  /** Used to match apostrophes. */
                  var reApos = RegExp(rsApos, 'g');

                  /**
                   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
                   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
                   */
                  var reComboMark = RegExp(rsCombo, 'g');

                  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
                  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

                  /** Used to match complex or compound words. */
                  var reUnicodeWord = RegExp(
                    [
                      rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
                      rsMiscUpper +
                        '+' +
                        rsOptContrUpper +
                        '(?=' +
                        [rsBreak, rsUpper + rsMiscLower, '$'].join('|') +
                        ')',
                      rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
                      rsUpper + '+' + rsOptContrUpper,
                      rsOrdUpper,
                      rsOrdLower,
                      rsDigits,
                      rsEmoji
                    ].join('|'),
                    'g'
                  );

                  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
                  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');

                  /** Used to detect strings that need a more robust regexp to match words. */
                  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

                  /** Used to assign default `context` object properties. */
                  var contextProps = [
                    'Array',
                    'Buffer',
                    'DataView',
                    'Date',
                    'Error',
                    'Float32Array',
                    'Float64Array',
                    'Function',
                    'Int8Array',
                    'Int16Array',
                    'Int32Array',
                    'Map',
                    'Math',
                    'Object',
                    'Promise',
                    'RegExp',
                    'Set',
                    'String',
                    'Symbol',
                    'TypeError',
                    'Uint8Array',
                    'Uint8ClampedArray',
                    'Uint16Array',
                    'Uint32Array',
                    'WeakMap',
                    '_',
                    'clearTimeout',
                    'isFinite',
                    'parseInt',
                    'setTimeout'
                  ];

                  /** Used to make template sourceURLs easier to identify. */
                  var templateCounter = -1;

                  /** Used to identify `toStringTag` values of typed arrays. */
                  var typedArrayTags = {};
                  typedArrayTags[float32Tag] =
                    typedArrayTags[float64Tag] =
                    typedArrayTags[int8Tag] =
                    typedArrayTags[int16Tag] =
                    typedArrayTags[int32Tag] =
                    typedArrayTags[uint8Tag] =
                    typedArrayTags[uint8ClampedTag] =
                    typedArrayTags[uint16Tag] =
                    typedArrayTags[uint32Tag] =
                      true;
                  typedArrayTags[argsTag] =
                    typedArrayTags[arrayTag] =
                    typedArrayTags[arrayBufferTag] =
                    typedArrayTags[boolTag] =
                    typedArrayTags[dataViewTag] =
                    typedArrayTags[dateTag] =
                    typedArrayTags[errorTag] =
                    typedArrayTags[funcTag] =
                    typedArrayTags[mapTag] =
                    typedArrayTags[numberTag] =
                    typedArrayTags[objectTag] =
                    typedArrayTags[regexpTag] =
                    typedArrayTags[setTag] =
                    typedArrayTags[stringTag] =
                    typedArrayTags[weakMapTag] =
                      false;

                  /** Used to identify `toStringTag` values supported by `_.clone`. */
                  var cloneableTags = {};
                  cloneableTags[argsTag] =
                    cloneableTags[arrayTag] =
                    cloneableTags[arrayBufferTag] =
                    cloneableTags[dataViewTag] =
                    cloneableTags[boolTag] =
                    cloneableTags[dateTag] =
                    cloneableTags[float32Tag] =
                    cloneableTags[float64Tag] =
                    cloneableTags[int8Tag] =
                    cloneableTags[int16Tag] =
                    cloneableTags[int32Tag] =
                    cloneableTags[mapTag] =
                    cloneableTags[numberTag] =
                    cloneableTags[objectTag] =
                    cloneableTags[regexpTag] =
                    cloneableTags[setTag] =
                    cloneableTags[stringTag] =
                    cloneableTags[symbolTag] =
                    cloneableTags[uint8Tag] =
                    cloneableTags[uint8ClampedTag] =
                    cloneableTags[uint16Tag] =
                    cloneableTags[uint32Tag] =
                      true;
                  cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;

                  /** Used to map Latin Unicode letters to basic Latin letters. */
                  var deburredLetters = {
                    // Latin-1 Supplement block.
                    '\xc0': 'A',
                    '\xc1': 'A',
                    '\xc2': 'A',
                    '\xc3': 'A',
                    '\xc4': 'A',
                    '\xc5': 'A',
                    '\xe0': 'a',
                    '\xe1': 'a',
                    '\xe2': 'a',
                    '\xe3': 'a',
                    '\xe4': 'a',
                    '\xe5': 'a',
                    '\xc7': 'C',
                    '\xe7': 'c',
                    '\xd0': 'D',
                    '\xf0': 'd',
                    '\xc8': 'E',
                    '\xc9': 'E',
                    '\xca': 'E',
                    '\xcb': 'E',
                    '\xe8': 'e',
                    '\xe9': 'e',
                    '\xea': 'e',
                    '\xeb': 'e',
                    '\xcc': 'I',
                    '\xcd': 'I',
                    '\xce': 'I',
                    '\xcf': 'I',
                    '\xec': 'i',
                    '\xed': 'i',
                    '\xee': 'i',
                    '\xef': 'i',
                    '\xd1': 'N',
                    '\xf1': 'n',
                    '\xd2': 'O',
                    '\xd3': 'O',
                    '\xd4': 'O',
                    '\xd5': 'O',
                    '\xd6': 'O',
                    '\xd8': 'O',
                    '\xf2': 'o',
                    '\xf3': 'o',
                    '\xf4': 'o',
                    '\xf5': 'o',
                    '\xf6': 'o',
                    '\xf8': 'o',
                    '\xd9': 'U',
                    '\xda': 'U',
                    '\xdb': 'U',
                    '\xdc': 'U',
                    '\xf9': 'u',
                    '\xfa': 'u',
                    '\xfb': 'u',
                    '\xfc': 'u',
                    '\xdd': 'Y',
                    '\xfd': 'y',
                    '\xff': 'y',
                    '\xc6': 'Ae',
                    '\xe6': 'ae',
                    '\xde': 'Th',
                    '\xfe': 'th',
                    '\xdf': 'ss',
                    // Latin Extended-A block.
                    '\u0100': 'A',
                    '\u0102': 'A',
                    '\u0104': 'A',
                    '\u0101': 'a',
                    '\u0103': 'a',
                    '\u0105': 'a',
                    '\u0106': 'C',
                    '\u0108': 'C',
                    '\u010a': 'C',
                    '\u010c': 'C',
                    '\u0107': 'c',
                    '\u0109': 'c',
                    '\u010b': 'c',
                    '\u010d': 'c',
                    '\u010e': 'D',
                    '\u0110': 'D',
                    '\u010f': 'd',
                    '\u0111': 'd',
                    '\u0112': 'E',
                    '\u0114': 'E',
                    '\u0116': 'E',
                    '\u0118': 'E',
                    '\u011a': 'E',
                    '\u0113': 'e',
                    '\u0115': 'e',
                    '\u0117': 'e',
                    '\u0119': 'e',
                    '\u011b': 'e',
                    '\u011c': 'G',
                    '\u011e': 'G',
                    '\u0120': 'G',
                    '\u0122': 'G',
                    '\u011d': 'g',
                    '\u011f': 'g',
                    '\u0121': 'g',
                    '\u0123': 'g',
                    '\u0124': 'H',
                    '\u0126': 'H',
                    '\u0125': 'h',
                    '\u0127': 'h',
                    '\u0128': 'I',
                    '\u012a': 'I',
                    '\u012c': 'I',
                    '\u012e': 'I',
                    '\u0130': 'I',
                    '\u0129': 'i',
                    '\u012b': 'i',
                    '\u012d': 'i',
                    '\u012f': 'i',
                    '\u0131': 'i',
                    '\u0134': 'J',
                    '\u0135': 'j',
                    '\u0136': 'K',
                    '\u0137': 'k',
                    '\u0138': 'k',
                    '\u0139': 'L',
                    '\u013b': 'L',
                    '\u013d': 'L',
                    '\u013f': 'L',
                    '\u0141': 'L',
                    '\u013a': 'l',
                    '\u013c': 'l',
                    '\u013e': 'l',
                    '\u0140': 'l',
                    '\u0142': 'l',
                    '\u0143': 'N',
                    '\u0145': 'N',
                    '\u0147': 'N',
                    '\u014a': 'N',
                    '\u0144': 'n',
                    '\u0146': 'n',
                    '\u0148': 'n',
                    '\u014b': 'n',
                    '\u014c': 'O',
                    '\u014e': 'O',
                    '\u0150': 'O',
                    '\u014d': 'o',
                    '\u014f': 'o',
                    '\u0151': 'o',
                    '\u0154': 'R',
                    '\u0156': 'R',
                    '\u0158': 'R',
                    '\u0155': 'r',
                    '\u0157': 'r',
                    '\u0159': 'r',
                    '\u015a': 'S',
                    '\u015c': 'S',
                    '\u015e': 'S',
                    '\u0160': 'S',
                    '\u015b': 's',
                    '\u015d': 's',
                    '\u015f': 's',
                    '\u0161': 's',
                    '\u0162': 'T',
                    '\u0164': 'T',
                    '\u0166': 'T',
                    '\u0163': 't',
                    '\u0165': 't',
                    '\u0167': 't',
                    '\u0168': 'U',
                    '\u016a': 'U',
                    '\u016c': 'U',
                    '\u016e': 'U',
                    '\u0170': 'U',
                    '\u0172': 'U',
                    '\u0169': 'u',
                    '\u016b': 'u',
                    '\u016d': 'u',
                    '\u016f': 'u',
                    '\u0171': 'u',
                    '\u0173': 'u',
                    '\u0174': 'W',
                    '\u0175': 'w',
                    '\u0176': 'Y',
                    '\u0177': 'y',
                    '\u0178': 'Y',
                    '\u0179': 'Z',
                    '\u017b': 'Z',
                    '\u017d': 'Z',
                    '\u017a': 'z',
                    '\u017c': 'z',
                    '\u017e': 'z',
                    '\u0132': 'IJ',
                    '\u0133': 'ij',
                    '\u0152': 'Oe',
                    '\u0153': 'oe',
                    '\u0149': "'n",
                    '\u017f': 's'
                  };

                  /** Used to map characters to HTML entities. */
                  var htmlEscapes = {
                    '&': '&amp;',
                    '<': '&lt;',
                    '>': '&gt;',
                    '"': '&quot;',
                    "'": '&#39;'
                  };

                  /** Used to map HTML entities to characters. */
                  var htmlUnescapes = {
                    '&amp;': '&',
                    '&lt;': '<',
                    '&gt;': '>',
                    '&quot;': '"',
                    '&#39;': "'"
                  };

                  /** Used to escape characters for inclusion in compiled string literals. */
                  var stringEscapes = {
                    '\\': '\\',
                    "'": "'",
                    '\n': 'n',
                    '\r': 'r',
                    '\u2028': 'u2028',
                    '\u2029': 'u2029'
                  };

                  /** Built-in method references without a dependency on `root`. */
                  var freeParseFloat = parseFloat,
                    freeParseInt = parseInt;

                  /** Detect free variable `global` from Node.js. */
                  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

                  /** Detect free variable `self`. */
                  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

                  /** Used as a reference to the global object. */
                  var root = freeGlobal || freeSelf || Function('return this')();

                  /** Detect free variable `exports`. */
                  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

                  /** Detect free variable `module`. */
                  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

                  /** Detect the popular CommonJS extension `module.exports`. */
                  var moduleExports = freeModule && freeModule.exports === freeExports;

                  /** Detect free variable `process` from Node.js. */
                  var freeProcess = moduleExports && freeGlobal.process;

                  /** Used to access faster Node.js helpers. */
                  var nodeUtil = (function () {
                    try {
                      return freeProcess && freeProcess.binding && freeProcess.binding('util');
                    } catch (e) {}
                  })();

                  /* Node.js helper references. */
                  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
                    nodeIsDate = nodeUtil && nodeUtil.isDate,
                    nodeIsMap = nodeUtil && nodeUtil.isMap,
                    nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
                    nodeIsSet = nodeUtil && nodeUtil.isSet,
                    nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

                  /*--------------------------------------------------------------------------*/

                  /**
                   * Adds the key-value `pair` to `map`.
                   *
                   * @private
                   * @param {Object} map The map to modify.
                   * @param {Array} pair The key-value pair to add.
                   * @returns {Object} Returns `map`.
                   */
                  function addMapEntry(map, pair) {
                    // Don't return `map.set` because it's not chainable in IE 11.
                    map.set(pair[0], pair[1]);
                    return map;
                  }

                  /**
                   * Adds `value` to `set`.
                   *
                   * @private
                   * @param {Object} set The set to modify.
                   * @param {*} value The value to add.
                   * @returns {Object} Returns `set`.
                   */
                  function addSetEntry(set, value) {
                    // Don't return `set.add` because it's not chainable in IE 11.
                    set.add(value);
                    return set;
                  }

                  /**
                   * A faster alternative to `Function#apply`, this function invokes `func`
                   * with the `this` binding of `thisArg` and the arguments of `args`.
                   *
                   * @private
                   * @param {Function} func The function to invoke.
                   * @param {*} thisArg The `this` binding of `func`.
                   * @param {Array} args The arguments to invoke `func` with.
                   * @returns {*} Returns the result of `func`.
                   */
                  function apply(func, thisArg, args) {
                    switch (args.length) {
                      case 0:
                        return func.call(thisArg);
                      case 1:
                        return func.call(thisArg, args[0]);
                      case 2:
                        return func.call(thisArg, args[0], args[1]);
                      case 3:
                        return func.call(thisArg, args[0], args[1], args[2]);
                    }
                    return func.apply(thisArg, args);
                  }

                  /**
                   * A specialized version of `baseAggregator` for arrays.
                   *
                   * @private
                   * @param {Array} [array] The array to iterate over.
                   * @param {Function} setter The function to set `accumulator` values.
                   * @param {Function} iteratee The iteratee to transform keys.
                   * @param {Object} accumulator The initial aggregated object.
                   * @returns {Function} Returns `accumulator`.
                   */
                  function arrayAggregator(array, setter, iteratee, accumulator) {
                    var index = -1,
                      length = array == null ? 0 : array.length;

                    while (++index < length) {
                      var value = array[index];
                      setter(accumulator, value, iteratee(value), array);
                    }
                    return accumulator;
                  }

                  /**
                   * A specialized version of `_.forEach` for arrays without support for
                   * iteratee shorthands.
                   *
                   * @private
                   * @param {Array} [array] The array to iterate over.
                   * @param {Function} iteratee The function invoked per iteration.
                   * @returns {Array} Returns `array`.
                   */
                  function arrayEach(array, iteratee) {
                    var index = -1,
                      length = array == null ? 0 : array.length;

                    while (++index < length) {
                      if (iteratee(array[index], index, array) === false) {
                        break;
                      }
                    }
                    return array;
                  }

                  /**
                   * A specialized version of `_.forEachRight` for arrays without support for
                   * iteratee shorthands.
                   *
                   * @private
                   * @param {Array} [array] The array to iterate over.
                   * @param {Function} iteratee The function invoked per iteration.
                   * @returns {Array} Returns `array`.
                   */
                  function arrayEachRight(array, iteratee) {
                    var length = array == null ? 0 : array.length;

                    while (length--) {
                      if (iteratee(array[length], length, array) === false) {
                        break;
                      }
                    }
                    return array;
                  }

                  /**
                   * A specialized version of `_.every` for arrays without support for
                   * iteratee shorthands.
                   *
                   * @private
                   * @param {Array} [array] The array to iterate over.
                   * @param {Function} predicate The function invoked per iteration.
                   * @returns {boolean} Returns `true` if all elements pass the predicate check,
                   *  else `false`.
                   */
                  function arrayEvery(array, predicate) {
                    var index = -1,
                      length = array == null ? 0 : array.length;

                    while (++index < length) {
                      if (!predicate(array[index], index, array)) {
                        return false;
                      }
                    }
                    return true;
                  }

                  /**
                   * A specialized version of `_.filter` for arrays without support for
                   * iteratee shorthands.
                   *
                   * @private
                   * @param {Array} [array] The array to iterate over.
                   * @param {Function} predicate The function invoked per iteration.
                   * @returns {Array} Returns the new filtered array.
                   */
                  function arrayFilter(array, predicate) {
                    var index = -1,
                      length = array == null ? 0 : array.length,
                      resIndex = 0,
                      result = [];

                    while (++index < length) {
                      var value = array[index];
                      if (predicate(value, index, array)) {
                        result[resIndex++] = value;
                      }
                    }
                    return result;
                  }

                  /**
                   * A specialized version of `_.includes` for arrays without support for
                   * specifying an index to search from.
                   *
                   * @private
                   * @param {Array} [array] The array to inspect.
                   * @param {*} target The value to search for.
                   * @returns {boolean} Returns `true` if `target` is found, else `false`.
                   */
                  function arrayIncludes(array, value) {
                    var length = array == null ? 0 : array.length;
                    return !!length && baseIndexOf(array, value, 0) > -1;
                  }

                  /**
                   * This function is like `arrayIncludes` except that it accepts a comparator.
                   *
                   * @private
                   * @param {Array} [array] The array to inspect.
                   * @param {*} target The value to search for.
                   * @param {Function} comparator The comparator invoked per element.
                   * @returns {boolean} Returns `true` if `target` is found, else `false`.
                   */
                  function arrayIncludesWith(array, value, comparator) {
                    var index = -1,
                      length = array == null ? 0 : array.length;

                    while (++index < length) {
                      if (comparator(value, array[index])) {
                        return true;
                      }
                    }
                    return false;
                  }

                  /**
                   * A specialized version of `_.map` for arrays without support for iteratee
                   * shorthands.
                   *
                   * @private
                   * @param {Array} [array] The array to iterate over.
                   * @param {Function} iteratee The function invoked per iteration.
                   * @returns {Array} Returns the new mapped array.
                   */
                  function arrayMap(array, iteratee) {
                    var index = -1,
                      length = array == null ? 0 : array.length,
                      result = Array(length);

                    while (++index < length) {
                      result[index] = iteratee(array[index], index, array);
                    }
                    return result;
                  }

                  /**
                   * Appends the elements of `values` to `array`.
                   *
                   * @private
                   * @param {Array} array The array to modify.
                   * @param {Array} values The values to append.
                   * @returns {Array} Returns `array`.
                   */
                  function arrayPush(array, values) {
                    var index = -1,
                      length = values.length,
                      offset = array.length;

                    while (++index < length) {
                      array[offset + index] = values[index];
                    }
                    return array;
                  }

                  /**
                   * A specialized version of `_.reduce` for arrays without support for
                   * iteratee shorthands.
                   *
                   * @private
                   * @param {Array} [array] The array to iterate over.
                   * @param {Function} iteratee The function invoked per iteration.
                   * @param {*} [accumulator] The initial value.
                   * @param {boolean} [initAccum] Specify using the first element of `array` as
                   *  the initial value.
                   * @returns {*} Returns the accumulated value.
                   */
                  function arrayReduce(array, iteratee, accumulator, initAccum) {
                    var index = -1,
                      length = array == null ? 0 : array.length;

                    if (initAccum && length) {
                      accumulator = array[++index];
                    }
                    while (++index < length) {
                      accumulator = iteratee(accumulator, array[index], index, array);
                    }
                    return accumulator;
                  }

                  /**
                   * A specialized version of `_.reduceRight` for arrays without support for
                   * iteratee shorthands.
                   *
                   * @private
                   * @param {Array} [array] The array to iterate over.
                   * @param {Function} iteratee The function invoked per iteration.
                   * @param {*} [accumulator] The initial value.
                   * @param {boolean} [initAccum] Specify using the last element of `array` as
                   *  the initial value.
                   * @returns {*} Returns the accumulated value.
                   */
                  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
                    var length = array == null ? 0 : array.length;
                    if (initAccum && length) {
                      accumulator = array[--length];
                    }
                    while (length--) {
                      accumulator = iteratee(accumulator, array[length], length, array);
                    }
                    return accumulator;
                  }

                  /**
                   * A specialized version of `_.some` for arrays without support for iteratee
                   * shorthands.
                   *
                   * @private
                   * @param {Array} [array] The array to iterate over.
                   * @param {Function} predicate The function invoked per iteration.
                   * @returns {boolean} Returns `true` if any element passes the predicate check,
                   *  else `false`.
                   */
                  function arraySome(array, predicate) {
                    var index = -1,
                      length = array == null ? 0 : array.length;

                    while (++index < length) {
                      if (predicate(array[index], index, array)) {
                        return true;
                      }
                    }
                    return false;
                  }

                  /**
                   * Gets the size of an ASCII `string`.
                   *
                   * @private
                   * @param {string} string The string inspect.
                   * @returns {number} Returns the string size.
                   */
                  var asciiSize = baseProperty('length');

                  /**
                   * Converts an ASCII `string` to an array.
                   *
                   * @private
                   * @param {string} string The string to convert.
                   * @returns {Array} Returns the converted array.
                   */
                  function asciiToArray(string) {
                    return string.split('');
                  }

                  /**
                   * Splits an ASCII `string` into an array of its words.
                   *
                   * @private
                   * @param {string} The string to inspect.
                   * @returns {Array} Returns the words of `string`.
                   */
                  function asciiWords(string) {
                    return string.match(reAsciiWord) || [];
                  }

                  /**
                   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
                   * without support for iteratee shorthands, which iterates over `collection`
                   * using `eachFunc`.
                   *
                   * @private
                   * @param {Array|Object} collection The collection to inspect.
                   * @param {Function} predicate The function invoked per iteration.
                   * @param {Function} eachFunc The function to iterate over `collection`.
                   * @returns {*} Returns the found element or its key, else `undefined`.
                   */
                  function baseFindKey(collection, predicate, eachFunc) {
                    var result;
                    eachFunc(collection, function (value, key, collection) {
                      if (predicate(value, key, collection)) {
                        result = key;
                        return false;
                      }
                    });
                    return result;
                  }

                  /**
                   * The base implementation of `_.findIndex` and `_.findLastIndex` without
                   * support for iteratee shorthands.
                   *
                   * @private
                   * @param {Array} array The array to inspect.
                   * @param {Function} predicate The function invoked per iteration.
                   * @param {number} fromIndex The index to search from.
                   * @param {boolean} [fromRight] Specify iterating from right to left.
                   * @returns {number} Returns the index of the matched value, else `-1`.
                   */
                  function baseFindIndex(array, predicate, fromIndex, fromRight) {
                    var length = array.length,
                      index = fromIndex + (fromRight ? 1 : -1);

                    while (fromRight ? index-- : ++index < length) {
                      if (predicate(array[index], index, array)) {
                        return index;
                      }
                    }
                    return -1;
                  }

                  /**
                   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
                   *
                   * @private
                   * @param {Array} array The array to inspect.
                   * @param {*} value The value to search for.
                   * @param {number} fromIndex The index to search from.
                   * @returns {number} Returns the index of the matched value, else `-1`.
                   */
                  function baseIndexOf(array, value, fromIndex) {
                    return value === value
                      ? strictIndexOf(array, value, fromIndex)
                      : baseFindIndex(array, baseIsNaN, fromIndex);
                  }

                  /**
                   * This function is like `baseIndexOf` except that it accepts a comparator.
                   *
                   * @private
                   * @param {Array} array The array to inspect.
                   * @param {*} value The value to search for.
                   * @param {number} fromIndex The index to search from.
                   * @param {Function} comparator The comparator invoked per element.
                   * @returns {number} Returns the index of the matched value, else `-1`.
                   */
                  function baseIndexOfWith(array, value, fromIndex, comparator) {
                    var index = fromIndex - 1,
                      length = array.length;

                    while (++index < length) {
                      if (comparator(array[index], value)) {
                        return index;
                      }
                    }
                    return -1;
                  }

                  /**
                   * The base implementation of `_.isNaN` without support for number objects.
                   *
                   * @private
                   * @param {*} value The value to check.
                   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
                   */
                  function baseIsNaN(value) {
                    return value !== value;
                  }

                  /**
                   * The base implementation of `_.mean` and `_.meanBy` without support for
                   * iteratee shorthands.
                   *
                   * @private
                   * @param {Array} array The array to iterate over.
                   * @param {Function} iteratee The function invoked per iteration.
                   * @returns {number} Returns the mean.
                   */
                  function baseMean(array, iteratee) {
                    var length = array == null ? 0 : array.length;
                    return length ? baseSum(array, iteratee) / length : NAN;
                  }

                  /**
                   * The base implementation of `_.property` without support for deep paths.
                   *
                   * @private
                   * @param {string} key The key of the property to get.
                   * @returns {Function} Returns the new accessor function.
                   */
                  function baseProperty(key) {
                    return function (object) {
                      return object == null ? undefined : object[key];
                    };
                  }

                  /**
                   * The base implementation of `_.propertyOf` without support for deep paths.
                   *
                   * @private
                   * @param {Object} object The object to query.
                   * @returns {Function} Returns the new accessor function.
                   */
                  function basePropertyOf(object) {
                    return function (key) {
                      return object == null ? undefined : object[key];
                    };
                  }

                  /**
                   * The base implementation of `_.reduce` and `_.reduceRight`, without support
                   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
                   *
                   * @private
                   * @param {Array|Object} collection The collection to iterate over.
                   * @param {Function} iteratee The function invoked per iteration.
                   * @param {*} accumulator The initial value.
                   * @param {boolean} initAccum Specify using the first or last element of
                   *  `collection` as the initial value.
                   * @param {Function} eachFunc The function to iterate over `collection`.
                   * @returns {*} Returns the accumulated value.
                   */
                  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
                    eachFunc(collection, function (value, index, collection) {
                      accumulator = initAccum
                        ? ((initAccum = false), value)
                        : iteratee(accumulator, value, index, collection);
                    });
                    return accumulator;
                  }

                  /**
                   * The base implementation of `_.sortBy` which uses `comparer` to define the
                   * sort order of `array` and replaces criteria objects with their corresponding
                   * values.
                   *
                   * @private
                   * @param {Array} array The array to sort.
                   * @param {Function} comparer The function to define sort order.
                   * @returns {Array} Returns `array`.
                   */
                  function baseSortBy(array, comparer) {
                    var length = array.length;

                    array.sort(comparer);
                    while (length--) {
                      array[length] = array[length].value;
                    }
                    return array;
                  }

                  /**
                   * The base implementation of `_.sum` and `_.sumBy` without support for
                   * iteratee shorthands.
                   *
                   * @private
                   * @param {Array} array The array to iterate over.
                   * @param {Function} iteratee The function invoked per iteration.
                   * @returns {number} Returns the sum.
                   */
                  function baseSum(array, iteratee) {
                    var result,
                      index = -1,
                      length = array.length;

                    while (++index < length) {
                      var current = iteratee(array[index]);
                      if (current !== undefined) {
                        result = result === undefined ? current : result + current;
                      }
                    }
                    return result;
                  }

                  /**
                   * The base implementation of `_.times` without support for iteratee shorthands
                   * or max array length checks.
                   *
                   * @private
                   * @param {number} n The number of times to invoke `iteratee`.
                   * @param {Function} iteratee The function invoked per iteration.
                   * @returns {Array} Returns the array of results.
                   */
                  function baseTimes(n, iteratee) {
                    var index = -1,
                      result = Array(n);

                    while (++index < n) {
                      result[index] = iteratee(index);
                    }
                    return result;
                  }

                  /**
                   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
                   * of key-value pairs for `object` corresponding to the property names of `props`.
                   *
                   * @private
                   * @param {Object} object The object to query.
                   * @param {Array} props The property names to get values for.
                   * @returns {Object} Returns the key-value pairs.
                   */
                  function baseToPairs(object, props) {
                    return arrayMap(props, function (key) {
                      return [key, object[key]];
                    });
                  }

                  /**
                   * The base implementation of `_.unary` without support for storing metadata.
                   *
                   * @private
                   * @param {Function} func The function to cap arguments for.
                   * @returns {Function} Returns the new capped function.
                   */
                  function baseUnary(func) {
                    return function (value) {
                      return func(value);
                    };
                  }

                  /**
                   * The base implementation of `_.values` and `_.valuesIn` which creates an
                   * array of `object` property values corresponding to the property names
                   * of `props`.
                   *
                   * @private
                   * @param {Object} object The object to query.
                   * @param {Array} props The property names to get values for.
                   * @returns {Object} Returns the array of property values.
                   */
                  function baseValues(object, props) {
                    return arrayMap(props, function (key) {
                      return object[key];
                    });
                  }

                  /**
                   * Checks if a `cache` value for `key` exists.
                   *
                   * @private
                   * @param {Object} cache The cache to query.
                   * @param {string} key The key of the entry to check.
                   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
                   */
                  function cacheHas(cache, key) {
                    return cache.has(key);
                  }

                  /**
                   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
                   * that is not found in the character symbols.
                   *
                   * @private
                   * @param {Array} strSymbols The string symbols to inspect.
                   * @param {Array} chrSymbols The character symbols to find.
                   * @returns {number} Returns the index of the first unmatched string symbol.
                   */
                  function charsStartIndex(strSymbols, chrSymbols) {
                    var index = -1,
                      length = strSymbols.length;

                    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
                    return index;
                  }

                  /**
                   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
                   * that is not found in the character symbols.
                   *
                   * @private
                   * @param {Array} strSymbols The string symbols to inspect.
                   * @param {Array} chrSymbols The character symbols to find.
                   * @returns {number} Returns the index of the last unmatched string symbol.
                   */
                  function charsEndIndex(strSymbols, chrSymbols) {
                    var index = strSymbols.length;

                    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
                    return index;
                  }

                  /**
                   * Gets the number of `placeholder` occurrences in `array`.
                   *
                   * @private
                   * @param {Array} array The array to inspect.
                   * @param {*} placeholder The placeholder to search for.
                   * @returns {number} Returns the placeholder count.
                   */
                  function countHolders(array, placeholder) {
                    var length = array.length,
                      result = 0;

                    while (length--) {
                      if (array[length] === placeholder) {
                        ++result;
                      }
                    }
                    return result;
                  }

                  /**
                   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
                   * letters to basic Latin letters.
                   *
                   * @private
                   * @param {string} letter The matched letter to deburr.
                   * @returns {string} Returns the deburred letter.
                   */
                  var deburrLetter = basePropertyOf(deburredLetters);

                  /**
                   * Used by `_.escape` to convert characters to HTML entities.
                   *
                   * @private
                   * @param {string} chr The matched character to escape.
                   * @returns {string} Returns the escaped character.
                   */
                  var escapeHtmlChar = basePropertyOf(htmlEscapes);

                  /**
                   * Used by `_.template` to escape characters for inclusion in compiled string literals.
                   *
                   * @private
                   * @param {string} chr The matched character to escape.
                   * @returns {string} Returns the escaped character.
                   */
                  function escapeStringChar(chr) {
                    return '\\' + stringEscapes[chr];
                  }

                  /**
                   * Gets the value at `key` of `object`.
                   *
                   * @private
                   * @param {Object} [object] The object to query.
                   * @param {string} key The key of the property to get.
                   * @returns {*} Returns the property value.
                   */
                  function getValue(object, key) {
                    return object == null ? undefined : object[key];
                  }

                  /**
                   * Checks if `string` contains Unicode symbols.
                   *
                   * @private
                   * @param {string} string The string to inspect.
                   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
                   */
                  function hasUnicode(string) {
                    return reHasUnicode.test(string);
                  }

                  /**
                   * Checks if `string` contains a word composed of Unicode symbols.
                   *
                   * @private
                   * @param {string} string The string to inspect.
                   * @returns {boolean} Returns `true` if a word is found, else `false`.
                   */
                  function hasUnicodeWord(string) {
                    return reHasUnicodeWord.test(string);
                  }

                  /**
                   * Converts `iterator` to an array.
                   *
                   * @private
                   * @param {Object} iterator The iterator to convert.
                   * @returns {Array} Returns the converted array.
                   */
                  function iteratorToArray(iterator) {
                    var data,
                      result = [];

                    while (!(data = iterator.next()).done) {
                      result.push(data.value);
                    }
                    return result;
                  }

                  /**
                   * Converts `map` to its key-value pairs.
                   *
                   * @private
                   * @param {Object} map The map to convert.
                   * @returns {Array} Returns the key-value pairs.
                   */
                  function mapToArray(map) {
                    var index = -1,
                      result = Array(map.size);

                    map.forEach(function (value, key) {
                      result[++index] = [key, value];
                    });
                    return result;
                  }

                  /**
                   * Creates a unary function that invokes `func` with its argument transformed.
                   *
                   * @private
                   * @param {Function} func The function to wrap.
                   * @param {Function} transform The argument transform.
                   * @returns {Function} Returns the new function.
                   */
                  function overArg(func, transform) {
                    return function (arg) {
                      return func(transform(arg));
                    };
                  }

                  /**
                   * Replaces all `placeholder` elements in `array` with an internal placeholder
                   * and returns an array of their indexes.
                   *
                   * @private
                   * @param {Array} array The array to modify.
                   * @param {*} placeholder The placeholder to replace.
                   * @returns {Array} Returns the new array of placeholder indexes.
                   */
                  function replaceHolders(array, placeholder) {
                    var index = -1,
                      length = array.length,
                      resIndex = 0,
                      result = [];

                    while (++index < length) {
                      var value = array[index];
                      if (value === placeholder || value === PLACEHOLDER) {
                        array[index] = PLACEHOLDER;
                        result[resIndex++] = index;
                      }
                    }
                    return result;
                  }

                  /**
                   * Converts `set` to an array of its values.
                   *
                   * @private
                   * @param {Object} set The set to convert.
                   * @returns {Array} Returns the values.
                   */
                  function setToArray(set) {
                    var index = -1,
                      result = Array(set.size);

                    set.forEach(function (value) {
                      result[++index] = value;
                    });
                    return result;
                  }

                  /**
                   * Converts `set` to its value-value pairs.
                   *
                   * @private
                   * @param {Object} set The set to convert.
                   * @returns {Array} Returns the value-value pairs.
                   */
                  function setToPairs(set) {
                    var index = -1,
                      result = Array(set.size);

                    set.forEach(function (value) {
                      result[++index] = [value, value];
                    });
                    return result;
                  }

                  /**
                   * A specialized version of `_.indexOf` which performs strict equality
                   * comparisons of values, i.e. `===`.
                   *
                   * @private
                   * @param {Array} array The array to inspect.
                   * @param {*} value The value to search for.
                   * @param {number} fromIndex The index to search from.
                   * @returns {number} Returns the index of the matched value, else `-1`.
                   */
                  function strictIndexOf(array, value, fromIndex) {
                    var index = fromIndex - 1,
                      length = array.length;

                    while (++index < length) {
                      if (array[index] === value) {
                        return index;
                      }
                    }
                    return -1;
                  }

                  /**
                   * A specialized version of `_.lastIndexOf` which performs strict equality
                   * comparisons of values, i.e. `===`.
                   *
                   * @private
                   * @param {Array} array The array to inspect.
                   * @param {*} value The value to search for.
                   * @param {number} fromIndex The index to search from.
                   * @returns {number} Returns the index of the matched value, else `-1`.
                   */
                  function strictLastIndexOf(array, value, fromIndex) {
                    var index = fromIndex + 1;
                    while (index--) {
                      if (array[index] === value) {
                        return index;
                      }
                    }
                    return index;
                  }

                  /**
                   * Gets the number of symbols in `string`.
                   *
                   * @private
                   * @param {string} string The string to inspect.
                   * @returns {number} Returns the string size.
                   */
                  function stringSize(string) {
                    return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
                  }

                  /**
                   * Converts `string` to an array.
                   *
                   * @private
                   * @param {string} string The string to convert.
                   * @returns {Array} Returns the converted array.
                   */
                  function stringToArray(string) {
                    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
                  }

                  /**
                   * Used by `_.unescape` to convert HTML entities to characters.
                   *
                   * @private
                   * @param {string} chr The matched character to unescape.
                   * @returns {string} Returns the unescaped character.
                   */
                  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

                  /**
                   * Gets the size of a Unicode `string`.
                   *
                   * @private
                   * @param {string} string The string inspect.
                   * @returns {number} Returns the string size.
                   */
                  function unicodeSize(string) {
                    var result = (reUnicode.lastIndex = 0);
                    while (reUnicode.test(string)) {
                      ++result;
                    }
                    return result;
                  }

                  /**
                   * Converts a Unicode `string` to an array.
                   *
                   * @private
                   * @param {string} string The string to convert.
                   * @returns {Array} Returns the converted array.
                   */
                  function unicodeToArray(string) {
                    return string.match(reUnicode) || [];
                  }

                  /**
                   * Splits a Unicode `string` into an array of its words.
                   *
                   * @private
                   * @param {string} The string to inspect.
                   * @returns {Array} Returns the words of `string`.
                   */
                  function unicodeWords(string) {
                    return string.match(reUnicodeWord) || [];
                  }

                  /*--------------------------------------------------------------------------*/

                  /**
                   * Create a new pristine `lodash` function using the `context` object.
                   *
                   * @static
                   * @memberOf _
                   * @since 1.1.0
                   * @category Util
                   * @param {Object} [context=root] The context object.
                   * @returns {Function} Returns a new `lodash` function.
                   * @example
                   *
                   * _.mixin({ 'foo': _.constant('foo') });
                   *
                   * var lodash = _.runInContext();
                   * lodash.mixin({ 'bar': lodash.constant('bar') });
                   *
                   * _.isFunction(_.foo);
                   * // => true
                   * _.isFunction(_.bar);
                   * // => false
                   *
                   * lodash.isFunction(lodash.foo);
                   * // => false
                   * lodash.isFunction(lodash.bar);
                   * // => true
                   *
                   * // Create a suped-up `defer` in Node.js.
                   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
                   */
                  var runInContext = function runInContext(context) {
                    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

                    /** Built-in constructor references. */
                    var Array = context.Array,
                      Date = context.Date,
                      Error = context.Error,
                      Function = context.Function,
                      Math = context.Math,
                      Object = context.Object,
                      RegExp = context.RegExp,
                      String = context.String,
                      TypeError = context.TypeError;

                    /** Used for built-in method references. */
                    var arrayProto = Array.prototype,
                      funcProto = Function.prototype,
                      objectProto = Object.prototype;

                    /** Used to detect overreaching core-js shims. */
                    var coreJsData = context['__core-js_shared__'];

                    /** Used to resolve the decompiled source of functions. */
                    var funcToString = funcProto.toString;

                    /** Used to check objects for own properties. */
                    var hasOwnProperty = objectProto.hasOwnProperty;

                    /** Used to generate unique IDs. */
                    var idCounter = 0;

                    /** Used to detect methods masquerading as native. */
                    var maskSrcKey = (function () {
                      var uid = /[^.]+$/.exec((coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO) || '');
                      return uid ? 'Symbol(src)_1.' + uid : '';
                    })();

                    /**
                     * Used to resolve the
                     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
                     * of values.
                     */
                    var nativeObjectToString = objectProto.toString;

                    /** Used to infer the `Object` constructor. */
                    var objectCtorString = funcToString.call(Object);

                    /** Used to restore the original `_` reference in `_.noConflict`. */
                    var oldDash = root._;

                    /** Used to detect if a method is native. */
                    var reIsNative = RegExp(
                      '^' +
                        funcToString
                          .call(hasOwnProperty)
                          .replace(reRegExpChar, '\\$&')
                          .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') +
                        '$'
                    );

                    /** Built-in value references. */
                    var Buffer = moduleExports ? context.Buffer : undefined,
                      Symbol = context.Symbol,
                      Uint8Array = context.Uint8Array,
                      allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
                      getPrototype = overArg(Object.getPrototypeOf, Object),
                      objectCreate = Object.create,
                      propertyIsEnumerable = objectProto.propertyIsEnumerable,
                      splice = arrayProto.splice,
                      spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
                      symIterator = Symbol ? Symbol.iterator : undefined,
                      symToStringTag = Symbol ? Symbol.toStringTag : undefined;

                    var defineProperty = (function () {
                      try {
                        var func = getNative(Object, 'defineProperty');
                        func({}, '', {});
                        return func;
                      } catch (e) {}
                    })();

                    /** Mocked built-ins. */
                    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
                      ctxNow = Date && Date.now !== root.Date.now && Date.now,
                      ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

                    /* Built-in method references for those with the same name as other `lodash` methods. */
                    var nativeCeil = Math.ceil,
                      nativeFloor = Math.floor,
                      nativeGetSymbols = Object.getOwnPropertySymbols,
                      nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
                      nativeIsFinite = context.isFinite,
                      nativeJoin = arrayProto.join,
                      nativeKeys = overArg(Object.keys, Object),
                      nativeMax = Math.max,
                      nativeMin = Math.min,
                      nativeNow = Date.now,
                      nativeParseInt = context.parseInt,
                      nativeRandom = Math.random,
                      nativeReverse = arrayProto.reverse;

                    /* Built-in method references that are verified to be native. */
                    var DataView = getNative(context, 'DataView'),
                      Map = getNative(context, 'Map'),
                      Promise = getNative(context, 'Promise'),
                      Set = getNative(context, 'Set'),
                      WeakMap = getNative(context, 'WeakMap'),
                      nativeCreate = getNative(Object, 'create');

                    /** Used to store function metadata. */
                    var metaMap = WeakMap && new WeakMap();

                    /** Used to lookup unminified function names. */
                    var realNames = {};

                    /** Used to detect maps, sets, and weakmaps. */
                    var dataViewCtorString = toSource(DataView),
                      mapCtorString = toSource(Map),
                      promiseCtorString = toSource(Promise),
                      setCtorString = toSource(Set),
                      weakMapCtorString = toSource(WeakMap);

                    /** Used to convert symbols to primitives and strings. */
                    var symbolProto = Symbol ? Symbol.prototype : undefined,
                      symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
                      symbolToString = symbolProto ? symbolProto.toString : undefined;

                    /*------------------------------------------------------------------------*/

                    /**
                     * Creates a `lodash` object which wraps `value` to enable implicit method
                     * chain sequences. Methods that operate on and return arrays, collections,
                     * and functions can be chained together. Methods that retrieve a single value
                     * or may return a primitive value will automatically end the chain sequence
                     * and return the unwrapped value. Otherwise, the value must be unwrapped
                     * with `_#value`.
                     *
                     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
                     * enabled using `_.chain`.
                     *
                     * The execution of chained methods is lazy, that is, it's deferred until
                     * `_#value` is implicitly or explicitly called.
                     *
                     * Lazy evaluation allows several methods to support shortcut fusion.
                     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
                     * the creation of intermediate arrays and can greatly reduce the number of
                     * iteratee executions. Sections of a chain sequence qualify for shortcut
                     * fusion if the section is applied to an array and iteratees accept only
                     * one argument. The heuristic for whether a section qualifies for shortcut
                     * fusion is subject to change.
                     *
                     * Chaining is supported in custom builds as long as the `_#value` method is
                     * directly or indirectly included in the build.
                     *
                     * In addition to lodash methods, wrappers have `Array` and `String` methods.
                     *
                     * The wrapper `Array` methods are:
                     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
                     *
                     * The wrapper `String` methods are:
                     * `replace` and `split`
                     *
                     * The wrapper methods that support shortcut fusion are:
                     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
                     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
                     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
                     *
                     * The chainable wrapper methods are:
                     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
                     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
                     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
                     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
                     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
                     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
                     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
                     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
                     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
                     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
                     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
                     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
                     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
                     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
                     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
                     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
                     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
                     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
                     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
                     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
                     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
                     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
                     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
                     * `zipObject`, `zipObjectDeep`, and `zipWith`
                     *
                     * The wrapper methods that are **not** chainable by default are:
                     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
                     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
                     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
                     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
                     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
                     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
                     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
                     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
                     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
                     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
                     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
                     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
                     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
                     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
                     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
                     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
                     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
                     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
                     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
                     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
                     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
                     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
                     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
                     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
                     * `upperFirst`, `value`, and `words`
                     *
                     * @name _
                     * @constructor
                     * @category Seq
                     * @param {*} value The value to wrap in a `lodash` instance.
                     * @returns {Object} Returns the new `lodash` wrapper instance.
                     * @example
                     *
                     * function square(n) {
                     *   return n * n;
                     * }
                     *
                     * var wrapped = _([1, 2, 3]);
                     *
                     * // Returns an unwrapped value.
                     * wrapped.reduce(_.add);
                     * // => 6
                     *
                     * // Returns a wrapped value.
                     * var squares = wrapped.map(square);
                     *
                     * _.isArray(squares);
                     * // => false
                     *
                     * _.isArray(squares.value());
                     * // => true
                     */
                    function lodash(value) {
                      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                        if (value instanceof LodashWrapper) {
                          return value;
                        }
                        if (hasOwnProperty.call(value, '__wrapped__')) {
                          return wrapperClone(value);
                        }
                      }
                      return new LodashWrapper(value);
                    }

                    /**
                     * The base implementation of `_.create` without support for assigning
                     * properties to the created object.
                     *
                     * @private
                     * @param {Object} proto The object to inherit from.
                     * @returns {Object} Returns the new object.
                     */
                    var baseCreate = (function () {
                      function object() {}
                      return function (proto) {
                        if (!isObject(proto)) {
                          return {};
                        }
                        if (objectCreate) {
                          return objectCreate(proto);
                        }
                        object.prototype = proto;
                        var result = new object();
                        object.prototype = undefined;
                        return result;
                      };
                    })();

                    /**
                     * The function whose prototype chain sequence wrappers inherit from.
                     *
                     * @private
                     */
                    function baseLodash() {
                      // No operation performed.
                    }

                    /**
                     * The base constructor for creating `lodash` wrapper objects.
                     *
                     * @private
                     * @param {*} value The value to wrap.
                     * @param {boolean} [chainAll] Enable explicit method chain sequences.
                     */
                    function LodashWrapper(value, chainAll) {
                      this.__wrapped__ = value;
                      this.__actions__ = [];
                      this.__chain__ = !!chainAll;
                      this.__index__ = 0;
                      this.__values__ = undefined;
                    }

                    /**
                     * By default, the template delimiters used by lodash are like those in
                     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
                     * following template settings to use alternative delimiters.
                     *
                     * @static
                     * @memberOf _
                     * @type {Object}
                     */
                    lodash.templateSettings = {
                      /**
                       * Used to detect `data` property values to be HTML-escaped.
                       *
                       * @memberOf _.templateSettings
                       * @type {RegExp}
                       */
                      escape: reEscape,

                      /**
                       * Used to detect code to be evaluated.
                       *
                       * @memberOf _.templateSettings
                       * @type {RegExp}
                       */
                      evaluate: reEvaluate,

                      /**
                       * Used to detect `data` property values to inject.
                       *
                       * @memberOf _.templateSettings
                       * @type {RegExp}
                       */
                      interpolate: reInterpolate,

                      /**
                       * Used to reference the data object in the template text.
                       *
                       * @memberOf _.templateSettings
                       * @type {string}
                       */
                      variable: '',

                      /**
                       * Used to import variables into the compiled template.
                       *
                       * @memberOf _.templateSettings
                       * @type {Object}
                       */
                      imports: {
                        /**
                         * A reference to the `lodash` function.
                         *
                         * @memberOf _.templateSettings.imports
                         * @type {Function}
                         */
                        _: lodash
                      }
                    };

                    // Ensure wrappers are instances of `baseLodash`.
                    lodash.prototype = baseLodash.prototype;
                    lodash.prototype.constructor = lodash;

                    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
                    LodashWrapper.prototype.constructor = LodashWrapper;

                    /*------------------------------------------------------------------------*/

                    /**
                     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
                     *
                     * @private
                     * @constructor
                     * @param {*} value The value to wrap.
                     */
                    function LazyWrapper(value) {
                      this.__wrapped__ = value;
                      this.__actions__ = [];
                      this.__dir__ = 1;
                      this.__filtered__ = false;
                      this.__iteratees__ = [];
                      this.__takeCount__ = MAX_ARRAY_LENGTH;
                      this.__views__ = [];
                    }

                    /**
                     * Creates a clone of the lazy wrapper object.
                     *
                     * @private
                     * @name clone
                     * @memberOf LazyWrapper
                     * @returns {Object} Returns the cloned `LazyWrapper` object.
                     */
                    function lazyClone() {
                      var result = new LazyWrapper(this.__wrapped__);
                      result.__actions__ = copyArray(this.__actions__);
                      result.__dir__ = this.__dir__;
                      result.__filtered__ = this.__filtered__;
                      result.__iteratees__ = copyArray(this.__iteratees__);
                      result.__takeCount__ = this.__takeCount__;
                      result.__views__ = copyArray(this.__views__);
                      return result;
                    }

                    /**
                     * Reverses the direction of lazy iteration.
                     *
                     * @private
                     * @name reverse
                     * @memberOf LazyWrapper
                     * @returns {Object} Returns the new reversed `LazyWrapper` object.
                     */
                    function lazyReverse() {
                      if (this.__filtered__) {
                        var result = new LazyWrapper(this);
                        result.__dir__ = -1;
                        result.__filtered__ = true;
                      } else {
                        result = this.clone();
                        result.__dir__ *= -1;
                      }
                      return result;
                    }

                    /**
                     * Extracts the unwrapped value from its lazy wrapper.
                     *
                     * @private
                     * @name value
                     * @memberOf LazyWrapper
                     * @returns {*} Returns the unwrapped value.
                     */
                    function lazyValue() {
                      var array = this.__wrapped__.value(),
                        dir = this.__dir__,
                        isArr = isArray(array),
                        isRight = dir < 0,
                        arrLength = isArr ? array.length : 0,
                        view = getView(0, arrLength, this.__views__),
                        start = view.start,
                        end = view.end,
                        length = end - start,
                        index = isRight ? end : start - 1,
                        iteratees = this.__iteratees__,
                        iterLength = iteratees.length,
                        resIndex = 0,
                        takeCount = nativeMin(length, this.__takeCount__);

                      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
                        return baseWrapperValue(array, this.__actions__);
                      }
                      var result = [];

                      outer: while (length-- && resIndex < takeCount) {
                        index += dir;

                        var iterIndex = -1,
                          value = array[index];

                        while (++iterIndex < iterLength) {
                          var data = iteratees[iterIndex],
                            iteratee = data.iteratee,
                            type = data.type,
                            computed = iteratee(value);

                          if (type == LAZY_MAP_FLAG) {
                            value = computed;
                          } else if (!computed) {
                            if (type == LAZY_FILTER_FLAG) {
                              continue outer;
                            } else {
                              break outer;
                            }
                          }
                        }
                        result[resIndex++] = value;
                      }
                      return result;
                    }

                    // Ensure `LazyWrapper` is an instance of `baseLodash`.
                    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
                    LazyWrapper.prototype.constructor = LazyWrapper;

                    /*------------------------------------------------------------------------*/

                    /**
                     * Creates a hash object.
                     *
                     * @private
                     * @constructor
                     * @param {Array} [entries] The key-value pairs to cache.
                     */
                    function Hash(entries) {
                      var index = -1,
                        length = entries == null ? 0 : entries.length;

                      this.clear();
                      while (++index < length) {
                        var entry = entries[index];
                        this.set(entry[0], entry[1]);
                      }
                    }

                    /**
                     * Removes all key-value entries from the hash.
                     *
                     * @private
                     * @name clear
                     * @memberOf Hash
                     */
                    function hashClear() {
                      this.__data__ = nativeCreate ? nativeCreate(null) : {};
                      this.size = 0;
                    }

                    /**
                     * Removes `key` and its value from the hash.
                     *
                     * @private
                     * @name delete
                     * @memberOf Hash
                     * @param {Object} hash The hash to modify.
                     * @param {string} key The key of the value to remove.
                     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
                     */
                    function hashDelete(key) {
                      var result = this.has(key) && delete this.__data__[key];
                      this.size -= result ? 1 : 0;
                      return result;
                    }

                    /**
                     * Gets the hash value for `key`.
                     *
                     * @private
                     * @name get
                     * @memberOf Hash
                     * @param {string} key The key of the value to get.
                     * @returns {*} Returns the entry value.
                     */
                    function hashGet(key) {
                      var data = this.__data__;
                      if (nativeCreate) {
                        var result = data[key];
                        return result === HASH_UNDEFINED ? undefined : result;
                      }
                      return hasOwnProperty.call(data, key) ? data[key] : undefined;
                    }

                    /**
                     * Checks if a hash value for `key` exists.
                     *
                     * @private
                     * @name has
                     * @memberOf Hash
                     * @param {string} key The key of the entry to check.
                     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
                     */
                    function hashHas(key) {
                      var data = this.__data__;
                      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
                    }

                    /**
                     * Sets the hash `key` to `value`.
                     *
                     * @private
                     * @name set
                     * @memberOf Hash
                     * @param {string} key The key of the value to set.
                     * @param {*} value The value to set.
                     * @returns {Object} Returns the hash instance.
                     */
                    function hashSet(key, value) {
                      var data = this.__data__;
                      this.size += this.has(key) ? 0 : 1;
                      data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
                      return this;
                    }

                    // Add methods to `Hash`.
                    Hash.prototype.clear = hashClear;
                    Hash.prototype['delete'] = hashDelete;
                    Hash.prototype.get = hashGet;
                    Hash.prototype.has = hashHas;
                    Hash.prototype.set = hashSet;

                    /*------------------------------------------------------------------------*/

                    /**
                     * Creates an list cache object.
                     *
                     * @private
                     * @constructor
                     * @param {Array} [entries] The key-value pairs to cache.
                     */
                    function ListCache(entries) {
                      var index = -1,
                        length = entries == null ? 0 : entries.length;

                      this.clear();
                      while (++index < length) {
                        var entry = entries[index];
                        this.set(entry[0], entry[1]);
                      }
                    }

                    /**
                     * Removes all key-value entries from the list cache.
                     *
                     * @private
                     * @name clear
                     * @memberOf ListCache
                     */
                    function listCacheClear() {
                      this.__data__ = [];
                      this.size = 0;
                    }

                    /**
                     * Removes `key` and its value from the list cache.
                     *
                     * @private
                     * @name delete
                     * @memberOf ListCache
                     * @param {string} key The key of the value to remove.
                     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
                     */
                    function listCacheDelete(key) {
                      var data = this.__data__,
                        index = assocIndexOf(data, key);

                      if (index < 0) {
                        return false;
                      }
                      var lastIndex = data.length - 1;
                      if (index == lastIndex) {
                        data.pop();
                      } else {
                        splice.call(data, index, 1);
                      }
                      --this.size;
                      return true;
                    }

                    /**
                     * Gets the list cache value for `key`.
                     *
                     * @private
                     * @name get
                     * @memberOf ListCache
                     * @param {string} key The key of the value to get.
                     * @returns {*} Returns the entry value.
                     */
                    function listCacheGet(key) {
                      var data = this.__data__,
                        index = assocIndexOf(data, key);

                      return index < 0 ? undefined : data[index][1];
                    }

                    /**
                     * Checks if a list cache value for `key` exists.
                     *
                     * @private
                     * @name has
                     * @memberOf ListCache
                     * @param {string} key The key of the entry to check.
                     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
                     */
                    function listCacheHas(key) {
                      return assocIndexOf(this.__data__, key) > -1;
                    }

                    /**
                     * Sets the list cache `key` to `value`.
                     *
                     * @private
                     * @name set
                     * @memberOf ListCache
                     * @param {string} key The key of the value to set.
                     * @param {*} value The value to set.
                     * @returns {Object} Returns the list cache instance.
                     */
                    function listCacheSet(key, value) {
                      var data = this.__data__,
                        index = assocIndexOf(data, key);

                      if (index < 0) {
                        ++this.size;
                        data.push([key, value]);
                      } else {
                        data[index][1] = value;
                      }
                      return this;
                    }

                    // Add methods to `ListCache`.
                    ListCache.prototype.clear = listCacheClear;
                    ListCache.prototype['delete'] = listCacheDelete;
                    ListCache.prototype.get = listCacheGet;
                    ListCache.prototype.has = listCacheHas;
                    ListCache.prototype.set = listCacheSet;

                    /*------------------------------------------------------------------------*/

                    /**
                     * Creates a map cache object to store key-value pairs.
                     *
                     * @private
                     * @constructor
                     * @param {Array} [entries] The key-value pairs to cache.
                     */
                    function MapCache(entries) {
                      var index = -1,
                        length = entries == null ? 0 : entries.length;

                      this.clear();
                      while (++index < length) {
                        var entry = entries[index];
                        this.set(entry[0], entry[1]);
                      }
                    }

                    /**
                     * Removes all key-value entries from the map.
                     *
                     * @private
                     * @name clear
                     * @memberOf MapCache
                     */
                    function mapCacheClear() {
                      this.size = 0;
                      this.__data__ = {
                        hash: new Hash(),
                        map: new (Map || ListCache)(),
                        string: new Hash()
                      };
                    }

                    /**
                     * Removes `key` and its value from the map.
                     *
                     * @private
                     * @name delete
                     * @memberOf MapCache
                     * @param {string} key The key of the value to remove.
                     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
                     */
                    function mapCacheDelete(key) {
                      var result = getMapData(this, key)['delete'](key);
                      this.size -= result ? 1 : 0;
                      return result;
                    }

                    /**
                     * Gets the map value for `key`.
                     *
                     * @private
                     * @name get
                     * @memberOf MapCache
                     * @param {string} key The key of the value to get.
                     * @returns {*} Returns the entry value.
                     */
                    function mapCacheGet(key) {
                      return getMapData(this, key).get(key);
                    }

                    /**
                     * Checks if a map value for `key` exists.
                     *
                     * @private
                     * @name has
                     * @memberOf MapCache
                     * @param {string} key The key of the entry to check.
                     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
                     */
                    function mapCacheHas(key) {
                      return getMapData(this, key).has(key);
                    }

                    /**
                     * Sets the map `key` to `value`.
                     *
                     * @private
                     * @name set
                     * @memberOf MapCache
                     * @param {string} key The key of the value to set.
                     * @param {*} value The value to set.
                     * @returns {Object} Returns the map cache instance.
                     */
                    function mapCacheSet(key, value) {
                      var data = getMapData(this, key),
                        size = data.size;

                      data.set(key, value);
                      this.size += data.size == size ? 0 : 1;
                      return this;
                    }

                    // Add methods to `MapCache`.
                    MapCache.prototype.clear = mapCacheClear;
                    MapCache.prototype['delete'] = mapCacheDelete;
                    MapCache.prototype.get = mapCacheGet;
                    MapCache.prototype.has = mapCacheHas;
                    MapCache.prototype.set = mapCacheSet;

                    /*------------------------------------------------------------------------*/

                    /**
                     *
                     * Creates an array cache object to store unique values.
                     *
                     * @private
                     * @constructor
                     * @param {Array} [values] The values to cache.
                     */
                    function SetCache(values) {
                      var index = -1,
                        length = values == null ? 0 : values.length;

                      this.__data__ = new MapCache();
                      while (++index < length) {
                        this.add(values[index]);
                      }
                    }

                    /**
                     * Adds `value` to the array cache.
                     *
                     * @private
                     * @name add
                     * @memberOf SetCache
                     * @alias push
                     * @param {*} value The value to cache.
                     * @returns {Object} Returns the cache instance.
                     */
                    function setCacheAdd(value) {
                      this.__data__.set(value, HASH_UNDEFINED);
                      return this;
                    }

                    /**
                     * Checks if `value` is in the array cache.
                     *
                     * @private
                     * @name has
                     * @memberOf SetCache
                     * @param {*} value The value to search for.
                     * @returns {number} Returns `true` if `value` is found, else `false`.
                     */
                    function setCacheHas(value) {
                      return this.__data__.has(value);
                    }

                    // Add methods to `SetCache`.
                    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
                    SetCache.prototype.has = setCacheHas;

                    /*------------------------------------------------------------------------*/

                    /**
                     * Creates a stack cache object to store key-value pairs.
                     *
                     * @private
                     * @constructor
                     * @param {Array} [entries] The key-value pairs to cache.
                     */
                    function Stack(entries) {
                      var data = (this.__data__ = new ListCache(entries));
                      this.size = data.size;
                    }

                    /**
                     * Removes all key-value entries from the stack.
                     *
                     * @private
                     * @name clear
                     * @memberOf Stack
                     */
                    function stackClear() {
                      this.__data__ = new ListCache();
                      this.size = 0;
                    }

                    /**
                     * Removes `key` and its value from the stack.
                     *
                     * @private
                     * @name delete
                     * @memberOf Stack
                     * @param {string} key The key of the value to remove.
                     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
                     */
                    function stackDelete(key) {
                      var data = this.__data__,
                        result = data['delete'](key);

                      this.size = data.size;
                      return result;
                    }

                    /**
                     * Gets the stack value for `key`.
                     *
                     * @private
                     * @name get
                     * @memberOf Stack
                     * @param {string} key The key of the value to get.
                     * @returns {*} Returns the entry value.
                     */
                    function stackGet(key) {
                      return this.__data__.get(key);
                    }

                    /**
                     * Checks if a stack value for `key` exists.
                     *
                     * @private
                     * @name has
                     * @memberOf Stack
                     * @param {string} key The key of the entry to check.
                     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
                     */
                    function stackHas(key) {
                      return this.__data__.has(key);
                    }

                    /**
                     * Sets the stack `key` to `value`.
                     *
                     * @private
                     * @name set
                     * @memberOf Stack
                     * @param {string} key The key of the value to set.
                     * @param {*} value The value to set.
                     * @returns {Object} Returns the stack cache instance.
                     */
                    function stackSet(key, value) {
                      var data = this.__data__;
                      if (data instanceof ListCache) {
                        var pairs = data.__data__;
                        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                          pairs.push([key, value]);
                          this.size = ++data.size;
                          return this;
                        }
                        data = this.__data__ = new MapCache(pairs);
                      }
                      data.set(key, value);
                      this.size = data.size;
                      return this;
                    }

                    // Add methods to `Stack`.
                    Stack.prototype.clear = stackClear;
                    Stack.prototype['delete'] = stackDelete;
                    Stack.prototype.get = stackGet;
                    Stack.prototype.has = stackHas;
                    Stack.prototype.set = stackSet;

                    /*------------------------------------------------------------------------*/

                    /**
                     * Creates an array of the enumerable property names of the array-like `value`.
                     *
                     * @private
                     * @param {*} value The value to query.
                     * @param {boolean} inherited Specify returning inherited property names.
                     * @returns {Array} Returns the array of property names.
                     */
                    function arrayLikeKeys(value, inherited) {
                      var isArr = isArray(value),
                        isArg = !isArr && isArguments(value),
                        isBuff = !isArr && !isArg && isBuffer(value),
                        isType = !isArr && !isArg && !isBuff && isTypedArray(value),
                        skipIndexes = isArr || isArg || isBuff || isType,
                        result = skipIndexes ? baseTimes(value.length, String) : [],
                        length = result.length;

                      for (var key in value) {
                        if (
                          (inherited || hasOwnProperty.call(value, key)) &&
                          !(
                            skipIndexes &&
                            // Safari 9 has enumerable `arguments.length` in strict mode.
                            (key == 'length' ||
                              // Node.js 0.10 has enumerable non-index properties on buffers.
                              (isBuff && (key == 'offset' || key == 'parent')) ||
                              // PhantomJS 2 has enumerable non-index properties on typed arrays.
                              (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
                              // Skip index properties.
                              isIndex(key, length))
                          )
                        ) {
                          result.push(key);
                        }
                      }
                      return result;
                    }

                    /**
                     * A specialized version of `_.sample` for arrays.
                     *
                     * @private
                     * @param {Array} array The array to sample.
                     * @returns {*} Returns the random element.
                     */
                    function arraySample(array) {
                      var length = array.length;
                      return length ? array[baseRandom(0, length - 1)] : undefined;
                    }

                    /**
                     * A specialized version of `_.sampleSize` for arrays.
                     *
                     * @private
                     * @param {Array} array The array to sample.
                     * @param {number} n The number of elements to sample.
                     * @returns {Array} Returns the random elements.
                     */
                    function arraySampleSize(array, n) {
                      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
                    }

                    /**
                     * A specialized version of `_.shuffle` for arrays.
                     *
                     * @private
                     * @param {Array} array The array to shuffle.
                     * @returns {Array} Returns the new shuffled array.
                     */
                    function arrayShuffle(array) {
                      return shuffleSelf(copyArray(array));
                    }

                    /**
                     * This function is like `assignValue` except that it doesn't assign
                     * `undefined` values.
                     *
                     * @private
                     * @param {Object} object The object to modify.
                     * @param {string} key The key of the property to assign.
                     * @param {*} value The value to assign.
                     */
                    function assignMergeValue(object, key, value) {
                      if (
                        (value !== undefined && !eq(object[key], value)) ||
                        (value === undefined && !(key in object))
                      ) {
                        baseAssignValue(object, key, value);
                      }
                    }

                    /**
                     * Assigns `value` to `key` of `object` if the existing value is not equivalent
                     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                     * for equality comparisons.
                     *
                     * @private
                     * @param {Object} object The object to modify.
                     * @param {string} key The key of the property to assign.
                     * @param {*} value The value to assign.
                     */
                    function assignValue(object, key, value) {
                      var objValue = object[key];
                      if (
                        !(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
                        (value === undefined && !(key in object))
                      ) {
                        baseAssignValue(object, key, value);
                      }
                    }

                    /**
                     * Gets the index at which the `key` is found in `array` of key-value pairs.
                     *
                     * @private
                     * @param {Array} array The array to inspect.
                     * @param {*} key The key to search for.
                     * @returns {number} Returns the index of the matched value, else `-1`.
                     */
                    function assocIndexOf(array, key) {
                      var length = array.length;
                      while (length--) {
                        if (eq(array[length][0], key)) {
                          return length;
                        }
                      }
                      return -1;
                    }

                    /**
                     * Aggregates elements of `collection` on `accumulator` with keys transformed
                     * by `iteratee` and values set by `setter`.
                     *
                     * @private
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} setter The function to set `accumulator` values.
                     * @param {Function} iteratee The iteratee to transform keys.
                     * @param {Object} accumulator The initial aggregated object.
                     * @returns {Function} Returns `accumulator`.
                     */
                    function baseAggregator(collection, setter, iteratee, accumulator) {
                      baseEach(collection, function (value, key, collection) {
                        setter(accumulator, value, iteratee(value), collection);
                      });
                      return accumulator;
                    }

                    /**
                     * The base implementation of `_.assign` without support for multiple sources
                     * or `customizer` functions.
                     *
                     * @private
                     * @param {Object} object The destination object.
                     * @param {Object} source The source object.
                     * @returns {Object} Returns `object`.
                     */
                    function baseAssign(object, source) {
                      return object && copyObject(source, keys(source), object);
                    }

                    /**
                     * The base implementation of `_.assignIn` without support for multiple sources
                     * or `customizer` functions.
                     *
                     * @private
                     * @param {Object} object The destination object.
                     * @param {Object} source The source object.
                     * @returns {Object} Returns `object`.
                     */
                    function baseAssignIn(object, source) {
                      return object && copyObject(source, keysIn(source), object);
                    }

                    /**
                     * The base implementation of `assignValue` and `assignMergeValue` without
                     * value checks.
                     *
                     * @private
                     * @param {Object} object The object to modify.
                     * @param {string} key The key of the property to assign.
                     * @param {*} value The value to assign.
                     */
                    function baseAssignValue(object, key, value) {
                      if (key == '__proto__' && defineProperty) {
                        defineProperty(object, key, {
                          configurable: true,
                          enumerable: true,
                          value: value,
                          writable: true
                        });
                      } else {
                        object[key] = value;
                      }
                    }

                    /**
                     * The base implementation of `_.at` without support for individual paths.
                     *
                     * @private
                     * @param {Object} object The object to iterate over.
                     * @param {string[]} paths The property paths to pick.
                     * @returns {Array} Returns the picked elements.
                     */
                    function baseAt(object, paths) {
                      var index = -1,
                        length = paths.length,
                        result = Array(length),
                        skip = object == null;

                      while (++index < length) {
                        result[index] = skip ? undefined : get(object, paths[index]);
                      }
                      return result;
                    }

                    /**
                     * The base implementation of `_.clamp` which doesn't coerce arguments.
                     *
                     * @private
                     * @param {number} number The number to clamp.
                     * @param {number} [lower] The lower bound.
                     * @param {number} upper The upper bound.
                     * @returns {number} Returns the clamped number.
                     */
                    function baseClamp(number, lower, upper) {
                      if (number === number) {
                        if (upper !== undefined) {
                          number = number <= upper ? number : upper;
                        }
                        if (lower !== undefined) {
                          number = number >= lower ? number : lower;
                        }
                      }
                      return number;
                    }

                    /**
                     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
                     * traversed objects.
                     *
                     * @private
                     * @param {*} value The value to clone.
                     * @param {boolean} bitmask The bitmask flags.
                     *  1 - Deep clone
                     *  2 - Flatten inherited properties
                     *  4 - Clone symbols
                     * @param {Function} [customizer] The function to customize cloning.
                     * @param {string} [key] The key of `value`.
                     * @param {Object} [object] The parent object of `value`.
                     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
                     * @returns {*} Returns the cloned value.
                     */
                    function baseClone(value, bitmask, customizer, key, object, stack) {
                      var result,
                        isDeep = bitmask & CLONE_DEEP_FLAG,
                        isFlat = bitmask & CLONE_FLAT_FLAG,
                        isFull = bitmask & CLONE_SYMBOLS_FLAG;

                      if (customizer) {
                        result = object ? customizer(value, key, object, stack) : customizer(value);
                      }
                      if (result !== undefined) {
                        return result;
                      }
                      if (!isObject(value)) {
                        return value;
                      }
                      var isArr = isArray(value);
                      if (isArr) {
                        result = initCloneArray(value);
                        if (!isDeep) {
                          return copyArray(value, result);
                        }
                      } else {
                        var tag = getTag(value),
                          isFunc = tag == funcTag || tag == genTag;

                        if (isBuffer(value)) {
                          return cloneBuffer(value, isDeep);
                        }
                        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
                          result = isFlat || isFunc ? {} : initCloneObject(value);
                          if (!isDeep) {
                            return isFlat
                              ? copySymbolsIn(value, baseAssignIn(result, value))
                              : copySymbols(value, baseAssign(result, value));
                          }
                        } else {
                          if (!cloneableTags[tag]) {
                            return object ? value : {};
                          }
                          result = initCloneByTag(value, tag, baseClone, isDeep);
                        }
                      }
                      // Check for circular references and return its corresponding clone.
                      stack || (stack = new Stack());
                      var stacked = stack.get(value);
                      if (stacked) {
                        return stacked;
                      }
                      stack.set(value, result);

                      var keysFunc = isFull ? (isFlat ? getAllKeysIn : getAllKeys) : isFlat ? keysIn : keys;

                      var props = isArr ? undefined : keysFunc(value);
                      arrayEach(props || value, function (subValue, key) {
                        if (props) {
                          key = subValue;
                          subValue = value[key];
                        }
                        // Recursively populate clone (susceptible to call stack limits).
                        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
                      });
                      return result;
                    }

                    /**
                     * The base implementation of `_.conforms` which doesn't clone `source`.
                     *
                     * @private
                     * @param {Object} source The object of property predicates to conform to.
                     * @returns {Function} Returns the new spec function.
                     */
                    function baseConforms(source) {
                      var props = keys(source);
                      return function (object) {
                        return baseConformsTo(object, source, props);
                      };
                    }

                    /**
                     * The base implementation of `_.conformsTo` which accepts `props` to check.
                     *
                     * @private
                     * @param {Object} object The object to inspect.
                     * @param {Object} source The object of property predicates to conform to.
                     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
                     */
                    function baseConformsTo(object, source, props) {
                      var length = props.length;
                      if (object == null) {
                        return !length;
                      }
                      object = Object(object);
                      while (length--) {
                        var key = props[length],
                          predicate = source[key],
                          value = object[key];

                        if ((value === undefined && !(key in object)) || !predicate(value)) {
                          return false;
                        }
                      }
                      return true;
                    }

                    /**
                     * The base implementation of `_.delay` and `_.defer` which accepts `args`
                     * to provide to `func`.
                     *
                     * @private
                     * @param {Function} func The function to delay.
                     * @param {number} wait The number of milliseconds to delay invocation.
                     * @param {Array} args The arguments to provide to `func`.
                     * @returns {number|Object} Returns the timer id or timeout object.
                     */
                    function baseDelay(func, wait, args) {
                      if (typeof func != 'function') {
                        throw new TypeError(FUNC_ERROR_TEXT);
                      }
                      return setTimeout(function () {
                        func.apply(undefined, args);
                      }, wait);
                    }

                    /**
                     * The base implementation of methods like `_.difference` without support
                     * for excluding multiple arrays or iteratee shorthands.
                     *
                     * @private
                     * @param {Array} array The array to inspect.
                     * @param {Array} values The values to exclude.
                     * @param {Function} [iteratee] The iteratee invoked per element.
                     * @param {Function} [comparator] The comparator invoked per element.
                     * @returns {Array} Returns the new array of filtered values.
                     */
                    function baseDifference(array, values, iteratee, comparator) {
                      var index = -1,
                        includes = arrayIncludes,
                        isCommon = true,
                        length = array.length,
                        result = [],
                        valuesLength = values.length;

                      if (!length) {
                        return result;
                      }
                      if (iteratee) {
                        values = arrayMap(values, baseUnary(iteratee));
                      }
                      if (comparator) {
                        includes = arrayIncludesWith;
                        isCommon = false;
                      } else if (values.length >= LARGE_ARRAY_SIZE) {
                        includes = cacheHas;
                        isCommon = false;
                        values = new SetCache(values);
                      }
                      outer: while (++index < length) {
                        var value = array[index],
                          computed = iteratee == null ? value : iteratee(value);

                        value = comparator || value !== 0 ? value : 0;
                        if (isCommon && computed === computed) {
                          var valuesIndex = valuesLength;
                          while (valuesIndex--) {
                            if (values[valuesIndex] === computed) {
                              continue outer;
                            }
                          }
                          result.push(value);
                        } else if (!includes(values, computed, comparator)) {
                          result.push(value);
                        }
                      }
                      return result;
                    }

                    /**
                     * The base implementation of `_.forEach` without support for iteratee shorthands.
                     *
                     * @private
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} iteratee The function invoked per iteration.
                     * @returns {Array|Object} Returns `collection`.
                     */
                    var baseEach = createBaseEach(baseForOwn);

                    /**
                     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
                     *
                     * @private
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} iteratee The function invoked per iteration.
                     * @returns {Array|Object} Returns `collection`.
                     */
                    var baseEachRight = createBaseEach(baseForOwnRight, true);

                    /**
                     * The base implementation of `_.every` without support for iteratee shorthands.
                     *
                     * @private
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} predicate The function invoked per iteration.
                     * @returns {boolean} Returns `true` if all elements pass the predicate check,
                     *  else `false`
                     */
                    function baseEvery(collection, predicate) {
                      var result = true;
                      baseEach(collection, function (value, index, collection) {
                        result = !!predicate(value, index, collection);
                        return result;
                      });
                      return result;
                    }

                    /**
                     * The base implementation of methods like `_.max` and `_.min` which accepts a
                     * `comparator` to determine the extremum value.
                     *
                     * @private
                     * @param {Array} array The array to iterate over.
                     * @param {Function} iteratee The iteratee invoked per iteration.
                     * @param {Function} comparator The comparator used to compare values.
                     * @returns {*} Returns the extremum value.
                     */
                    function baseExtremum(array, iteratee, comparator) {
                      var index = -1,
                        length = array.length;

                      while (++index < length) {
                        var value = array[index],
                          current = iteratee(value);

                        if (
                          current != null &&
                          (computed === undefined
                            ? current === current && !isSymbol(current)
                            : comparator(current, computed))
                        ) {
                          var computed = current,
                            result = value;
                        }
                      }
                      return result;
                    }

                    /**
                     * The base implementation of `_.fill` without an iteratee call guard.
                     *
                     * @private
                     * @param {Array} array The array to fill.
                     * @param {*} value The value to fill `array` with.
                     * @param {number} [start=0] The start position.
                     * @param {number} [end=array.length] The end position.
                     * @returns {Array} Returns `array`.
                     */
                    function baseFill(array, value, start, end) {
                      var length = array.length;

                      start = toInteger(start);
                      if (start < 0) {
                        start = -start > length ? 0 : length + start;
                      }
                      end = end === undefined || end > length ? length : toInteger(end);
                      if (end < 0) {
                        end += length;
                      }
                      end = start > end ? 0 : toLength(end);
                      while (start < end) {
                        array[start++] = value;
                      }
                      return array;
                    }

                    /**
                     * The base implementation of `_.filter` without support for iteratee shorthands.
                     *
                     * @private
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} predicate The function invoked per iteration.
                     * @returns {Array} Returns the new filtered array.
                     */
                    function baseFilter(collection, predicate) {
                      var result = [];
                      baseEach(collection, function (value, index, collection) {
                        if (predicate(value, index, collection)) {
                          result.push(value);
                        }
                      });
                      return result;
                    }

                    /**
                     * The base implementation of `_.flatten` with support for restricting flattening.
                     *
                     * @private
                     * @param {Array} array The array to flatten.
                     * @param {number} depth The maximum recursion depth.
                     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
                     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
                     * @param {Array} [result=[]] The initial result value.
                     * @returns {Array} Returns the new flattened array.
                     */
                    function baseFlatten(array, depth, predicate, isStrict, result) {
                      var index = -1,
                        length = array.length;

                      predicate || (predicate = isFlattenable);
                      result || (result = []);

                      while (++index < length) {
                        var value = array[index];
                        if (depth > 0 && predicate(value)) {
                          if (depth > 1) {
                            // Recursively flatten arrays (susceptible to call stack limits).
                            baseFlatten(value, depth - 1, predicate, isStrict, result);
                          } else {
                            arrayPush(result, value);
                          }
                        } else if (!isStrict) {
                          result[result.length] = value;
                        }
                      }
                      return result;
                    }

                    /**
                     * The base implementation of `baseForOwn` which iterates over `object`
                     * properties returned by `keysFunc` and invokes `iteratee` for each property.
                     * Iteratee functions may exit iteration early by explicitly returning `false`.
                     *
                     * @private
                     * @param {Object} object The object to iterate over.
                     * @param {Function} iteratee The function invoked per iteration.
                     * @param {Function} keysFunc The function to get the keys of `object`.
                     * @returns {Object} Returns `object`.
                     */
                    var baseFor = createBaseFor();

                    /**
                     * This function is like `baseFor` except that it iterates over properties
                     * in the opposite order.
                     *
                     * @private
                     * @param {Object} object The object to iterate over.
                     * @param {Function} iteratee The function invoked per iteration.
                     * @param {Function} keysFunc The function to get the keys of `object`.
                     * @returns {Object} Returns `object`.
                     */
                    var baseForRight = createBaseFor(true);

                    /**
                     * The base implementation of `_.forOwn` without support for iteratee shorthands.
                     *
                     * @private
                     * @param {Object} object The object to iterate over.
                     * @param {Function} iteratee The function invoked per iteration.
                     * @returns {Object} Returns `object`.
                     */
                    function baseForOwn(object, iteratee) {
                      return object && baseFor(object, iteratee, keys);
                    }

                    /**
                     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
                     *
                     * @private
                     * @param {Object} object The object to iterate over.
                     * @param {Function} iteratee The function invoked per iteration.
                     * @returns {Object} Returns `object`.
                     */
                    function baseForOwnRight(object, iteratee) {
                      return object && baseForRight(object, iteratee, keys);
                    }

                    /**
                     * The base implementation of `_.functions` which creates an array of
                     * `object` function property names filtered from `props`.
                     *
                     * @private
                     * @param {Object} object The object to inspect.
                     * @param {Array} props The property names to filter.
                     * @returns {Array} Returns the function names.
                     */
                    function baseFunctions(object, props) {
                      return arrayFilter(props, function (key) {
                        return isFunction(object[key]);
                      });
                    }

                    /**
                     * The base implementation of `_.get` without support for default values.
                     *
                     * @private
                     * @param {Object} object The object to query.
                     * @param {Array|string} path The path of the property to get.
                     * @returns {*} Returns the resolved value.
                     */
                    function baseGet(object, path) {
                      path = castPath(path, object);

                      var index = 0,
                        length = path.length;

                      while (object != null && index < length) {
                        object = object[toKey(path[index++])];
                      }
                      return index && index == length ? object : undefined;
                    }

                    /**
                     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
                     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
                     * symbols of `object`.
                     *
                     * @private
                     * @param {Object} object The object to query.
                     * @param {Function} keysFunc The function to get the keys of `object`.
                     * @param {Function} symbolsFunc The function to get the symbols of `object`.
                     * @returns {Array} Returns the array of property names and symbols.
                     */
                    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
                      var result = keysFunc(object);
                      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
                    }

                    /**
                     * The base implementation of `getTag` without fallbacks for buggy environments.
                     *
                     * @private
                     * @param {*} value The value to query.
                     * @returns {string} Returns the `toStringTag`.
                     */
                    function baseGetTag(value) {
                      if (value == null) {
                        return value === undefined ? undefinedTag : nullTag;
                      }
                      return symToStringTag && symToStringTag in Object(value)
                        ? getRawTag(value)
                        : objectToString(value);
                    }

                    /**
                     * The base implementation of `_.gt` which doesn't coerce arguments.
                     *
                     * @private
                     * @param {*} value The value to compare.
                     * @param {*} other The other value to compare.
                     * @returns {boolean} Returns `true` if `value` is greater than `other`,
                     *  else `false`.
                     */
                    function baseGt(value, other) {
                      return value > other;
                    }

                    /**
                     * The base implementation of `_.has` without support for deep paths.
                     *
                     * @private
                     * @param {Object} [object] The object to query.
                     * @param {Array|string} key The key to check.
                     * @returns {boolean} Returns `true` if `key` exists, else `false`.
                     */
                    function baseHas(object, key) {
                      return object != null && hasOwnProperty.call(object, key);
                    }

                    /**
                     * The base implementation of `_.hasIn` without support for deep paths.
                     *
                     * @private
                     * @param {Object} [object] The object to query.
                     * @param {Array|string} key The key to check.
                     * @returns {boolean} Returns `true` if `key` exists, else `false`.
                     */
                    function baseHasIn(object, key) {
                      return object != null && key in Object(object);
                    }

                    /**
                     * The base implementation of `_.inRange` which doesn't coerce arguments.
                     *
                     * @private
                     * @param {number} number The number to check.
                     * @param {number} start The start of the range.
                     * @param {number} end The end of the range.
                     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
                     */
                    function baseInRange(number, start, end) {
                      return number >= nativeMin(start, end) && number < nativeMax(start, end);
                    }

                    /**
                     * The base implementation of methods like `_.intersection`, without support
                     * for iteratee shorthands, that accepts an array of arrays to inspect.
                     *
                     * @private
                     * @param {Array} arrays The arrays to inspect.
                     * @param {Function} [iteratee] The iteratee invoked per element.
                     * @param {Function} [comparator] The comparator invoked per element.
                     * @returns {Array} Returns the new array of shared values.
                     */
                    function baseIntersection(arrays, iteratee, comparator) {
                      var includes = comparator ? arrayIncludesWith : arrayIncludes,
                        length = arrays[0].length,
                        othLength = arrays.length,
                        othIndex = othLength,
                        caches = Array(othLength),
                        maxLength = Infinity,
                        result = [];

                      while (othIndex--) {
                        var array = arrays[othIndex];
                        if (othIndex && iteratee) {
                          array = arrayMap(array, baseUnary(iteratee));
                        }
                        maxLength = nativeMin(array.length, maxLength);
                        caches[othIndex] =
                          !comparator && (iteratee || (length >= 120 && array.length >= 120))
                            ? new SetCache(othIndex && array)
                            : undefined;
                      }
                      array = arrays[0];

                      var index = -1,
                        seen = caches[0];

                      outer: while (++index < length && result.length < maxLength) {
                        var value = array[index],
                          computed = iteratee ? iteratee(value) : value;

                        value = comparator || value !== 0 ? value : 0;
                        if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                          othIndex = othLength;
                          while (--othIndex) {
                            var cache = caches[othIndex];
                            if (
                              !(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))
                            ) {
                              continue outer;
                            }
                          }
                          if (seen) {
                            seen.push(computed);
                          }
                          result.push(value);
                        }
                      }
                      return result;
                    }

                    /**
                     * The base implementation of `_.invert` and `_.invertBy` which inverts
                     * `object` with values transformed by `iteratee` and set by `setter`.
                     *
                     * @private
                     * @param {Object} object The object to iterate over.
                     * @param {Function} setter The function to set `accumulator` values.
                     * @param {Function} iteratee The iteratee to transform values.
                     * @param {Object} accumulator The initial inverted object.
                     * @returns {Function} Returns `accumulator`.
                     */
                    function baseInverter(object, setter, iteratee, accumulator) {
                      baseForOwn(object, function (value, key, object) {
                        setter(accumulator, iteratee(value), key, object);
                      });
                      return accumulator;
                    }

                    /**
                     * The base implementation of `_.invoke` without support for individual
                     * method arguments.
                     *
                     * @private
                     * @param {Object} object The object to query.
                     * @param {Array|string} path The path of the method to invoke.
                     * @param {Array} args The arguments to invoke the method with.
                     * @returns {*} Returns the result of the invoked method.
                     */
                    function baseInvoke(object, path, args) {
                      path = castPath(path, object);
                      object = parent(object, path);
                      var func = object == null ? object : object[toKey(last(path))];
                      return func == null ? undefined : apply(func, object, args);
                    }

                    /**
                     * The base implementation of `_.isArguments`.
                     *
                     * @private
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
                     */
                    function baseIsArguments(value) {
                      return isObjectLike(value) && baseGetTag(value) == argsTag;
                    }

                    /**
                     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
                     *
                     * @private
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
                     */
                    function baseIsArrayBuffer(value) {
                      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
                    }

                    /**
                     * The base implementation of `_.isDate` without Node.js optimizations.
                     *
                     * @private
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
                     */
                    function baseIsDate(value) {
                      return isObjectLike(value) && baseGetTag(value) == dateTag;
                    }

                    /**
                     * The base implementation of `_.isEqual` which supports partial comparisons
                     * and tracks traversed objects.
                     *
                     * @private
                     * @param {*} value The value to compare.
                     * @param {*} other The other value to compare.
                     * @param {boolean} bitmask The bitmask flags.
                     *  1 - Unordered comparison
                     *  2 - Partial comparison
                     * @param {Function} [customizer] The function to customize comparisons.
                     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
                     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
                     */
                    function baseIsEqual(value, other, bitmask, customizer, stack) {
                      if (value === other) {
                        return true;
                      }
                      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
                        return value !== value && other !== other;
                      }
                      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
                    }

                    /**
                     * A specialized version of `baseIsEqual` for arrays and objects which performs
                     * deep comparisons and tracks traversed objects enabling objects with circular
                     * references to be compared.
                     *
                     * @private
                     * @param {Object} object The object to compare.
                     * @param {Object} other The other object to compare.
                     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
                     * @param {Function} customizer The function to customize comparisons.
                     * @param {Function} equalFunc The function to determine equivalents of values.
                     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
                     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
                     */
                    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
                      var objIsArr = isArray(object),
                        othIsArr = isArray(other),
                        objTag = objIsArr ? arrayTag : getTag(object),
                        othTag = othIsArr ? arrayTag : getTag(other);

                      objTag = objTag == argsTag ? objectTag : objTag;
                      othTag = othTag == argsTag ? objectTag : othTag;

                      var objIsObj = objTag == objectTag,
                        othIsObj = othTag == objectTag,
                        isSameTag = objTag == othTag;

                      if (isSameTag && isBuffer(object)) {
                        if (!isBuffer(other)) {
                          return false;
                        }
                        objIsArr = true;
                        objIsObj = false;
                      }
                      if (isSameTag && !objIsObj) {
                        stack || (stack = new Stack());
                        return objIsArr || isTypedArray(object)
                          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
                          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
                      }
                      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
                          othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

                        if (objIsWrapped || othIsWrapped) {
                          var objUnwrapped = objIsWrapped ? object.value() : object,
                            othUnwrapped = othIsWrapped ? other.value() : other;

                          stack || (stack = new Stack());
                          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                        }
                      }
                      if (!isSameTag) {
                        return false;
                      }
                      stack || (stack = new Stack());
                      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
                    }

                    /**
                     * The base implementation of `_.isMap` without Node.js optimizations.
                     *
                     * @private
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
                     */
                    function baseIsMap(value) {
                      return isObjectLike(value) && getTag(value) == mapTag;
                    }

                    /**
                     * The base implementation of `_.isMatch` without support for iteratee shorthands.
                     *
                     * @private
                     * @param {Object} object The object to inspect.
                     * @param {Object} source The object of property values to match.
                     * @param {Array} matchData The property names, values, and compare flags to match.
                     * @param {Function} [customizer] The function to customize comparisons.
                     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
                     */
                    function baseIsMatch(object, source, matchData, customizer) {
                      var index = matchData.length,
                        length = index,
                        noCustomizer = !customizer;

                      if (object == null) {
                        return !length;
                      }
                      object = Object(object);
                      while (index--) {
                        var data = matchData[index];
                        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
                          return false;
                        }
                      }
                      while (++index < length) {
                        data = matchData[index];
                        var key = data[0],
                          objValue = object[key],
                          srcValue = data[1];

                        if (noCustomizer && data[2]) {
                          if (objValue === undefined && !(key in object)) {
                            return false;
                          }
                        } else {
                          var stack = new Stack();
                          if (customizer) {
                            var result = customizer(objValue, srcValue, key, object, source, stack);
                          }
                          if (
                            !(result === undefined
                              ? baseIsEqual(
                                  srcValue,
                                  objValue,
                                  COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG,
                                  customizer,
                                  stack
                                )
                              : result)
                          ) {
                            return false;
                          }
                        }
                      }
                      return true;
                    }

                    /**
                     * The base implementation of `_.isNative` without bad shim checks.
                     *
                     * @private
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a native function,
                     *  else `false`.
                     */
                    function baseIsNative(value) {
                      if (!isObject(value) || isMasked(value)) {
                        return false;
                      }
                      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
                      return pattern.test(toSource(value));
                    }

                    /**
                     * The base implementation of `_.isRegExp` without Node.js optimizations.
                     *
                     * @private
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
                     */
                    function baseIsRegExp(value) {
                      return isObjectLike(value) && baseGetTag(value) == regexpTag;
                    }

                    /**
                     * The base implementation of `_.isSet` without Node.js optimizations.
                     *
                     * @private
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
                     */
                    function baseIsSet(value) {
                      return isObjectLike(value) && getTag(value) == setTag;
                    }

                    /**
                     * The base implementation of `_.isTypedArray` without Node.js optimizations.
                     *
                     * @private
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
                     */
                    function baseIsTypedArray(value) {
                      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
                    }

                    /**
                     * The base implementation of `_.iteratee`.
                     *
                     * @private
                     * @param {*} [value=_.identity] The value to convert to an iteratee.
                     * @returns {Function} Returns the iteratee.
                     */
                    function baseIteratee(value) {
                      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
                      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
                      if (typeof value == 'function') {
                        return value;
                      }
                      if (value == null) {
                        return identity;
                      }
                      if (typeof value == 'object') {
                        return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
                      }
                      return property(value);
                    }

                    /**
                     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
                     *
                     * @private
                     * @param {Object} object The object to query.
                     * @returns {Array} Returns the array of property names.
                     */
                    function baseKeys(object) {
                      if (!isPrototype(object)) {
                        return nativeKeys(object);
                      }
                      var result = [];
                      for (var key in Object(object)) {
                        if (hasOwnProperty.call(object, key) && key != 'constructor') {
                          result.push(key);
                        }
                      }
                      return result;
                    }

                    /**
                     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
                     *
                     * @private
                     * @param {Object} object The object to query.
                     * @returns {Array} Returns the array of property names.
                     */
                    function baseKeysIn(object) {
                      if (!isObject(object)) {
                        return nativeKeysIn(object);
                      }
                      var isProto = isPrototype(object),
                        result = [];

                      for (var key in object) {
                        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
                          result.push(key);
                        }
                      }
                      return result;
                    }

                    /**
                     * The base implementation of `_.lt` which doesn't coerce arguments.
                     *
                     * @private
                     * @param {*} value The value to compare.
                     * @param {*} other The other value to compare.
                     * @returns {boolean} Returns `true` if `value` is less than `other`,
                     *  else `false`.
                     */
                    function baseLt(value, other) {
                      return value < other;
                    }

                    /**
                     * The base implementation of `_.map` without support for iteratee shorthands.
                     *
                     * @private
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} iteratee The function invoked per iteration.
                     * @returns {Array} Returns the new mapped array.
                     */
                    function baseMap(collection, iteratee) {
                      var index = -1,
                        result = isArrayLike(collection) ? Array(collection.length) : [];

                      baseEach(collection, function (value, key, collection) {
                        result[++index] = iteratee(value, key, collection);
                      });
                      return result;
                    }

                    /**
                     * The base implementation of `_.matches` which doesn't clone `source`.
                     *
                     * @private
                     * @param {Object} source The object of property values to match.
                     * @returns {Function} Returns the new spec function.
                     */
                    function baseMatches(source) {
                      var matchData = getMatchData(source);
                      if (matchData.length == 1 && matchData[0][2]) {
                        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
                      }
                      return function (object) {
                        return object === source || baseIsMatch(object, source, matchData);
                      };
                    }

                    /**
                     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
                     *
                     * @private
                     * @param {string} path The path of the property to get.
                     * @param {*} srcValue The value to match.
                     * @returns {Function} Returns the new spec function.
                     */
                    function baseMatchesProperty(path, srcValue) {
                      if (isKey(path) && isStrictComparable(srcValue)) {
                        return matchesStrictComparable(toKey(path), srcValue);
                      }
                      return function (object) {
                        var objValue = get(object, path);
                        return objValue === undefined && objValue === srcValue
                          ? hasIn(object, path)
                          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
                      };
                    }

                    /**
                     * The base implementation of `_.merge` without support for multiple sources.
                     *
                     * @private
                     * @param {Object} object The destination object.
                     * @param {Object} source The source object.
                     * @param {number} srcIndex The index of `source`.
                     * @param {Function} [customizer] The function to customize merged values.
                     * @param {Object} [stack] Tracks traversed source values and their merged
                     *  counterparts.
                     */
                    function baseMerge(object, source, srcIndex, customizer, stack) {
                      if (object === source) {
                        return;
                      }
                      baseFor(
                        source,
                        function (srcValue, key) {
                          if (isObject(srcValue)) {
                            stack || (stack = new Stack());
                            baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                          } else {
                            var newValue = customizer
                              ? customizer(object[key], srcValue, key + '', object, source, stack)
                              : undefined;

                            if (newValue === undefined) {
                              newValue = srcValue;
                            }
                            assignMergeValue(object, key, newValue);
                          }
                        },
                        keysIn
                      );
                    }

                    /**
                     * A specialized version of `baseMerge` for arrays and objects which performs
                     * deep merges and tracks traversed objects enabling objects with circular
                     * references to be merged.
                     *
                     * @private
                     * @param {Object} object The destination object.
                     * @param {Object} source The source object.
                     * @param {string} key The key of the value to merge.
                     * @param {number} srcIndex The index of `source`.
                     * @param {Function} mergeFunc The function to merge values.
                     * @param {Function} [customizer] The function to customize assigned values.
                     * @param {Object} [stack] Tracks traversed source values and their merged
                     *  counterparts.
                     */
                    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
                      var objValue = object[key],
                        srcValue = source[key],
                        stacked = stack.get(srcValue);

                      if (stacked) {
                        assignMergeValue(object, key, stacked);
                        return;
                      }
                      var newValue = customizer
                        ? customizer(objValue, srcValue, key + '', object, source, stack)
                        : undefined;

                      var isCommon = newValue === undefined;

                      if (isCommon) {
                        var isArr = isArray(srcValue),
                          isBuff = !isArr && isBuffer(srcValue),
                          isTyped = !isArr && !isBuff && isTypedArray(srcValue);

                        newValue = srcValue;
                        if (isArr || isBuff || isTyped) {
                          if (isArray(objValue)) {
                            newValue = objValue;
                          } else if (isArrayLikeObject(objValue)) {
                            newValue = copyArray(objValue);
                          } else if (isBuff) {
                            isCommon = false;
                            newValue = cloneBuffer(srcValue, true);
                          } else if (isTyped) {
                            isCommon = false;
                            newValue = cloneTypedArray(srcValue, true);
                          } else {
                            newValue = [];
                          }
                        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                          newValue = objValue;
                          if (isArguments(objValue)) {
                            newValue = toPlainObject(objValue);
                          } else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
                            newValue = initCloneObject(srcValue);
                          }
                        } else {
                          isCommon = false;
                        }
                      }
                      if (isCommon) {
                        // Recursively merge objects and arrays (susceptible to call stack limits).
                        stack.set(srcValue, newValue);
                        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                        stack['delete'](srcValue);
                      }
                      assignMergeValue(object, key, newValue);
                    }

                    /**
                     * The base implementation of `_.nth` which doesn't coerce arguments.
                     *
                     * @private
                     * @param {Array} array The array to query.
                     * @param {number} n The index of the element to return.
                     * @returns {*} Returns the nth element of `array`.
                     */
                    function baseNth(array, n) {
                      var length = array.length;
                      if (!length) {
                        return;
                      }
                      n += n < 0 ? length : 0;
                      return isIndex(n, length) ? array[n] : undefined;
                    }

                    /**
                     * The base implementation of `_.orderBy` without param guards.
                     *
                     * @private
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
                     * @param {string[]} orders The sort orders of `iteratees`.
                     * @returns {Array} Returns the new sorted array.
                     */
                    function baseOrderBy(collection, iteratees, orders) {
                      var index = -1;
                      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

                      var result = baseMap(collection, function (value, key, collection) {
                        var criteria = arrayMap(iteratees, function (iteratee) {
                          return iteratee(value);
                        });
                        return { criteria: criteria, index: ++index, value: value };
                      });

                      return baseSortBy(result, function (object, other) {
                        return compareMultiple(object, other, orders);
                      });
                    }

                    /**
                     * The base implementation of `_.pick` without support for individual
                     * property identifiers.
                     *
                     * @private
                     * @param {Object} object The source object.
                     * @param {string[]} paths The property paths to pick.
                     * @returns {Object} Returns the new object.
                     */
                    function basePick(object, paths) {
                      return basePickBy(object, paths, function (value, path) {
                        return hasIn(object, path);
                      });
                    }

                    /**
                     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
                     *
                     * @private
                     * @param {Object} object The source object.
                     * @param {string[]} paths The property paths to pick.
                     * @param {Function} predicate The function invoked per property.
                     * @returns {Object} Returns the new object.
                     */
                    function basePickBy(object, paths, predicate) {
                      var index = -1,
                        length = paths.length,
                        result = {};

                      while (++index < length) {
                        var path = paths[index],
                          value = baseGet(object, path);

                        if (predicate(value, path)) {
                          baseSet(result, castPath(path, object), value);
                        }
                      }
                      return result;
                    }

                    /**
                     * A specialized version of `baseProperty` which supports deep paths.
                     *
                     * @private
                     * @param {Array|string} path The path of the property to get.
                     * @returns {Function} Returns the new accessor function.
                     */
                    function basePropertyDeep(path) {
                      return function (object) {
                        return baseGet(object, path);
                      };
                    }

                    /**
                     * The base implementation of `_.pullAllBy` without support for iteratee
                     * shorthands.
                     *
                     * @private
                     * @param {Array} array The array to modify.
                     * @param {Array} values The values to remove.
                     * @param {Function} [iteratee] The iteratee invoked per element.
                     * @param {Function} [comparator] The comparator invoked per element.
                     * @returns {Array} Returns `array`.
                     */
                    function basePullAll(array, values, iteratee, comparator) {
                      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
                        index = -1,
                        length = values.length,
                        seen = array;

                      if (array === values) {
                        values = copyArray(values);
                      }
                      if (iteratee) {
                        seen = arrayMap(array, baseUnary(iteratee));
                      }
                      while (++index < length) {
                        var fromIndex = 0,
                          value = values[index],
                          computed = iteratee ? iteratee(value) : value;

                        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
                          if (seen !== array) {
                            splice.call(seen, fromIndex, 1);
                          }
                          splice.call(array, fromIndex, 1);
                        }
                      }
                      return array;
                    }

                    /**
                     * The base implementation of `_.pullAt` without support for individual
                     * indexes or capturing the removed elements.
                     *
                     * @private
                     * @param {Array} array The array to modify.
                     * @param {number[]} indexes The indexes of elements to remove.
                     * @returns {Array} Returns `array`.
                     */
                    function basePullAt(array, indexes) {
                      var length = array ? indexes.length : 0,
                        lastIndex = length - 1;

                      while (length--) {
                        var index = indexes[length];
                        if (length == lastIndex || index !== previous) {
                          var previous = index;
                          if (isIndex(index)) {
                            splice.call(array, index, 1);
                          } else {
                            baseUnset(array, index);
                          }
                        }
                      }
                      return array;
                    }

                    /**
                     * The base implementation of `_.random` without support for returning
                     * floating-point numbers.
                     *
                     * @private
                     * @param {number} lower The lower bound.
                     * @param {number} upper The upper bound.
                     * @returns {number} Returns the random number.
                     */
                    function baseRandom(lower, upper) {
                      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
                    }

                    /**
                     * The base implementation of `_.range` and `_.rangeRight` which doesn't
                     * coerce arguments.
                     *
                     * @private
                     * @param {number} start The start of the range.
                     * @param {number} end The end of the range.
                     * @param {number} step The value to increment or decrement by.
                     * @param {boolean} [fromRight] Specify iterating from right to left.
                     * @returns {Array} Returns the range of numbers.
                     */
                    function baseRange(start, end, step, fromRight) {
                      var index = -1,
                        length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
                        result = Array(length);

                      while (length--) {
                        result[fromRight ? length : ++index] = start;
                        start += step;
                      }
                      return result;
                    }

                    /**
                     * The base implementation of `_.repeat` which doesn't coerce arguments.
                     *
                     * @private
                     * @param {string} string The string to repeat.
                     * @param {number} n The number of times to repeat the string.
                     * @returns {string} Returns the repeated string.
                     */
                    function baseRepeat(string, n) {
                      var result = '';
                      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
                        return result;
                      }
                      // Leverage the exponentiation by squaring algorithm for a faster repeat.
                      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
                      do {
                        if (n % 2) {
                          result += string;
                        }
                        n = nativeFloor(n / 2);
                        if (n) {
                          string += string;
                        }
                      } while (n);

                      return result;
                    }

                    /**
                     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
                     *
                     * @private
                     * @param {Function} func The function to apply a rest parameter to.
                     * @param {number} [start=func.length-1] The start position of the rest parameter.
                     * @returns {Function} Returns the new function.
                     */
                    function baseRest(func, start) {
                      return setToString(overRest(func, start, identity), func + '');
                    }

                    /**
                     * The base implementation of `_.sample`.
                     *
                     * @private
                     * @param {Array|Object} collection The collection to sample.
                     * @returns {*} Returns the random element.
                     */
                    function baseSample(collection) {
                      return arraySample(values(collection));
                    }

                    /**
                     * The base implementation of `_.sampleSize` without param guards.
                     *
                     * @private
                     * @param {Array|Object} collection The collection to sample.
                     * @param {number} n The number of elements to sample.
                     * @returns {Array} Returns the random elements.
                     */
                    function baseSampleSize(collection, n) {
                      var array = values(collection);
                      return shuffleSelf(array, baseClamp(n, 0, array.length));
                    }

                    /**
                     * The base implementation of `_.set`.
                     *
                     * @private
                     * @param {Object} object The object to modify.
                     * @param {Array|string} path The path of the property to set.
                     * @param {*} value The value to set.
                     * @param {Function} [customizer] The function to customize path creation.
                     * @returns {Object} Returns `object`.
                     */
                    function baseSet(object, path, value, customizer) {
                      if (!isObject(object)) {
                        return object;
                      }
                      path = castPath(path, object);

                      var index = -1,
                        length = path.length,
                        lastIndex = length - 1,
                        nested = object;

                      while (nested != null && ++index < length) {
                        var key = toKey(path[index]),
                          newValue = value;

                        if (index != lastIndex) {
                          var objValue = nested[key];
                          newValue = customizer ? customizer(objValue, key, nested) : undefined;
                          if (newValue === undefined) {
                            newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                          }
                        }
                        assignValue(nested, key, newValue);
                        nested = nested[key];
                      }
                      return object;
                    }

                    /**
                     * The base implementation of `setData` without support for hot loop shorting.
                     *
                     * @private
                     * @param {Function} func The function to associate metadata with.
                     * @param {*} data The metadata.
                     * @returns {Function} Returns `func`.
                     */
                    var baseSetData = !metaMap
                      ? identity
                      : function (func, data) {
                          metaMap.set(func, data);
                          return func;
                        };

                    /**
                     * The base implementation of `setToString` without support for hot loop shorting.
                     *
                     * @private
                     * @param {Function} func The function to modify.
                     * @param {Function} string The `toString` result.
                     * @returns {Function} Returns `func`.
                     */
                    var baseSetToString = !defineProperty
                      ? identity
                      : function (func, string) {
                          return defineProperty(func, 'toString', {
                            configurable: true,
                            enumerable: false,
                            value: constant(string),
                            writable: true
                          });
                        };

                    /**
                     * The base implementation of `_.shuffle`.
                     *
                     * @private
                     * @param {Array|Object} collection The collection to shuffle.
                     * @returns {Array} Returns the new shuffled array.
                     */
                    function baseShuffle(collection) {
                      return shuffleSelf(values(collection));
                    }

                    /**
                     * The base implementation of `_.slice` without an iteratee call guard.
                     *
                     * @private
                     * @param {Array} array The array to slice.
                     * @param {number} [start=0] The start position.
                     * @param {number} [end=array.length] The end position.
                     * @returns {Array} Returns the slice of `array`.
                     */
                    function baseSlice(array, start, end) {
                      var index = -1,
                        length = array.length;

                      if (start < 0) {
                        start = -start > length ? 0 : length + start;
                      }
                      end = end > length ? length : end;
                      if (end < 0) {
                        end += length;
                      }
                      length = start > end ? 0 : (end - start) >>> 0;
                      start >>>= 0;

                      var result = Array(length);
                      while (++index < length) {
                        result[index] = array[index + start];
                      }
                      return result;
                    }

                    /**
                     * The base implementation of `_.some` without support for iteratee shorthands.
                     *
                     * @private
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} predicate The function invoked per iteration.
                     * @returns {boolean} Returns `true` if any element passes the predicate check,
                     *  else `false`.
                     */
                    function baseSome(collection, predicate) {
                      var result;

                      baseEach(collection, function (value, index, collection) {
                        result = predicate(value, index, collection);
                        return !result;
                      });
                      return !!result;
                    }

                    /**
                     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
                     * performs a binary search of `array` to determine the index at which `value`
                     * should be inserted into `array` in order to maintain its sort order.
                     *
                     * @private
                     * @param {Array} array The sorted array to inspect.
                     * @param {*} value The value to evaluate.
                     * @param {boolean} [retHighest] Specify returning the highest qualified index.
                     * @returns {number} Returns the index at which `value` should be inserted
                     *  into `array`.
                     */
                    function baseSortedIndex(array, value, retHighest) {
                      var low = 0,
                        high = array == null ? low : array.length;

                      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                        while (low < high) {
                          var mid = (low + high) >>> 1,
                            computed = array[mid];

                          if (
                            computed !== null &&
                            !isSymbol(computed) &&
                            (retHighest ? computed <= value : computed < value)
                          ) {
                            low = mid + 1;
                          } else {
                            high = mid;
                          }
                        }
                        return high;
                      }
                      return baseSortedIndexBy(array, value, identity, retHighest);
                    }

                    /**
                     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
                     * which invokes `iteratee` for `value` and each element of `array` to compute
                     * their sort ranking. The iteratee is invoked with one argument; (value).
                     *
                     * @private
                     * @param {Array} array The sorted array to inspect.
                     * @param {*} value The value to evaluate.
                     * @param {Function} iteratee The iteratee invoked per element.
                     * @param {boolean} [retHighest] Specify returning the highest qualified index.
                     * @returns {number} Returns the index at which `value` should be inserted
                     *  into `array`.
                     */
                    function baseSortedIndexBy(array, value, iteratee, retHighest) {
                      value = iteratee(value);

                      var low = 0,
                        high = array == null ? 0 : array.length,
                        valIsNaN = value !== value,
                        valIsNull = value === null,
                        valIsSymbol = isSymbol(value),
                        valIsUndefined = value === undefined;

                      while (low < high) {
                        var mid = nativeFloor((low + high) / 2),
                          computed = iteratee(array[mid]),
                          othIsDefined = computed !== undefined,
                          othIsNull = computed === null,
                          othIsReflexive = computed === computed,
                          othIsSymbol = isSymbol(computed);

                        if (valIsNaN) {
                          var setLow = retHighest || othIsReflexive;
                        } else if (valIsUndefined) {
                          setLow = othIsReflexive && (retHighest || othIsDefined);
                        } else if (valIsNull) {
                          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                        } else if (valIsSymbol) {
                          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                        } else if (othIsNull || othIsSymbol) {
                          setLow = false;
                        } else {
                          setLow = retHighest ? computed <= value : computed < value;
                        }
                        if (setLow) {
                          low = mid + 1;
                        } else {
                          high = mid;
                        }
                      }
                      return nativeMin(high, MAX_ARRAY_INDEX);
                    }

                    /**
                     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
                     * support for iteratee shorthands.
                     *
                     * @private
                     * @param {Array} array The array to inspect.
                     * @param {Function} [iteratee] The iteratee invoked per element.
                     * @returns {Array} Returns the new duplicate free array.
                     */
                    function baseSortedUniq(array, iteratee) {
                      var index = -1,
                        length = array.length,
                        resIndex = 0,
                        result = [];

                      while (++index < length) {
                        var value = array[index],
                          computed = iteratee ? iteratee(value) : value;

                        if (!index || !eq(computed, seen)) {
                          var seen = computed;
                          result[resIndex++] = value === 0 ? 0 : value;
                        }
                      }
                      return result;
                    }

                    /**
                     * The base implementation of `_.toNumber` which doesn't ensure correct
                     * conversions of binary, hexadecimal, or octal string values.
                     *
                     * @private
                     * @param {*} value The value to process.
                     * @returns {number} Returns the number.
                     */
                    function baseToNumber(value) {
                      if (typeof value == 'number') {
                        return value;
                      }
                      if (isSymbol(value)) {
                        return NAN;
                      }
                      return +value;
                    }

                    /**
                     * The base implementation of `_.toString` which doesn't convert nullish
                     * values to empty strings.
                     *
                     * @private
                     * @param {*} value The value to process.
                     * @returns {string} Returns the string.
                     */
                    function baseToString(value) {
                      // Exit early for strings to avoid a performance hit in some environments.
                      if (typeof value == 'string') {
                        return value;
                      }
                      if (isArray(value)) {
                        // Recursively convert values (susceptible to call stack limits).
                        return arrayMap(value, baseToString) + '';
                      }
                      if (isSymbol(value)) {
                        return symbolToString ? symbolToString.call(value) : '';
                      }
                      var result = value + '';
                      return result == '0' && 1 / value == -INFINITY ? '-0' : result;
                    }

                    /**
                     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
                     *
                     * @private
                     * @param {Array} array The array to inspect.
                     * @param {Function} [iteratee] The iteratee invoked per element.
                     * @param {Function} [comparator] The comparator invoked per element.
                     * @returns {Array} Returns the new duplicate free array.
                     */
                    function baseUniq(array, iteratee, comparator) {
                      var index = -1,
                        includes = arrayIncludes,
                        length = array.length,
                        isCommon = true,
                        result = [],
                        seen = result;

                      if (comparator) {
                        isCommon = false;
                        includes = arrayIncludesWith;
                      } else if (length >= LARGE_ARRAY_SIZE) {
                        var set = iteratee ? null : createSet(array);
                        if (set) {
                          return setToArray(set);
                        }
                        isCommon = false;
                        includes = cacheHas;
                        seen = new SetCache();
                      } else {
                        seen = iteratee ? [] : result;
                      }
                      outer: while (++index < length) {
                        var value = array[index],
                          computed = iteratee ? iteratee(value) : value;

                        value = comparator || value !== 0 ? value : 0;
                        if (isCommon && computed === computed) {
                          var seenIndex = seen.length;
                          while (seenIndex--) {
                            if (seen[seenIndex] === computed) {
                              continue outer;
                            }
                          }
                          if (iteratee) {
                            seen.push(computed);
                          }
                          result.push(value);
                        } else if (!includes(seen, computed, comparator)) {
                          if (seen !== result) {
                            seen.push(computed);
                          }
                          result.push(value);
                        }
                      }
                      return result;
                    }

                    /**
                     * The base implementation of `_.unset`.
                     *
                     * @private
                     * @param {Object} object The object to modify.
                     * @param {Array|string} path The property path to unset.
                     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
                     */
                    function baseUnset(object, path) {
                      path = castPath(path, object);
                      object = parent(object, path);
                      return object == null || delete object[toKey(last(path))];
                    }

                    /**
                     * The base implementation of `_.update`.
                     *
                     * @private
                     * @param {Object} object The object to modify.
                     * @param {Array|string} path The path of the property to update.
                     * @param {Function} updater The function to produce the updated value.
                     * @param {Function} [customizer] The function to customize path creation.
                     * @returns {Object} Returns `object`.
                     */
                    function baseUpdate(object, path, updater, customizer) {
                      return baseSet(object, path, updater(baseGet(object, path)), customizer);
                    }

                    /**
                     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
                     * without support for iteratee shorthands.
                     *
                     * @private
                     * @param {Array} array The array to query.
                     * @param {Function} predicate The function invoked per iteration.
                     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
                     * @param {boolean} [fromRight] Specify iterating from right to left.
                     * @returns {Array} Returns the slice of `array`.
                     */
                    function baseWhile(array, predicate, isDrop, fromRight) {
                      var length = array.length,
                        index = fromRight ? length : -1;

                      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}

                      return isDrop
                        ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length)
                        : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
                    }

                    /**
                     * The base implementation of `wrapperValue` which returns the result of
                     * performing a sequence of actions on the unwrapped `value`, where each
                     * successive action is supplied the return value of the previous.
                     *
                     * @private
                     * @param {*} value The unwrapped value.
                     * @param {Array} actions Actions to perform to resolve the unwrapped value.
                     * @returns {*} Returns the resolved value.
                     */
                    function baseWrapperValue(value, actions) {
                      var result = value;
                      if (result instanceof LazyWrapper) {
                        result = result.value();
                      }
                      return arrayReduce(
                        actions,
                        function (result, action) {
                          return action.func.apply(action.thisArg, arrayPush([result], action.args));
                        },
                        result
                      );
                    }

                    /**
                     * The base implementation of methods like `_.xor`, without support for
                     * iteratee shorthands, that accepts an array of arrays to inspect.
                     *
                     * @private
                     * @param {Array} arrays The arrays to inspect.
                     * @param {Function} [iteratee] The iteratee invoked per element.
                     * @param {Function} [comparator] The comparator invoked per element.
                     * @returns {Array} Returns the new array of values.
                     */
                    function baseXor(arrays, iteratee, comparator) {
                      var length = arrays.length;
                      if (length < 2) {
                        return length ? baseUniq(arrays[0]) : [];
                      }
                      var index = -1,
                        result = Array(length);

                      while (++index < length) {
                        var array = arrays[index],
                          othIndex = -1;

                        while (++othIndex < length) {
                          if (othIndex != index) {
                            result[index] = baseDifference(
                              result[index] || array,
                              arrays[othIndex],
                              iteratee,
                              comparator
                            );
                          }
                        }
                      }
                      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
                    }

                    /**
                     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
                     *
                     * @private
                     * @param {Array} props The property identifiers.
                     * @param {Array} values The property values.
                     * @param {Function} assignFunc The function to assign values.
                     * @returns {Object} Returns the new object.
                     */
                    function baseZipObject(props, values, assignFunc) {
                      var index = -1,
                        length = props.length,
                        valsLength = values.length,
                        result = {};

                      while (++index < length) {
                        var value = index < valsLength ? values[index] : undefined;
                        assignFunc(result, props[index], value);
                      }
                      return result;
                    }

                    /**
                     * Casts `value` to an empty array if it's not an array like object.
                     *
                     * @private
                     * @param {*} value The value to inspect.
                     * @returns {Array|Object} Returns the cast array-like object.
                     */
                    function castArrayLikeObject(value) {
                      return isArrayLikeObject(value) ? value : [];
                    }

                    /**
                     * Casts `value` to `identity` if it's not a function.
                     *
                     * @private
                     * @param {*} value The value to inspect.
                     * @returns {Function} Returns cast function.
                     */
                    function castFunction(value) {
                      return typeof value == 'function' ? value : identity;
                    }

                    /**
                     * Casts `value` to a path array if it's not one.
                     *
                     * @private
                     * @param {*} value The value to inspect.
                     * @param {Object} [object] The object to query keys on.
                     * @returns {Array} Returns the cast property path array.
                     */
                    function castPath(value, object) {
                      if (isArray(value)) {
                        return value;
                      }
                      return isKey(value, object) ? [value] : stringToPath(toString(value));
                    }

                    /**
                     * A `baseRest` alias which can be replaced with `identity` by module
                     * replacement plugins.
                     *
                     * @private
                     * @type {Function}
                     * @param {Function} func The function to apply a rest parameter to.
                     * @returns {Function} Returns the new function.
                     */
                    var castRest = baseRest;

                    /**
                     * Casts `array` to a slice if it's needed.
                     *
                     * @private
                     * @param {Array} array The array to inspect.
                     * @param {number} start The start position.
                     * @param {number} [end=array.length] The end position.
                     * @returns {Array} Returns the cast slice.
                     */
                    function castSlice(array, start, end) {
                      var length = array.length;
                      end = end === undefined ? length : end;
                      return !start && end >= length ? array : baseSlice(array, start, end);
                    }

                    /**
                     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
                     *
                     * @private
                     * @param {number|Object} id The timer id or timeout object of the timer to clear.
                     */
                    var clearTimeout =
                      ctxClearTimeout ||
                      function (id) {
                        return root.clearTimeout(id);
                      };

                    /**
                     * Creates a clone of  `buffer`.
                     *
                     * @private
                     * @param {Buffer} buffer The buffer to clone.
                     * @param {boolean} [isDeep] Specify a deep clone.
                     * @returns {Buffer} Returns the cloned buffer.
                     */
                    function cloneBuffer(buffer, isDeep) {
                      if (isDeep) {
                        return buffer.slice();
                      }
                      var length = buffer.length,
                        result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

                      buffer.copy(result);
                      return result;
                    }

                    /**
                     * Creates a clone of `arrayBuffer`.
                     *
                     * @private
                     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
                     * @returns {ArrayBuffer} Returns the cloned array buffer.
                     */
                    function cloneArrayBuffer(arrayBuffer) {
                      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
                      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
                      return result;
                    }

                    /**
                     * Creates a clone of `dataView`.
                     *
                     * @private
                     * @param {Object} dataView The data view to clone.
                     * @param {boolean} [isDeep] Specify a deep clone.
                     * @returns {Object} Returns the cloned data view.
                     */
                    function cloneDataView(dataView, isDeep) {
                      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
                      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
                    }

                    /**
                     * Creates a clone of `map`.
                     *
                     * @private
                     * @param {Object} map The map to clone.
                     * @param {Function} cloneFunc The function to clone values.
                     * @param {boolean} [isDeep] Specify a deep clone.
                     * @returns {Object} Returns the cloned map.
                     */
                    function cloneMap(map, isDeep, cloneFunc) {
                      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
                      return arrayReduce(array, addMapEntry, new map.constructor());
                    }

                    /**
                     * Creates a clone of `regexp`.
                     *
                     * @private
                     * @param {Object} regexp The regexp to clone.
                     * @returns {Object} Returns the cloned regexp.
                     */
                    function cloneRegExp(regexp) {
                      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
                      result.lastIndex = regexp.lastIndex;
                      return result;
                    }

                    /**
                     * Creates a clone of `set`.
                     *
                     * @private
                     * @param {Object} set The set to clone.
                     * @param {Function} cloneFunc The function to clone values.
                     * @param {boolean} [isDeep] Specify a deep clone.
                     * @returns {Object} Returns the cloned set.
                     */
                    function cloneSet(set, isDeep, cloneFunc) {
                      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
                      return arrayReduce(array, addSetEntry, new set.constructor());
                    }

                    /**
                     * Creates a clone of the `symbol` object.
                     *
                     * @private
                     * @param {Object} symbol The symbol object to clone.
                     * @returns {Object} Returns the cloned symbol object.
                     */
                    function cloneSymbol(symbol) {
                      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
                    }

                    /**
                     * Creates a clone of `typedArray`.
                     *
                     * @private
                     * @param {Object} typedArray The typed array to clone.
                     * @param {boolean} [isDeep] Specify a deep clone.
                     * @returns {Object} Returns the cloned typed array.
                     */
                    function cloneTypedArray(typedArray, isDeep) {
                      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
                      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
                    }

                    /**
                     * Compares values to sort them in ascending order.
                     *
                     * @private
                     * @param {*} value The value to compare.
                     * @param {*} other The other value to compare.
                     * @returns {number} Returns the sort order indicator for `value`.
                     */
                    function compareAscending(value, other) {
                      if (value !== other) {
                        var valIsDefined = value !== undefined,
                          valIsNull = value === null,
                          valIsReflexive = value === value,
                          valIsSymbol = isSymbol(value);

                        var othIsDefined = other !== undefined,
                          othIsNull = other === null,
                          othIsReflexive = other === other,
                          othIsSymbol = isSymbol(other);

                        if (
                          (!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
                          (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
                          (valIsNull && othIsDefined && othIsReflexive) ||
                          (!valIsDefined && othIsReflexive) ||
                          !valIsReflexive
                        ) {
                          return 1;
                        }
                        if (
                          (!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
                          (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
                          (othIsNull && valIsDefined && valIsReflexive) ||
                          (!othIsDefined && valIsReflexive) ||
                          !othIsReflexive
                        ) {
                          return -1;
                        }
                      }
                      return 0;
                    }

                    /**
                     * Used by `_.orderBy` to compare multiple properties of a value to another
                     * and stable sort them.
                     *
                     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
                     * specify an order of "desc" for descending or "asc" for ascending sort order
                     * of corresponding values.
                     *
                     * @private
                     * @param {Object} object The object to compare.
                     * @param {Object} other The other object to compare.
                     * @param {boolean[]|string[]} orders The order to sort by for each property.
                     * @returns {number} Returns the sort order indicator for `object`.
                     */
                    function compareMultiple(object, other, orders) {
                      var index = -1,
                        objCriteria = object.criteria,
                        othCriteria = other.criteria,
                        length = objCriteria.length,
                        ordersLength = orders.length;

                      while (++index < length) {
                        var result = compareAscending(objCriteria[index], othCriteria[index]);
                        if (result) {
                          if (index >= ordersLength) {
                            return result;
                          }
                          var order = orders[index];
                          return result * (order == 'desc' ? -1 : 1);
                        }
                      }
                      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
                      // that causes it, under certain circumstances, to provide the same value for
                      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
                      // for more details.
                      //
                      // This also ensures a stable sort in V8 and other engines.
                      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
                      return object.index - other.index;
                    }

                    /**
                     * Creates an array that is the composition of partially applied arguments,
                     * placeholders, and provided arguments into a single array of arguments.
                     *
                     * @private
                     * @param {Array} args The provided arguments.
                     * @param {Array} partials The arguments to prepend to those provided.
                     * @param {Array} holders The `partials` placeholder indexes.
                     * @params {boolean} [isCurried] Specify composing for a curried function.
                     * @returns {Array} Returns the new array of composed arguments.
                     */
                    function composeArgs(args, partials, holders, isCurried) {
                      var argsIndex = -1,
                        argsLength = args.length,
                        holdersLength = holders.length,
                        leftIndex = -1,
                        leftLength = partials.length,
                        rangeLength = nativeMax(argsLength - holdersLength, 0),
                        result = Array(leftLength + rangeLength),
                        isUncurried = !isCurried;

                      while (++leftIndex < leftLength) {
                        result[leftIndex] = partials[leftIndex];
                      }
                      while (++argsIndex < holdersLength) {
                        if (isUncurried || argsIndex < argsLength) {
                          result[holders[argsIndex]] = args[argsIndex];
                        }
                      }
                      while (rangeLength--) {
                        result[leftIndex++] = args[argsIndex++];
                      }
                      return result;
                    }

                    /**
                     * This function is like `composeArgs` except that the arguments composition
                     * is tailored for `_.partialRight`.
                     *
                     * @private
                     * @param {Array} args The provided arguments.
                     * @param {Array} partials The arguments to append to those provided.
                     * @param {Array} holders The `partials` placeholder indexes.
                     * @params {boolean} [isCurried] Specify composing for a curried function.
                     * @returns {Array} Returns the new array of composed arguments.
                     */
                    function composeArgsRight(args, partials, holders, isCurried) {
                      var argsIndex = -1,
                        argsLength = args.length,
                        holdersIndex = -1,
                        holdersLength = holders.length,
                        rightIndex = -1,
                        rightLength = partials.length,
                        rangeLength = nativeMax(argsLength - holdersLength, 0),
                        result = Array(rangeLength + rightLength),
                        isUncurried = !isCurried;

                      while (++argsIndex < rangeLength) {
                        result[argsIndex] = args[argsIndex];
                      }
                      var offset = argsIndex;
                      while (++rightIndex < rightLength) {
                        result[offset + rightIndex] = partials[rightIndex];
                      }
                      while (++holdersIndex < holdersLength) {
                        if (isUncurried || argsIndex < argsLength) {
                          result[offset + holders[holdersIndex]] = args[argsIndex++];
                        }
                      }
                      return result;
                    }

                    /**
                     * Copies the values of `source` to `array`.
                     *
                     * @private
                     * @param {Array} source The array to copy values from.
                     * @param {Array} [array=[]] The array to copy values to.
                     * @returns {Array} Returns `array`.
                     */
                    function copyArray(source, array) {
                      var index = -1,
                        length = source.length;

                      array || (array = Array(length));
                      while (++index < length) {
                        array[index] = source[index];
                      }
                      return array;
                    }

                    /**
                     * Copies properties of `source` to `object`.
                     *
                     * @private
                     * @param {Object} source The object to copy properties from.
                     * @param {Array} props The property identifiers to copy.
                     * @param {Object} [object={}] The object to copy properties to.
                     * @param {Function} [customizer] The function to customize copied values.
                     * @returns {Object} Returns `object`.
                     */
                    function copyObject(source, props, object, customizer) {
                      var isNew = !object;
                      object || (object = {});

                      var index = -1,
                        length = props.length;

                      while (++index < length) {
                        var key = props[index];

                        var newValue = customizer
                          ? customizer(object[key], source[key], key, object, source)
                          : undefined;

                        if (newValue === undefined) {
                          newValue = source[key];
                        }
                        if (isNew) {
                          baseAssignValue(object, key, newValue);
                        } else {
                          assignValue(object, key, newValue);
                        }
                      }
                      return object;
                    }

                    /**
                     * Copies own symbols of `source` to `object`.
                     *
                     * @private
                     * @param {Object} source The object to copy symbols from.
                     * @param {Object} [object={}] The object to copy symbols to.
                     * @returns {Object} Returns `object`.
                     */
                    function copySymbols(source, object) {
                      return copyObject(source, getSymbols(source), object);
                    }

                    /**
                     * Copies own and inherited symbols of `source` to `object`.
                     *
                     * @private
                     * @param {Object} source The object to copy symbols from.
                     * @param {Object} [object={}] The object to copy symbols to.
                     * @returns {Object} Returns `object`.
                     */
                    function copySymbolsIn(source, object) {
                      return copyObject(source, getSymbolsIn(source), object);
                    }

                    /**
                     * Creates a function like `_.groupBy`.
                     *
                     * @private
                     * @param {Function} setter The function to set accumulator values.
                     * @param {Function} [initializer] The accumulator object initializer.
                     * @returns {Function} Returns the new aggregator function.
                     */
                    function createAggregator(setter, initializer) {
                      return function (collection, iteratee) {
                        var func = isArray(collection) ? arrayAggregator : baseAggregator,
                          accumulator = initializer ? initializer() : {};

                        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
                      };
                    }

                    /**
                     * Creates a function like `_.assign`.
                     *
                     * @private
                     * @param {Function} assigner The function to assign values.
                     * @returns {Function} Returns the new assigner function.
                     */
                    function createAssigner(assigner) {
                      return baseRest(function (object, sources) {
                        var index = -1,
                          length = sources.length,
                          customizer = length > 1 ? sources[length - 1] : undefined,
                          guard = length > 2 ? sources[2] : undefined;

                        customizer =
                          assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

                        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                          customizer = length < 3 ? undefined : customizer;
                          length = 1;
                        }
                        object = Object(object);
                        while (++index < length) {
                          var source = sources[index];
                          if (source) {
                            assigner(object, source, index, customizer);
                          }
                        }
                        return object;
                      });
                    }

                    /**
                     * Creates a `baseEach` or `baseEachRight` function.
                     *
                     * @private
                     * @param {Function} eachFunc The function to iterate over a collection.
                     * @param {boolean} [fromRight] Specify iterating from right to left.
                     * @returns {Function} Returns the new base function.
                     */
                    function createBaseEach(eachFunc, fromRight) {
                      return function (collection, iteratee) {
                        if (collection == null) {
                          return collection;
                        }
                        if (!isArrayLike(collection)) {
                          return eachFunc(collection, iteratee);
                        }
                        var length = collection.length,
                          index = fromRight ? length : -1,
                          iterable = Object(collection);

                        while (fromRight ? index-- : ++index < length) {
                          if (iteratee(iterable[index], index, iterable) === false) {
                            break;
                          }
                        }
                        return collection;
                      };
                    }

                    /**
                     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
                     *
                     * @private
                     * @param {boolean} [fromRight] Specify iterating from right to left.
                     * @returns {Function} Returns the new base function.
                     */
                    function createBaseFor(fromRight) {
                      return function (object, iteratee, keysFunc) {
                        var index = -1,
                          iterable = Object(object),
                          props = keysFunc(object),
                          length = props.length;

                        while (length--) {
                          var key = props[fromRight ? length : ++index];
                          if (iteratee(iterable[key], key, iterable) === false) {
                            break;
                          }
                        }
                        return object;
                      };
                    }

                    /**
                     * Creates a function that wraps `func` to invoke it with the optional `this`
                     * binding of `thisArg`.
                     *
                     * @private
                     * @param {Function} func The function to wrap.
                     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
                     * @param {*} [thisArg] The `this` binding of `func`.
                     * @returns {Function} Returns the new wrapped function.
                     */
                    function createBind(func, bitmask, thisArg) {
                      var isBind = bitmask & WRAP_BIND_FLAG,
                        Ctor = createCtor(func);

                      function wrapper() {
                        var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                        return fn.apply(isBind ? thisArg : this, arguments);
                      }
                      return wrapper;
                    }

                    /**
                     * Creates a function like `_.lowerFirst`.
                     *
                     * @private
                     * @param {string} methodName The name of the `String` case method to use.
                     * @returns {Function} Returns the new case function.
                     */
                    function createCaseFirst(methodName) {
                      return function (string) {
                        string = toString(string);

                        var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;

                        var chr = strSymbols ? strSymbols[0] : string.charAt(0);

                        var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);

                        return chr[methodName]() + trailing;
                      };
                    }

                    /**
                     * Creates a function like `_.camelCase`.
                     *
                     * @private
                     * @param {Function} callback The function to combine each word.
                     * @returns {Function} Returns the new compounder function.
                     */
                    function createCompounder(callback) {
                      return function (string) {
                        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
                      };
                    }

                    /**
                     * Creates a function that produces an instance of `Ctor` regardless of
                     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
                     *
                     * @private
                     * @param {Function} Ctor The constructor to wrap.
                     * @returns {Function} Returns the new wrapped function.
                     */
                    function createCtor(Ctor) {
                      return function () {
                        // Use a `switch` statement to work with class constructors. See
                        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                        // for more details.
                        var args = arguments;
                        switch (args.length) {
                          case 0:
                            return new Ctor();
                          case 1:
                            return new Ctor(args[0]);
                          case 2:
                            return new Ctor(args[0], args[1]);
                          case 3:
                            return new Ctor(args[0], args[1], args[2]);
                          case 4:
                            return new Ctor(args[0], args[1], args[2], args[3]);
                          case 5:
                            return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                          case 6:
                            return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                          case 7:
                            return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                        }
                        var thisBinding = baseCreate(Ctor.prototype),
                          result = Ctor.apply(thisBinding, args);

                        // Mimic the constructor's `return` behavior.
                        // See https://es5.github.io/#x13.2.2 for more details.
                        return isObject(result) ? result : thisBinding;
                      };
                    }

                    /**
                     * Creates a function that wraps `func` to enable currying.
                     *
                     * @private
                     * @param {Function} func The function to wrap.
                     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
                     * @param {number} arity The arity of `func`.
                     * @returns {Function} Returns the new wrapped function.
                     */
                    function createCurry(func, bitmask, arity) {
                      var Ctor = createCtor(func);

                      function wrapper() {
                        var length = arguments.length,
                          args = Array(length),
                          index = length,
                          placeholder = getHolder(wrapper);

                        while (index--) {
                          args[index] = arguments[index];
                        }
                        var holders =
                          length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder
                            ? []
                            : replaceHolders(args, placeholder);

                        length -= holders.length;
                        if (length < arity) {
                          return createRecurry(
                            func,
                            bitmask,
                            createHybrid,
                            wrapper.placeholder,
                            undefined,
                            args,
                            holders,
                            undefined,
                            undefined,
                            arity - length
                          );
                        }
                        var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                        return apply(fn, this, args);
                      }
                      return wrapper;
                    }

                    /**
                     * Creates a `_.find` or `_.findLast` function.
                     *
                     * @private
                     * @param {Function} findIndexFunc The function to find the collection index.
                     * @returns {Function} Returns the new find function.
                     */
                    function createFind(findIndexFunc) {
                      return function (collection, predicate, fromIndex) {
                        var iterable = Object(collection);
                        if (!isArrayLike(collection)) {
                          var iteratee = getIteratee(predicate, 3);
                          collection = keys(collection);
                          predicate = function (key) {
                            return iteratee(iterable[key], key, iterable);
                          };
                        }
                        var index = findIndexFunc(collection, predicate, fromIndex);
                        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
                      };
                    }

                    /**
                     * Creates a `_.flow` or `_.flowRight` function.
                     *
                     * @private
                     * @param {boolean} [fromRight] Specify iterating from right to left.
                     * @returns {Function} Returns the new flow function.
                     */
                    function createFlow(fromRight) {
                      return flatRest(function (funcs) {
                        var length = funcs.length,
                          index = length,
                          prereq = LodashWrapper.prototype.thru;

                        if (fromRight) {
                          funcs.reverse();
                        }
                        while (index--) {
                          var func = funcs[index];
                          if (typeof func != 'function') {
                            throw new TypeError(FUNC_ERROR_TEXT);
                          }
                          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
                            var wrapper = new LodashWrapper([], true);
                          }
                        }
                        index = wrapper ? index : length;
                        while (++index < length) {
                          func = funcs[index];

                          var funcName = getFuncName(func),
                            data = funcName == 'wrapper' ? getData(func) : undefined;

                          if (
                            data &&
                            isLaziable(data[0]) &&
                            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                            !data[4].length &&
                            data[9] == 1
                          ) {
                            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                          } else {
                            wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                          }
                        }
                        return function () {
                          var args = arguments,
                            value = args[0];

                          if (wrapper && args.length == 1 && isArray(value)) {
                            return wrapper.plant(value).value();
                          }
                          var index = 0,
                            result = length ? funcs[index].apply(this, args) : value;

                          while (++index < length) {
                            result = funcs[index].call(this, result);
                          }
                          return result;
                        };
                      });
                    }

                    /**
                     * Creates a function that wraps `func` to invoke it with optional `this`
                     * binding of `thisArg`, partial application, and currying.
                     *
                     * @private
                     * @param {Function|string} func The function or method name to wrap.
                     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
                     * @param {*} [thisArg] The `this` binding of `func`.
                     * @param {Array} [partials] The arguments to prepend to those provided to
                     *  the new function.
                     * @param {Array} [holders] The `partials` placeholder indexes.
                     * @param {Array} [partialsRight] The arguments to append to those provided
                     *  to the new function.
                     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
                     * @param {Array} [argPos] The argument positions of the new function.
                     * @param {number} [ary] The arity cap of `func`.
                     * @param {number} [arity] The arity of `func`.
                     * @returns {Function} Returns the new wrapped function.
                     */
                    function createHybrid(
                      func,
                      bitmask,
                      thisArg,
                      partials,
                      holders,
                      partialsRight,
                      holdersRight,
                      argPos,
                      ary,
                      arity
                    ) {
                      var isAry = bitmask & WRAP_ARY_FLAG,
                        isBind = bitmask & WRAP_BIND_FLAG,
                        isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
                        isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
                        isFlip = bitmask & WRAP_FLIP_FLAG,
                        Ctor = isBindKey ? undefined : createCtor(func);

                      function wrapper() {
                        var length = arguments.length,
                          args = Array(length),
                          index = length;

                        while (index--) {
                          args[index] = arguments[index];
                        }
                        if (isCurried) {
                          var placeholder = getHolder(wrapper),
                            holdersCount = countHolders(args, placeholder);
                        }
                        if (partials) {
                          args = composeArgs(args, partials, holders, isCurried);
                        }
                        if (partialsRight) {
                          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                        }
                        length -= holdersCount;
                        if (isCurried && length < arity) {
                          var newHolders = replaceHolders(args, placeholder);
                          return createRecurry(
                            func,
                            bitmask,
                            createHybrid,
                            wrapper.placeholder,
                            thisArg,
                            args,
                            newHolders,
                            argPos,
                            ary,
                            arity - length
                          );
                        }
                        var thisBinding = isBind ? thisArg : this,
                          fn = isBindKey ? thisBinding[func] : func;

                        length = args.length;
                        if (argPos) {
                          args = reorder(args, argPos);
                        } else if (isFlip && length > 1) {
                          args.reverse();
                        }
                        if (isAry && ary < length) {
                          args.length = ary;
                        }
                        if (this && this !== root && this instanceof wrapper) {
                          fn = Ctor || createCtor(fn);
                        }
                        return fn.apply(thisBinding, args);
                      }
                      return wrapper;
                    }

                    /**
                     * Creates a function like `_.invertBy`.
                     *
                     * @private
                     * @param {Function} setter The function to set accumulator values.
                     * @param {Function} toIteratee The function to resolve iteratees.
                     * @returns {Function} Returns the new inverter function.
                     */
                    function createInverter(setter, toIteratee) {
                      return function (object, iteratee) {
                        return baseInverter(object, setter, toIteratee(iteratee), {});
                      };
                    }

                    /**
                     * Creates a function that performs a mathematical operation on two values.
                     *
                     * @private
                     * @param {Function} operator The function to perform the operation.
                     * @param {number} [defaultValue] The value used for `undefined` arguments.
                     * @returns {Function} Returns the new mathematical operation function.
                     */
                    function createMathOperation(operator, defaultValue) {
                      return function (value, other) {
                        var result;
                        if (value === undefined && other === undefined) {
                          return defaultValue;
                        }
                        if (value !== undefined) {
                          result = value;
                        }
                        if (other !== undefined) {
                          if (result === undefined) {
                            return other;
                          }
                          if (typeof value == 'string' || typeof other == 'string') {
                            value = baseToString(value);
                            other = baseToString(other);
                          } else {
                            value = baseToNumber(value);
                            other = baseToNumber(other);
                          }
                          result = operator(value, other);
                        }
                        return result;
                      };
                    }

                    /**
                     * Creates a function like `_.over`.
                     *
                     * @private
                     * @param {Function} arrayFunc The function to iterate over iteratees.
                     * @returns {Function} Returns the new over function.
                     */
                    function createOver(arrayFunc) {
                      return flatRest(function (iteratees) {
                        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                        return baseRest(function (args) {
                          var thisArg = this;
                          return arrayFunc(iteratees, function (iteratee) {
                            return apply(iteratee, thisArg, args);
                          });
                        });
                      });
                    }

                    /**
                     * Creates the padding for `string` based on `length`. The `chars` string
                     * is truncated if the number of characters exceeds `length`.
                     *
                     * @private
                     * @param {number} length The padding length.
                     * @param {string} [chars=' '] The string used as padding.
                     * @returns {string} Returns the padding for `string`.
                     */
                    function createPadding(length, chars) {
                      chars = chars === undefined ? ' ' : baseToString(chars);

                      var charsLength = chars.length;
                      if (charsLength < 2) {
                        return charsLength ? baseRepeat(chars, length) : chars;
                      }
                      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
                      return hasUnicode(chars)
                        ? castSlice(stringToArray(result), 0, length).join('')
                        : result.slice(0, length);
                    }

                    /**
                     * Creates a function that wraps `func` to invoke it with the `this` binding
                     * of `thisArg` and `partials` prepended to the arguments it receives.
                     *
                     * @private
                     * @param {Function} func The function to wrap.
                     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
                     * @param {*} thisArg The `this` binding of `func`.
                     * @param {Array} partials The arguments to prepend to those provided to
                     *  the new function.
                     * @returns {Function} Returns the new wrapped function.
                     */
                    function createPartial(func, bitmask, thisArg, partials) {
                      var isBind = bitmask & WRAP_BIND_FLAG,
                        Ctor = createCtor(func);

                      function wrapper() {
                        var argsIndex = -1,
                          argsLength = arguments.length,
                          leftIndex = -1,
                          leftLength = partials.length,
                          args = Array(leftLength + argsLength),
                          fn = this && this !== root && this instanceof wrapper ? Ctor : func;

                        while (++leftIndex < leftLength) {
                          args[leftIndex] = partials[leftIndex];
                        }
                        while (argsLength--) {
                          args[leftIndex++] = arguments[++argsIndex];
                        }
                        return apply(fn, isBind ? thisArg : this, args);
                      }
                      return wrapper;
                    }

                    /**
                     * Creates a `_.range` or `_.rangeRight` function.
                     *
                     * @private
                     * @param {boolean} [fromRight] Specify iterating from right to left.
                     * @returns {Function} Returns the new range function.
                     */
                    function createRange(fromRight) {
                      return function (start, end, step) {
                        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
                          end = step = undefined;
                        }
                        // Ensure the sign of `-0` is preserved.
                        start = toFinite(start);
                        if (end === undefined) {
                          end = start;
                          start = 0;
                        } else {
                          end = toFinite(end);
                        }
                        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
                        return baseRange(start, end, step, fromRight);
                      };
                    }

                    /**
                     * Creates a function that performs a relational operation on two values.
                     *
                     * @private
                     * @param {Function} operator The function to perform the operation.
                     * @returns {Function} Returns the new relational operation function.
                     */
                    function createRelationalOperation(operator) {
                      return function (value, other) {
                        if (!(typeof value == 'string' && typeof other == 'string')) {
                          value = toNumber(value);
                          other = toNumber(other);
                        }
                        return operator(value, other);
                      };
                    }

                    /**
                     * Creates a function that wraps `func` to continue currying.
                     *
                     * @private
                     * @param {Function} func The function to wrap.
                     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
                     * @param {Function} wrapFunc The function to create the `func` wrapper.
                     * @param {*} placeholder The placeholder value.
                     * @param {*} [thisArg] The `this` binding of `func`.
                     * @param {Array} [partials] The arguments to prepend to those provided to
                     *  the new function.
                     * @param {Array} [holders] The `partials` placeholder indexes.
                     * @param {Array} [argPos] The argument positions of the new function.
                     * @param {number} [ary] The arity cap of `func`.
                     * @param {number} [arity] The arity of `func`.
                     * @returns {Function} Returns the new wrapped function.
                     */
                    function createRecurry(
                      func,
                      bitmask,
                      wrapFunc,
                      placeholder,
                      thisArg,
                      partials,
                      holders,
                      argPos,
                      ary,
                      arity
                    ) {
                      var isCurry = bitmask & WRAP_CURRY_FLAG,
                        newHolders = isCurry ? holders : undefined,
                        newHoldersRight = isCurry ? undefined : holders,
                        newPartials = isCurry ? partials : undefined,
                        newPartialsRight = isCurry ? undefined : partials;

                      bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
                      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

                      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
                        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
                      }
                      var newData = [
                        func,
                        bitmask,
                        thisArg,
                        newPartials,
                        newHolders,
                        newPartialsRight,
                        newHoldersRight,
                        argPos,
                        ary,
                        arity
                      ];

                      var result = wrapFunc.apply(undefined, newData);
                      if (isLaziable(func)) {
                        setData(result, newData);
                      }
                      result.placeholder = placeholder;
                      return setWrapToString(result, func, bitmask);
                    }

                    /**
                     * Creates a function like `_.round`.
                     *
                     * @private
                     * @param {string} methodName The name of the `Math` method to use when rounding.
                     * @returns {Function} Returns the new round function.
                     */
                    function createRound(methodName) {
                      var func = Math[methodName];
                      return function (number, precision) {
                        number = toNumber(number);
                        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                        if (precision) {
                          // Shift with exponential notation to avoid floating-point issues.
                          // See [MDN](https://mdn.io/round#Examples) for more details.
                          var pair = (toString(number) + 'e').split('e'),
                            value = func(pair[0] + 'e' + (+pair[1] + precision));

                          pair = (toString(value) + 'e').split('e');
                          return +(pair[0] + 'e' + (+pair[1] - precision));
                        }
                        return func(number);
                      };
                    }

                    /**
                     * Creates a set object of `values`.
                     *
                     * @private
                     * @param {Array} values The values to add to the set.
                     * @returns {Object} Returns the new set.
                     */
                    var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY)
                      ? noop
                      : function (values) {
                          return new Set(values);
                        };

                    /**
                     * Creates a `_.toPairs` or `_.toPairsIn` function.
                     *
                     * @private
                     * @param {Function} keysFunc The function to get the keys of a given object.
                     * @returns {Function} Returns the new pairs function.
                     */
                    function createToPairs(keysFunc) {
                      return function (object) {
                        var tag = getTag(object);
                        if (tag == mapTag) {
                          return mapToArray(object);
                        }
                        if (tag == setTag) {
                          return setToPairs(object);
                        }
                        return baseToPairs(object, keysFunc(object));
                      };
                    }

                    /**
                     * Creates a function that either curries or invokes `func` with optional
                     * `this` binding and partially applied arguments.
                     *
                     * @private
                     * @param {Function|string} func The function or method name to wrap.
                     * @param {number} bitmask The bitmask flags.
                     *    1 - `_.bind`
                     *    2 - `_.bindKey`
                     *    4 - `_.curry` or `_.curryRight` of a bound function
                     *    8 - `_.curry`
                     *   16 - `_.curryRight`
                     *   32 - `_.partial`
                     *   64 - `_.partialRight`
                     *  128 - `_.rearg`
                     *  256 - `_.ary`
                     *  512 - `_.flip`
                     * @param {*} [thisArg] The `this` binding of `func`.
                     * @param {Array} [partials] The arguments to be partially applied.
                     * @param {Array} [holders] The `partials` placeholder indexes.
                     * @param {Array} [argPos] The argument positions of the new function.
                     * @param {number} [ary] The arity cap of `func`.
                     * @param {number} [arity] The arity of `func`.
                     * @returns {Function} Returns the new wrapped function.
                     */
                    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
                      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
                      if (!isBindKey && typeof func != 'function') {
                        throw new TypeError(FUNC_ERROR_TEXT);
                      }
                      var length = partials ? partials.length : 0;
                      if (!length) {
                        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                        partials = holders = undefined;
                      }
                      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
                      arity = arity === undefined ? arity : toInteger(arity);
                      length -= holders ? holders.length : 0;

                      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                        var partialsRight = partials,
                          holdersRight = holders;

                        partials = holders = undefined;
                      }
                      var data = isBindKey ? undefined : getData(func);

                      var newData = [
                        func,
                        bitmask,
                        thisArg,
                        partials,
                        holders,
                        partialsRight,
                        holdersRight,
                        argPos,
                        ary,
                        arity
                      ];

                      if (data) {
                        mergeData(newData, data);
                      }
                      func = newData[0];
                      bitmask = newData[1];
                      thisArg = newData[2];
                      partials = newData[3];
                      holders = newData[4];
                      arity = newData[9] =
                        newData[9] === undefined ? (isBindKey ? 0 : func.length) : nativeMax(newData[9] - length, 0);

                      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
                        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
                      }
                      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
                        var result = createBind(func, bitmask, thisArg);
                      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
                        result = createCurry(func, bitmask, arity);
                      } else if (
                        (bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) &&
                        !holders.length
                      ) {
                        result = createPartial(func, bitmask, thisArg, partials);
                      } else {
                        result = createHybrid.apply(undefined, newData);
                      }
                      var setter = data ? baseSetData : setData;
                      return setWrapToString(setter(result, newData), func, bitmask);
                    }

                    /**
                     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
                     * of source objects to the destination object for all destination properties
                     * that resolve to `undefined`.
                     *
                     * @private
                     * @param {*} objValue The destination value.
                     * @param {*} srcValue The source value.
                     * @param {string} key The key of the property to assign.
                     * @param {Object} object The parent object of `objValue`.
                     * @returns {*} Returns the value to assign.
                     */
                    function customDefaultsAssignIn(objValue, srcValue, key, object) {
                      if (
                        objValue === undefined ||
                        (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))
                      ) {
                        return srcValue;
                      }
                      return objValue;
                    }

                    /**
                     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
                     * objects into destination objects that are passed thru.
                     *
                     * @private
                     * @param {*} objValue The destination value.
                     * @param {*} srcValue The source value.
                     * @param {string} key The key of the property to merge.
                     * @param {Object} object The parent object of `objValue`.
                     * @param {Object} source The parent object of `srcValue`.
                     * @param {Object} [stack] Tracks traversed source values and their merged
                     *  counterparts.
                     * @returns {*} Returns the value to assign.
                     */
                    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
                      if (isObject(objValue) && isObject(srcValue)) {
                        // Recursively merge objects and arrays (susceptible to call stack limits).
                        stack.set(srcValue, objValue);
                        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                        stack['delete'](srcValue);
                      }
                      return objValue;
                    }

                    /**
                     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
                     * objects.
                     *
                     * @private
                     * @param {*} value The value to inspect.
                     * @param {string} key The key of the property to inspect.
                     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
                     */
                    function customOmitClone(value) {
                      return isPlainObject(value) ? undefined : value;
                    }

                    /**
                     * A specialized version of `baseIsEqualDeep` for arrays with support for
                     * partial deep comparisons.
                     *
                     * @private
                     * @param {Array} array The array to compare.
                     * @param {Array} other The other array to compare.
                     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
                     * @param {Function} customizer The function to customize comparisons.
                     * @param {Function} equalFunc The function to determine equivalents of values.
                     * @param {Object} stack Tracks traversed `array` and `other` objects.
                     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
                     */
                    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
                      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
                        arrLength = array.length,
                        othLength = other.length;

                      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
                        return false;
                      }
                      // Assume cyclic values are equal.
                      var stacked = stack.get(array);
                      if (stacked && stack.get(other)) {
                        return stacked == other;
                      }
                      var index = -1,
                        result = true,
                        seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;

                      stack.set(array, other);
                      stack.set(other, array);

                      // Ignore non-index properties.
                      while (++index < arrLength) {
                        var arrValue = array[index],
                          othValue = other[index];

                        if (customizer) {
                          var compared = isPartial
                            ? customizer(othValue, arrValue, index, other, array, stack)
                            : customizer(arrValue, othValue, index, array, other, stack);
                        }
                        if (compared !== undefined) {
                          if (compared) {
                            continue;
                          }
                          result = false;
                          break;
                        }
                        // Recursively compare arrays (susceptible to call stack limits).
                        if (seen) {
                          if (
                            !arraySome(other, function (othValue, othIndex) {
                              if (
                                !cacheHas(seen, othIndex) &&
                                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))
                              ) {
                                return seen.push(othIndex);
                              }
                            })
                          ) {
                            result = false;
                            break;
                          }
                        } else if (
                          !(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))
                        ) {
                          result = false;
                          break;
                        }
                      }
                      stack['delete'](array);
                      stack['delete'](other);
                      return result;
                    }

                    /**
                     * A specialized version of `baseIsEqualDeep` for comparing objects of
                     * the same `toStringTag`.
                     *
                     * **Note:** This function only supports comparing values with tags of
                     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
                     *
                     * @private
                     * @param {Object} object The object to compare.
                     * @param {Object} other The other object to compare.
                     * @param {string} tag The `toStringTag` of the objects to compare.
                     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
                     * @param {Function} customizer The function to customize comparisons.
                     * @param {Function} equalFunc The function to determine equivalents of values.
                     * @param {Object} stack Tracks traversed `object` and `other` objects.
                     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
                     */
                    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
                      switch (tag) {
                        case dataViewTag:
                          if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                            return false;
                          }
                          object = object.buffer;
                          other = other.buffer;

                        case arrayBufferTag:
                          if (
                            object.byteLength != other.byteLength ||
                            !equalFunc(new Uint8Array(object), new Uint8Array(other))
                          ) {
                            return false;
                          }
                          return true;

                        case boolTag:
                        case dateTag:
                        case numberTag:
                          // Coerce booleans to `1` or `0` and dates to milliseconds.
                          // Invalid dates are coerced to `NaN`.
                          return eq(+object, +other);

                        case errorTag:
                          return object.name == other.name && object.message == other.message;

                        case regexpTag:
                        case stringTag:
                          // Coerce regexes to strings and treat strings, primitives and objects,
                          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                          // for more details.
                          return object == other + '';

                        case mapTag:
                          var convert = mapToArray;

                        case setTag:
                          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                          convert || (convert = setToArray);

                          if (object.size != other.size && !isPartial) {
                            return false;
                          }
                          // Assume cyclic values are equal.
                          var stacked = stack.get(object);
                          if (stacked) {
                            return stacked == other;
                          }
                          bitmask |= COMPARE_UNORDERED_FLAG;

                          // Recursively compare objects (susceptible to call stack limits).
                          stack.set(object, other);
                          var result = equalArrays(
                            convert(object),
                            convert(other),
                            bitmask,
                            customizer,
                            equalFunc,
                            stack
                          );
                          stack['delete'](object);
                          return result;

                        case symbolTag:
                          if (symbolValueOf) {
                            return symbolValueOf.call(object) == symbolValueOf.call(other);
                          }
                      }
                      return false;
                    }

                    /**
                     * A specialized version of `baseIsEqualDeep` for objects with support for
                     * partial deep comparisons.
                     *
                     * @private
                     * @param {Object} object The object to compare.
                     * @param {Object} other The other object to compare.
                     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
                     * @param {Function} customizer The function to customize comparisons.
                     * @param {Function} equalFunc The function to determine equivalents of values.
                     * @param {Object} stack Tracks traversed `object` and `other` objects.
                     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
                     */
                    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
                      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
                        objProps = getAllKeys(object),
                        objLength = objProps.length,
                        othProps = getAllKeys(other),
                        othLength = othProps.length;

                      if (objLength != othLength && !isPartial) {
                        return false;
                      }
                      var index = objLength;
                      while (index--) {
                        var key = objProps[index];
                        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
                          return false;
                        }
                      }
                      // Assume cyclic values are equal.
                      var stacked = stack.get(object);
                      if (stacked && stack.get(other)) {
                        return stacked == other;
                      }
                      var result = true;
                      stack.set(object, other);
                      stack.set(other, object);

                      var skipCtor = isPartial;
                      while (++index < objLength) {
                        key = objProps[index];
                        var objValue = object[key],
                          othValue = other[key];

                        if (customizer) {
                          var compared = isPartial
                            ? customizer(othValue, objValue, key, other, object, stack)
                            : customizer(objValue, othValue, key, object, other, stack);
                        }
                        // Recursively compare objects (susceptible to call stack limits).
                        if (
                          !(compared === undefined
                            ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack)
                            : compared)
                        ) {
                          result = false;
                          break;
                        }
                        skipCtor || (skipCtor = key == 'constructor');
                      }
                      if (result && !skipCtor) {
                        var objCtor = object.constructor,
                          othCtor = other.constructor;

                        // Non `Object` object instances with different constructors are not equal.
                        if (
                          objCtor != othCtor &&
                          'constructor' in object &&
                          'constructor' in other &&
                          !(
                            typeof objCtor == 'function' &&
                            objCtor instanceof objCtor &&
                            typeof othCtor == 'function' &&
                            othCtor instanceof othCtor
                          )
                        ) {
                          result = false;
                        }
                      }
                      stack['delete'](object);
                      stack['delete'](other);
                      return result;
                    }

                    /**
                     * A specialized version of `baseRest` which flattens the rest array.
                     *
                     * @private
                     * @param {Function} func The function to apply a rest parameter to.
                     * @returns {Function} Returns the new function.
                     */
                    function flatRest(func) {
                      return setToString(overRest(func, undefined, flatten), func + '');
                    }

                    /**
                     * Creates an array of own enumerable property names and symbols of `object`.
                     *
                     * @private
                     * @param {Object} object The object to query.
                     * @returns {Array} Returns the array of property names and symbols.
                     */
                    function getAllKeys(object) {
                      return baseGetAllKeys(object, keys, getSymbols);
                    }

                    /**
                     * Creates an array of own and inherited enumerable property names and
                     * symbols of `object`.
                     *
                     * @private
                     * @param {Object} object The object to query.
                     * @returns {Array} Returns the array of property names and symbols.
                     */
                    function getAllKeysIn(object) {
                      return baseGetAllKeys(object, keysIn, getSymbolsIn);
                    }

                    /**
                     * Gets metadata for `func`.
                     *
                     * @private
                     * @param {Function} func The function to query.
                     * @returns {*} Returns the metadata for `func`.
                     */
                    var getData = !metaMap
                      ? noop
                      : function (func) {
                          return metaMap.get(func);
                        };

                    /**
                     * Gets the name of `func`.
                     *
                     * @private
                     * @param {Function} func The function to query.
                     * @returns {string} Returns the function name.
                     */
                    function getFuncName(func) {
                      var result = func.name + '',
                        array = realNames[result],
                        length = hasOwnProperty.call(realNames, result) ? array.length : 0;

                      while (length--) {
                        var data = array[length],
                          otherFunc = data.func;
                        if (otherFunc == null || otherFunc == func) {
                          return data.name;
                        }
                      }
                      return result;
                    }

                    /**
                     * Gets the argument placeholder value for `func`.
                     *
                     * @private
                     * @param {Function} func The function to inspect.
                     * @returns {*} Returns the placeholder value.
                     */
                    function getHolder(func) {
                      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
                      return object.placeholder;
                    }

                    /**
                     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
                     * this function returns the custom method, otherwise it returns `baseIteratee`.
                     * If arguments are provided, the chosen function is invoked with them and
                     * its result is returned.
                     *
                     * @private
                     * @param {*} [value] The value to convert to an iteratee.
                     * @param {number} [arity] The arity of the created iteratee.
                     * @returns {Function} Returns the chosen function or its result.
                     */
                    function getIteratee() {
                      var result = lodash.iteratee || iteratee;
                      result = result === iteratee ? baseIteratee : result;
                      return arguments.length ? result(arguments[0], arguments[1]) : result;
                    }

                    /**
                     * Gets the data for `map`.
                     *
                     * @private
                     * @param {Object} map The map to query.
                     * @param {string} key The reference key.
                     * @returns {*} Returns the map data.
                     */
                    function getMapData(map, key) {
                      var data = map.__data__;
                      return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
                    }

                    /**
                     * Gets the property names, values, and compare flags of `object`.
                     *
                     * @private
                     * @param {Object} object The object to query.
                     * @returns {Array} Returns the match data of `object`.
                     */
                    function getMatchData(object) {
                      var result = keys(object),
                        length = result.length;

                      while (length--) {
                        var key = result[length],
                          value = object[key];

                        result[length] = [key, value, isStrictComparable(value)];
                      }
                      return result;
                    }

                    /**
                     * Gets the native function at `key` of `object`.
                     *
                     * @private
                     * @param {Object} object The object to query.
                     * @param {string} key The key of the method to get.
                     * @returns {*} Returns the function if it's native, else `undefined`.
                     */
                    function getNative(object, key) {
                      var value = getValue(object, key);
                      return baseIsNative(value) ? value : undefined;
                    }

                    /**
                     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
                     *
                     * @private
                     * @param {*} value The value to query.
                     * @returns {string} Returns the raw `toStringTag`.
                     */
                    function getRawTag(value) {
                      var isOwn = hasOwnProperty.call(value, symToStringTag),
                        tag = value[symToStringTag];

                      try {
                        value[symToStringTag] = undefined;
                        var unmasked = true;
                      } catch (e) {}

                      var result = nativeObjectToString.call(value);
                      if (unmasked) {
                        if (isOwn) {
                          value[symToStringTag] = tag;
                        } else {
                          delete value[symToStringTag];
                        }
                      }
                      return result;
                    }

                    /**
                     * Creates an array of the own enumerable symbols of `object`.
                     *
                     * @private
                     * @param {Object} object The object to query.
                     * @returns {Array} Returns the array of symbols.
                     */
                    var getSymbols = !nativeGetSymbols
                      ? stubArray
                      : function (object) {
                          if (object == null) {
                            return [];
                          }
                          object = Object(object);
                          return arrayFilter(nativeGetSymbols(object), function (symbol) {
                            return propertyIsEnumerable.call(object, symbol);
                          });
                        };

                    /**
                     * Creates an array of the own and inherited enumerable symbols of `object`.
                     *
                     * @private
                     * @param {Object} object The object to query.
                     * @returns {Array} Returns the array of symbols.
                     */
                    var getSymbolsIn = !nativeGetSymbols
                      ? stubArray
                      : function (object) {
                          var result = [];
                          while (object) {
                            arrayPush(result, getSymbols(object));
                            object = getPrototype(object);
                          }
                          return result;
                        };

                    /**
                     * Gets the `toStringTag` of `value`.
                     *
                     * @private
                     * @param {*} value The value to query.
                     * @returns {string} Returns the `toStringTag`.
                     */
                    var getTag = baseGetTag;

                    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
                    if (
                      (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
                      (Map && getTag(new Map()) != mapTag) ||
                      (Promise && getTag(Promise.resolve()) != promiseTag) ||
                      (Set && getTag(new Set()) != setTag) ||
                      (WeakMap && getTag(new WeakMap()) != weakMapTag)
                    ) {
                      getTag = function (value) {
                        var result = baseGetTag(value),
                          Ctor = result == objectTag ? value.constructor : undefined,
                          ctorString = Ctor ? toSource(Ctor) : '';

                        if (ctorString) {
                          switch (ctorString) {
                            case dataViewCtorString:
                              return dataViewTag;
                            case mapCtorString:
                              return mapTag;
                            case promiseCtorString:
                              return promiseTag;
                            case setCtorString:
                              return setTag;
                            case weakMapCtorString:
                              return weakMapTag;
                          }
                        }
                        return result;
                      };
                    }

                    /**
                     * Gets the view, applying any `transforms` to the `start` and `end` positions.
                     *
                     * @private
                     * @param {number} start The start of the view.
                     * @param {number} end The end of the view.
                     * @param {Array} transforms The transformations to apply to the view.
                     * @returns {Object} Returns an object containing the `start` and `end`
                     *  positions of the view.
                     */
                    function getView(start, end, transforms) {
                      var index = -1,
                        length = transforms.length;

                      while (++index < length) {
                        var data = transforms[index],
                          size = data.size;

                        switch (data.type) {
                          case 'drop':
                            start += size;
                            break;
                          case 'dropRight':
                            end -= size;
                            break;
                          case 'take':
                            end = nativeMin(end, start + size);
                            break;
                          case 'takeRight':
                            start = nativeMax(start, end - size);
                            break;
                        }
                      }
                      return { start: start, end: end };
                    }

                    /**
                     * Extracts wrapper details from the `source` body comment.
                     *
                     * @private
                     * @param {string} source The source to inspect.
                     * @returns {Array} Returns the wrapper details.
                     */
                    function getWrapDetails(source) {
                      var match = source.match(reWrapDetails);
                      return match ? match[1].split(reSplitDetails) : [];
                    }

                    /**
                     * Checks if `path` exists on `object`.
                     *
                     * @private
                     * @param {Object} object The object to query.
                     * @param {Array|string} path The path to check.
                     * @param {Function} hasFunc The function to check properties.
                     * @returns {boolean} Returns `true` if `path` exists, else `false`.
                     */
                    function hasPath(object, path, hasFunc) {
                      path = castPath(path, object);

                      var index = -1,
                        length = path.length,
                        result = false;

                      while (++index < length) {
                        var key = toKey(path[index]);
                        if (!(result = object != null && hasFunc(object, key))) {
                          break;
                        }
                        object = object[key];
                      }
                      if (result || ++index != length) {
                        return result;
                      }
                      length = object == null ? 0 : object.length;
                      return (
                        !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object))
                      );
                    }

                    /**
                     * Initializes an array clone.
                     *
                     * @private
                     * @param {Array} array The array to clone.
                     * @returns {Array} Returns the initialized clone.
                     */
                    function initCloneArray(array) {
                      var length = array.length,
                        result = array.constructor(length);

                      // Add properties assigned by `RegExp#exec`.
                      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                        result.index = array.index;
                        result.input = array.input;
                      }
                      return result;
                    }

                    /**
                     * Initializes an object clone.
                     *
                     * @private
                     * @param {Object} object The object to clone.
                     * @returns {Object} Returns the initialized clone.
                     */
                    function initCloneObject(object) {
                      return typeof object.constructor == 'function' && !isPrototype(object)
                        ? baseCreate(getPrototype(object))
                        : {};
                    }

                    /**
                     * Initializes an object clone based on its `toStringTag`.
                     *
                     * **Note:** This function only supports cloning values with tags of
                     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
                     *
                     * @private
                     * @param {Object} object The object to clone.
                     * @param {string} tag The `toStringTag` of the object to clone.
                     * @param {Function} cloneFunc The function to clone values.
                     * @param {boolean} [isDeep] Specify a deep clone.
                     * @returns {Object} Returns the initialized clone.
                     */
                    function initCloneByTag(object, tag, cloneFunc, isDeep) {
                      var Ctor = object.constructor;
                      switch (tag) {
                        case arrayBufferTag:
                          return cloneArrayBuffer(object);

                        case boolTag:
                        case dateTag:
                          return new Ctor(+object);

                        case dataViewTag:
                          return cloneDataView(object, isDeep);

                        case float32Tag:
                        case float64Tag:
                        case int8Tag:
                        case int16Tag:
                        case int32Tag:
                        case uint8Tag:
                        case uint8ClampedTag:
                        case uint16Tag:
                        case uint32Tag:
                          return cloneTypedArray(object, isDeep);

                        case mapTag:
                          return cloneMap(object, isDeep, cloneFunc);

                        case numberTag:
                        case stringTag:
                          return new Ctor(object);

                        case regexpTag:
                          return cloneRegExp(object);

                        case setTag:
                          return cloneSet(object, isDeep, cloneFunc);

                        case symbolTag:
                          return cloneSymbol(object);
                      }
                    }

                    /**
                     * Inserts wrapper `details` in a comment at the top of the `source` body.
                     *
                     * @private
                     * @param {string} source The source to modify.
                     * @returns {Array} details The details to insert.
                     * @returns {string} Returns the modified source.
                     */
                    function insertWrapDetails(source, details) {
                      var length = details.length;
                      if (!length) {
                        return source;
                      }
                      var lastIndex = length - 1;
                      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
                      details = details.join(length > 2 ? ', ' : ' ');
                      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
                    }

                    /**
                     * Checks if `value` is a flattenable `arguments` object or array.
                     *
                     * @private
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
                     */
                    function isFlattenable(value) {
                      return (
                        isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol])
                      );
                    }

                    /**
                     * Checks if `value` is a valid array-like index.
                     *
                     * @private
                     * @param {*} value The value to check.
                     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
                     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
                     */
                    function isIndex(value, length) {
                      length = length == null ? MAX_SAFE_INTEGER : length;
                      return (
                        !!length &&
                        (typeof value == 'number' || reIsUint.test(value)) &&
                        value > -1 &&
                        value % 1 == 0 &&
                        value < length
                      );
                    }

                    /**
                     * Checks if the given arguments are from an iteratee call.
                     *
                     * @private
                     * @param {*} value The potential iteratee value argument.
                     * @param {*} index The potential iteratee index or key argument.
                     * @param {*} object The potential iteratee object argument.
                     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
                     *  else `false`.
                     */
                    function isIterateeCall(value, index, object) {
                      if (!isObject(object)) {
                        return false;
                      }
                      var type = typeof index;
                      if (
                        type == 'number'
                          ? isArrayLike(object) && isIndex(index, object.length)
                          : type == 'string' && index in object
                      ) {
                        return eq(object[index], value);
                      }
                      return false;
                    }

                    /**
                     * Checks if `value` is a property name and not a property path.
                     *
                     * @private
                     * @param {*} value The value to check.
                     * @param {Object} [object] The object to query keys on.
                     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
                     */
                    function isKey(value, object) {
                      if (isArray(value)) {
                        return false;
                      }
                      var type = typeof value;
                      if (
                        type == 'number' ||
                        type == 'symbol' ||
                        type == 'boolean' ||
                        value == null ||
                        isSymbol(value)
                      ) {
                        return true;
                      }
                      return (
                        reIsPlainProp.test(value) ||
                        !reIsDeepProp.test(value) ||
                        (object != null && value in Object(object))
                      );
                    }

                    /**
                     * Checks if `value` is suitable for use as unique object key.
                     *
                     * @private
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
                     */
                    function isKeyable(value) {
                      var type = typeof value;
                      return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean'
                        ? value !== '__proto__'
                        : value === null;
                    }

                    /**
                     * Checks if `func` has a lazy counterpart.
                     *
                     * @private
                     * @param {Function} func The function to check.
                     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
                     *  else `false`.
                     */
                    function isLaziable(func) {
                      var funcName = getFuncName(func),
                        other = lodash[funcName];

                      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
                        return false;
                      }
                      if (func === other) {
                        return true;
                      }
                      var data = getData(other);
                      return !!data && func === data[0];
                    }

                    /**
                     * Checks if `func` has its source masked.
                     *
                     * @private
                     * @param {Function} func The function to check.
                     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
                     */
                    function isMasked(func) {
                      return !!maskSrcKey && maskSrcKey in func;
                    }

                    /**
                     * Checks if `func` is capable of being masked.
                     *
                     * @private
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
                     */
                    var isMaskable = coreJsData ? isFunction : stubFalse;

                    /**
                     * Checks if `value` is likely a prototype object.
                     *
                     * @private
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
                     */
                    function isPrototype(value) {
                      var Ctor = value && value.constructor,
                        proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

                      return value === proto;
                    }

                    /**
                     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
                     *
                     * @private
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` if suitable for strict
                     *  equality comparisons, else `false`.
                     */
                    function isStrictComparable(value) {
                      return value === value && !isObject(value);
                    }

                    /**
                     * A specialized version of `matchesProperty` for source values suitable
                     * for strict equality comparisons, i.e. `===`.
                     *
                     * @private
                     * @param {string} key The key of the property to get.
                     * @param {*} srcValue The value to match.
                     * @returns {Function} Returns the new spec function.
                     */
                    function matchesStrictComparable(key, srcValue) {
                      return function (object) {
                        if (object == null) {
                          return false;
                        }
                        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
                      };
                    }

                    /**
                     * A specialized version of `_.memoize` which clears the memoized function's
                     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
                     *
                     * @private
                     * @param {Function} func The function to have its output memoized.
                     * @returns {Function} Returns the new memoized function.
                     */
                    function memoizeCapped(func) {
                      var result = memoize(func, function (key) {
                        if (cache.size === MAX_MEMOIZE_SIZE) {
                          cache.clear();
                        }
                        return key;
                      });

                      var cache = result.cache;
                      return result;
                    }

                    /**
                     * Merges the function metadata of `source` into `data`.
                     *
                     * Merging metadata reduces the number of wrappers used to invoke a function.
                     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
                     * may be applied regardless of execution order. Methods like `_.ary` and
                     * `_.rearg` modify function arguments, making the order in which they are
                     * executed important, preventing the merging of metadata. However, we make
                     * an exception for a safe combined case where curried functions have `_.ary`
                     * and or `_.rearg` applied.
                     *
                     * @private
                     * @param {Array} data The destination metadata.
                     * @param {Array} source The source metadata.
                     * @returns {Array} Returns `data`.
                     */
                    function mergeData(data, source) {
                      var bitmask = data[1],
                        srcBitmask = source[1],
                        newBitmask = bitmask | srcBitmask,
                        isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

                      var isCombo =
                        (srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG) ||
                        (srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8]) ||
                        (srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) &&
                          source[7].length <= source[8] &&
                          bitmask == WRAP_CURRY_FLAG);

                      // Exit early if metadata can't be merged.
                      if (!(isCommon || isCombo)) {
                        return data;
                      }
                      // Use source `thisArg` if available.
                      if (srcBitmask & WRAP_BIND_FLAG) {
                        data[2] = source[2];
                        // Set when currying a bound function.
                        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
                      }
                      // Compose partial arguments.
                      var value = source[3];
                      if (value) {
                        var partials = data[3];
                        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
                      }
                      // Compose partial right arguments.
                      value = source[5];
                      if (value) {
                        partials = data[5];
                        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
                      }
                      // Use source `argPos` if available.
                      value = source[7];
                      if (value) {
                        data[7] = value;
                      }
                      // Use source `ary` if it's smaller.
                      if (srcBitmask & WRAP_ARY_FLAG) {
                        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
                      }
                      // Use source `arity` if one is not provided.
                      if (data[9] == null) {
                        data[9] = source[9];
                      }
                      // Use source `func` and merge bitmasks.
                      data[0] = source[0];
                      data[1] = newBitmask;

                      return data;
                    }

                    /**
                     * This function is like
                     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
                     * except that it includes inherited enumerable properties.
                     *
                     * @private
                     * @param {Object} object The object to query.
                     * @returns {Array} Returns the array of property names.
                     */
                    function nativeKeysIn(object) {
                      var result = [];
                      if (object != null) {
                        for (var key in Object(object)) {
                          result.push(key);
                        }
                      }
                      return result;
                    }

                    /**
                     * Converts `value` to a string using `Object.prototype.toString`.
                     *
                     * @private
                     * @param {*} value The value to convert.
                     * @returns {string} Returns the converted string.
                     */
                    function objectToString(value) {
                      return nativeObjectToString.call(value);
                    }

                    /**
                     * A specialized version of `baseRest` which transforms the rest array.
                     *
                     * @private
                     * @param {Function} func The function to apply a rest parameter to.
                     * @param {number} [start=func.length-1] The start position of the rest parameter.
                     * @param {Function} transform The rest array transform.
                     * @returns {Function} Returns the new function.
                     */
                    function overRest(func, start, transform) {
                      start = nativeMax(start === undefined ? func.length - 1 : start, 0);
                      return function () {
                        var args = arguments,
                          index = -1,
                          length = nativeMax(args.length - start, 0),
                          array = Array(length);

                        while (++index < length) {
                          array[index] = args[start + index];
                        }
                        index = -1;
                        var otherArgs = Array(start + 1);
                        while (++index < start) {
                          otherArgs[index] = args[index];
                        }
                        otherArgs[start] = transform(array);
                        return apply(func, this, otherArgs);
                      };
                    }

                    /**
                     * Gets the parent value at `path` of `object`.
                     *
                     * @private
                     * @param {Object} object The object to query.
                     * @param {Array} path The path to get the parent value of.
                     * @returns {*} Returns the parent value.
                     */
                    function parent(object, path) {
                      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
                    }

                    /**
                     * Reorder `array` according to the specified indexes where the element at
                     * the first index is assigned as the first element, the element at
                     * the second index is assigned as the second element, and so on.
                     *
                     * @private
                     * @param {Array} array The array to reorder.
                     * @param {Array} indexes The arranged array indexes.
                     * @returns {Array} Returns `array`.
                     */
                    function reorder(array, indexes) {
                      var arrLength = array.length,
                        length = nativeMin(indexes.length, arrLength),
                        oldArray = copyArray(array);

                      while (length--) {
                        var index = indexes[length];
                        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
                      }
                      return array;
                    }

                    /**
                     * Sets metadata for `func`.
                     *
                     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
                     * period of time, it will trip its breaker and transition to an identity
                     * function to avoid garbage collection pauses in V8. See
                     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
                     * for more details.
                     *
                     * @private
                     * @param {Function} func The function to associate metadata with.
                     * @param {*} data The metadata.
                     * @returns {Function} Returns `func`.
                     */
                    var setData = shortOut(baseSetData);

                    /**
                     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
                     *
                     * @private
                     * @param {Function} func The function to delay.
                     * @param {number} wait The number of milliseconds to delay invocation.
                     * @returns {number|Object} Returns the timer id or timeout object.
                     */
                    var setTimeout =
                      ctxSetTimeout ||
                      function (func, wait) {
                        return root.setTimeout(func, wait);
                      };

                    /**
                     * Sets the `toString` method of `func` to return `string`.
                     *
                     * @private
                     * @param {Function} func The function to modify.
                     * @param {Function} string The `toString` result.
                     * @returns {Function} Returns `func`.
                     */
                    var setToString = shortOut(baseSetToString);

                    /**
                     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
                     * with wrapper details in a comment at the top of the source body.
                     *
                     * @private
                     * @param {Function} wrapper The function to modify.
                     * @param {Function} reference The reference function.
                     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
                     * @returns {Function} Returns `wrapper`.
                     */
                    function setWrapToString(wrapper, reference, bitmask) {
                      var source = reference + '';
                      return setToString(
                        wrapper,
                        insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask))
                      );
                    }

                    /**
                     * Creates a function that'll short out and invoke `identity` instead
                     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
                     * milliseconds.
                     *
                     * @private
                     * @param {Function} func The function to restrict.
                     * @returns {Function} Returns the new shortable function.
                     */
                    function shortOut(func) {
                      var count = 0,
                        lastCalled = 0;

                      return function () {
                        var stamp = nativeNow(),
                          remaining = HOT_SPAN - (stamp - lastCalled);

                        lastCalled = stamp;
                        if (remaining > 0) {
                          if (++count >= HOT_COUNT) {
                            return arguments[0];
                          }
                        } else {
                          count = 0;
                        }
                        return func.apply(undefined, arguments);
                      };
                    }

                    /**
                     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
                     *
                     * @private
                     * @param {Array} array The array to shuffle.
                     * @param {number} [size=array.length] The size of `array`.
                     * @returns {Array} Returns `array`.
                     */
                    function shuffleSelf(array, size) {
                      var index = -1,
                        length = array.length,
                        lastIndex = length - 1;

                      size = size === undefined ? length : size;
                      while (++index < size) {
                        var rand = baseRandom(index, lastIndex),
                          value = array[rand];

                        array[rand] = array[index];
                        array[index] = value;
                      }
                      array.length = size;
                      return array;
                    }

                    /**
                     * Converts `string` to a property path array.
                     *
                     * @private
                     * @param {string} string The string to convert.
                     * @returns {Array} Returns the property path array.
                     */
                    var stringToPath = memoizeCapped(function (string) {
                      var result = [];
                      if (reLeadingDot.test(string)) {
                        result.push('');
                      }
                      string.replace(rePropName, function (match, number, quote, string) {
                        result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
                      });
                      return result;
                    });

                    /**
                     * Converts `value` to a string key if it's not a string or symbol.
                     *
                     * @private
                     * @param {*} value The value to inspect.
                     * @returns {string|symbol} Returns the key.
                     */
                    function toKey(value) {
                      if (typeof value == 'string' || isSymbol(value)) {
                        return value;
                      }
                      var result = value + '';
                      return result == '0' && 1 / value == -INFINITY ? '-0' : result;
                    }

                    /**
                     * Converts `func` to its source code.
                     *
                     * @private
                     * @param {Function} func The function to convert.
                     * @returns {string} Returns the source code.
                     */
                    function toSource(func) {
                      if (func != null) {
                        try {
                          return funcToString.call(func);
                        } catch (e) {}
                        try {
                          return func + '';
                        } catch (e) {}
                      }
                      return '';
                    }

                    /**
                     * Updates wrapper `details` based on `bitmask` flags.
                     *
                     * @private
                     * @returns {Array} details The details to modify.
                     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
                     * @returns {Array} Returns `details`.
                     */
                    function updateWrapDetails(details, bitmask) {
                      arrayEach(wrapFlags, function (pair) {
                        var value = '_.' + pair[0];
                        if (bitmask & pair[1] && !arrayIncludes(details, value)) {
                          details.push(value);
                        }
                      });
                      return details.sort();
                    }

                    /**
                     * Creates a clone of `wrapper`.
                     *
                     * @private
                     * @param {Object} wrapper The wrapper to clone.
                     * @returns {Object} Returns the cloned wrapper.
                     */
                    function wrapperClone(wrapper) {
                      if (wrapper instanceof LazyWrapper) {
                        return wrapper.clone();
                      }
                      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
                      result.__actions__ = copyArray(wrapper.__actions__);
                      result.__index__ = wrapper.__index__;
                      result.__values__ = wrapper.__values__;
                      return result;
                    }

                    /*------------------------------------------------------------------------*/

                    /**
                     * Creates an array of elements split into groups the length of `size`.
                     * If `array` can't be split evenly, the final chunk will be the remaining
                     * elements.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Array
                     * @param {Array} array The array to process.
                     * @param {number} [size=1] The length of each chunk
                     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                     * @returns {Array} Returns the new array of chunks.
                     * @example
                     *
                     * _.chunk(['a', 'b', 'c', 'd'], 2);
                     * // => [['a', 'b'], ['c', 'd']]
                     *
                     * _.chunk(['a', 'b', 'c', 'd'], 3);
                     * // => [['a', 'b', 'c'], ['d']]
                     */
                    function chunk(array, size, guard) {
                      if (guard ? isIterateeCall(array, size, guard) : size === undefined) {
                        size = 1;
                      } else {
                        size = nativeMax(toInteger(size), 0);
                      }
                      var length = array == null ? 0 : array.length;
                      if (!length || size < 1) {
                        return [];
                      }
                      var index = 0,
                        resIndex = 0,
                        result = Array(nativeCeil(length / size));

                      while (index < length) {
                        result[resIndex++] = baseSlice(array, index, (index += size));
                      }
                      return result;
                    }

                    /**
                     * Creates an array with all falsey values removed. The values `false`, `null`,
                     * `0`, `""`, `undefined`, and `NaN` are falsey.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Array
                     * @param {Array} array The array to compact.
                     * @returns {Array} Returns the new array of filtered values.
                     * @example
                     *
                     * _.compact([0, 1, false, 2, '', 3]);
                     * // => [1, 2, 3]
                     */
                    function compact(array) {
                      var index = -1,
                        length = array == null ? 0 : array.length,
                        resIndex = 0,
                        result = [];

                      while (++index < length) {
                        var value = array[index];
                        if (value) {
                          result[resIndex++] = value;
                        }
                      }
                      return result;
                    }

                    /**
                     * Creates a new array concatenating `array` with any additional arrays
                     * and/or values.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {Array} array The array to concatenate.
                     * @param {...*} [values] The values to concatenate.
                     * @returns {Array} Returns the new concatenated array.
                     * @example
                     *
                     * var array = [1];
                     * var other = _.concat(array, 2, [3], [[4]]);
                     *
                     * console.log(other);
                     * // => [1, 2, 3, [4]]
                     *
                     * console.log(array);
                     * // => [1]
                     */
                    function concat() {
                      var length = arguments.length;
                      if (!length) {
                        return [];
                      }
                      var args = Array(length - 1),
                        array = arguments[0],
                        index = length;

                      while (index--) {
                        args[index - 1] = arguments[index];
                      }
                      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
                    }

                    /**
                     * Creates an array of `array` values not included in the other given arrays
                     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                     * for equality comparisons. The order and references of result values are
                     * determined by the first array.
                     *
                     * **Note:** Unlike `_.pullAll`, this method returns a new array.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Array
                     * @param {Array} array The array to inspect.
                     * @param {...Array} [values] The values to exclude.
                     * @returns {Array} Returns the new array of filtered values.
                     * @see _.without, _.xor
                     * @example
                     *
                     * _.difference([2, 1], [2, 3]);
                     * // => [1]
                     */
                    var difference = baseRest(function (array, values) {
                      return isArrayLikeObject(array)
                        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
                        : [];
                    });

                    /**
                     * This method is like `_.difference` except that it accepts `iteratee` which
                     * is invoked for each element of `array` and `values` to generate the criterion
                     * by which they're compared. The order and references of result values are
                     * determined by the first array. The iteratee is invoked with one argument:
                     * (value).
                     *
                     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {Array} array The array to inspect.
                     * @param {...Array} [values] The values to exclude.
                     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                     * @returns {Array} Returns the new array of filtered values.
                     * @example
                     *
                     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
                     * // => [1.2]
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
                     * // => [{ 'x': 2 }]
                     */
                    var differenceBy = baseRest(function (array, values) {
                      var iteratee = last(values);
                      if (isArrayLikeObject(iteratee)) {
                        iteratee = undefined;
                      }
                      return isArrayLikeObject(array)
                        ? baseDifference(
                            array,
                            baseFlatten(values, 1, isArrayLikeObject, true),
                            getIteratee(iteratee, 2)
                          )
                        : [];
                    });

                    /**
                     * This method is like `_.difference` except that it accepts `comparator`
                     * which is invoked to compare elements of `array` to `values`. The order and
                     * references of result values are determined by the first array. The comparator
                     * is invoked with two arguments: (arrVal, othVal).
                     *
                     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {Array} array The array to inspect.
                     * @param {...Array} [values] The values to exclude.
                     * @param {Function} [comparator] The comparator invoked per element.
                     * @returns {Array} Returns the new array of filtered values.
                     * @example
                     *
                     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
                     *
                     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
                     * // => [{ 'x': 2, 'y': 1 }]
                     */
                    var differenceWith = baseRest(function (array, values) {
                      var comparator = last(values);
                      if (isArrayLikeObject(comparator)) {
                        comparator = undefined;
                      }
                      return isArrayLikeObject(array)
                        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
                        : [];
                    });

                    /**
                     * Creates a slice of `array` with `n` elements dropped from the beginning.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.5.0
                     * @category Array
                     * @param {Array} array The array to query.
                     * @param {number} [n=1] The number of elements to drop.
                     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                     * @returns {Array} Returns the slice of `array`.
                     * @example
                     *
                     * _.drop([1, 2, 3]);
                     * // => [2, 3]
                     *
                     * _.drop([1, 2, 3], 2);
                     * // => [3]
                     *
                     * _.drop([1, 2, 3], 5);
                     * // => []
                     *
                     * _.drop([1, 2, 3], 0);
                     * // => [1, 2, 3]
                     */
                    function drop(array, n, guard) {
                      var length = array == null ? 0 : array.length;
                      if (!length) {
                        return [];
                      }
                      n = guard || n === undefined ? 1 : toInteger(n);
                      return baseSlice(array, n < 0 ? 0 : n, length);
                    }

                    /**
                     * Creates a slice of `array` with `n` elements dropped from the end.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Array
                     * @param {Array} array The array to query.
                     * @param {number} [n=1] The number of elements to drop.
                     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                     * @returns {Array} Returns the slice of `array`.
                     * @example
                     *
                     * _.dropRight([1, 2, 3]);
                     * // => [1, 2]
                     *
                     * _.dropRight([1, 2, 3], 2);
                     * // => [1]
                     *
                     * _.dropRight([1, 2, 3], 5);
                     * // => []
                     *
                     * _.dropRight([1, 2, 3], 0);
                     * // => [1, 2, 3]
                     */
                    function dropRight(array, n, guard) {
                      var length = array == null ? 0 : array.length;
                      if (!length) {
                        return [];
                      }
                      n = guard || n === undefined ? 1 : toInteger(n);
                      n = length - n;
                      return baseSlice(array, 0, n < 0 ? 0 : n);
                    }

                    /**
                     * Creates a slice of `array` excluding elements dropped from the end.
                     * Elements are dropped until `predicate` returns falsey. The predicate is
                     * invoked with three arguments: (value, index, array).
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Array
                     * @param {Array} array The array to query.
                     * @param {Function} [predicate=_.identity] The function invoked per iteration.
                     * @returns {Array} Returns the slice of `array`.
                     * @example
                     *
                     * var users = [
                     *   { 'user': 'barney',  'active': true },
                     *   { 'user': 'fred',    'active': false },
                     *   { 'user': 'pebbles', 'active': false }
                     * ];
                     *
                     * _.dropRightWhile(users, function(o) { return !o.active; });
                     * // => objects for ['barney']
                     *
                     * // The `_.matches` iteratee shorthand.
                     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
                     * // => objects for ['barney', 'fred']
                     *
                     * // The `_.matchesProperty` iteratee shorthand.
                     * _.dropRightWhile(users, ['active', false]);
                     * // => objects for ['barney']
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.dropRightWhile(users, 'active');
                     * // => objects for ['barney', 'fred', 'pebbles']
                     */
                    function dropRightWhile(array, predicate) {
                      return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
                    }

                    /**
                     * Creates a slice of `array` excluding elements dropped from the beginning.
                     * Elements are dropped until `predicate` returns falsey. The predicate is
                     * invoked with three arguments: (value, index, array).
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Array
                     * @param {Array} array The array to query.
                     * @param {Function} [predicate=_.identity] The function invoked per iteration.
                     * @returns {Array} Returns the slice of `array`.
                     * @example
                     *
                     * var users = [
                     *   { 'user': 'barney',  'active': false },
                     *   { 'user': 'fred',    'active': false },
                     *   { 'user': 'pebbles', 'active': true }
                     * ];
                     *
                     * _.dropWhile(users, function(o) { return !o.active; });
                     * // => objects for ['pebbles']
                     *
                     * // The `_.matches` iteratee shorthand.
                     * _.dropWhile(users, { 'user': 'barney', 'active': false });
                     * // => objects for ['fred', 'pebbles']
                     *
                     * // The `_.matchesProperty` iteratee shorthand.
                     * _.dropWhile(users, ['active', false]);
                     * // => objects for ['pebbles']
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.dropWhile(users, 'active');
                     * // => objects for ['barney', 'fred', 'pebbles']
                     */
                    function dropWhile(array, predicate) {
                      return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
                    }

                    /**
                     * Fills elements of `array` with `value` from `start` up to, but not
                     * including, `end`.
                     *
                     * **Note:** This method mutates `array`.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.2.0
                     * @category Array
                     * @param {Array} array The array to fill.
                     * @param {*} value The value to fill `array` with.
                     * @param {number} [start=0] The start position.
                     * @param {number} [end=array.length] The end position.
                     * @returns {Array} Returns `array`.
                     * @example
                     *
                     * var array = [1, 2, 3];
                     *
                     * _.fill(array, 'a');
                     * console.log(array);
                     * // => ['a', 'a', 'a']
                     *
                     * _.fill(Array(3), 2);
                     * // => [2, 2, 2]
                     *
                     * _.fill([4, 6, 8, 10], '*', 1, 3);
                     * // => [4, '*', '*', 10]
                     */
                    function fill(array, value, start, end) {
                      var length = array == null ? 0 : array.length;
                      if (!length) {
                        return [];
                      }
                      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                        start = 0;
                        end = length;
                      }
                      return baseFill(array, value, start, end);
                    }

                    /**
                     * This method is like `_.find` except that it returns the index of the first
                     * element `predicate` returns truthy for instead of the element itself.
                     *
                     * @static
                     * @memberOf _
                     * @since 1.1.0
                     * @category Array
                     * @param {Array} array The array to inspect.
                     * @param {Function} [predicate=_.identity] The function invoked per iteration.
                     * @param {number} [fromIndex=0] The index to search from.
                     * @returns {number} Returns the index of the found element, else `-1`.
                     * @example
                     *
                     * var users = [
                     *   { 'user': 'barney',  'active': false },
                     *   { 'user': 'fred',    'active': false },
                     *   { 'user': 'pebbles', 'active': true }
                     * ];
                     *
                     * _.findIndex(users, function(o) { return o.user == 'barney'; });
                     * // => 0
                     *
                     * // The `_.matches` iteratee shorthand.
                     * _.findIndex(users, { 'user': 'fred', 'active': false });
                     * // => 1
                     *
                     * // The `_.matchesProperty` iteratee shorthand.
                     * _.findIndex(users, ['active', false]);
                     * // => 0
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.findIndex(users, 'active');
                     * // => 2
                     */
                    function findIndex(array, predicate, fromIndex) {
                      var length = array == null ? 0 : array.length;
                      if (!length) {
                        return -1;
                      }
                      var index = fromIndex == null ? 0 : toInteger(fromIndex);
                      if (index < 0) {
                        index = nativeMax(length + index, 0);
                      }
                      return baseFindIndex(array, getIteratee(predicate, 3), index);
                    }

                    /**
                     * This method is like `_.findIndex` except that it iterates over elements
                     * of `collection` from right to left.
                     *
                     * @static
                     * @memberOf _
                     * @since 2.0.0
                     * @category Array
                     * @param {Array} array The array to inspect.
                     * @param {Function} [predicate=_.identity] The function invoked per iteration.
                     * @param {number} [fromIndex=array.length-1] The index to search from.
                     * @returns {number} Returns the index of the found element, else `-1`.
                     * @example
                     *
                     * var users = [
                     *   { 'user': 'barney',  'active': true },
                     *   { 'user': 'fred',    'active': false },
                     *   { 'user': 'pebbles', 'active': false }
                     * ];
                     *
                     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
                     * // => 2
                     *
                     * // The `_.matches` iteratee shorthand.
                     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
                     * // => 0
                     *
                     * // The `_.matchesProperty` iteratee shorthand.
                     * _.findLastIndex(users, ['active', false]);
                     * // => 2
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.findLastIndex(users, 'active');
                     * // => 0
                     */
                    function findLastIndex(array, predicate, fromIndex) {
                      var length = array == null ? 0 : array.length;
                      if (!length) {
                        return -1;
                      }
                      var index = length - 1;
                      if (fromIndex !== undefined) {
                        index = toInteger(fromIndex);
                        index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
                      }
                      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
                    }

                    /**
                     * Flattens `array` a single level deep.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Array
                     * @param {Array} array The array to flatten.
                     * @returns {Array} Returns the new flattened array.
                     * @example
                     *
                     * _.flatten([1, [2, [3, [4]], 5]]);
                     * // => [1, 2, [3, [4]], 5]
                     */
                    function flatten(array) {
                      var length = array == null ? 0 : array.length;
                      return length ? baseFlatten(array, 1) : [];
                    }

                    /**
                     * Recursively flattens `array`.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Array
                     * @param {Array} array The array to flatten.
                     * @returns {Array} Returns the new flattened array.
                     * @example
                     *
                     * _.flattenDeep([1, [2, [3, [4]], 5]]);
                     * // => [1, 2, 3, 4, 5]
                     */
                    function flattenDeep(array) {
                      var length = array == null ? 0 : array.length;
                      return length ? baseFlatten(array, INFINITY) : [];
                    }

                    /**
                     * Recursively flatten `array` up to `depth` times.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.4.0
                     * @category Array
                     * @param {Array} array The array to flatten.
                     * @param {number} [depth=1] The maximum recursion depth.
                     * @returns {Array} Returns the new flattened array.
                     * @example
                     *
                     * var array = [1, [2, [3, [4]], 5]];
                     *
                     * _.flattenDepth(array, 1);
                     * // => [1, 2, [3, [4]], 5]
                     *
                     * _.flattenDepth(array, 2);
                     * // => [1, 2, 3, [4], 5]
                     */
                    function flattenDepth(array, depth) {
                      var length = array == null ? 0 : array.length;
                      if (!length) {
                        return [];
                      }
                      depth = depth === undefined ? 1 : toInteger(depth);
                      return baseFlatten(array, depth);
                    }

                    /**
                     * The inverse of `_.toPairs`; this method returns an object composed
                     * from key-value `pairs`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {Array} pairs The key-value pairs.
                     * @returns {Object} Returns the new object.
                     * @example
                     *
                     * _.fromPairs([['a', 1], ['b', 2]]);
                     * // => { 'a': 1, 'b': 2 }
                     */
                    function fromPairs(pairs) {
                      var index = -1,
                        length = pairs == null ? 0 : pairs.length,
                        result = {};

                      while (++index < length) {
                        var pair = pairs[index];
                        result[pair[0]] = pair[1];
                      }
                      return result;
                    }

                    /**
                     * Gets the first element of `array`.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @alias first
                     * @category Array
                     * @param {Array} array The array to query.
                     * @returns {*} Returns the first element of `array`.
                     * @example
                     *
                     * _.head([1, 2, 3]);
                     * // => 1
                     *
                     * _.head([]);
                     * // => undefined
                     */
                    function head(array) {
                      return array && array.length ? array[0] : undefined;
                    }

                    /**
                     * Gets the index at which the first occurrence of `value` is found in `array`
                     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                     * for equality comparisons. If `fromIndex` is negative, it's used as the
                     * offset from the end of `array`.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Array
                     * @param {Array} array The array to inspect.
                     * @param {*} value The value to search for.
                     * @param {number} [fromIndex=0] The index to search from.
                     * @returns {number} Returns the index of the matched value, else `-1`.
                     * @example
                     *
                     * _.indexOf([1, 2, 1, 2], 2);
                     * // => 1
                     *
                     * // Search from the `fromIndex`.
                     * _.indexOf([1, 2, 1, 2], 2, 2);
                     * // => 3
                     */
                    function indexOf(array, value, fromIndex) {
                      var length = array == null ? 0 : array.length;
                      if (!length) {
                        return -1;
                      }
                      var index = fromIndex == null ? 0 : toInteger(fromIndex);
                      if (index < 0) {
                        index = nativeMax(length + index, 0);
                      }
                      return baseIndexOf(array, value, index);
                    }

                    /**
                     * Gets all but the last element of `array`.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Array
                     * @param {Array} array The array to query.
                     * @returns {Array} Returns the slice of `array`.
                     * @example
                     *
                     * _.initial([1, 2, 3]);
                     * // => [1, 2]
                     */
                    function initial(array) {
                      var length = array == null ? 0 : array.length;
                      return length ? baseSlice(array, 0, -1) : [];
                    }

                    /**
                     * Creates an array of unique values that are included in all given arrays
                     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                     * for equality comparisons. The order and references of result values are
                     * determined by the first array.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Array
                     * @param {...Array} [arrays] The arrays to inspect.
                     * @returns {Array} Returns the new array of intersecting values.
                     * @example
                     *
                     * _.intersection([2, 1], [2, 3]);
                     * // => [2]
                     */
                    var intersection = baseRest(function (arrays) {
                      var mapped = arrayMap(arrays, castArrayLikeObject);
                      return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
                    });

                    /**
                     * This method is like `_.intersection` except that it accepts `iteratee`
                     * which is invoked for each element of each `arrays` to generate the criterion
                     * by which they're compared. The order and references of result values are
                     * determined by the first array. The iteratee is invoked with one argument:
                     * (value).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {...Array} [arrays] The arrays to inspect.
                     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                     * @returns {Array} Returns the new array of intersecting values.
                     * @example
                     *
                     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
                     * // => [2.1]
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
                     * // => [{ 'x': 1 }]
                     */
                    var intersectionBy = baseRest(function (arrays) {
                      var iteratee = last(arrays),
                        mapped = arrayMap(arrays, castArrayLikeObject);

                      if (iteratee === last(mapped)) {
                        iteratee = undefined;
                      } else {
                        mapped.pop();
                      }
                      return mapped.length && mapped[0] === arrays[0]
                        ? baseIntersection(mapped, getIteratee(iteratee, 2))
                        : [];
                    });

                    /**
                     * This method is like `_.intersection` except that it accepts `comparator`
                     * which is invoked to compare elements of `arrays`. The order and references
                     * of result values are determined by the first array. The comparator is
                     * invoked with two arguments: (arrVal, othVal).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {...Array} [arrays] The arrays to inspect.
                     * @param {Function} [comparator] The comparator invoked per element.
                     * @returns {Array} Returns the new array of intersecting values.
                     * @example
                     *
                     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
                     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
                     *
                     * _.intersectionWith(objects, others, _.isEqual);
                     * // => [{ 'x': 1, 'y': 2 }]
                     */
                    var intersectionWith = baseRest(function (arrays) {
                      var comparator = last(arrays),
                        mapped = arrayMap(arrays, castArrayLikeObject);

                      comparator = typeof comparator == 'function' ? comparator : undefined;
                      if (comparator) {
                        mapped.pop();
                      }
                      return mapped.length && mapped[0] === arrays[0]
                        ? baseIntersection(mapped, undefined, comparator)
                        : [];
                    });

                    /**
                     * Converts all elements in `array` into a string separated by `separator`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {Array} array The array to convert.
                     * @param {string} [separator=','] The element separator.
                     * @returns {string} Returns the joined string.
                     * @example
                     *
                     * _.join(['a', 'b', 'c'], '~');
                     * // => 'a~b~c'
                     */
                    function join(array, separator) {
                      return array == null ? '' : nativeJoin.call(array, separator);
                    }

                    /**
                     * Gets the last element of `array`.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Array
                     * @param {Array} array The array to query.
                     * @returns {*} Returns the last element of `array`.
                     * @example
                     *
                     * _.last([1, 2, 3]);
                     * // => 3
                     */
                    function last(array) {
                      var length = array == null ? 0 : array.length;
                      return length ? array[length - 1] : undefined;
                    }

                    /**
                     * This method is like `_.indexOf` except that it iterates over elements of
                     * `array` from right to left.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Array
                     * @param {Array} array The array to inspect.
                     * @param {*} value The value to search for.
                     * @param {number} [fromIndex=array.length-1] The index to search from.
                     * @returns {number} Returns the index of the matched value, else `-1`.
                     * @example
                     *
                     * _.lastIndexOf([1, 2, 1, 2], 2);
                     * // => 3
                     *
                     * // Search from the `fromIndex`.
                     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
                     * // => 1
                     */
                    function lastIndexOf(array, value, fromIndex) {
                      var length = array == null ? 0 : array.length;
                      if (!length) {
                        return -1;
                      }
                      var index = length;
                      if (fromIndex !== undefined) {
                        index = toInteger(fromIndex);
                        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
                      }
                      return value === value
                        ? strictLastIndexOf(array, value, index)
                        : baseFindIndex(array, baseIsNaN, index, true);
                    }

                    /**
                     * Gets the element at index `n` of `array`. If `n` is negative, the nth
                     * element from the end is returned.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.11.0
                     * @category Array
                     * @param {Array} array The array to query.
                     * @param {number} [n=0] The index of the element to return.
                     * @returns {*} Returns the nth element of `array`.
                     * @example
                     *
                     * var array = ['a', 'b', 'c', 'd'];
                     *
                     * _.nth(array, 1);
                     * // => 'b'
                     *
                     * _.nth(array, -2);
                     * // => 'c';
                     */
                    function nth(array, n) {
                      return array && array.length ? baseNth(array, toInteger(n)) : undefined;
                    }

                    /**
                     * Removes all given values from `array` using
                     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                     * for equality comparisons.
                     *
                     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
                     * to remove elements from an array by predicate.
                     *
                     * @static
                     * @memberOf _
                     * @since 2.0.0
                     * @category Array
                     * @param {Array} array The array to modify.
                     * @param {...*} [values] The values to remove.
                     * @returns {Array} Returns `array`.
                     * @example
                     *
                     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
                     *
                     * _.pull(array, 'a', 'c');
                     * console.log(array);
                     * // => ['b', 'b']
                     */
                    var pull = baseRest(pullAll);

                    /**
                     * This method is like `_.pull` except that it accepts an array of values to remove.
                     *
                     * **Note:** Unlike `_.difference`, this method mutates `array`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {Array} array The array to modify.
                     * @param {Array} values The values to remove.
                     * @returns {Array} Returns `array`.
                     * @example
                     *
                     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
                     *
                     * _.pullAll(array, ['a', 'c']);
                     * console.log(array);
                     * // => ['b', 'b']
                     */
                    function pullAll(array, values) {
                      return array && array.length && values && values.length ? basePullAll(array, values) : array;
                    }

                    /**
                     * This method is like `_.pullAll` except that it accepts `iteratee` which is
                     * invoked for each element of `array` and `values` to generate the criterion
                     * by which they're compared. The iteratee is invoked with one argument: (value).
                     *
                     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {Array} array The array to modify.
                     * @param {Array} values The values to remove.
                     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                     * @returns {Array} Returns `array`.
                     * @example
                     *
                     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
                     *
                     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
                     * console.log(array);
                     * // => [{ 'x': 2 }]
                     */
                    function pullAllBy(array, values, iteratee) {
                      return array && array.length && values && values.length
                        ? basePullAll(array, values, getIteratee(iteratee, 2))
                        : array;
                    }

                    /**
                     * This method is like `_.pullAll` except that it accepts `comparator` which
                     * is invoked to compare elements of `array` to `values`. The comparator is
                     * invoked with two arguments: (arrVal, othVal).
                     *
                     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.6.0
                     * @category Array
                     * @param {Array} array The array to modify.
                     * @param {Array} values The values to remove.
                     * @param {Function} [comparator] The comparator invoked per element.
                     * @returns {Array} Returns `array`.
                     * @example
                     *
                     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
                     *
                     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
                     * console.log(array);
                     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
                     */
                    function pullAllWith(array, values, comparator) {
                      return array && array.length && values && values.length
                        ? basePullAll(array, values, undefined, comparator)
                        : array;
                    }

                    /**
                     * Removes elements from `array` corresponding to `indexes` and returns an
                     * array of removed elements.
                     *
                     * **Note:** Unlike `_.at`, this method mutates `array`.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Array
                     * @param {Array} array The array to modify.
                     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
                     * @returns {Array} Returns the new array of removed elements.
                     * @example
                     *
                     * var array = ['a', 'b', 'c', 'd'];
                     * var pulled = _.pullAt(array, [1, 3]);
                     *
                     * console.log(array);
                     * // => ['a', 'c']
                     *
                     * console.log(pulled);
                     * // => ['b', 'd']
                     */
                    var pullAt = flatRest(function (array, indexes) {
                      var length = array == null ? 0 : array.length,
                        result = baseAt(array, indexes);

                      basePullAt(
                        array,
                        arrayMap(indexes, function (index) {
                          return isIndex(index, length) ? +index : index;
                        }).sort(compareAscending)
                      );

                      return result;
                    });

                    /**
                     * Removes all elements from `array` that `predicate` returns truthy for
                     * and returns an array of the removed elements. The predicate is invoked
                     * with three arguments: (value, index, array).
                     *
                     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
                     * to pull elements from an array by value.
                     *
                     * @static
                     * @memberOf _
                     * @since 2.0.0
                     * @category Array
                     * @param {Array} array The array to modify.
                     * @param {Function} [predicate=_.identity] The function invoked per iteration.
                     * @returns {Array} Returns the new array of removed elements.
                     * @example
                     *
                     * var array = [1, 2, 3, 4];
                     * var evens = _.remove(array, function(n) {
                     *   return n % 2 == 0;
                     * });
                     *
                     * console.log(array);
                     * // => [1, 3]
                     *
                     * console.log(evens);
                     * // => [2, 4]
                     */
                    function remove(array, predicate) {
                      var result = [];
                      if (!(array && array.length)) {
                        return result;
                      }
                      var index = -1,
                        indexes = [],
                        length = array.length;

                      predicate = getIteratee(predicate, 3);
                      while (++index < length) {
                        var value = array[index];
                        if (predicate(value, index, array)) {
                          result.push(value);
                          indexes.push(index);
                        }
                      }
                      basePullAt(array, indexes);
                      return result;
                    }

                    /**
                     * Reverses `array` so that the first element becomes the last, the second
                     * element becomes the second to last, and so on.
                     *
                     * **Note:** This method mutates `array` and is based on
                     * [`Array#reverse`](https://mdn.io/Array/reverse).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {Array} array The array to modify.
                     * @returns {Array} Returns `array`.
                     * @example
                     *
                     * var array = [1, 2, 3];
                     *
                     * _.reverse(array);
                     * // => [3, 2, 1]
                     *
                     * console.log(array);
                     * // => [3, 2, 1]
                     */
                    function reverse(array) {
                      return array == null ? array : nativeReverse.call(array);
                    }

                    /**
                     * Creates a slice of `array` from `start` up to, but not including, `end`.
                     *
                     * **Note:** This method is used instead of
                     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
                     * returned.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Array
                     * @param {Array} array The array to slice.
                     * @param {number} [start=0] The start position.
                     * @param {number} [end=array.length] The end position.
                     * @returns {Array} Returns the slice of `array`.
                     */
                    function slice(array, start, end) {
                      var length = array == null ? 0 : array.length;
                      if (!length) {
                        return [];
                      }
                      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                        start = 0;
                        end = length;
                      } else {
                        start = start == null ? 0 : toInteger(start);
                        end = end === undefined ? length : toInteger(end);
                      }
                      return baseSlice(array, start, end);
                    }

                    /**
                     * Uses a binary search to determine the lowest index at which `value`
                     * should be inserted into `array` in order to maintain its sort order.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Array
                     * @param {Array} array The sorted array to inspect.
                     * @param {*} value The value to evaluate.
                     * @returns {number} Returns the index at which `value` should be inserted
                     *  into `array`.
                     * @example
                     *
                     * _.sortedIndex([30, 50], 40);
                     * // => 1
                     */
                    function sortedIndex(array, value) {
                      return baseSortedIndex(array, value);
                    }

                    /**
                     * This method is like `_.sortedIndex` except that it accepts `iteratee`
                     * which is invoked for `value` and each element of `array` to compute their
                     * sort ranking. The iteratee is invoked with one argument: (value).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {Array} array The sorted array to inspect.
                     * @param {*} value The value to evaluate.
                     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                     * @returns {number} Returns the index at which `value` should be inserted
                     *  into `array`.
                     * @example
                     *
                     * var objects = [{ 'x': 4 }, { 'x': 5 }];
                     *
                     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
                     * // => 0
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
                     * // => 0
                     */
                    function sortedIndexBy(array, value, iteratee) {
                      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
                    }

                    /**
                     * This method is like `_.indexOf` except that it performs a binary
                     * search on a sorted `array`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {Array} array The array to inspect.
                     * @param {*} value The value to search for.
                     * @returns {number} Returns the index of the matched value, else `-1`.
                     * @example
                     *
                     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
                     * // => 1
                     */
                    function sortedIndexOf(array, value) {
                      var length = array == null ? 0 : array.length;
                      if (length) {
                        var index = baseSortedIndex(array, value);
                        if (index < length && eq(array[index], value)) {
                          return index;
                        }
                      }
                      return -1;
                    }

                    /**
                     * This method is like `_.sortedIndex` except that it returns the highest
                     * index at which `value` should be inserted into `array` in order to
                     * maintain its sort order.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Array
                     * @param {Array} array The sorted array to inspect.
                     * @param {*} value The value to evaluate.
                     * @returns {number} Returns the index at which `value` should be inserted
                     *  into `array`.
                     * @example
                     *
                     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
                     * // => 4
                     */
                    function sortedLastIndex(array, value) {
                      return baseSortedIndex(array, value, true);
                    }

                    /**
                     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
                     * which is invoked for `value` and each element of `array` to compute their
                     * sort ranking. The iteratee is invoked with one argument: (value).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {Array} array The sorted array to inspect.
                     * @param {*} value The value to evaluate.
                     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                     * @returns {number} Returns the index at which `value` should be inserted
                     *  into `array`.
                     * @example
                     *
                     * var objects = [{ 'x': 4 }, { 'x': 5 }];
                     *
                     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
                     * // => 1
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
                     * // => 1
                     */
                    function sortedLastIndexBy(array, value, iteratee) {
                      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
                    }

                    /**
                     * This method is like `_.lastIndexOf` except that it performs a binary
                     * search on a sorted `array`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {Array} array The array to inspect.
                     * @param {*} value The value to search for.
                     * @returns {number} Returns the index of the matched value, else `-1`.
                     * @example
                     *
                     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
                     * // => 3
                     */
                    function sortedLastIndexOf(array, value) {
                      var length = array == null ? 0 : array.length;
                      if (length) {
                        var index = baseSortedIndex(array, value, true) - 1;
                        if (eq(array[index], value)) {
                          return index;
                        }
                      }
                      return -1;
                    }

                    /**
                     * This method is like `_.uniq` except that it's designed and optimized
                     * for sorted arrays.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {Array} array The array to inspect.
                     * @returns {Array} Returns the new duplicate free array.
                     * @example
                     *
                     * _.sortedUniq([1, 1, 2]);
                     * // => [1, 2]
                     */
                    function sortedUniq(array) {
                      return array && array.length ? baseSortedUniq(array) : [];
                    }

                    /**
                     * This method is like `_.uniqBy` except that it's designed and optimized
                     * for sorted arrays.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {Array} array The array to inspect.
                     * @param {Function} [iteratee] The iteratee invoked per element.
                     * @returns {Array} Returns the new duplicate free array.
                     * @example
                     *
                     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
                     * // => [1.1, 2.3]
                     */
                    function sortedUniqBy(array, iteratee) {
                      return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
                    }

                    /**
                     * Gets all but the first element of `array`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {Array} array The array to query.
                     * @returns {Array} Returns the slice of `array`.
                     * @example
                     *
                     * _.tail([1, 2, 3]);
                     * // => [2, 3]
                     */
                    function tail(array) {
                      var length = array == null ? 0 : array.length;
                      return length ? baseSlice(array, 1, length) : [];
                    }

                    /**
                     * Creates a slice of `array` with `n` elements taken from the beginning.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Array
                     * @param {Array} array The array to query.
                     * @param {number} [n=1] The number of elements to take.
                     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                     * @returns {Array} Returns the slice of `array`.
                     * @example
                     *
                     * _.take([1, 2, 3]);
                     * // => [1]
                     *
                     * _.take([1, 2, 3], 2);
                     * // => [1, 2]
                     *
                     * _.take([1, 2, 3], 5);
                     * // => [1, 2, 3]
                     *
                     * _.take([1, 2, 3], 0);
                     * // => []
                     */
                    function take(array, n, guard) {
                      if (!(array && array.length)) {
                        return [];
                      }
                      n = guard || n === undefined ? 1 : toInteger(n);
                      return baseSlice(array, 0, n < 0 ? 0 : n);
                    }

                    /**
                     * Creates a slice of `array` with `n` elements taken from the end.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Array
                     * @param {Array} array The array to query.
                     * @param {number} [n=1] The number of elements to take.
                     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                     * @returns {Array} Returns the slice of `array`.
                     * @example
                     *
                     * _.takeRight([1, 2, 3]);
                     * // => [3]
                     *
                     * _.takeRight([1, 2, 3], 2);
                     * // => [2, 3]
                     *
                     * _.takeRight([1, 2, 3], 5);
                     * // => [1, 2, 3]
                     *
                     * _.takeRight([1, 2, 3], 0);
                     * // => []
                     */
                    function takeRight(array, n, guard) {
                      var length = array == null ? 0 : array.length;
                      if (!length) {
                        return [];
                      }
                      n = guard || n === undefined ? 1 : toInteger(n);
                      n = length - n;
                      return baseSlice(array, n < 0 ? 0 : n, length);
                    }

                    /**
                     * Creates a slice of `array` with elements taken from the end. Elements are
                     * taken until `predicate` returns falsey. The predicate is invoked with
                     * three arguments: (value, index, array).
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Array
                     * @param {Array} array The array to query.
                     * @param {Function} [predicate=_.identity] The function invoked per iteration.
                     * @returns {Array} Returns the slice of `array`.
                     * @example
                     *
                     * var users = [
                     *   { 'user': 'barney',  'active': true },
                     *   { 'user': 'fred',    'active': false },
                     *   { 'user': 'pebbles', 'active': false }
                     * ];
                     *
                     * _.takeRightWhile(users, function(o) { return !o.active; });
                     * // => objects for ['fred', 'pebbles']
                     *
                     * // The `_.matches` iteratee shorthand.
                     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
                     * // => objects for ['pebbles']
                     *
                     * // The `_.matchesProperty` iteratee shorthand.
                     * _.takeRightWhile(users, ['active', false]);
                     * // => objects for ['fred', 'pebbles']
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.takeRightWhile(users, 'active');
                     * // => []
                     */
                    function takeRightWhile(array, predicate) {
                      return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
                    }

                    /**
                     * Creates a slice of `array` with elements taken from the beginning. Elements
                     * are taken until `predicate` returns falsey. The predicate is invoked with
                     * three arguments: (value, index, array).
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Array
                     * @param {Array} array The array to query.
                     * @param {Function} [predicate=_.identity] The function invoked per iteration.
                     * @returns {Array} Returns the slice of `array`.
                     * @example
                     *
                     * var users = [
                     *   { 'user': 'barney',  'active': false },
                     *   { 'user': 'fred',    'active': false },
                     *   { 'user': 'pebbles', 'active': true }
                     * ];
                     *
                     * _.takeWhile(users, function(o) { return !o.active; });
                     * // => objects for ['barney', 'fred']
                     *
                     * // The `_.matches` iteratee shorthand.
                     * _.takeWhile(users, { 'user': 'barney', 'active': false });
                     * // => objects for ['barney']
                     *
                     * // The `_.matchesProperty` iteratee shorthand.
                     * _.takeWhile(users, ['active', false]);
                     * // => objects for ['barney', 'fred']
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.takeWhile(users, 'active');
                     * // => []
                     */
                    function takeWhile(array, predicate) {
                      return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
                    }

                    /**
                     * Creates an array of unique values, in order, from all given arrays using
                     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                     * for equality comparisons.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Array
                     * @param {...Array} [arrays] The arrays to inspect.
                     * @returns {Array} Returns the new array of combined values.
                     * @example
                     *
                     * _.union([2], [1, 2]);
                     * // => [2, 1]
                     */
                    var union = baseRest(function (arrays) {
                      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
                    });

                    /**
                     * This method is like `_.union` except that it accepts `iteratee` which is
                     * invoked for each element of each `arrays` to generate the criterion by
                     * which uniqueness is computed. Result values are chosen from the first
                     * array in which the value occurs. The iteratee is invoked with one argument:
                     * (value).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {...Array} [arrays] The arrays to inspect.
                     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                     * @returns {Array} Returns the new array of combined values.
                     * @example
                     *
                     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
                     * // => [2.1, 1.2]
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
                     * // => [{ 'x': 1 }, { 'x': 2 }]
                     */
                    var unionBy = baseRest(function (arrays) {
                      var iteratee = last(arrays);
                      if (isArrayLikeObject(iteratee)) {
                        iteratee = undefined;
                      }
                      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
                    });

                    /**
                     * This method is like `_.union` except that it accepts `comparator` which
                     * is invoked to compare elements of `arrays`. Result values are chosen from
                     * the first array in which the value occurs. The comparator is invoked
                     * with two arguments: (arrVal, othVal).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {...Array} [arrays] The arrays to inspect.
                     * @param {Function} [comparator] The comparator invoked per element.
                     * @returns {Array} Returns the new array of combined values.
                     * @example
                     *
                     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
                     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
                     *
                     * _.unionWith(objects, others, _.isEqual);
                     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
                     */
                    var unionWith = baseRest(function (arrays) {
                      var comparator = last(arrays);
                      comparator = typeof comparator == 'function' ? comparator : undefined;
                      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
                    });

                    /**
                     * Creates a duplicate-free version of an array, using
                     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                     * for equality comparisons, in which only the first occurrence of each element
                     * is kept. The order of result values is determined by the order they occur
                     * in the array.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Array
                     * @param {Array} array The array to inspect.
                     * @returns {Array} Returns the new duplicate free array.
                     * @example
                     *
                     * _.uniq([2, 1, 2]);
                     * // => [2, 1]
                     */
                    function uniq(array) {
                      return array && array.length ? baseUniq(array) : [];
                    }

                    /**
                     * This method is like `_.uniq` except that it accepts `iteratee` which is
                     * invoked for each element in `array` to generate the criterion by which
                     * uniqueness is computed. The order of result values is determined by the
                     * order they occur in the array. The iteratee is invoked with one argument:
                     * (value).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {Array} array The array to inspect.
                     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                     * @returns {Array} Returns the new duplicate free array.
                     * @example
                     *
                     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
                     * // => [2.1, 1.2]
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
                     * // => [{ 'x': 1 }, { 'x': 2 }]
                     */
                    function uniqBy(array, iteratee) {
                      return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
                    }

                    /**
                     * This method is like `_.uniq` except that it accepts `comparator` which
                     * is invoked to compare elements of `array`. The order of result values is
                     * determined by the order they occur in the array.The comparator is invoked
                     * with two arguments: (arrVal, othVal).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {Array} array The array to inspect.
                     * @param {Function} [comparator] The comparator invoked per element.
                     * @returns {Array} Returns the new duplicate free array.
                     * @example
                     *
                     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
                     *
                     * _.uniqWith(objects, _.isEqual);
                     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
                     */
                    function uniqWith(array, comparator) {
                      comparator = typeof comparator == 'function' ? comparator : undefined;
                      return array && array.length ? baseUniq(array, undefined, comparator) : [];
                    }

                    /**
                     * This method is like `_.zip` except that it accepts an array of grouped
                     * elements and creates an array regrouping the elements to their pre-zip
                     * configuration.
                     *
                     * @static
                     * @memberOf _
                     * @since 1.2.0
                     * @category Array
                     * @param {Array} array The array of grouped elements to process.
                     * @returns {Array} Returns the new array of regrouped elements.
                     * @example
                     *
                     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
                     * // => [['a', 1, true], ['b', 2, false]]
                     *
                     * _.unzip(zipped);
                     * // => [['a', 'b'], [1, 2], [true, false]]
                     */
                    function unzip(array) {
                      if (!(array && array.length)) {
                        return [];
                      }
                      var length = 0;
                      array = arrayFilter(array, function (group) {
                        if (isArrayLikeObject(group)) {
                          length = nativeMax(group.length, length);
                          return true;
                        }
                      });
                      return baseTimes(length, function (index) {
                        return arrayMap(array, baseProperty(index));
                      });
                    }

                    /**
                     * This method is like `_.unzip` except that it accepts `iteratee` to specify
                     * how regrouped values should be combined. The iteratee is invoked with the
                     * elements of each group: (...group).
                     *
                     * @static
                     * @memberOf _
                     * @since 3.8.0
                     * @category Array
                     * @param {Array} array The array of grouped elements to process.
                     * @param {Function} [iteratee=_.identity] The function to combine
                     *  regrouped values.
                     * @returns {Array} Returns the new array of regrouped elements.
                     * @example
                     *
                     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
                     * // => [[1, 10, 100], [2, 20, 200]]
                     *
                     * _.unzipWith(zipped, _.add);
                     * // => [3, 30, 300]
                     */
                    function unzipWith(array, iteratee) {
                      if (!(array && array.length)) {
                        return [];
                      }
                      var result = unzip(array);
                      if (iteratee == null) {
                        return result;
                      }
                      return arrayMap(result, function (group) {
                        return apply(iteratee, undefined, group);
                      });
                    }

                    /**
                     * Creates an array excluding all given values using
                     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                     * for equality comparisons.
                     *
                     * **Note:** Unlike `_.pull`, this method returns a new array.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Array
                     * @param {Array} array The array to inspect.
                     * @param {...*} [values] The values to exclude.
                     * @returns {Array} Returns the new array of filtered values.
                     * @see _.difference, _.xor
                     * @example
                     *
                     * _.without([2, 1, 2, 3], 1, 2);
                     * // => [3]
                     */
                    var without = baseRest(function (array, values) {
                      return isArrayLikeObject(array) ? baseDifference(array, values) : [];
                    });

                    /**
                     * Creates an array of unique values that is the
                     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
                     * of the given arrays. The order of result values is determined by the order
                     * they occur in the arrays.
                     *
                     * @static
                     * @memberOf _
                     * @since 2.4.0
                     * @category Array
                     * @param {...Array} [arrays] The arrays to inspect.
                     * @returns {Array} Returns the new array of filtered values.
                     * @see _.difference, _.without
                     * @example
                     *
                     * _.xor([2, 1], [2, 3]);
                     * // => [1, 3]
                     */
                    var xor = baseRest(function (arrays) {
                      return baseXor(arrayFilter(arrays, isArrayLikeObject));
                    });

                    /**
                     * This method is like `_.xor` except that it accepts `iteratee` which is
                     * invoked for each element of each `arrays` to generate the criterion by
                     * which by which they're compared. The order of result values is determined
                     * by the order they occur in the arrays. The iteratee is invoked with one
                     * argument: (value).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {...Array} [arrays] The arrays to inspect.
                     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                     * @returns {Array} Returns the new array of filtered values.
                     * @example
                     *
                     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
                     * // => [1.2, 3.4]
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
                     * // => [{ 'x': 2 }]
                     */
                    var xorBy = baseRest(function (arrays) {
                      var iteratee = last(arrays);
                      if (isArrayLikeObject(iteratee)) {
                        iteratee = undefined;
                      }
                      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
                    });

                    /**
                     * This method is like `_.xor` except that it accepts `comparator` which is
                     * invoked to compare elements of `arrays`. The order of result values is
                     * determined by the order they occur in the arrays. The comparator is invoked
                     * with two arguments: (arrVal, othVal).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Array
                     * @param {...Array} [arrays] The arrays to inspect.
                     * @param {Function} [comparator] The comparator invoked per element.
                     * @returns {Array} Returns the new array of filtered values.
                     * @example
                     *
                     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
                     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
                     *
                     * _.xorWith(objects, others, _.isEqual);
                     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
                     */
                    var xorWith = baseRest(function (arrays) {
                      var comparator = last(arrays);
                      comparator = typeof comparator == 'function' ? comparator : undefined;
                      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
                    });

                    /**
                     * Creates an array of grouped elements, the first of which contains the
                     * first elements of the given arrays, the second of which contains the
                     * second elements of the given arrays, and so on.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Array
                     * @param {...Array} [arrays] The arrays to process.
                     * @returns {Array} Returns the new array of grouped elements.
                     * @example
                     *
                     * _.zip(['a', 'b'], [1, 2], [true, false]);
                     * // => [['a', 1, true], ['b', 2, false]]
                     */
                    var zip = baseRest(unzip);

                    /**
                     * This method is like `_.fromPairs` except that it accepts two arrays,
                     * one of property identifiers and one of corresponding values.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.4.0
                     * @category Array
                     * @param {Array} [props=[]] The property identifiers.
                     * @param {Array} [values=[]] The property values.
                     * @returns {Object} Returns the new object.
                     * @example
                     *
                     * _.zipObject(['a', 'b'], [1, 2]);
                     * // => { 'a': 1, 'b': 2 }
                     */
                    function zipObject(props, values) {
                      return baseZipObject(props || [], values || [], assignValue);
                    }

                    /**
                     * This method is like `_.zipObject` except that it supports property paths.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.1.0
                     * @category Array
                     * @param {Array} [props=[]] The property identifiers.
                     * @param {Array} [values=[]] The property values.
                     * @returns {Object} Returns the new object.
                     * @example
                     *
                     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
                     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
                     */
                    function zipObjectDeep(props, values) {
                      return baseZipObject(props || [], values || [], baseSet);
                    }

                    /**
                     * This method is like `_.zip` except that it accepts `iteratee` to specify
                     * how grouped values should be combined. The iteratee is invoked with the
                     * elements of each group: (...group).
                     *
                     * @static
                     * @memberOf _
                     * @since 3.8.0
                     * @category Array
                     * @param {...Array} [arrays] The arrays to process.
                     * @param {Function} [iteratee=_.identity] The function to combine
                     *  grouped values.
                     * @returns {Array} Returns the new array of grouped elements.
                     * @example
                     *
                     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
                     *   return a + b + c;
                     * });
                     * // => [111, 222]
                     */
                    var zipWith = baseRest(function (arrays) {
                      var length = arrays.length,
                        iteratee = length > 1 ? arrays[length - 1] : undefined;

                      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
                      return unzipWith(arrays, iteratee);
                    });

                    /*------------------------------------------------------------------------*/

                    /**
                     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
                     * chain sequences enabled. The result of such sequences must be unwrapped
                     * with `_#value`.
                     *
                     * @static
                     * @memberOf _
                     * @since 1.3.0
                     * @category Seq
                     * @param {*} value The value to wrap.
                     * @returns {Object} Returns the new `lodash` wrapper instance.
                     * @example
                     *
                     * var users = [
                     *   { 'user': 'barney',  'age': 36 },
                     *   { 'user': 'fred',    'age': 40 },
                     *   { 'user': 'pebbles', 'age': 1 }
                     * ];
                     *
                     * var youngest = _
                     *   .chain(users)
                     *   .sortBy('age')
                     *   .map(function(o) {
                     *     return o.user + ' is ' + o.age;
                     *   })
                     *   .head()
                     *   .value();
                     * // => 'pebbles is 1'
                     */
                    function chain(value) {
                      var result = lodash(value);
                      result.__chain__ = true;
                      return result;
                    }

                    /**
                     * This method invokes `interceptor` and returns `value`. The interceptor
                     * is invoked with one argument; (value). The purpose of this method is to
                     * "tap into" a method chain sequence in order to modify intermediate results.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Seq
                     * @param {*} value The value to provide to `interceptor`.
                     * @param {Function} interceptor The function to invoke.
                     * @returns {*} Returns `value`.
                     * @example
                     *
                     * _([1, 2, 3])
                     *  .tap(function(array) {
                     *    // Mutate input array.
                     *    array.pop();
                     *  })
                     *  .reverse()
                     *  .value();
                     * // => [2, 1]
                     */
                    function tap(value, interceptor) {
                      interceptor(value);
                      return value;
                    }

                    /**
                     * This method is like `_.tap` except that it returns the result of `interceptor`.
                     * The purpose of this method is to "pass thru" values replacing intermediate
                     * results in a method chain sequence.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Seq
                     * @param {*} value The value to provide to `interceptor`.
                     * @param {Function} interceptor The function to invoke.
                     * @returns {*} Returns the result of `interceptor`.
                     * @example
                     *
                     * _('  abc  ')
                     *  .chain()
                     *  .trim()
                     *  .thru(function(value) {
                     *    return [value];
                     *  })
                     *  .value();
                     * // => ['abc']
                     */
                    function thru(value, interceptor) {
                      return interceptor(value);
                    }

                    /**
                     * This method is the wrapper version of `_.at`.
                     *
                     * @name at
                     * @memberOf _
                     * @since 1.0.0
                     * @category Seq
                     * @param {...(string|string[])} [paths] The property paths to pick.
                     * @returns {Object} Returns the new `lodash` wrapper instance.
                     * @example
                     *
                     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
                     *
                     * _(object).at(['a[0].b.c', 'a[1]']).value();
                     * // => [3, 4]
                     */
                    var wrapperAt = flatRest(function (paths) {
                      var length = paths.length,
                        start = length ? paths[0] : 0,
                        value = this.__wrapped__,
                        interceptor = function (object) {
                          return baseAt(object, paths);
                        };

                      if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
                        return this.thru(interceptor);
                      }
                      value = value.slice(start, +start + (length ? 1 : 0));
                      value.__actions__.push({
                        func: thru,
                        args: [interceptor],
                        thisArg: undefined
                      });
                      return new LodashWrapper(value, this.__chain__).thru(function (array) {
                        if (length && !array.length) {
                          array.push(undefined);
                        }
                        return array;
                      });
                    });

                    /**
                     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
                     *
                     * @name chain
                     * @memberOf _
                     * @since 0.1.0
                     * @category Seq
                     * @returns {Object} Returns the new `lodash` wrapper instance.
                     * @example
                     *
                     * var users = [
                     *   { 'user': 'barney', 'age': 36 },
                     *   { 'user': 'fred',   'age': 40 }
                     * ];
                     *
                     * // A sequence without explicit chaining.
                     * _(users).head();
                     * // => { 'user': 'barney', 'age': 36 }
                     *
                     * // A sequence with explicit chaining.
                     * _(users)
                     *   .chain()
                     *   .head()
                     *   .pick('user')
                     *   .value();
                     * // => { 'user': 'barney' }
                     */
                    function wrapperChain() {
                      return chain(this);
                    }

                    /**
                     * Executes the chain sequence and returns the wrapped result.
                     *
                     * @name commit
                     * @memberOf _
                     * @since 3.2.0
                     * @category Seq
                     * @returns {Object} Returns the new `lodash` wrapper instance.
                     * @example
                     *
                     * var array = [1, 2];
                     * var wrapped = _(array).push(3);
                     *
                     * console.log(array);
                     * // => [1, 2]
                     *
                     * wrapped = wrapped.commit();
                     * console.log(array);
                     * // => [1, 2, 3]
                     *
                     * wrapped.last();
                     * // => 3
                     *
                     * console.log(array);
                     * // => [1, 2, 3]
                     */
                    function wrapperCommit() {
                      return new LodashWrapper(this.value(), this.__chain__);
                    }

                    /**
                     * Gets the next value on a wrapped object following the
                     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
                     *
                     * @name next
                     * @memberOf _
                     * @since 4.0.0
                     * @category Seq
                     * @returns {Object} Returns the next iterator value.
                     * @example
                     *
                     * var wrapped = _([1, 2]);
                     *
                     * wrapped.next();
                     * // => { 'done': false, 'value': 1 }
                     *
                     * wrapped.next();
                     * // => { 'done': false, 'value': 2 }
                     *
                     * wrapped.next();
                     * // => { 'done': true, 'value': undefined }
                     */
                    function wrapperNext() {
                      if (this.__values__ === undefined) {
                        this.__values__ = toArray(this.value());
                      }
                      var done = this.__index__ >= this.__values__.length,
                        value = done ? undefined : this.__values__[this.__index__++];

                      return { done: done, value: value };
                    }

                    /**
                     * Enables the wrapper to be iterable.
                     *
                     * @name Symbol.iterator
                     * @memberOf _
                     * @since 4.0.0
                     * @category Seq
                     * @returns {Object} Returns the wrapper object.
                     * @example
                     *
                     * var wrapped = _([1, 2]);
                     *
                     * wrapped[Symbol.iterator]() === wrapped;
                     * // => true
                     *
                     * Array.from(wrapped);
                     * // => [1, 2]
                     */
                    function wrapperToIterator() {
                      return this;
                    }

                    /**
                     * Creates a clone of the chain sequence planting `value` as the wrapped value.
                     *
                     * @name plant
                     * @memberOf _
                     * @since 3.2.0
                     * @category Seq
                     * @param {*} value The value to plant.
                     * @returns {Object} Returns the new `lodash` wrapper instance.
                     * @example
                     *
                     * function square(n) {
                     *   return n * n;
                     * }
                     *
                     * var wrapped = _([1, 2]).map(square);
                     * var other = wrapped.plant([3, 4]);
                     *
                     * other.value();
                     * // => [9, 16]
                     *
                     * wrapped.value();
                     * // => [1, 4]
                     */
                    function wrapperPlant(value) {
                      var result,
                        parent = this;

                      while (parent instanceof baseLodash) {
                        var clone = wrapperClone(parent);
                        clone.__index__ = 0;
                        clone.__values__ = undefined;
                        if (result) {
                          previous.__wrapped__ = clone;
                        } else {
                          result = clone;
                        }
                        var previous = clone;
                        parent = parent.__wrapped__;
                      }
                      previous.__wrapped__ = value;
                      return result;
                    }

                    /**
                     * This method is the wrapper version of `_.reverse`.
                     *
                     * **Note:** This method mutates the wrapped array.
                     *
                     * @name reverse
                     * @memberOf _
                     * @since 0.1.0
                     * @category Seq
                     * @returns {Object} Returns the new `lodash` wrapper instance.
                     * @example
                     *
                     * var array = [1, 2, 3];
                     *
                     * _(array).reverse().value()
                     * // => [3, 2, 1]
                     *
                     * console.log(array);
                     * // => [3, 2, 1]
                     */
                    function wrapperReverse() {
                      var value = this.__wrapped__;
                      if (value instanceof LazyWrapper) {
                        var wrapped = value;
                        if (this.__actions__.length) {
                          wrapped = new LazyWrapper(this);
                        }
                        wrapped = wrapped.reverse();
                        wrapped.__actions__.push({
                          func: thru,
                          args: [reverse],
                          thisArg: undefined
                        });
                        return new LodashWrapper(wrapped, this.__chain__);
                      }
                      return this.thru(reverse);
                    }

                    /**
                     * Executes the chain sequence to resolve the unwrapped value.
                     *
                     * @name value
                     * @memberOf _
                     * @since 0.1.0
                     * @alias toJSON, valueOf
                     * @category Seq
                     * @returns {*} Returns the resolved unwrapped value.
                     * @example
                     *
                     * _([1, 2, 3]).value();
                     * // => [1, 2, 3]
                     */
                    function wrapperValue() {
                      return baseWrapperValue(this.__wrapped__, this.__actions__);
                    }

                    /*------------------------------------------------------------------------*/

                    /**
                     * Creates an object composed of keys generated from the results of running
                     * each element of `collection` thru `iteratee`. The corresponding value of
                     * each key is the number of times the key was returned by `iteratee`. The
                     * iteratee is invoked with one argument: (value).
                     *
                     * @static
                     * @memberOf _
                     * @since 0.5.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
                     * @returns {Object} Returns the composed aggregate object.
                     * @example
                     *
                     * _.countBy([6.1, 4.2, 6.3], Math.floor);
                     * // => { '4': 1, '6': 2 }
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.countBy(['one', 'two', 'three'], 'length');
                     * // => { '3': 2, '5': 1 }
                     */
                    var countBy = createAggregator(function (result, value, key) {
                      if (hasOwnProperty.call(result, key)) {
                        ++result[key];
                      } else {
                        baseAssignValue(result, key, 1);
                      }
                    });

                    /**
                     * Checks if `predicate` returns truthy for **all** elements of `collection`.
                     * Iteration is stopped once `predicate` returns falsey. The predicate is
                     * invoked with three arguments: (value, index|key, collection).
                     *
                     * **Note:** This method returns `true` for
                     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
                     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
                     * elements of empty collections.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} [predicate=_.identity] The function invoked per iteration.
                     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                     * @returns {boolean} Returns `true` if all elements pass the predicate check,
                     *  else `false`.
                     * @example
                     *
                     * _.every([true, 1, null, 'yes'], Boolean);
                     * // => false
                     *
                     * var users = [
                     *   { 'user': 'barney', 'age': 36, 'active': false },
                     *   { 'user': 'fred',   'age': 40, 'active': false }
                     * ];
                     *
                     * // The `_.matches` iteratee shorthand.
                     * _.every(users, { 'user': 'barney', 'active': false });
                     * // => false
                     *
                     * // The `_.matchesProperty` iteratee shorthand.
                     * _.every(users, ['active', false]);
                     * // => true
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.every(users, 'active');
                     * // => false
                     */
                    function every(collection, predicate, guard) {
                      var func = isArray(collection) ? arrayEvery : baseEvery;
                      if (guard && isIterateeCall(collection, predicate, guard)) {
                        predicate = undefined;
                      }
                      return func(collection, getIteratee(predicate, 3));
                    }

                    /**
                     * Iterates over elements of `collection`, returning an array of all elements
                     * `predicate` returns truthy for. The predicate is invoked with three
                     * arguments: (value, index|key, collection).
                     *
                     * **Note:** Unlike `_.remove`, this method returns a new array.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} [predicate=_.identity] The function invoked per iteration.
                     * @returns {Array} Returns the new filtered array.
                     * @see _.reject
                     * @example
                     *
                     * var users = [
                     *   { 'user': 'barney', 'age': 36, 'active': true },
                     *   { 'user': 'fred',   'age': 40, 'active': false }
                     * ];
                     *
                     * _.filter(users, function(o) { return !o.active; });
                     * // => objects for ['fred']
                     *
                     * // The `_.matches` iteratee shorthand.
                     * _.filter(users, { 'age': 36, 'active': true });
                     * // => objects for ['barney']
                     *
                     * // The `_.matchesProperty` iteratee shorthand.
                     * _.filter(users, ['active', false]);
                     * // => objects for ['fred']
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.filter(users, 'active');
                     * // => objects for ['barney']
                     */
                    function filter(collection, predicate) {
                      var func = isArray(collection) ? arrayFilter : baseFilter;
                      return func(collection, getIteratee(predicate, 3));
                    }

                    /**
                     * Iterates over elements of `collection`, returning the first element
                     * `predicate` returns truthy for. The predicate is invoked with three
                     * arguments: (value, index|key, collection).
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to inspect.
                     * @param {Function} [predicate=_.identity] The function invoked per iteration.
                     * @param {number} [fromIndex=0] The index to search from.
                     * @returns {*} Returns the matched element, else `undefined`.
                     * @example
                     *
                     * var users = [
                     *   { 'user': 'barney',  'age': 36, 'active': true },
                     *   { 'user': 'fred',    'age': 40, 'active': false },
                     *   { 'user': 'pebbles', 'age': 1,  'active': true }
                     * ];
                     *
                     * _.find(users, function(o) { return o.age < 40; });
                     * // => object for 'barney'
                     *
                     * // The `_.matches` iteratee shorthand.
                     * _.find(users, { 'age': 1, 'active': true });
                     * // => object for 'pebbles'
                     *
                     * // The `_.matchesProperty` iteratee shorthand.
                     * _.find(users, ['active', false]);
                     * // => object for 'fred'
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.find(users, 'active');
                     * // => object for 'barney'
                     */
                    var find = createFind(findIndex);

                    /**
                     * This method is like `_.find` except that it iterates over elements of
                     * `collection` from right to left.
                     *
                     * @static
                     * @memberOf _
                     * @since 2.0.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to inspect.
                     * @param {Function} [predicate=_.identity] The function invoked per iteration.
                     * @param {number} [fromIndex=collection.length-1] The index to search from.
                     * @returns {*} Returns the matched element, else `undefined`.
                     * @example
                     *
                     * _.findLast([1, 2, 3, 4], function(n) {
                     *   return n % 2 == 1;
                     * });
                     * // => 3
                     */
                    var findLast = createFind(findLastIndex);

                    /**
                     * Creates a flattened array of values by running each element in `collection`
                     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
                     * with three arguments: (value, index|key, collection).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                     * @returns {Array} Returns the new flattened array.
                     * @example
                     *
                     * function duplicate(n) {
                     *   return [n, n];
                     * }
                     *
                     * _.flatMap([1, 2], duplicate);
                     * // => [1, 1, 2, 2]
                     */
                    function flatMap(collection, iteratee) {
                      return baseFlatten(map(collection, iteratee), 1);
                    }

                    /**
                     * This method is like `_.flatMap` except that it recursively flattens the
                     * mapped results.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.7.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                     * @returns {Array} Returns the new flattened array.
                     * @example
                     *
                     * function duplicate(n) {
                     *   return [[[n, n]]];
                     * }
                     *
                     * _.flatMapDeep([1, 2], duplicate);
                     * // => [1, 1, 2, 2]
                     */
                    function flatMapDeep(collection, iteratee) {
                      return baseFlatten(map(collection, iteratee), INFINITY);
                    }

                    /**
                     * This method is like `_.flatMap` except that it recursively flattens the
                     * mapped results up to `depth` times.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.7.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                     * @param {number} [depth=1] The maximum recursion depth.
                     * @returns {Array} Returns the new flattened array.
                     * @example
                     *
                     * function duplicate(n) {
                     *   return [[[n, n]]];
                     * }
                     *
                     * _.flatMapDepth([1, 2], duplicate, 2);
                     * // => [[1, 1], [2, 2]]
                     */
                    function flatMapDepth(collection, iteratee, depth) {
                      depth = depth === undefined ? 1 : toInteger(depth);
                      return baseFlatten(map(collection, iteratee), depth);
                    }

                    /**
                     * Iterates over elements of `collection` and invokes `iteratee` for each element.
                     * The iteratee is invoked with three arguments: (value, index|key, collection).
                     * Iteratee functions may exit iteration early by explicitly returning `false`.
                     *
                     * **Note:** As with other "Collections" methods, objects with a "length"
                     * property are iterated like arrays. To avoid this behavior use `_.forIn`
                     * or `_.forOwn` for object iteration.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @alias each
                     * @category Collection
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                     * @returns {Array|Object} Returns `collection`.
                     * @see _.forEachRight
                     * @example
                     *
                     * _.forEach([1, 2], function(value) {
                     *   console.log(value);
                     * });
                     * // => Logs `1` then `2`.
                     *
                     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
                     *   console.log(key);
                     * });
                     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
                     */
                    function forEach(collection, iteratee) {
                      var func = isArray(collection) ? arrayEach : baseEach;
                      return func(collection, getIteratee(iteratee, 3));
                    }

                    /**
                     * This method is like `_.forEach` except that it iterates over elements of
                     * `collection` from right to left.
                     *
                     * @static
                     * @memberOf _
                     * @since 2.0.0
                     * @alias eachRight
                     * @category Collection
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                     * @returns {Array|Object} Returns `collection`.
                     * @see _.forEach
                     * @example
                     *
                     * _.forEachRight([1, 2], function(value) {
                     *   console.log(value);
                     * });
                     * // => Logs `2` then `1`.
                     */
                    function forEachRight(collection, iteratee) {
                      var func = isArray(collection) ? arrayEachRight : baseEachRight;
                      return func(collection, getIteratee(iteratee, 3));
                    }

                    /**
                     * Creates an object composed of keys generated from the results of running
                     * each element of `collection` thru `iteratee`. The order of grouped values
                     * is determined by the order they occur in `collection`. The corresponding
                     * value of each key is an array of elements responsible for generating the
                     * key. The iteratee is invoked with one argument: (value).
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
                     * @returns {Object} Returns the composed aggregate object.
                     * @example
                     *
                     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
                     * // => { '4': [4.2], '6': [6.1, 6.3] }
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.groupBy(['one', 'two', 'three'], 'length');
                     * // => { '3': ['one', 'two'], '5': ['three'] }
                     */
                    var groupBy = createAggregator(function (result, value, key) {
                      if (hasOwnProperty.call(result, key)) {
                        result[key].push(value);
                      } else {
                        baseAssignValue(result, key, [value]);
                      }
                    });

                    /**
                     * Checks if `value` is in `collection`. If `collection` is a string, it's
                     * checked for a substring of `value`, otherwise
                     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                     * is used for equality comparisons. If `fromIndex` is negative, it's used as
                     * the offset from the end of `collection`.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Collection
                     * @param {Array|Object|string} collection The collection to inspect.
                     * @param {*} value The value to search for.
                     * @param {number} [fromIndex=0] The index to search from.
                     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
                     * @returns {boolean} Returns `true` if `value` is found, else `false`.
                     * @example
                     *
                     * _.includes([1, 2, 3], 1);
                     * // => true
                     *
                     * _.includes([1, 2, 3], 1, 2);
                     * // => false
                     *
                     * _.includes({ 'a': 1, 'b': 2 }, 1);
                     * // => true
                     *
                     * _.includes('abcd', 'bc');
                     * // => true
                     */
                    function includes(collection, value, fromIndex, guard) {
                      collection = isArrayLike(collection) ? collection : values(collection);
                      fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;

                      var length = collection.length;
                      if (fromIndex < 0) {
                        fromIndex = nativeMax(length + fromIndex, 0);
                      }
                      return isString(collection)
                        ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1
                        : !!length && baseIndexOf(collection, value, fromIndex) > -1;
                    }

                    /**
                     * Invokes the method at `path` of each element in `collection`, returning
                     * an array of the results of each invoked method. Any additional arguments
                     * are provided to each invoked method. If `path` is a function, it's invoked
                     * for, and `this` bound to, each element in `collection`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Array|Function|string} path The path of the method to invoke or
                     *  the function invoked per iteration.
                     * @param {...*} [args] The arguments to invoke each method with.
                     * @returns {Array} Returns the array of results.
                     * @example
                     *
                     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
                     * // => [[1, 5, 7], [1, 2, 3]]
                     *
                     * _.invokeMap([123, 456], String.prototype.split, '');
                     * // => [['1', '2', '3'], ['4', '5', '6']]
                     */
                    var invokeMap = baseRest(function (collection, path, args) {
                      var index = -1,
                        isFunc = typeof path == 'function',
                        result = isArrayLike(collection) ? Array(collection.length) : [];

                      baseEach(collection, function (value) {
                        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
                      });
                      return result;
                    });

                    /**
                     * Creates an object composed of keys generated from the results of running
                     * each element of `collection` thru `iteratee`. The corresponding value of
                     * each key is the last element responsible for generating the key. The
                     * iteratee is invoked with one argument: (value).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
                     * @returns {Object} Returns the composed aggregate object.
                     * @example
                     *
                     * var array = [
                     *   { 'dir': 'left', 'code': 97 },
                     *   { 'dir': 'right', 'code': 100 }
                     * ];
                     *
                     * _.keyBy(array, function(o) {
                     *   return String.fromCharCode(o.code);
                     * });
                     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
                     *
                     * _.keyBy(array, 'dir');
                     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
                     */
                    var keyBy = createAggregator(function (result, value, key) {
                      baseAssignValue(result, key, value);
                    });

                    /**
                     * Creates an array of values by running each element in `collection` thru
                     * `iteratee`. The iteratee is invoked with three arguments:
                     * (value, index|key, collection).
                     *
                     * Many lodash methods are guarded to work as iteratees for methods like
                     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
                     *
                     * The guarded methods are:
                     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
                     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
                     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
                     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                     * @returns {Array} Returns the new mapped array.
                     * @example
                     *
                     * function square(n) {
                     *   return n * n;
                     * }
                     *
                     * _.map([4, 8], square);
                     * // => [16, 64]
                     *
                     * _.map({ 'a': 4, 'b': 8 }, square);
                     * // => [16, 64] (iteration order is not guaranteed)
                     *
                     * var users = [
                     *   { 'user': 'barney' },
                     *   { 'user': 'fred' }
                     * ];
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.map(users, 'user');
                     * // => ['barney', 'fred']
                     */
                    function map(collection, iteratee) {
                      var func = isArray(collection) ? arrayMap : baseMap;
                      return func(collection, getIteratee(iteratee, 3));
                    }

                    /**
                     * This method is like `_.sortBy` except that it allows specifying the sort
                     * orders of the iteratees to sort by. If `orders` is unspecified, all values
                     * are sorted in ascending order. Otherwise, specify an order of "desc" for
                     * descending or "asc" for ascending sort order of corresponding values.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
                     *  The iteratees to sort by.
                     * @param {string[]} [orders] The sort orders of `iteratees`.
                     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
                     * @returns {Array} Returns the new sorted array.
                     * @example
                     *
                     * var users = [
                     *   { 'user': 'fred',   'age': 48 },
                     *   { 'user': 'barney', 'age': 34 },
                     *   { 'user': 'fred',   'age': 40 },
                     *   { 'user': 'barney', 'age': 36 }
                     * ];
                     *
                     * // Sort by `user` in ascending order and by `age` in descending order.
                     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
                     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
                     */
                    function orderBy(collection, iteratees, orders, guard) {
                      if (collection == null) {
                        return [];
                      }
                      if (!isArray(iteratees)) {
                        iteratees = iteratees == null ? [] : [iteratees];
                      }
                      orders = guard ? undefined : orders;
                      if (!isArray(orders)) {
                        orders = orders == null ? [] : [orders];
                      }
                      return baseOrderBy(collection, iteratees, orders);
                    }

                    /**
                     * Creates an array of elements split into two groups, the first of which
                     * contains elements `predicate` returns truthy for, the second of which
                     * contains elements `predicate` returns falsey for. The predicate is
                     * invoked with one argument: (value).
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} [predicate=_.identity] The function invoked per iteration.
                     * @returns {Array} Returns the array of grouped elements.
                     * @example
                     *
                     * var users = [
                     *   { 'user': 'barney',  'age': 36, 'active': false },
                     *   { 'user': 'fred',    'age': 40, 'active': true },
                     *   { 'user': 'pebbles', 'age': 1,  'active': false }
                     * ];
                     *
                     * _.partition(users, function(o) { return o.active; });
                     * // => objects for [['fred'], ['barney', 'pebbles']]
                     *
                     * // The `_.matches` iteratee shorthand.
                     * _.partition(users, { 'age': 1, 'active': false });
                     * // => objects for [['pebbles'], ['barney', 'fred']]
                     *
                     * // The `_.matchesProperty` iteratee shorthand.
                     * _.partition(users, ['active', false]);
                     * // => objects for [['barney', 'pebbles'], ['fred']]
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.partition(users, 'active');
                     * // => objects for [['fred'], ['barney', 'pebbles']]
                     */
                    var partition = createAggregator(
                      function (result, value, key) {
                        result[key ? 0 : 1].push(value);
                      },
                      function () {
                        return [[], []];
                      }
                    );

                    /**
                     * Reduces `collection` to a value which is the accumulated result of running
                     * each element in `collection` thru `iteratee`, where each successive
                     * invocation is supplied the return value of the previous. If `accumulator`
                     * is not given, the first element of `collection` is used as the initial
                     * value. The iteratee is invoked with four arguments:
                     * (accumulator, value, index|key, collection).
                     *
                     * Many lodash methods are guarded to work as iteratees for methods like
                     * `_.reduce`, `_.reduceRight`, and `_.transform`.
                     *
                     * The guarded methods are:
                     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
                     * and `sortBy`
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                     * @param {*} [accumulator] The initial value.
                     * @returns {*} Returns the accumulated value.
                     * @see _.reduceRight
                     * @example
                     *
                     * _.reduce([1, 2], function(sum, n) {
                     *   return sum + n;
                     * }, 0);
                     * // => 3
                     *
                     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
                     *   (result[value] || (result[value] = [])).push(key);
                     *   return result;
                     * }, {});
                     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
                     */
                    function reduce(collection, iteratee, accumulator) {
                      var func = isArray(collection) ? arrayReduce : baseReduce,
                        initAccum = arguments.length < 3;

                      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
                    }

                    /**
                     * This method is like `_.reduce` except that it iterates over elements of
                     * `collection` from right to left.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                     * @param {*} [accumulator] The initial value.
                     * @returns {*} Returns the accumulated value.
                     * @see _.reduce
                     * @example
                     *
                     * var array = [[0, 1], [2, 3], [4, 5]];
                     *
                     * _.reduceRight(array, function(flattened, other) {
                     *   return flattened.concat(other);
                     * }, []);
                     * // => [4, 5, 2, 3, 0, 1]
                     */
                    function reduceRight(collection, iteratee, accumulator) {
                      var func = isArray(collection) ? arrayReduceRight : baseReduce,
                        initAccum = arguments.length < 3;

                      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
                    }

                    /**
                     * The opposite of `_.filter`; this method returns the elements of `collection`
                     * that `predicate` does **not** return truthy for.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} [predicate=_.identity] The function invoked per iteration.
                     * @returns {Array} Returns the new filtered array.
                     * @see _.filter
                     * @example
                     *
                     * var users = [
                     *   { 'user': 'barney', 'age': 36, 'active': false },
                     *   { 'user': 'fred',   'age': 40, 'active': true }
                     * ];
                     *
                     * _.reject(users, function(o) { return !o.active; });
                     * // => objects for ['fred']
                     *
                     * // The `_.matches` iteratee shorthand.
                     * _.reject(users, { 'age': 40, 'active': true });
                     * // => objects for ['barney']
                     *
                     * // The `_.matchesProperty` iteratee shorthand.
                     * _.reject(users, ['active', false]);
                     * // => objects for ['fred']
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.reject(users, 'active');
                     * // => objects for ['barney']
                     */
                    function reject(collection, predicate) {
                      var func = isArray(collection) ? arrayFilter : baseFilter;
                      return func(collection, negate(getIteratee(predicate, 3)));
                    }

                    /**
                     * Gets a random element from `collection`.
                     *
                     * @static
                     * @memberOf _
                     * @since 2.0.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to sample.
                     * @returns {*} Returns the random element.
                     * @example
                     *
                     * _.sample([1, 2, 3, 4]);
                     * // => 2
                     */
                    function sample(collection) {
                      var func = isArray(collection) ? arraySample : baseSample;
                      return func(collection);
                    }

                    /**
                     * Gets `n` random elements at unique keys from `collection` up to the
                     * size of `collection`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to sample.
                     * @param {number} [n=1] The number of elements to sample.
                     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                     * @returns {Array} Returns the random elements.
                     * @example
                     *
                     * _.sampleSize([1, 2, 3], 2);
                     * // => [3, 1]
                     *
                     * _.sampleSize([1, 2, 3], 4);
                     * // => [2, 3, 1]
                     */
                    function sampleSize(collection, n, guard) {
                      if (guard ? isIterateeCall(collection, n, guard) : n === undefined) {
                        n = 1;
                      } else {
                        n = toInteger(n);
                      }
                      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
                      return func(collection, n);
                    }

                    /**
                     * Creates an array of shuffled values, using a version of the
                     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to shuffle.
                     * @returns {Array} Returns the new shuffled array.
                     * @example
                     *
                     * _.shuffle([1, 2, 3, 4]);
                     * // => [4, 1, 3, 2]
                     */
                    function shuffle(collection) {
                      var func = isArray(collection) ? arrayShuffle : baseShuffle;
                      return func(collection);
                    }

                    /**
                     * Gets the size of `collection` by returning its length for array-like
                     * values or the number of own enumerable string keyed properties for objects.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Collection
                     * @param {Array|Object|string} collection The collection to inspect.
                     * @returns {number} Returns the collection size.
                     * @example
                     *
                     * _.size([1, 2, 3]);
                     * // => 3
                     *
                     * _.size({ 'a': 1, 'b': 2 });
                     * // => 2
                     *
                     * _.size('pebbles');
                     * // => 7
                     */
                    function size(collection) {
                      if (collection == null) {
                        return 0;
                      }
                      if (isArrayLike(collection)) {
                        return isString(collection) ? stringSize(collection) : collection.length;
                      }
                      var tag = getTag(collection);
                      if (tag == mapTag || tag == setTag) {
                        return collection.size;
                      }
                      return baseKeys(collection).length;
                    }

                    /**
                     * Checks if `predicate` returns truthy for **any** element of `collection`.
                     * Iteration is stopped once `predicate` returns truthy. The predicate is
                     * invoked with three arguments: (value, index|key, collection).
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {Function} [predicate=_.identity] The function invoked per iteration.
                     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                     * @returns {boolean} Returns `true` if any element passes the predicate check,
                     *  else `false`.
                     * @example
                     *
                     * _.some([null, 0, 'yes', false], Boolean);
                     * // => true
                     *
                     * var users = [
                     *   { 'user': 'barney', 'active': true },
                     *   { 'user': 'fred',   'active': false }
                     * ];
                     *
                     * // The `_.matches` iteratee shorthand.
                     * _.some(users, { 'user': 'barney', 'active': false });
                     * // => false
                     *
                     * // The `_.matchesProperty` iteratee shorthand.
                     * _.some(users, ['active', false]);
                     * // => true
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.some(users, 'active');
                     * // => true
                     */
                    function some(collection, predicate, guard) {
                      var func = isArray(collection) ? arraySome : baseSome;
                      if (guard && isIterateeCall(collection, predicate, guard)) {
                        predicate = undefined;
                      }
                      return func(collection, getIteratee(predicate, 3));
                    }

                    /**
                     * Creates an array of elements, sorted in ascending order by the results of
                     * running each element in a collection thru each iteratee. This method
                     * performs a stable sort, that is, it preserves the original sort order of
                     * equal elements. The iteratees are invoked with one argument: (value).
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Collection
                     * @param {Array|Object} collection The collection to iterate over.
                     * @param {...(Function|Function[])} [iteratees=[_.identity]]
                     *  The iteratees to sort by.
                     * @returns {Array} Returns the new sorted array.
                     * @example
                     *
                     * var users = [
                     *   { 'user': 'fred',   'age': 48 },
                     *   { 'user': 'barney', 'age': 36 },
                     *   { 'user': 'fred',   'age': 40 },
                     *   { 'user': 'barney', 'age': 34 }
                     * ];
                     *
                     * _.sortBy(users, [function(o) { return o.user; }]);
                     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
                     *
                     * _.sortBy(users, ['user', 'age']);
                     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
                     */
                    var sortBy = baseRest(function (collection, iteratees) {
                      if (collection == null) {
                        return [];
                      }
                      var length = iteratees.length;
                      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
                        iteratees = [];
                      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
                        iteratees = [iteratees[0]];
                      }
                      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
                    });

                    /*------------------------------------------------------------------------*/

                    /**
                     * Gets the timestamp of the number of milliseconds that have elapsed since
                     * the Unix epoch (1 January 1970 00:00:00 UTC).
                     *
                     * @static
                     * @memberOf _
                     * @since 2.4.0
                     * @category Date
                     * @returns {number} Returns the timestamp.
                     * @example
                     *
                     * _.defer(function(stamp) {
                     *   console.log(_.now() - stamp);
                     * }, _.now());
                     * // => Logs the number of milliseconds it took for the deferred invocation.
                     */
                    var now =
                      ctxNow ||
                      function () {
                        return root.Date.now();
                      };

                    /*------------------------------------------------------------------------*/

                    /**
                     * The opposite of `_.before`; this method creates a function that invokes
                     * `func` once it's called `n` or more times.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Function
                     * @param {number} n The number of calls before `func` is invoked.
                     * @param {Function} func The function to restrict.
                     * @returns {Function} Returns the new restricted function.
                     * @example
                     *
                     * var saves = ['profile', 'settings'];
                     *
                     * var done = _.after(saves.length, function() {
                     *   console.log('done saving!');
                     * });
                     *
                     * _.forEach(saves, function(type) {
                     *   asyncSave({ 'type': type, 'complete': done });
                     * });
                     * // => Logs 'done saving!' after the two async saves have completed.
                     */
                    function after(n, func) {
                      if (typeof func != 'function') {
                        throw new TypeError(FUNC_ERROR_TEXT);
                      }
                      n = toInteger(n);
                      return function () {
                        if (--n < 1) {
                          return func.apply(this, arguments);
                        }
                      };
                    }

                    /**
                     * Creates a function that invokes `func`, with up to `n` arguments,
                     * ignoring any additional arguments.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Function
                     * @param {Function} func The function to cap arguments for.
                     * @param {number} [n=func.length] The arity cap.
                     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                     * @returns {Function} Returns the new capped function.
                     * @example
                     *
                     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
                     * // => [6, 8, 10]
                     */
                    function ary(func, n, guard) {
                      n = guard ? undefined : n;
                      n = func && n == null ? func.length : n;
                      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
                    }

                    /**
                     * Creates a function that invokes `func`, with the `this` binding and arguments
                     * of the created function, while it's called less than `n` times. Subsequent
                     * calls to the created function return the result of the last `func` invocation.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Function
                     * @param {number} n The number of calls at which `func` is no longer invoked.
                     * @param {Function} func The function to restrict.
                     * @returns {Function} Returns the new restricted function.
                     * @example
                     *
                     * jQuery(element).on('click', _.before(5, addContactToList));
                     * // => Allows adding up to 4 contacts to the list.
                     */
                    function before(n, func) {
                      var result;
                      if (typeof func != 'function') {
                        throw new TypeError(FUNC_ERROR_TEXT);
                      }
                      n = toInteger(n);
                      return function () {
                        if (--n > 0) {
                          result = func.apply(this, arguments);
                        }
                        if (n <= 1) {
                          func = undefined;
                        }
                        return result;
                      };
                    }

                    /**
                     * Creates a function that invokes `func` with the `this` binding of `thisArg`
                     * and `partials` prepended to the arguments it receives.
                     *
                     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
                     * may be used as a placeholder for partially applied arguments.
                     *
                     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
                     * property of bound functions.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Function
                     * @param {Function} func The function to bind.
                     * @param {*} thisArg The `this` binding of `func`.
                     * @param {...*} [partials] The arguments to be partially applied.
                     * @returns {Function} Returns the new bound function.
                     * @example
                     *
                     * function greet(greeting, punctuation) {
                     *   return greeting + ' ' + this.user + punctuation;
                     * }
                     *
                     * var object = { 'user': 'fred' };
                     *
                     * var bound = _.bind(greet, object, 'hi');
                     * bound('!');
                     * // => 'hi fred!'
                     *
                     * // Bound with placeholders.
                     * var bound = _.bind(greet, object, _, '!');
                     * bound('hi');
                     * // => 'hi fred!'
                     */
                    var bind = baseRest(function (func, thisArg, partials) {
                      var bitmask = WRAP_BIND_FLAG;
                      if (partials.length) {
                        var holders = replaceHolders(partials, getHolder(bind));
                        bitmask |= WRAP_PARTIAL_FLAG;
                      }
                      return createWrap(func, bitmask, thisArg, partials, holders);
                    });

                    /**
                     * Creates a function that invokes the method at `object[key]` with `partials`
                     * prepended to the arguments it receives.
                     *
                     * This method differs from `_.bind` by allowing bound functions to reference
                     * methods that may be redefined or don't yet exist. See
                     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
                     * for more details.
                     *
                     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
                     * builds, may be used as a placeholder for partially applied arguments.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.10.0
                     * @category Function
                     * @param {Object} object The object to invoke the method on.
                     * @param {string} key The key of the method.
                     * @param {...*} [partials] The arguments to be partially applied.
                     * @returns {Function} Returns the new bound function.
                     * @example
                     *
                     * var object = {
                     *   'user': 'fred',
                     *   'greet': function(greeting, punctuation) {
                     *     return greeting + ' ' + this.user + punctuation;
                     *   }
                     * };
                     *
                     * var bound = _.bindKey(object, 'greet', 'hi');
                     * bound('!');
                     * // => 'hi fred!'
                     *
                     * object.greet = function(greeting, punctuation) {
                     *   return greeting + 'ya ' + this.user + punctuation;
                     * };
                     *
                     * bound('!');
                     * // => 'hiya fred!'
                     *
                     * // Bound with placeholders.
                     * var bound = _.bindKey(object, 'greet', _, '!');
                     * bound('hi');
                     * // => 'hiya fred!'
                     */
                    var bindKey = baseRest(function (object, key, partials) {
                      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
                      if (partials.length) {
                        var holders = replaceHolders(partials, getHolder(bindKey));
                        bitmask |= WRAP_PARTIAL_FLAG;
                      }
                      return createWrap(key, bitmask, object, partials, holders);
                    });

                    /**
                     * Creates a function that accepts arguments of `func` and either invokes
                     * `func` returning its result, if at least `arity` number of arguments have
                     * been provided, or returns a function that accepts the remaining `func`
                     * arguments, and so on. The arity of `func` may be specified if `func.length`
                     * is not sufficient.
                     *
                     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
                     * may be used as a placeholder for provided arguments.
                     *
                     * **Note:** This method doesn't set the "length" property of curried functions.
                     *
                     * @static
                     * @memberOf _
                     * @since 2.0.0
                     * @category Function
                     * @param {Function} func The function to curry.
                     * @param {number} [arity=func.length] The arity of `func`.
                     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                     * @returns {Function} Returns the new curried function.
                     * @example
                     *
                     * var abc = function(a, b, c) {
                     *   return [a, b, c];
                     * };
                     *
                     * var curried = _.curry(abc);
                     *
                     * curried(1)(2)(3);
                     * // => [1, 2, 3]
                     *
                     * curried(1, 2)(3);
                     * // => [1, 2, 3]
                     *
                     * curried(1, 2, 3);
                     * // => [1, 2, 3]
                     *
                     * // Curried with placeholders.
                     * curried(1)(_, 3)(2);
                     * // => [1, 2, 3]
                     */
                    function curry(func, arity, guard) {
                      arity = guard ? undefined : arity;
                      var result = createWrap(
                        func,
                        WRAP_CURRY_FLAG,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        arity
                      );
                      result.placeholder = curry.placeholder;
                      return result;
                    }

                    /**
                     * This method is like `_.curry` except that arguments are applied to `func`
                     * in the manner of `_.partialRight` instead of `_.partial`.
                     *
                     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
                     * builds, may be used as a placeholder for provided arguments.
                     *
                     * **Note:** This method doesn't set the "length" property of curried functions.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Function
                     * @param {Function} func The function to curry.
                     * @param {number} [arity=func.length] The arity of `func`.
                     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                     * @returns {Function} Returns the new curried function.
                     * @example
                     *
                     * var abc = function(a, b, c) {
                     *   return [a, b, c];
                     * };
                     *
                     * var curried = _.curryRight(abc);
                     *
                     * curried(3)(2)(1);
                     * // => [1, 2, 3]
                     *
                     * curried(2, 3)(1);
                     * // => [1, 2, 3]
                     *
                     * curried(1, 2, 3);
                     * // => [1, 2, 3]
                     *
                     * // Curried with placeholders.
                     * curried(3)(1, _)(2);
                     * // => [1, 2, 3]
                     */
                    function curryRight(func, arity, guard) {
                      arity = guard ? undefined : arity;
                      var result = createWrap(
                        func,
                        WRAP_CURRY_RIGHT_FLAG,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        arity
                      );
                      result.placeholder = curryRight.placeholder;
                      return result;
                    }

                    /**
                     * Creates a debounced function that delays invoking `func` until after `wait`
                     * milliseconds have elapsed since the last time the debounced function was
                     * invoked. The debounced function comes with a `cancel` method to cancel
                     * delayed `func` invocations and a `flush` method to immediately invoke them.
                     * Provide `options` to indicate whether `func` should be invoked on the
                     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
                     * with the last arguments provided to the debounced function. Subsequent
                     * calls to the debounced function return the result of the last `func`
                     * invocation.
                     *
                     * **Note:** If `leading` and `trailing` options are `true`, `func` is
                     * invoked on the trailing edge of the timeout only if the debounced function
                     * is invoked more than once during the `wait` timeout.
                     *
                     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
                     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
                     *
                     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
                     * for details over the differences between `_.debounce` and `_.throttle`.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Function
                     * @param {Function} func The function to debounce.
                     * @param {number} [wait=0] The number of milliseconds to delay.
                     * @param {Object} [options={}] The options object.
                     * @param {boolean} [options.leading=false]
                     *  Specify invoking on the leading edge of the timeout.
                     * @param {number} [options.maxWait]
                     *  The maximum time `func` is allowed to be delayed before it's invoked.
                     * @param {boolean} [options.trailing=true]
                     *  Specify invoking on the trailing edge of the timeout.
                     * @returns {Function} Returns the new debounced function.
                     * @example
                     *
                     * // Avoid costly calculations while the window size is in flux.
                     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
                     *
                     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
                     * jQuery(element).on('click', _.debounce(sendMail, 300, {
                     *   'leading': true,
                     *   'trailing': false
                     * }));
                     *
                     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
                     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
                     * var source = new EventSource('/stream');
                     * jQuery(source).on('message', debounced);
                     *
                     * // Cancel the trailing debounced invocation.
                     * jQuery(window).on('popstate', debounced.cancel);
                     */
                    function debounce(func, wait, options) {
                      var lastArgs,
                        lastThis,
                        maxWait,
                        result,
                        timerId,
                        lastCallTime,
                        lastInvokeTime = 0,
                        leading = false,
                        maxing = false,
                        trailing = true;

                      if (typeof func != 'function') {
                        throw new TypeError(FUNC_ERROR_TEXT);
                      }
                      wait = toNumber(wait) || 0;
                      if (isObject(options)) {
                        leading = !!options.leading;
                        maxing = 'maxWait' in options;
                        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                        trailing = 'trailing' in options ? !!options.trailing : trailing;
                      }

                      function invokeFunc(time) {
                        var args = lastArgs,
                          thisArg = lastThis;

                        lastArgs = lastThis = undefined;
                        lastInvokeTime = time;
                        result = func.apply(thisArg, args);
                        return result;
                      }

                      function leadingEdge(time) {
                        // Reset any `maxWait` timer.
                        lastInvokeTime = time;
                        // Start the timer for the trailing edge.
                        timerId = setTimeout(timerExpired, wait);
                        // Invoke the leading edge.
                        return leading ? invokeFunc(time) : result;
                      }

                      function remainingWait(time) {
                        var timeSinceLastCall = time - lastCallTime,
                          timeSinceLastInvoke = time - lastInvokeTime,
                          result = wait - timeSinceLastCall;

                        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
                      }

                      function shouldInvoke(time) {
                        var timeSinceLastCall = time - lastCallTime,
                          timeSinceLastInvoke = time - lastInvokeTime;

                        // Either this is the first call, activity has stopped and we're at the
                        // trailing edge, the system time has gone backwards and we're treating
                        // it as the trailing edge, or we've hit the `maxWait` limit.
                        return (
                          lastCallTime === undefined ||
                          timeSinceLastCall >= wait ||
                          timeSinceLastCall < 0 ||
                          (maxing && timeSinceLastInvoke >= maxWait)
                        );
                      }

                      function timerExpired() {
                        var time = now();
                        if (shouldInvoke(time)) {
                          return trailingEdge(time);
                        }
                        // Restart the timer.
                        timerId = setTimeout(timerExpired, remainingWait(time));
                      }

                      function trailingEdge(time) {
                        timerId = undefined;

                        // Only invoke if we have `lastArgs` which means `func` has been
                        // debounced at least once.
                        if (trailing && lastArgs) {
                          return invokeFunc(time);
                        }
                        lastArgs = lastThis = undefined;
                        return result;
                      }

                      function cancel() {
                        if (timerId !== undefined) {
                          clearTimeout(timerId);
                        }
                        lastInvokeTime = 0;
                        lastArgs = lastCallTime = lastThis = timerId = undefined;
                      }

                      function flush() {
                        return timerId === undefined ? result : trailingEdge(now());
                      }

                      function debounced() {
                        var time = now(),
                          isInvoking = shouldInvoke(time);

                        lastArgs = arguments;
                        lastThis = this;
                        lastCallTime = time;

                        if (isInvoking) {
                          if (timerId === undefined) {
                            return leadingEdge(lastCallTime);
                          }
                          if (maxing) {
                            // Handle invocations in a tight loop.
                            timerId = setTimeout(timerExpired, wait);
                            return invokeFunc(lastCallTime);
                          }
                        }
                        if (timerId === undefined) {
                          timerId = setTimeout(timerExpired, wait);
                        }
                        return result;
                      }
                      debounced.cancel = cancel;
                      debounced.flush = flush;
                      return debounced;
                    }

                    /**
                     * Defers invoking the `func` until the current call stack has cleared. Any
                     * additional arguments are provided to `func` when it's invoked.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Function
                     * @param {Function} func The function to defer.
                     * @param {...*} [args] The arguments to invoke `func` with.
                     * @returns {number} Returns the timer id.
                     * @example
                     *
                     * _.defer(function(text) {
                     *   console.log(text);
                     * }, 'deferred');
                     * // => Logs 'deferred' after one millisecond.
                     */
                    var defer = baseRest(function (func, args) {
                      return baseDelay(func, 1, args);
                    });

                    /**
                     * Invokes `func` after `wait` milliseconds. Any additional arguments are
                     * provided to `func` when it's invoked.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Function
                     * @param {Function} func The function to delay.
                     * @param {number} wait The number of milliseconds to delay invocation.
                     * @param {...*} [args] The arguments to invoke `func` with.
                     * @returns {number} Returns the timer id.
                     * @example
                     *
                     * _.delay(function(text) {
                     *   console.log(text);
                     * }, 1000, 'later');
                     * // => Logs 'later' after one second.
                     */
                    var delay = baseRest(function (func, wait, args) {
                      return baseDelay(func, toNumber(wait) || 0, args);
                    });

                    /**
                     * Creates a function that invokes `func` with arguments reversed.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Function
                     * @param {Function} func The function to flip arguments for.
                     * @returns {Function} Returns the new flipped function.
                     * @example
                     *
                     * var flipped = _.flip(function() {
                     *   return _.toArray(arguments);
                     * });
                     *
                     * flipped('a', 'b', 'c', 'd');
                     * // => ['d', 'c', 'b', 'a']
                     */
                    function flip(func) {
                      return createWrap(func, WRAP_FLIP_FLAG);
                    }

                    /**
                     * Creates a function that memoizes the result of `func`. If `resolver` is
                     * provided, it determines the cache key for storing the result based on the
                     * arguments provided to the memoized function. By default, the first argument
                     * provided to the memoized function is used as the map cache key. The `func`
                     * is invoked with the `this` binding of the memoized function.
                     *
                     * **Note:** The cache is exposed as the `cache` property on the memoized
                     * function. Its creation may be customized by replacing the `_.memoize.Cache`
                     * constructor with one whose instances implement the
                     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
                     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Function
                     * @param {Function} func The function to have its output memoized.
                     * @param {Function} [resolver] The function to resolve the cache key.
                     * @returns {Function} Returns the new memoized function.
                     * @example
                     *
                     * var object = { 'a': 1, 'b': 2 };
                     * var other = { 'c': 3, 'd': 4 };
                     *
                     * var values = _.memoize(_.values);
                     * values(object);
                     * // => [1, 2]
                     *
                     * values(other);
                     * // => [3, 4]
                     *
                     * object.a = 2;
                     * values(object);
                     * // => [1, 2]
                     *
                     * // Modify the result cache.
                     * values.cache.set(object, ['a', 'b']);
                     * values(object);
                     * // => ['a', 'b']
                     *
                     * // Replace `_.memoize.Cache`.
                     * _.memoize.Cache = WeakMap;
                     */
                    function memoize(func, resolver) {
                      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
                        throw new TypeError(FUNC_ERROR_TEXT);
                      }
                      var memoized = function () {
                        var args = arguments,
                          key = resolver ? resolver.apply(this, args) : args[0],
                          cache = memoized.cache;

                        if (cache.has(key)) {
                          return cache.get(key);
                        }
                        var result = func.apply(this, args);
                        memoized.cache = cache.set(key, result) || cache;
                        return result;
                      };
                      memoized.cache = new (memoize.Cache || MapCache)();
                      return memoized;
                    }

                    // Expose `MapCache`.
                    memoize.Cache = MapCache;

                    /**
                     * Creates a function that negates the result of the predicate `func`. The
                     * `func` predicate is invoked with the `this` binding and arguments of the
                     * created function.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Function
                     * @param {Function} predicate The predicate to negate.
                     * @returns {Function} Returns the new negated function.
                     * @example
                     *
                     * function isEven(n) {
                     *   return n % 2 == 0;
                     * }
                     *
                     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
                     * // => [1, 3, 5]
                     */
                    function negate(predicate) {
                      if (typeof predicate != 'function') {
                        throw new TypeError(FUNC_ERROR_TEXT);
                      }
                      return function () {
                        var args = arguments;
                        switch (args.length) {
                          case 0:
                            return !predicate.call(this);
                          case 1:
                            return !predicate.call(this, args[0]);
                          case 2:
                            return !predicate.call(this, args[0], args[1]);
                          case 3:
                            return !predicate.call(this, args[0], args[1], args[2]);
                        }
                        return !predicate.apply(this, args);
                      };
                    }

                    /**
                     * Creates a function that is restricted to invoking `func` once. Repeat calls
                     * to the function return the value of the first invocation. The `func` is
                     * invoked with the `this` binding and arguments of the created function.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Function
                     * @param {Function} func The function to restrict.
                     * @returns {Function} Returns the new restricted function.
                     * @example
                     *
                     * var initialize = _.once(createApplication);
                     * initialize();
                     * initialize();
                     * // => `createApplication` is invoked once
                     */
                    function once(func) {
                      return before(2, func);
                    }

                    /**
                     * Creates a function that invokes `func` with its arguments transformed.
                     *
                     * @static
                     * @since 4.0.0
                     * @memberOf _
                     * @category Function
                     * @param {Function} func The function to wrap.
                     * @param {...(Function|Function[])} [transforms=[_.identity]]
                     *  The argument transforms.
                     * @returns {Function} Returns the new function.
                     * @example
                     *
                     * function doubled(n) {
                     *   return n * 2;
                     * }
                     *
                     * function square(n) {
                     *   return n * n;
                     * }
                     *
                     * var func = _.overArgs(function(x, y) {
                     *   return [x, y];
                     * }, [square, doubled]);
                     *
                     * func(9, 3);
                     * // => [81, 6]
                     *
                     * func(10, 5);
                     * // => [100, 10]
                     */
                    var overArgs = castRest(function (func, transforms) {
                      transforms =
                        transforms.length == 1 && isArray(transforms[0])
                          ? arrayMap(transforms[0], baseUnary(getIteratee()))
                          : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

                      var funcsLength = transforms.length;
                      return baseRest(function (args) {
                        var index = -1,
                          length = nativeMin(args.length, funcsLength);

                        while (++index < length) {
                          args[index] = transforms[index].call(this, args[index]);
                        }
                        return apply(func, this, args);
                      });
                    });

                    /**
                     * Creates a function that invokes `func` with `partials` prepended to the
                     * arguments it receives. This method is like `_.bind` except it does **not**
                     * alter the `this` binding.
                     *
                     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
                     * builds, may be used as a placeholder for partially applied arguments.
                     *
                     * **Note:** This method doesn't set the "length" property of partially
                     * applied functions.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.2.0
                     * @category Function
                     * @param {Function} func The function to partially apply arguments to.
                     * @param {...*} [partials] The arguments to be partially applied.
                     * @returns {Function} Returns the new partially applied function.
                     * @example
                     *
                     * function greet(greeting, name) {
                     *   return greeting + ' ' + name;
                     * }
                     *
                     * var sayHelloTo = _.partial(greet, 'hello');
                     * sayHelloTo('fred');
                     * // => 'hello fred'
                     *
                     * // Partially applied with placeholders.
                     * var greetFred = _.partial(greet, _, 'fred');
                     * greetFred('hi');
                     * // => 'hi fred'
                     */
                    var partial = baseRest(function (func, partials) {
                      var holders = replaceHolders(partials, getHolder(partial));
                      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
                    });

                    /**
                     * This method is like `_.partial` except that partially applied arguments
                     * are appended to the arguments it receives.
                     *
                     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
                     * builds, may be used as a placeholder for partially applied arguments.
                     *
                     * **Note:** This method doesn't set the "length" property of partially
                     * applied functions.
                     *
                     * @static
                     * @memberOf _
                     * @since 1.0.0
                     * @category Function
                     * @param {Function} func The function to partially apply arguments to.
                     * @param {...*} [partials] The arguments to be partially applied.
                     * @returns {Function} Returns the new partially applied function.
                     * @example
                     *
                     * function greet(greeting, name) {
                     *   return greeting + ' ' + name;
                     * }
                     *
                     * var greetFred = _.partialRight(greet, 'fred');
                     * greetFred('hi');
                     * // => 'hi fred'
                     *
                     * // Partially applied with placeholders.
                     * var sayHelloTo = _.partialRight(greet, 'hello', _);
                     * sayHelloTo('fred');
                     * // => 'hello fred'
                     */
                    var partialRight = baseRest(function (func, partials) {
                      var holders = replaceHolders(partials, getHolder(partialRight));
                      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
                    });

                    /**
                     * Creates a function that invokes `func` with arguments arranged according
                     * to the specified `indexes` where the argument value at the first index is
                     * provided as the first argument, the argument value at the second index is
                     * provided as the second argument, and so on.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Function
                     * @param {Function} func The function to rearrange arguments for.
                     * @param {...(number|number[])} indexes The arranged argument indexes.
                     * @returns {Function} Returns the new function.
                     * @example
                     *
                     * var rearged = _.rearg(function(a, b, c) {
                     *   return [a, b, c];
                     * }, [2, 0, 1]);
                     *
                     * rearged('b', 'c', 'a')
                     * // => ['a', 'b', 'c']
                     */
                    var rearg = flatRest(function (func, indexes) {
                      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
                    });

                    /**
                     * Creates a function that invokes `func` with the `this` binding of the
                     * created function and arguments from `start` and beyond provided as
                     * an array.
                     *
                     * **Note:** This method is based on the
                     * [rest parameter](https://mdn.io/rest_parameters).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Function
                     * @param {Function} func The function to apply a rest parameter to.
                     * @param {number} [start=func.length-1] The start position of the rest parameter.
                     * @returns {Function} Returns the new function.
                     * @example
                     *
                     * var say = _.rest(function(what, names) {
                     *   return what + ' ' + _.initial(names).join(', ') +
                     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
                     * });
                     *
                     * say('hello', 'fred', 'barney', 'pebbles');
                     * // => 'hello fred, barney, & pebbles'
                     */
                    function rest(func, start) {
                      if (typeof func != 'function') {
                        throw new TypeError(FUNC_ERROR_TEXT);
                      }
                      start = start === undefined ? start : toInteger(start);
                      return baseRest(func, start);
                    }

                    /**
                     * Creates a function that invokes `func` with the `this` binding of the
                     * create function and an array of arguments much like
                     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
                     *
                     * **Note:** This method is based on the
                     * [spread operator](https://mdn.io/spread_operator).
                     *
                     * @static
                     * @memberOf _
                     * @since 3.2.0
                     * @category Function
                     * @param {Function} func The function to spread arguments over.
                     * @param {number} [start=0] The start position of the spread.
                     * @returns {Function} Returns the new function.
                     * @example
                     *
                     * var say = _.spread(function(who, what) {
                     *   return who + ' says ' + what;
                     * });
                     *
                     * say(['fred', 'hello']);
                     * // => 'fred says hello'
                     *
                     * var numbers = Promise.all([
                     *   Promise.resolve(40),
                     *   Promise.resolve(36)
                     * ]);
                     *
                     * numbers.then(_.spread(function(x, y) {
                     *   return x + y;
                     * }));
                     * // => a Promise of 76
                     */
                    function spread(func, start) {
                      if (typeof func != 'function') {
                        throw new TypeError(FUNC_ERROR_TEXT);
                      }
                      start = start == null ? 0 : nativeMax(toInteger(start), 0);
                      return baseRest(function (args) {
                        var array = args[start],
                          otherArgs = castSlice(args, 0, start);

                        if (array) {
                          arrayPush(otherArgs, array);
                        }
                        return apply(func, this, otherArgs);
                      });
                    }

                    /**
                     * Creates a throttled function that only invokes `func` at most once per
                     * every `wait` milliseconds. The throttled function comes with a `cancel`
                     * method to cancel delayed `func` invocations and a `flush` method to
                     * immediately invoke them. Provide `options` to indicate whether `func`
                     * should be invoked on the leading and/or trailing edge of the `wait`
                     * timeout. The `func` is invoked with the last arguments provided to the
                     * throttled function. Subsequent calls to the throttled function return the
                     * result of the last `func` invocation.
                     *
                     * **Note:** If `leading` and `trailing` options are `true`, `func` is
                     * invoked on the trailing edge of the timeout only if the throttled function
                     * is invoked more than once during the `wait` timeout.
                     *
                     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
                     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
                     *
                     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
                     * for details over the differences between `_.throttle` and `_.debounce`.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Function
                     * @param {Function} func The function to throttle.
                     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
                     * @param {Object} [options={}] The options object.
                     * @param {boolean} [options.leading=true]
                     *  Specify invoking on the leading edge of the timeout.
                     * @param {boolean} [options.trailing=true]
                     *  Specify invoking on the trailing edge of the timeout.
                     * @returns {Function} Returns the new throttled function.
                     * @example
                     *
                     * // Avoid excessively updating the position while scrolling.
                     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
                     *
                     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
                     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
                     * jQuery(element).on('click', throttled);
                     *
                     * // Cancel the trailing throttled invocation.
                     * jQuery(window).on('popstate', throttled.cancel);
                     */
                    function throttle(func, wait, options) {
                      var leading = true,
                        trailing = true;

                      if (typeof func != 'function') {
                        throw new TypeError(FUNC_ERROR_TEXT);
                      }
                      if (isObject(options)) {
                        leading = 'leading' in options ? !!options.leading : leading;
                        trailing = 'trailing' in options ? !!options.trailing : trailing;
                      }
                      return debounce(func, wait, {
                        leading: leading,
                        maxWait: wait,
                        trailing: trailing
                      });
                    }

                    /**
                     * Creates a function that accepts up to one argument, ignoring any
                     * additional arguments.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Function
                     * @param {Function} func The function to cap arguments for.
                     * @returns {Function} Returns the new capped function.
                     * @example
                     *
                     * _.map(['6', '8', '10'], _.unary(parseInt));
                     * // => [6, 8, 10]
                     */
                    function unary(func) {
                      return ary(func, 1);
                    }

                    /**
                     * Creates a function that provides `value` to `wrapper` as its first
                     * argument. Any additional arguments provided to the function are appended
                     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
                     * binding of the created function.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Function
                     * @param {*} value The value to wrap.
                     * @param {Function} [wrapper=identity] The wrapper function.
                     * @returns {Function} Returns the new function.
                     * @example
                     *
                     * var p = _.wrap(_.escape, function(func, text) {
                     *   return '<p>' + func(text) + '</p>';
                     * });
                     *
                     * p('fred, barney, & pebbles');
                     * // => '<p>fred, barney, &amp; pebbles</p>'
                     */
                    function wrap(value, wrapper) {
                      return partial(castFunction(wrapper), value);
                    }

                    /*------------------------------------------------------------------------*/

                    /**
                     * Casts `value` as an array if it's not one.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.4.0
                     * @category Lang
                     * @param {*} value The value to inspect.
                     * @returns {Array} Returns the cast array.
                     * @example
                     *
                     * _.castArray(1);
                     * // => [1]
                     *
                     * _.castArray({ 'a': 1 });
                     * // => [{ 'a': 1 }]
                     *
                     * _.castArray('abc');
                     * // => ['abc']
                     *
                     * _.castArray(null);
                     * // => [null]
                     *
                     * _.castArray(undefined);
                     * // => [undefined]
                     *
                     * _.castArray();
                     * // => []
                     *
                     * var array = [1, 2, 3];
                     * console.log(_.castArray(array) === array);
                     * // => true
                     */
                    function castArray() {
                      if (!arguments.length) {
                        return [];
                      }
                      var value = arguments[0];
                      return isArray(value) ? value : [value];
                    }

                    /**
                     * Creates a shallow clone of `value`.
                     *
                     * **Note:** This method is loosely based on the
                     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
                     * and supports cloning arrays, array buffers, booleans, date objects, maps,
                     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
                     * arrays. The own enumerable properties of `arguments` objects are cloned
                     * as plain objects. An empty object is returned for uncloneable values such
                     * as error objects, functions, DOM nodes, and WeakMaps.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Lang
                     * @param {*} value The value to clone.
                     * @returns {*} Returns the cloned value.
                     * @see _.cloneDeep
                     * @example
                     *
                     * var objects = [{ 'a': 1 }, { 'b': 2 }];
                     *
                     * var shallow = _.clone(objects);
                     * console.log(shallow[0] === objects[0]);
                     * // => true
                     */
                    function clone(value) {
                      return baseClone(value, CLONE_SYMBOLS_FLAG);
                    }

                    /**
                     * This method is like `_.clone` except that it accepts `customizer` which
                     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
                     * cloning is handled by the method instead. The `customizer` is invoked with
                     * up to four arguments; (value [, index|key, object, stack]).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Lang
                     * @param {*} value The value to clone.
                     * @param {Function} [customizer] The function to customize cloning.
                     * @returns {*} Returns the cloned value.
                     * @see _.cloneDeepWith
                     * @example
                     *
                     * function customizer(value) {
                     *   if (_.isElement(value)) {
                     *     return value.cloneNode(false);
                     *   }
                     * }
                     *
                     * var el = _.cloneWith(document.body, customizer);
                     *
                     * console.log(el === document.body);
                     * // => false
                     * console.log(el.nodeName);
                     * // => 'BODY'
                     * console.log(el.childNodes.length);
                     * // => 0
                     */
                    function cloneWith(value, customizer) {
                      customizer = typeof customizer == 'function' ? customizer : undefined;
                      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
                    }

                    /**
                     * This method is like `_.clone` except that it recursively clones `value`.
                     *
                     * @static
                     * @memberOf _
                     * @since 1.0.0
                     * @category Lang
                     * @param {*} value The value to recursively clone.
                     * @returns {*} Returns the deep cloned value.
                     * @see _.clone
                     * @example
                     *
                     * var objects = [{ 'a': 1 }, { 'b': 2 }];
                     *
                     * var deep = _.cloneDeep(objects);
                     * console.log(deep[0] === objects[0]);
                     * // => false
                     */
                    function cloneDeep(value) {
                      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
                    }

                    /**
                     * This method is like `_.cloneWith` except that it recursively clones `value`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Lang
                     * @param {*} value The value to recursively clone.
                     * @param {Function} [customizer] The function to customize cloning.
                     * @returns {*} Returns the deep cloned value.
                     * @see _.cloneWith
                     * @example
                     *
                     * function customizer(value) {
                     *   if (_.isElement(value)) {
                     *     return value.cloneNode(true);
                     *   }
                     * }
                     *
                     * var el = _.cloneDeepWith(document.body, customizer);
                     *
                     * console.log(el === document.body);
                     * // => false
                     * console.log(el.nodeName);
                     * // => 'BODY'
                     * console.log(el.childNodes.length);
                     * // => 20
                     */
                    function cloneDeepWith(value, customizer) {
                      customizer = typeof customizer == 'function' ? customizer : undefined;
                      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
                    }

                    /**
                     * Checks if `object` conforms to `source` by invoking the predicate
                     * properties of `source` with the corresponding property values of `object`.
                     *
                     * **Note:** This method is equivalent to `_.conforms` when `source` is
                     * partially applied.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.14.0
                     * @category Lang
                     * @param {Object} object The object to inspect.
                     * @param {Object} source The object of property predicates to conform to.
                     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
                     * @example
                     *
                     * var object = { 'a': 1, 'b': 2 };
                     *
                     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
                     * // => true
                     *
                     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
                     * // => false
                     */
                    function conformsTo(object, source) {
                      return source == null || baseConformsTo(object, source, keys(source));
                    }

                    /**
                     * Performs a
                     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                     * comparison between two values to determine if they are equivalent.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Lang
                     * @param {*} value The value to compare.
                     * @param {*} other The other value to compare.
                     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
                     * @example
                     *
                     * var object = { 'a': 1 };
                     * var other = { 'a': 1 };
                     *
                     * _.eq(object, object);
                     * // => true
                     *
                     * _.eq(object, other);
                     * // => false
                     *
                     * _.eq('a', 'a');
                     * // => true
                     *
                     * _.eq('a', Object('a'));
                     * // => false
                     *
                     * _.eq(NaN, NaN);
                     * // => true
                     */
                    function eq(value, other) {
                      return value === other || (value !== value && other !== other);
                    }

                    /**
                     * Checks if `value` is greater than `other`.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.9.0
                     * @category Lang
                     * @param {*} value The value to compare.
                     * @param {*} other The other value to compare.
                     * @returns {boolean} Returns `true` if `value` is greater than `other`,
                     *  else `false`.
                     * @see _.lt
                     * @example
                     *
                     * _.gt(3, 1);
                     * // => true
                     *
                     * _.gt(3, 3);
                     * // => false
                     *
                     * _.gt(1, 3);
                     * // => false
                     */
                    var gt = createRelationalOperation(baseGt);

                    /**
                     * Checks if `value` is greater than or equal to `other`.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.9.0
                     * @category Lang
                     * @param {*} value The value to compare.
                     * @param {*} other The other value to compare.
                     * @returns {boolean} Returns `true` if `value` is greater than or equal to
                     *  `other`, else `false`.
                     * @see _.lte
                     * @example
                     *
                     * _.gte(3, 1);
                     * // => true
                     *
                     * _.gte(3, 3);
                     * // => true
                     *
                     * _.gte(1, 3);
                     * // => false
                     */
                    var gte = createRelationalOperation(function (value, other) {
                      return value >= other;
                    });

                    /**
                     * Checks if `value` is likely an `arguments` object.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
                     *  else `false`.
                     * @example
                     *
                     * _.isArguments(function() { return arguments; }());
                     * // => true
                     *
                     * _.isArguments([1, 2, 3]);
                     * // => false
                     */
                    var isArguments = baseIsArguments(
                      (function () {
                        return arguments;
                      })()
                    )
                      ? baseIsArguments
                      : function (value) {
                          return (
                            isObjectLike(value) &&
                            hasOwnProperty.call(value, 'callee') &&
                            !propertyIsEnumerable.call(value, 'callee')
                          );
                        };

                    /**
                     * Checks if `value` is classified as an `Array` object.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
                     * @example
                     *
                     * _.isArray([1, 2, 3]);
                     * // => true
                     *
                     * _.isArray(document.body.children);
                     * // => false
                     *
                     * _.isArray('abc');
                     * // => false
                     *
                     * _.isArray(_.noop);
                     * // => false
                     */
                    var isArray = Array.isArray;

                    /**
                     * Checks if `value` is classified as an `ArrayBuffer` object.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.3.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
                     * @example
                     *
                     * _.isArrayBuffer(new ArrayBuffer(2));
                     * // => true
                     *
                     * _.isArrayBuffer(new Array(2));
                     * // => false
                     */
                    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

                    /**
                     * Checks if `value` is array-like. A value is considered array-like if it's
                     * not a function and has a `value.length` that's an integer greater than or
                     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
                     * @example
                     *
                     * _.isArrayLike([1, 2, 3]);
                     * // => true
                     *
                     * _.isArrayLike(document.body.children);
                     * // => true
                     *
                     * _.isArrayLike('abc');
                     * // => true
                     *
                     * _.isArrayLike(_.noop);
                     * // => false
                     */
                    function isArrayLike(value) {
                      return value != null && isLength(value.length) && !isFunction(value);
                    }

                    /**
                     * This method is like `_.isArrayLike` except that it also checks if `value`
                     * is an object.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is an array-like object,
                     *  else `false`.
                     * @example
                     *
                     * _.isArrayLikeObject([1, 2, 3]);
                     * // => true
                     *
                     * _.isArrayLikeObject(document.body.children);
                     * // => true
                     *
                     * _.isArrayLikeObject('abc');
                     * // => false
                     *
                     * _.isArrayLikeObject(_.noop);
                     * // => false
                     */
                    function isArrayLikeObject(value) {
                      return isObjectLike(value) && isArrayLike(value);
                    }

                    /**
                     * Checks if `value` is classified as a boolean primitive or object.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
                     * @example
                     *
                     * _.isBoolean(false);
                     * // => true
                     *
                     * _.isBoolean(null);
                     * // => false
                     */
                    function isBoolean(value) {
                      return value === true || value === false || (isObjectLike(value) && baseGetTag(value) == boolTag);
                    }

                    /**
                     * Checks if `value` is a buffer.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.3.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
                     * @example
                     *
                     * _.isBuffer(new Buffer(2));
                     * // => true
                     *
                     * _.isBuffer(new Uint8Array(2));
                     * // => false
                     */
                    var isBuffer = nativeIsBuffer || stubFalse;

                    /**
                     * Checks if `value` is classified as a `Date` object.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
                     * @example
                     *
                     * _.isDate(new Date);
                     * // => true
                     *
                     * _.isDate('Mon April 23 2012');
                     * // => false
                     */
                    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

                    /**
                     * Checks if `value` is likely a DOM element.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
                     * @example
                     *
                     * _.isElement(document.body);
                     * // => true
                     *
                     * _.isElement('<body>');
                     * // => false
                     */
                    function isElement(value) {
                      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
                    }

                    /**
                     * Checks if `value` is an empty object, collection, map, or set.
                     *
                     * Objects are considered empty if they have no own enumerable string keyed
                     * properties.
                     *
                     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
                     * jQuery-like collections are considered empty if they have a `length` of `0`.
                     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
                     * @example
                     *
                     * _.isEmpty(null);
                     * // => true
                     *
                     * _.isEmpty(true);
                     * // => true
                     *
                     * _.isEmpty(1);
                     * // => true
                     *
                     * _.isEmpty([1, 2, 3]);
                     * // => false
                     *
                     * _.isEmpty({ 'a': 1 });
                     * // => false
                     */
                    function isEmpty(value) {
                      if (value == null) {
                        return true;
                      }
                      if (
                        isArrayLike(value) &&
                        (isArray(value) ||
                          typeof value == 'string' ||
                          typeof value.splice == 'function' ||
                          isBuffer(value) ||
                          isTypedArray(value) ||
                          isArguments(value))
                      ) {
                        return !value.length;
                      }
                      var tag = getTag(value);
                      if (tag == mapTag || tag == setTag) {
                        return !value.size;
                      }
                      if (isPrototype(value)) {
                        return !baseKeys(value).length;
                      }
                      for (var key in value) {
                        if (hasOwnProperty.call(value, key)) {
                          return false;
                        }
                      }
                      return true;
                    }

                    /**
                     * Performs a deep comparison between two values to determine if they are
                     * equivalent.
                     *
                     * **Note:** This method supports comparing arrays, array buffers, booleans,
                     * date objects, error objects, maps, numbers, `Object` objects, regexes,
                     * sets, strings, symbols, and typed arrays. `Object` objects are compared
                     * by their own, not inherited, enumerable properties. Functions and DOM
                     * nodes are compared by strict equality, i.e. `===`.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Lang
                     * @param {*} value The value to compare.
                     * @param {*} other The other value to compare.
                     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
                     * @example
                     *
                     * var object = { 'a': 1 };
                     * var other = { 'a': 1 };
                     *
                     * _.isEqual(object, other);
                     * // => true
                     *
                     * object === other;
                     * // => false
                     */
                    function isEqual(value, other) {
                      return baseIsEqual(value, other);
                    }

                    /**
                     * This method is like `_.isEqual` except that it accepts `customizer` which
                     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
                     * are handled by the method instead. The `customizer` is invoked with up to
                     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Lang
                     * @param {*} value The value to compare.
                     * @param {*} other The other value to compare.
                     * @param {Function} [customizer] The function to customize comparisons.
                     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
                     * @example
                     *
                     * function isGreeting(value) {
                     *   return /^h(?:i|ello)$/.test(value);
                     * }
                     *
                     * function customizer(objValue, othValue) {
                     *   if (isGreeting(objValue) && isGreeting(othValue)) {
                     *     return true;
                     *   }
                     * }
                     *
                     * var array = ['hello', 'goodbye'];
                     * var other = ['hi', 'goodbye'];
                     *
                     * _.isEqualWith(array, other, customizer);
                     * // => true
                     */
                    function isEqualWith(value, other, customizer) {
                      customizer = typeof customizer == 'function' ? customizer : undefined;
                      var result = customizer ? customizer(value, other) : undefined;
                      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
                    }

                    /**
                     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
                     * `SyntaxError`, `TypeError`, or `URIError` object.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
                     * @example
                     *
                     * _.isError(new Error);
                     * // => true
                     *
                     * _.isError(Error);
                     * // => false
                     */
                    function isError(value) {
                      if (!isObjectLike(value)) {
                        return false;
                      }
                      var tag = baseGetTag(value);
                      return (
                        tag == errorTag ||
                        tag == domExcTag ||
                        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value))
                      );
                    }

                    /**
                     * Checks if `value` is a finite primitive number.
                     *
                     * **Note:** This method is based on
                     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
                     * @example
                     *
                     * _.isFinite(3);
                     * // => true
                     *
                     * _.isFinite(Number.MIN_VALUE);
                     * // => true
                     *
                     * _.isFinite(Infinity);
                     * // => false
                     *
                     * _.isFinite('3');
                     * // => false
                     */
                    function isFinite(value) {
                      return typeof value == 'number' && nativeIsFinite(value);
                    }

                    /**
                     * Checks if `value` is classified as a `Function` object.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
                     * @example
                     *
                     * _.isFunction(_);
                     * // => true
                     *
                     * _.isFunction(/abc/);
                     * // => false
                     */
                    function isFunction(value) {
                      if (!isObject(value)) {
                        return false;
                      }
                      // The use of `Object#toString` avoids issues with the `typeof` operator
                      // in Safari 9 which returns 'object' for typed arrays and other constructors.
                      var tag = baseGetTag(value);
                      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
                    }

                    /**
                     * Checks if `value` is an integer.
                     *
                     * **Note:** This method is based on
                     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
                     * @example
                     *
                     * _.isInteger(3);
                     * // => true
                     *
                     * _.isInteger(Number.MIN_VALUE);
                     * // => false
                     *
                     * _.isInteger(Infinity);
                     * // => false
                     *
                     * _.isInteger('3');
                     * // => false
                     */
                    function isInteger(value) {
                      return typeof value == 'number' && value == toInteger(value);
                    }

                    /**
                     * Checks if `value` is a valid array-like length.
                     *
                     * **Note:** This method is loosely based on
                     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
                     * @example
                     *
                     * _.isLength(3);
                     * // => true
                     *
                     * _.isLength(Number.MIN_VALUE);
                     * // => false
                     *
                     * _.isLength(Infinity);
                     * // => false
                     *
                     * _.isLength('3');
                     * // => false
                     */
                    function isLength(value) {
                      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
                    }

                    /**
                     * Checks if `value` is the
                     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
                     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
                     * @example
                     *
                     * _.isObject({});
                     * // => true
                     *
                     * _.isObject([1, 2, 3]);
                     * // => true
                     *
                     * _.isObject(_.noop);
                     * // => true
                     *
                     * _.isObject(null);
                     * // => false
                     */
                    function isObject(value) {
                      var type = typeof value;
                      return value != null && (type == 'object' || type == 'function');
                    }

                    /**
                     * Checks if `value` is object-like. A value is object-like if it's not `null`
                     * and has a `typeof` result of "object".
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
                     * @example
                     *
                     * _.isObjectLike({});
                     * // => true
                     *
                     * _.isObjectLike([1, 2, 3]);
                     * // => true
                     *
                     * _.isObjectLike(_.noop);
                     * // => false
                     *
                     * _.isObjectLike(null);
                     * // => false
                     */
                    function isObjectLike(value) {
                      return value != null && typeof value == 'object';
                    }

                    /**
                     * Checks if `value` is classified as a `Map` object.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.3.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
                     * @example
                     *
                     * _.isMap(new Map);
                     * // => true
                     *
                     * _.isMap(new WeakMap);
                     * // => false
                     */
                    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

                    /**
                     * Performs a partial deep comparison between `object` and `source` to
                     * determine if `object` contains equivalent property values.
                     *
                     * **Note:** This method is equivalent to `_.matches` when `source` is
                     * partially applied.
                     *
                     * Partial comparisons will match empty array and empty object `source`
                     * values against any array or object value, respectively. See `_.isEqual`
                     * for a list of supported value comparisons.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Lang
                     * @param {Object} object The object to inspect.
                     * @param {Object} source The object of property values to match.
                     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
                     * @example
                     *
                     * var object = { 'a': 1, 'b': 2 };
                     *
                     * _.isMatch(object, { 'b': 2 });
                     * // => true
                     *
                     * _.isMatch(object, { 'b': 1 });
                     * // => false
                     */
                    function isMatch(object, source) {
                      return object === source || baseIsMatch(object, source, getMatchData(source));
                    }

                    /**
                     * This method is like `_.isMatch` except that it accepts `customizer` which
                     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
                     * are handled by the method instead. The `customizer` is invoked with five
                     * arguments: (objValue, srcValue, index|key, object, source).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Lang
                     * @param {Object} object The object to inspect.
                     * @param {Object} source The object of property values to match.
                     * @param {Function} [customizer] The function to customize comparisons.
                     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
                     * @example
                     *
                     * function isGreeting(value) {
                     *   return /^h(?:i|ello)$/.test(value);
                     * }
                     *
                     * function customizer(objValue, srcValue) {
                     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
                     *     return true;
                     *   }
                     * }
                     *
                     * var object = { 'greeting': 'hello' };
                     * var source = { 'greeting': 'hi' };
                     *
                     * _.isMatchWith(object, source, customizer);
                     * // => true
                     */
                    function isMatchWith(object, source, customizer) {
                      customizer = typeof customizer == 'function' ? customizer : undefined;
                      return baseIsMatch(object, source, getMatchData(source), customizer);
                    }

                    /**
                     * Checks if `value` is `NaN`.
                     *
                     * **Note:** This method is based on
                     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
                     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
                     * `undefined` and other non-number values.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
                     * @example
                     *
                     * _.isNaN(NaN);
                     * // => true
                     *
                     * _.isNaN(new Number(NaN));
                     * // => true
                     *
                     * isNaN(undefined);
                     * // => true
                     *
                     * _.isNaN(undefined);
                     * // => false
                     */
                    function isNaN(value) {
                      // An `NaN` primitive is the only value that is not equal to itself.
                      // Perform the `toStringTag` check first to avoid errors with some
                      // ActiveX objects in IE.
                      return isNumber(value) && value != +value;
                    }

                    /**
                     * Checks if `value` is a pristine native function.
                     *
                     * **Note:** This method can't reliably detect native functions in the presence
                     * of the core-js package because core-js circumvents this kind of detection.
                     * Despite multiple requests, the core-js maintainer has made it clear: any
                     * attempt to fix the detection will be obstructed. As a result, we're left
                     * with little choice but to throw an error. Unfortunately, this also affects
                     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
                     * which rely on core-js.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a native function,
                     *  else `false`.
                     * @example
                     *
                     * _.isNative(Array.prototype.push);
                     * // => true
                     *
                     * _.isNative(_);
                     * // => false
                     */
                    function isNative(value) {
                      if (isMaskable(value)) {
                        throw new Error(CORE_ERROR_TEXT);
                      }
                      return baseIsNative(value);
                    }

                    /**
                     * Checks if `value` is `null`.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
                     * @example
                     *
                     * _.isNull(null);
                     * // => true
                     *
                     * _.isNull(void 0);
                     * // => false
                     */
                    function isNull(value) {
                      return value === null;
                    }

                    /**
                     * Checks if `value` is `null` or `undefined`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
                     * @example
                     *
                     * _.isNil(null);
                     * // => true
                     *
                     * _.isNil(void 0);
                     * // => true
                     *
                     * _.isNil(NaN);
                     * // => false
                     */
                    function isNil(value) {
                      return value == null;
                    }

                    /**
                     * Checks if `value` is classified as a `Number` primitive or object.
                     *
                     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
                     * classified as numbers, use the `_.isFinite` method.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
                     * @example
                     *
                     * _.isNumber(3);
                     * // => true
                     *
                     * _.isNumber(Number.MIN_VALUE);
                     * // => true
                     *
                     * _.isNumber(Infinity);
                     * // => true
                     *
                     * _.isNumber('3');
                     * // => false
                     */
                    function isNumber(value) {
                      return typeof value == 'number' || (isObjectLike(value) && baseGetTag(value) == numberTag);
                    }

                    /**
                     * Checks if `value` is a plain object, that is, an object created by the
                     * `Object` constructor or one with a `[[Prototype]]` of `null`.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.8.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
                     * @example
                     *
                     * function Foo() {
                     *   this.a = 1;
                     * }
                     *
                     * _.isPlainObject(new Foo);
                     * // => false
                     *
                     * _.isPlainObject([1, 2, 3]);
                     * // => false
                     *
                     * _.isPlainObject({ 'x': 0, 'y': 0 });
                     * // => true
                     *
                     * _.isPlainObject(Object.create(null));
                     * // => true
                     */
                    function isPlainObject(value) {
                      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
                        return false;
                      }
                      var proto = getPrototype(value);
                      if (proto === null) {
                        return true;
                      }
                      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
                      return (
                        typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString
                      );
                    }

                    /**
                     * Checks if `value` is classified as a `RegExp` object.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.1.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
                     * @example
                     *
                     * _.isRegExp(/abc/);
                     * // => true
                     *
                     * _.isRegExp('/abc/');
                     * // => false
                     */
                    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

                    /**
                     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
                     * double precision number which isn't the result of a rounded unsafe integer.
                     *
                     * **Note:** This method is based on
                     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
                     * @example
                     *
                     * _.isSafeInteger(3);
                     * // => true
                     *
                     * _.isSafeInteger(Number.MIN_VALUE);
                     * // => false
                     *
                     * _.isSafeInteger(Infinity);
                     * // => false
                     *
                     * _.isSafeInteger('3');
                     * // => false
                     */
                    function isSafeInteger(value) {
                      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
                    }

                    /**
                     * Checks if `value` is classified as a `Set` object.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.3.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
                     * @example
                     *
                     * _.isSet(new Set);
                     * // => true
                     *
                     * _.isSet(new WeakSet);
                     * // => false
                     */
                    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

                    /**
                     * Checks if `value` is classified as a `String` primitive or object.
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
                     * @example
                     *
                     * _.isString('abc');
                     * // => true
                     *
                     * _.isString(1);
                     * // => false
                     */
                    function isString(value) {
                      return (
                        typeof value == 'string' ||
                        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag)
                      );
                    }

                    /**
                     * Checks if `value` is classified as a `Symbol` primitive or object.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
                     * @example
                     *
                     * _.isSymbol(Symbol.iterator);
                     * // => true
                     *
                     * _.isSymbol('abc');
                     * // => false
                     */
                    function isSymbol(value) {
                      return typeof value == 'symbol' || (isObjectLike(value) && baseGetTag(value) == symbolTag);
                    }

                    /**
                     * Checks if `value` is classified as a typed array.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
                     * @example
                     *
                     * _.isTypedArray(new Uint8Array);
                     * // => true
                     *
                     * _.isTypedArray([]);
                     * // => false
                     */
                    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

                    /**
                     * Checks if `value` is `undefined`.
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
                     * @example
                     *
                     * _.isUndefined(void 0);
                     * // => true
                     *
                     * _.isUndefined(null);
                     * // => false
                     */
                    function isUndefined(value) {
                      return value === undefined;
                    }

                    /**
                     * Checks if `value` is classified as a `WeakMap` object.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.3.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
                     * @example
                     *
                     * _.isWeakMap(new WeakMap);
                     * // => true
                     *
                     * _.isWeakMap(new Map);
                     * // => false
                     */
                    function isWeakMap(value) {
                      return isObjectLike(value) && getTag(value) == weakMapTag;
                    }

                    /**
                     * Checks if `value` is classified as a `WeakSet` object.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.3.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
                     * @example
                     *
                     * _.isWeakSet(new WeakSet);
                     * // => true
                     *
                     * _.isWeakSet(new Set);
                     * // => false
                     */
                    function isWeakSet(value) {
                      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
                    }

                    /**
                     * Checks if `value` is less than `other`.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.9.0
                     * @category Lang
                     * @param {*} value The value to compare.
                     * @param {*} other The other value to compare.
                     * @returns {boolean} Returns `true` if `value` is less than `other`,
                     *  else `false`.
                     * @see _.gt
                     * @example
                     *
                     * _.lt(1, 3);
                     * // => true
                     *
                     * _.lt(3, 3);
                     * // => false
                     *
                     * _.lt(3, 1);
                     * // => false
                     */
                    var lt = createRelationalOperation(baseLt);

                    /**
                     * Checks if `value` is less than or equal to `other`.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.9.0
                     * @category Lang
                     * @param {*} value The value to compare.
                     * @param {*} other The other value to compare.
                     * @returns {boolean} Returns `true` if `value` is less than or equal to
                     *  `other`, else `false`.
                     * @see _.gte
                     * @example
                     *
                     * _.lte(1, 3);
                     * // => true
                     *
                     * _.lte(3, 3);
                     * // => true
                     *
                     * _.lte(3, 1);
                     * // => false
                     */
                    var lte = createRelationalOperation(function (value, other) {
                      return value <= other;
                    });

                    /**
                     * Converts `value` to an array.
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category Lang
                     * @param {*} value The value to convert.
                     * @returns {Array} Returns the converted array.
                     * @example
                     *
                     * _.toArray({ 'a': 1, 'b': 2 });
                     * // => [1, 2]
                     *
                     * _.toArray('abc');
                     * // => ['a', 'b', 'c']
                     *
                     * _.toArray(1);
                     * // => []
                     *
                     * _.toArray(null);
                     * // => []
                     */
                    function toArray(value) {
                      if (!value) {
                        return [];
                      }
                      if (isArrayLike(value)) {
                        return isString(value) ? stringToArray(value) : copyArray(value);
                      }
                      if (symIterator && value[symIterator]) {
                        return iteratorToArray(value[symIterator]());
                      }
                      var tag = getTag(value),
                        func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;

                      return func(value);
                    }

                    /**
                     * Converts `value` to a finite number.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.12.0
                     * @category Lang
                     * @param {*} value The value to convert.
                     * @returns {number} Returns the converted number.
                     * @example
                     *
                     * _.toFinite(3.2);
                     * // => 3.2
                     *
                     * _.toFinite(Number.MIN_VALUE);
                     * // => 5e-324
                     *
                     * _.toFinite(Infinity);
                     * // => 1.7976931348623157e+308
                     *
                     * _.toFinite('3.2');
                     * // => 3.2
                     */
                    function toFinite(value) {
                      if (!value) {
                        return value === 0 ? value : 0;
                      }
                      value = toNumber(value);
                      if (value === INFINITY || value === -INFINITY) {
                        var sign = value < 0 ? -1 : 1;
                        return sign * MAX_INTEGER;
                      }
                      return value === value ? value : 0;
                    }

                    /**
                     * Converts `value` to an integer.
                     *
                     * **Note:** This method is loosely based on
                     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Lang
                     * @param {*} value The value to convert.
                     * @returns {number} Returns the converted integer.
                     * @example
                     *
                     * _.toInteger(3.2);
                     * // => 3
                     *
                     * _.toInteger(Number.MIN_VALUE);
                     * // => 0
                     *
                     * _.toInteger(Infinity);
                     * // => 1.7976931348623157e+308
                     *
                     * _.toInteger('3.2');
                     * // => 3
                     */
                    function toInteger(value) {
                      var result = toFinite(value),
                        remainder = result % 1;

                      return result === result ? (remainder ? result - remainder : result) : 0;
                    }

                    /**
                     * Converts `value` to an integer suitable for use as the length of an
                     * array-like object.
                     *
                     * **Note:** This method is based on
                     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Lang
                     * @param {*} value The value to convert.
                     * @returns {number} Returns the converted integer.
                     * @example
                     *
                     * _.toLength(3.2);
                     * // => 3
                     *
                     * _.toLength(Number.MIN_VALUE);
                     * // => 0
                     *
                     * _.toLength(Infinity);
                     * // => 4294967295
                     *
                     * _.toLength('3.2');
                     * // => 3
                     */
                    function toLength(value) {
                      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
                    }

                    /**
                     * Converts `value` to a number.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Lang
                     * @param {*} value The value to process.
                     * @returns {number} Returns the number.
                     * @example
                     *
                     * _.toNumber(3.2);
                     * // => 3.2
                     *
                     * _.toNumber(Number.MIN_VALUE);
                     * // => 5e-324
                     *
                     * _.toNumber(Infinity);
                     * // => Infinity
                     *
                     * _.toNumber('3.2');
                     * // => 3.2
                     */
                    function toNumber(value) {
                      if (typeof value == 'number') {
                        return value;
                      }
                      if (isSymbol(value)) {
                        return NAN;
                      }
                      if (isObject(value)) {
                        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                        value = isObject(other) ? other + '' : other;
                      }
                      if (typeof value != 'string') {
                        return value === 0 ? value : +value;
                      }
                      value = value.replace(reTrim, '');
                      var isBinary = reIsBinary.test(value);
                      return isBinary || reIsOctal.test(value)
                        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
                        : reIsBadHex.test(value)
                          ? NAN
                          : +value;
                    }

                    /**
                     * Converts `value` to a plain object flattening inherited enumerable string
                     * keyed properties of `value` to own properties of the plain object.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Lang
                     * @param {*} value The value to convert.
                     * @returns {Object} Returns the converted plain object.
                     * @example
                     *
                     * function Foo() {
                     *   this.b = 2;
                     * }
                     *
                     * Foo.prototype.c = 3;
                     *
                     * _.assign({ 'a': 1 }, new Foo);
                     * // => { 'a': 1, 'b': 2 }
                     *
                     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
                     * // => { 'a': 1, 'b': 2, 'c': 3 }
                     */
                    function toPlainObject(value) {
                      return copyObject(value, keysIn(value));
                    }

                    /**
                     * Converts `value` to a safe integer. A safe integer can be compared and
                     * represented correctly.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Lang
                     * @param {*} value The value to convert.
                     * @returns {number} Returns the converted integer.
                     * @example
                     *
                     * _.toSafeInteger(3.2);
                     * // => 3
                     *
                     * _.toSafeInteger(Number.MIN_VALUE);
                     * // => 0
                     *
                     * _.toSafeInteger(Infinity);
                     * // => 9007199254740991
                     *
                     * _.toSafeInteger('3.2');
                     * // => 3
                     */
                    function toSafeInteger(value) {
                      return value
                        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
                        : value === 0
                          ? value
                          : 0;
                    }

                    /**
                     * Converts `value` to a string. An empty string is returned for `null`
                     * and `undefined` values. The sign of `-0` is preserved.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Lang
                     * @param {*} value The value to convert.
                     * @returns {string} Returns the converted string.
                     * @example
                     *
                     * _.toString(null);
                     * // => ''
                     *
                     * _.toString(-0);
                     * // => '-0'
                     *
                     * _.toString([1, 2, 3]);
                     * // => '1,2,3'
                     */
                    function toString(value) {
                      return value == null ? '' : baseToString(value);
                    }

                    /*------------------------------------------------------------------------*/

                    /**
                     * Assigns own enumerable string keyed properties of source objects to the
                     * destination object. Source objects are applied from left to right.
                     * Subsequent sources overwrite property assignments of previous sources.
                     *
                     * **Note:** This method mutates `object` and is loosely based on
                     * [`Object.assign`](https://mdn.io/Object/assign).
                     *
                     * @static
                     * @memberOf _
                     * @since 0.10.0
                     * @category Object
                     * @param {Object} object The destination object.
                     * @param {...Object} [sources] The source objects.
                     * @returns {Object} Returns `object`.
                     * @see _.assignIn
                     * @example
                     *
                     * function Foo() {
                     *   this.a = 1;
                     * }
                     *
                     * function Bar() {
                     *   this.c = 3;
                     * }
                     *
                     * Foo.prototype.b = 2;
                     * Bar.prototype.d = 4;
                     *
                     * _.assign({ 'a': 0 }, new Foo, new Bar);
                     * // => { 'a': 1, 'c': 3 }
                     */
                    var assign = createAssigner(function (object, source) {
                      if (isPrototype(source) || isArrayLike(source)) {
                        copyObject(source, keys(source), object);
                        return;
                      }
                      for (var key in source) {
                        if (hasOwnProperty.call(source, key)) {
                          assignValue(object, key, source[key]);
                        }
                      }
                    });

                    /**
                     * This method is like `_.assign` except that it iterates over own and
                     * inherited source properties.
                     *
                     * **Note:** This method mutates `object`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @alias extend
                     * @category Object
                     * @param {Object} object The destination object.
                     * @param {...Object} [sources] The source objects.
                     * @returns {Object} Returns `object`.
                     * @see _.assign
                     * @example
                     *
                     * function Foo() {
                     *   this.a = 1;
                     * }
                     *
                     * function Bar() {
                     *   this.c = 3;
                     * }
                     *
                     * Foo.prototype.b = 2;
                     * Bar.prototype.d = 4;
                     *
                     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
                     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
                     */
                    var assignIn = createAssigner(function (object, source) {
                      copyObject(source, keysIn(source), object);
                    });

                    /**
                     * This method is like `_.assignIn` except that it accepts `customizer`
                     * which is invoked to produce the assigned values. If `customizer` returns
                     * `undefined`, assignment is handled by the method instead. The `customizer`
                     * is invoked with five arguments: (objValue, srcValue, key, object, source).
                     *
                     * **Note:** This method mutates `object`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @alias extendWith
                     * @category Object
                     * @param {Object} object The destination object.
                     * @param {...Object} sources The source objects.
                     * @param {Function} [customizer] The function to customize assigned values.
                     * @returns {Object} Returns `object`.
                     * @see _.assignWith
                     * @example
                     *
                     * function customizer(objValue, srcValue) {
                     *   return _.isUndefined(objValue) ? srcValue : objValue;
                     * }
                     *
                     * var defaults = _.partialRight(_.assignInWith, customizer);
                     *
                     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
                     * // => { 'a': 1, 'b': 2 }
                     */
                    var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
                      copyObject(source, keysIn(source), object, customizer);
                    });

                    /**
                     * This method is like `_.assign` except that it accepts `customizer`
                     * which is invoked to produce the assigned values. If `customizer` returns
                     * `undefined`, assignment is handled by the method instead. The `customizer`
                     * is invoked with five arguments: (objValue, srcValue, key, object, source).
                     *
                     * **Note:** This method mutates `object`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Object
                     * @param {Object} object The destination object.
                     * @param {...Object} sources The source objects.
                     * @param {Function} [customizer] The function to customize assigned values.
                     * @returns {Object} Returns `object`.
                     * @see _.assignInWith
                     * @example
                     *
                     * function customizer(objValue, srcValue) {
                     *   return _.isUndefined(objValue) ? srcValue : objValue;
                     * }
                     *
                     * var defaults = _.partialRight(_.assignWith, customizer);
                     *
                     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
                     * // => { 'a': 1, 'b': 2 }
                     */
                    var assignWith = createAssigner(function (object, source, srcIndex, customizer) {
                      copyObject(source, keys(source), object, customizer);
                    });

                    /**
                     * Creates an array of values corresponding to `paths` of `object`.
                     *
                     * @static
                     * @memberOf _
                     * @since 1.0.0
                     * @category Object
                     * @param {Object} object The object to iterate over.
                     * @param {...(string|string[])} [paths] The property paths to pick.
                     * @returns {Array} Returns the picked values.
                     * @example
                     *
                     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
                     *
                     * _.at(object, ['a[0].b.c', 'a[1]']);
                     * // => [3, 4]
                     */
                    var at = flatRest(baseAt);

                    /**
                     * Creates an object that inherits from the `prototype` object. If a
                     * `properties` object is given, its own enumerable string keyed properties
                     * are assigned to the created object.
                     *
                     * @static
                     * @memberOf _
                     * @since 2.3.0
                     * @category Object
                     * @param {Object} prototype The object to inherit from.
                     * @param {Object} [properties] The properties to assign to the object.
                     * @returns {Object} Returns the new object.
                     * @example
                     *
                     * function Shape() {
                     *   this.x = 0;
                     *   this.y = 0;
                     * }
                     *
                     * function Circle() {
                     *   Shape.call(this);
                     * }
                     *
                     * Circle.prototype = _.create(Shape.prototype, {
                     *   'constructor': Circle
                     * });
                     *
                     * var circle = new Circle;
                     * circle instanceof Circle;
                     * // => true
                     *
                     * circle instanceof Shape;
                     * // => true
                     */
                    function create(prototype, properties) {
                      var result = baseCreate(prototype);
                      return properties == null ? result : baseAssign(result, properties);
                    }

                    /**
                     * Assigns own and inherited enumerable string keyed properties of source
                     * objects to the destination object for all destination properties that
                     * resolve to `undefined`. Source objects are applied from left to right.
                     * Once a property is set, additional values of the same property are ignored.
                     *
                     * **Note:** This method mutates `object`.
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category Object
                     * @param {Object} object The destination object.
                     * @param {...Object} [sources] The source objects.
                     * @returns {Object} Returns `object`.
                     * @see _.defaultsDeep
                     * @example
                     *
                     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
                     * // => { 'a': 1, 'b': 2 }
                     */
                    var defaults = baseRest(function (args) {
                      args.push(undefined, customDefaultsAssignIn);
                      return apply(assignInWith, undefined, args);
                    });

                    /**
                     * This method is like `_.defaults` except that it recursively assigns
                     * default properties.
                     *
                     * **Note:** This method mutates `object`.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.10.0
                     * @category Object
                     * @param {Object} object The destination object.
                     * @param {...Object} [sources] The source objects.
                     * @returns {Object} Returns `object`.
                     * @see _.defaults
                     * @example
                     *
                     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
                     * // => { 'a': { 'b': 2, 'c': 3 } }
                     */
                    var defaultsDeep = baseRest(function (args) {
                      args.push(undefined, customDefaultsMerge);
                      return apply(mergeWith, undefined, args);
                    });

                    /**
                     * This method is like `_.find` except that it returns the key of the first
                     * element `predicate` returns truthy for instead of the element itself.
                     *
                     * @static
                     * @memberOf _
                     * @since 1.1.0
                     * @category Object
                     * @param {Object} object The object to inspect.
                     * @param {Function} [predicate=_.identity] The function invoked per iteration.
                     * @returns {string|undefined} Returns the key of the matched element,
                     *  else `undefined`.
                     * @example
                     *
                     * var users = {
                     *   'barney':  { 'age': 36, 'active': true },
                     *   'fred':    { 'age': 40, 'active': false },
                     *   'pebbles': { 'age': 1,  'active': true }
                     * };
                     *
                     * _.findKey(users, function(o) { return o.age < 40; });
                     * // => 'barney' (iteration order is not guaranteed)
                     *
                     * // The `_.matches` iteratee shorthand.
                     * _.findKey(users, { 'age': 1, 'active': true });
                     * // => 'pebbles'
                     *
                     * // The `_.matchesProperty` iteratee shorthand.
                     * _.findKey(users, ['active', false]);
                     * // => 'fred'
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.findKey(users, 'active');
                     * // => 'barney'
                     */
                    function findKey(object, predicate) {
                      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
                    }

                    /**
                     * This method is like `_.findKey` except that it iterates over elements of
                     * a collection in the opposite order.
                     *
                     * @static
                     * @memberOf _
                     * @since 2.0.0
                     * @category Object
                     * @param {Object} object The object to inspect.
                     * @param {Function} [predicate=_.identity] The function invoked per iteration.
                     * @returns {string|undefined} Returns the key of the matched element,
                     *  else `undefined`.
                     * @example
                     *
                     * var users = {
                     *   'barney':  { 'age': 36, 'active': true },
                     *   'fred':    { 'age': 40, 'active': false },
                     *   'pebbles': { 'age': 1,  'active': true }
                     * };
                     *
                     * _.findLastKey(users, function(o) { return o.age < 40; });
                     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
                     *
                     * // The `_.matches` iteratee shorthand.
                     * _.findLastKey(users, { 'age': 36, 'active': true });
                     * // => 'barney'
                     *
                     * // The `_.matchesProperty` iteratee shorthand.
                     * _.findLastKey(users, ['active', false]);
                     * // => 'fred'
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.findLastKey(users, 'active');
                     * // => 'pebbles'
                     */
                    function findLastKey(object, predicate) {
                      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
                    }

                    /**
                     * Iterates over own and inherited enumerable string keyed properties of an
                     * object and invokes `iteratee` for each property. The iteratee is invoked
                     * with three arguments: (value, key, object). Iteratee functions may exit
                     * iteration early by explicitly returning `false`.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.3.0
                     * @category Object
                     * @param {Object} object The object to iterate over.
                     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                     * @returns {Object} Returns `object`.
                     * @see _.forInRight
                     * @example
                     *
                     * function Foo() {
                     *   this.a = 1;
                     *   this.b = 2;
                     * }
                     *
                     * Foo.prototype.c = 3;
                     *
                     * _.forIn(new Foo, function(value, key) {
                     *   console.log(key);
                     * });
                     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
                     */
                    function forIn(object, iteratee) {
                      return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
                    }

                    /**
                     * This method is like `_.forIn` except that it iterates over properties of
                     * `object` in the opposite order.
                     *
                     * @static
                     * @memberOf _
                     * @since 2.0.0
                     * @category Object
                     * @param {Object} object The object to iterate over.
                     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                     * @returns {Object} Returns `object`.
                     * @see _.forIn
                     * @example
                     *
                     * function Foo() {
                     *   this.a = 1;
                     *   this.b = 2;
                     * }
                     *
                     * Foo.prototype.c = 3;
                     *
                     * _.forInRight(new Foo, function(value, key) {
                     *   console.log(key);
                     * });
                     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
                     */
                    function forInRight(object, iteratee) {
                      return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
                    }

                    /**
                     * Iterates over own enumerable string keyed properties of an object and
                     * invokes `iteratee` for each property. The iteratee is invoked with three
                     * arguments: (value, key, object). Iteratee functions may exit iteration
                     * early by explicitly returning `false`.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.3.0
                     * @category Object
                     * @param {Object} object The object to iterate over.
                     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                     * @returns {Object} Returns `object`.
                     * @see _.forOwnRight
                     * @example
                     *
                     * function Foo() {
                     *   this.a = 1;
                     *   this.b = 2;
                     * }
                     *
                     * Foo.prototype.c = 3;
                     *
                     * _.forOwn(new Foo, function(value, key) {
                     *   console.log(key);
                     * });
                     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
                     */
                    function forOwn(object, iteratee) {
                      return object && baseForOwn(object, getIteratee(iteratee, 3));
                    }

                    /**
                     * This method is like `_.forOwn` except that it iterates over properties of
                     * `object` in the opposite order.
                     *
                     * @static
                     * @memberOf _
                     * @since 2.0.0
                     * @category Object
                     * @param {Object} object The object to iterate over.
                     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                     * @returns {Object} Returns `object`.
                     * @see _.forOwn
                     * @example
                     *
                     * function Foo() {
                     *   this.a = 1;
                     *   this.b = 2;
                     * }
                     *
                     * Foo.prototype.c = 3;
                     *
                     * _.forOwnRight(new Foo, function(value, key) {
                     *   console.log(key);
                     * });
                     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
                     */
                    function forOwnRight(object, iteratee) {
                      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
                    }

                    /**
                     * Creates an array of function property names from own enumerable properties
                     * of `object`.
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category Object
                     * @param {Object} object The object to inspect.
                     * @returns {Array} Returns the function names.
                     * @see _.functionsIn
                     * @example
                     *
                     * function Foo() {
                     *   this.a = _.constant('a');
                     *   this.b = _.constant('b');
                     * }
                     *
                     * Foo.prototype.c = _.constant('c');
                     *
                     * _.functions(new Foo);
                     * // => ['a', 'b']
                     */
                    function functions(object) {
                      return object == null ? [] : baseFunctions(object, keys(object));
                    }

                    /**
                     * Creates an array of function property names from own and inherited
                     * enumerable properties of `object`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Object
                     * @param {Object} object The object to inspect.
                     * @returns {Array} Returns the function names.
                     * @see _.functions
                     * @example
                     *
                     * function Foo() {
                     *   this.a = _.constant('a');
                     *   this.b = _.constant('b');
                     * }
                     *
                     * Foo.prototype.c = _.constant('c');
                     *
                     * _.functionsIn(new Foo);
                     * // => ['a', 'b', 'c']
                     */
                    function functionsIn(object) {
                      return object == null ? [] : baseFunctions(object, keysIn(object));
                    }

                    /**
                     * Gets the value at `path` of `object`. If the resolved value is
                     * `undefined`, the `defaultValue` is returned in its place.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.7.0
                     * @category Object
                     * @param {Object} object The object to query.
                     * @param {Array|string} path The path of the property to get.
                     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
                     * @returns {*} Returns the resolved value.
                     * @example
                     *
                     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
                     *
                     * _.get(object, 'a[0].b.c');
                     * // => 3
                     *
                     * _.get(object, ['a', '0', 'b', 'c']);
                     * // => 3
                     *
                     * _.get(object, 'a.b.c', 'default');
                     * // => 'default'
                     */
                    function get(object, path, defaultValue) {
                      var result = object == null ? undefined : baseGet(object, path);
                      return result === undefined ? defaultValue : result;
                    }

                    /**
                     * Checks if `path` is a direct property of `object`.
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category Object
                     * @param {Object} object The object to query.
                     * @param {Array|string} path The path to check.
                     * @returns {boolean} Returns `true` if `path` exists, else `false`.
                     * @example
                     *
                     * var object = { 'a': { 'b': 2 } };
                     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
                     *
                     * _.has(object, 'a');
                     * // => true
                     *
                     * _.has(object, 'a.b');
                     * // => true
                     *
                     * _.has(object, ['a', 'b']);
                     * // => true
                     *
                     * _.has(other, 'a');
                     * // => false
                     */
                    function has(object, path) {
                      return object != null && hasPath(object, path, baseHas);
                    }

                    /**
                     * Checks if `path` is a direct or inherited property of `object`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Object
                     * @param {Object} object The object to query.
                     * @param {Array|string} path The path to check.
                     * @returns {boolean} Returns `true` if `path` exists, else `false`.
                     * @example
                     *
                     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
                     *
                     * _.hasIn(object, 'a');
                     * // => true
                     *
                     * _.hasIn(object, 'a.b');
                     * // => true
                     *
                     * _.hasIn(object, ['a', 'b']);
                     * // => true
                     *
                     * _.hasIn(object, 'b');
                     * // => false
                     */
                    function hasIn(object, path) {
                      return object != null && hasPath(object, path, baseHasIn);
                    }

                    /**
                     * Creates an object composed of the inverted keys and values of `object`.
                     * If `object` contains duplicate values, subsequent values overwrite
                     * property assignments of previous values.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.7.0
                     * @category Object
                     * @param {Object} object The object to invert.
                     * @returns {Object} Returns the new inverted object.
                     * @example
                     *
                     * var object = { 'a': 1, 'b': 2, 'c': 1 };
                     *
                     * _.invert(object);
                     * // => { '1': 'c', '2': 'b' }
                     */
                    var invert = createInverter(function (result, value, key) {
                      result[value] = key;
                    }, constant(identity));

                    /**
                     * This method is like `_.invert` except that the inverted object is generated
                     * from the results of running each element of `object` thru `iteratee`. The
                     * corresponding inverted value of each inverted key is an array of keys
                     * responsible for generating the inverted value. The iteratee is invoked
                     * with one argument: (value).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.1.0
                     * @category Object
                     * @param {Object} object The object to invert.
                     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                     * @returns {Object} Returns the new inverted object.
                     * @example
                     *
                     * var object = { 'a': 1, 'b': 2, 'c': 1 };
                     *
                     * _.invertBy(object);
                     * // => { '1': ['a', 'c'], '2': ['b'] }
                     *
                     * _.invertBy(object, function(value) {
                     *   return 'group' + value;
                     * });
                     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
                     */
                    var invertBy = createInverter(function (result, value, key) {
                      if (hasOwnProperty.call(result, value)) {
                        result[value].push(key);
                      } else {
                        result[value] = [key];
                      }
                    }, getIteratee);

                    /**
                     * Invokes the method at `path` of `object`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Object
                     * @param {Object} object The object to query.
                     * @param {Array|string} path The path of the method to invoke.
                     * @param {...*} [args] The arguments to invoke the method with.
                     * @returns {*} Returns the result of the invoked method.
                     * @example
                     *
                     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
                     *
                     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
                     * // => [2, 3]
                     */
                    var invoke = baseRest(baseInvoke);

                    /**
                     * Creates an array of the own enumerable property names of `object`.
                     *
                     * **Note:** Non-object values are coerced to objects. See the
                     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
                     * for more details.
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category Object
                     * @param {Object} object The object to query.
                     * @returns {Array} Returns the array of property names.
                     * @example
                     *
                     * function Foo() {
                     *   this.a = 1;
                     *   this.b = 2;
                     * }
                     *
                     * Foo.prototype.c = 3;
                     *
                     * _.keys(new Foo);
                     * // => ['a', 'b'] (iteration order is not guaranteed)
                     *
                     * _.keys('hi');
                     * // => ['0', '1']
                     */
                    function keys(object) {
                      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
                    }

                    /**
                     * Creates an array of the own and inherited enumerable property names of `object`.
                     *
                     * **Note:** Non-object values are coerced to objects.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Object
                     * @param {Object} object The object to query.
                     * @returns {Array} Returns the array of property names.
                     * @example
                     *
                     * function Foo() {
                     *   this.a = 1;
                     *   this.b = 2;
                     * }
                     *
                     * Foo.prototype.c = 3;
                     *
                     * _.keysIn(new Foo);
                     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
                     */
                    function keysIn(object) {
                      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
                    }

                    /**
                     * The opposite of `_.mapValues`; this method creates an object with the
                     * same values as `object` and keys generated by running each own enumerable
                     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
                     * with three arguments: (value, key, object).
                     *
                     * @static
                     * @memberOf _
                     * @since 3.8.0
                     * @category Object
                     * @param {Object} object The object to iterate over.
                     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                     * @returns {Object} Returns the new mapped object.
                     * @see _.mapValues
                     * @example
                     *
                     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
                     *   return key + value;
                     * });
                     * // => { 'a1': 1, 'b2': 2 }
                     */
                    function mapKeys(object, iteratee) {
                      var result = {};
                      iteratee = getIteratee(iteratee, 3);

                      baseForOwn(object, function (value, key, object) {
                        baseAssignValue(result, iteratee(value, key, object), value);
                      });
                      return result;
                    }

                    /**
                     * Creates an object with the same keys as `object` and values generated
                     * by running each own enumerable string keyed property of `object` thru
                     * `iteratee`. The iteratee is invoked with three arguments:
                     * (value, key, object).
                     *
                     * @static
                     * @memberOf _
                     * @since 2.4.0
                     * @category Object
                     * @param {Object} object The object to iterate over.
                     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                     * @returns {Object} Returns the new mapped object.
                     * @see _.mapKeys
                     * @example
                     *
                     * var users = {
                     *   'fred':    { 'user': 'fred',    'age': 40 },
                     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
                     * };
                     *
                     * _.mapValues(users, function(o) { return o.age; });
                     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.mapValues(users, 'age');
                     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
                     */
                    function mapValues(object, iteratee) {
                      var result = {};
                      iteratee = getIteratee(iteratee, 3);

                      baseForOwn(object, function (value, key, object) {
                        baseAssignValue(result, key, iteratee(value, key, object));
                      });
                      return result;
                    }

                    /**
                     * This method is like `_.assign` except that it recursively merges own and
                     * inherited enumerable string keyed properties of source objects into the
                     * destination object. Source properties that resolve to `undefined` are
                     * skipped if a destination value exists. Array and plain object properties
                     * are merged recursively. Other objects and value types are overridden by
                     * assignment. Source objects are applied from left to right. Subsequent
                     * sources overwrite property assignments of previous sources.
                     *
                     * **Note:** This method mutates `object`.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.5.0
                     * @category Object
                     * @param {Object} object The destination object.
                     * @param {...Object} [sources] The source objects.
                     * @returns {Object} Returns `object`.
                     * @example
                     *
                     * var object = {
                     *   'a': [{ 'b': 2 }, { 'd': 4 }]
                     * };
                     *
                     * var other = {
                     *   'a': [{ 'c': 3 }, { 'e': 5 }]
                     * };
                     *
                     * _.merge(object, other);
                     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
                     */
                    var merge = createAssigner(function (object, source, srcIndex) {
                      baseMerge(object, source, srcIndex);
                    });

                    /**
                     * This method is like `_.merge` except that it accepts `customizer` which
                     * is invoked to produce the merged values of the destination and source
                     * properties. If `customizer` returns `undefined`, merging is handled by the
                     * method instead. The `customizer` is invoked with six arguments:
                     * (objValue, srcValue, key, object, source, stack).
                     *
                     * **Note:** This method mutates `object`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Object
                     * @param {Object} object The destination object.
                     * @param {...Object} sources The source objects.
                     * @param {Function} customizer The function to customize assigned values.
                     * @returns {Object} Returns `object`.
                     * @example
                     *
                     * function customizer(objValue, srcValue) {
                     *   if (_.isArray(objValue)) {
                     *     return objValue.concat(srcValue);
                     *   }
                     * }
                     *
                     * var object = { 'a': [1], 'b': [2] };
                     * var other = { 'a': [3], 'b': [4] };
                     *
                     * _.mergeWith(object, other, customizer);
                     * // => { 'a': [1, 3], 'b': [2, 4] }
                     */
                    var mergeWith = createAssigner(function (object, source, srcIndex, customizer) {
                      baseMerge(object, source, srcIndex, customizer);
                    });

                    /**
                     * The opposite of `_.pick`; this method creates an object composed of the
                     * own and inherited enumerable property paths of `object` that are not omitted.
                     *
                     * **Note:** This method is considerably slower than `_.pick`.
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category Object
                     * @param {Object} object The source object.
                     * @param {...(string|string[])} [paths] The property paths to omit.
                     * @returns {Object} Returns the new object.
                     * @example
                     *
                     * var object = { 'a': 1, 'b': '2', 'c': 3 };
                     *
                     * _.omit(object, ['a', 'c']);
                     * // => { 'b': '2' }
                     */
                    var omit = flatRest(function (object, paths) {
                      var result = {};
                      if (object == null) {
                        return result;
                      }
                      var isDeep = false;
                      paths = arrayMap(paths, function (path) {
                        path = castPath(path, object);
                        isDeep || (isDeep = path.length > 1);
                        return path;
                      });
                      copyObject(object, getAllKeysIn(object), result);
                      if (isDeep) {
                        result = baseClone(
                          result,
                          CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG,
                          customOmitClone
                        );
                      }
                      var length = paths.length;
                      while (length--) {
                        baseUnset(result, paths[length]);
                      }
                      return result;
                    });

                    /**
                     * The opposite of `_.pickBy`; this method creates an object composed of
                     * the own and inherited enumerable string keyed properties of `object` that
                     * `predicate` doesn't return truthy for. The predicate is invoked with two
                     * arguments: (value, key).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Object
                     * @param {Object} object The source object.
                     * @param {Function} [predicate=_.identity] The function invoked per property.
                     * @returns {Object} Returns the new object.
                     * @example
                     *
                     * var object = { 'a': 1, 'b': '2', 'c': 3 };
                     *
                     * _.omitBy(object, _.isNumber);
                     * // => { 'b': '2' }
                     */
                    function omitBy(object, predicate) {
                      return pickBy(object, negate(getIteratee(predicate)));
                    }

                    /**
                     * Creates an object composed of the picked `object` properties.
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category Object
                     * @param {Object} object The source object.
                     * @param {...(string|string[])} [paths] The property paths to pick.
                     * @returns {Object} Returns the new object.
                     * @example
                     *
                     * var object = { 'a': 1, 'b': '2', 'c': 3 };
                     *
                     * _.pick(object, ['a', 'c']);
                     * // => { 'a': 1, 'c': 3 }
                     */
                    var pick = flatRest(function (object, paths) {
                      return object == null ? {} : basePick(object, paths);
                    });

                    /**
                     * Creates an object composed of the `object` properties `predicate` returns
                     * truthy for. The predicate is invoked with two arguments: (value, key).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Object
                     * @param {Object} object The source object.
                     * @param {Function} [predicate=_.identity] The function invoked per property.
                     * @returns {Object} Returns the new object.
                     * @example
                     *
                     * var object = { 'a': 1, 'b': '2', 'c': 3 };
                     *
                     * _.pickBy(object, _.isNumber);
                     * // => { 'a': 1, 'c': 3 }
                     */
                    function pickBy(object, predicate) {
                      if (object == null) {
                        return {};
                      }
                      var props = arrayMap(getAllKeysIn(object), function (prop) {
                        return [prop];
                      });
                      predicate = getIteratee(predicate);
                      return basePickBy(object, props, function (value, path) {
                        return predicate(value, path[0]);
                      });
                    }

                    /**
                     * This method is like `_.get` except that if the resolved value is a
                     * function it's invoked with the `this` binding of its parent object and
                     * its result is returned.
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category Object
                     * @param {Object} object The object to query.
                     * @param {Array|string} path The path of the property to resolve.
                     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
                     * @returns {*} Returns the resolved value.
                     * @example
                     *
                     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
                     *
                     * _.result(object, 'a[0].b.c1');
                     * // => 3
                     *
                     * _.result(object, 'a[0].b.c2');
                     * // => 4
                     *
                     * _.result(object, 'a[0].b.c3', 'default');
                     * // => 'default'
                     *
                     * _.result(object, 'a[0].b.c3', _.constant('default'));
                     * // => 'default'
                     */
                    function result(object, path, defaultValue) {
                      path = castPath(path, object);

                      var index = -1,
                        length = path.length;

                      // Ensure the loop is entered when path is empty.
                      if (!length) {
                        length = 1;
                        object = undefined;
                      }
                      while (++index < length) {
                        var value = object == null ? undefined : object[toKey(path[index])];
                        if (value === undefined) {
                          index = length;
                          value = defaultValue;
                        }
                        object = isFunction(value) ? value.call(object) : value;
                      }
                      return object;
                    }

                    /**
                     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
                     * it's created. Arrays are created for missing index properties while objects
                     * are created for all other missing properties. Use `_.setWith` to customize
                     * `path` creation.
                     *
                     * **Note:** This method mutates `object`.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.7.0
                     * @category Object
                     * @param {Object} object The object to modify.
                     * @param {Array|string} path The path of the property to set.
                     * @param {*} value The value to set.
                     * @returns {Object} Returns `object`.
                     * @example
                     *
                     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
                     *
                     * _.set(object, 'a[0].b.c', 4);
                     * console.log(object.a[0].b.c);
                     * // => 4
                     *
                     * _.set(object, ['x', '0', 'y', 'z'], 5);
                     * console.log(object.x[0].y.z);
                     * // => 5
                     */
                    function set(object, path, value) {
                      return object == null ? object : baseSet(object, path, value);
                    }

                    /**
                     * This method is like `_.set` except that it accepts `customizer` which is
                     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
                     * path creation is handled by the method instead. The `customizer` is invoked
                     * with three arguments: (nsValue, key, nsObject).
                     *
                     * **Note:** This method mutates `object`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Object
                     * @param {Object} object The object to modify.
                     * @param {Array|string} path The path of the property to set.
                     * @param {*} value The value to set.
                     * @param {Function} [customizer] The function to customize assigned values.
                     * @returns {Object} Returns `object`.
                     * @example
                     *
                     * var object = {};
                     *
                     * _.setWith(object, '[0][1]', 'a', Object);
                     * // => { '0': { '1': 'a' } }
                     */
                    function setWith(object, path, value, customizer) {
                      customizer = typeof customizer == 'function' ? customizer : undefined;
                      return object == null ? object : baseSet(object, path, value, customizer);
                    }

                    /**
                     * Creates an array of own enumerable string keyed-value pairs for `object`
                     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
                     * entries are returned.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @alias entries
                     * @category Object
                     * @param {Object} object The object to query.
                     * @returns {Array} Returns the key-value pairs.
                     * @example
                     *
                     * function Foo() {
                     *   this.a = 1;
                     *   this.b = 2;
                     * }
                     *
                     * Foo.prototype.c = 3;
                     *
                     * _.toPairs(new Foo);
                     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
                     */
                    var toPairs = createToPairs(keys);

                    /**
                     * Creates an array of own and inherited enumerable string keyed-value pairs
                     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
                     * or set, its entries are returned.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @alias entriesIn
                     * @category Object
                     * @param {Object} object The object to query.
                     * @returns {Array} Returns the key-value pairs.
                     * @example
                     *
                     * function Foo() {
                     *   this.a = 1;
                     *   this.b = 2;
                     * }
                     *
                     * Foo.prototype.c = 3;
                     *
                     * _.toPairsIn(new Foo);
                     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
                     */
                    var toPairsIn = createToPairs(keysIn);

                    /**
                     * An alternative to `_.reduce`; this method transforms `object` to a new
                     * `accumulator` object which is the result of running each of its own
                     * enumerable string keyed properties thru `iteratee`, with each invocation
                     * potentially mutating the `accumulator` object. If `accumulator` is not
                     * provided, a new object with the same `[[Prototype]]` will be used. The
                     * iteratee is invoked with four arguments: (accumulator, value, key, object).
                     * Iteratee functions may exit iteration early by explicitly returning `false`.
                     *
                     * @static
                     * @memberOf _
                     * @since 1.3.0
                     * @category Object
                     * @param {Object} object The object to iterate over.
                     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                     * @param {*} [accumulator] The custom accumulator value.
                     * @returns {*} Returns the accumulated value.
                     * @example
                     *
                     * _.transform([2, 3, 4], function(result, n) {
                     *   result.push(n *= n);
                     *   return n % 2 == 0;
                     * }, []);
                     * // => [4, 9]
                     *
                     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
                     *   (result[value] || (result[value] = [])).push(key);
                     * }, {});
                     * // => { '1': ['a', 'c'], '2': ['b'] }
                     */
                    function transform(object, iteratee, accumulator) {
                      var isArr = isArray(object),
                        isArrLike = isArr || isBuffer(object) || isTypedArray(object);

                      iteratee = getIteratee(iteratee, 4);
                      if (accumulator == null) {
                        var Ctor = object && object.constructor;
                        if (isArrLike) {
                          accumulator = isArr ? new Ctor() : [];
                        } else if (isObject(object)) {
                          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                        } else {
                          accumulator = {};
                        }
                      }
                      (isArrLike ? arrayEach : baseForOwn)(object, function (value, index, object) {
                        return iteratee(accumulator, value, index, object);
                      });
                      return accumulator;
                    }

                    /**
                     * Removes the property at `path` of `object`.
                     *
                     * **Note:** This method mutates `object`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Object
                     * @param {Object} object The object to modify.
                     * @param {Array|string} path The path of the property to unset.
                     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
                     * @example
                     *
                     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
                     * _.unset(object, 'a[0].b.c');
                     * // => true
                     *
                     * console.log(object);
                     * // => { 'a': [{ 'b': {} }] };
                     *
                     * _.unset(object, ['a', '0', 'b', 'c']);
                     * // => true
                     *
                     * console.log(object);
                     * // => { 'a': [{ 'b': {} }] };
                     */
                    function unset(object, path) {
                      return object == null ? true : baseUnset(object, path);
                    }

                    /**
                     * This method is like `_.set` except that accepts `updater` to produce the
                     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
                     * is invoked with one argument: (value).
                     *
                     * **Note:** This method mutates `object`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.6.0
                     * @category Object
                     * @param {Object} object The object to modify.
                     * @param {Array|string} path The path of the property to set.
                     * @param {Function} updater The function to produce the updated value.
                     * @returns {Object} Returns `object`.
                     * @example
                     *
                     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
                     *
                     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
                     * console.log(object.a[0].b.c);
                     * // => 9
                     *
                     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
                     * console.log(object.x[0].y.z);
                     * // => 0
                     */
                    function update(object, path, updater) {
                      return object == null ? object : baseUpdate(object, path, castFunction(updater));
                    }

                    /**
                     * This method is like `_.update` except that it accepts `customizer` which is
                     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
                     * path creation is handled by the method instead. The `customizer` is invoked
                     * with three arguments: (nsValue, key, nsObject).
                     *
                     * **Note:** This method mutates `object`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.6.0
                     * @category Object
                     * @param {Object} object The object to modify.
                     * @param {Array|string} path The path of the property to set.
                     * @param {Function} updater The function to produce the updated value.
                     * @param {Function} [customizer] The function to customize assigned values.
                     * @returns {Object} Returns `object`.
                     * @example
                     *
                     * var object = {};
                     *
                     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
                     * // => { '0': { '1': 'a' } }
                     */
                    function updateWith(object, path, updater, customizer) {
                      customizer = typeof customizer == 'function' ? customizer : undefined;
                      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
                    }

                    /**
                     * Creates an array of the own enumerable string keyed property values of `object`.
                     *
                     * **Note:** Non-object values are coerced to objects.
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category Object
                     * @param {Object} object The object to query.
                     * @returns {Array} Returns the array of property values.
                     * @example
                     *
                     * function Foo() {
                     *   this.a = 1;
                     *   this.b = 2;
                     * }
                     *
                     * Foo.prototype.c = 3;
                     *
                     * _.values(new Foo);
                     * // => [1, 2] (iteration order is not guaranteed)
                     *
                     * _.values('hi');
                     * // => ['h', 'i']
                     */
                    function values(object) {
                      return object == null ? [] : baseValues(object, keys(object));
                    }

                    /**
                     * Creates an array of the own and inherited enumerable string keyed property
                     * values of `object`.
                     *
                     * **Note:** Non-object values are coerced to objects.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Object
                     * @param {Object} object The object to query.
                     * @returns {Array} Returns the array of property values.
                     * @example
                     *
                     * function Foo() {
                     *   this.a = 1;
                     *   this.b = 2;
                     * }
                     *
                     * Foo.prototype.c = 3;
                     *
                     * _.valuesIn(new Foo);
                     * // => [1, 2, 3] (iteration order is not guaranteed)
                     */
                    function valuesIn(object) {
                      return object == null ? [] : baseValues(object, keysIn(object));
                    }

                    /*------------------------------------------------------------------------*/

                    /**
                     * Clamps `number` within the inclusive `lower` and `upper` bounds.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Number
                     * @param {number} number The number to clamp.
                     * @param {number} [lower] The lower bound.
                     * @param {number} upper The upper bound.
                     * @returns {number} Returns the clamped number.
                     * @example
                     *
                     * _.clamp(-10, -5, 5);
                     * // => -5
                     *
                     * _.clamp(10, -5, 5);
                     * // => 5
                     */
                    function clamp(number, lower, upper) {
                      if (upper === undefined) {
                        upper = lower;
                        lower = undefined;
                      }
                      if (upper !== undefined) {
                        upper = toNumber(upper);
                        upper = upper === upper ? upper : 0;
                      }
                      if (lower !== undefined) {
                        lower = toNumber(lower);
                        lower = lower === lower ? lower : 0;
                      }
                      return baseClamp(toNumber(number), lower, upper);
                    }

                    /**
                     * Checks if `n` is between `start` and up to, but not including, `end`. If
                     * `end` is not specified, it's set to `start` with `start` then set to `0`.
                     * If `start` is greater than `end` the params are swapped to support
                     * negative ranges.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.3.0
                     * @category Number
                     * @param {number} number The number to check.
                     * @param {number} [start=0] The start of the range.
                     * @param {number} end The end of the range.
                     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
                     * @see _.range, _.rangeRight
                     * @example
                     *
                     * _.inRange(3, 2, 4);
                     * // => true
                     *
                     * _.inRange(4, 8);
                     * // => true
                     *
                     * _.inRange(4, 2);
                     * // => false
                     *
                     * _.inRange(2, 2);
                     * // => false
                     *
                     * _.inRange(1.2, 2);
                     * // => true
                     *
                     * _.inRange(5.2, 4);
                     * // => false
                     *
                     * _.inRange(-3, -2, -6);
                     * // => true
                     */
                    function inRange(number, start, end) {
                      start = toFinite(start);
                      if (end === undefined) {
                        end = start;
                        start = 0;
                      } else {
                        end = toFinite(end);
                      }
                      number = toNumber(number);
                      return baseInRange(number, start, end);
                    }

                    /**
                     * Produces a random number between the inclusive `lower` and `upper` bounds.
                     * If only one argument is provided a number between `0` and the given number
                     * is returned. If `floating` is `true`, or either `lower` or `upper` are
                     * floats, a floating-point number is returned instead of an integer.
                     *
                     * **Note:** JavaScript follows the IEEE-754 standard for resolving
                     * floating-point values which can produce unexpected results.
                     *
                     * @static
                     * @memberOf _
                     * @since 0.7.0
                     * @category Number
                     * @param {number} [lower=0] The lower bound.
                     * @param {number} [upper=1] The upper bound.
                     * @param {boolean} [floating] Specify returning a floating-point number.
                     * @returns {number} Returns the random number.
                     * @example
                     *
                     * _.random(0, 5);
                     * // => an integer between 0 and 5
                     *
                     * _.random(5);
                     * // => also an integer between 0 and 5
                     *
                     * _.random(5, true);
                     * // => a floating-point number between 0 and 5
                     *
                     * _.random(1.2, 5.2);
                     * // => a floating-point number between 1.2 and 5.2
                     */
                    function random(lower, upper, floating) {
                      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
                        upper = floating = undefined;
                      }
                      if (floating === undefined) {
                        if (typeof upper == 'boolean') {
                          floating = upper;
                          upper = undefined;
                        } else if (typeof lower == 'boolean') {
                          floating = lower;
                          lower = undefined;
                        }
                      }
                      if (lower === undefined && upper === undefined) {
                        lower = 0;
                        upper = 1;
                      } else {
                        lower = toFinite(lower);
                        if (upper === undefined) {
                          upper = lower;
                          lower = 0;
                        } else {
                          upper = toFinite(upper);
                        }
                      }
                      if (lower > upper) {
                        var temp = lower;
                        lower = upper;
                        upper = temp;
                      }
                      if (floating || lower % 1 || upper % 1) {
                        var rand = nativeRandom();
                        return nativeMin(
                          lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))),
                          upper
                        );
                      }
                      return baseRandom(lower, upper);
                    }

                    /*------------------------------------------------------------------------*/

                    /**
                     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category String
                     * @param {string} [string=''] The string to convert.
                     * @returns {string} Returns the camel cased string.
                     * @example
                     *
                     * _.camelCase('Foo Bar');
                     * // => 'fooBar'
                     *
                     * _.camelCase('--foo-bar--');
                     * // => 'fooBar'
                     *
                     * _.camelCase('__FOO_BAR__');
                     * // => 'fooBar'
                     */
                    var camelCase = createCompounder(function (result, word, index) {
                      word = word.toLowerCase();
                      return result + (index ? capitalize(word) : word);
                    });

                    /**
                     * Converts the first character of `string` to upper case and the remaining
                     * to lower case.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category String
                     * @param {string} [string=''] The string to capitalize.
                     * @returns {string} Returns the capitalized string.
                     * @example
                     *
                     * _.capitalize('FRED');
                     * // => 'Fred'
                     */
                    function capitalize(string) {
                      return upperFirst(toString(string).toLowerCase());
                    }

                    /**
                     * Deburrs `string` by converting
                     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
                     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
                     * letters to basic Latin letters and removing
                     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category String
                     * @param {string} [string=''] The string to deburr.
                     * @returns {string} Returns the deburred string.
                     * @example
                     *
                     * _.deburr('déjà vu');
                     * // => 'deja vu'
                     */
                    function deburr(string) {
                      string = toString(string);
                      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
                    }

                    /**
                     * Checks if `string` ends with the given target string.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category String
                     * @param {string} [string=''] The string to inspect.
                     * @param {string} [target] The string to search for.
                     * @param {number} [position=string.length] The position to search up to.
                     * @returns {boolean} Returns `true` if `string` ends with `target`,
                     *  else `false`.
                     * @example
                     *
                     * _.endsWith('abc', 'c');
                     * // => true
                     *
                     * _.endsWith('abc', 'b');
                     * // => false
                     *
                     * _.endsWith('abc', 'b', 2);
                     * // => true
                     */
                    function endsWith(string, target, position) {
                      string = toString(string);
                      target = baseToString(target);

                      var length = string.length;
                      position = position === undefined ? length : baseClamp(toInteger(position), 0, length);

                      var end = position;
                      position -= target.length;
                      return position >= 0 && string.slice(position, end) == target;
                    }

                    /**
                     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
                     * corresponding HTML entities.
                     *
                     * **Note:** No other characters are escaped. To escape additional
                     * characters use a third-party library like [_he_](https://mths.be/he).
                     *
                     * Though the ">" character is escaped for symmetry, characters like
                     * ">" and "/" don't need escaping in HTML and have no special meaning
                     * unless they're part of a tag or unquoted attribute value. See
                     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
                     * (under "semi-related fun fact") for more details.
                     *
                     * When working with HTML you should always
                     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
                     * XSS vectors.
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category String
                     * @param {string} [string=''] The string to escape.
                     * @returns {string} Returns the escaped string.
                     * @example
                     *
                     * _.escape('fred, barney, & pebbles');
                     * // => 'fred, barney, &amp; pebbles'
                     */
                    function escape(string) {
                      string = toString(string);
                      return string && reHasUnescapedHtml.test(string)
                        ? string.replace(reUnescapedHtml, escapeHtmlChar)
                        : string;
                    }

                    /**
                     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
                     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category String
                     * @param {string} [string=''] The string to escape.
                     * @returns {string} Returns the escaped string.
                     * @example
                     *
                     * _.escapeRegExp('[lodash](https://lodash.com/)');
                     * // => '\[lodash\]\(https://lodash\.com/\)'
                     */
                    function escapeRegExp(string) {
                      string = toString(string);
                      return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
                    }

                    /**
                     * Converts `string` to
                     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category String
                     * @param {string} [string=''] The string to convert.
                     * @returns {string} Returns the kebab cased string.
                     * @example
                     *
                     * _.kebabCase('Foo Bar');
                     * // => 'foo-bar'
                     *
                     * _.kebabCase('fooBar');
                     * // => 'foo-bar'
                     *
                     * _.kebabCase('__FOO_BAR__');
                     * // => 'foo-bar'
                     */
                    var kebabCase = createCompounder(function (result, word, index) {
                      return result + (index ? '-' : '') + word.toLowerCase();
                    });

                    /**
                     * Converts `string`, as space separated words, to lower case.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category String
                     * @param {string} [string=''] The string to convert.
                     * @returns {string} Returns the lower cased string.
                     * @example
                     *
                     * _.lowerCase('--Foo-Bar--');
                     * // => 'foo bar'
                     *
                     * _.lowerCase('fooBar');
                     * // => 'foo bar'
                     *
                     * _.lowerCase('__FOO_BAR__');
                     * // => 'foo bar'
                     */
                    var lowerCase = createCompounder(function (result, word, index) {
                      return result + (index ? ' ' : '') + word.toLowerCase();
                    });

                    /**
                     * Converts the first character of `string` to lower case.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category String
                     * @param {string} [string=''] The string to convert.
                     * @returns {string} Returns the converted string.
                     * @example
                     *
                     * _.lowerFirst('Fred');
                     * // => 'fred'
                     *
                     * _.lowerFirst('FRED');
                     * // => 'fRED'
                     */
                    var lowerFirst = createCaseFirst('toLowerCase');

                    /**
                     * Pads `string` on the left and right sides if it's shorter than `length`.
                     * Padding characters are truncated if they can't be evenly divided by `length`.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category String
                     * @param {string} [string=''] The string to pad.
                     * @param {number} [length=0] The padding length.
                     * @param {string} [chars=' '] The string used as padding.
                     * @returns {string} Returns the padded string.
                     * @example
                     *
                     * _.pad('abc', 8);
                     * // => '  abc   '
                     *
                     * _.pad('abc', 8, '_-');
                     * // => '_-abc_-_'
                     *
                     * _.pad('abc', 3);
                     * // => 'abc'
                     */
                    function pad(string, length, chars) {
                      string = toString(string);
                      length = toInteger(length);

                      var strLength = length ? stringSize(string) : 0;
                      if (!length || strLength >= length) {
                        return string;
                      }
                      var mid = (length - strLength) / 2;
                      return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
                    }

                    /**
                     * Pads `string` on the right side if it's shorter than `length`. Padding
                     * characters are truncated if they exceed `length`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category String
                     * @param {string} [string=''] The string to pad.
                     * @param {number} [length=0] The padding length.
                     * @param {string} [chars=' '] The string used as padding.
                     * @returns {string} Returns the padded string.
                     * @example
                     *
                     * _.padEnd('abc', 6);
                     * // => 'abc   '
                     *
                     * _.padEnd('abc', 6, '_-');
                     * // => 'abc_-_'
                     *
                     * _.padEnd('abc', 3);
                     * // => 'abc'
                     */
                    function padEnd(string, length, chars) {
                      string = toString(string);
                      length = toInteger(length);

                      var strLength = length ? stringSize(string) : 0;
                      return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
                    }

                    /**
                     * Pads `string` on the left side if it's shorter than `length`. Padding
                     * characters are truncated if they exceed `length`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category String
                     * @param {string} [string=''] The string to pad.
                     * @param {number} [length=0] The padding length.
                     * @param {string} [chars=' '] The string used as padding.
                     * @returns {string} Returns the padded string.
                     * @example
                     *
                     * _.padStart('abc', 6);
                     * // => '   abc'
                     *
                     * _.padStart('abc', 6, '_-');
                     * // => '_-_abc'
                     *
                     * _.padStart('abc', 3);
                     * // => 'abc'
                     */
                    function padStart(string, length, chars) {
                      string = toString(string);
                      length = toInteger(length);

                      var strLength = length ? stringSize(string) : 0;
                      return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
                    }

                    /**
                     * Converts `string` to an integer of the specified radix. If `radix` is
                     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
                     * hexadecimal, in which case a `radix` of `16` is used.
                     *
                     * **Note:** This method aligns with the
                     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
                     *
                     * @static
                     * @memberOf _
                     * @since 1.1.0
                     * @category String
                     * @param {string} string The string to convert.
                     * @param {number} [radix=10] The radix to interpret `value` by.
                     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                     * @returns {number} Returns the converted integer.
                     * @example
                     *
                     * _.parseInt('08');
                     * // => 8
                     *
                     * _.map(['6', '08', '10'], _.parseInt);
                     * // => [6, 8, 10]
                     */
                    function parseInt(string, radix, guard) {
                      if (guard || radix == null) {
                        radix = 0;
                      } else if (radix) {
                        radix = +radix;
                      }
                      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
                    }

                    /**
                     * Repeats the given string `n` times.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category String
                     * @param {string} [string=''] The string to repeat.
                     * @param {number} [n=1] The number of times to repeat the string.
                     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                     * @returns {string} Returns the repeated string.
                     * @example
                     *
                     * _.repeat('*', 3);
                     * // => '***'
                     *
                     * _.repeat('abc', 2);
                     * // => 'abcabc'
                     *
                     * _.repeat('abc', 0);
                     * // => ''
                     */
                    function repeat(string, n, guard) {
                      if (guard ? isIterateeCall(string, n, guard) : n === undefined) {
                        n = 1;
                      } else {
                        n = toInteger(n);
                      }
                      return baseRepeat(toString(string), n);
                    }

                    /**
                     * Replaces matches for `pattern` in `string` with `replacement`.
                     *
                     * **Note:** This method is based on
                     * [`String#replace`](https://mdn.io/String/replace).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category String
                     * @param {string} [string=''] The string to modify.
                     * @param {RegExp|string} pattern The pattern to replace.
                     * @param {Function|string} replacement The match replacement.
                     * @returns {string} Returns the modified string.
                     * @example
                     *
                     * _.replace('Hi Fred', 'Fred', 'Barney');
                     * // => 'Hi Barney'
                     */
                    function replace() {
                      var args = arguments,
                        string = toString(args[0]);

                      return args.length < 3 ? string : string.replace(args[1], args[2]);
                    }

                    /**
                     * Converts `string` to
                     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category String
                     * @param {string} [string=''] The string to convert.
                     * @returns {string} Returns the snake cased string.
                     * @example
                     *
                     * _.snakeCase('Foo Bar');
                     * // => 'foo_bar'
                     *
                     * _.snakeCase('fooBar');
                     * // => 'foo_bar'
                     *
                     * _.snakeCase('--FOO-BAR--');
                     * // => 'foo_bar'
                     */
                    var snakeCase = createCompounder(function (result, word, index) {
                      return result + (index ? '_' : '') + word.toLowerCase();
                    });

                    /**
                     * Splits `string` by `separator`.
                     *
                     * **Note:** This method is based on
                     * [`String#split`](https://mdn.io/String/split).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category String
                     * @param {string} [string=''] The string to split.
                     * @param {RegExp|string} separator The separator pattern to split by.
                     * @param {number} [limit] The length to truncate results to.
                     * @returns {Array} Returns the string segments.
                     * @example
                     *
                     * _.split('a-b-c', '-', 2);
                     * // => ['a', 'b']
                     */
                    function split(string, separator, limit) {
                      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
                        separator = limit = undefined;
                      }
                      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
                      if (!limit) {
                        return [];
                      }
                      string = toString(string);
                      if (string && (typeof separator == 'string' || (separator != null && !isRegExp(separator)))) {
                        separator = baseToString(separator);
                        if (!separator && hasUnicode(string)) {
                          return castSlice(stringToArray(string), 0, limit);
                        }
                      }
                      return string.split(separator, limit);
                    }

                    /**
                     * Converts `string` to
                     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
                     *
                     * @static
                     * @memberOf _
                     * @since 3.1.0
                     * @category String
                     * @param {string} [string=''] The string to convert.
                     * @returns {string} Returns the start cased string.
                     * @example
                     *
                     * _.startCase('--foo-bar--');
                     * // => 'Foo Bar'
                     *
                     * _.startCase('fooBar');
                     * // => 'Foo Bar'
                     *
                     * _.startCase('__FOO_BAR__');
                     * // => 'FOO BAR'
                     */
                    var startCase = createCompounder(function (result, word, index) {
                      return result + (index ? ' ' : '') + upperFirst(word);
                    });

                    /**
                     * Checks if `string` starts with the given target string.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category String
                     * @param {string} [string=''] The string to inspect.
                     * @param {string} [target] The string to search for.
                     * @param {number} [position=0] The position to search from.
                     * @returns {boolean} Returns `true` if `string` starts with `target`,
                     *  else `false`.
                     * @example
                     *
                     * _.startsWith('abc', 'a');
                     * // => true
                     *
                     * _.startsWith('abc', 'b');
                     * // => false
                     *
                     * _.startsWith('abc', 'b', 1);
                     * // => true
                     */
                    function startsWith(string, target, position) {
                      string = toString(string);
                      position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);

                      target = baseToString(target);
                      return string.slice(position, position + target.length) == target;
                    }

                    /**
                     * Creates a compiled template function that can interpolate data properties
                     * in "interpolate" delimiters, HTML-escape interpolated data properties in
                     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
                     * properties may be accessed as free variables in the template. If a setting
                     * object is given, it takes precedence over `_.templateSettings` values.
                     *
                     * **Note:** In the development build `_.template` utilizes
                     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
                     * for easier debugging.
                     *
                     * For more information on precompiling templates see
                     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
                     *
                     * For more information on Chrome extension sandboxes see
                     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category String
                     * @param {string} [string=''] The template string.
                     * @param {Object} [options={}] The options object.
                     * @param {RegExp} [options.escape=_.templateSettings.escape]
                     *  The HTML "escape" delimiter.
                     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
                     *  The "evaluate" delimiter.
                     * @param {Object} [options.imports=_.templateSettings.imports]
                     *  An object to import into the template as free variables.
                     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
                     *  The "interpolate" delimiter.
                     * @param {string} [options.sourceURL='lodash.templateSources[n]']
                     *  The sourceURL of the compiled template.
                     * @param {string} [options.variable='obj']
                     *  The data object variable name.
                     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                     * @returns {Function} Returns the compiled template function.
                     * @example
                     *
                     * // Use the "interpolate" delimiter to create a compiled template.
                     * var compiled = _.template('hello <%= user %>!');
                     * compiled({ 'user': 'fred' });
                     * // => 'hello fred!'
                     *
                     * // Use the HTML "escape" delimiter to escape data property values.
                     * var compiled = _.template('<b><%- value %></b>');
                     * compiled({ 'value': '<script>' });
                     * // => '<b>&lt;script&gt;</b>'
                     *
                     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
                     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
                     * compiled({ 'users': ['fred', 'barney'] });
                     * // => '<li>fred</li><li>barney</li>'
                     *
                     * // Use the internal `print` function in "evaluate" delimiters.
                     * var compiled = _.template('<% print("hello " + user); %>!');
                     * compiled({ 'user': 'barney' });
                     * // => 'hello barney!'
                     *
                     * // Use the ES template literal delimiter as an "interpolate" delimiter.
                     * // Disable support by replacing the "interpolate" delimiter.
                     * var compiled = _.template('hello ${ user }!');
                     * compiled({ 'user': 'pebbles' });
                     * // => 'hello pebbles!'
                     *
                     * // Use backslashes to treat delimiters as plain text.
                     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
                     * compiled({ 'value': 'ignored' });
                     * // => '<%- value %>'
                     *
                     * // Use the `imports` option to import `jQuery` as `jq`.
                     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
                     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
                     * compiled({ 'users': ['fred', 'barney'] });
                     * // => '<li>fred</li><li>barney</li>'
                     *
                     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
                     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
                     * compiled(data);
                     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
                     *
                     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
                     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
                     * compiled.source;
                     * // => function(data) {
                     * //   var __t, __p = '';
                     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
                     * //   return __p;
                     * // }
                     *
                     * // Use custom template delimiters.
                     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
                     * var compiled = _.template('hello {{ user }}!');
                     * compiled({ 'user': 'mustache' });
                     * // => 'hello mustache!'
                     *
                     * // Use the `source` property to inline compiled templates for meaningful
                     * // line numbers in error messages and stack traces.
                     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
                     *   var JST = {\
                     *     "main": ' + _.template(mainText).source + '\
                     *   };\
                     * ');
                     */
                    function template(string, options, guard) {
                      // Based on John Resig's `tmpl` implementation
                      // (http://ejohn.org/blog/javascript-micro-templating/)
                      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
                      var settings = lodash.templateSettings;

                      if (guard && isIterateeCall(string, options, guard)) {
                        options = undefined;
                      }
                      string = toString(string);
                      options = assignInWith({}, options, settings, customDefaultsAssignIn);

                      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
                        importsKeys = keys(imports),
                        importsValues = baseValues(imports, importsKeys);

                      var isEscaping,
                        isEvaluating,
                        index = 0,
                        interpolate = options.interpolate || reNoMatch,
                        source = "__p += '";

                      // Compile the regexp to match each delimiter.
                      var reDelimiters = RegExp(
                        (options.escape || reNoMatch).source +
                          '|' +
                          interpolate.source +
                          '|' +
                          (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source +
                          '|' +
                          (options.evaluate || reNoMatch).source +
                          '|$',
                        'g'
                      );

                      // Use a sourceURL for easier debugging.
                      var sourceURL =
                        '//# sourceURL=' +
                        ('sourceURL' in options
                          ? options.sourceURL
                          : 'lodash.templateSources[' + ++templateCounter + ']') +
                        '\n';

                      string.replace(
                        reDelimiters,
                        function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                          interpolateValue || (interpolateValue = esTemplateValue);

                          // Escape characters that can't be included in string literals.
                          source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

                          // Replace delimiters with snippets.
                          if (escapeValue) {
                            isEscaping = true;
                            source += "' +\n__e(" + escapeValue + ") +\n'";
                          }
                          if (evaluateValue) {
                            isEvaluating = true;
                            source += "';\n" + evaluateValue + ";\n__p += '";
                          }
                          if (interpolateValue) {
                            source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                          }
                          index = offset + match.length;

                          // The JS engine embedded in Adobe products needs `match` returned in
                          // order to produce the correct `offset` value.
                          return match;
                        }
                      );

                      source += "';\n";

                      // If `variable` is not specified wrap a with-statement around the generated
                      // code to add the data object to the top of the scope chain.
                      var variable = options.variable;
                      if (!variable) {
                        source = 'with (obj) {\n' + source + '\n}\n';
                      }
                      // Cleanup code by stripping empty strings.
                      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
                        .replace(reEmptyStringMiddle, '$1')
                        .replace(reEmptyStringTrailing, '$1;');

                      // Frame code as the function body.
                      source =
                        'function(' +
                        (variable || 'obj') +
                        ') {\n' +
                        (variable ? '' : 'obj || (obj = {});\n') +
                        "var __t, __p = ''" +
                        (isEscaping ? ', __e = _.escape' : '') +
                        (isEvaluating
                          ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n"
                          : ';\n') +
                        source +
                        'return __p\n}';

                      var result = attempt(function () {
                        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
                      });

                      // Provide the compiled function's source by its `toString` method or
                      // the `source` property as a convenience for inlining compiled templates.
                      result.source = source;
                      if (isError(result)) {
                        throw result;
                      }
                      return result;
                    }

                    /**
                     * Converts `string`, as a whole, to lower case just like
                     * [String#toLowerCase](https://mdn.io/toLowerCase).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category String
                     * @param {string} [string=''] The string to convert.
                     * @returns {string} Returns the lower cased string.
                     * @example
                     *
                     * _.toLower('--Foo-Bar--');
                     * // => '--foo-bar--'
                     *
                     * _.toLower('fooBar');
                     * // => 'foobar'
                     *
                     * _.toLower('__FOO_BAR__');
                     * // => '__foo_bar__'
                     */
                    function toLower(value) {
                      return toString(value).toLowerCase();
                    }

                    /**
                     * Converts `string`, as a whole, to upper case just like
                     * [String#toUpperCase](https://mdn.io/toUpperCase).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category String
                     * @param {string} [string=''] The string to convert.
                     * @returns {string} Returns the upper cased string.
                     * @example
                     *
                     * _.toUpper('--foo-bar--');
                     * // => '--FOO-BAR--'
                     *
                     * _.toUpper('fooBar');
                     * // => 'FOOBAR'
                     *
                     * _.toUpper('__foo_bar__');
                     * // => '__FOO_BAR__'
                     */
                    function toUpper(value) {
                      return toString(value).toUpperCase();
                    }

                    /**
                     * Removes leading and trailing whitespace or specified characters from `string`.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category String
                     * @param {string} [string=''] The string to trim.
                     * @param {string} [chars=whitespace] The characters to trim.
                     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                     * @returns {string} Returns the trimmed string.
                     * @example
                     *
                     * _.trim('  abc  ');
                     * // => 'abc'
                     *
                     * _.trim('-_-abc-_-', '_-');
                     * // => 'abc'
                     *
                     * _.map(['  foo  ', '  bar  '], _.trim);
                     * // => ['foo', 'bar']
                     */
                    function trim(string, chars, guard) {
                      string = toString(string);
                      if (string && (guard || chars === undefined)) {
                        return string.replace(reTrim, '');
                      }
                      if (!string || !(chars = baseToString(chars))) {
                        return string;
                      }
                      var strSymbols = stringToArray(string),
                        chrSymbols = stringToArray(chars),
                        start = charsStartIndex(strSymbols, chrSymbols),
                        end = charsEndIndex(strSymbols, chrSymbols) + 1;

                      return castSlice(strSymbols, start, end).join('');
                    }

                    /**
                     * Removes trailing whitespace or specified characters from `string`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category String
                     * @param {string} [string=''] The string to trim.
                     * @param {string} [chars=whitespace] The characters to trim.
                     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                     * @returns {string} Returns the trimmed string.
                     * @example
                     *
                     * _.trimEnd('  abc  ');
                     * // => '  abc'
                     *
                     * _.trimEnd('-_-abc-_-', '_-');
                     * // => '-_-abc'
                     */
                    function trimEnd(string, chars, guard) {
                      string = toString(string);
                      if (string && (guard || chars === undefined)) {
                        return string.replace(reTrimEnd, '');
                      }
                      if (!string || !(chars = baseToString(chars))) {
                        return string;
                      }
                      var strSymbols = stringToArray(string),
                        end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

                      return castSlice(strSymbols, 0, end).join('');
                    }

                    /**
                     * Removes leading whitespace or specified characters from `string`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category String
                     * @param {string} [string=''] The string to trim.
                     * @param {string} [chars=whitespace] The characters to trim.
                     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                     * @returns {string} Returns the trimmed string.
                     * @example
                     *
                     * _.trimStart('  abc  ');
                     * // => 'abc  '
                     *
                     * _.trimStart('-_-abc-_-', '_-');
                     * // => 'abc-_-'
                     */
                    function trimStart(string, chars, guard) {
                      string = toString(string);
                      if (string && (guard || chars === undefined)) {
                        return string.replace(reTrimStart, '');
                      }
                      if (!string || !(chars = baseToString(chars))) {
                        return string;
                      }
                      var strSymbols = stringToArray(string),
                        start = charsStartIndex(strSymbols, stringToArray(chars));

                      return castSlice(strSymbols, start).join('');
                    }

                    /**
                     * Truncates `string` if it's longer than the given maximum string length.
                     * The last characters of the truncated string are replaced with the omission
                     * string which defaults to "...".
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category String
                     * @param {string} [string=''] The string to truncate.
                     * @param {Object} [options={}] The options object.
                     * @param {number} [options.length=30] The maximum string length.
                     * @param {string} [options.omission='...'] The string to indicate text is omitted.
                     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
                     * @returns {string} Returns the truncated string.
                     * @example
                     *
                     * _.truncate('hi-diddly-ho there, neighborino');
                     * // => 'hi-diddly-ho there, neighbo...'
                     *
                     * _.truncate('hi-diddly-ho there, neighborino', {
                     *   'length': 24,
                     *   'separator': ' '
                     * });
                     * // => 'hi-diddly-ho there,...'
                     *
                     * _.truncate('hi-diddly-ho there, neighborino', {
                     *   'length': 24,
                     *   'separator': /,? +/
                     * });
                     * // => 'hi-diddly-ho there...'
                     *
                     * _.truncate('hi-diddly-ho there, neighborino', {
                     *   'omission': ' [...]'
                     * });
                     * // => 'hi-diddly-ho there, neig [...]'
                     */
                    function truncate(string, options) {
                      var length = DEFAULT_TRUNC_LENGTH,
                        omission = DEFAULT_TRUNC_OMISSION;

                      if (isObject(options)) {
                        var separator = 'separator' in options ? options.separator : separator;
                        length = 'length' in options ? toInteger(options.length) : length;
                        omission = 'omission' in options ? baseToString(options.omission) : omission;
                      }
                      string = toString(string);

                      var strLength = string.length;
                      if (hasUnicode(string)) {
                        var strSymbols = stringToArray(string);
                        strLength = strSymbols.length;
                      }
                      if (length >= strLength) {
                        return string;
                      }
                      var end = length - stringSize(omission);
                      if (end < 1) {
                        return omission;
                      }
                      var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);

                      if (separator === undefined) {
                        return result + omission;
                      }
                      if (strSymbols) {
                        end += result.length - end;
                      }
                      if (isRegExp(separator)) {
                        if (string.slice(end).search(separator)) {
                          var match,
                            substring = result;

                          if (!separator.global) {
                            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
                          }
                          separator.lastIndex = 0;
                          while ((match = separator.exec(substring))) {
                            var newEnd = match.index;
                          }
                          result = result.slice(0, newEnd === undefined ? end : newEnd);
                        }
                      } else if (string.indexOf(baseToString(separator), end) != end) {
                        var index = result.lastIndexOf(separator);
                        if (index > -1) {
                          result = result.slice(0, index);
                        }
                      }
                      return result + omission;
                    }

                    /**
                     * The inverse of `_.escape`; this method converts the HTML entities
                     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
                     * their corresponding characters.
                     *
                     * **Note:** No other HTML entities are unescaped. To unescape additional
                     * HTML entities use a third-party library like [_he_](https://mths.be/he).
                     *
                     * @static
                     * @memberOf _
                     * @since 0.6.0
                     * @category String
                     * @param {string} [string=''] The string to unescape.
                     * @returns {string} Returns the unescaped string.
                     * @example
                     *
                     * _.unescape('fred, barney, &amp; pebbles');
                     * // => 'fred, barney, & pebbles'
                     */
                    function unescape(string) {
                      string = toString(string);
                      return string && reHasEscapedHtml.test(string)
                        ? string.replace(reEscapedHtml, unescapeHtmlChar)
                        : string;
                    }

                    /**
                     * Converts `string`, as space separated words, to upper case.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category String
                     * @param {string} [string=''] The string to convert.
                     * @returns {string} Returns the upper cased string.
                     * @example
                     *
                     * _.upperCase('--foo-bar');
                     * // => 'FOO BAR'
                     *
                     * _.upperCase('fooBar');
                     * // => 'FOO BAR'
                     *
                     * _.upperCase('__foo_bar__');
                     * // => 'FOO BAR'
                     */
                    var upperCase = createCompounder(function (result, word, index) {
                      return result + (index ? ' ' : '') + word.toUpperCase();
                    });

                    /**
                     * Converts the first character of `string` to upper case.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category String
                     * @param {string} [string=''] The string to convert.
                     * @returns {string} Returns the converted string.
                     * @example
                     *
                     * _.upperFirst('fred');
                     * // => 'Fred'
                     *
                     * _.upperFirst('FRED');
                     * // => 'FRED'
                     */
                    var upperFirst = createCaseFirst('toUpperCase');

                    /**
                     * Splits `string` into an array of its words.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category String
                     * @param {string} [string=''] The string to inspect.
                     * @param {RegExp|string} [pattern] The pattern to match words.
                     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                     * @returns {Array} Returns the words of `string`.
                     * @example
                     *
                     * _.words('fred, barney, & pebbles');
                     * // => ['fred', 'barney', 'pebbles']
                     *
                     * _.words('fred, barney, & pebbles', /[^, ]+/g);
                     * // => ['fred', 'barney', '&', 'pebbles']
                     */
                    function words(string, pattern, guard) {
                      string = toString(string);
                      pattern = guard ? undefined : pattern;

                      if (pattern === undefined) {
                        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
                      }
                      return string.match(pattern) || [];
                    }

                    /*------------------------------------------------------------------------*/

                    /**
                     * Attempts to invoke `func`, returning either the result or the caught error
                     * object. Any additional arguments are provided to `func` when it's invoked.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Util
                     * @param {Function} func The function to attempt.
                     * @param {...*} [args] The arguments to invoke `func` with.
                     * @returns {*} Returns the `func` result or error object.
                     * @example
                     *
                     * // Avoid throwing errors for invalid selectors.
                     * var elements = _.attempt(function(selector) {
                     *   return document.querySelectorAll(selector);
                     * }, '>_>');
                     *
                     * if (_.isError(elements)) {
                     *   elements = [];
                     * }
                     */
                    var attempt = baseRest(function (func, args) {
                      try {
                        return apply(func, undefined, args);
                      } catch (e) {
                        return isError(e) ? e : new Error(e);
                      }
                    });

                    /**
                     * Binds methods of an object to the object itself, overwriting the existing
                     * method.
                     *
                     * **Note:** This method doesn't set the "length" property of bound functions.
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category Util
                     * @param {Object} object The object to bind and assign the bound methods to.
                     * @param {...(string|string[])} methodNames The object method names to bind.
                     * @returns {Object} Returns `object`.
                     * @example
                     *
                     * var view = {
                     *   'label': 'docs',
                     *   'click': function() {
                     *     console.log('clicked ' + this.label);
                     *   }
                     * };
                     *
                     * _.bindAll(view, ['click']);
                     * jQuery(element).on('click', view.click);
                     * // => Logs 'clicked docs' when clicked.
                     */
                    var bindAll = flatRest(function (object, methodNames) {
                      arrayEach(methodNames, function (key) {
                        key = toKey(key);
                        baseAssignValue(object, key, bind(object[key], object));
                      });
                      return object;
                    });

                    /**
                     * Creates a function that iterates over `pairs` and invokes the corresponding
                     * function of the first predicate to return truthy. The predicate-function
                     * pairs are invoked with the `this` binding and arguments of the created
                     * function.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Util
                     * @param {Array} pairs The predicate-function pairs.
                     * @returns {Function} Returns the new composite function.
                     * @example
                     *
                     * var func = _.cond([
                     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
                     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
                     *   [_.stubTrue,                      _.constant('no match')]
                     * ]);
                     *
                     * func({ 'a': 1, 'b': 2 });
                     * // => 'matches A'
                     *
                     * func({ 'a': 0, 'b': 1 });
                     * // => 'matches B'
                     *
                     * func({ 'a': '1', 'b': '2' });
                     * // => 'no match'
                     */
                    function cond(pairs) {
                      var length = pairs == null ? 0 : pairs.length,
                        toIteratee = getIteratee();

                      pairs = !length
                        ? []
                        : arrayMap(pairs, function (pair) {
                            if (typeof pair[1] != 'function') {
                              throw new TypeError(FUNC_ERROR_TEXT);
                            }
                            return [toIteratee(pair[0]), pair[1]];
                          });

                      return baseRest(function (args) {
                        var index = -1;
                        while (++index < length) {
                          var pair = pairs[index];
                          if (apply(pair[0], this, args)) {
                            return apply(pair[1], this, args);
                          }
                        }
                      });
                    }

                    /**
                     * Creates a function that invokes the predicate properties of `source` with
                     * the corresponding property values of a given object, returning `true` if
                     * all predicates return truthy, else `false`.
                     *
                     * **Note:** The created function is equivalent to `_.conformsTo` with
                     * `source` partially applied.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Util
                     * @param {Object} source The object of property predicates to conform to.
                     * @returns {Function} Returns the new spec function.
                     * @example
                     *
                     * var objects = [
                     *   { 'a': 2, 'b': 1 },
                     *   { 'a': 1, 'b': 2 }
                     * ];
                     *
                     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
                     * // => [{ 'a': 1, 'b': 2 }]
                     */
                    function conforms(source) {
                      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
                    }

                    /**
                     * Creates a function that returns `value`.
                     *
                     * @static
                     * @memberOf _
                     * @since 2.4.0
                     * @category Util
                     * @param {*} value The value to return from the new function.
                     * @returns {Function} Returns the new constant function.
                     * @example
                     *
                     * var objects = _.times(2, _.constant({ 'a': 1 }));
                     *
                     * console.log(objects);
                     * // => [{ 'a': 1 }, { 'a': 1 }]
                     *
                     * console.log(objects[0] === objects[1]);
                     * // => true
                     */
                    function constant(value) {
                      return function () {
                        return value;
                      };
                    }

                    /**
                     * Checks `value` to determine whether a default value should be returned in
                     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
                     * or `undefined`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.14.0
                     * @category Util
                     * @param {*} value The value to check.
                     * @param {*} defaultValue The default value.
                     * @returns {*} Returns the resolved value.
                     * @example
                     *
                     * _.defaultTo(1, 10);
                     * // => 1
                     *
                     * _.defaultTo(undefined, 10);
                     * // => 10
                     */
                    function defaultTo(value, defaultValue) {
                      return value == null || value !== value ? defaultValue : value;
                    }

                    /**
                     * Creates a function that returns the result of invoking the given functions
                     * with the `this` binding of the created function, where each successive
                     * invocation is supplied the return value of the previous.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Util
                     * @param {...(Function|Function[])} [funcs] The functions to invoke.
                     * @returns {Function} Returns the new composite function.
                     * @see _.flowRight
                     * @example
                     *
                     * function square(n) {
                     *   return n * n;
                     * }
                     *
                     * var addSquare = _.flow([_.add, square]);
                     * addSquare(1, 2);
                     * // => 9
                     */
                    var flow = createFlow();

                    /**
                     * This method is like `_.flow` except that it creates a function that
                     * invokes the given functions from right to left.
                     *
                     * @static
                     * @since 3.0.0
                     * @memberOf _
                     * @category Util
                     * @param {...(Function|Function[])} [funcs] The functions to invoke.
                     * @returns {Function} Returns the new composite function.
                     * @see _.flow
                     * @example
                     *
                     * function square(n) {
                     *   return n * n;
                     * }
                     *
                     * var addSquare = _.flowRight([square, _.add]);
                     * addSquare(1, 2);
                     * // => 9
                     */
                    var flowRight = createFlow(true);

                    /**
                     * This method returns the first argument it receives.
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category Util
                     * @param {*} value Any value.
                     * @returns {*} Returns `value`.
                     * @example
                     *
                     * var object = { 'a': 1 };
                     *
                     * console.log(_.identity(object) === object);
                     * // => true
                     */
                    function identity(value) {
                      return value;
                    }

                    /**
                     * Creates a function that invokes `func` with the arguments of the created
                     * function. If `func` is a property name, the created function returns the
                     * property value for a given element. If `func` is an array or object, the
                     * created function returns `true` for elements that contain the equivalent
                     * source properties, otherwise it returns `false`.
                     *
                     * @static
                     * @since 4.0.0
                     * @memberOf _
                     * @category Util
                     * @param {*} [func=_.identity] The value to convert to a callback.
                     * @returns {Function} Returns the callback.
                     * @example
                     *
                     * var users = [
                     *   { 'user': 'barney', 'age': 36, 'active': true },
                     *   { 'user': 'fred',   'age': 40, 'active': false }
                     * ];
                     *
                     * // The `_.matches` iteratee shorthand.
                     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
                     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
                     *
                     * // The `_.matchesProperty` iteratee shorthand.
                     * _.filter(users, _.iteratee(['user', 'fred']));
                     * // => [{ 'user': 'fred', 'age': 40 }]
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.map(users, _.iteratee('user'));
                     * // => ['barney', 'fred']
                     *
                     * // Create custom iteratee shorthands.
                     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
                     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
                     *     return func.test(string);
                     *   };
                     * });
                     *
                     * _.filter(['abc', 'def'], /ef/);
                     * // => ['def']
                     */
                    function iteratee(func) {
                      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
                    }

                    /**
                     * Creates a function that performs a partial deep comparison between a given
                     * object and `source`, returning `true` if the given object has equivalent
                     * property values, else `false`.
                     *
                     * **Note:** The created function is equivalent to `_.isMatch` with `source`
                     * partially applied.
                     *
                     * Partial comparisons will match empty array and empty object `source`
                     * values against any array or object value, respectively. See `_.isEqual`
                     * for a list of supported value comparisons.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Util
                     * @param {Object} source The object of property values to match.
                     * @returns {Function} Returns the new spec function.
                     * @example
                     *
                     * var objects = [
                     *   { 'a': 1, 'b': 2, 'c': 3 },
                     *   { 'a': 4, 'b': 5, 'c': 6 }
                     * ];
                     *
                     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
                     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
                     */
                    function matches(source) {
                      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
                    }

                    /**
                     * Creates a function that performs a partial deep comparison between the
                     * value at `path` of a given object to `srcValue`, returning `true` if the
                     * object value is equivalent, else `false`.
                     *
                     * **Note:** Partial comparisons will match empty array and empty object
                     * `srcValue` values against any array or object value, respectively. See
                     * `_.isEqual` for a list of supported value comparisons.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.2.0
                     * @category Util
                     * @param {Array|string} path The path of the property to get.
                     * @param {*} srcValue The value to match.
                     * @returns {Function} Returns the new spec function.
                     * @example
                     *
                     * var objects = [
                     *   { 'a': 1, 'b': 2, 'c': 3 },
                     *   { 'a': 4, 'b': 5, 'c': 6 }
                     * ];
                     *
                     * _.find(objects, _.matchesProperty('a', 4));
                     * // => { 'a': 4, 'b': 5, 'c': 6 }
                     */
                    function matchesProperty(path, srcValue) {
                      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
                    }

                    /**
                     * Creates a function that invokes the method at `path` of a given object.
                     * Any additional arguments are provided to the invoked method.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.7.0
                     * @category Util
                     * @param {Array|string} path The path of the method to invoke.
                     * @param {...*} [args] The arguments to invoke the method with.
                     * @returns {Function} Returns the new invoker function.
                     * @example
                     *
                     * var objects = [
                     *   { 'a': { 'b': _.constant(2) } },
                     *   { 'a': { 'b': _.constant(1) } }
                     * ];
                     *
                     * _.map(objects, _.method('a.b'));
                     * // => [2, 1]
                     *
                     * _.map(objects, _.method(['a', 'b']));
                     * // => [2, 1]
                     */
                    var method = baseRest(function (path, args) {
                      return function (object) {
                        return baseInvoke(object, path, args);
                      };
                    });

                    /**
                     * The opposite of `_.method`; this method creates a function that invokes
                     * the method at a given path of `object`. Any additional arguments are
                     * provided to the invoked method.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.7.0
                     * @category Util
                     * @param {Object} object The object to query.
                     * @param {...*} [args] The arguments to invoke the method with.
                     * @returns {Function} Returns the new invoker function.
                     * @example
                     *
                     * var array = _.times(3, _.constant),
                     *     object = { 'a': array, 'b': array, 'c': array };
                     *
                     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
                     * // => [2, 0]
                     *
                     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
                     * // => [2, 0]
                     */
                    var methodOf = baseRest(function (object, args) {
                      return function (path) {
                        return baseInvoke(object, path, args);
                      };
                    });

                    /**
                     * Adds all own enumerable string keyed function properties of a source
                     * object to the destination object. If `object` is a function, then methods
                     * are added to its prototype as well.
                     *
                     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
                     * avoid conflicts caused by modifying the original.
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category Util
                     * @param {Function|Object} [object=lodash] The destination object.
                     * @param {Object} source The object of functions to add.
                     * @param {Object} [options={}] The options object.
                     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
                     * @returns {Function|Object} Returns `object`.
                     * @example
                     *
                     * function vowels(string) {
                     *   return _.filter(string, function(v) {
                     *     return /[aeiou]/i.test(v);
                     *   });
                     * }
                     *
                     * _.mixin({ 'vowels': vowels });
                     * _.vowels('fred');
                     * // => ['e']
                     *
                     * _('fred').vowels().value();
                     * // => ['e']
                     *
                     * _.mixin({ 'vowels': vowels }, { 'chain': false });
                     * _('fred').vowels();
                     * // => ['e']
                     */
                    function mixin(object, source, options) {
                      var props = keys(source),
                        methodNames = baseFunctions(source, props);

                      if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                        options = source;
                        source = object;
                        object = this;
                        methodNames = baseFunctions(source, keys(source));
                      }
                      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
                        isFunc = isFunction(object);

                      arrayEach(methodNames, function (methodName) {
                        var func = source[methodName];
                        object[methodName] = func;
                        if (isFunc) {
                          object.prototype[methodName] = function () {
                            var chainAll = this.__chain__;
                            if (chain || chainAll) {
                              var result = object(this.__wrapped__),
                                actions = (result.__actions__ = copyArray(this.__actions__));

                              actions.push({ func: func, args: arguments, thisArg: object });
                              result.__chain__ = chainAll;
                              return result;
                            }
                            return func.apply(object, arrayPush([this.value()], arguments));
                          };
                        }
                      });

                      return object;
                    }

                    /**
                     * Reverts the `_` variable to its previous value and returns a reference to
                     * the `lodash` function.
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category Util
                     * @returns {Function} Returns the `lodash` function.
                     * @example
                     *
                     * var lodash = _.noConflict();
                     */
                    function noConflict() {
                      if (root._ === this) {
                        root._ = oldDash;
                      }
                      return this;
                    }

                    /**
                     * This method returns `undefined`.
                     *
                     * @static
                     * @memberOf _
                     * @since 2.3.0
                     * @category Util
                     * @example
                     *
                     * _.times(2, _.noop);
                     * // => [undefined, undefined]
                     */
                    function noop() {
                      // No operation performed.
                    }

                    /**
                     * Creates a function that gets the argument at index `n`. If `n` is negative,
                     * the nth argument from the end is returned.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Util
                     * @param {number} [n=0] The index of the argument to return.
                     * @returns {Function} Returns the new pass-thru function.
                     * @example
                     *
                     * var func = _.nthArg(1);
                     * func('a', 'b', 'c', 'd');
                     * // => 'b'
                     *
                     * var func = _.nthArg(-2);
                     * func('a', 'b', 'c', 'd');
                     * // => 'c'
                     */
                    function nthArg(n) {
                      n = toInteger(n);
                      return baseRest(function (args) {
                        return baseNth(args, n);
                      });
                    }

                    /**
                     * Creates a function that invokes `iteratees` with the arguments it receives
                     * and returns their results.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Util
                     * @param {...(Function|Function[])} [iteratees=[_.identity]]
                     *  The iteratees to invoke.
                     * @returns {Function} Returns the new function.
                     * @example
                     *
                     * var func = _.over([Math.max, Math.min]);
                     *
                     * func(1, 2, 3, 4);
                     * // => [4, 1]
                     */
                    var over = createOver(arrayMap);

                    /**
                     * Creates a function that checks if **all** of the `predicates` return
                     * truthy when invoked with the arguments it receives.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Util
                     * @param {...(Function|Function[])} [predicates=[_.identity]]
                     *  The predicates to check.
                     * @returns {Function} Returns the new function.
                     * @example
                     *
                     * var func = _.overEvery([Boolean, isFinite]);
                     *
                     * func('1');
                     * // => true
                     *
                     * func(null);
                     * // => false
                     *
                     * func(NaN);
                     * // => false
                     */
                    var overEvery = createOver(arrayEvery);

                    /**
                     * Creates a function that checks if **any** of the `predicates` return
                     * truthy when invoked with the arguments it receives.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Util
                     * @param {...(Function|Function[])} [predicates=[_.identity]]
                     *  The predicates to check.
                     * @returns {Function} Returns the new function.
                     * @example
                     *
                     * var func = _.overSome([Boolean, isFinite]);
                     *
                     * func('1');
                     * // => true
                     *
                     * func(null);
                     * // => true
                     *
                     * func(NaN);
                     * // => false
                     */
                    var overSome = createOver(arraySome);

                    /**
                     * Creates a function that returns the value at `path` of a given object.
                     *
                     * @static
                     * @memberOf _
                     * @since 2.4.0
                     * @category Util
                     * @param {Array|string} path The path of the property to get.
                     * @returns {Function} Returns the new accessor function.
                     * @example
                     *
                     * var objects = [
                     *   { 'a': { 'b': 2 } },
                     *   { 'a': { 'b': 1 } }
                     * ];
                     *
                     * _.map(objects, _.property('a.b'));
                     * // => [2, 1]
                     *
                     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
                     * // => [1, 2]
                     */
                    function property(path) {
                      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
                    }

                    /**
                     * The opposite of `_.property`; this method creates a function that returns
                     * the value at a given path of `object`.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.0.0
                     * @category Util
                     * @param {Object} object The object to query.
                     * @returns {Function} Returns the new accessor function.
                     * @example
                     *
                     * var array = [0, 1, 2],
                     *     object = { 'a': array, 'b': array, 'c': array };
                     *
                     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
                     * // => [2, 0]
                     *
                     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
                     * // => [2, 0]
                     */
                    function propertyOf(object) {
                      return function (path) {
                        return object == null ? undefined : baseGet(object, path);
                      };
                    }

                    /**
                     * Creates an array of numbers (positive and/or negative) progressing from
                     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
                     * `start` is specified without an `end` or `step`. If `end` is not specified,
                     * it's set to `start` with `start` then set to `0`.
                     *
                     * **Note:** JavaScript follows the IEEE-754 standard for resolving
                     * floating-point values which can produce unexpected results.
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category Util
                     * @param {number} [start=0] The start of the range.
                     * @param {number} end The end of the range.
                     * @param {number} [step=1] The value to increment or decrement by.
                     * @returns {Array} Returns the range of numbers.
                     * @see _.inRange, _.rangeRight
                     * @example
                     *
                     * _.range(4);
                     * // => [0, 1, 2, 3]
                     *
                     * _.range(-4);
                     * // => [0, -1, -2, -3]
                     *
                     * _.range(1, 5);
                     * // => [1, 2, 3, 4]
                     *
                     * _.range(0, 20, 5);
                     * // => [0, 5, 10, 15]
                     *
                     * _.range(0, -4, -1);
                     * // => [0, -1, -2, -3]
                     *
                     * _.range(1, 4, 0);
                     * // => [1, 1, 1]
                     *
                     * _.range(0);
                     * // => []
                     */
                    var range = createRange();

                    /**
                     * This method is like `_.range` except that it populates values in
                     * descending order.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Util
                     * @param {number} [start=0] The start of the range.
                     * @param {number} end The end of the range.
                     * @param {number} [step=1] The value to increment or decrement by.
                     * @returns {Array} Returns the range of numbers.
                     * @see _.inRange, _.range
                     * @example
                     *
                     * _.rangeRight(4);
                     * // => [3, 2, 1, 0]
                     *
                     * _.rangeRight(-4);
                     * // => [-3, -2, -1, 0]
                     *
                     * _.rangeRight(1, 5);
                     * // => [4, 3, 2, 1]
                     *
                     * _.rangeRight(0, 20, 5);
                     * // => [15, 10, 5, 0]
                     *
                     * _.rangeRight(0, -4, -1);
                     * // => [-3, -2, -1, 0]
                     *
                     * _.rangeRight(1, 4, 0);
                     * // => [1, 1, 1]
                     *
                     * _.rangeRight(0);
                     * // => []
                     */
                    var rangeRight = createRange(true);

                    /**
                     * This method returns a new empty array.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.13.0
                     * @category Util
                     * @returns {Array} Returns the new empty array.
                     * @example
                     *
                     * var arrays = _.times(2, _.stubArray);
                     *
                     * console.log(arrays);
                     * // => [[], []]
                     *
                     * console.log(arrays[0] === arrays[1]);
                     * // => false
                     */
                    function stubArray() {
                      return [];
                    }

                    /**
                     * This method returns `false`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.13.0
                     * @category Util
                     * @returns {boolean} Returns `false`.
                     * @example
                     *
                     * _.times(2, _.stubFalse);
                     * // => [false, false]
                     */
                    function stubFalse() {
                      return false;
                    }

                    /**
                     * This method returns a new empty object.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.13.0
                     * @category Util
                     * @returns {Object} Returns the new empty object.
                     * @example
                     *
                     * var objects = _.times(2, _.stubObject);
                     *
                     * console.log(objects);
                     * // => [{}, {}]
                     *
                     * console.log(objects[0] === objects[1]);
                     * // => false
                     */
                    function stubObject() {
                      return {};
                    }

                    /**
                     * This method returns an empty string.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.13.0
                     * @category Util
                     * @returns {string} Returns the empty string.
                     * @example
                     *
                     * _.times(2, _.stubString);
                     * // => ['', '']
                     */
                    function stubString() {
                      return '';
                    }

                    /**
                     * This method returns `true`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.13.0
                     * @category Util
                     * @returns {boolean} Returns `true`.
                     * @example
                     *
                     * _.times(2, _.stubTrue);
                     * // => [true, true]
                     */
                    function stubTrue() {
                      return true;
                    }

                    /**
                     * Invokes the iteratee `n` times, returning an array of the results of
                     * each invocation. The iteratee is invoked with one argument; (index).
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category Util
                     * @param {number} n The number of times to invoke `iteratee`.
                     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                     * @returns {Array} Returns the array of results.
                     * @example
                     *
                     * _.times(3, String);
                     * // => ['0', '1', '2']
                     *
                     *  _.times(4, _.constant(0));
                     * // => [0, 0, 0, 0]
                     */
                    function times(n, iteratee) {
                      n = toInteger(n);
                      if (n < 1 || n > MAX_SAFE_INTEGER) {
                        return [];
                      }
                      var index = MAX_ARRAY_LENGTH,
                        length = nativeMin(n, MAX_ARRAY_LENGTH);

                      iteratee = getIteratee(iteratee);
                      n -= MAX_ARRAY_LENGTH;

                      var result = baseTimes(length, iteratee);
                      while (++index < n) {
                        iteratee(index);
                      }
                      return result;
                    }

                    /**
                     * Converts `value` to a property path array.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Util
                     * @param {*} value The value to convert.
                     * @returns {Array} Returns the new property path array.
                     * @example
                     *
                     * _.toPath('a.b.c');
                     * // => ['a', 'b', 'c']
                     *
                     * _.toPath('a[0].b.c');
                     * // => ['a', '0', 'b', 'c']
                     */
                    function toPath(value) {
                      if (isArray(value)) {
                        return arrayMap(value, toKey);
                      }
                      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
                    }

                    /**
                     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category Util
                     * @param {string} [prefix=''] The value to prefix the ID with.
                     * @returns {string} Returns the unique ID.
                     * @example
                     *
                     * _.uniqueId('contact_');
                     * // => 'contact_104'
                     *
                     * _.uniqueId();
                     * // => '105'
                     */
                    function uniqueId(prefix) {
                      var id = ++idCounter;
                      return toString(prefix) + id;
                    }

                    /*------------------------------------------------------------------------*/

                    /**
                     * Adds two numbers.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.4.0
                     * @category Math
                     * @param {number} augend The first number in an addition.
                     * @param {number} addend The second number in an addition.
                     * @returns {number} Returns the total.
                     * @example
                     *
                     * _.add(6, 4);
                     * // => 10
                     */
                    var add = createMathOperation(function (augend, addend) {
                      return augend + addend;
                    }, 0);

                    /**
                     * Computes `number` rounded up to `precision`.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.10.0
                     * @category Math
                     * @param {number} number The number to round up.
                     * @param {number} [precision=0] The precision to round up to.
                     * @returns {number} Returns the rounded up number.
                     * @example
                     *
                     * _.ceil(4.006);
                     * // => 5
                     *
                     * _.ceil(6.004, 2);
                     * // => 6.01
                     *
                     * _.ceil(6040, -2);
                     * // => 6100
                     */
                    var ceil = createRound('ceil');

                    /**
                     * Divide two numbers.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.7.0
                     * @category Math
                     * @param {number} dividend The first number in a division.
                     * @param {number} divisor The second number in a division.
                     * @returns {number} Returns the quotient.
                     * @example
                     *
                     * _.divide(6, 4);
                     * // => 1.5
                     */
                    var divide = createMathOperation(function (dividend, divisor) {
                      return dividend / divisor;
                    }, 1);

                    /**
                     * Computes `number` rounded down to `precision`.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.10.0
                     * @category Math
                     * @param {number} number The number to round down.
                     * @param {number} [precision=0] The precision to round down to.
                     * @returns {number} Returns the rounded down number.
                     * @example
                     *
                     * _.floor(4.006);
                     * // => 4
                     *
                     * _.floor(0.046, 2);
                     * // => 0.04
                     *
                     * _.floor(4060, -2);
                     * // => 4000
                     */
                    var floor = createRound('floor');

                    /**
                     * Computes the maximum value of `array`. If `array` is empty or falsey,
                     * `undefined` is returned.
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category Math
                     * @param {Array} array The array to iterate over.
                     * @returns {*} Returns the maximum value.
                     * @example
                     *
                     * _.max([4, 2, 8, 6]);
                     * // => 8
                     *
                     * _.max([]);
                     * // => undefined
                     */
                    function max(array) {
                      return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
                    }

                    /**
                     * This method is like `_.max` except that it accepts `iteratee` which is
                     * invoked for each element in `array` to generate the criterion by which
                     * the value is ranked. The iteratee is invoked with one argument: (value).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Math
                     * @param {Array} array The array to iterate over.
                     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                     * @returns {*} Returns the maximum value.
                     * @example
                     *
                     * var objects = [{ 'n': 1 }, { 'n': 2 }];
                     *
                     * _.maxBy(objects, function(o) { return o.n; });
                     * // => { 'n': 2 }
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.maxBy(objects, 'n');
                     * // => { 'n': 2 }
                     */
                    function maxBy(array, iteratee) {
                      return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
                    }

                    /**
                     * Computes the mean of the values in `array`.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Math
                     * @param {Array} array The array to iterate over.
                     * @returns {number} Returns the mean.
                     * @example
                     *
                     * _.mean([4, 2, 8, 6]);
                     * // => 5
                     */
                    function mean(array) {
                      return baseMean(array, identity);
                    }

                    /**
                     * This method is like `_.mean` except that it accepts `iteratee` which is
                     * invoked for each element in `array` to generate the value to be averaged.
                     * The iteratee is invoked with one argument: (value).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.7.0
                     * @category Math
                     * @param {Array} array The array to iterate over.
                     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                     * @returns {number} Returns the mean.
                     * @example
                     *
                     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
                     *
                     * _.meanBy(objects, function(o) { return o.n; });
                     * // => 5
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.meanBy(objects, 'n');
                     * // => 5
                     */
                    function meanBy(array, iteratee) {
                      return baseMean(array, getIteratee(iteratee, 2));
                    }

                    /**
                     * Computes the minimum value of `array`. If `array` is empty or falsey,
                     * `undefined` is returned.
                     *
                     * @static
                     * @since 0.1.0
                     * @memberOf _
                     * @category Math
                     * @param {Array} array The array to iterate over.
                     * @returns {*} Returns the minimum value.
                     * @example
                     *
                     * _.min([4, 2, 8, 6]);
                     * // => 2
                     *
                     * _.min([]);
                     * // => undefined
                     */
                    function min(array) {
                      return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
                    }

                    /**
                     * This method is like `_.min` except that it accepts `iteratee` which is
                     * invoked for each element in `array` to generate the criterion by which
                     * the value is ranked. The iteratee is invoked with one argument: (value).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Math
                     * @param {Array} array The array to iterate over.
                     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                     * @returns {*} Returns the minimum value.
                     * @example
                     *
                     * var objects = [{ 'n': 1 }, { 'n': 2 }];
                     *
                     * _.minBy(objects, function(o) { return o.n; });
                     * // => { 'n': 1 }
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.minBy(objects, 'n');
                     * // => { 'n': 1 }
                     */
                    function minBy(array, iteratee) {
                      return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
                    }

                    /**
                     * Multiply two numbers.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.7.0
                     * @category Math
                     * @param {number} multiplier The first number in a multiplication.
                     * @param {number} multiplicand The second number in a multiplication.
                     * @returns {number} Returns the product.
                     * @example
                     *
                     * _.multiply(6, 4);
                     * // => 24
                     */
                    var multiply = createMathOperation(function (multiplier, multiplicand) {
                      return multiplier * multiplicand;
                    }, 1);

                    /**
                     * Computes `number` rounded to `precision`.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.10.0
                     * @category Math
                     * @param {number} number The number to round.
                     * @param {number} [precision=0] The precision to round to.
                     * @returns {number} Returns the rounded number.
                     * @example
                     *
                     * _.round(4.006);
                     * // => 4
                     *
                     * _.round(4.006, 2);
                     * // => 4.01
                     *
                     * _.round(4060, -2);
                     * // => 4100
                     */
                    var round = createRound('round');

                    /**
                     * Subtract two numbers.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Math
                     * @param {number} minuend The first number in a subtraction.
                     * @param {number} subtrahend The second number in a subtraction.
                     * @returns {number} Returns the difference.
                     * @example
                     *
                     * _.subtract(6, 4);
                     * // => 2
                     */
                    var subtract = createMathOperation(function (minuend, subtrahend) {
                      return minuend - subtrahend;
                    }, 0);

                    /**
                     * Computes the sum of the values in `array`.
                     *
                     * @static
                     * @memberOf _
                     * @since 3.4.0
                     * @category Math
                     * @param {Array} array The array to iterate over.
                     * @returns {number} Returns the sum.
                     * @example
                     *
                     * _.sum([4, 2, 8, 6]);
                     * // => 20
                     */
                    function sum(array) {
                      return array && array.length ? baseSum(array, identity) : 0;
                    }

                    /**
                     * This method is like `_.sum` except that it accepts `iteratee` which is
                     * invoked for each element in `array` to generate the value to be summed.
                     * The iteratee is invoked with one argument: (value).
                     *
                     * @static
                     * @memberOf _
                     * @since 4.0.0
                     * @category Math
                     * @param {Array} array The array to iterate over.
                     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                     * @returns {number} Returns the sum.
                     * @example
                     *
                     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
                     *
                     * _.sumBy(objects, function(o) { return o.n; });
                     * // => 20
                     *
                     * // The `_.property` iteratee shorthand.
                     * _.sumBy(objects, 'n');
                     * // => 20
                     */
                    function sumBy(array, iteratee) {
                      return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
                    }

                    /*------------------------------------------------------------------------*/

                    // Add methods that return wrapped values in chain sequences.
                    lodash.after = after;
                    lodash.ary = ary;
                    lodash.assign = assign;
                    lodash.assignIn = assignIn;
                    lodash.assignInWith = assignInWith;
                    lodash.assignWith = assignWith;
                    lodash.at = at;
                    lodash.before = before;
                    lodash.bind = bind;
                    lodash.bindAll = bindAll;
                    lodash.bindKey = bindKey;
                    lodash.castArray = castArray;
                    lodash.chain = chain;
                    lodash.chunk = chunk;
                    lodash.compact = compact;
                    lodash.concat = concat;
                    lodash.cond = cond;
                    lodash.conforms = conforms;
                    lodash.constant = constant;
                    lodash.countBy = countBy;
                    lodash.create = create;
                    lodash.curry = curry;
                    lodash.curryRight = curryRight;
                    lodash.debounce = debounce;
                    lodash.defaults = defaults;
                    lodash.defaultsDeep = defaultsDeep;
                    lodash.defer = defer;
                    lodash.delay = delay;
                    lodash.difference = difference;
                    lodash.differenceBy = differenceBy;
                    lodash.differenceWith = differenceWith;
                    lodash.drop = drop;
                    lodash.dropRight = dropRight;
                    lodash.dropRightWhile = dropRightWhile;
                    lodash.dropWhile = dropWhile;
                    lodash.fill = fill;
                    lodash.filter = filter;
                    lodash.flatMap = flatMap;
                    lodash.flatMapDeep = flatMapDeep;
                    lodash.flatMapDepth = flatMapDepth;
                    lodash.flatten = flatten;
                    lodash.flattenDeep = flattenDeep;
                    lodash.flattenDepth = flattenDepth;
                    lodash.flip = flip;
                    lodash.flow = flow;
                    lodash.flowRight = flowRight;
                    lodash.fromPairs = fromPairs;
                    lodash.functions = functions;
                    lodash.functionsIn = functionsIn;
                    lodash.groupBy = groupBy;
                    lodash.initial = initial;
                    lodash.intersection = intersection;
                    lodash.intersectionBy = intersectionBy;
                    lodash.intersectionWith = intersectionWith;
                    lodash.invert = invert;
                    lodash.invertBy = invertBy;
                    lodash.invokeMap = invokeMap;
                    lodash.iteratee = iteratee;
                    lodash.keyBy = keyBy;
                    lodash.keys = keys;
                    lodash.keysIn = keysIn;
                    lodash.map = map;
                    lodash.mapKeys = mapKeys;
                    lodash.mapValues = mapValues;
                    lodash.matches = matches;
                    lodash.matchesProperty = matchesProperty;
                    lodash.memoize = memoize;
                    lodash.merge = merge;
                    lodash.mergeWith = mergeWith;
                    lodash.method = method;
                    lodash.methodOf = methodOf;
                    lodash.mixin = mixin;
                    lodash.negate = negate;
                    lodash.nthArg = nthArg;
                    lodash.omit = omit;
                    lodash.omitBy = omitBy;
                    lodash.once = once;
                    lodash.orderBy = orderBy;
                    lodash.over = over;
                    lodash.overArgs = overArgs;
                    lodash.overEvery = overEvery;
                    lodash.overSome = overSome;
                    lodash.partial = partial;
                    lodash.partialRight = partialRight;
                    lodash.partition = partition;
                    lodash.pick = pick;
                    lodash.pickBy = pickBy;
                    lodash.property = property;
                    lodash.propertyOf = propertyOf;
                    lodash.pull = pull;
                    lodash.pullAll = pullAll;
                    lodash.pullAllBy = pullAllBy;
                    lodash.pullAllWith = pullAllWith;
                    lodash.pullAt = pullAt;
                    lodash.range = range;
                    lodash.rangeRight = rangeRight;
                    lodash.rearg = rearg;
                    lodash.reject = reject;
                    lodash.remove = remove;
                    lodash.rest = rest;
                    lodash.reverse = reverse;
                    lodash.sampleSize = sampleSize;
                    lodash.set = set;
                    lodash.setWith = setWith;
                    lodash.shuffle = shuffle;
                    lodash.slice = slice;
                    lodash.sortBy = sortBy;
                    lodash.sortedUniq = sortedUniq;
                    lodash.sortedUniqBy = sortedUniqBy;
                    lodash.split = split;
                    lodash.spread = spread;
                    lodash.tail = tail;
                    lodash.take = take;
                    lodash.takeRight = takeRight;
                    lodash.takeRightWhile = takeRightWhile;
                    lodash.takeWhile = takeWhile;
                    lodash.tap = tap;
                    lodash.throttle = throttle;
                    lodash.thru = thru;
                    lodash.toArray = toArray;
                    lodash.toPairs = toPairs;
                    lodash.toPairsIn = toPairsIn;
                    lodash.toPath = toPath;
                    lodash.toPlainObject = toPlainObject;
                    lodash.transform = transform;
                    lodash.unary = unary;
                    lodash.union = union;
                    lodash.unionBy = unionBy;
                    lodash.unionWith = unionWith;
                    lodash.uniq = uniq;
                    lodash.uniqBy = uniqBy;
                    lodash.uniqWith = uniqWith;
                    lodash.unset = unset;
                    lodash.unzip = unzip;
                    lodash.unzipWith = unzipWith;
                    lodash.update = update;
                    lodash.updateWith = updateWith;
                    lodash.values = values;
                    lodash.valuesIn = valuesIn;
                    lodash.without = without;
                    lodash.words = words;
                    lodash.wrap = wrap;
                    lodash.xor = xor;
                    lodash.xorBy = xorBy;
                    lodash.xorWith = xorWith;
                    lodash.zip = zip;
                    lodash.zipObject = zipObject;
                    lodash.zipObjectDeep = zipObjectDeep;
                    lodash.zipWith = zipWith;

                    // Add aliases.
                    lodash.entries = toPairs;
                    lodash.entriesIn = toPairsIn;
                    lodash.extend = assignIn;
                    lodash.extendWith = assignInWith;

                    // Add methods to `lodash.prototype`.
                    mixin(lodash, lodash);

                    /*------------------------------------------------------------------------*/

                    // Add methods that return unwrapped values in chain sequences.
                    lodash.add = add;
                    lodash.attempt = attempt;
                    lodash.camelCase = camelCase;
                    lodash.capitalize = capitalize;
                    lodash.ceil = ceil;
                    lodash.clamp = clamp;
                    lodash.clone = clone;
                    lodash.cloneDeep = cloneDeep;
                    lodash.cloneDeepWith = cloneDeepWith;
                    lodash.cloneWith = cloneWith;
                    lodash.conformsTo = conformsTo;
                    lodash.deburr = deburr;
                    lodash.defaultTo = defaultTo;
                    lodash.divide = divide;
                    lodash.endsWith = endsWith;
                    lodash.eq = eq;
                    lodash.escape = escape;
                    lodash.escapeRegExp = escapeRegExp;
                    lodash.every = every;
                    lodash.find = find;
                    lodash.findIndex = findIndex;
                    lodash.findKey = findKey;
                    lodash.findLast = findLast;
                    lodash.findLastIndex = findLastIndex;
                    lodash.findLastKey = findLastKey;
                    lodash.floor = floor;
                    lodash.forEach = forEach;
                    lodash.forEachRight = forEachRight;
                    lodash.forIn = forIn;
                    lodash.forInRight = forInRight;
                    lodash.forOwn = forOwn;
                    lodash.forOwnRight = forOwnRight;
                    lodash.get = get;
                    lodash.gt = gt;
                    lodash.gte = gte;
                    lodash.has = has;
                    lodash.hasIn = hasIn;
                    lodash.head = head;
                    lodash.identity = identity;
                    lodash.includes = includes;
                    lodash.indexOf = indexOf;
                    lodash.inRange = inRange;
                    lodash.invoke = invoke;
                    lodash.isArguments = isArguments;
                    lodash.isArray = isArray;
                    lodash.isArrayBuffer = isArrayBuffer;
                    lodash.isArrayLike = isArrayLike;
                    lodash.isArrayLikeObject = isArrayLikeObject;
                    lodash.isBoolean = isBoolean;
                    lodash.isBuffer = isBuffer;
                    lodash.isDate = isDate;
                    lodash.isElement = isElement;
                    lodash.isEmpty = isEmpty;
                    lodash.isEqual = isEqual;
                    lodash.isEqualWith = isEqualWith;
                    lodash.isError = isError;
                    lodash.isFinite = isFinite;
                    lodash.isFunction = isFunction;
                    lodash.isInteger = isInteger;
                    lodash.isLength = isLength;
                    lodash.isMap = isMap;
                    lodash.isMatch = isMatch;
                    lodash.isMatchWith = isMatchWith;
                    lodash.isNaN = isNaN;
                    lodash.isNative = isNative;
                    lodash.isNil = isNil;
                    lodash.isNull = isNull;
                    lodash.isNumber = isNumber;
                    lodash.isObject = isObject;
                    lodash.isObjectLike = isObjectLike;
                    lodash.isPlainObject = isPlainObject;
                    lodash.isRegExp = isRegExp;
                    lodash.isSafeInteger = isSafeInteger;
                    lodash.isSet = isSet;
                    lodash.isString = isString;
                    lodash.isSymbol = isSymbol;
                    lodash.isTypedArray = isTypedArray;
                    lodash.isUndefined = isUndefined;
                    lodash.isWeakMap = isWeakMap;
                    lodash.isWeakSet = isWeakSet;
                    lodash.join = join;
                    lodash.kebabCase = kebabCase;
                    lodash.last = last;
                    lodash.lastIndexOf = lastIndexOf;
                    lodash.lowerCase = lowerCase;
                    lodash.lowerFirst = lowerFirst;
                    lodash.lt = lt;
                    lodash.lte = lte;
                    lodash.max = max;
                    lodash.maxBy = maxBy;
                    lodash.mean = mean;
                    lodash.meanBy = meanBy;
                    lodash.min = min;
                    lodash.minBy = minBy;
                    lodash.stubArray = stubArray;
                    lodash.stubFalse = stubFalse;
                    lodash.stubObject = stubObject;
                    lodash.stubString = stubString;
                    lodash.stubTrue = stubTrue;
                    lodash.multiply = multiply;
                    lodash.nth = nth;
                    lodash.noConflict = noConflict;
                    lodash.noop = noop;
                    lodash.now = now;
                    lodash.pad = pad;
                    lodash.padEnd = padEnd;
                    lodash.padStart = padStart;
                    lodash.parseInt = parseInt;
                    lodash.random = random;
                    lodash.reduce = reduce;
                    lodash.reduceRight = reduceRight;
                    lodash.repeat = repeat;
                    lodash.replace = replace;
                    lodash.result = result;
                    lodash.round = round;
                    lodash.runInContext = runInContext;
                    lodash.sample = sample;
                    lodash.size = size;
                    lodash.snakeCase = snakeCase;
                    lodash.some = some;
                    lodash.sortedIndex = sortedIndex;
                    lodash.sortedIndexBy = sortedIndexBy;
                    lodash.sortedIndexOf = sortedIndexOf;
                    lodash.sortedLastIndex = sortedLastIndex;
                    lodash.sortedLastIndexBy = sortedLastIndexBy;
                    lodash.sortedLastIndexOf = sortedLastIndexOf;
                    lodash.startCase = startCase;
                    lodash.startsWith = startsWith;
                    lodash.subtract = subtract;
                    lodash.sum = sum;
                    lodash.sumBy = sumBy;
                    lodash.template = template;
                    lodash.times = times;
                    lodash.toFinite = toFinite;
                    lodash.toInteger = toInteger;
                    lodash.toLength = toLength;
                    lodash.toLower = toLower;
                    lodash.toNumber = toNumber;
                    lodash.toSafeInteger = toSafeInteger;
                    lodash.toString = toString;
                    lodash.toUpper = toUpper;
                    lodash.trim = trim;
                    lodash.trimEnd = trimEnd;
                    lodash.trimStart = trimStart;
                    lodash.truncate = truncate;
                    lodash.unescape = unescape;
                    lodash.uniqueId = uniqueId;
                    lodash.upperCase = upperCase;
                    lodash.upperFirst = upperFirst;

                    // Add aliases.
                    lodash.each = forEach;
                    lodash.eachRight = forEachRight;
                    lodash.first = head;

                    mixin(
                      lodash,
                      (function () {
                        var source = {};
                        baseForOwn(lodash, function (func, methodName) {
                          if (!hasOwnProperty.call(lodash.prototype, methodName)) {
                            source[methodName] = func;
                          }
                        });
                        return source;
                      })(),
                      { chain: false }
                    );

                    /*------------------------------------------------------------------------*/

                    /**
                     * The semantic version number.
                     *
                     * @static
                     * @memberOf _
                     * @type {string}
                     */
                    lodash.VERSION = VERSION;

                    // Assign default placeholders.
                    arrayEach(
                      ['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'],
                      function (methodName) {
                        lodash[methodName].placeholder = lodash;
                      }
                    );

                    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
                    arrayEach(['drop', 'take'], function (methodName, index) {
                      LazyWrapper.prototype[methodName] = function (n) {
                        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

                        var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();

                        if (result.__filtered__) {
                          result.__takeCount__ = nativeMin(n, result.__takeCount__);
                        } else {
                          result.__views__.push({
                            size: nativeMin(n, MAX_ARRAY_LENGTH),
                            type: methodName + (result.__dir__ < 0 ? 'Right' : '')
                          });
                        }
                        return result;
                      };

                      LazyWrapper.prototype[methodName + 'Right'] = function (n) {
                        return this.reverse()[methodName](n).reverse();
                      };
                    });

                    // Add `LazyWrapper` methods that accept an `iteratee` value.
                    arrayEach(['filter', 'map', 'takeWhile'], function (methodName, index) {
                      var type = index + 1,
                        isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

                      LazyWrapper.prototype[methodName] = function (iteratee) {
                        var result = this.clone();
                        result.__iteratees__.push({
                          iteratee: getIteratee(iteratee, 3),
                          type: type
                        });
                        result.__filtered__ = result.__filtered__ || isFilter;
                        return result;
                      };
                    });

                    // Add `LazyWrapper` methods for `_.head` and `_.last`.
                    arrayEach(['head', 'last'], function (methodName, index) {
                      var takeName = 'take' + (index ? 'Right' : '');

                      LazyWrapper.prototype[methodName] = function () {
                        return this[takeName](1).value()[0];
                      };
                    });

                    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
                    arrayEach(['initial', 'tail'], function (methodName, index) {
                      var dropName = 'drop' + (index ? '' : 'Right');

                      LazyWrapper.prototype[methodName] = function () {
                        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
                      };
                    });

                    LazyWrapper.prototype.compact = function () {
                      return this.filter(identity);
                    };

                    LazyWrapper.prototype.find = function (predicate) {
                      return this.filter(predicate).head();
                    };

                    LazyWrapper.prototype.findLast = function (predicate) {
                      return this.reverse().find(predicate);
                    };

                    LazyWrapper.prototype.invokeMap = baseRest(function (path, args) {
                      if (typeof path == 'function') {
                        return new LazyWrapper(this);
                      }
                      return this.map(function (value) {
                        return baseInvoke(value, path, args);
                      });
                    });

                    LazyWrapper.prototype.reject = function (predicate) {
                      return this.filter(negate(getIteratee(predicate)));
                    };

                    LazyWrapper.prototype.slice = function (start, end) {
                      start = toInteger(start);

                      var result = this;
                      if (result.__filtered__ && (start > 0 || end < 0)) {
                        return new LazyWrapper(result);
                      }
                      if (start < 0) {
                        result = result.takeRight(-start);
                      } else if (start) {
                        result = result.drop(start);
                      }
                      if (end !== undefined) {
                        end = toInteger(end);
                        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
                      }
                      return result;
                    };

                    LazyWrapper.prototype.takeRightWhile = function (predicate) {
                      return this.reverse().takeWhile(predicate).reverse();
                    };

                    LazyWrapper.prototype.toArray = function () {
                      return this.take(MAX_ARRAY_LENGTH);
                    };

                    // Add `LazyWrapper` methods to `lodash.prototype`.
                    baseForOwn(LazyWrapper.prototype, function (func, methodName) {
                      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
                        isTaker = /^(?:head|last)$/.test(methodName),
                        lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName],
                        retUnwrapped = isTaker || /^find/.test(methodName);

                      if (!lodashFunc) {
                        return;
                      }
                      lodash.prototype[methodName] = function () {
                        var value = this.__wrapped__,
                          args = isTaker ? [1] : arguments,
                          isLazy = value instanceof LazyWrapper,
                          iteratee = args[0],
                          useLazy = isLazy || isArray(value);

                        var interceptor = function (value) {
                          var result = lodashFunc.apply(lodash, arrayPush([value], args));
                          return isTaker && chainAll ? result[0] : result;
                        };

                        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
                          // Avoid lazy use if the iteratee has a "length" value other than `1`.
                          isLazy = useLazy = false;
                        }
                        var chainAll = this.__chain__,
                          isHybrid = !!this.__actions__.length,
                          isUnwrapped = retUnwrapped && !chainAll,
                          onlyLazy = isLazy && !isHybrid;

                        if (!retUnwrapped && useLazy) {
                          value = onlyLazy ? value : new LazyWrapper(this);
                          var result = func.apply(value, args);
                          result.__actions__.push({ func: thru, args: [interceptor], thisArg: undefined });
                          return new LodashWrapper(result, chainAll);
                        }
                        if (isUnwrapped && onlyLazy) {
                          return func.apply(this, args);
                        }
                        result = this.thru(interceptor);
                        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
                      };
                    });

                    // Add `Array` methods to `lodash.prototype`.
                    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function (methodName) {
                      var func = arrayProto[methodName],
                        chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
                        retUnwrapped = /^(?:pop|shift)$/.test(methodName);

                      lodash.prototype[methodName] = function () {
                        var args = arguments;
                        if (retUnwrapped && !this.__chain__) {
                          var value = this.value();
                          return func.apply(isArray(value) ? value : [], args);
                        }
                        return this[chainName](function (value) {
                          return func.apply(isArray(value) ? value : [], args);
                        });
                      };
                    });

                    // Map minified method names to their real names.
                    baseForOwn(LazyWrapper.prototype, function (func, methodName) {
                      var lodashFunc = lodash[methodName];
                      if (lodashFunc) {
                        var key = lodashFunc.name + '',
                          names = realNames[key] || (realNames[key] = []);

                        names.push({ name: methodName, func: lodashFunc });
                      }
                    });

                    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
                      {
                        name: 'wrapper',
                        func: undefined
                      }
                    ];

                    // Add methods to `LazyWrapper`.
                    LazyWrapper.prototype.clone = lazyClone;
                    LazyWrapper.prototype.reverse = lazyReverse;
                    LazyWrapper.prototype.value = lazyValue;

                    // Add chain sequence methods to the `lodash` wrapper.
                    lodash.prototype.at = wrapperAt;
                    lodash.prototype.chain = wrapperChain;
                    lodash.prototype.commit = wrapperCommit;
                    lodash.prototype.next = wrapperNext;
                    lodash.prototype.plant = wrapperPlant;
                    lodash.prototype.reverse = wrapperReverse;
                    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

                    // Add lazy aliases.
                    lodash.prototype.first = lodash.prototype.head;

                    if (symIterator) {
                      lodash.prototype[symIterator] = wrapperToIterator;
                    }
                    return lodash;
                  };

                  /*--------------------------------------------------------------------------*/

                  // Export lodash.
                  var _ = runInContext();

                  // Some AMD build optimizers, like r.js, check for condition patterns like:
                  if (true) {
                    // Expose Lodash on the global object to prevent errors when Lodash is
                    // loaded by a script tag in the presence of an AMD loader.
                    // See http://requirejs.org/docs/errors.html#mismatch for more details.
                    // Use `_.noConflict` to remove Lodash from the global object.
                    root._ = _;

                    // Define as an anonymous module so, through path mapping, it can be
                    // referenced as the "underscore" module.
                    !((__WEBPACK_AMD_DEFINE_RESULT__ = function () {
                      return _;
                    }.call(exports, __webpack_require__, exports, module)),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
                  }
                  // Check for `exports` after `define` in case a build optimizer adds it.
                  else if (freeModule) {
                    // Export for Node.js.
                    (freeModule.exports = _)._ = _;
                    // Export for CommonJS support.
                    freeExports._ = _;
                  } else {
                    // Export to the global object.
                    root._ = _;
                  }
                }).call(this);

                /* WEBPACK VAR INJECTION */
              }).call(exports, __webpack_require__(89), __webpack_require__(54)(module));

              /***/
            },
            /* 89 */
            /***/ function (module, exports) {
              var g;

              // This works in non-strict mode
              g = (function () {
                return this;
              })();

              try {
                // This works if eval is allowed (see CSP)
                g = g || Function('return this')() || (1, eval)('this');
              } catch (e) {
                // This works if the window reference is available
                if (typeof window === 'object') g = window;
              }

              // g can still be undefined, but nothing to do about it...
              // We return undefined, instead of nothing here, so it's
              // easier to handle this case. if(!global) { ...}

              module.exports = g;

              /***/
            },
            /* 90 */
            /***/ function (module, exports, __webpack_require__) {
              module.exports = __webpack_require__(168);

              /***/
            },
            /* 91 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              module.exports = function bind(fn, thisArg) {
                return function wrap() {
                  var args = new Array(arguments.length);
                  for (var i = 0; i < args.length; i++) {
                    args[i] = arguments[i];
                  }
                  return fn.apply(thisArg, args);
                };
              };

              /***/
            },
            /* 92 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';
              /* WEBPACK VAR INJECTION */ (function (process) {
                var utils = __webpack_require__(5);
                var settle = __webpack_require__(172);
                var buildURL = __webpack_require__(174);
                var parseHeaders = __webpack_require__(175);
                var isURLSameOrigin = __webpack_require__(176);
                var createError = __webpack_require__(93);
                var btoa =
                  (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) ||
                  __webpack_require__(177);

                module.exports = function xhrAdapter(config) {
                  return new Promise(function dispatchXhrRequest(resolve, reject) {
                    var requestData = config.data;
                    var requestHeaders = config.headers;

                    if (utils.isFormData(requestData)) {
                      delete requestHeaders['Content-Type']; // Let the browser set it
                    }

                    var request = new XMLHttpRequest();
                    var loadEvent = 'onreadystatechange';
                    var xDomain = false;

                    // For IE 8/9 CORS support
                    // Only supports POST and GET calls and doesn't returns the response headers.
                    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
                    if (
                      process.env.NODE_ENV !== 'test' &&
                      typeof window !== 'undefined' &&
                      window.XDomainRequest &&
                      !('withCredentials' in request) &&
                      !isURLSameOrigin(config.url)
                    ) {
                      request = new window.XDomainRequest();
                      loadEvent = 'onload';
                      xDomain = true;
                      request.onprogress = function handleProgress() {};
                      request.ontimeout = function handleTimeout() {};
                    }

                    // HTTP basic authentication
                    if (config.auth) {
                      var username = config.auth.username || '';
                      var password = config.auth.password || '';
                      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
                    }

                    request.open(
                      config.method.toUpperCase(),
                      buildURL(config.url, config.params, config.paramsSerializer),
                      true
                    );

                    // Set the request timeout in MS
                    request.timeout = config.timeout;

                    // Listen for ready state
                    request[loadEvent] = function handleLoad() {
                      if (!request || (request.readyState !== 4 && !xDomain)) {
                        return;
                      }

                      // The request errored out and we didn't get a response, this will be
                      // handled by onerror instead
                      // With one exception: request that using file: protocol, most browsers
                      // will return status as 0 even though it's a successful request
                      if (
                        request.status === 0 &&
                        !(request.responseURL && request.responseURL.indexOf('file:') === 0)
                      ) {
                        return;
                      }

                      // Prepare the response
                      var responseHeaders =
                        'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
                      var responseData =
                        !config.responseType || config.responseType === 'text'
                          ? request.responseText
                          : request.response;
                      var response = {
                        data: responseData,
                        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
                        status: request.status === 1223 ? 204 : request.status,
                        statusText: request.status === 1223 ? 'No Content' : request.statusText,
                        headers: responseHeaders,
                        config: config,
                        request: request
                      };

                      settle(resolve, reject, response);

                      // Clean up request
                      request = null;
                    };

                    // Handle low level network errors
                    request.onerror = function handleError() {
                      // Real errors are hidden from us by the browser
                      // onerror should only fire if it's a network error
                      reject(createError('Network Error', config, null, request));

                      // Clean up request
                      request = null;
                    };

                    // Handle timeout
                    request.ontimeout = function handleTimeout() {
                      reject(
                        createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED', request)
                      );

                      // Clean up request
                      request = null;
                    };

                    // Add xsrf header
                    // This is only done if running in a standard browser environment.
                    // Specifically not if we're in a web worker, or react-native.
                    if (utils.isStandardBrowserEnv()) {
                      var cookies = __webpack_require__(178);

                      // Add xsrf header
                      var xsrfValue =
                        (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName
                          ? cookies.read(config.xsrfCookieName)
                          : undefined;

                      if (xsrfValue) {
                        requestHeaders[config.xsrfHeaderName] = xsrfValue;
                      }
                    }

                    // Add headers to the request
                    if ('setRequestHeader' in request) {
                      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
                        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
                          // Remove Content-Type if data is undefined
                          delete requestHeaders[key];
                        } else {
                          // Otherwise add header to the request
                          request.setRequestHeader(key, val);
                        }
                      });
                    }

                    // Add withCredentials to request if needed
                    if (config.withCredentials) {
                      request.withCredentials = true;
                    }

                    // Add responseType to request if needed
                    if (config.responseType) {
                      try {
                        request.responseType = config.responseType;
                      } catch (e) {
                        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
                        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
                        if (config.responseType !== 'json') {
                          throw e;
                        }
                      }
                    }

                    // Handle progress if needed
                    if (typeof config.onDownloadProgress === 'function') {
                      request.addEventListener('progress', config.onDownloadProgress);
                    }

                    // Not all browsers support upload events
                    if (typeof config.onUploadProgress === 'function' && request.upload) {
                      request.upload.addEventListener('progress', config.onUploadProgress);
                    }

                    if (config.cancelToken) {
                      // Handle cancellation
                      config.cancelToken.promise.then(function onCanceled(cancel) {
                        if (!request) {
                          return;
                        }

                        request.abort();
                        reject(cancel);
                        // Clean up request
                        request = null;
                      });
                    }

                    if (requestData === undefined) {
                      requestData = null;
                    }

                    // Send the request
                    request.send(requestData);
                  });
                };

                /* WEBPACK VAR INJECTION */
              }).call(exports, __webpack_require__(36));

              /***/
            },
            /* 93 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              var enhanceError = __webpack_require__(173);

              /**
               * Create an Error with the specified message, config, error code, request and response.
               *
               * @param {string} message The error message.
               * @param {Object} config The config.
               * @param {string} [code] The error code (for example, 'ECONNABORTED').
               * @param {Object} [request] The request.
               * @param {Object} [response] The response.
               * @returns {Error} The created error.
               */
              module.exports = function createError(message, config, code, request, response) {
                var error = new Error(message);
                return enhanceError(error, config, code, request, response);
              };

              /***/
            },
            /* 94 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              module.exports = function isCancel(value) {
                return !!(value && value.__CANCEL__);
              };

              /***/
            },
            /* 95 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              /**
               * A `Cancel` is an object that is thrown when an operation is canceled.
               *
               * @class
               * @param {string=} message The message.
               */
              function Cancel(message) {
                this.message = message;
              }

              Cancel.prototype.toString = function toString() {
                return 'Cancel' + (this.message ? ': ' + this.message : '');
              };

              Cancel.prototype.__CANCEL__ = true;

              module.exports = Cancel;

              /***/
            },
            /* 96 */
            /***/ function (module, exports, __webpack_require__) {
              var defineProperty = __webpack_require__(97);

              /**
               * The base implementation of `assignValue` and `assignMergeValue` without
               * value checks.
               *
               * @private
               * @param {Object} object The object to modify.
               * @param {string} key The key of the property to assign.
               * @param {*} value The value to assign.
               */
              function baseAssignValue(object, key, value) {
                if (key == '__proto__' && defineProperty) {
                  defineProperty(object, key, {
                    configurable: true,
                    enumerable: true,
                    value: value,
                    writable: true
                  });
                } else {
                  object[key] = value;
                }
              }

              module.exports = baseAssignValue;

              /***/
            },
            /* 97 */
            /***/ function (module, exports, __webpack_require__) {
              var getNative = __webpack_require__(194);

              var defineProperty = (function () {
                try {
                  var func = getNative(Object, 'defineProperty');
                  func({}, '', {});
                  return func;
                } catch (e) {}
              })();

              module.exports = defineProperty;

              /***/
            },
            /* 98 */
            /***/ function (module, exports, __webpack_require__) {
              var root = __webpack_require__(59);

              /** Built-in value references. */
              var Symbol = root.Symbol;

              module.exports = Symbol;

              /***/
            },
            /* 99 */
            /***/ function (module, exports, __webpack_require__) {
              /* WEBPACK VAR INJECTION */ (function (global) {
                /** Detect free variable `global` from Node.js. */
                var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

                module.exports = freeGlobal;

                /* WEBPACK VAR INJECTION */
              }).call(exports, __webpack_require__(89));

              /***/
            },
            /* 100 */
            /***/ function (module, exports) {
              /**
               * Performs a
               * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
               * comparison between two values to determine if they are equivalent.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {*} value The value to compare.
               * @param {*} other The other value to compare.
               * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
               * @example
               *
               * var object = { 'a': 1 };
               * var other = { 'a': 1 };
               *
               * _.eq(object, object);
               * // => true
               *
               * _.eq(object, other);
               * // => false
               *
               * _.eq('a', 'a');
               * // => true
               *
               * _.eq('a', Object('a'));
               * // => false
               *
               * _.eq(NaN, NaN);
               * // => true
               */
              function eq(value, other) {
                return value === other || (value !== value && other !== other);
              }

              module.exports = eq;

              /***/
            },
            /* 101 */
            /***/ function (module, exports) {
              /**
               * This method returns the first argument it receives.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Util
               * @param {*} value Any value.
               * @returns {*} Returns `value`.
               * @example
               *
               * var object = { 'a': 1 };
               *
               * console.log(_.identity(object) === object);
               * // => true
               */
              function identity(value) {
                return value;
              }

              module.exports = identity;

              /***/
            },
            /* 102 */
            /***/ function (module, exports, __webpack_require__) {
              var isFunction = __webpack_require__(58),
                isLength = __webpack_require__(103);

              /**
               * Checks if `value` is array-like. A value is considered array-like if it's
               * not a function and has a `value.length` that's an integer greater than or
               * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
               * @example
               *
               * _.isArrayLike([1, 2, 3]);
               * // => true
               *
               * _.isArrayLike(document.body.children);
               * // => true
               *
               * _.isArrayLike('abc');
               * // => true
               *
               * _.isArrayLike(_.noop);
               * // => false
               */
              function isArrayLike(value) {
                return value != null && isLength(value.length) && !isFunction(value);
              }

              module.exports = isArrayLike;

              /***/
            },
            /* 103 */
            /***/ function (module, exports) {
              /** Used as references for various `Number` constants. */
              var MAX_SAFE_INTEGER = 9007199254740991;

              /**
               * Checks if `value` is a valid array-like length.
               *
               * **Note:** This method is loosely based on
               * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
               * @example
               *
               * _.isLength(3);
               * // => true
               *
               * _.isLength(Number.MIN_VALUE);
               * // => false
               *
               * _.isLength(Infinity);
               * // => false
               *
               * _.isLength('3');
               * // => false
               */
              function isLength(value) {
                return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
              }

              module.exports = isLength;

              /***/
            },
            /* 104 */
            /***/ function (module, exports) {
              /** Used as references for various `Number` constants. */
              var MAX_SAFE_INTEGER = 9007199254740991;

              /** Used to detect unsigned integer values. */
              var reIsUint = /^(?:0|[1-9]\d*)$/;

              /**
               * Checks if `value` is a valid array-like index.
               *
               * @private
               * @param {*} value The value to check.
               * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
               * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
               */
              function isIndex(value, length) {
                length = length == null ? MAX_SAFE_INTEGER : length;
                return (
                  !!length &&
                  (typeof value == 'number' || reIsUint.test(value)) &&
                  value > -1 &&
                  value % 1 == 0 &&
                  value < length
                );
              }

              module.exports = isIndex;

              /***/
            },
            /* 105 */
            /***/ function (module, exports) {
              /**
               * Checks if `value` is classified as an `Array` object.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is an array, else `false`.
               * @example
               *
               * _.isArray([1, 2, 3]);
               * // => true
               *
               * _.isArray(document.body.children);
               * // => false
               *
               * _.isArray('abc');
               * // => false
               *
               * _.isArray(_.noop);
               * // => false
               */
              var isArray = Array.isArray;

              module.exports = isArray;

              /***/
            },
            /* 106 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ =
                __webpack_require__(53);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_money__ = __webpack_require__(57);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_money___default = __webpack_require__.n(
                __WEBPACK_IMPORTED_MODULE_2_js_money__
              );

              /** Config*/

              var Config =
                /**
                 * Construct a new config.
                 * @param {Object}	options - Properties to initialze on config.
                 */
                function Config(options) {
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Config);

                  options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(
                    {},
                    {
                      defaultCurrency: 'USD',
                      useGeoForCurrency: true,
                      moneySpanSelectors: ['[data-money]'],
                      moneySpanParser: function moneySpanParser(el, easyCurrency) {
                        var amount = el.dataset.money;
                        var currency = el.dataset.moneyCurrency || easyCurrency.getState().currency;
                        delete el.dataset.money;
                        delete el.dataset.moneyCurrency;
                        amount = Number(amount);
                        return new __WEBPACK_IMPORTED_MODULE_2_js_money___default.a(amount, currency);
                      }
                    },
                    options
                  );

                  /** @type {String} Currency code, used for initial currency. */
                  this.defaultCurrency = options.defaultCurrency;
                  /** @type {Boolean} If true, currency will be determined via geoservice on load. */
                  this.useGeoForCurrency = options.useGeoForCurrency;
                  /** @type {String[]} Array of CSS selectors for finding money spans */
                  this.moneySpanSelectors = options.moneySpanSelectors;
                  /** @type {function(el: DOMNode, easyCurrency: src/easycurrency/main.js~EasyCurrency): js-money} Callback which determines initial money span value. */
                  this.moneySpanParser = options.moneySpanParser;
                };

              /** @ignore */

              /* harmony default export */ __webpack_exports__['a'] = new Config();

              /***/
            },
            /* 107 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ =
                __webpack_require__(19);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ =
                __webpack_require__(20);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ =
                __webpack_require__(1);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);

              /**
               * Provides information about available currencies.
               * This is an abstract class which resolvers should extend from.
               * @public
               */
              var CurrencyResolver = (function () {
                function CurrencyResolver() {
                  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CurrencyResolver);
                }

                __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CurrencyResolver, [
                  {
                    key: 'listCurrencyCodes',

                    /**
                     * List the available currencies.
                     * @return {String[]}
                     * @throws {Error} - CurrencyResolver should implement listCurrencyCodes
                     */
                    value: (function () {
                      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(
                        /*#__PURE__*/ __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(
                          function _callee() {
                            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(
                              function _callee$(_context) {
                                while (1) {
                                  switch ((_context.prev = _context.next)) {
                                    case 0:
                                      throw Error('CurrencyResolver should implement listCurrencyCodes');

                                    case 1:
                                    case 'end':
                                      return _context.stop();
                                  }
                                }
                              },
                              _callee,
                              this
                            );
                          }
                        )
                      );

                      function listCurrencyCodes() {
                        return _ref.apply(this, arguments);
                      }

                      return listCurrencyCodes;
                    })()

                    /**
                     * Get conversion rate for a specific currency pair.
                     * @param {String}	from
                     * @param {String}	to
                     * @return {Number}
                     * @throws {Error} - CurrencyResolver should implement getConversionRate
                     */
                  },
                  {
                    key: 'getConversionRate',
                    value: (function () {
                      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(
                        /*#__PURE__*/ __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(
                          function _callee2(from, to) {
                            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(
                              function _callee2$(_context2) {
                                while (1) {
                                  switch ((_context2.prev = _context2.next)) {
                                    case 0:
                                      throw Error('CurrencyResolver should implement getConversionRate');

                                    case 1:
                                    case 'end':
                                      return _context2.stop();
                                  }
                                }
                              },
                              _callee2,
                              this
                            );
                          }
                        )
                      );

                      function getConversionRate(_x, _x2) {
                        return _ref2.apply(this, arguments);
                      }

                      return getConversionRate;
                    })()
                  }
                ]);

                return CurrencyResolver;
              })();

              /* harmony default export */ __webpack_exports__['a'] = CurrencyResolver;

              /***/
            },
            /* 108 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ =
                __webpack_require__(1);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);

              /**
               * Formats currencies.
               * This is an abstract class which formatters should extend from.
               * @public
               */
              var Formatter = (function () {
                function Formatter() {
                  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Formatter);
                }

                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Formatter, [
                  {
                    key: 'format',

                    /**
                     * Format a currency.
                     * @param {type}	amount - Amount in cents.
                     * @param {type}	currency - Currency code to convert to.
                     * @return {String}
                     */
                    value: function format(amount, currency) {
                      throw Error('Formatter should implement format');
                    }
                  }
                ]);

                return Formatter;
              })();

              /* harmony default export */ __webpack_exports__['a'] = Formatter;

              /***/
            },
            /* 109 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              Object.defineProperty(exports, '__esModule', {
                value: true
              });

              var _createClass = (function () {
                function defineProperties(target, props) {
                  for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ('value' in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                  }
                }
                return function (Constructor, protoProps, staticProps) {
                  if (protoProps) defineProperties(Constructor.prototype, protoProps);
                  if (staticProps) defineProperties(Constructor, staticProps);
                  return Constructor;
                };
              })();

              exports.hasCookies = hasCookies;

              var _cookie = __webpack_require__(247);

              var _cookie2 = _interopRequireDefault(_cookie);

              function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : { default: obj };
              }

              function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                  throw new TypeError('Cannot call a class as a function');
                }
              }

              var prefix = 'lS_';

              var CookieStorage = (function () {
                function CookieStorage() {
                  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                  _classCallCheck(this, CookieStorage);

                  this.cookieOptions = Object.assign({ path: '/' }, options);
                  prefix = options.prefix || prefix;
                }

                _createClass(CookieStorage, [
                  {
                    key: 'getItem',
                    value: function getItem(key) {
                      var cookies = _cookie2.default.parse(document.cookie);
                      if (!cookies || !cookies.hasOwnProperty(prefix + key)) {
                        return null;
                      }
                      return cookies[prefix + key];
                    }
                  },
                  {
                    key: 'setItem',
                    value: function setItem(key, value) {
                      document.cookie = _cookie2.default.serialize(prefix + key, value, this.cookieOptions);
                      return value;
                    }
                  },
                  {
                    key: 'removeItem',
                    value: function removeItem(key) {
                      var options = Object.assign({}, this.cookieOptions, { maxAge: -1 });
                      document.cookie = _cookie2.default.serialize(prefix + key, '', options);
                      return null;
                    }
                  },
                  {
                    key: 'clear',
                    value: function clear() {
                      var cookies = _cookie2.default.parse(document.cookie);
                      for (var key in cookies) {
                        if (key.indexOf(prefix) === 0) {
                          this.removeItem(key.substr(prefix.length));
                        }
                      }

                      return null;
                    }
                  }
                ]);

                return CookieStorage;
              })();

              exports.default = CookieStorage;
              function hasCookies() {
                var storage = new CookieStorage();

                try {
                  var TEST_KEY = '__test';
                  storage.setItem(TEST_KEY, '1');
                  var value = storage.getItem(TEST_KEY);
                  storage.removeItem(TEST_KEY);

                  return value === '1';
                } catch (e) {
                  return false;
                }
              }

              /***/
            },
            /* 110 */
            /***/ function (module, exports, __webpack_require__) {
              module.exports = { default: __webpack_require__(111), __esModule: true };

              /***/
            },
            /* 111 */
            /***/ function (module, exports, __webpack_require__) {
              __webpack_require__(112);
              var $Object = __webpack_require__(2).Object;
              module.exports = function defineProperty(it, key, desc) {
                return $Object.defineProperty(it, key, desc);
              };

              /***/
            },
            /* 112 */
            /***/ function (module, exports, __webpack_require__) {
              var $export = __webpack_require__(6);
              // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
              $export($export.S + $export.F * !__webpack_require__(9), 'Object', {
                defineProperty: __webpack_require__(8).f
              });

              /***/
            },
            /* 113 */
            /***/ function (module, exports, __webpack_require__) {
              __webpack_require__(41);
              __webpack_require__(48);
              module.exports = __webpack_require__(122);

              /***/
            },
            /* 114 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              var addToUnscopables = __webpack_require__(115);
              var step = __webpack_require__(116);
              var Iterators = __webpack_require__(24);
              var toIObject = __webpack_require__(12);

              // 22.1.3.4 Array.prototype.entries()
              // 22.1.3.13 Array.prototype.keys()
              // 22.1.3.29 Array.prototype.values()
              // 22.1.3.30 Array.prototype[@@iterator]()
              module.exports = __webpack_require__(65)(
                Array,
                'Array',
                function (iterated, kind) {
                  this._t = toIObject(iterated); // target
                  this._i = 0; // next index
                  this._k = kind; // kind
                  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
                },
                function () {
                  var O = this._t;
                  var kind = this._k;
                  var index = this._i++;
                  if (!O || index >= O.length) {
                    this._t = undefined;
                    return step(1);
                  }
                  if (kind == 'keys') return step(0, index);
                  if (kind == 'values') return step(0, O[index]);
                  return step(0, [index, O[index]]);
                },
                'values'
              );

              // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
              Iterators.Arguments = Iterators.Array;

              addToUnscopables('keys');
              addToUnscopables('values');
              addToUnscopables('entries');

              /***/
            },
            /* 115 */
            /***/ function (module, exports) {
              module.exports = function () {
                /* empty */
              };

              /***/
            },
            /* 116 */
            /***/ function (module, exports) {
              module.exports = function (done, value) {
                return { value: value, done: !!done };
              };

              /***/
            },
            /* 117 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              var create = __webpack_require__(43);
              var descriptor = __webpack_require__(30);
              var setToStringTag = __webpack_require__(33);
              var IteratorPrototype = {};

              // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
              __webpack_require__(10)(IteratorPrototype, __webpack_require__(4)('iterator'), function () {
                return this;
              });

              module.exports = function (Constructor, NAME, next) {
                Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
                setToStringTag(Constructor, NAME + ' Iterator');
              };

              /***/
            },
            /* 118 */
            /***/ function (module, exports, __webpack_require__) {
              var dP = __webpack_require__(8);
              var anObject = __webpack_require__(7);
              var getKeys = __webpack_require__(18);

              module.exports = __webpack_require__(9)
                ? Object.defineProperties
                : function defineProperties(O, Properties) {
                    anObject(O);
                    var keys = getKeys(Properties);
                    var length = keys.length;
                    var i = 0;
                    var P;
                    while (length > i) dP.f(O, (P = keys[i++]), Properties[P]);
                    return O;
                  };

              /***/
            },
            /* 119 */
            /***/ function (module, exports, __webpack_require__) {
              // false -> Array#indexOf
              // true  -> Array#includes
              var toIObject = __webpack_require__(12);
              var toLength = __webpack_require__(68);
              var toAbsoluteIndex = __webpack_require__(120);
              module.exports = function (IS_INCLUDES) {
                return function ($this, el, fromIndex) {
                  var O = toIObject($this);
                  var length = toLength(O.length);
                  var index = toAbsoluteIndex(fromIndex, length);
                  var value;
                  // Array#includes uses SameValueZero equality algorithm
                  // eslint-disable-next-line no-self-compare
                  if (IS_INCLUDES && el != el)
                    while (length > index) {
                      value = O[index++];
                      // eslint-disable-next-line no-self-compare
                      if (value != value) return true;
                      // Array#indexOf ignores holes, Array#includes - not
                    }
                  else
                    for (; length > index; index++)
                      if (IS_INCLUDES || index in O) {
                        if (O[index] === el) return IS_INCLUDES || index || 0;
                      }
                  return !IS_INCLUDES && -1;
                };
              };

              /***/
            },
            /* 120 */
            /***/ function (module, exports, __webpack_require__) {
              var toInteger = __webpack_require__(44);
              var max = Math.max;
              var min = Math.min;
              module.exports = function (index, length) {
                index = toInteger(index);
                return index < 0 ? max(index + length, 0) : min(index, length);
              };

              /***/
            },
            /* 121 */
            /***/ function (module, exports, __webpack_require__) {
              var toInteger = __webpack_require__(44);
              var defined = __webpack_require__(42);
              // true  -> String#at
              // false -> String#codePointAt
              module.exports = function (TO_STRING) {
                return function (that, pos) {
                  var s = String(defined(that));
                  var i = toInteger(pos);
                  var l = s.length;
                  var a, b;
                  if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
                  a = s.charCodeAt(i);
                  return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
                    ? TO_STRING
                      ? s.charAt(i)
                      : a
                    : TO_STRING
                      ? s.slice(i, i + 2)
                      : ((a - 0xd800) << 10) + (b - 0xdc00) + 0x10000;
                };
              };

              /***/
            },
            /* 122 */
            /***/ function (module, exports, __webpack_require__) {
              var anObject = __webpack_require__(7);
              var get = __webpack_require__(71);
              module.exports = __webpack_require__(2).getIterator = function (it) {
                var iterFn = get(it);
                if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
                return anObject(iterFn.call(it));
              };

              /***/
            },
            /* 123 */
            /***/ function (module, exports, __webpack_require__) {
              __webpack_require__(124);
              module.exports = __webpack_require__(2).Object.getPrototypeOf;

              /***/
            },
            /* 124 */
            /***/ function (module, exports, __webpack_require__) {
              // 19.1.2.9 Object.getPrototypeOf(O)
              var toObject = __webpack_require__(34);
              var $getPrototypeOf = __webpack_require__(70);

              __webpack_require__(76)('getPrototypeOf', function () {
                return function getPrototypeOf(it) {
                  return $getPrototypeOf(toObject(it));
                };
              });

              /***/
            },
            /* 125 */
            /***/ function (module, exports, __webpack_require__) {
              module.exports = { default: __webpack_require__(126), __esModule: true };

              /***/
            },
            /* 126 */
            /***/ function (module, exports, __webpack_require__) {
              __webpack_require__(48);
              __webpack_require__(41);
              module.exports = __webpack_require__(49).f('iterator');

              /***/
            },
            /* 127 */
            /***/ function (module, exports, __webpack_require__) {
              module.exports = { default: __webpack_require__(128), __esModule: true };

              /***/
            },
            /* 128 */
            /***/ function (module, exports, __webpack_require__) {
              __webpack_require__(129);
              __webpack_require__(80);
              __webpack_require__(134);
              __webpack_require__(135);
              module.exports = __webpack_require__(2).Symbol;

              /***/
            },
            /* 129 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              // ECMAScript 6 symbols shim
              var global = __webpack_require__(3);
              var has = __webpack_require__(13);
              var DESCRIPTORS = __webpack_require__(9);
              var $export = __webpack_require__(6);
              var redefine = __webpack_require__(66);
              var META = __webpack_require__(130).KEY;
              var $fails = __webpack_require__(17);
              var shared = __webpack_require__(46);
              var setToStringTag = __webpack_require__(33);
              var uid = __webpack_require__(32);
              var wks = __webpack_require__(4);
              var wksExt = __webpack_require__(49);
              var wksDefine = __webpack_require__(50);
              var enumKeys = __webpack_require__(131);
              var isArray = __webpack_require__(132);
              var anObject = __webpack_require__(7);
              var toIObject = __webpack_require__(12);
              var toPrimitive = __webpack_require__(39);
              var createDesc = __webpack_require__(30);
              var _create = __webpack_require__(43);
              var gOPNExt = __webpack_require__(133);
              var $GOPD = __webpack_require__(79);
              var $DP = __webpack_require__(8);
              var $keys = __webpack_require__(18);
              var gOPD = $GOPD.f;
              var dP = $DP.f;
              var gOPN = gOPNExt.f;
              var $Symbol = global.Symbol;
              var $JSON = global.JSON;
              var _stringify = $JSON && $JSON.stringify;
              var PROTOTYPE = 'prototype';
              var HIDDEN = wks('_hidden');
              var TO_PRIMITIVE = wks('toPrimitive');
              var isEnum = {}.propertyIsEnumerable;
              var SymbolRegistry = shared('symbol-registry');
              var AllSymbols = shared('symbols');
              var OPSymbols = shared('op-symbols');
              var ObjectProto = Object[PROTOTYPE];
              var USE_NATIVE = typeof $Symbol == 'function';
              var QObject = global.QObject;
              // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
              var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

              // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
              var setSymbolDesc =
                DESCRIPTORS &&
                $fails(function () {
                  return (
                    _create(
                      dP({}, 'a', {
                        get: function () {
                          return dP(this, 'a', { value: 7 }).a;
                        }
                      })
                    ).a != 7
                  );
                })
                  ? function (it, key, D) {
                      var protoDesc = gOPD(ObjectProto, key);
                      if (protoDesc) delete ObjectProto[key];
                      dP(it, key, D);
                      if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
                    }
                  : dP;

              var wrap = function (tag) {
                var sym = (AllSymbols[tag] = _create($Symbol[PROTOTYPE]));
                sym._k = tag;
                return sym;
              };

              var isSymbol =
                USE_NATIVE && typeof $Symbol.iterator == 'symbol'
                  ? function (it) {
                      return typeof it == 'symbol';
                    }
                  : function (it) {
                      return it instanceof $Symbol;
                    };

              var $defineProperty = function defineProperty(it, key, D) {
                if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
                anObject(it);
                key = toPrimitive(key, true);
                anObject(D);
                if (has(AllSymbols, key)) {
                  if (!D.enumerable) {
                    if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
                    it[HIDDEN][key] = true;
                  } else {
                    if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
                    D = _create(D, { enumerable: createDesc(0, false) });
                  }
                  return setSymbolDesc(it, key, D);
                }
                return dP(it, key, D);
              };
              var $defineProperties = function defineProperties(it, P) {
                anObject(it);
                var keys = enumKeys((P = toIObject(P)));
                var i = 0;
                var l = keys.length;
                var key;
                while (l > i) $defineProperty(it, (key = keys[i++]), P[key]);
                return it;
              };
              var $create = function create(it, P) {
                return P === undefined ? _create(it) : $defineProperties(_create(it), P);
              };
              var $propertyIsEnumerable = function propertyIsEnumerable(key) {
                var E = isEnum.call(this, (key = toPrimitive(key, true)));
                if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
                return E || !has(this, key) || !has(AllSymbols, key) || (has(this, HIDDEN) && this[HIDDEN][key])
                  ? E
                  : true;
              };
              var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
                it = toIObject(it);
                key = toPrimitive(key, true);
                if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
                var D = gOPD(it, key);
                if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
                return D;
              };
              var $getOwnPropertyNames = function getOwnPropertyNames(it) {
                var names = gOPN(toIObject(it));
                var result = [];
                var i = 0;
                var key;
                while (names.length > i) {
                  if (!has(AllSymbols, (key = names[i++])) && key != HIDDEN && key != META) result.push(key);
                }
                return result;
              };
              var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
                var IS_OP = it === ObjectProto;
                var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
                var result = [];
                var i = 0;
                var key;
                while (names.length > i) {
                  if (has(AllSymbols, (key = names[i++])) && (IS_OP ? has(ObjectProto, key) : true))
                    result.push(AllSymbols[key]);
                }
                return result;
              };

              // 19.4.1.1 Symbol([description])
              if (!USE_NATIVE) {
                $Symbol = function Symbol() {
                  if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
                  var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
                  var $set = function (value) {
                    if (this === ObjectProto) $set.call(OPSymbols, value);
                    if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
                    setSymbolDesc(this, tag, createDesc(1, value));
                  };
                  if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
                  return wrap(tag);
                };
                redefine($Symbol[PROTOTYPE], 'toString', function toString() {
                  return this._k;
                });

                $GOPD.f = $getOwnPropertyDescriptor;
                $DP.f = $defineProperty;
                __webpack_require__(78).f = gOPNExt.f = $getOwnPropertyNames;
                __webpack_require__(26).f = $propertyIsEnumerable;
                __webpack_require__(51).f = $getOwnPropertySymbols;

                if (DESCRIPTORS && !__webpack_require__(31)) {
                  redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
                }

                wksExt.f = function (name) {
                  return wrap(wks(name));
                };
              }

              $export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

              for (
                var es6Symbols =
                    // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
                    'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(
                      ','
                    ),
                  j = 0;
                es6Symbols.length > j;

              )
                wks(es6Symbols[j++]);

              for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k; )
                wksDefine(wellKnownSymbols[k++]);

              $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
                // 19.4.2.1 Symbol.for(key)
                for: function (key) {
                  return has(SymbolRegistry, (key += '')) ? SymbolRegistry[key] : (SymbolRegistry[key] = $Symbol(key));
                },
                // 19.4.2.5 Symbol.keyFor(sym)
                keyFor: function keyFor(sym) {
                  if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
                  for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
                },
                useSetter: function () {
                  setter = true;
                },
                useSimple: function () {
                  setter = false;
                }
              });

              $export($export.S + $export.F * !USE_NATIVE, 'Object', {
                // 19.1.2.2 Object.create(O [, Properties])
                create: $create,
                // 19.1.2.4 Object.defineProperty(O, P, Attributes)
                defineProperty: $defineProperty,
                // 19.1.2.3 Object.defineProperties(O, Properties)
                defineProperties: $defineProperties,
                // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
                getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
                // 19.1.2.7 Object.getOwnPropertyNames(O)
                getOwnPropertyNames: $getOwnPropertyNames,
                // 19.1.2.8 Object.getOwnPropertySymbols(O)
                getOwnPropertySymbols: $getOwnPropertySymbols
              });

              // 24.3.2 JSON.stringify(value [, replacer [, space]])
              $JSON &&
                $export(
                  $export.S +
                    $export.F *
                      (!USE_NATIVE ||
                        $fails(function () {
                          var S = $Symbol();
                          // MS Edge converts symbol values to JSON as {}
                          // WebKit converts symbol values to JSON as null
                          // V8 throws on boxed symbols
                          return (
                            _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}'
                          );
                        })),
                  'JSON',
                  {
                    stringify: function stringify(it) {
                      if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
                      var args = [it];
                      var i = 1;
                      var replacer, $replacer;
                      while (arguments.length > i) args.push(arguments[i++]);
                      replacer = args[1];
                      if (typeof replacer == 'function') $replacer = replacer;
                      if ($replacer || !isArray(replacer))
                        replacer = function (key, value) {
                          if ($replacer) value = $replacer.call(this, key, value);
                          if (!isSymbol(value)) return value;
                        };
                      args[1] = replacer;
                      return _stringify.apply($JSON, args);
                    }
                  }
                );

              // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
              $Symbol[PROTOTYPE][TO_PRIMITIVE] ||
                __webpack_require__(10)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
              // 19.4.3.5 Symbol.prototype[@@toStringTag]
              setToStringTag($Symbol, 'Symbol');
              // 20.2.1.9 Math[@@toStringTag]
              setToStringTag(Math, 'Math', true);
              // 24.3.3 JSON[@@toStringTag]
              setToStringTag(global.JSON, 'JSON', true);

              /***/
            },
            /* 130 */
            /***/ function (module, exports, __webpack_require__) {
              var META = __webpack_require__(32)('meta');
              var isObject = __webpack_require__(11);
              var has = __webpack_require__(13);
              var setDesc = __webpack_require__(8).f;
              var id = 0;
              var isExtensible =
                Object.isExtensible ||
                function () {
                  return true;
                };
              var FREEZE = !__webpack_require__(17)(function () {
                return isExtensible(Object.preventExtensions({}));
              });
              var setMeta = function (it) {
                setDesc(it, META, {
                  value: {
                    i: 'O' + ++id, // object ID
                    w: {} // weak collections IDs
                  }
                });
              };
              var fastKey = function (it, create) {
                // return primitive with prefix
                if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
                if (!has(it, META)) {
                  // can't set metadata to uncaught frozen object
                  if (!isExtensible(it)) return 'F';
                  // not necessary to add metadata
                  if (!create) return 'E';
                  // add missing metadata
                  setMeta(it);
                  // return object ID
                }
                return it[META].i;
              };
              var getWeak = function (it, create) {
                if (!has(it, META)) {
                  // can't set metadata to uncaught frozen object
                  if (!isExtensible(it)) return true;
                  // not necessary to add metadata
                  if (!create) return false;
                  // add missing metadata
                  setMeta(it);
                  // return hash weak collections IDs
                }
                return it[META].w;
              };
              // add metadata on freeze-family methods calling
              var onFreeze = function (it) {
                if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
                return it;
              };
              var meta = (module.exports = {
                KEY: META,
                NEED: false,
                fastKey: fastKey,
                getWeak: getWeak,
                onFreeze: onFreeze
              });

              /***/
            },
            /* 131 */
            /***/ function (module, exports, __webpack_require__) {
              // all enumerable object keys, includes symbols
              var getKeys = __webpack_require__(18);
              var gOPS = __webpack_require__(51);
              var pIE = __webpack_require__(26);
              module.exports = function (it) {
                var result = getKeys(it);
                var getSymbols = gOPS.f;
                if (getSymbols) {
                  var symbols = getSymbols(it);
                  var isEnum = pIE.f;
                  var i = 0;
                  var key;
                  while (symbols.length > i) if (isEnum.call(it, (key = symbols[i++]))) result.push(key);
                }
                return result;
              };

              /***/
            },
            /* 132 */
            /***/ function (module, exports, __webpack_require__) {
              // 7.2.2 IsArray(argument)
              var cof = __webpack_require__(25);
              module.exports =
                Array.isArray ||
                function isArray(arg) {
                  return cof(arg) == 'Array';
                };

              /***/
            },
            /* 133 */
            /***/ function (module, exports, __webpack_require__) {
              // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
              var toIObject = __webpack_require__(12);
              var gOPN = __webpack_require__(78).f;
              var toString = {}.toString;

              var windowNames =
                typeof window == 'object' && window && Object.getOwnPropertyNames
                  ? Object.getOwnPropertyNames(window)
                  : [];

              var getWindowNames = function (it) {
                try {
                  return gOPN(it);
                } catch (e) {
                  return windowNames.slice();
                }
              };

              module.exports.f = function getOwnPropertyNames(it) {
                return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
              };

              /***/
            },
            /* 134 */
            /***/ function (module, exports, __webpack_require__) {
              __webpack_require__(50)('asyncIterator');

              /***/
            },
            /* 135 */
            /***/ function (module, exports, __webpack_require__) {
              __webpack_require__(50)('observable');

              /***/
            },
            /* 136 */
            /***/ function (module, exports, __webpack_require__) {
              module.exports = { default: __webpack_require__(137), __esModule: true };

              /***/
            },
            /* 137 */
            /***/ function (module, exports, __webpack_require__) {
              __webpack_require__(138);
              module.exports = __webpack_require__(2).Object.setPrototypeOf;

              /***/
            },
            /* 138 */
            /***/ function (module, exports, __webpack_require__) {
              // 19.1.3.19 Object.setPrototypeOf(O, proto)
              var $export = __webpack_require__(6);
              $export($export.S, 'Object', { setPrototypeOf: __webpack_require__(139).set });

              /***/
            },
            /* 139 */
            /***/ function (module, exports, __webpack_require__) {
              // Works with __proto__ only. Old v8 can't work with null proto objects.
              /* eslint-disable no-proto */
              var isObject = __webpack_require__(11);
              var anObject = __webpack_require__(7);
              var check = function (O, proto) {
                anObject(O);
                if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
              };
              module.exports = {
                set:
                  Object.setPrototypeOf ||
                  ('__proto__' in {} // eslint-disable-line
                    ? (function (test, buggy, set) {
                        try {
                          set = __webpack_require__(23)(
                            Function.call,
                            __webpack_require__(79).f(Object.prototype, '__proto__').set,
                            2
                          );
                          set(test, []);
                          buggy = !(test instanceof Array);
                        } catch (e) {
                          buggy = true;
                        }
                        return function setPrototypeOf(O, proto) {
                          check(O, proto);
                          if (buggy) O.__proto__ = proto;
                          else set(O, proto);
                          return O;
                        };
                      })({}, false)
                    : undefined),
                check: check
              };

              /***/
            },
            /* 140 */
            /***/ function (module, exports, __webpack_require__) {
              module.exports = { default: __webpack_require__(141), __esModule: true };

              /***/
            },
            /* 141 */
            /***/ function (module, exports, __webpack_require__) {
              __webpack_require__(142);
              var $Object = __webpack_require__(2).Object;
              module.exports = function create(P, D) {
                return $Object.create(P, D);
              };

              /***/
            },
            /* 142 */
            /***/ function (module, exports, __webpack_require__) {
              var $export = __webpack_require__(6);
              // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
              $export($export.S, 'Object', { create: __webpack_require__(43) });

              /***/
            },
            /* 143 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              Object.defineProperty(__webpack_exports__, '__esModule', { value: true });
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cart__ = __webpack_require__(144);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shop__ = __webpack_require__(186);

              var Entities = function Entities() {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Entities);

                /** @type {src/entities/Cart.js~Cart} */
                this.Cart = __WEBPACK_IMPORTED_MODULE_1__Cart__['a' /* default */];
                /** @type {src/entities/Shop.js~Shop} */
                this.Shop = __WEBPACK_IMPORTED_MODULE_2__Shop__['a' /* default */];
              };

              /** @ignore */

              /* harmony default export */ __webpack_exports__['default'] = new Entities();

              /***/
            },
            /* 144 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ =
                __webpack_require__(40);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ =
                __webpack_require__(81);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ =
                __webpack_require__(53);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ =
                __webpack_require__(19);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ =
                __webpack_require__(20);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ =
                __webpack_require__(14);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ =
                __webpack_require__(1);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__ =
                __webpack_require__(15);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__ =
                __webpack_require__(16);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_evee__ = __webpack_require__(35);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_evee___default = __webpack_require__.n(
                __WEBPACK_IMPORTED_MODULE_10_evee__
              );
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_promise_queue__ = __webpack_require__(86);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_promise_queue___default = __webpack_require__.n(
                __WEBPACK_IMPORTED_MODULE_11_promise_queue__
              );
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_deep_equal__ = __webpack_require__(87);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_deep_equal___default = __webpack_require__.n(
                __WEBPACK_IMPORTED_MODULE_12_deep_equal__
              );
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(88);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(
                __WEBPACK_IMPORTED_MODULE_13_lodash__
              );
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_config__ = __webpack_require__(55);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_log__ = __webpack_require__(37);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_http_shopifyAJAXAPI__ = __webpack_require__(167);

              var TAG = 'Cart';

              /**
               * @typedef {Object}  ShopifyCartLineItem
               * @property {Number} id
               * @property {Object|null} properties
               * @property {Number} quantity
               * @property {Number} variant_id
               * @property {String} key
               * @property {String} title
               * @property {Number} price
               * @property {Number} original_price
               * @property {Number} discounted_price
               * @property {Number} original_line_price
               * @property {Number} line_price
               * @property {Number} total_discount
               * @property {Object[]} discounts
               * @property {String|null} sku
               * @property {Number} grams
               * @property {String} vendor
               * @property {Boolean} taxable
               * @property {Number} product_id
               * @property {Boolean} gift_card
               * @property {String} url
               * @property {String|null} image
               * @property {String} handle
               * @property {Boolean} requires_shipping
               * @property {String|null} product_type
               * @property {String} product_title
               * @property {String|null} product_description
               * @property {String} variant_title
               * @property {String[]} variant_options
               */

              /**
               * @typedef {Object} ShopifyCart
               * @property {String} token
               * @property {String} note
               * @property {Object} attributes
               * @property {Number} total_price
               * @property {Number} total_weight
               * @property {ShopifyCartLineItem[]} items
               * @property {Boolean} requires_shipping
               */

              /**
               * Shopify Cart entity.
               * @extends {evee}
               */

              var Cart = (function (_Evee) {
                __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default()(Cart, _Evee);

                /**
                 * Construct a new instance of the cart entity.
                 */
                function Cart() {
                  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, Cart);

                  /** @type {promise-queue} */
                  var _this = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(
                    this,
                    (
                      Cart.__proto__ ||
                      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(Cart)
                    ).call(this)
                  );

                  _this._queue = new __WEBPACK_IMPORTED_MODULE_11_promise_queue___default.a(1, Infinity);
                  _this._attributes = {};
                  _this._ready = false;

                  /** @type {Object[]} */
                  _this._items = [];
                  _this._attributes = {};
                  return _this;
                }

                /**
                 * Initialize the cart entity with the current state of the visitor's cart.
                 * @param {ShopifyCart} cartData - Shopify Cart object.
                 */

                __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(Cart, [
                  {
                    key: 'initialize',
                    value: function initialize(cartData) {
                      this._loadFromShopifyCart(cartData);

                      this._emitUpdate('init', null);
                      if (this.items.length == 0) {
                        this._emitClear([]);
                      }

                      __WEBPACK_IMPORTED_MODULE_15_log__['a' /* default */].send(
                        __WEBPACK_IMPORTED_MODULE_15_log__['a' /* default */].DEBUG,
                        TAG,
                        'Loaded.'
                      );
                    }

                    /**
                     * Alias to getItems();
                     * @type {ShopifyCartLineItem[]}
                     */
                  },
                  {
                    key: 'getItems',

                    /**
                     * Returns items in the cart (in the normal Shopify line item format.
                     * @returns {ShopifyCartLineItem[]}
                     */
                    value: function getItems() {
                      return this._items;
                    }

                    /**
                     * Alias to getTotalPrice();
                     * @type {Number}
                     */
                  },
                  {
                    key: 'getTotalPrice',

                    /**
                     * Calculates the total value of the cart.
                     * @returns {Number}
                     */
                    value: function getTotalPrice() {
                      return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.reduce(
                        this.items,
                        function (total, item) {
                          return total + item.line_price;
                        },
                        0
                      );
                    }

                    /**
                     * Reloads the cart state via AJAX.
                     * @returns {Promise<src/entities/Cart.js~Cart, Error>}
                     */
                  },
                  {
                    key: 'reload',
                    value: (function () {
                      var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(
                        /*#__PURE__*/ __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(
                          function _callee() {
                            var cartData;
                            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(
                              function _callee$(_context) {
                                while (1) {
                                  switch ((_context.prev = _context.next)) {
                                    case 0:
                                      _context.next = 2;
                                      return __WEBPACK_IMPORTED_MODULE_16_http_shopifyAJAXAPI__['a' /* default */].get(
                                        '/cart.js'
                                      );

                                    case 2:
                                      cartData = _context.sent;

                                      this._loadFromShopifyCart(cartData.data);
                                      return _context.abrupt('return', this);

                                    case 5:
                                    case 'end':
                                      return _context.stop();
                                  }
                                }
                              },
                              _callee,
                              this
                            );
                          }
                        )
                      );

                      function reload() {
                        return _ref.apply(this, arguments);
                      }

                      return reload;
                    })()

                    /**
                     * Alias to getAttributes()
                     * @type {Object}
                     */
                  },
                  {
                    key: 'getAttributes',

                    /**
                     * Returns cart attributes.
                     * @returns {Object}
                     */
                    value: function getAttributes() {
                      return this._attributes;
                    }

                    /**
                     * Sets all attributes on the cart. This will override/remove existing attributes.
                     * @param {Object} attributes - New attributes for the cart.
                     * @returns {Promise<src/entities/Cart.js~Cart, Error>}
                     */
                  },
                  {
                    key: 'setAttributes',
                    value: function setAttributes(attributes) {
                      var _this2 = this;

                      __WEBPACK_IMPORTED_MODULE_15_log__['a' /* default */].sendObject(
                        __WEBPACK_IMPORTED_MODULE_15_log__['a' /* default */].DEBUG,
                        TAG,
                        'Setting attributes...',
                        {
                          attributes: attributes
                        }
                      );
                      return this._queue.add(
                        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(
                          /*#__PURE__*/ __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(
                            function _callee2() {
                              var cart;
                              return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(
                                function _callee2$(_context2) {
                                  while (1) {
                                    switch ((_context2.prev = _context2.next)) {
                                      case 0:
                                        _context2.next = 2;
                                        return __WEBPACK_IMPORTED_MODULE_16_http_shopifyAJAXAPI__[
                                          'a' /* default */
                                        ].post({ attributes: attributes });

                                      case 2:
                                        cart = _context2.sent;

                                        _this2._loadFromShopifyCart(cart.data);
                                        _this2._emitUpdate('attribute-updated', null);

                                      case 5:
                                      case 'end':
                                        return _context2.stop();
                                    }
                                  }
                                },
                                _callee2,
                                _this2
                              );
                            }
                          )
                        )
                      );
                    }
                  },
                  {
                    key: 'getAttribute',
                    value: function getAttribute(key) {
                      return this._attributes[key];
                    }
                  },
                  {
                    key: 'setAttribute',
                    value: function setAttribute(key, value) {
                      var _this3 = this;

                      __WEBPACK_IMPORTED_MODULE_15_log__['a' /* default */].sendObject(
                        __WEBPACK_IMPORTED_MODULE_15_log__['a' /* default */].DEBUG,
                        TAG,
                        'Setting attribute...',
                        {
                          key: key,
                          value: value
                        }
                      );
                      return this._queue.add(
                        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(
                          /*#__PURE__*/ __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(
                            function _callee3() {
                              var newAttributes, cart;
                              return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(
                                function _callee3$(_context3) {
                                  while (1) {
                                    switch ((_context3.prev = _context3.next)) {
                                      case 0:
                                        newAttributes =
                                          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(
                                            {},
                                            _this3._attributes
                                          );

                                        newAttributes[key] = value;
                                        _context3.next = 4;
                                        return __WEBPACK_IMPORTED_MODULE_16_http_shopifyAJAXAPI__[
                                          'a' /* default */
                                        ].post({ attributes: newAttributes });

                                      case 4:
                                        cart = _context3.sent;

                                        _this3._loadFromShopifyCart(cart.data);
                                        _this3._emitUpdate('attribute-updated', null);

                                      case 7:
                                      case 'end':
                                        return _context3.stop();
                                    }
                                  }
                                },
                                _callee3,
                                _this3
                              );
                            }
                          )
                        )
                      );
                    }

                    /**
                     * Add a new item to the cart.
                     * @param {Number|String} id - Variant ID to add to cart.
                     * @param {Number} quantity - Quantity to add.
                     * @param {Object} properties - Line item attributes.
                     * @returns {Promise<ShopifyCartLineItem, Error>}
                     */
                  },
                  {
                    key: 'addItem',
                    value: function addItem(id, quantity, properties) {
                      var _this4 = this;

                      __WEBPACK_IMPORTED_MODULE_15_log__['a' /* default */].sendObject(
                        __WEBPACK_IMPORTED_MODULE_15_log__['a' /* default */].DEBUG,
                        TAG,
                        'Queuing addItem...',
                        {
                          id: id,
                          quantity: quantity,
                          properties: properties
                        }
                      );
                      return this._queue.add(
                        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(
                          /*#__PURE__*/ __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(
                            function _callee4() {
                              var res, data, item;
                              return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(
                                function _callee4$(_context4) {
                                  while (1) {
                                    switch ((_context4.prev = _context4.next)) {
                                      case 0:
                                        _context4.next = 2;
                                        return __WEBPACK_IMPORTED_MODULE_16_http_shopifyAJAXAPI__[
                                          'a' /* default */
                                        ].post('/cart/add.js', {
                                          id: id,
                                          quantity: quantity,
                                          properties: properties
                                        });

                                      case 2:
                                        res = _context4.sent;
                                        data = res.data;

                                        __WEBPACK_IMPORTED_MODULE_15_log__['a' /* default */].sendObject(
                                          __WEBPACK_IMPORTED_MODULE_15_log__['a' /* default */].DEBUG,
                                          TAG,
                                          'addItem resonse',
                                          data
                                        );

                                        if (!data.id) {
                                          _context4.next = 10;
                                          break;
                                        }

                                        item = _this4._loadItem(data);

                                        _this4._emitAdd(item);
                                        _this4._emitUpdate('add', item);
                                        return _context4.abrupt('return', item);

                                      case 10:
                                        throw new Error(data);

                                      case 11:
                                      case 'end':
                                        return _context4.stop();
                                    }
                                  }
                                },
                                _callee4,
                                _this4
                              );
                            }
                          )
                        )
                      );
                    }
                  },
                  {
                    key: 'updateItem',
                    value: function updateItem(lineNumber, quantity, properties) {
                      return this._queue.add(function () {
                        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (
                          acc,
                          rej
                        ) {});
                      });
                    }
                  },
                  {
                    key: 'removeItem',
                    value: function removeItem(lineNumber) {
                      return this._queue.add(function () {
                        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (
                          acc,
                          rej
                        ) {});
                      });
                    }
                  },
                  {
                    key: 'updateItemById',
                    value: function updateItemById(id, quantity, properties) {
                      return this._queue.add(function () {
                        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (
                          acc,
                          rej
                        ) {});
                      });
                    }
                  },
                  {
                    key: 'updateItemById',
                    value: function updateItemById(id, quantity, properties) {
                      return this._queue.add(function () {
                        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (
                          acc,
                          rej
                        ) {});
                      });
                    }
                  },
                  {
                    key: 'updateItemQuantitiesById',
                    value: function updateItemQuantitiesById(updates) {
                      return this._queue.add(function () {
                        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (
                          acc,
                          rej
                        ) {});
                      });
                    }
                  },
                  {
                    key: 'removeItemById',
                    value: function removeItemById(id) {
                      return this._queue.add(function () {
                        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (
                          acc,
                          rej
                        ) {});
                      });
                    }

                    /**
                     * Clear the cart.
                     * @returns {Promise<src/entities/Cart.js~Cart, Error>}
                     */
                  },
                  {
                    key: 'clear',
                    value: function clear() {
                      var _this5 = this;

                      return this._queue.add(
                        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(
                          /*#__PURE__*/ __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(
                            function _callee5() {
                              var cartData, oldItems;
                              return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(
                                function _callee5$(_context5) {
                                  while (1) {
                                    switch ((_context5.prev = _context5.next)) {
                                      case 0:
                                        _context5.next = 2;
                                        return __WEBPACK_IMPORTED_MODULE_16_http_shopifyAJAXAPI__[
                                          'a' /* default */
                                        ].post('/cart/clear.js');

                                      case 2:
                                        cartData = _context5.sent;
                                        oldItems = _this5.items;

                                        _this5._loadFromShopifyCart(cartData);
                                        _this5._emitClear(oldItems);

                                      case 6:
                                      case 'end':
                                        return _context5.stop();
                                    }
                                  }
                                },
                                _callee5,
                                _this5
                              );
                            }
                          )
                        )
                      );
                    }
                  },
                  {
                    key: '_loadItem',
                    value: function _loadItem(itemData) {
                      var _iteratorNormalCompletion = true;
                      var _didIteratorError = false;
                      var _iteratorError = undefined;

                      try {
                        for (
                          var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(
                              this.items
                            ),
                            _step;
                          !(_iteratorNormalCompletion = (_step = _iterator.next()).done);
                          _iteratorNormalCompletion = true
                        ) {
                          var item = _step.value;

                          if (
                            item.id == itemData.id &&
                            __WEBPACK_IMPORTED_MODULE_12_deep_equal___default()(item.properties, itemData.properties)
                          ) {
                            item.quantity = itemData.quantity;
                            return item;
                          }
                        }
                      } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                          }
                        } finally {
                          if (_didIteratorError) {
                            throw _iteratorError;
                          }
                        }
                      }

                      this.items.push(itemData);
                      return itemData;
                    }
                  },
                  {
                    key: '_emitUpdate',
                    value: function _emitUpdate(operation, item) {
                      var data = {
                        items: this.items,
                        operation: operation,
                        item: item
                      };
                      __WEBPACK_IMPORTED_MODULE_15_log__['a' /* default */].sendObject(
                        __WEBPACK_IMPORTED_MODULE_15_log__['a' /* default */].DEBUG,
                        TAG,
                        'Event: update',
                        data
                      );
                      this.emit('update', data);
                    }
                  },
                  {
                    key: '_emitClear',
                    value: function _emitClear(oldItems) {
                      var data = {
                        oldItems: oldItems
                      };
                      __WEBPACK_IMPORTED_MODULE_15_log__['a' /* default */].sendObject(
                        __WEBPACK_IMPORTED_MODULE_15_log__['a' /* default */].DEBUG,
                        TAG,
                        'Event: clear',
                        data
                      );
                      this.emit('clear', data);
                    }
                  },
                  {
                    key: '_emitAdd',
                    value: function _emitAdd(item) {
                      var data = {
                        items: this.items,
                        item: item
                      };
                      __WEBPACK_IMPORTED_MODULE_15_log__['a' /* default */].sendObject(
                        __WEBPACK_IMPORTED_MODULE_15_log__['a' /* default */].DEBUG,
                        TAG,
                        'Event: add',
                        data
                      );
                      this.emit('add', data);
                    }
                  },
                  {
                    key: '_emitUpdateItem',
                    value: function _emitUpdateItem(item) {
                      var data = {
                        items: this.items,
                        item: item
                      };
                      __WEBPACK_IMPORTED_MODULE_15_log__['a' /* default */].sendObject(
                        __WEBPACK_IMPORTED_MODULE_15_log__['a' /* default */].DEBUG,
                        TAG,
                        'Event: updae-item',
                        data
                      );
                      this.emit('update-item', data);
                    }
                  },
                  {
                    key: '_emitRemove',
                    value: function _emitRemove(item) {
                      var data = {
                        items: this.items,
                        item: item
                      };
                      __WEBPACK_IMPORTED_MODULE_15_log__['a' /* default */].sendObject(
                        __WEBPACK_IMPORTED_MODULE_15_log__['a' /* default */].DEBUG,
                        TAG,
                        'Event: remove',
                        data
                      );
                      this.emit('clear', data);
                    }
                  },
                  {
                    key: '_loadFromShopifyCart',
                    value: function _loadFromShopifyCart(cart) {
                      this._items = cart.items;
                    }
                  },
                  {
                    key: 'items',
                    get: function get() {
                      return this.getItems();
                    }
                  },
                  {
                    key: 'total_price',
                    get: function get() {
                      return this.getTotalPrice();
                    }
                    /**
                     * Alias to getTotalPrice();
                     * @type {Number}
                     */
                  },
                  {
                    key: 'totalPrice',
                    get: function get() {
                      return this.getTotalPrice();
                    }
                  },
                  {
                    key: 'attributes',
                    get: function get() {
                      return this.getAttributes();
                    }
                  }
                ]);

                return Cart;
              })(__WEBPACK_IMPORTED_MODULE_10_evee___default.a);

              /* harmony default export */ __webpack_exports__['a'] = Cart;

              /***/
            },
            /* 145 */
            /***/ function (module, exports, __webpack_require__) {
              __webpack_require__(80);
              __webpack_require__(48);
              __webpack_require__(41);
              __webpack_require__(146);
              __webpack_require__(156);
              __webpack_require__(157);
              module.exports = __webpack_require__(2).Promise;

              /***/
            },
            /* 146 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              var LIBRARY = __webpack_require__(31);
              var global = __webpack_require__(3);
              var ctx = __webpack_require__(23);
              var classof = __webpack_require__(72);
              var $export = __webpack_require__(6);
              var isObject = __webpack_require__(11);
              var aFunction = __webpack_require__(29);
              var anInstance = __webpack_require__(147);
              var forOf = __webpack_require__(148);
              var speciesConstructor = __webpack_require__(82);
              var task = __webpack_require__(83).set;
              var microtask = __webpack_require__(152)();
              var newPromiseCapabilityModule = __webpack_require__(52);
              var perform = __webpack_require__(84);
              var promiseResolve = __webpack_require__(85);
              var PROMISE = 'Promise';
              var TypeError = global.TypeError;
              var process = global.process;
              var $Promise = global[PROMISE];
              var isNode = classof(process) == 'process';
              var empty = function () {
                /* empty */
              };
              var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
              var newPromiseCapability = (newGenericPromiseCapability = newPromiseCapabilityModule.f);

              var USE_NATIVE = !!(function () {
                try {
                  // correct subclassing with @@species support
                  var promise = $Promise.resolve(1);
                  var FakePromise = ((promise.constructor = {})[__webpack_require__(4)('species')] = function (exec) {
                    exec(empty, empty);
                  });
                  // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
                  return (
                    (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise
                  );
                } catch (e) {
                  /* empty */
                }
              })();

              // helpers
              var isThenable = function (it) {
                var then;
                return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
              };
              var notify = function (promise, isReject) {
                if (promise._n) return;
                promise._n = true;
                var chain = promise._c;
                microtask(function () {
                  var value = promise._v;
                  var ok = promise._s == 1;
                  var i = 0;
                  var run = function (reaction) {
                    var handler = ok ? reaction.ok : reaction.fail;
                    var resolve = reaction.resolve;
                    var reject = reaction.reject;
                    var domain = reaction.domain;
                    var result, then;
                    try {
                      if (handler) {
                        if (!ok) {
                          if (promise._h == 2) onHandleUnhandled(promise);
                          promise._h = 1;
                        }
                        if (handler === true) result = value;
                        else {
                          if (domain) domain.enter();
                          result = handler(value);
                          if (domain) domain.exit();
                        }
                        if (result === reaction.promise) {
                          reject(TypeError('Promise-chain cycle'));
                        } else if ((then = isThenable(result))) {
                          then.call(result, resolve, reject);
                        } else resolve(result);
                      } else reject(value);
                    } catch (e) {
                      reject(e);
                    }
                  };
                  while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
                  promise._c = [];
                  promise._n = false;
                  if (isReject && !promise._h) onUnhandled(promise);
                });
              };
              var onUnhandled = function (promise) {
                task.call(global, function () {
                  var value = promise._v;
                  var unhandled = isUnhandled(promise);
                  var result, handler, console;
                  if (unhandled) {
                    result = perform(function () {
                      if (isNode) {
                        process.emit('unhandledRejection', value, promise);
                      } else if ((handler = global.onunhandledrejection)) {
                        handler({ promise: promise, reason: value });
                      } else if ((console = global.console) && console.error) {
                        console.error('Unhandled promise rejection', value);
                      }
                    });
                    // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
                    promise._h = isNode || isUnhandled(promise) ? 2 : 1;
                  }
                  promise._a = undefined;
                  if (unhandled && result.e) throw result.v;
                });
              };
              var isUnhandled = function (promise) {
                if (promise._h == 1) return false;
                var chain = promise._a || promise._c;
                var i = 0;
                var reaction;
                while (chain.length > i) {
                  reaction = chain[i++];
                  if (reaction.fail || !isUnhandled(reaction.promise)) return false;
                }
                return true;
              };
              var onHandleUnhandled = function (promise) {
                task.call(global, function () {
                  var handler;
                  if (isNode) {
                    process.emit('rejectionHandled', promise);
                  } else if ((handler = global.onrejectionhandled)) {
                    handler({ promise: promise, reason: promise._v });
                  }
                });
              };
              var $reject = function (value) {
                var promise = this;
                if (promise._d) return;
                promise._d = true;
                promise = promise._w || promise; // unwrap
                promise._v = value;
                promise._s = 2;
                if (!promise._a) promise._a = promise._c.slice();
                notify(promise, true);
              };
              var $resolve = function (value) {
                var promise = this;
                var then;
                if (promise._d) return;
                promise._d = true;
                promise = promise._w || promise; // unwrap
                try {
                  if (promise === value) throw TypeError("Promise can't be resolved itself");
                  if ((then = isThenable(value))) {
                    microtask(function () {
                      var wrapper = { _w: promise, _d: false }; // wrap
                      try {
                        then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
                      } catch (e) {
                        $reject.call(wrapper, e);
                      }
                    });
                  } else {
                    promise._v = value;
                    promise._s = 1;
                    notify(promise, false);
                  }
                } catch (e) {
                  $reject.call({ _w: promise, _d: false }, e); // wrap
                }
              };

              // constructor polyfill
              if (!USE_NATIVE) {
                // 25.4.3.1 Promise(executor)
                $Promise = function Promise(executor) {
                  anInstance(this, $Promise, PROMISE, '_h');
                  aFunction(executor);
                  Internal.call(this);
                  try {
                    executor(ctx($resolve, this, 1), ctx($reject, this, 1));
                  } catch (err) {
                    $reject.call(this, err);
                  }
                };
                // eslint-disable-next-line no-unused-vars
                Internal = function Promise(executor) {
                  this._c = []; // <- awaiting reactions
                  this._a = undefined; // <- checked in isUnhandled reactions
                  this._s = 0; // <- state
                  this._d = false; // <- done
                  this._v = undefined; // <- value
                  this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
                  this._n = false; // <- notify
                };
                Internal.prototype = __webpack_require__(153)($Promise.prototype, {
                  // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
                  then: function then(onFulfilled, onRejected) {
                    var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
                    reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
                    reaction.fail = typeof onRejected == 'function' && onRejected;
                    reaction.domain = isNode ? process.domain : undefined;
                    this._c.push(reaction);
                    if (this._a) this._a.push(reaction);
                    if (this._s) notify(this, false);
                    return reaction.promise;
                  },
                  // 25.4.5.1 Promise.prototype.catch(onRejected)
                  catch: function (onRejected) {
                    return this.then(undefined, onRejected);
                  }
                });
                OwnPromiseCapability = function () {
                  var promise = new Internal();
                  this.promise = promise;
                  this.resolve = ctx($resolve, promise, 1);
                  this.reject = ctx($reject, promise, 1);
                };
                newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
                  return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
                };
              }

              $export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
              __webpack_require__(33)($Promise, PROMISE);
              __webpack_require__(154)(PROMISE);
              Wrapper = __webpack_require__(2)[PROMISE];

              // statics
              $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
                // 25.4.4.5 Promise.reject(r)
                reject: function reject(r) {
                  var capability = newPromiseCapability(this);
                  var $$reject = capability.reject;
                  $$reject(r);
                  return capability.promise;
                }
              });
              $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
                // 25.4.4.6 Promise.resolve(x)
                resolve: function resolve(x) {
                  return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
                }
              });
              $export(
                $export.S +
                  $export.F *
                    !(
                      USE_NATIVE &&
                      __webpack_require__(155)(function (iter) {
                        $Promise.all(iter)['catch'](empty);
                      })
                    ),
                PROMISE,
                {
                  // 25.4.4.1 Promise.all(iterable)
                  all: function all(iterable) {
                    var C = this;
                    var capability = newPromiseCapability(C);
                    var resolve = capability.resolve;
                    var reject = capability.reject;
                    var result = perform(function () {
                      var values = [];
                      var index = 0;
                      var remaining = 1;
                      forOf(iterable, false, function (promise) {
                        var $index = index++;
                        var alreadyCalled = false;
                        values.push(undefined);
                        remaining++;
                        C.resolve(promise).then(function (value) {
                          if (alreadyCalled) return;
                          alreadyCalled = true;
                          values[$index] = value;
                          --remaining || resolve(values);
                        }, reject);
                      });
                      --remaining || resolve(values);
                    });
                    if (result.e) reject(result.v);
                    return capability.promise;
                  },
                  // 25.4.4.4 Promise.race(iterable)
                  race: function race(iterable) {
                    var C = this;
                    var capability = newPromiseCapability(C);
                    var reject = capability.reject;
                    var result = perform(function () {
                      forOf(iterable, false, function (promise) {
                        C.resolve(promise).then(capability.resolve, reject);
                      });
                    });
                    if (result.e) reject(result.v);
                    return capability.promise;
                  }
                }
              );

              /***/
            },
            /* 147 */
            /***/ function (module, exports) {
              module.exports = function (it, Constructor, name, forbiddenField) {
                if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
                  throw TypeError(name + ': incorrect invocation!');
                }
                return it;
              };

              /***/
            },
            /* 148 */
            /***/ function (module, exports, __webpack_require__) {
              var ctx = __webpack_require__(23);
              var call = __webpack_require__(149);
              var isArrayIter = __webpack_require__(150);
              var anObject = __webpack_require__(7);
              var toLength = __webpack_require__(68);
              var getIterFn = __webpack_require__(71);
              var BREAK = {};
              var RETURN = {};
              var exports = (module.exports = function (iterable, entries, fn, that, ITERATOR) {
                var iterFn = ITERATOR
                  ? function () {
                      return iterable;
                    }
                  : getIterFn(iterable);
                var f = ctx(fn, that, entries ? 2 : 1);
                var index = 0;
                var length, step, iterator, result;
                if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
                // fast case for arrays with default iterator
                if (isArrayIter(iterFn))
                  for (length = toLength(iterable.length); length > index; index++) {
                    result = entries ? f(anObject((step = iterable[index]))[0], step[1]) : f(iterable[index]);
                    if (result === BREAK || result === RETURN) return result;
                  }
                else
                  for (iterator = iterFn.call(iterable); !(step = iterator.next()).done; ) {
                    result = call(iterator, f, step.value, entries);
                    if (result === BREAK || result === RETURN) return result;
                  }
              });
              exports.BREAK = BREAK;
              exports.RETURN = RETURN;

              /***/
            },
            /* 149 */
            /***/ function (module, exports, __webpack_require__) {
              // call something on iterator step with safe closing on error
              var anObject = __webpack_require__(7);
              module.exports = function (iterator, fn, value, entries) {
                try {
                  return entries ? fn(anObject(value)[0], value[1]) : fn(value);
                  // 7.4.6 IteratorClose(iterator, completion)
                } catch (e) {
                  var ret = iterator['return'];
                  if (ret !== undefined) anObject(ret.call(iterator));
                  throw e;
                }
              };

              /***/
            },
            /* 150 */
            /***/ function (module, exports, __webpack_require__) {
              // check on default Array iterator
              var Iterators = __webpack_require__(24);
              var ITERATOR = __webpack_require__(4)('iterator');
              var ArrayProto = Array.prototype;

              module.exports = function (it) {
                return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
              };

              /***/
            },
            /* 151 */
            /***/ function (module, exports) {
              // fast apply, http://jsperf.lnkit.com/fast-apply/5
              module.exports = function (fn, args, that) {
                var un = that === undefined;
                switch (args.length) {
                  case 0:
                    return un ? fn() : fn.call(that);
                  case 1:
                    return un ? fn(args[0]) : fn.call(that, args[0]);
                  case 2:
                    return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
                  case 3:
                    return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
                  case 4:
                    return un
                      ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
                }
                return fn.apply(that, args);
              };

              /***/
            },
            /* 152 */
            /***/ function (module, exports, __webpack_require__) {
              var global = __webpack_require__(3);
              var macrotask = __webpack_require__(83).set;
              var Observer = global.MutationObserver || global.WebKitMutationObserver;
              var process = global.process;
              var Promise = global.Promise;
              var isNode = __webpack_require__(25)(process) == 'process';

              module.exports = function () {
                var head, last, notify;

                var flush = function () {
                  var parent, fn;
                  if (isNode && (parent = process.domain)) parent.exit();
                  while (head) {
                    fn = head.fn;
                    head = head.next;
                    try {
                      fn();
                    } catch (e) {
                      if (head) notify();
                      else last = undefined;
                      throw e;
                    }
                  }
                  last = undefined;
                  if (parent) parent.enter();
                };

                // Node.js
                if (isNode) {
                  notify = function () {
                    process.nextTick(flush);
                  };
                  // browsers with MutationObserver
                } else if (Observer) {
                  var toggle = true;
                  var node = document.createTextNode('');
                  new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
                  notify = function () {
                    node.data = toggle = !toggle;
                  };
                  // environments with maybe non-completely correct, but existent Promise
                } else if (Promise && Promise.resolve) {
                  var promise = Promise.resolve();
                  notify = function () {
                    promise.then(flush);
                  };
                  // for other environments - macrotask based on:
                  // - setImmediate
                  // - MessageChannel
                  // - window.postMessag
                  // - onreadystatechange
                  // - setTimeout
                } else {
                  notify = function () {
                    // strange IE + webpack dev server bug - use .call(global)
                    macrotask.call(global, flush);
                  };
                }

                return function (fn) {
                  var task = { fn: fn, next: undefined };
                  if (last) last.next = task;
                  if (!head) {
                    head = task;
                    notify();
                  }
                  last = task;
                };
              };

              /***/
            },
            /* 153 */
            /***/ function (module, exports, __webpack_require__) {
              var hide = __webpack_require__(10);
              module.exports = function (target, src, safe) {
                for (var key in src) {
                  if (safe && target[key]) target[key] = src[key];
                  else hide(target, key, src[key]);
                }
                return target;
              };

              /***/
            },
            /* 154 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              var global = __webpack_require__(3);
              var core = __webpack_require__(2);
              var dP = __webpack_require__(8);
              var DESCRIPTORS = __webpack_require__(9);
              var SPECIES = __webpack_require__(4)('species');

              module.exports = function (KEY) {
                var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
                if (DESCRIPTORS && C && !C[SPECIES])
                  dP.f(C, SPECIES, {
                    configurable: true,
                    get: function () {
                      return this;
                    }
                  });
              };

              /***/
            },
            /* 155 */
            /***/ function (module, exports, __webpack_require__) {
              var ITERATOR = __webpack_require__(4)('iterator');
              var SAFE_CLOSING = false;

              try {
                var riter = [7][ITERATOR]();
                riter['return'] = function () {
                  SAFE_CLOSING = true;
                };
                // eslint-disable-next-line no-throw-literal
                Array.from(riter, function () {
                  throw 2;
                });
              } catch (e) {
                /* empty */
              }

              module.exports = function (exec, skipClosing) {
                if (!skipClosing && !SAFE_CLOSING) return false;
                var safe = false;
                try {
                  var arr = [7];
                  var iter = arr[ITERATOR]();
                  iter.next = function () {
                    return { done: (safe = true) };
                  };
                  arr[ITERATOR] = function () {
                    return iter;
                  };
                  exec(arr);
                } catch (e) {
                  /* empty */
                }
                return safe;
              };

              /***/
            },
            /* 156 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';
              // https://github.com/tc39/proposal-promise-finally

              var $export = __webpack_require__(6);
              var core = __webpack_require__(2);
              var global = __webpack_require__(3);
              var speciesConstructor = __webpack_require__(82);
              var promiseResolve = __webpack_require__(85);

              $export($export.P + $export.R, 'Promise', {
                finally: function (onFinally) {
                  var C = speciesConstructor(this, core.Promise || global.Promise);
                  var isFunction = typeof onFinally == 'function';
                  return this.then(
                    isFunction
                      ? function (x) {
                          return promiseResolve(C, onFinally()).then(function () {
                            return x;
                          });
                        }
                      : onFinally,
                    isFunction
                      ? function (e) {
                          return promiseResolve(C, onFinally()).then(function () {
                            throw e;
                          });
                        }
                      : onFinally
                  );
                }
              });

              /***/
            },
            /* 157 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              // https://github.com/tc39/proposal-promise-try
              var $export = __webpack_require__(6);
              var newPromiseCapability = __webpack_require__(52);
              var perform = __webpack_require__(84);

              $export($export.S, 'Promise', {
                try: function (callbackfn) {
                  var promiseCapability = newPromiseCapability.f(this);
                  var result = perform(callbackfn);
                  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
                  return promiseCapability.promise;
                }
              });

              /***/
            },
            /* 158 */
            /***/ function (module, exports, __webpack_require__) {
              __webpack_require__(159);
              module.exports = __webpack_require__(2).Object.assign;

              /***/
            },
            /* 159 */
            /***/ function (module, exports, __webpack_require__) {
              // 19.1.3.1 Object.assign(target, source)
              var $export = __webpack_require__(6);

              $export($export.S + $export.F, 'Object', { assign: __webpack_require__(160) });

              /***/
            },
            /* 160 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              // 19.1.2.1 Object.assign(target, source, ...)
              var getKeys = __webpack_require__(18);
              var gOPS = __webpack_require__(51);
              var pIE = __webpack_require__(26);
              var toObject = __webpack_require__(34);
              var IObject = __webpack_require__(64);
              var $assign = Object.assign;

              // should work with symbols and should have deterministic property order (V8 bug)
              module.exports =
                !$assign ||
                __webpack_require__(17)(function () {
                  var A = {};
                  var B = {};
                  // eslint-disable-next-line no-undef
                  var S = Symbol();
                  var K = 'abcdefghijklmnopqrst';
                  A[S] = 7;
                  K.split('').forEach(function (k) {
                    B[k] = k;
                  });
                  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
                })
                  ? function assign(target, source) {
                      // eslint-disable-line no-unused-vars
                      var T = toObject(target);
                      var aLen = arguments.length;
                      var index = 1;
                      var getSymbols = gOPS.f;
                      var isEnum = pIE.f;
                      while (aLen > index) {
                        var S = IObject(arguments[index++]);
                        var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
                        var length = keys.length;
                        var j = 0;
                        var key;
                        while (length > j) if (isEnum.call(S, (key = keys[j++]))) T[key] = S[key];
                      }
                      return T;
                    }
                  : $assign;

              /***/
            },
            /* 161 */
            /***/ function (module, exports, __webpack_require__) {
              // This method of obtaining a reference to the global object needs to be
              // kept identical to the way it is obtained in runtime.js
              var g =
                (function () {
                  return this;
                })() || Function('return this')();

              // Use `getOwnPropertyNames` because not all browsers support calling
              // `hasOwnProperty` on the global `self` object in a worker. See #183.
              var hadRuntime = g.regeneratorRuntime && Object.getOwnPropertyNames(g).indexOf('regeneratorRuntime') >= 0;

              // Save the old regeneratorRuntime in case it needs to be restored later.
              var oldRuntime = hadRuntime && g.regeneratorRuntime;

              // Force reevalutation of runtime.js.
              g.regeneratorRuntime = undefined;

              module.exports = __webpack_require__(162);

              if (hadRuntime) {
                // Restore the original runtime.
                g.regeneratorRuntime = oldRuntime;
              } else {
                // Remove the global property added by runtime.js.
                try {
                  delete g.regeneratorRuntime;
                } catch (e) {
                  g.regeneratorRuntime = undefined;
                }
              }

              /***/
            },
            /* 162 */
            /***/ function (module, exports) {
              /**
               * Copyright (c) 2014, Facebook, Inc.
               * All rights reserved.
               *
               * This source code is licensed under the BSD-style license found in the
               * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
               * additional grant of patent rights can be found in the PATENTS file in
               * the same directory.
               */

              !(function (global) {
                'use strict';

                var Op = Object.prototype;
                var hasOwn = Op.hasOwnProperty;
                var undefined; // More compressible than void 0.
                var $Symbol = typeof Symbol === 'function' ? Symbol : {};
                var iteratorSymbol = $Symbol.iterator || '@@iterator';
                var asyncIteratorSymbol = $Symbol.asyncIterator || '@@asyncIterator';
                var toStringTagSymbol = $Symbol.toStringTag || '@@toStringTag';

                var inModule = typeof module === 'object';
                var runtime = global.regeneratorRuntime;
                if (runtime) {
                  if (inModule) {
                    // If regeneratorRuntime is defined globally and we're in a module,
                    // make the exports object identical to regeneratorRuntime.
                    module.exports = runtime;
                  }
                  // Don't bother evaluating the rest of this file if the runtime was
                  // already defined globally.
                  return;
                }

                // Define the runtime globally (as expected by generated code) as either
                // module.exports (if we're in a module) or a new, empty object.
                runtime = global.regeneratorRuntime = inModule ? module.exports : {};

                function wrap(innerFn, outerFn, self, tryLocsList) {
                  // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
                  var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
                  var generator = Object.create(protoGenerator.prototype);
                  var context = new Context(tryLocsList || []);

                  // The ._invoke method unifies the implementations of the .next,
                  // .throw, and .return methods.
                  generator._invoke = makeInvokeMethod(innerFn, self, context);

                  return generator;
                }
                runtime.wrap = wrap;

                // Try/catch helper to minimize deoptimizations. Returns a completion
                // record like context.tryEntries[i].completion. This interface could
                // have been (and was previously) designed to take a closure to be
                // invoked without arguments, but in all the cases we care about we
                // already have an existing method we want to call, so there's no need
                // to create a new function object. We can even get away with assuming
                // the method takes exactly one argument, since that happens to be true
                // in every case, so we don't have to touch the arguments object. The
                // only additional allocation required is the completion record, which
                // has a stable shape and so hopefully should be cheap to allocate.
                function tryCatch(fn, obj, arg) {
                  try {
                    return { type: 'normal', arg: fn.call(obj, arg) };
                  } catch (err) {
                    return { type: 'throw', arg: err };
                  }
                }

                var GenStateSuspendedStart = 'suspendedStart';
                var GenStateSuspendedYield = 'suspendedYield';
                var GenStateExecuting = 'executing';
                var GenStateCompleted = 'completed';

                // Returning this object from the innerFn has the same effect as
                // breaking out of the dispatch switch statement.
                var ContinueSentinel = {};

                // Dummy constructor functions that we use as the .constructor and
                // .constructor.prototype properties for functions that return Generator
                // objects. For full spec compliance, you may wish to configure your
                // minifier not to mangle the names of these two functions.
                function Generator() {}
                function GeneratorFunction() {}
                function GeneratorFunctionPrototype() {}

                // This is a polyfill for %IteratorPrototype% for environments that
                // don't natively support it.
                var IteratorPrototype = {};
                IteratorPrototype[iteratorSymbol] = function () {
                  return this;
                };

                var getProto = Object.getPrototypeOf;
                var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
                if (
                  NativeIteratorPrototype &&
                  NativeIteratorPrototype !== Op &&
                  hasOwn.call(NativeIteratorPrototype, iteratorSymbol)
                ) {
                  // This environment has a native %IteratorPrototype%; use it instead
                  // of the polyfill.
                  IteratorPrototype = NativeIteratorPrototype;
                }

                var Gp =
                  (GeneratorFunctionPrototype.prototype =
                  Generator.prototype =
                    Object.create(IteratorPrototype));
                GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
                GeneratorFunctionPrototype.constructor = GeneratorFunction;
                GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = 'GeneratorFunction';

                // Helper for defining the .next, .throw, and .return methods of the
                // Iterator interface in terms of a single ._invoke method.
                function defineIteratorMethods(prototype) {
                  ['next', 'throw', 'return'].forEach(function (method) {
                    prototype[method] = function (arg) {
                      return this._invoke(method, arg);
                    };
                  });
                }

                runtime.isGeneratorFunction = function (genFun) {
                  var ctor = typeof genFun === 'function' && genFun.constructor;
                  return ctor
                    ? ctor === GeneratorFunction ||
                        // For the native GeneratorFunction constructor, the best we can
                        // do is to check its .name property.
                        (ctor.displayName || ctor.name) === 'GeneratorFunction'
                    : false;
                };

                runtime.mark = function (genFun) {
                  if (Object.setPrototypeOf) {
                    Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
                  } else {
                    genFun.__proto__ = GeneratorFunctionPrototype;
                    if (!(toStringTagSymbol in genFun)) {
                      genFun[toStringTagSymbol] = 'GeneratorFunction';
                    }
                  }
                  genFun.prototype = Object.create(Gp);
                  return genFun;
                };

                // Within the body of any async function, `await x` is transformed to
                // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
                // `hasOwn.call(value, "__await")` to determine if the yielded value is
                // meant to be awaited.
                runtime.awrap = function (arg) {
                  return { __await: arg };
                };

                function AsyncIterator(generator) {
                  function invoke(method, arg, resolve, reject) {
                    var record = tryCatch(generator[method], generator, arg);
                    if (record.type === 'throw') {
                      reject(record.arg);
                    } else {
                      var result = record.arg;
                      var value = result.value;
                      if (value && typeof value === 'object' && hasOwn.call(value, '__await')) {
                        return Promise.resolve(value.__await).then(
                          function (value) {
                            invoke('next', value, resolve, reject);
                          },
                          function (err) {
                            invoke('throw', err, resolve, reject);
                          }
                        );
                      }

                      return Promise.resolve(value).then(function (unwrapped) {
                        // When a yielded Promise is resolved, its final value becomes
                        // the .value of the Promise<{value,done}> result for the
                        // current iteration. If the Promise is rejected, however, the
                        // result for this iteration will be rejected with the same
                        // reason. Note that rejections of yielded Promises are not
                        // thrown back into the generator function, as is the case
                        // when an awaited Promise is rejected. This difference in
                        // behavior between yield and await is important, because it
                        // allows the consumer to decide what to do with the yielded
                        // rejection (swallow it and continue, manually .throw it back
                        // into the generator, abandon iteration, whatever). With
                        // await, by contrast, there is no opportunity to examine the
                        // rejection reason outside the generator function, so the
                        // only option is to throw it from the await expression, and
                        // let the generator function handle the exception.
                        result.value = unwrapped;
                        resolve(result);
                      }, reject);
                    }
                  }

                  var previousPromise;

                  function enqueue(method, arg) {
                    function callInvokeWithMethodAndArg() {
                      return new Promise(function (resolve, reject) {
                        invoke(method, arg, resolve, reject);
                      });
                    }

                    return (previousPromise =
                      // If enqueue has been called before, then we want to wait until
                      // all previous Promises have been resolved before calling invoke,
                      // so that results are always delivered in the correct order. If
                      // enqueue has not been called before, then it is important to
                      // call invoke immediately, without waiting on a callback to fire,
                      // so that the async generator function has the opportunity to do
                      // any necessary setup in a predictable way. This predictability
                      // is why the Promise constructor synchronously invokes its
                      // executor callback, and why async functions synchronously
                      // execute code before the first await. Since we implement simple
                      // async functions in terms of async generators, it is especially
                      // important to get this right, even though it requires care.
                      previousPromise
                        ? previousPromise.then(
                            callInvokeWithMethodAndArg,
                            // Avoid propagating failures to Promises returned by later
                            // invocations of the iterator.
                            callInvokeWithMethodAndArg
                          )
                        : callInvokeWithMethodAndArg());
                  }

                  // Define the unified helper method that is used to implement .next,
                  // .throw, and .return (see defineIteratorMethods).
                  this._invoke = enqueue;
                }

                defineIteratorMethods(AsyncIterator.prototype);
                AsyncIterator.prototype[asyncIteratorSymbol] = function () {
                  return this;
                };
                runtime.AsyncIterator = AsyncIterator;

                // Note that simple async functions are implemented on top of
                // AsyncIterator objects; they just return a Promise for the value of
                // the final result produced by the iterator.
                runtime.async = function (innerFn, outerFn, self, tryLocsList) {
                  var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));

                  return runtime.isGeneratorFunction(outerFn)
                    ? iter // If outerFn is a generator, return the full iterator.
                    : iter.next().then(function (result) {
                        return result.done ? result.value : iter.next();
                      });
                };

                function makeInvokeMethod(innerFn, self, context) {
                  var state = GenStateSuspendedStart;

                  return function invoke(method, arg) {
                    if (state === GenStateExecuting) {
                      throw new Error('Generator is already running');
                    }

                    if (state === GenStateCompleted) {
                      if (method === 'throw') {
                        throw arg;
                      }

                      // Be forgiving, per 25.3.3.3.3 of the spec:
                      // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                      return doneResult();
                    }

                    context.method = method;
                    context.arg = arg;

                    while (true) {
                      var delegate = context.delegate;
                      if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                          if (delegateResult === ContinueSentinel) continue;
                          return delegateResult;
                        }
                      }

                      if (context.method === 'next') {
                        // Setting context._sent for legacy support of Babel's
                        // function.sent implementation.
                        context.sent = context._sent = context.arg;
                      } else if (context.method === 'throw') {
                        if (state === GenStateSuspendedStart) {
                          state = GenStateCompleted;
                          throw context.arg;
                        }

                        context.dispatchException(context.arg);
                      } else if (context.method === 'return') {
                        context.abrupt('return', context.arg);
                      }

                      state = GenStateExecuting;

                      var record = tryCatch(innerFn, self, context);
                      if (record.type === 'normal') {
                        // If an exception is thrown from innerFn, we leave state ===
                        // GenStateExecuting and loop back for another invocation.
                        state = context.done ? GenStateCompleted : GenStateSuspendedYield;

                        if (record.arg === ContinueSentinel) {
                          continue;
                        }

                        return {
                          value: record.arg,
                          done: context.done
                        };
                      } else if (record.type === 'throw') {
                        state = GenStateCompleted;
                        // Dispatch the exception by looping back around to the
                        // context.dispatchException(context.arg) call above.
                        context.method = 'throw';
                        context.arg = record.arg;
                      }
                    }
                  };
                }

                // Call delegate.iterator[context.method](context.arg) and handle the
                // result, either by returning a { value, done } result from the
                // delegate iterator, or by modifying context.method and context.arg,
                // setting context.delegate to null, and returning the ContinueSentinel.
                function maybeInvokeDelegate(delegate, context) {
                  var method = delegate.iterator[context.method];
                  if (method === undefined) {
                    // A .throw or .return when the delegate iterator has no .throw
                    // method always terminates the yield* loop.
                    context.delegate = null;

                    if (context.method === 'throw') {
                      if (delegate.iterator.return) {
                        // If the delegate iterator has a return method, give it a
                        // chance to clean up.
                        context.method = 'return';
                        context.arg = undefined;
                        maybeInvokeDelegate(delegate, context);

                        if (context.method === 'throw') {
                          // If maybeInvokeDelegate(context) changed context.method from
                          // "return" to "throw", let that override the TypeError below.
                          return ContinueSentinel;
                        }
                      }

                      context.method = 'throw';
                      context.arg = new TypeError("The iterator does not provide a 'throw' method");
                    }

                    return ContinueSentinel;
                  }

                  var record = tryCatch(method, delegate.iterator, context.arg);

                  if (record.type === 'throw') {
                    context.method = 'throw';
                    context.arg = record.arg;
                    context.delegate = null;
                    return ContinueSentinel;
                  }

                  var info = record.arg;

                  if (!info) {
                    context.method = 'throw';
                    context.arg = new TypeError('iterator result is not an object');
                    context.delegate = null;
                    return ContinueSentinel;
                  }

                  if (info.done) {
                    // Assign the result of the finished delegate to the temporary
                    // variable specified by delegate.resultName (see delegateYield).
                    context[delegate.resultName] = info.value;

                    // Resume execution at the desired location (see delegateYield).
                    context.next = delegate.nextLoc;

                    // If context.method was "throw" but the delegate handled the
                    // exception, let the outer generator proceed normally. If
                    // context.method was "next", forget context.arg since it has been
                    // "consumed" by the delegate iterator. If context.method was
                    // "return", allow the original .return call to continue in the
                    // outer generator.
                    if (context.method !== 'return') {
                      context.method = 'next';
                      context.arg = undefined;
                    }
                  } else {
                    // Re-yield the result returned by the delegate method.
                    return info;
                  }

                  // The delegate iterator is finished, so forget it and continue with
                  // the outer generator.
                  context.delegate = null;
                  return ContinueSentinel;
                }

                // Define Generator.prototype.{next,throw,return} in terms of the
                // unified ._invoke helper method.
                defineIteratorMethods(Gp);

                Gp[toStringTagSymbol] = 'Generator';

                // A Generator should always return itself as the iterator object when the
                // @@iterator function is called on it. Some browsers' implementations of the
                // iterator prototype chain incorrectly implement this, causing the Generator
                // object to not be returned from this call. This ensures that doesn't happen.
                // See https://github.com/facebook/regenerator/issues/274 for more details.
                Gp[iteratorSymbol] = function () {
                  return this;
                };

                Gp.toString = function () {
                  return '[object Generator]';
                };

                function pushTryEntry(locs) {
                  var entry = { tryLoc: locs[0] };

                  if (1 in locs) {
                    entry.catchLoc = locs[1];
                  }

                  if (2 in locs) {
                    entry.finallyLoc = locs[2];
                    entry.afterLoc = locs[3];
                  }

                  this.tryEntries.push(entry);
                }

                function resetTryEntry(entry) {
                  var record = entry.completion || {};
                  record.type = 'normal';
                  delete record.arg;
                  entry.completion = record;
                }

                function Context(tryLocsList) {
                  // The root entry object (effectively a try statement without a catch
                  // or a finally block) gives us a place to store values thrown from
                  // locations where there is no enclosing try statement.
                  this.tryEntries = [{ tryLoc: 'root' }];
                  tryLocsList.forEach(pushTryEntry, this);
                  this.reset(true);
                }

                runtime.keys = function (object) {
                  var keys = [];
                  for (var key in object) {
                    keys.push(key);
                  }
                  keys.reverse();

                  // Rather than returning an object with a next method, we keep
                  // things simple and return the next function itself.
                  return function next() {
                    while (keys.length) {
                      var key = keys.pop();
                      if (key in object) {
                        next.value = key;
                        next.done = false;
                        return next;
                      }
                    }

                    // To avoid creating an additional object, we just hang the .value
                    // and .done properties off the next function object itself. This
                    // also ensures that the minifier will not anonymize the function.
                    next.done = true;
                    return next;
                  };
                };

                function values(iterable) {
                  if (iterable) {
                    var iteratorMethod = iterable[iteratorSymbol];
                    if (iteratorMethod) {
                      return iteratorMethod.call(iterable);
                    }

                    if (typeof iterable.next === 'function') {
                      return iterable;
                    }

                    if (!isNaN(iterable.length)) {
                      var i = -1,
                        next = function next() {
                          while (++i < iterable.length) {
                            if (hasOwn.call(iterable, i)) {
                              next.value = iterable[i];
                              next.done = false;
                              return next;
                            }
                          }

                          next.value = undefined;
                          next.done = true;

                          return next;
                        };

                      return (next.next = next);
                    }
                  }

                  // Return an iterator with no values.
                  return { next: doneResult };
                }
                runtime.values = values;

                function doneResult() {
                  return { value: undefined, done: true };
                }

                Context.prototype = {
                  constructor: Context,

                  reset: function (skipTempReset) {
                    this.prev = 0;
                    this.next = 0;
                    // Resetting context._sent for legacy support of Babel's
                    // function.sent implementation.
                    this.sent = this._sent = undefined;
                    this.done = false;
                    this.delegate = null;

                    this.method = 'next';
                    this.arg = undefined;

                    this.tryEntries.forEach(resetTryEntry);

                    if (!skipTempReset) {
                      for (var name in this) {
                        // Not sure about the optimal order of these conditions:
                        if (name.charAt(0) === 't' && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                          this[name] = undefined;
                        }
                      }
                    }
                  },

                  stop: function () {
                    this.done = true;

                    var rootEntry = this.tryEntries[0];
                    var rootRecord = rootEntry.completion;
                    if (rootRecord.type === 'throw') {
                      throw rootRecord.arg;
                    }

                    return this.rval;
                  },

                  dispatchException: function (exception) {
                    if (this.done) {
                      throw exception;
                    }

                    var context = this;
                    function handle(loc, caught) {
                      record.type = 'throw';
                      record.arg = exception;
                      context.next = loc;

                      if (caught) {
                        // If the dispatched exception was caught by a catch block,
                        // then let that catch block handle the exception normally.
                        context.method = 'next';
                        context.arg = undefined;
                      }

                      return !!caught;
                    }

                    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                      var entry = this.tryEntries[i];
                      var record = entry.completion;

                      if (entry.tryLoc === 'root') {
                        // Exception thrown outside of any try block that could handle
                        // it, so set the completion value of the entire function to
                        // throw the exception.
                        return handle('end');
                      }

                      if (entry.tryLoc <= this.prev) {
                        var hasCatch = hasOwn.call(entry, 'catchLoc');
                        var hasFinally = hasOwn.call(entry, 'finallyLoc');

                        if (hasCatch && hasFinally) {
                          if (this.prev < entry.catchLoc) {
                            return handle(entry.catchLoc, true);
                          } else if (this.prev < entry.finallyLoc) {
                            return handle(entry.finallyLoc);
                          }
                        } else if (hasCatch) {
                          if (this.prev < entry.catchLoc) {
                            return handle(entry.catchLoc, true);
                          }
                        } else if (hasFinally) {
                          if (this.prev < entry.finallyLoc) {
                            return handle(entry.finallyLoc);
                          }
                        } else {
                          throw new Error('try statement without catch or finally');
                        }
                      }
                    }
                  },

                  abrupt: function (type, arg) {
                    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                      var entry = this.tryEntries[i];
                      if (
                        entry.tryLoc <= this.prev &&
                        hasOwn.call(entry, 'finallyLoc') &&
                        this.prev < entry.finallyLoc
                      ) {
                        var finallyEntry = entry;
                        break;
                      }
                    }

                    if (
                      finallyEntry &&
                      (type === 'break' || type === 'continue') &&
                      finallyEntry.tryLoc <= arg &&
                      arg <= finallyEntry.finallyLoc
                    ) {
                      // Ignore the finally entry if control is not jumping to a
                      // location outside the try/catch block.
                      finallyEntry = null;
                    }

                    var record = finallyEntry ? finallyEntry.completion : {};
                    record.type = type;
                    record.arg = arg;

                    if (finallyEntry) {
                      this.method = 'next';
                      this.next = finallyEntry.finallyLoc;
                      return ContinueSentinel;
                    }

                    return this.complete(record);
                  },

                  complete: function (record, afterLoc) {
                    if (record.type === 'throw') {
                      throw record.arg;
                    }

                    if (record.type === 'break' || record.type === 'continue') {
                      this.next = record.arg;
                    } else if (record.type === 'return') {
                      this.rval = this.arg = record.arg;
                      this.method = 'return';
                      this.next = 'end';
                    } else if (record.type === 'normal' && afterLoc) {
                      this.next = afterLoc;
                    }

                    return ContinueSentinel;
                  },

                  finish: function (finallyLoc) {
                    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                      var entry = this.tryEntries[i];
                      if (entry.finallyLoc === finallyLoc) {
                        this.complete(entry.completion, entry.afterLoc);
                        resetTryEntry(entry);
                        return ContinueSentinel;
                      }
                    }
                  },

                  catch: function (tryLoc) {
                    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                      var entry = this.tryEntries[i];
                      if (entry.tryLoc === tryLoc) {
                        var record = entry.completion;
                        if (record.type === 'throw') {
                          var thrown = record.arg;
                          resetTryEntry(entry);
                        }
                        return thrown;
                      }
                    }

                    // The context.catch method must only be called with a location
                    // argument that corresponds to a known catch block.
                    throw new Error('illegal catch attempt');
                  },

                  delegateYield: function (iterable, resultName, nextLoc) {
                    this.delegate = {
                      iterator: values(iterable),
                      resultName: resultName,
                      nextLoc: nextLoc
                    };

                    if (this.method === 'next') {
                      // Deliberately forget the last sent value so that we don't
                      // accidentally pass it on to the delegate.
                      this.arg = undefined;
                    }

                    return ContinueSentinel;
                  }
                };
              })(
                // In sloppy mode, unbound `this` refers to the global object, fallback to
                // Function constructor if we're in global strict mode. That is sadly a form
                // of indirect eval which violates Content Security Policy.
                (function () {
                  return this;
                })() || Function('return this')()
              );

              /***/
            },
            /* 163 */
            /***/ function (module, exports) {
              /***/
            },
            /* 164 */
            /***/ function (module, exports, __webpack_require__) {
              var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__; /* global define, Promise */
              (function (root, factory) {
                'use strict';
                if (typeof module === 'object' && module.exports && 'function' === 'function') {
                  // CommonJS
                  module.exports = factory();
                } else if (true) {
                  // AMD. Register as an anonymous module.
                  !((__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
                  (__WEBPACK_AMD_DEFINE_RESULT__ =
                    typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function'
                      ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)
                      : __WEBPACK_AMD_DEFINE_FACTORY__),
                  __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
                } else {
                  // Browser globals
                  root.Queue = factory();
                }
              })(this, function () {
                'use strict';

                /**
                 * @return {Object}
                 */
                var LocalPromise =
                  typeof Promise !== 'undefined'
                    ? Promise
                    : function () {
                        return {
                          then: function () {
                            throw new Error('Queue.configure() before use Queue');
                          }
                        };
                      };

                var noop = function () {};

                /**
                 * @param {*} value
                 * @returns {LocalPromise}
                 */
                var resolveWith = function (value) {
                  if (value && typeof value.then === 'function') {
                    return value;
                  }

                  return new LocalPromise(function (resolve) {
                    resolve(value);
                  });
                };

                /**
                 * It limits concurrently executed promises
                 *
                 * @param {Number} [maxPendingPromises=Infinity] max number of concurrently executed promises
                 * @param {Number} [maxQueuedPromises=Infinity]  max number of queued promises
                 * @constructor
                 *
                 * @example
                 *
                 * var queue = new Queue(1);
                 *
                 * queue.add(function () {
                 *     // resolve of this promise will resume next request
                 *     return downloadTarballFromGithub(url, file);
                 * })
                 * .then(function (file) {
                 *     doStuffWith(file);
                 * });
                 *
                 * queue.add(function () {
                 *     return downloadTarballFromGithub(url, file);
                 * })
                 * // This request will be paused
                 * .then(function (file) {
                 *     doStuffWith(file);
                 * });
                 */
                function Queue(maxPendingPromises, maxQueuedPromises) {
                  this.pendingPromises = 0;
                  this.maxPendingPromises = typeof maxPendingPromises !== 'undefined' ? maxPendingPromises : Infinity;
                  this.maxQueuedPromises = typeof maxQueuedPromises !== 'undefined' ? maxQueuedPromises : Infinity;
                  this.queue = [];
                }

                /**
                 * Defines promise promiseFactory
                 * @param {Function} GlobalPromise
                 */
                Queue.configure = function (GlobalPromise) {
                  LocalPromise = GlobalPromise;
                };

                /**
                 * @param {Function} promiseGenerator
                 * @return {LocalPromise}
                 */
                Queue.prototype.add = function (promiseGenerator) {
                  var self = this;
                  return new LocalPromise(function (resolve, reject, notify) {
                    // Do not queue to much promises
                    if (self.queue.length >= self.maxQueuedPromises) {
                      reject(new Error('Queue limit reached'));
                      return;
                    }

                    // Add to queue
                    self.queue.push({
                      promiseGenerator: promiseGenerator,
                      resolve: resolve,
                      reject: reject,
                      notify: notify || noop
                    });

                    self._dequeue();
                  });
                };

                /**
                 * Number of simultaneously running promises (which are resolving)
                 *
                 * @return {number}
                 */
                Queue.prototype.getPendingLength = function () {
                  return this.pendingPromises;
                };

                /**
                 * Number of queued promises (which are waiting)
                 *
                 * @return {number}
                 */
                Queue.prototype.getQueueLength = function () {
                  return this.queue.length;
                };

                /**
                 * @returns {boolean} true if first item removed from queue
                 * @private
                 */
                Queue.prototype._dequeue = function () {
                  var self = this;
                  if (this.pendingPromises >= this.maxPendingPromises) {
                    return false;
                  }

                  // Remove from queue
                  var item = this.queue.shift();
                  if (!item) {
                    return false;
                  }

                  try {
                    this.pendingPromises++;

                    resolveWith(item.promiseGenerator())
                      // Forward all stuff
                      .then(
                        function (value) {
                          // It is not pending now
                          self.pendingPromises--;
                          // It should pass values
                          item.resolve(value);
                          self._dequeue();
                        },
                        function (err) {
                          // It is not pending now
                          self.pendingPromises--;
                          // It should not mask errors
                          item.reject(err);
                          self._dequeue();
                        },
                        function (message) {
                          // It should pass notifications
                          item.notify(message);
                        }
                      );
                  } catch (err) {
                    self.pendingPromises--;
                    item.reject(err);
                    self._dequeue();
                  }

                  return true;
                };

                return Queue;
              });

              /***/
            },
            /* 165 */
            /***/ function (module, exports) {
              exports = module.exports = typeof Object.keys === 'function' ? Object.keys : shim;

              exports.shim = shim;
              function shim(obj) {
                var keys = [];
                for (var key in obj) keys.push(key);
                return keys;
              }

              /***/
            },
            /* 166 */
            /***/ function (module, exports) {
              var supportsArgumentsClass =
                (function () {
                  return Object.prototype.toString.call(arguments);
                })() == '[object Arguments]';

              exports = module.exports = supportsArgumentsClass ? supported : unsupported;

              exports.supported = supported;
              function supported(object) {
                return Object.prototype.toString.call(object) == '[object Arguments]';
              }

              exports.unsupported = unsupported;
              function unsupported(object) {
                return (
                  (object &&
                    typeof object == 'object' &&
                    typeof object.length == 'number' &&
                    Object.prototype.hasOwnProperty.call(object, 'callee') &&
                    !Object.prototype.propertyIsEnumerable.call(object, 'callee')) ||
                  false
                );
              }

              /***/
            },
            /* 167 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(90);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(
                __WEBPACK_IMPORTED_MODULE_0_axios__
              );

              /* harmony default export */ __webpack_exports__['a'] =
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
                  timeout: 10000
                });

              /***/
            },
            /* 168 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              var utils = __webpack_require__(5);
              var bind = __webpack_require__(91);
              var Axios = __webpack_require__(170);
              var defaults = __webpack_require__(56);

              /**
               * Create an instance of Axios
               *
               * @param {Object} defaultConfig The default config for the instance
               * @return {Axios} A new instance of Axios
               */
              function createInstance(defaultConfig) {
                var context = new Axios(defaultConfig);
                var instance = bind(Axios.prototype.request, context);

                // Copy axios.prototype to instance
                utils.extend(instance, Axios.prototype, context);

                // Copy context to instance
                utils.extend(instance, context);

                return instance;
              }

              // Create the default instance to be exported
              var axios = createInstance(defaults);

              // Expose Axios class to allow class inheritance
              axios.Axios = Axios;

              // Factory for creating new instances
              axios.create = function create(instanceConfig) {
                return createInstance(utils.merge(defaults, instanceConfig));
              };

              // Expose Cancel & CancelToken
              axios.Cancel = __webpack_require__(95);
              axios.CancelToken = __webpack_require__(184);
              axios.isCancel = __webpack_require__(94);

              // Expose all/spread
              axios.all = function all(promises) {
                return Promise.all(promises);
              };
              axios.spread = __webpack_require__(185);

              module.exports = axios;

              // Allow use of default import syntax in TypeScript
              module.exports.default = axios;

              /***/
            },
            /* 169 */
            /***/ function (module, exports) {
              /*!
               * Determine if an object is a Buffer
               *
               * @author   Feross Aboukhadijeh <https://feross.org>
               * @license  MIT
               */

              // The _isBuffer check is for Safari 5-7 support, because it's missing
              // Object.prototype.constructor. Remove this eventually
              module.exports = function (obj) {
                return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
              };

              function isBuffer(obj) {
                return (
                  !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
                );
              }

              // For Node v0.10 support. Remove this eventually.
              function isSlowBuffer(obj) {
                return (
                  typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
                );
              }

              /***/
            },
            /* 170 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              var defaults = __webpack_require__(56);
              var utils = __webpack_require__(5);
              var InterceptorManager = __webpack_require__(179);
              var dispatchRequest = __webpack_require__(180);

              /**
               * Create a new instance of Axios
               *
               * @param {Object} instanceConfig The default config for the instance
               */
              function Axios(instanceConfig) {
                this.defaults = instanceConfig;
                this.interceptors = {
                  request: new InterceptorManager(),
                  response: new InterceptorManager()
                };
              }

              /**
               * Dispatch a request
               *
               * @param {Object} config The config specific for this request (merged with this.defaults)
               */
              Axios.prototype.request = function request(config) {
                /*eslint no-param-reassign:0*/
                // Allow for axios('example/url'[, config]) a la fetch API
                if (typeof config === 'string') {
                  config = utils.merge(
                    {
                      url: arguments[0]
                    },
                    arguments[1]
                  );
                }

                config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
                config.method = config.method.toLowerCase();

                // Hook up interceptors middleware
                var chain = [dispatchRequest, undefined];
                var promise = Promise.resolve(config);

                this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
                  chain.unshift(interceptor.fulfilled, interceptor.rejected);
                });

                this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
                  chain.push(interceptor.fulfilled, interceptor.rejected);
                });

                while (chain.length) {
                  promise = promise.then(chain.shift(), chain.shift());
                }

                return promise;
              };

              // Provide aliases for supported request methods
              utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
                /*eslint func-names:0*/
                Axios.prototype[method] = function (url, config) {
                  return this.request(
                    utils.merge(config || {}, {
                      method: method,
                      url: url
                    })
                  );
                };
              });

              utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
                /*eslint func-names:0*/
                Axios.prototype[method] = function (url, data, config) {
                  return this.request(
                    utils.merge(config || {}, {
                      method: method,
                      url: url,
                      data: data
                    })
                  );
                };
              });

              module.exports = Axios;

              /***/
            },
            /* 171 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              var utils = __webpack_require__(5);

              module.exports = function normalizeHeaderName(headers, normalizedName) {
                utils.forEach(headers, function processHeader(value, name) {
                  if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
                    headers[normalizedName] = value;
                    delete headers[name];
                  }
                });
              };

              /***/
            },
            /* 172 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              var createError = __webpack_require__(93);

              /**
               * Resolve or reject a Promise based on response status.
               *
               * @param {Function} resolve A function that resolves the promise.
               * @param {Function} reject A function that rejects the promise.
               * @param {object} response The response.
               */
              module.exports = function settle(resolve, reject, response) {
                var validateStatus = response.config.validateStatus;
                // Note: status is not exposed by XDomainRequest
                if (!response.status || !validateStatus || validateStatus(response.status)) {
                  resolve(response);
                } else {
                  reject(
                    createError(
                      'Request failed with status code ' + response.status,
                      response.config,
                      null,
                      response.request,
                      response
                    )
                  );
                }
              };

              /***/
            },
            /* 173 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              /**
               * Update an Error with the specified config, error code, and response.
               *
               * @param {Error} error The error to update.
               * @param {Object} config The config.
               * @param {string} [code] The error code (for example, 'ECONNABORTED').
               * @param {Object} [request] The request.
               * @param {Object} [response] The response.
               * @returns {Error} The error.
               */
              module.exports = function enhanceError(error, config, code, request, response) {
                error.config = config;
                if (code) {
                  error.code = code;
                }
                error.request = request;
                error.response = response;
                return error;
              };

              /***/
            },
            /* 174 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              var utils = __webpack_require__(5);

              function encode(val) {
                return encodeURIComponent(val)
                  .replace(/%40/gi, '@')
                  .replace(/%3A/gi, ':')
                  .replace(/%24/g, '$')
                  .replace(/%2C/gi, ',')
                  .replace(/%20/g, '+')
                  .replace(/%5B/gi, '[')
                  .replace(/%5D/gi, ']');
              }

              /**
               * Build a URL by appending params to the end
               *
               * @param {string} url The base of the url (e.g., http://www.google.com)
               * @param {object} [params] The params to be appended
               * @returns {string} The formatted url
               */
              module.exports = function buildURL(url, params, paramsSerializer) {
                /*eslint no-param-reassign:0*/
                if (!params) {
                  return url;
                }

                var serializedParams;
                if (paramsSerializer) {
                  serializedParams = paramsSerializer(params);
                } else if (utils.isURLSearchParams(params)) {
                  serializedParams = params.toString();
                } else {
                  var parts = [];

                  utils.forEach(params, function serialize(val, key) {
                    if (val === null || typeof val === 'undefined') {
                      return;
                    }

                    if (utils.isArray(val)) {
                      key = key + '[]';
                    }

                    if (!utils.isArray(val)) {
                      val = [val];
                    }

                    utils.forEach(val, function parseValue(v) {
                      if (utils.isDate(v)) {
                        v = v.toISOString();
                      } else if (utils.isObject(v)) {
                        v = JSON.stringify(v);
                      }
                      parts.push(encode(key) + '=' + encode(v));
                    });
                  });

                  serializedParams = parts.join('&');
                }

                if (serializedParams) {
                  url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
                }

                return url;
              };

              /***/
            },
            /* 175 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              var utils = __webpack_require__(5);

              // Headers whose duplicates are ignored by node
              // c.f. https://nodejs.org/api/http.html#http_message_headers
              var ignoreDuplicateOf = [
                'age',
                'authorization',
                'content-length',
                'content-type',
                'etag',
                'expires',
                'from',
                'host',
                'if-modified-since',
                'if-unmodified-since',
                'last-modified',
                'location',
                'max-forwards',
                'proxy-authorization',
                'referer',
                'retry-after',
                'user-agent'
              ];

              /**
               * Parse headers into an object
               *
               * ```
               * Date: Wed, 27 Aug 2014 08:58:49 GMT
               * Content-Type: application/json
               * Connection: keep-alive
               * Transfer-Encoding: chunked
               * ```
               *
               * @param {String} headers Headers needing to be parsed
               * @returns {Object} Headers parsed into an object
               */
              module.exports = function parseHeaders(headers) {
                var parsed = {};
                var key;
                var val;
                var i;

                if (!headers) {
                  return parsed;
                }

                utils.forEach(headers.split('\n'), function parser(line) {
                  i = line.indexOf(':');
                  key = utils.trim(line.substr(0, i)).toLowerCase();
                  val = utils.trim(line.substr(i + 1));

                  if (key) {
                    if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
                      return;
                    }
                    if (key === 'set-cookie') {
                      parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
                    } else {
                      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
                    }
                  }
                });

                return parsed;
              };

              /***/
            },
            /* 176 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              var utils = __webpack_require__(5);

              module.exports = utils.isStandardBrowserEnv()
                ? // Standard browser envs have full support of the APIs needed to test
                  // whether the request URL is of the same origin as current location.
                  (function standardBrowserEnv() {
                    var msie = /(msie|trident)/i.test(navigator.userAgent);
                    var urlParsingNode = document.createElement('a');
                    var originURL;

                    /**
                     * Parse a URL to discover it's components
                     *
                     * @param {String} url The URL to be parsed
                     * @returns {Object}
                     */
                    function resolveURL(url) {
                      var href = url;

                      if (msie) {
                        // IE needs attribute set twice to normalize properties
                        urlParsingNode.setAttribute('href', href);
                        href = urlParsingNode.href;
                      }

                      urlParsingNode.setAttribute('href', href);

                      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
                      return {
                        href: urlParsingNode.href,
                        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
                        host: urlParsingNode.host,
                        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
                        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
                        hostname: urlParsingNode.hostname,
                        port: urlParsingNode.port,
                        pathname:
                          urlParsingNode.pathname.charAt(0) === '/'
                            ? urlParsingNode.pathname
                            : '/' + urlParsingNode.pathname
                      };
                    }

                    originURL = resolveURL(window.location.href);

                    /**
                     * Determine if a URL shares the same origin as the current location
                     *
                     * @param {String} requestURL The URL to test
                     * @returns {boolean} True if URL shares the same origin, otherwise false
                     */
                    return function isURLSameOrigin(requestURL) {
                      var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
                      return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
                    };
                  })()
                : // Non standard browser envs (web workers, react-native) lack needed support.
                  (function nonStandardBrowserEnv() {
                    return function isURLSameOrigin() {
                      return true;
                    };
                  })();

              /***/
            },
            /* 177 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              // btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

              var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

              function E() {
                this.message = 'String contains an invalid character';
              }
              E.prototype = new Error();
              E.prototype.code = 5;
              E.prototype.name = 'InvalidCharacterError';

              function btoa(input) {
                var str = String(input);
                var output = '';
                for (
                  // initialize result and counter
                  var block, charCode, idx = 0, map = chars;
                  // if the next str index does not exist:
                  //   change the mapping table to "="
                  //   check if d has no fractional digits
                  str.charAt(idx | 0) || ((map = '='), idx % 1);
                  // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
                  output += map.charAt(63 & (block >> (8 - (idx % 1) * 8)))
                ) {
                  charCode = str.charCodeAt((idx += 3 / 4));
                  if (charCode > 0xff) {
                    throw new E();
                  }
                  block = (block << 8) | charCode;
                }
                return output;
              }

              module.exports = btoa;

              /***/
            },
            /* 178 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              var utils = __webpack_require__(5);

              module.exports = utils.isStandardBrowserEnv()
                ? // Standard browser envs support document.cookie
                  (function standardBrowserEnv() {
                    return {
                      write: function write(name, value, expires, path, domain, secure) {
                        var cookie = [];
                        cookie.push(name + '=' + encodeURIComponent(value));

                        if (utils.isNumber(expires)) {
                          cookie.push('expires=' + new Date(expires).toGMTString());
                        }

                        if (utils.isString(path)) {
                          cookie.push('path=' + path);
                        }

                        if (utils.isString(domain)) {
                          cookie.push('domain=' + domain);
                        }

                        if (secure === true) {
                          cookie.push('secure');
                        }

                        document.cookie = cookie.join('; ');
                      },

                      read: function read(name) {
                        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
                        return match ? decodeURIComponent(match[3]) : null;
                      },

                      remove: function remove(name) {
                        this.write(name, '', Date.now() - 86400000);
                      }
                    };
                  })()
                : // Non standard browser env (web workers, react-native) lack needed support.
                  (function nonStandardBrowserEnv() {
                    return {
                      write: function write() {},
                      read: function read() {
                        return null;
                      },
                      remove: function remove() {}
                    };
                  })();

              /***/
            },
            /* 179 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              var utils = __webpack_require__(5);

              function InterceptorManager() {
                this.handlers = [];
              }

              /**
               * Add a new interceptor to the stack
               *
               * @param {Function} fulfilled The function to handle `then` for a `Promise`
               * @param {Function} rejected The function to handle `reject` for a `Promise`
               *
               * @return {Number} An ID used to remove interceptor later
               */
              InterceptorManager.prototype.use = function use(fulfilled, rejected) {
                this.handlers.push({
                  fulfilled: fulfilled,
                  rejected: rejected
                });
                return this.handlers.length - 1;
              };

              /**
               * Remove an interceptor from the stack
               *
               * @param {Number} id The ID that was returned by `use`
               */
              InterceptorManager.prototype.eject = function eject(id) {
                if (this.handlers[id]) {
                  this.handlers[id] = null;
                }
              };

              /**
               * Iterate over all the registered interceptors
               *
               * This method is particularly useful for skipping over any
               * interceptors that may have become `null` calling `eject`.
               *
               * @param {Function} fn The function to call for each interceptor
               */
              InterceptorManager.prototype.forEach = function forEach(fn) {
                utils.forEach(this.handlers, function forEachHandler(h) {
                  if (h !== null) {
                    fn(h);
                  }
                });
              };

              module.exports = InterceptorManager;

              /***/
            },
            /* 180 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              var utils = __webpack_require__(5);
              var transformData = __webpack_require__(181);
              var isCancel = __webpack_require__(94);
              var defaults = __webpack_require__(56);
              var isAbsoluteURL = __webpack_require__(182);
              var combineURLs = __webpack_require__(183);

              /**
               * Throws a `Cancel` if cancellation has been requested.
               */
              function throwIfCancellationRequested(config) {
                if (config.cancelToken) {
                  config.cancelToken.throwIfRequested();
                }
              }

              /**
               * Dispatch a request to the server using the configured adapter.
               *
               * @param {object} config The config that is to be used for the request
               * @returns {Promise} The Promise to be fulfilled
               */
              module.exports = function dispatchRequest(config) {
                throwIfCancellationRequested(config);

                // Support baseURL config
                if (config.baseURL && !isAbsoluteURL(config.url)) {
                  config.url = combineURLs(config.baseURL, config.url);
                }

                // Ensure headers exist
                config.headers = config.headers || {};

                // Transform request data
                config.data = transformData(config.data, config.headers, config.transformRequest);

                // Flatten headers
                config.headers = utils.merge(
                  config.headers.common || {},
                  config.headers[config.method] || {},
                  config.headers || {}
                );

                utils.forEach(
                  ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
                  function cleanHeaderConfig(method) {
                    delete config.headers[method];
                  }
                );

                var adapter = config.adapter || defaults.adapter;

                return adapter(config).then(
                  function onAdapterResolution(response) {
                    throwIfCancellationRequested(config);

                    // Transform response data
                    response.data = transformData(response.data, response.headers, config.transformResponse);

                    return response;
                  },
                  function onAdapterRejection(reason) {
                    if (!isCancel(reason)) {
                      throwIfCancellationRequested(config);

                      // Transform response data
                      if (reason && reason.response) {
                        reason.response.data = transformData(
                          reason.response.data,
                          reason.response.headers,
                          config.transformResponse
                        );
                      }
                    }

                    return Promise.reject(reason);
                  }
                );
              };

              /***/
            },
            /* 181 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              var utils = __webpack_require__(5);

              /**
               * Transform the data for a request or a response
               *
               * @param {Object|String} data The data to be transformed
               * @param {Array} headers The headers for the request or response
               * @param {Array|Function} fns A single function or Array of functions
               * @returns {*} The resulting transformed data
               */
              module.exports = function transformData(data, headers, fns) {
                /*eslint no-param-reassign:0*/
                utils.forEach(fns, function transform(fn) {
                  data = fn(data, headers);
                });

                return data;
              };

              /***/
            },
            /* 182 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              /**
               * Determines whether the specified URL is absolute
               *
               * @param {string} url The URL to test
               * @returns {boolean} True if the specified URL is absolute, otherwise false
               */
              module.exports = function isAbsoluteURL(url) {
                // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
                // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
                // by any combination of letters, digits, plus, period, or hyphen.
                return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
              };

              /***/
            },
            /* 183 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              /**
               * Creates a new URL by combining the specified URLs
               *
               * @param {string} baseURL The base URL
               * @param {string} relativeURL The relative URL
               * @returns {string} The combined URL
               */
              module.exports = function combineURLs(baseURL, relativeURL) {
                return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
              };

              /***/
            },
            /* 184 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              var Cancel = __webpack_require__(95);

              /**
               * A `CancelToken` is an object that can be used to request cancellation of an operation.
               *
               * @class
               * @param {Function} executor The executor function.
               */
              function CancelToken(executor) {
                if (typeof executor !== 'function') {
                  throw new TypeError('executor must be a function.');
                }

                var resolvePromise;
                this.promise = new Promise(function promiseExecutor(resolve) {
                  resolvePromise = resolve;
                });

                var token = this;
                executor(function cancel(message) {
                  if (token.reason) {
                    // Cancellation has already been requested
                    return;
                  }

                  token.reason = new Cancel(message);
                  resolvePromise(token.reason);
                });
              }

              /**
               * Throws a `Cancel` if cancellation has been requested.
               */
              CancelToken.prototype.throwIfRequested = function throwIfRequested() {
                if (this.reason) {
                  throw this.reason;
                }
              };

              /**
               * Returns an object that contains a new `CancelToken` and a function that, when called,
               * cancels the `CancelToken`.
               */
              CancelToken.source = function source() {
                var cancel;
                var token = new CancelToken(function executor(c) {
                  cancel = c;
                });
                return {
                  token: token,
                  cancel: cancel
                };
              };

              module.exports = CancelToken;

              /***/
            },
            /* 185 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              /**
               * Syntactic sugar for invoking a function and expanding an array for arguments.
               *
               * Common use case would be to use `Function.prototype.apply`.
               *
               *  ```js
               *  function f(x, y, z) {}
               *  var args = [1, 2, 3];
               *  f.apply(null, args);
               *  ```
               *
               * With `spread` this example can be re-written.
               *
               *  ```js
               *  spread(function(x, y, z) {})([1, 2, 3]);
               *  ```
               *
               * @param {Function} callback
               * @returns {Function}
               */
              module.exports = function spread(callback) {
                return function wrap(arr) {
                  return callback.apply(null, arr);
                };
              };

              /***/
            },
            /* 186 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ =
                __webpack_require__(14);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ =
                __webpack_require__(1);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ =
                __webpack_require__(15);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ =
                __webpack_require__(16);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_evee__ = __webpack_require__(35);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_evee___default = __webpack_require__.n(
                __WEBPACK_IMPORTED_MODULE_5_evee__
              );
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_promise_queue__ = __webpack_require__(86);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_promise_queue___default = __webpack_require__.n(
                __WEBPACK_IMPORTED_MODULE_6_promise_queue__
              );
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_deep_equal__ = __webpack_require__(87);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_deep_equal___default = __webpack_require__.n(
                __WEBPACK_IMPORTED_MODULE_7_deep_equal__
              );
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(88);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(
                __WEBPACK_IMPORTED_MODULE_8_lodash__
              );
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_config__ = __webpack_require__(55);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_log__ = __webpack_require__(37);

              var TAG = 'Shop';

              /**
               * @typedef {Object}  ShopifyShop
               * @property {ShopifyAddress} address
               * @property {Number} collections_count
               * @property {String} currency
               * @property {String} description
               * @property {String} domain
               * @property {String} email
               * @property {String[]} enabled_payment_types
               * @property {String} locale
               * @property {String} money_format
               * @property {String} money_format_with_currency
               * @property {String} name
               * @property {String} password_message
               * @property {String} permanent_domain
               * @property {ShopifyPolicy[]} policies
               * @property {String} refund_policy
               * @property {String} secure_url
               * @property {String} terms_of_service
               * @property {String[]} types
               * @property {String} url
               * @property {String[]} vendors
               */

              /**
               * @typedef {Object} ShopifyAddress
               * @property {String} address1
               * @property {String} address2
               * @property {String} city
               * @property {String|null} company
               * @property {String} country
               * @property {String} country_code
               * @property {String|null} first_name
               * @property {String|null} last_name
               * @property {Number|null} latitude
               * @property {Number|null} longitude
               * @property {String|null} name
               * @property {String|null} phone
               * @property {String|null} province
               * @property {String|null} province_code
               * @property {String|null} zip
               */

              /**
               * @typedef {Object} ShopifyPolicy
               * @property {String} body
               * @property {String} title
               */

              /**
               * Shopify Shop entity.
               * @extends {evee}
               */

              var Shop = (function (_Evee) {
                __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Shop, _Evee);

                /**
                 * Construct a new instance of the shop entity.
                 */
                function Shop() {
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Shop);

                  /** @type {ShopifyAddress} */
                  var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(
                    this,
                    (
                      Shop.__proto__ ||
                      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Shop)
                    ).call(this)
                  );

                  _this.address = null;
                  /** @type {Number} */
                  _this.collections_count = null;
                  /** @type {String} */
                  _this.currency = null;
                  /** @type {String} */
                  _this.description = null;
                  /** @type {String} */
                  _this.domain = null;
                  /** @type {String} */
                  _this.email = null;
                  /** @type {String[]} */
                  _this.enabled_payment_types = [];
                  /** @type {String} */
                  _this.locale = null;
                  /** @type {String} */
                  _this.money_format = null;
                  /** @type {String} */
                  _this.money_format_with_currency = null;
                  /** @type {String} */
                  _this.name = null;
                  /** @type {String} */
                  _this.password_message = null;
                  /** @type {String} */
                  _this.permanent_domain = null;
                  /** @type {ShopifyPolicy[]} */
                  _this.policies = [];
                  /** @type {String} */
                  _this.refund_policy = null;
                  /** @type {String} */
                  _this.secure_url = null;
                  /** @type {String} */
                  _this.terms_of_service = null;
                  /** @type {String[]} */
                  _this.types = [];
                  /** @type {String} */
                  _this.url = null;
                  /** @type {String[]} */
                  _this.vendors = [];
                  return _this;
                }

                /**
                 * Initialize the shop entity with the global shop state.
                 * @param {ShopifyShop} shopData - Shopify shop object.
                 */

                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Shop, [
                  {
                    key: 'initialize',
                    value: function initialize(shopData) {
                      this._loadFromShopifyShop(shopData);

                      this.emit('init', { shop: this });
                      __WEBPACK_IMPORTED_MODULE_10_log__['a' /* default */].send(
                        __WEBPACK_IMPORTED_MODULE_10_log__['a' /* default */].DEBUG,
                        TAG,
                        'Loaded.'
                      );
                    }

                    /**
                     * Loads properties from the given shop.
                     * @param {ShopifyShop} shop
                     */
                  },
                  {
                    key: '_loadFromShopifyShop',
                    value: function _loadFromShopifyShop(shop) {
                      this.address = shop.address;
                      this.collections_count = shop.collections_count;
                      this.currency = shop.currency;
                      this.description = shop.description;
                      this.domain = shop.domain;
                      this.email = shop.email;
                      this.enabled_payment_types = shop.enabled_payment_types;
                      this.locale = shop.locale;
                      this.money_format = shop.money_format;
                      this.money_format_with_currency = shop.money_format_with_currency;
                      this.name = shop.name;
                      this.password_message = shop.password_message;
                      this.permanent_domain = shop.permanent_domain;
                      this.policies = shop.policies;
                      this.refund_policy = shop.refund_polcy;
                      this.secure_url = shop.secure_url;
                      this.terms_of_service = shop.terms_of_service;
                      this.types = shop.types;
                      this.url = shop.url;
                      this.vendors = shop.vendors;
                    }

                    /**
                     * Normalizes a relative URL according to the current pathname.
                     * @param {String} rel
                     * @returns {String}
                     */
                  },
                  {
                    key: '_normalizeRelativeUrl',
                    value: function _normalizeRelativeUrl(rel) {
                      var normal = relative;
                      if (normal.length > 0 && normal[0] != '/') {
                        normal = window.location.pathname + normal;
                      }
                    }

                    /**
                     * Generates an absolute URL containing the shop primary domain.
                     * @param {String} relative - A relative URL to make absolute (i.e. '/collections/all')
                     * @returns {String}
                     */
                  },
                  {
                    key: 'makeAbsoluteUrl',
                    value: function makeAbsoluteUrl(relative) {
                      var normal = this._normalizeRelativeUrl(relative);
                      return this.secure_url + normal;
                    }

                    /**
                     * Generates an absolute URL containing the shop's myshopify domain.
                     * @param {String} relative - A relative URL to make absolute (i.e. '/collections/all')
                     * @returns {String}
                     */
                  },
                  {
                    key: 'makePermanentUrl',
                    value: function makePermanentUrl(relative) {
                      var normal = this._normalizeRelativeUrl(relative);
                      return this.secure_url.replace(this.domain, this.permanent_domain) + normal;
                    }
                  }
                ]);

                return Shop;
              })(__WEBPACK_IMPORTED_MODULE_5_evee___default.a);

              /* harmony default export */ __webpack_exports__['a'] = Shop;

              /***/
            },
            /* 187 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              Object.defineProperty(__webpack_exports__, '__esModule', { value: true });
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__easycurrency_EasyCurrency__ =
                __webpack_require__(188);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__geoservice_GeoService__ = __webpack_require__(249);

              var Plugins = function Plugins() {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Plugins);

                /** @type {src/plugins/easycurrency/EasyCurrency.js~EasyCurrency} */
                this.EasyCurrency = __WEBPACK_IMPORTED_MODULE_1__easycurrency_EasyCurrency__['a' /* default */];
                /** @type {src/plugins/geoservice/GeoService.js~GeoService} */
                this.GeoService = __WEBPACK_IMPORTED_MODULE_2__geoservice_GeoService__['a' /* default */];
              };

              /** @ignore */

              /* harmony default export */ __webpack_exports__['default'] = new Plugins();

              /***/
            },
            /* 188 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ =
                __webpack_require__(40);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ =
                __webpack_require__(19);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ =
                __webpack_require__(20);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ =
                __webpack_require__(53);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ =
                __webpack_require__(14);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ =
                __webpack_require__(1);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ =
                __webpack_require__(15);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ =
                __webpack_require__(16);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_evee__ = __webpack_require__(35);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_evee___default = __webpack_require__.n(
                __WEBPACK_IMPORTED_MODULE_9_evee__
              );
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_js_money__ = __webpack_require__(57);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_js_money___default = __webpack_require__.n(
                __WEBPACK_IMPORTED_MODULE_10_js_money__
              );
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(106);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__state__ = __webpack_require__(231);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_log__ = __webpack_require__(37);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__MoneySpanSet__ = __webpack_require__(232);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__MoneySpan__ = __webpack_require__(237);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__resolvers_GeoserviceResolver__ =
                __webpack_require__(238);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__formatters_DefaultFormatter__ =
                __webpack_require__(242);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__formatters_Formatter__ = __webpack_require__(108);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__resolvers_CurrencyResolver__ =
                __webpack_require__(107);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helpers_SelectHelper__ = __webpack_require__(243);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Session__ = __webpack_require__(244);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_index__ = __webpack_require__(28);

              /** @ignore */
              var TAG = 'EasyCurrency';

              /** @ignore */
              var instanceCount = 0;

              /**
               * Plugin for automatic currency conversion, tax handling, etc.
               * @extends {evee}
               * @private
               */

              var EasyCurrency = (function (_Evee) {
                __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(EasyCurrency, _Evee);

                /**
                 * Creates a new instance of EasyCurrency.
                 * This class is intended to be used as a singleton, and has global
                 * side-effects - do not create multiple instances.
                 */
                function EasyCurrency() {
                  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, EasyCurrency);

                  var _this = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(
                    this,
                    (
                      EasyCurrency.__proto__ ||
                      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(
                        EasyCurrency
                      )
                    ).call(this)
                  );

                  instanceCount++;
                  var styles = [];
                  if (instanceCount > 1) {
                    __WEBPACK_IMPORTED_MODULE_13_log__['a' /* default */].warn(
                      TAG,
                      'More than one instance of EasyCurrency has been created. This may cause unexpected behavior.'
                    );
                  }

                  /** @type {src/plugins/easycurrency/config.js~Config} */
                  _this._config = __WEBPACK_IMPORTED_MODULE_11__config__['a' /* default */];
                  /** @type {src/plugins/easycurrency/resolvers/CurrencyResolver.js~CurrencyResolver} */
                  _this._resolver = null;
                  /** @type {src/plugins/easycurrency/state.js~State} */
                  _this._state = __WEBPACK_IMPORTED_MODULE_12__state__['a' /* default */];
                  /** @type {src/plugins/easycurrency/MoneySpanSet.js~MoneySpanSet} */
                  _this._moneySpanSet = new __WEBPACK_IMPORTED_MODULE_14__MoneySpanSet__['a' /* default */]();
                  /** @type {src/plugins/easycurrency/formatters/Formatter.js~Formatter} */
                  _this._formatter = new __WEBPACK_IMPORTED_MODULE_17__formatters_DefaultFormatter__[
                    'a' /* default */
                  ]();
                  /** @type {src/plugins/easycurrency/Session.js~Session} */
                  _this._session = new __WEBPACK_IMPORTED_MODULE_21__Session__['a' /* default */]();

                  /** @type {src/plugins/easycurrency/helpers/SelectHelper.js~SelectHelper} */
                  _this.selectHelper = new __WEBPACK_IMPORTED_MODULE_20__helpers_SelectHelper__['a' /* default */](
                    _this
                  );
                  return _this;
                }

                /**
                 * Uses a default {@link GeoserviceResolver} as the currency resolver.
                 */

                __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(EasyCurrency, [
                  {
                    key: 'useGeoserviceResolver',
                    value: function useGeoserviceResolver() {
                      this.setCurrencyResolver(
                        new __WEBPACK_IMPORTED_MODULE_16__resolvers_GeoserviceResolver__['a' /* default */]()
                      );
                    }

                    /**
                     * Start running EasyCurrency on the current page.
                     * @param {Object|src/plugins/easycurrency/config.js~Config} config
                     * @emits {Object|src/plugins/easycurrency/config.js~Config} beforeInitialize(config)
                     * @emits {Object|src/plugins/easycurrency/config.js~Config} initialize(config)
                     */
                  },
                  {
                    key: 'initialize',
                    value: function initialize(config) {
                      var _this2 = this;

                      this.emit('beforeInitialize', config);
                      __WEBPACK_IMPORTED_MODULE_13_log__['a' /* default */].debug(
                        TAG,
                        'Initialized with config',
                        config
                      );
                      if (config) {
                        this._config = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(
                          {},
                          this._config,
                          config
                        );
                      }

                      var currency = this._session.getCurrency();
                      var fromSession = currency;
                      currency = currency || this._config.defaultCurrency;

                      this.setActiveCurrency(this._session.getCurrency() || this._config.defaultCurrency);
                      this.emit('initialize', config);

                      if (!fromSession && this._config.useGeoForCurrency) {
                        __WEBPACK_IMPORTED_MODULE_22_index__['geoService'].lookupGeo().then(function (result) {
                          __WEBPACK_IMPORTED_MODULE_13_log__['a' /* default */].debug(
                            TAG,
                            'Got currency from geoservice: ' + result.currency
                          );
                          _this2.setActiveCurrency(result.currency);
                        });
                      }
                    }

                    /**
                     * Sets the active currency, and refreshs any money spans.
                     * @param {String} currency Currency code
                     * @emits {String} beforeCurrencyChanged(currency)
                     * @emits {String} currencyChanged(currency)
                     */
                  },
                  {
                    key: 'setActiveCurrency',
                    value: function setActiveCurrency(currency) {
                      this.emit('beforeCurrencyChanged', currency);
                      __WEBPACK_IMPORTED_MODULE_13_log__['a' /* default */].debug(TAG, 'Set active currency', currency);
                      this._state.currency = currency;

                      this._session.saveCurrency(currency);

                      this.parse();
                      this.render();
                      this.emit('currencyChanged', currency);
                    }

                    /**
                     * Returns the active currency.
                     * @return {String}
                     */
                  },
                  {
                    key: 'getActiveCurrency',
                    value: function getActiveCurrency() {
                      return this._state.currency;
                    }

                    /**
                     * Returns the available currency codes.
                     * @return {String[]}
                     */
                  },
                  {
                    key: 'getAvailableCurrencies',
                    value: (function () {
                      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(
                        /*#__PURE__*/ __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(
                          function _callee() {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(
                              function _callee$(_context) {
                                while (1) {
                                  switch ((_context.prev = _context.next)) {
                                    case 0:
                                      return _context.abrupt('return', this._resolver.listCurrencyCodes());

                                    case 1:
                                    case 'end':
                                      return _context.stop();
                                  }
                                }
                              },
                              _callee,
                              this
                            );
                          }
                        )
                      );

                      function getAvailableCurrencies() {
                        return _ref.apply(this, arguments);
                      }

                      return getAvailableCurrencies;
                    })()

                    /**
                     * Attempts to find new money spans on the page.
                     * Change moneySpanSelectors / moneySpanParser config options to modify
                     * how money spans are parsed.
                     * @emits {null} beforeParse
                     * @emits {null} parse
                     */
                  },
                  {
                    key: 'parse',
                    value: function parse() {
                      this.emit('beforeParse');
                      __WEBPACK_IMPORTED_MODULE_13_log__['a' /* default */].debug(TAG, 'Parsing');
                      var els = [];
                      var _iteratorNormalCompletion = true;
                      var _didIteratorError = false;
                      var _iteratorError = undefined;

                      try {
                        for (
                          var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(
                              this._config.moneySpanSelectors
                            ),
                            _step;
                          !(_iteratorNormalCompletion = (_step = _iterator.next()).done);
                          _iteratorNormalCompletion = true
                        ) {
                          var selector = _step.value;

                          var els = document.querySelectorAll(selector);
                          for (var i = 0; i < els.length; i++) {
                            var el = els[i];
                            this._processElement(el);
                          }
                        }
                      } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                          }
                        } finally {
                          if (_didIteratorError) {
                            throw _iteratorError;
                          }
                        }
                      }

                      this.emit('parse');
                    }

                    /**
                     * @param {DOMNode}	el - Element to process
                     */
                  },
                  {
                    key: '_processElement',
                    value: function _processElement(el) {
                      var money = this._config.moneySpanParser(el);
                      var moneySpan = new __WEBPACK_IMPORTED_MODULE_15__MoneySpan__['a' /* default */](money, this);
                      moneySpan.setElement(el);
                      this._moneySpanSet.add(moneySpan);
                    }

                    /**
                     * Forces all money spans to re-render.
                     * @emits {null} beforeRender
                     * @emits {null} render
                     */
                  },
                  {
                    key: 'render',
                    value: function render() {
                      this.emit('beforeRender');
                      __WEBPACK_IMPORTED_MODULE_13_log__['a' /* default */].debug(TAG, 'Rendering');
                      var _iteratorNormalCompletion2 = true;
                      var _didIteratorError2 = false;
                      var _iteratorError2 = undefined;

                      try {
                        for (
                          var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(
                              this._moneySpanSet.list()
                            ),
                            _step2;
                          !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done);
                          _iteratorNormalCompletion2 = true
                        ) {
                          var moneySpan = _step2.value;

                          moneySpan.render();
                        }
                      } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                          }
                        } finally {
                          if (_didIteratorError2) {
                            throw _iteratorError2;
                          }
                        }
                      }

                      this.emit('render');
                    }

                    /**
                     * Returns the current state.
                     * @return {src/plugins/easycurrency/state.js~State}
                     */
                  },
                  {
                    key: 'getState',
                    value: function getState() {
                      return this._state;
                    }

                    /**
                     * Format a value as a currency
                     * @param {js-money|Number} amount
                     * @param {String|null} [currency] If null, uses current currency.
                     * @return {String}
                     */
                  },
                  {
                    key: 'format',
                    value: function format(amount, currency) {
                      if (typeof amount == 'number') {
                        amount = new __WEBPACK_IMPORTED_MODULE_10_js_money___default.a(
                          amount,
                          currency || this._state.currency
                        );
                      }
                      var str = this._formatter.format(amount.amount, amount.currency);
                      return str;
                    }

                    /**
                     * Convert an amount to another currency.
                     * @param {js-money|Number} amount
                     * @param {String} [to] - If null, uses current currency
                     * @param {null|String} [from] Ignored if amount is a Money object.
                     * @return {Promise<js-money>}
                     */
                  },
                  {
                    key: 'convert',
                    value: (function () {
                      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(
                        /*#__PURE__*/ __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(
                          function _callee2(amount, to, from) {
                            var rate;
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(
                              function _callee2$(_context2) {
                                while (1) {
                                  switch ((_context2.prev = _context2.next)) {
                                    case 0:
                                      if (typeof amount == 'number') {
                                        amount = new __WEBPACK_IMPORTED_MODULE_10_js_money___default.a(
                                          amount,
                                          from || this._state.currency
                                        );
                                      }
                                      _context2.next = 3;
                                      return this._resolver.getConversionRate(
                                        amount.currency,
                                        to || this._state.currency
                                      );

                                    case 3:
                                      rate = _context2.sent;
                                      return _context2.abrupt(
                                        'return',
                                        new __WEBPACK_IMPORTED_MODULE_10_js_money___default.a(
                                          amount.multiply(rate).amount,
                                          __WEBPACK_IMPORTED_MODULE_10_js_money___default.a[to || this._state.currency]
                                        )
                                      );

                                    case 5:
                                    case 'end':
                                      return _context2.stop();
                                  }
                                }
                              },
                              _callee2,
                              this
                            );
                          }
                        )
                      );

                      function convert(_x, _x2, _x3) {
                        return _ref2.apply(this, arguments);
                      }

                      return convert;
                    })()

                    /**
                     * Adds the current tax rate to the given amount
                     * @param {js-money|Number} amount
                     * @return {Promise<js-money>}
                     */
                  },
                  {
                    key: 'addTax',
                    value: (function () {
                      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(
                        /*#__PURE__*/ __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(
                          function _callee3(amount) {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(
                              function _callee3$(_context3) {
                                while (1) {
                                  switch ((_context3.prev = _context3.next)) {
                                    case 0:
                                      if (typeof amount == 'number') {
                                        amount = new __WEBPACK_IMPORTED_MODULE_10_js_money___default.a(
                                          amount,
                                          this._state.currency
                                        );
                                      }
                                      return _context3.abrupt('return', amount.multiply(1 + this._state.taxRate));

                                    case 2:
                                    case 'end':
                                      return _context3.stop();
                                  }
                                }
                              },
                              _callee3,
                              this
                            );
                          }
                        )
                      );

                      function addTax(_x4) {
                        return _ref3.apply(this, arguments);
                      }

                      return addTax;
                    })()

                    /**
                     * Sets the current tax rate.
                     * @param {type}	taxRate - Tax rate as a decimal percentage (i.e. 20% = 0.2)
                     * @emits {null} beforeChangeTaxRate
                     * @emits {null} taxRateChanged
                     */
                  },
                  {
                    key: 'setTaxRate',
                    value: function setTaxRate(taxRate) {
                      this.emit('beforeChangeTaxRate');
                      this._state.taxRate = taxRate;

                      this.parse();
                      this.render();
                      this.emit('taxRateChanged');
                    }

                    /**
                     * Overrides the default currency resolver, which provides information
                     * about the available currencies.
                     * @param {src/plugins/easycurrency/resolvers/CurrencyResolver.js~CurrencyResolver} resolver
                     * @emits {src/plugins/easycurrency/resolvers/CurrencyResolver.js~CurrencyResolver} currencyResolverChanged(resolver)
                     */
                  },
                  {
                    key: 'setCurrencyResolver',
                    value: function setCurrencyResolver(resolver) {
                      this._resolver = resolver;
                      this.emit('currencyResolverChanged', resolver);
                    }

                    /**
                     * Overrides the default formatter.
                     * @param {src/plugins/easycurrency/formatters/Formatter.js~Formatter} formatter
                     * @emits {src/plugins/easycurrency/formatters/Formatter.js~Formatter} formatterChanged(formatter)
                     */
                  },
                  {
                    key: 'setFormatter',
                    value: function setFormatter(formatter) {
                      this._formatter = formatter;
                      this.emit('formatterChanged', resolver);
                    }
                  }
                ]);

                return EasyCurrency;
              })(__WEBPACK_IMPORTED_MODULE_9_evee___default.a);

              EasyCurrency.formatters = {
                DefaultFormatter: __WEBPACK_IMPORTED_MODULE_17__formatters_DefaultFormatter__['a' /* default */],
                Formatter: __WEBPACK_IMPORTED_MODULE_18__formatters_Formatter__['a' /* default */]
              };

              EasyCurrency.helpers = {
                SelectHelper: __WEBPACK_IMPORTED_MODULE_20__helpers_SelectHelper__['a' /* default */]
              };

              EasyCurrency.resolvers = {
                CurrencyResolver: __WEBPACK_IMPORTED_MODULE_19__resolvers_CurrencyResolver__['a' /* default */],
                GeoserviceResolver: __WEBPACK_IMPORTED_MODULE_16__resolvers_GeoserviceResolver__['a' /* default */]
              };

              /* harmony default export */ __webpack_exports__['a'] = EasyCurrency;

              /***/
            },
            /* 189 */
            /***/ function (module, exports, __webpack_require__) {
              /**
               * This file is part of the JS Money library
               *
               * Copyright (c) 2014 David Kalosi
               *
               * For the full copyright and license information, please view the LICENSE
               * file that was distributed with this source code.
               */

              var extend = __webpack_require__(190);
              var isFunction = __webpack_require__(58);
              var isNaN = __webpack_require__(225);
              var isObject = __webpack_require__(27);
              var isPlainObject = __webpack_require__(227);
              var isString = __webpack_require__(230);
              var currencies = __webpack_require__(60);

              var isInt = function (n) {
                return Number(n) === n && n % 1 === 0;
              };

              var decimalPlaces = function (num) {
                var match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);

                if (!match) return 0;

                return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
              };

              var assertSameCurrency = function (left, right) {
                if (left.currency !== right.currency) throw new Error('Different currencies');
              };

              var assertType = function (other) {
                if (!(other instanceof Money)) throw new TypeError('Instance of Money required');
              };

              var assertOperand = function (operand) {
                if (isNaN(parseFloat(operand)) && !isFinite(operand)) throw new TypeError('Operand must be a number');
              };

              /**
               * Creates a new Money instance.
               * The created Money instances is a value object thus it is immutable.
               *
               * @param {Number} amount
               * @param {Object/String} currency
               * @returns {Money}
               * @constructor
               */
              function Money(amount, currency) {
                if (isString(currency)) currency = currencies[currency];

                if (!isPlainObject(currency)) throw new TypeError('Invalid currency');

                if (!isInt(amount)) throw new TypeError('Amount must be an integer');

                this.amount = amount;
                this.currency = currency.code;
                Object.freeze(this);
              }

              Money.fromInteger = function (amount, currency) {
                if (isObject(amount)) {
                  if (amount.amount === undefined || amount.currency === undefined)
                    throw new TypeError('Missing required parameters amount,currency');

                  currency = amount.currency;
                  amount = amount.amount;
                }

                if (!isInt(amount)) throw new TypeError('Amount must be an integer value');

                return new Money(amount, currency);
              };

              Money.fromDecimal = function (amount, currency, rounder) {
                if (isObject(amount)) {
                  if (amount.amount === undefined || amount.currency === undefined)
                    throw new TypeError('Missing required parameters amount,currency');

                  rounder = currency;
                  currency = amount.currency;
                  amount = amount.amount;
                }

                if (isString(currency)) currency = currencies[currency];

                if (!isPlainObject(currency)) throw new TypeError('Invalid currency');

                if (rounder === undefined) {
                  var decimals = decimalPlaces(amount);

                  if (decimals > currency.decimal_digits)
                    throw new Error(
                      'The currency ' + currency.code + ' supports only ' + currency.decimal_digits + ' decimal digits'
                    );
                } else {
                  if (['round', 'floor', 'ceil'].indexOf(rounder) === -1 && typeof rounder !== 'function')
                    throw new TypeError('Invalid parameter rounder');

                  if (isString(rounder)) rounder = Math[rounder];
                }

                var precisionMultiplier = Math.pow(10, currency.decimal_digits);
                var resultAmount = amount * precisionMultiplier;

                if (rounder) resultAmount = rounder(resultAmount);

                return new Money(resultAmount, currency);
              };

              /**
               * Returns true if the two instances of Money are equal, false otherwise.
               *
               * @param {Money} other
               * @returns {Boolean}
               */
              Money.prototype.equals = function (other) {
                var self = this;
                assertType(other);

                return self.amount === other.amount && self.currency === other.currency;
              };

              /**
               * Adds the two objects together creating a new Money instance that holds the result of the operation.
               *
               * @param {Money} other
               * @returns {Money}
               */
              Money.prototype.add = function (other) {
                var self = this;
                assertType(other);
                assertSameCurrency(self, other);

                return new Money(self.amount + other.amount, self.currency);
              };

              /**
               * Subtracts the two objects creating a new Money instance that holds the result of the operation.
               *
               * @param {Money} other
               * @returns {Money}
               */
              Money.prototype.subtract = function (other) {
                var self = this;
                assertType(other);
                assertSameCurrency(self, other);

                return new Money(self.amount - other.amount, self.currency);
              };

              /**
               * Multiplies the object by the multiplier returning a new Money instance that holds the result of the operation.
               *
               * @param {Number} multiplier
               * @param {Function} [fn=Math.round]
               * @returns {Money}
               */
              Money.prototype.multiply = function (multiplier, fn) {
                if (!isFunction(fn)) fn = Math.round;

                assertOperand(multiplier);
                var amount = fn(this.amount * multiplier);

                return new Money(amount, this.currency);
              };

              /**
               * Divides the object by the multiplier returning a new Money instance that holds the result of the operation.
               *
               * @param {Number} divisor
               * @param {Function} [fn=Math.round]
               * @returns {Money}
               */
              Money.prototype.divide = function (divisor, fn) {
                if (!isFunction(fn)) fn = Math.round;

                assertOperand(divisor);
                var amount = fn(this.amount / divisor);

                return new Money(amount, this.currency);
              };

              /**
               * Allocates fund bases on the ratios provided returing an array of objects as a product of the allocation.
               *
               * @param {Array} other
               * @returns {Array.Money}
               */
              Money.prototype.allocate = function (ratios) {
                var self = this;
                var remainder = self.amount;
                var results = [];
                var total = 0;

                ratios.forEach(function (ratio) {
                  total += ratio;
                });

                ratios.forEach(function (ratio) {
                  var share = Math.floor((self.amount * ratio) / total);
                  results.push(new Money(share, self.currency));
                  remainder -= share;
                });

                for (var i = 0; remainder > 0; i++) {
                  results[i] = new Money(results[i].amount + 1, results[i].currency);
                  remainder--;
                }

                return results;
              };

              /**
               * Compares two instances of Money.
               *
               * @param {Money} other
               * @returns {Number}
               */
              Money.prototype.compare = function (other) {
                var self = this;

                assertType(other);
                assertSameCurrency(self, other);

                if (self.amount === other.amount) return 0;

                return self.amount > other.amount ? 1 : -1;
              };

              /**
               * Checks whether the value represented by this object is greater than the other.
               *
               * @param {Money} other
               * @returns {boolean}
               */
              Money.prototype.greaterThan = function (other) {
                return 1 === this.compare(other);
              };

              /**
               * Checks whether the value represented by this object is greater or equal to the other.
               *
               * @param {Money} other
               * @returns {boolean}
               */
              Money.prototype.greaterThanOrEqual = function (other) {
                return 0 <= this.compare(other);
              };

              /**
               * Checks whether the value represented by this object is less than the other.
               *
               * @param {Money} other
               * @returns {boolean}
               */
              Money.prototype.lessThan = function (other) {
                return -1 === this.compare(other);
              };

              /**
               * Checks whether the value represented by this object is less than or equal to the other.
               *
               * @param {Money} other
               * @returns {boolean}
               */
              Money.prototype.lessThanOrEqual = function (other) {
                return 0 >= this.compare(other);
              };

              /**
               * Returns true if the amount is zero.
               *
               * @returns {boolean}
               */
              Money.prototype.isZero = function () {
                return this.amount === 0;
              };

              /**
               * Returns true if the amount is positive.
               *
               * @returns {boolean}
               */
              Money.prototype.isPositive = function () {
                return this.amount > 0;
              };

              /**
               * Returns true if the amount is negative.
               *
               * @returns {boolean}
               */
              Money.prototype.isNegative = function () {
                return this.amount < 0;
              };

              /**
               * Returns the decimal value as a float.
               *
               * @returns {number}
               */
              Money.prototype.toDecimal = function () {
                return Number(this.toString());
              };

              /**
               * Returns the decimal value as a string.
               *
               * @returns {string}
               */
              Money.prototype.toString = function () {
                var currency = currencies[this.currency];
                return (this.amount / Math.pow(10, currency.decimal_digits)).toFixed(currency.decimal_digits);
              };

              /**
               * Returns a serialised version of the instance.
               *
               * @returns {{amount: number, currency: string}}
               */
              Money.prototype.toJSON = function () {
                return {
                  amount: this.amount,
                  currency: this.currency
                };
              };

              /**
               * Returns the amount represented by this object.
               *
               * @returns {number}
               */
              Money.prototype.getAmount = function () {
                return this.amount;
              };

              /**
               * Returns the currency represented by this object.
               *
               * @returns {string}
               */
              Money.prototype.getCurrency = function () {
                return this.currency;
              };

              module.exports = extend(Money, currencies);

              /***/
            },
            /* 190 */
            /***/ function (module, exports, __webpack_require__) {
              module.exports = __webpack_require__(191);

              /***/
            },
            /* 191 */
            /***/ function (module, exports, __webpack_require__) {
              var copyObject = __webpack_require__(192),
                createAssigner = __webpack_require__(202),
                keysIn = __webpack_require__(211);

              /**
               * This method is like `_.assign` except that it iterates over own and
               * inherited source properties.
               *
               * **Note:** This method mutates `object`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @alias extend
               * @category Object
               * @param {Object} object The destination object.
               * @param {...Object} [sources] The source objects.
               * @returns {Object} Returns `object`.
               * @see _.assign
               * @example
               *
               * function Foo() {
               *   this.a = 1;
               * }
               *
               * function Bar() {
               *   this.c = 3;
               * }
               *
               * Foo.prototype.b = 2;
               * Bar.prototype.d = 4;
               *
               * _.assignIn({ 'a': 0 }, new Foo, new Bar);
               * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
               */
              var assignIn = createAssigner(function (object, source) {
                copyObject(source, keysIn(source), object);
              });

              module.exports = assignIn;

              /***/
            },
            /* 192 */
            /***/ function (module, exports, __webpack_require__) {
              var assignValue = __webpack_require__(193),
                baseAssignValue = __webpack_require__(96);

              /**
               * Copies properties of `source` to `object`.
               *
               * @private
               * @param {Object} source The object to copy properties from.
               * @param {Array} props The property identifiers to copy.
               * @param {Object} [object={}] The object to copy properties to.
               * @param {Function} [customizer] The function to customize copied values.
               * @returns {Object} Returns `object`.
               */
              function copyObject(source, props, object, customizer) {
                var isNew = !object;
                object || (object = {});

                var index = -1,
                  length = props.length;

                while (++index < length) {
                  var key = props[index];

                  var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

                  if (newValue === undefined) {
                    newValue = source[key];
                  }
                  if (isNew) {
                    baseAssignValue(object, key, newValue);
                  } else {
                    assignValue(object, key, newValue);
                  }
                }
                return object;
              }

              module.exports = copyObject;

              /***/
            },
            /* 193 */
            /***/ function (module, exports, __webpack_require__) {
              var baseAssignValue = __webpack_require__(96),
                eq = __webpack_require__(100);

              /** Used for built-in method references. */
              var objectProto = Object.prototype;

              /** Used to check objects for own properties. */
              var hasOwnProperty = objectProto.hasOwnProperty;

              /**
               * Assigns `value` to `key` of `object` if the existing value is not equivalent
               * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
               * for equality comparisons.
               *
               * @private
               * @param {Object} object The object to modify.
               * @param {string} key The key of the property to assign.
               * @param {*} value The value to assign.
               */
              function assignValue(object, key, value) {
                var objValue = object[key];
                if (
                  !(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
                  (value === undefined && !(key in object))
                ) {
                  baseAssignValue(object, key, value);
                }
              }

              module.exports = assignValue;

              /***/
            },
            /* 194 */
            /***/ function (module, exports, __webpack_require__) {
              var baseIsNative = __webpack_require__(195),
                getValue = __webpack_require__(201);

              /**
               * Gets the native function at `key` of `object`.
               *
               * @private
               * @param {Object} object The object to query.
               * @param {string} key The key of the method to get.
               * @returns {*} Returns the function if it's native, else `undefined`.
               */
              function getNative(object, key) {
                var value = getValue(object, key);
                return baseIsNative(value) ? value : undefined;
              }

              module.exports = getNative;

              /***/
            },
            /* 195 */
            /***/ function (module, exports, __webpack_require__) {
              var isFunction = __webpack_require__(58),
                isMasked = __webpack_require__(198),
                isObject = __webpack_require__(27),
                toSource = __webpack_require__(200);

              /**
               * Used to match `RegExp`
               * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
               */
              var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

              /** Used to detect host constructors (Safari). */
              var reIsHostCtor = /^\[object .+?Constructor\]$/;

              /** Used for built-in method references. */
              var funcProto = Function.prototype,
                objectProto = Object.prototype;

              /** Used to resolve the decompiled source of functions. */
              var funcToString = funcProto.toString;

              /** Used to check objects for own properties. */
              var hasOwnProperty = objectProto.hasOwnProperty;

              /** Used to detect if a method is native. */
              var reIsNative = RegExp(
                '^' +
                  funcToString
                    .call(hasOwnProperty)
                    .replace(reRegExpChar, '\\$&')
                    .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') +
                  '$'
              );

              /**
               * The base implementation of `_.isNative` without bad shim checks.
               *
               * @private
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a native function,
               *  else `false`.
               */
              function baseIsNative(value) {
                if (!isObject(value) || isMasked(value)) {
                  return false;
                }
                var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
                return pattern.test(toSource(value));
              }

              module.exports = baseIsNative;

              /***/
            },
            /* 196 */
            /***/ function (module, exports, __webpack_require__) {
              var Symbol = __webpack_require__(98);

              /** Used for built-in method references. */
              var objectProto = Object.prototype;

              /** Used to check objects for own properties. */
              var hasOwnProperty = objectProto.hasOwnProperty;

              /**
               * Used to resolve the
               * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
               * of values.
               */
              var nativeObjectToString = objectProto.toString;

              /** Built-in value references. */
              var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

              /**
               * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
               *
               * @private
               * @param {*} value The value to query.
               * @returns {string} Returns the raw `toStringTag`.
               */
              function getRawTag(value) {
                var isOwn = hasOwnProperty.call(value, symToStringTag),
                  tag = value[symToStringTag];

                try {
                  value[symToStringTag] = undefined;
                  var unmasked = true;
                } catch (e) {}

                var result = nativeObjectToString.call(value);
                if (unmasked) {
                  if (isOwn) {
                    value[symToStringTag] = tag;
                  } else {
                    delete value[symToStringTag];
                  }
                }
                return result;
              }

              module.exports = getRawTag;

              /***/
            },
            /* 197 */
            /***/ function (module, exports) {
              /** Used for built-in method references. */
              var objectProto = Object.prototype;

              /**
               * Used to resolve the
               * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
               * of values.
               */
              var nativeObjectToString = objectProto.toString;

              /**
               * Converts `value` to a string using `Object.prototype.toString`.
               *
               * @private
               * @param {*} value The value to convert.
               * @returns {string} Returns the converted string.
               */
              function objectToString(value) {
                return nativeObjectToString.call(value);
              }

              module.exports = objectToString;

              /***/
            },
            /* 198 */
            /***/ function (module, exports, __webpack_require__) {
              var coreJsData = __webpack_require__(199);

              /** Used to detect methods masquerading as native. */
              var maskSrcKey = (function () {
                var uid = /[^.]+$/.exec((coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO) || '');
                return uid ? 'Symbol(src)_1.' + uid : '';
              })();

              /**
               * Checks if `func` has its source masked.
               *
               * @private
               * @param {Function} func The function to check.
               * @returns {boolean} Returns `true` if `func` is masked, else `false`.
               */
              function isMasked(func) {
                return !!maskSrcKey && maskSrcKey in func;
              }

              module.exports = isMasked;

              /***/
            },
            /* 199 */
            /***/ function (module, exports, __webpack_require__) {
              var root = __webpack_require__(59);

              /** Used to detect overreaching core-js shims. */
              var coreJsData = root['__core-js_shared__'];

              module.exports = coreJsData;

              /***/
            },
            /* 200 */
            /***/ function (module, exports) {
              /** Used for built-in method references. */
              var funcProto = Function.prototype;

              /** Used to resolve the decompiled source of functions. */
              var funcToString = funcProto.toString;

              /**
               * Converts `func` to its source code.
               *
               * @private
               * @param {Function} func The function to convert.
               * @returns {string} Returns the source code.
               */
              function toSource(func) {
                if (func != null) {
                  try {
                    return funcToString.call(func);
                  } catch (e) {}
                  try {
                    return func + '';
                  } catch (e) {}
                }
                return '';
              }

              module.exports = toSource;

              /***/
            },
            /* 201 */
            /***/ function (module, exports) {
              /**
               * Gets the value at `key` of `object`.
               *
               * @private
               * @param {Object} [object] The object to query.
               * @param {string} key The key of the property to get.
               * @returns {*} Returns the property value.
               */
              function getValue(object, key) {
                return object == null ? undefined : object[key];
              }

              module.exports = getValue;

              /***/
            },
            /* 202 */
            /***/ function (module, exports, __webpack_require__) {
              var baseRest = __webpack_require__(203),
                isIterateeCall = __webpack_require__(210);

              /**
               * Creates a function like `_.assign`.
               *
               * @private
               * @param {Function} assigner The function to assign values.
               * @returns {Function} Returns the new assigner function.
               */
              function createAssigner(assigner) {
                return baseRest(function (object, sources) {
                  var index = -1,
                    length = sources.length,
                    customizer = length > 1 ? sources[length - 1] : undefined,
                    guard = length > 2 ? sources[2] : undefined;

                  customizer =
                    assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

                  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                  }
                  object = Object(object);
                  while (++index < length) {
                    var source = sources[index];
                    if (source) {
                      assigner(object, source, index, customizer);
                    }
                  }
                  return object;
                });
              }

              module.exports = createAssigner;

              /***/
            },
            /* 203 */
            /***/ function (module, exports, __webpack_require__) {
              var identity = __webpack_require__(101),
                overRest = __webpack_require__(204),
                setToString = __webpack_require__(206);

              /**
               * The base implementation of `_.rest` which doesn't validate or coerce arguments.
               *
               * @private
               * @param {Function} func The function to apply a rest parameter to.
               * @param {number} [start=func.length-1] The start position of the rest parameter.
               * @returns {Function} Returns the new function.
               */
              function baseRest(func, start) {
                return setToString(overRest(func, start, identity), func + '');
              }

              module.exports = baseRest;

              /***/
            },
            /* 204 */
            /***/ function (module, exports, __webpack_require__) {
              var apply = __webpack_require__(205);

              /* Built-in method references for those with the same name as other `lodash` methods. */
              var nativeMax = Math.max;

              /**
               * A specialized version of `baseRest` which transforms the rest array.
               *
               * @private
               * @param {Function} func The function to apply a rest parameter to.
               * @param {number} [start=func.length-1] The start position of the rest parameter.
               * @param {Function} transform The rest array transform.
               * @returns {Function} Returns the new function.
               */
              function overRest(func, start, transform) {
                start = nativeMax(start === undefined ? func.length - 1 : start, 0);
                return function () {
                  var args = arguments,
                    index = -1,
                    length = nativeMax(args.length - start, 0),
                    array = Array(length);

                  while (++index < length) {
                    array[index] = args[start + index];
                  }
                  index = -1;
                  var otherArgs = Array(start + 1);
                  while (++index < start) {
                    otherArgs[index] = args[index];
                  }
                  otherArgs[start] = transform(array);
                  return apply(func, this, otherArgs);
                };
              }

              module.exports = overRest;

              /***/
            },
            /* 205 */
            /***/ function (module, exports) {
              /**
               * A faster alternative to `Function#apply`, this function invokes `func`
               * with the `this` binding of `thisArg` and the arguments of `args`.
               *
               * @private
               * @param {Function} func The function to invoke.
               * @param {*} thisArg The `this` binding of `func`.
               * @param {Array} args The arguments to invoke `func` with.
               * @returns {*} Returns the result of `func`.
               */
              function apply(func, thisArg, args) {
                switch (args.length) {
                  case 0:
                    return func.call(thisArg);
                  case 1:
                    return func.call(thisArg, args[0]);
                  case 2:
                    return func.call(thisArg, args[0], args[1]);
                  case 3:
                    return func.call(thisArg, args[0], args[1], args[2]);
                }
                return func.apply(thisArg, args);
              }

              module.exports = apply;

              /***/
            },
            /* 206 */
            /***/ function (module, exports, __webpack_require__) {
              var baseSetToString = __webpack_require__(207),
                shortOut = __webpack_require__(209);

              /**
               * Sets the `toString` method of `func` to return `string`.
               *
               * @private
               * @param {Function} func The function to modify.
               * @param {Function} string The `toString` result.
               * @returns {Function} Returns `func`.
               */
              var setToString = shortOut(baseSetToString);

              module.exports = setToString;

              /***/
            },
            /* 207 */
            /***/ function (module, exports, __webpack_require__) {
              var constant = __webpack_require__(208),
                defineProperty = __webpack_require__(97),
                identity = __webpack_require__(101);

              /**
               * The base implementation of `setToString` without support for hot loop shorting.
               *
               * @private
               * @param {Function} func The function to modify.
               * @param {Function} string The `toString` result.
               * @returns {Function} Returns `func`.
               */
              var baseSetToString = !defineProperty
                ? identity
                : function (func, string) {
                    return defineProperty(func, 'toString', {
                      configurable: true,
                      enumerable: false,
                      value: constant(string),
                      writable: true
                    });
                  };

              module.exports = baseSetToString;

              /***/
            },
            /* 208 */
            /***/ function (module, exports) {
              /**
               * Creates a function that returns `value`.
               *
               * @static
               * @memberOf _
               * @since 2.4.0
               * @category Util
               * @param {*} value The value to return from the new function.
               * @returns {Function} Returns the new constant function.
               * @example
               *
               * var objects = _.times(2, _.constant({ 'a': 1 }));
               *
               * console.log(objects);
               * // => [{ 'a': 1 }, { 'a': 1 }]
               *
               * console.log(objects[0] === objects[1]);
               * // => true
               */
              function constant(value) {
                return function () {
                  return value;
                };
              }

              module.exports = constant;

              /***/
            },
            /* 209 */
            /***/ function (module, exports) {
              /** Used to detect hot functions by number of calls within a span of milliseconds. */
              var HOT_COUNT = 800,
                HOT_SPAN = 16;

              /* Built-in method references for those with the same name as other `lodash` methods. */
              var nativeNow = Date.now;

              /**
               * Creates a function that'll short out and invoke `identity` instead
               * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
               * milliseconds.
               *
               * @private
               * @param {Function} func The function to restrict.
               * @returns {Function} Returns the new shortable function.
               */
              function shortOut(func) {
                var count = 0,
                  lastCalled = 0;

                return function () {
                  var stamp = nativeNow(),
                    remaining = HOT_SPAN - (stamp - lastCalled);

                  lastCalled = stamp;
                  if (remaining > 0) {
                    if (++count >= HOT_COUNT) {
                      return arguments[0];
                    }
                  } else {
                    count = 0;
                  }
                  return func.apply(undefined, arguments);
                };
              }

              module.exports = shortOut;

              /***/
            },
            /* 210 */
            /***/ function (module, exports, __webpack_require__) {
              var eq = __webpack_require__(100),
                isArrayLike = __webpack_require__(102),
                isIndex = __webpack_require__(104),
                isObject = __webpack_require__(27);

              /**
               * Checks if the given arguments are from an iteratee call.
               *
               * @private
               * @param {*} value The potential iteratee value argument.
               * @param {*} index The potential iteratee index or key argument.
               * @param {*} object The potential iteratee object argument.
               * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
               *  else `false`.
               */
              function isIterateeCall(value, index, object) {
                if (!isObject(object)) {
                  return false;
                }
                var type = typeof index;
                if (
                  type == 'number'
                    ? isArrayLike(object) && isIndex(index, object.length)
                    : type == 'string' && index in object
                ) {
                  return eq(object[index], value);
                }
                return false;
              }

              module.exports = isIterateeCall;

              /***/
            },
            /* 211 */
            /***/ function (module, exports, __webpack_require__) {
              var arrayLikeKeys = __webpack_require__(212),
                baseKeysIn = __webpack_require__(222),
                isArrayLike = __webpack_require__(102);

              /**
               * Creates an array of the own and inherited enumerable property names of `object`.
               *
               * **Note:** Non-object values are coerced to objects.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Object
               * @param {Object} object The object to query.
               * @returns {Array} Returns the array of property names.
               * @example
               *
               * function Foo() {
               *   this.a = 1;
               *   this.b = 2;
               * }
               *
               * Foo.prototype.c = 3;
               *
               * _.keysIn(new Foo);
               * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
               */
              function keysIn(object) {
                return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
              }

              module.exports = keysIn;

              /***/
            },
            /* 212 */
            /***/ function (module, exports, __webpack_require__) {
              var baseTimes = __webpack_require__(213),
                isArguments = __webpack_require__(214),
                isArray = __webpack_require__(105),
                isBuffer = __webpack_require__(216),
                isIndex = __webpack_require__(104),
                isTypedArray = __webpack_require__(218);

              /** Used for built-in method references. */
              var objectProto = Object.prototype;

              /** Used to check objects for own properties. */
              var hasOwnProperty = objectProto.hasOwnProperty;

              /**
               * Creates an array of the enumerable property names of the array-like `value`.
               *
               * @private
               * @param {*} value The value to query.
               * @param {boolean} inherited Specify returning inherited property names.
               * @returns {Array} Returns the array of property names.
               */
              function arrayLikeKeys(value, inherited) {
                var isArr = isArray(value),
                  isArg = !isArr && isArguments(value),
                  isBuff = !isArr && !isArg && isBuffer(value),
                  isType = !isArr && !isArg && !isBuff && isTypedArray(value),
                  skipIndexes = isArr || isArg || isBuff || isType,
                  result = skipIndexes ? baseTimes(value.length, String) : [],
                  length = result.length;

                for (var key in value) {
                  if (
                    (inherited || hasOwnProperty.call(value, key)) &&
                    !(
                      skipIndexes &&
                      // Safari 9 has enumerable `arguments.length` in strict mode.
                      (key == 'length' ||
                        // Node.js 0.10 has enumerable non-index properties on buffers.
                        (isBuff && (key == 'offset' || key == 'parent')) ||
                        // PhantomJS 2 has enumerable non-index properties on typed arrays.
                        (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
                        // Skip index properties.
                        isIndex(key, length))
                    )
                  ) {
                    result.push(key);
                  }
                }
                return result;
              }

              module.exports = arrayLikeKeys;

              /***/
            },
            /* 213 */
            /***/ function (module, exports) {
              /**
               * The base implementation of `_.times` without support for iteratee shorthands
               * or max array length checks.
               *
               * @private
               * @param {number} n The number of times to invoke `iteratee`.
               * @param {Function} iteratee The function invoked per iteration.
               * @returns {Array} Returns the array of results.
               */
              function baseTimes(n, iteratee) {
                var index = -1,
                  result = Array(n);

                while (++index < n) {
                  result[index] = iteratee(index);
                }
                return result;
              }

              module.exports = baseTimes;

              /***/
            },
            /* 214 */
            /***/ function (module, exports, __webpack_require__) {
              var baseIsArguments = __webpack_require__(215),
                isObjectLike = __webpack_require__(22);

              /** Used for built-in method references. */
              var objectProto = Object.prototype;

              /** Used to check objects for own properties. */
              var hasOwnProperty = objectProto.hasOwnProperty;

              /** Built-in value references. */
              var propertyIsEnumerable = objectProto.propertyIsEnumerable;

              /**
               * Checks if `value` is likely an `arguments` object.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is an `arguments` object,
               *  else `false`.
               * @example
               *
               * _.isArguments(function() { return arguments; }());
               * // => true
               *
               * _.isArguments([1, 2, 3]);
               * // => false
               */
              var isArguments = baseIsArguments(
                (function () {
                  return arguments;
                })()
              )
                ? baseIsArguments
                : function (value) {
                    return (
                      isObjectLike(value) &&
                      hasOwnProperty.call(value, 'callee') &&
                      !propertyIsEnumerable.call(value, 'callee')
                    );
                  };

              module.exports = isArguments;

              /***/
            },
            /* 215 */
            /***/ function (module, exports, __webpack_require__) {
              var baseGetTag = __webpack_require__(21),
                isObjectLike = __webpack_require__(22);

              /** `Object#toString` result references. */
              var argsTag = '[object Arguments]';

              /**
               * The base implementation of `_.isArguments`.
               *
               * @private
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is an `arguments` object,
               */
              function baseIsArguments(value) {
                return isObjectLike(value) && baseGetTag(value) == argsTag;
              }

              module.exports = baseIsArguments;

              /***/
            },
            /* 216 */
            /***/ function (module, exports, __webpack_require__) {
              /* WEBPACK VAR INJECTION */ (function (module) {
                var root = __webpack_require__(59),
                  stubFalse = __webpack_require__(217);

                /** Detect free variable `exports`. */
                var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

                /** Detect free variable `module`. */
                var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

                /** Detect the popular CommonJS extension `module.exports`. */
                var moduleExports = freeModule && freeModule.exports === freeExports;

                /** Built-in value references. */
                var Buffer = moduleExports ? root.Buffer : undefined;

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

                /**
                 * Checks if `value` is a buffer.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.3.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
                 * @example
                 *
                 * _.isBuffer(new Buffer(2));
                 * // => true
                 *
                 * _.isBuffer(new Uint8Array(2));
                 * // => false
                 */
                var isBuffer = nativeIsBuffer || stubFalse;

                module.exports = isBuffer;

                /* WEBPACK VAR INJECTION */
              }).call(exports, __webpack_require__(54)(module));

              /***/
            },
            /* 217 */
            /***/ function (module, exports) {
              /**
               * This method returns `false`.
               *
               * @static
               * @memberOf _
               * @since 4.13.0
               * @category Util
               * @returns {boolean} Returns `false`.
               * @example
               *
               * _.times(2, _.stubFalse);
               * // => [false, false]
               */
              function stubFalse() {
                return false;
              }

              module.exports = stubFalse;

              /***/
            },
            /* 218 */
            /***/ function (module, exports, __webpack_require__) {
              var baseIsTypedArray = __webpack_require__(219),
                baseUnary = __webpack_require__(220),
                nodeUtil = __webpack_require__(221);

              /* Node.js helper references. */
              var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

              /**
               * Checks if `value` is classified as a typed array.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
               * @example
               *
               * _.isTypedArray(new Uint8Array);
               * // => true
               *
               * _.isTypedArray([]);
               * // => false
               */
              var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

              module.exports = isTypedArray;

              /***/
            },
            /* 219 */
            /***/ function (module, exports, __webpack_require__) {
              var baseGetTag = __webpack_require__(21),
                isLength = __webpack_require__(103),
                isObjectLike = __webpack_require__(22);

              /** `Object#toString` result references. */
              var argsTag = '[object Arguments]',
                arrayTag = '[object Array]',
                boolTag = '[object Boolean]',
                dateTag = '[object Date]',
                errorTag = '[object Error]',
                funcTag = '[object Function]',
                mapTag = '[object Map]',
                numberTag = '[object Number]',
                objectTag = '[object Object]',
                regexpTag = '[object RegExp]',
                setTag = '[object Set]',
                stringTag = '[object String]',
                weakMapTag = '[object WeakMap]';

              var arrayBufferTag = '[object ArrayBuffer]',
                dataViewTag = '[object DataView]',
                float32Tag = '[object Float32Array]',
                float64Tag = '[object Float64Array]',
                int8Tag = '[object Int8Array]',
                int16Tag = '[object Int16Array]',
                int32Tag = '[object Int32Array]',
                uint8Tag = '[object Uint8Array]',
                uint8ClampedTag = '[object Uint8ClampedArray]',
                uint16Tag = '[object Uint16Array]',
                uint32Tag = '[object Uint32Array]';

              /** Used to identify `toStringTag` values of typed arrays. */
              var typedArrayTags = {};
              typedArrayTags[float32Tag] =
                typedArrayTags[float64Tag] =
                typedArrayTags[int8Tag] =
                typedArrayTags[int16Tag] =
                typedArrayTags[int32Tag] =
                typedArrayTags[uint8Tag] =
                typedArrayTags[uint8ClampedTag] =
                typedArrayTags[uint16Tag] =
                typedArrayTags[uint32Tag] =
                  true;
              typedArrayTags[argsTag] =
                typedArrayTags[arrayTag] =
                typedArrayTags[arrayBufferTag] =
                typedArrayTags[boolTag] =
                typedArrayTags[dataViewTag] =
                typedArrayTags[dateTag] =
                typedArrayTags[errorTag] =
                typedArrayTags[funcTag] =
                typedArrayTags[mapTag] =
                typedArrayTags[numberTag] =
                typedArrayTags[objectTag] =
                typedArrayTags[regexpTag] =
                typedArrayTags[setTag] =
                typedArrayTags[stringTag] =
                typedArrayTags[weakMapTag] =
                  false;

              /**
               * The base implementation of `_.isTypedArray` without Node.js optimizations.
               *
               * @private
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
               */
              function baseIsTypedArray(value) {
                return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
              }

              module.exports = baseIsTypedArray;

              /***/
            },
            /* 220 */
            /***/ function (module, exports) {
              /**
               * The base implementation of `_.unary` without support for storing metadata.
               *
               * @private
               * @param {Function} func The function to cap arguments for.
               * @returns {Function} Returns the new capped function.
               */
              function baseUnary(func) {
                return function (value) {
                  return func(value);
                };
              }

              module.exports = baseUnary;

              /***/
            },
            /* 221 */
            /***/ function (module, exports, __webpack_require__) {
              /* WEBPACK VAR INJECTION */ (function (module) {
                var freeGlobal = __webpack_require__(99);

                /** Detect free variable `exports`. */
                var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

                /** Detect free variable `module`. */
                var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

                /** Detect the popular CommonJS extension `module.exports`. */
                var moduleExports = freeModule && freeModule.exports === freeExports;

                /** Detect free variable `process` from Node.js. */
                var freeProcess = moduleExports && freeGlobal.process;

                /** Used to access faster Node.js helpers. */
                var nodeUtil = (function () {
                  try {
                    return freeProcess && freeProcess.binding && freeProcess.binding('util');
                  } catch (e) {}
                })();

                module.exports = nodeUtil;

                /* WEBPACK VAR INJECTION */
              }).call(exports, __webpack_require__(54)(module));

              /***/
            },
            /* 222 */
            /***/ function (module, exports, __webpack_require__) {
              var isObject = __webpack_require__(27),
                isPrototype = __webpack_require__(223),
                nativeKeysIn = __webpack_require__(224);

              /** Used for built-in method references. */
              var objectProto = Object.prototype;

              /** Used to check objects for own properties. */
              var hasOwnProperty = objectProto.hasOwnProperty;

              /**
               * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
               *
               * @private
               * @param {Object} object The object to query.
               * @returns {Array} Returns the array of property names.
               */
              function baseKeysIn(object) {
                if (!isObject(object)) {
                  return nativeKeysIn(object);
                }
                var isProto = isPrototype(object),
                  result = [];

                for (var key in object) {
                  if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
                    result.push(key);
                  }
                }
                return result;
              }

              module.exports = baseKeysIn;

              /***/
            },
            /* 223 */
            /***/ function (module, exports) {
              /** Used for built-in method references. */
              var objectProto = Object.prototype;

              /**
               * Checks if `value` is likely a prototype object.
               *
               * @private
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
               */
              function isPrototype(value) {
                var Ctor = value && value.constructor,
                  proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

                return value === proto;
              }

              module.exports = isPrototype;

              /***/
            },
            /* 224 */
            /***/ function (module, exports) {
              /**
               * This function is like
               * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
               * except that it includes inherited enumerable properties.
               *
               * @private
               * @param {Object} object The object to query.
               * @returns {Array} Returns the array of property names.
               */
              function nativeKeysIn(object) {
                var result = [];
                if (object != null) {
                  for (var key in Object(object)) {
                    result.push(key);
                  }
                }
                return result;
              }

              module.exports = nativeKeysIn;

              /***/
            },
            /* 225 */
            /***/ function (module, exports, __webpack_require__) {
              var isNumber = __webpack_require__(226);

              /**
               * Checks if `value` is `NaN`.
               *
               * **Note:** This method is based on
               * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
               * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
               * `undefined` and other non-number values.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
               * @example
               *
               * _.isNaN(NaN);
               * // => true
               *
               * _.isNaN(new Number(NaN));
               * // => true
               *
               * isNaN(undefined);
               * // => true
               *
               * _.isNaN(undefined);
               * // => false
               */
              function isNaN(value) {
                // An `NaN` primitive is the only value that is not equal to itself.
                // Perform the `toStringTag` check first to avoid errors with some
                // ActiveX objects in IE.
                return isNumber(value) && value != +value;
              }

              module.exports = isNaN;

              /***/
            },
            /* 226 */
            /***/ function (module, exports, __webpack_require__) {
              var baseGetTag = __webpack_require__(21),
                isObjectLike = __webpack_require__(22);

              /** `Object#toString` result references. */
              var numberTag = '[object Number]';

              /**
               * Checks if `value` is classified as a `Number` primitive or object.
               *
               * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
               * classified as numbers, use the `_.isFinite` method.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a number, else `false`.
               * @example
               *
               * _.isNumber(3);
               * // => true
               *
               * _.isNumber(Number.MIN_VALUE);
               * // => true
               *
               * _.isNumber(Infinity);
               * // => true
               *
               * _.isNumber('3');
               * // => false
               */
              function isNumber(value) {
                return typeof value == 'number' || (isObjectLike(value) && baseGetTag(value) == numberTag);
              }

              module.exports = isNumber;

              /***/
            },
            /* 227 */
            /***/ function (module, exports, __webpack_require__) {
              var baseGetTag = __webpack_require__(21),
                getPrototype = __webpack_require__(228),
                isObjectLike = __webpack_require__(22);

              /** `Object#toString` result references. */
              var objectTag = '[object Object]';

              /** Used for built-in method references. */
              var funcProto = Function.prototype,
                objectProto = Object.prototype;

              /** Used to resolve the decompiled source of functions. */
              var funcToString = funcProto.toString;

              /** Used to check objects for own properties. */
              var hasOwnProperty = objectProto.hasOwnProperty;

              /** Used to infer the `Object` constructor. */
              var objectCtorString = funcToString.call(Object);

              /**
               * Checks if `value` is a plain object, that is, an object created by the
               * `Object` constructor or one with a `[[Prototype]]` of `null`.
               *
               * @static
               * @memberOf _
               * @since 0.8.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
               * @example
               *
               * function Foo() {
               *   this.a = 1;
               * }
               *
               * _.isPlainObject(new Foo);
               * // => false
               *
               * _.isPlainObject([1, 2, 3]);
               * // => false
               *
               * _.isPlainObject({ 'x': 0, 'y': 0 });
               * // => true
               *
               * _.isPlainObject(Object.create(null));
               * // => true
               */
              function isPlainObject(value) {
                if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
                  return false;
                }
                var proto = getPrototype(value);
                if (proto === null) {
                  return true;
                }
                var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
                return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
              }

              module.exports = isPlainObject;

              /***/
            },
            /* 228 */
            /***/ function (module, exports, __webpack_require__) {
              var overArg = __webpack_require__(229);

              /** Built-in value references. */
              var getPrototype = overArg(Object.getPrototypeOf, Object);

              module.exports = getPrototype;

              /***/
            },
            /* 229 */
            /***/ function (module, exports) {
              /**
               * Creates a unary function that invokes `func` with its argument transformed.
               *
               * @private
               * @param {Function} func The function to wrap.
               * @param {Function} transform The argument transform.
               * @returns {Function} Returns the new function.
               */
              function overArg(func, transform) {
                return function (arg) {
                  return func(transform(arg));
                };
              }

              module.exports = overArg;

              /***/
            },
            /* 230 */
            /***/ function (module, exports, __webpack_require__) {
              var baseGetTag = __webpack_require__(21),
                isArray = __webpack_require__(105),
                isObjectLike = __webpack_require__(22);

              /** `Object#toString` result references. */
              var stringTag = '[object String]';

              /**
               * Checks if `value` is classified as a `String` primitive or object.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a string, else `false`.
               * @example
               *
               * _.isString('abc');
               * // => true
               *
               * _.isString(1);
               * // => false
               */
              function isString(value) {
                return (
                  typeof value == 'string' || (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag)
                );
              }

              module.exports = isString;

              /***/
            },
            /* 231 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

              /**
               * Represents the current currency settings.
               */
              var State =
                /**
                 * Create new instance of the state.
                 */
                function State() {
                  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, State);

                  /** @type {null|String} */
                  this.currency = null;
                  /** @type {Number} */
                  this.taxRate = 0;
                };

              /** @ignore */

              /* harmony default export */ __webpack_exports__['a'] = new State();

              /***/
            },
            /* 232 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ =
                __webpack_require__(233);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ =
                __webpack_require__(1);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);

              /**
               * Represents a unique set of MoneySpan objects.
               */
              var MoneySpanSet = (function () {
                /**
                 * Create an empty MoneySpanSet.
                 */
                function MoneySpanSet() {
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MoneySpanSet);

                  /** @type {Object<String, MoneySpan>} */
                  this._spansByElement = {};
                }

                /**
                 * Add a new span to the set.
                 * @param {src/plugins/easycurrency/MoneySpan.js~MoneySpan}	moneySpan - Span to add
                 */

                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MoneySpanSet, [
                  {
                    key: 'add',
                    value: function add(moneySpan) {
                      this._spansByElement[moneySpan.getElement()] = moneySpan;
                    }

                    /**
                     * Find a span by the element it renders to.
                     * @param {type}	element - The element the span renders to.
                     * @return {undefined|src/plugins/easycurrency/MoneySpan.js~MoneySpan}
                     */
                  },
                  {
                    key: 'findByElement',
                    value: function findByElement(element) {
                      return this._spansByElement[element];
                    }

                    /**
                     * Returns a list of all the spans in the set.
                     * @return {MoneySpan[]}
                     */
                  },
                  {
                    key: 'list',
                    value: function list() {
                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(
                        this._spansByElement
                      );
                    }
                  }
                ]);

                return MoneySpanSet;
              })();

              /* harmony default export */ __webpack_exports__['a'] = MoneySpanSet;

              /***/
            },
            /* 233 */
            /***/ function (module, exports, __webpack_require__) {
              module.exports = { default: __webpack_require__(234), __esModule: true };

              /***/
            },
            /* 234 */
            /***/ function (module, exports, __webpack_require__) {
              __webpack_require__(235);
              module.exports = __webpack_require__(2).Object.values;

              /***/
            },
            /* 235 */
            /***/ function (module, exports, __webpack_require__) {
              // https://github.com/tc39/proposal-object-values-entries
              var $export = __webpack_require__(6);
              var $values = __webpack_require__(236)(false);

              $export($export.S, 'Object', {
                values: function values(it) {
                  return $values(it);
                }
              });

              /***/
            },
            /* 236 */
            /***/ function (module, exports, __webpack_require__) {
              var getKeys = __webpack_require__(18);
              var toIObject = __webpack_require__(12);
              var isEnum = __webpack_require__(26).f;
              module.exports = function (isEntries) {
                return function (it) {
                  var O = toIObject(it);
                  var keys = getKeys(O);
                  var length = keys.length;
                  var i = 0;
                  var result = [];
                  var key;
                  while (length > i)
                    if (isEnum.call(O, (key = keys[i++]))) {
                      result.push(isEntries ? [key, O[key]] : O[key]);
                    }
                  return result;
                };
              };

              /***/
            },
            /* 237 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ =
                __webpack_require__(1);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(106);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_money__ = __webpack_require__(57);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_money___default = __webpack_require__.n(
                __WEBPACK_IMPORTED_MODULE_3_js_money__
              );

              /**
               * Represents an element which renders a monetary value.
               */

              var MoneySpan = (function () {
                /**
                 * Create a new MoneySpan instance.
                 * @param {js-money} money The initial value of the element.
                 * @param {src/plugins/easycurrency/main.js~EasyCurrency} easyCurrency EasyCurrency
                 */
                function MoneySpan(money, easyCurrency) {
                  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MoneySpan);

                  /** @type {DOMNode} */
                  this._element = null;
                  /** @type {js-money} */
                  this._money = money;
                  /** @type {src/plugins/easycurrency/main.js~EasyCurrency} */
                  this._easyCurrency = easyCurrency;
                }

                /**
                 * Retrieves the element this money span is attached to.
                 * @return {DOMNode}
                 */

                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MoneySpan, [
                  {
                    key: 'getElement',
                    value: function getElement() {
                      return this._element;
                    }

                    /**
                     * Attaches this money span to the given element.
                     * @param {DOMNode}	el - The element to attach to.
                     */
                  },
                  {
                    key: 'setElement',
                    value: function setElement(el) {
                      this._element = el;
                    }

                    /**
                     * Destroys this MoneySpan.
                     */
                  },
                  {
                    key: 'destroy',
                    value: function destroy() {
                      this._element = null;
                      this._easyCurrency = null;
                      this._money = null;
                    }

                    /**
                     * Set an element which this money value will render to when changed.
                     * @param {DOMNode} element - The element to render to.
                     */
                  },
                  {
                    key: 'setRenderElement',
                    value: function setRenderElement(element) {
                      this._element = element;
                      this.render();
                    }

                    /**
                     * Change the value of this MoneySpan.
                     * @param {js-money} money
                     */
                  },
                  {
                    key: 'set',
                    value: function set(money) {
                      this._money = money;
                      this.render();
                    }

                    /**
                     * Re-render the element.
                     */
                  },
                  {
                    key: 'render',
                    value: function render() {
                      var _this = this;

                      if (!this._element) {
                        return;
                      }

                      this._easyCurrency
                        .addTax(this._money)
                        .then(function (v) {
                          return _this._easyCurrency.convert(v);
                        })
                        .then(function (v) {
                          return _this._easyCurrency.format(v);
                        })
                        .then(function (str) {
                          _this._element.innerText = str;
                        });
                    }
                  }
                ]);

                return MoneySpan;
              })();

              /* harmony default export */ __webpack_exports__['a'] = MoneySpan;

              /***/
            },
            /* 238 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ =
                __webpack_require__(239);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ =
                __webpack_require__(19);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ =
                __webpack_require__(20);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ =
                __webpack_require__(14);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ =
                __webpack_require__(1);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ =
                __webpack_require__(15);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ =
                __webpack_require__(16);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CurrencyResolver__ = __webpack_require__(107);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_index__ = __webpack_require__(28);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_js_money_lib_currency_js__ =
                __webpack_require__(60);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_js_money_lib_currency_js___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_js_money_lib_currency_js__);

              /**
               * Gets currency information from the ESC Geoservice.
               * @private
               */

              var GeoserviceResolver = (function (_CurrencyResolver) {
                __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(
                  GeoserviceResolver,
                  _CurrencyResolver
                );

                /**
                 * Create new instance of GeoserviceResolver.
                 */
                function GeoserviceResolver() {
                  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(
                    this,
                    GeoserviceResolver
                  );

                  /** @type {Object} */
                  var _this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(
                    this,
                    (
                      GeoserviceResolver.__proto__ ||
                      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(
                        GeoserviceResolver
                      )
                    ).call(this)
                  );

                  _this._rates = null;
                  /** @type {Boolean} */
                  _this._requested = false;
                  /** @type {Promise<Object, Error} */
                  _this._ratesPromise = null;
                  return _this;
                }

                /**
                 * Retrieves rates from the server.
                 * Rates are cached in memory.
                 * @return {Promise<Object, Error>}
                 */

                __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(GeoserviceResolver, [
                  {
                    key: '_getRates',
                    value: (function () {
                      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(
                        /*#__PURE__*/ __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(
                          function _callee2() {
                            var _this2 = this;

                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(
                              function _callee2$(_context2) {
                                while (1) {
                                  switch ((_context2.prev = _context2.next)) {
                                    case 0:
                                      if (!this._rates) {
                                        _context2.next = 2;
                                        break;
                                      }

                                      return _context2.abrupt('return', this._rates);

                                    case 2:
                                      if (!this._ratesPromise) {
                                        this._ratesPromise =
                                          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(
                                            /*#__PURE__*/ __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(
                                              function _callee() {
                                                var rates;
                                                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(
                                                  function _callee$(_context) {
                                                    while (1) {
                                                      switch ((_context.prev = _context.next)) {
                                                        case 0:
                                                          _context.next = 2;
                                                          return __WEBPACK_IMPORTED_MODULE_9_index__[
                                                            'geoService'
                                                          ].getCurrencyInfo();

                                                        case 2:
                                                          rates = _context.sent;

                                                          _this2._rates = rates;
                                                          return _context.abrupt('return', rates);

                                                        case 5:
                                                        case 'end':
                                                          return _context.stop();
                                                      }
                                                    }
                                                  },
                                                  _callee,
                                                  _this2
                                                );
                                              }
                                            )
                                          )();
                                      }
                                      _context2.next = 5;
                                      return this._ratesPromise;

                                    case 5:
                                      return _context2.abrupt('return', _context2.sent);

                                    case 6:
                                    case 'end':
                                      return _context2.stop();
                                  }
                                }
                              },
                              _callee2,
                              this
                            );
                          }
                        )
                      );

                      function _getRates() {
                        return _ref.apply(this, arguments);
                      }

                      return _getRates;
                    })()

                    /**
                     * List the available currencies.
                     * @return {String[]}
                     * @throws {Error} - CurrencyResolver should implement listCurrencyCodes
                     */
                  },
                  {
                    key: 'listCurrencyCodes',
                    value: (function () {
                      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(
                        /*#__PURE__*/ __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(
                          function _callee3() {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(
                              function _callee3$(_context3) {
                                while (1) {
                                  switch ((_context3.prev = _context3.next)) {
                                    case 0:
                                      return _context3.abrupt(
                                        'return',
                                        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(
                                          __WEBPACK_IMPORTED_MODULE_10_js_money_lib_currency_js__
                                        )
                                      );

                                    case 1:
                                    case 'end':
                                      return _context3.stop();
                                  }
                                }
                              },
                              _callee3,
                              this
                            );
                          }
                        )
                      );

                      function listCurrencyCodes() {
                        return _ref3.apply(this, arguments);
                      }

                      return listCurrencyCodes;
                    })()

                    /**
                     * Get conversion rate for a specific currency pair.
                     * @param {String}	from
                     * @param {String}	to
                     * @return {Number}
                     * @throws {Error} - CurrencyResolver should implement getConversionRate
                     */
                  },
                  {
                    key: 'getConversionRate',
                    value: (function () {
                      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(
                        /*#__PURE__*/ __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(
                          function _callee4(from, to) {
                            var info, usdToFrom, fromToUsd, usdToTo, combinedRate;
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(
                              function _callee4$(_context4) {
                                while (1) {
                                  switch ((_context4.prev = _context4.next)) {
                                    case 0:
                                      _context4.next = 2;
                                      return this._getRates();

                                    case 2:
                                      info = _context4.sent;
                                      usdToFrom = from == 'USD' ? 1 : info.rates[from];
                                      fromToUsd = 1 / usdToFrom;
                                      usdToTo = to == 'USD' ? 1 : info.rates[to];
                                      combinedRate = fromToUsd * usdToTo;
                                      return _context4.abrupt('return', combinedRate);

                                    case 8:
                                    case 'end':
                                      return _context4.stop();
                                  }
                                }
                              },
                              _callee4,
                              this
                            );
                          }
                        )
                      );

                      function getConversionRate(_x, _x2) {
                        return _ref4.apply(this, arguments);
                      }

                      return getConversionRate;
                    })()
                  }
                ]);

                return GeoserviceResolver;
              })(__WEBPACK_IMPORTED_MODULE_8__CurrencyResolver__['a' /* default */]);

              /* harmony default export */ __webpack_exports__['a'] = GeoserviceResolver;

              /***/
            },
            /* 239 */
            /***/ function (module, exports, __webpack_require__) {
              module.exports = { default: __webpack_require__(240), __esModule: true };

              /***/
            },
            /* 240 */
            /***/ function (module, exports, __webpack_require__) {
              __webpack_require__(241);
              module.exports = __webpack_require__(2).Object.keys;

              /***/
            },
            /* 241 */
            /***/ function (module, exports, __webpack_require__) {
              // 19.1.2.14 Object.keys(O)
              var toObject = __webpack_require__(34);
              var $keys = __webpack_require__(18);

              __webpack_require__(76)('keys', function () {
                return function keys(it) {
                  return $keys(toObject(it));
                };
              });

              /***/
            },
            /* 242 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ =
                __webpack_require__(14);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ =
                __webpack_require__(1);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ =
                __webpack_require__(15);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ =
                __webpack_require__(16);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_money_lib_currency_js__ = __webpack_require__(60);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_money_lib_currency_js___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_money_lib_currency_js__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Formatter__ = __webpack_require__(108);

              /**
               * A default formatting implementation.
               * Formats most currencies as $00.00, except JPY which is 00 $
               */

              var DefaultFormatter = (function (_Formatter) {
                __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DefaultFormatter, _Formatter);

                function DefaultFormatter() {
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DefaultFormatter);

                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(
                    this,
                    (
                      DefaultFormatter.__proto__ ||
                      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(
                        DefaultFormatter
                      )
                    ).apply(this, arguments)
                  );
                }

                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DefaultFormatter, [
                  {
                    key: 'format',

                    /**
                     * Format a currency.
                     * @param {type}	amount - Amount in cents.
                     * @param {type}	currency - Currency code to convert to.
                     * @return {String}
                     */
                    value: function format(amount, currency) {
                      var currencyInfo = __WEBPACK_IMPORTED_MODULE_5_js_money_lib_currency_js__[currency];

                      if (currencyInfo.code == 'JPY') {
                        return this._suffixSymbolNoDecimal(amount, currencyInfo, true);
                      }

                      return this._formatPrefixedSymbolTwoDecimal(amount, currencyInfo, false);
                    }

                    /**
                     * Format as 00 $
                     * @param {Number}	amount
                     * @param {Object}	currencyInfo
                     * @param {Boolean}	space
                     * @return {String}
                     */
                  },
                  {
                    key: '_suffixSymbolNoDecimal',
                    value: function _suffixSymbolNoDecimal(amount, currencyInfo, space) {
                      // Amount is always in cents, even for JPY
                      return amount / 100 + (space ? ' ' : '') + currencyInfo.symbol_native;
                    }

                    /**
                     * Format as $00.00
                     * @param {Number}	amount
                     * @param {Object}	currencyInfo
                     * @param {Boolean}	space
                     * @return {String}
                     */
                  },
                  {
                    key: '_formatPrefixedSymbolTwoDecimal',
                    value: function _formatPrefixedSymbolTwoDecimal(amount, currencyInfo, space) {
                      return currencyInfo.symbol_native + (space ? ' ' : '') + (amount / 100).toFixed(2);
                    }
                  }
                ]);

                return DefaultFormatter;
              })(__WEBPACK_IMPORTED_MODULE_6__Formatter__['a' /* default */]);

              /* harmony default export */ __webpack_exports__['a'] = DefaultFormatter;

              /***/
            },
            /* 243 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ =
                __webpack_require__(1);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);

              /**
               * Helper to bind select elements to EasyCurrency.
               */
              var SelectHelper = (function () {
                /**
                 * Construct a new instance of the helper.
                 * @param {src/plugins/easycurrency/EasyCurrency.js~EasyCurrency} easyCurrency
                 */
                function SelectHelper(easyCurrency) {
                  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SelectHelper);

                  /** @type {src/plugins/easycurrency/EasyCurrency.js~EasyCurrency} */
                  this._easyCurrency = easyCurrency;
                }

                /**
                 * Bind a input element with EasyCurrency.
                 * @param {DOMNode}	element
                 */

                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(SelectHelper, [
                  {
                    key: 'link',
                    value: function link(element) {
                      var _this = this;

                      element.addEventListener('change', function (e) {
                        _this._easyCurrency.setActiveCurrency(element.value);
                      });

                      this._easyCurrency.on('currencyChanged', function (e) {
                        var newCurrency = e.data;
                        element.value = newCurrency;
                      });

                      element.value = this._easyCurrency.getActiveCurrency();
                    }
                  }
                ]);

                return SelectHelper;
              })();

              /* harmony default export */ __webpack_exports__['a'] = SelectHelper;

              /***/
            },
            /* 244 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ =
                __webpack_require__(1);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_local_storage_fallback__ = __webpack_require__(245);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_local_storage_fallback___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_local_storage_fallback__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_general__ = __webpack_require__(61);

              /**
               * Methods for persisting the state into the current session.
               */

              var Session = (function () {
                function Session() {
                  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Session);
                }

                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Session, [
                  {
                    key: 'getCurrency',

                    /**
                     * Retrieves the active currency from session.
                     * @return {undefined|String}
                     */
                    value: function getCurrency() {
                      return __WEBPACK_IMPORTED_MODULE_2_local_storage_fallback___default.a.getItem(
                        __WEBPACK_IMPORTED_MODULE_3_utils_general__['a' /* default */].safeStorageKey(
                          'escshopify',
                          'EasyCurrency::Session:currency'
                        )
                      );
                    }

                    /**
                     * Records the active currency in the session.
                     * @param {null|String}	value - The currency to record, or null to clear.
                     */
                  },
                  {
                    key: 'saveCurrency',
                    value: function saveCurrency(value) {
                      __WEBPACK_IMPORTED_MODULE_2_local_storage_fallback___default.a.setItem(
                        __WEBPACK_IMPORTED_MODULE_3_utils_general__['a' /* default */].safeStorageKey(
                          'escshopify',
                          'EasyCurrency::Session:currency'
                        ),
                        value
                      );
                    }
                  }
                ]);

                return Session;
              })();

              /* harmony default export */ __webpack_exports__['a'] = Session;

              /***/
            },
            /* 245 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              Object.defineProperty(exports, '__esModule', {
                value: true
              });
              exports.MemoryStorage = exports.CookieStorage = exports.isSupported = exports.storage = undefined;

              var _isSupported = __webpack_require__(246);

              var _isSupported2 = _interopRequireDefault(_isSupported);

              var _CookieStorage = __webpack_require__(109);

              var _CookieStorage2 = _interopRequireDefault(_CookieStorage);

              var _MemoryStorage = __webpack_require__(248);

              var _MemoryStorage2 = _interopRequireDefault(_MemoryStorage);

              function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : { default: obj };
              }

              var storage = null;

              if ((0, _isSupported2.default)('localStorage')) {
                // use localStorage
                exports.storage = storage = window.localStorage;
              } else if ((0, _isSupported2.default)('sessionStorage')) {
                // use sessionStorage
                exports.storage = storage = window.sessionStorage;
              } else if ((0, _isSupported2.default)('cookieStorage')) {
                // use cookies
                exports.storage = storage = new _CookieStorage2.default();
              } else {
                // use memory
                exports.storage = storage = new _MemoryStorage2.default();
              }

              exports.default = storage;
              exports.storage = storage;
              exports.isSupported = _isSupported2.default;
              exports.CookieStorage = _CookieStorage2.default;
              exports.MemoryStorage = _MemoryStorage2.default;

              /***/
            },
            /* 246 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              Object.defineProperty(exports, '__esModule', {
                value: true
              });
              exports.default = isSupported;

              var _CookieStorage = __webpack_require__(109);

              var TEST_KEY = '__test';

              function hasStorage(name) {
                try {
                  var storage = window[name];
                  storage.setItem(TEST_KEY, '1');
                  storage.removeItem(TEST_KEY);
                  return true;
                } catch (e) {
                  return false;
                }
              }

              function isSupported() {
                var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'localStorage';

                var storage = String(name)
                  .replace(/storage$/i, '')
                  .toLowerCase();

                if (storage === 'local') {
                  return hasStorage('localStorage');
                }

                if (storage === 'session') {
                  return hasStorage('sessionStorage');
                }

                if (storage === 'cookie') {
                  return (0, _CookieStorage.hasCookies)();
                }

                if (storage === 'memory') {
                  return true;
                }

                throw new Error(
                  'Storage method `' +
                    name +
                    '` is not available.\n    Please use one of the following: localStorage, sessionStorage, cookieStorage, memoryStorage.'
                );
              }

              /***/
            },
            /* 247 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';
              /*!
               * cookie
               * Copyright(c) 2012-2014 Roman Shtylman
               * Copyright(c) 2015 Douglas Christopher Wilson
               * MIT Licensed
               */

              /**
               * Module exports.
               * @public
               */

              exports.parse = parse;
              exports.serialize = serialize;

              /**
               * Module variables.
               * @private
               */

              var decode = decodeURIComponent;
              var encode = encodeURIComponent;
              var pairSplitRegExp = /; */;

              /**
               * RegExp to match field-content in RFC 7230 sec 3.2
               *
               * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
               * field-vchar   = VCHAR / obs-text
               * obs-text      = %x80-FF
               */

              var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

              /**
               * Parse a cookie header.
               *
               * Parse the given cookie header string into an object
               * The object has the various cookies as keys(names) => values
               *
               * @param {string} str
               * @param {object} [options]
               * @return {object}
               * @public
               */

              function parse(str, options) {
                if (typeof str !== 'string') {
                  throw new TypeError('argument str must be a string');
                }

                var obj = {};
                var opt = options || {};
                var pairs = str.split(pairSplitRegExp);
                var dec = opt.decode || decode;

                for (var i = 0; i < pairs.length; i++) {
                  var pair = pairs[i];
                  var eq_idx = pair.indexOf('=');

                  // skip things that don't look like key=value
                  if (eq_idx < 0) {
                    continue;
                  }

                  var key = pair.substr(0, eq_idx).trim();
                  var val = pair.substr(++eq_idx, pair.length).trim();

                  // quoted values
                  if ('"' == val[0]) {
                    val = val.slice(1, -1);
                  }

                  // only assign once
                  if (undefined == obj[key]) {
                    obj[key] = tryDecode(val, dec);
                  }
                }

                return obj;
              }

              /**
               * Serialize data into a cookie header.
               *
               * Serialize the a name value pair into a cookie string suitable for
               * http headers. An optional options object specified cookie parameters.
               *
               * serialize('foo', 'bar', { httpOnly: true })
               *   => "foo=bar; httpOnly"
               *
               * @param {string} name
               * @param {string} val
               * @param {object} [options]
               * @return {string}
               * @public
               */

              function serialize(name, val, options) {
                var opt = options || {};
                var enc = opt.encode || encode;

                if (typeof enc !== 'function') {
                  throw new TypeError('option encode is invalid');
                }

                if (!fieldContentRegExp.test(name)) {
                  throw new TypeError('argument name is invalid');
                }

                var value = enc(val);

                if (value && !fieldContentRegExp.test(value)) {
                  throw new TypeError('argument val is invalid');
                }

                var str = name + '=' + value;

                if (null != opt.maxAge) {
                  var maxAge = opt.maxAge - 0;
                  if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
                  str += '; Max-Age=' + Math.floor(maxAge);
                }

                if (opt.domain) {
                  if (!fieldContentRegExp.test(opt.domain)) {
                    throw new TypeError('option domain is invalid');
                  }

                  str += '; Domain=' + opt.domain;
                }

                if (opt.path) {
                  if (!fieldContentRegExp.test(opt.path)) {
                    throw new TypeError('option path is invalid');
                  }

                  str += '; Path=' + opt.path;
                }

                if (opt.expires) {
                  if (typeof opt.expires.toUTCString !== 'function') {
                    throw new TypeError('option expires is invalid');
                  }

                  str += '; Expires=' + opt.expires.toUTCString();
                }

                if (opt.httpOnly) {
                  str += '; HttpOnly';
                }

                if (opt.secure) {
                  str += '; Secure';
                }

                if (opt.sameSite) {
                  var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;

                  switch (sameSite) {
                    case true:
                      str += '; SameSite=Strict';
                      break;
                    case 'lax':
                      str += '; SameSite=Lax';
                      break;
                    case 'strict':
                      str += '; SameSite=Strict';
                      break;
                    default:
                      throw new TypeError('option sameSite is invalid');
                  }
                }

                return str;
              }

              /**
               * Try decoding a string using a decoding function.
               *
               * @param {string} str
               * @param {function} decode
               * @private
               */

              function tryDecode(str, decode) {
                try {
                  return decode(str);
                } catch (e) {
                  return str;
                }
              }

              /***/
            },
            /* 248 */
            /***/ function (module, exports, __webpack_require__) {
              'use strict';

              Object.defineProperty(exports, '__esModule', {
                value: true
              });

              var _createClass = (function () {
                function defineProperties(target, props) {
                  for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ('value' in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                  }
                }
                return function (Constructor, protoProps, staticProps) {
                  if (protoProps) defineProperties(Constructor.prototype, protoProps);
                  if (staticProps) defineProperties(Constructor, staticProps);
                  return Constructor;
                };
              })();

              function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                  throw new TypeError('Cannot call a class as a function');
                }
              }

              var MemoryStorage = (function () {
                function MemoryStorage() {
                  _classCallCheck(this, MemoryStorage);

                  this._data = {};
                }

                _createClass(MemoryStorage, [
                  {
                    key: 'getItem',
                    value: function getItem(key) {
                      return this._data.hasOwnProperty(key) ? this._data[key] : undefined;
                    }
                  },
                  {
                    key: 'setItem',
                    value: function setItem(key, value) {
                      return (this._data[key] = String(value));
                    }
                  },
                  {
                    key: 'removeItem',
                    value: function removeItem(key) {
                      return delete this._data[key];
                    }
                  },
                  {
                    key: 'clear',
                    value: function clear() {
                      return (this._data = {});
                    }
                  }
                ]);

                return MemoryStorage;
              })();

              exports.default = MemoryStorage;

              /***/
            },
            /* 249 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ =
                __webpack_require__(19);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ =
                __webpack_require__(20);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ =
                __webpack_require__(14);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ =
                __webpack_require__(1);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ =
                __webpack_require__(15);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ =
                __webpack_require__(16);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_evee__ = __webpack_require__(35);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_evee___default = __webpack_require__.n(
                __WEBPACK_IMPORTED_MODULE_7_evee__
              );
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__API__ = __webpack_require__(250);

              /**
               * @typedef {Object} GSGeoResponse
               * @property {GSContinent} continent
               * @property {GSCountry} country
               * @property {GSLocation} location
               * @property {GSCountry} registered_country
               * @property {String} currency
               */
              /**
               * @typedef {Object} GSTranslatedString
               * @property {String} de
               * @property {String} en
               * @property {String} es
               * @property {String} fr
               * @property {String} ja
               * @property {String} pt-BR
               * @property {String} ru
               * @property {String} zh-CN
               */
              /**
               * @typedef {Object} GSContinent
               * @property {String} code
               * @property {Number} geoname_id
               * @property {GSTranslatedString} names
               */
              /**
               * @typedef {Object} GSCountry
               * @property {Number} geoname_id
               * @property {String} iso_code
               * @property {GSTranslatedString} names
               */
              /**
               * @typedef {Object} GSLocation
               * @property {Number} accuracy_radius
               * @property {Number} latitude
               * @property {Number} longitude
               */

              /**
               * @typedef {Object} GSCurrencyResponse
               * @property {String} base
               * @property {String} date - Update date in Y-M-D format
               * @property {GSCurrencyRates} rates
               */
              /**
               * @typedef {Object} GSCurrencyRates
               * @property {Number} AUD
               * @property {Number} BGN
               * @property {Number} BRL
               * @property {Number} CAD
               * @property {Number} CHF
               * @property {Number} CNY
               * @property {Number} CZK
               * @property {Number} DKK
               * @property {Number} GBP
               * @property {Number} HKD
               * @property {Number} HUF
               * @property {Number} IDR
               * @property {Number} ILD
               * @property {Number} INR
               * @property {Number} JPY
               * @property {Number} KRW
               * @property {Number} MXN
               * @property {Number} MYR
               * @property {Number} NOK
               * @property {Number} NZD
               * @property {Number} PHP
               * @property {Number} PLN
               * @property {Number} RON
               * @property {Number} RUB
               * @property {Number} SEK
               * @property {Number} SGD
               * @property {Number} THB
               * @property {Number} TRY
               * @property {Number} ZAR
               * @property {Number} EUR
               */

              /**
               * Provides access to the ESC Geoservice.
               */

              var GeoService = (function (_Evee) {
                __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(GeoService, _Evee);

                /**
                 * Create a new instance of GeoService.
                 */
                function GeoService() {
                  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, GeoService);

                  /** @type {src/plugins/geoservice/API.js~API} */
                  var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(
                    this,
                    (
                      GeoService.__proto__ ||
                      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(GeoService)
                    ).call(this)
                  );

                  _this.api = new __WEBPACK_IMPORTED_MODULE_8__API__['a' /* default */]();
                  /** @type {Boolean} */
                  _this.cacheLookups = true;
                  /** @type {Object<String, Object>} */
                  _this._cachedLookups = {};
                  return _this;
                }

                /**
                 * Retrieves geolocation information.
                 * @param {String}	[ip] - IP address to get information on. If not supplied, uses local IP.
                 * @return {Promise<GSGeoResponse|Error>}
                 */

                __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(GeoService, [
                  {
                    key: 'lookupGeo',
                    value: (function () {
                      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(
                        /*#__PURE__*/ __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(
                          function _callee(ip) {
                            var result;
                            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(
                              function _callee$(_context) {
                                while (1) {
                                  switch ((_context.prev = _context.next)) {
                                    case 0:
                                      if (!ip) {
                                        ip = '';
                                      }

                                      if (!(this.cacheLookups && this._cachedLookups[ip])) {
                                        _context.next = 3;
                                        break;
                                      }

                                      return _context.abrupt('return', this._cachedLookups[ip]);

                                    case 3:
                                      _context.next = 5;
                                      return this.api.geoip(ip);

                                    case 5:
                                      result = _context.sent;

                                      if (this.cacheLookups) {
                                        this._cachedLookups[ip] = result;
                                      }
                                      return _context.abrupt('return', result);

                                    case 8:
                                    case 'end':
                                      return _context.stop();
                                  }
                                }
                              },
                              _callee,
                              this
                            );
                          }
                        )
                      );

                      function lookupGeo(_x) {
                        return _ref.apply(this, arguments);
                      }

                      return lookupGeo;
                    })()

                    /**
                     * Retrieves currency info.
                     * @return {Promise<GSCurrencyResponse, Error>}
                     */
                  },
                  {
                    key: 'getCurrencyInfo',
                    value: (function () {
                      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(
                        /*#__PURE__*/ __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(
                          function _callee2() {
                            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(
                              function _callee2$(_context2) {
                                while (1) {
                                  switch ((_context2.prev = _context2.next)) {
                                    case 0:
                                      _context2.next = 2;
                                      return this.api.currency();

                                    case 2:
                                      return _context2.abrupt('return', _context2.sent);

                                    case 3:
                                    case 'end':
                                      return _context2.stop();
                                  }
                                }
                              },
                              _callee2,
                              this
                            );
                          }
                        )
                      );

                      function getCurrencyInfo() {
                        return _ref2.apply(this, arguments);
                      }

                      return getCurrencyInfo;
                    })()
                  }
                ]);

                return GeoService;
              })(__WEBPACK_IMPORTED_MODULE_7_evee___default.a);

              /* harmony default export */ __webpack_exports__['a'] = GeoService;

              /***/
            },
            /* 250 */
            /***/ function (module, __webpack_exports__, __webpack_require__) {
              'use strict';
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ =
                __webpack_require__(19);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ =
                __webpack_require__(20);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ =
                __webpack_require__(0);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ =
                __webpack_require__(1);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default =
                __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(90);
              /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(
                __WEBPACK_IMPORTED_MODULE_4_axios__
              );

              /** API root URL */
              var ROOT_URL = 'https://geo.eastsideapps.io/api/v1';
              /** Path for geolcation */
              var PATH_GEOIP = '/info?ip={ip}';
              /** Path for currency info */
              var PATH_CURRENCY = '/currency';

              /**
               * Handles requests to the ESC Geoservice.
               */

              var API = (function () {
                /**
                 * Create a new instance of the API.
                 */
                function API() {
                  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, API);

                  /** @type {String} */
                  this.rootUrl = ROOT_URL;
                }

                /**
                 * Lookup GeoIP info for a given IP address. Uses local IP if not provided.
                 * @param {String|null} ip
                 * @returns {Promise<Object, Error>} GeoIP info. Throws if request fails.
                 */

                __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(API, [
                  {
                    key: 'geoip',
                    value: (function () {
                      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(
                        /*#__PURE__*/ __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(
                          function _callee(ip) {
                            var url, res;
                            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(
                              function _callee$(_context) {
                                while (1) {
                                  switch ((_context.prev = _context.next)) {
                                    case 0:
                                      if (!ip) {
                                        ip = '';
                                      }
                                      url = this.rootUrl + PATH_GEOIP.replace('{ip}', ip);
                                      _context.next = 4;
                                      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url);

                                    case 4:
                                      res = _context.sent;

                                      if (res.data.success) {
                                        _context.next = 7;
                                        break;
                                      }

                                      throw new Error('Request failed.');

                                    case 7:
                                      return _context.abrupt('return', res.data.result);

                                    case 8:
                                    case 'end':
                                      return _context.stop();
                                  }
                                }
                              },
                              _callee,
                              this
                            );
                          }
                        )
                      );

                      function geoip(_x) {
                        return _ref.apply(this, arguments);
                      }

                      return geoip;
                    })()

                    /**
                     * Lookup currency information.
                     * @return {Promise<Object, Error>}
                     */
                  },
                  {
                    key: 'currency',
                    value: (function () {
                      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(
                        /*#__PURE__*/ __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(
                          function _callee2() {
                            var url, res;
                            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(
                              function _callee2$(_context2) {
                                while (1) {
                                  switch ((_context2.prev = _context2.next)) {
                                    case 0:
                                      url = this.rootUrl + PATH_CURRENCY;
                                      _context2.next = 3;
                                      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url);

                                    case 3:
                                      res = _context2.sent;

                                      if (res.data.success) {
                                        _context2.next = 6;
                                        break;
                                      }

                                      throw new Error('Request failed.');

                                    case 6:
                                      return _context2.abrupt('return', res.data.rates);

                                    case 7:
                                    case 'end':
                                      return _context2.stop();
                                  }
                                }
                              },
                              _callee2,
                              this
                            );
                          }
                        )
                      );

                      function currency() {
                        return _ref2.apply(this, arguments);
                      }

                      return currency;
                    })()
                  }
                ]);

                return API;
              })();

              /* harmony default export */ __webpack_exports__['a'] = API;

              /***/
            }
            /******/
          ]
        )['default'];
      });
      //# sourceMappingURL=escshopify.web.js.map

      /***/
    },
    /* 358 */
    /***/ function (module, exports, __webpack_require__) {
      module.exports = { default: __webpack_require__(359), __esModule: true };

      /***/
    },
    /* 359 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(360);
      var $Object = __webpack_require__(21).Object;
      module.exports = function defineProperty(it, key, desc) {
        return $Object.defineProperty(it, key, desc);
      };

      /***/
    },
    /* 360 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(34);
      // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
      $export($export.S + $export.F * !__webpack_require__(57), 'Object', {
        defineProperty: __webpack_require__(56).f
      });

      /***/
    },
    /* 361 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var strictUriEncode = __webpack_require__(362);
      var objectAssign = __webpack_require__(363);
      var decodeComponent = __webpack_require__(364);

      function encoderForArrayFormat(opts) {
        switch (opts.arrayFormat) {
          case 'index':
            return function (key, value, index) {
              return value === null
                ? [encode(key, opts), '[', index, ']'].join('')
                : [encode(key, opts), '[', encode(index, opts), ']=', encode(value, opts)].join('');
            };

          case 'bracket':
            return function (key, value) {
              return value === null ? encode(key, opts) : [encode(key, opts), '[]=', encode(value, opts)].join('');
            };

          default:
            return function (key, value) {
              return value === null ? encode(key, opts) : [encode(key, opts), '=', encode(value, opts)].join('');
            };
        }
      }

      function parserForArrayFormat(opts) {
        var result;

        switch (opts.arrayFormat) {
          case 'index':
            return function (key, value, accumulator) {
              result = /\[(\d*)\]$/.exec(key);

              key = key.replace(/\[\d*\]$/, '');

              if (!result) {
                accumulator[key] = value;
                return;
              }

              if (accumulator[key] === undefined) {
                accumulator[key] = {};
              }

              accumulator[key][result[1]] = value;
            };

          case 'bracket':
            return function (key, value, accumulator) {
              result = /(\[\])$/.exec(key);
              key = key.replace(/\[\]$/, '');

              if (!result) {
                accumulator[key] = value;
                return;
              } else if (accumulator[key] === undefined) {
                accumulator[key] = [value];
                return;
              }

              accumulator[key] = [].concat(accumulator[key], value);
            };

          default:
            return function (key, value, accumulator) {
              if (accumulator[key] === undefined) {
                accumulator[key] = value;
                return;
              }

              accumulator[key] = [].concat(accumulator[key], value);
            };
        }
      }

      function encode(value, opts) {
        if (opts.encode) {
          return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
        }

        return value;
      }

      function keysSorter(input) {
        if (Array.isArray(input)) {
          return input.sort();
        } else if (typeof input === 'object') {
          return keysSorter(Object.keys(input))
            .sort(function (a, b) {
              return Number(a) - Number(b);
            })
            .map(function (key) {
              return input[key];
            });
        }

        return input;
      }

      exports.extract = function (str) {
        var queryStart = str.indexOf('?');
        if (queryStart === -1) {
          return '';
        }
        return str.slice(queryStart + 1);
      };

      exports.parse = function (str, opts) {
        opts = objectAssign({ arrayFormat: 'none' }, opts);

        var formatter = parserForArrayFormat(opts);

        // Create an object with no prototype
        // https://github.com/sindresorhus/query-string/issues/47
        var ret = Object.create(null);

        if (typeof str !== 'string') {
          return ret;
        }

        str = str.trim().replace(/^[?#&]/, '');

        if (!str) {
          return ret;
        }

        str.split('&').forEach(function (param) {
          var parts = param.replace(/\+/g, ' ').split('=');
          // Firefox (pre 40) decodes `%3D` to `=`
          // https://github.com/sindresorhus/query-string/pull/37
          var key = parts.shift();
          var val = parts.length > 0 ? parts.join('=') : undefined;

          // missing `=` should be `null`:
          // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
          val = val === undefined ? null : decodeComponent(val);

          formatter(decodeComponent(key), val, ret);
        });

        return Object.keys(ret)
          .sort()
          .reduce(function (result, key) {
            var val = ret[key];
            if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
              // Sort object keys, not values
              result[key] = keysSorter(val);
            } else {
              result[key] = val;
            }

            return result;
          }, Object.create(null));
      };

      exports.stringify = function (obj, opts) {
        var defaults = {
          encode: true,
          strict: true,
          arrayFormat: 'none'
        };

        opts = objectAssign(defaults, opts);

        var formatter = encoderForArrayFormat(opts);

        return obj
          ? Object.keys(obj)
              .sort()
              .map(function (key) {
                var val = obj[key];

                if (val === undefined) {
                  return '';
                }

                if (val === null) {
                  return encode(key, opts);
                }

                if (Array.isArray(val)) {
                  var result = [];

                  val.slice().forEach(function (val2) {
                    if (val2 === undefined) {
                      return;
                    }

                    result.push(formatter(key, val2, result.length));
                  });

                  return result.join('&');
                }

                return encode(key, opts) + '=' + encode(val, opts);
              })
              .filter(function (x) {
                return x.length > 0;
              })
              .join('&')
          : '';
      };

      /***/
    },
    /* 362 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      module.exports = function (str) {
        return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
          return '%' + c.charCodeAt(0).toString(16).toUpperCase();
        });
      };

      /***/
    },
    /* 363 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';
      /*
object-assign
(c) Sindre Sorhus
@license MIT
*/

      /* eslint-disable no-unused-vars */
      var getOwnPropertySymbols = Object.getOwnPropertySymbols;
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var propIsEnumerable = Object.prototype.propertyIsEnumerable;

      function toObject(val) {
        if (val === null || val === undefined) {
          throw new TypeError('Object.assign cannot be called with null or undefined');
        }

        return Object(val);
      }

      function shouldUseNative() {
        try {
          if (!Object.assign) {
            return false;
          }

          // Detect buggy property enumeration order in older V8 versions.

          // https://bugs.chromium.org/p/v8/issues/detail?id=4118
          var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
          test1[5] = 'de';
          if (Object.getOwnPropertyNames(test1)[0] === '5') {
            return false;
          }

          // https://bugs.chromium.org/p/v8/issues/detail?id=3056
          var test2 = {};
          for (var i = 0; i < 10; i++) {
            test2['_' + String.fromCharCode(i)] = i;
          }
          var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
            return test2[n];
          });
          if (order2.join('') !== '0123456789') {
            return false;
          }

          // https://bugs.chromium.org/p/v8/issues/detail?id=3056
          var test3 = {};
          'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
            test3[letter] = letter;
          });
          if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
            return false;
          }

          return true;
        } catch (err) {
          // We don't expect any of the above to throw, but better to be safe.
          return false;
        }
      }

      module.exports = shouldUseNative()
        ? Object.assign
        : function (target, source) {
            var from;
            var to = toObject(target);
            var symbols;

            for (var s = 1; s < arguments.length; s++) {
              from = Object(arguments[s]);

              for (var key in from) {
                if (hasOwnProperty.call(from, key)) {
                  to[key] = from[key];
                }
              }

              if (getOwnPropertySymbols) {
                symbols = getOwnPropertySymbols(from);
                for (var i = 0; i < symbols.length; i++) {
                  if (propIsEnumerable.call(from, symbols[i])) {
                    to[symbols[i]] = from[symbols[i]];
                  }
                }
              }
            }

            return to;
          };

      /***/
    },
    /* 364 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var token = '%[a-f0-9]{2}';
      var singleMatcher = new RegExp(token, 'gi');
      var multiMatcher = new RegExp('(' + token + ')+', 'gi');

      function decodeComponents(components, split) {
        try {
          // Try to decode the entire string first
          return decodeURIComponent(components.join(''));
        } catch (err) {
          // Do nothing
        }

        if (components.length === 1) {
          return components;
        }

        split = split || 1;

        // Split the array in 2 parts
        var left = components.slice(0, split);
        var right = components.slice(split);

        return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
      }

      function decode(input) {
        try {
          return decodeURIComponent(input);
        } catch (err) {
          var tokens = input.match(singleMatcher);

          for (var i = 1; i < tokens.length; i++) {
            input = decodeComponents(tokens, i).join('');

            tokens = input.match(singleMatcher);
          }

          return input;
        }
      }

      function customDecodeURIComponent(input) {
        // Keep track of all the replacements and prefill the map with the `BOM`
        var replaceMap = {
          '%FE%FF': '\uFFFD\uFFFD',
          '%FF%FE': '\uFFFD\uFFFD'
        };

        var match = multiMatcher.exec(input);
        while (match) {
          try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
          } catch (err) {
            var result = decode(match[0]);

            if (result !== match[0]) {
              replaceMap[match[0]] = result;
            }
          }

          match = multiMatcher.exec(input);
        }

        // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
        replaceMap['%C2'] = '\uFFFD';

        var entries = Object.keys(replaceMap);

        for (var i = 0; i < entries.length; i++) {
          // Replace all decoded components
          var key = entries[i];
          input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
        }

        return input;
      }

      module.exports = function (encodedURI) {
        if (typeof encodedURI !== 'string') {
          throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
        }

        try {
          encodedURI = encodedURI.replace(/\+/g, ' ');

          // Try the built in decoder first
          return decodeURIComponent(encodedURI);
        } catch (err) {
          // Fallback to a more advanced decoder
          return customDecodeURIComponent(encodedURI);
        }
      };

      /***/
    },
    /* 365 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true
      });

      var _getIterator2 = __webpack_require__(366);

      var _getIterator3 = _interopRequireDefault(_getIterator2);

      var _classCallCheck2 = __webpack_require__(10);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(11);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _Accordion = __webpack_require__(381);

      var _Accordion2 = _interopRequireDefault(_Accordion);

      var _ChangeClass = __webpack_require__(385);

      var _ChangeClass2 = _interopRequireDefault(_ChangeClass);

      var _ChangeMasterSelect = __webpack_require__(392);

      var _ChangeMasterSelect2 = _interopRequireDefault(_ChangeMasterSelect);

      var _CustomVideoContainer = __webpack_require__(393);

      var _CustomVideoContainer2 = _interopRequireDefault(_CustomVideoContainer);

      var _FadeInImages = __webpack_require__(394);

      var _FadeInImages2 = _interopRequireDefault(_FadeInImages);

      var _FlickitySlider = __webpack_require__(395);

      var _FlickitySlider2 = _interopRequireDefault(_FlickitySlider);

      var _ResponsiveTooltip = __webpack_require__(408);

      var _ResponsiveTooltip2 = _interopRequireDefault(_ResponsiveTooltip);

      var _ShowMoreOptions = __webpack_require__(409);

      var _ShowMoreOptions2 = _interopRequireDefault(_ShowMoreOptions);

      var _Slick = __webpack_require__(411);

      var _Slick2 = _interopRequireDefault(_Slick);

      var _UpdateCart = __webpack_require__(413);

      var _UpdateCart2 = _interopRequireDefault(_UpdateCart);

      var _LoadMore = __webpack_require__(414);

      var _LoadMore2 = _interopRequireDefault(_LoadMore);

      var _context = __webpack_require__(150);

      var _context2 = _interopRequireDefault(_context);

      var _ProductInfoAccordion = __webpack_require__(449);

      var _ProductInfoAccordion2 = _interopRequireDefault(_ProductInfoAccordion);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var components = {
        accordion: _Accordion2.default,
        'change-class': _ChangeClass2.default,
        'change-master-select': _ChangeMasterSelect2.default,
        'custom-video-container': _CustomVideoContainer2.default,
        'fade-in-images': _FadeInImages2.default,
        'flickity-slider': _FlickitySlider2.default,
        'responsive-tooltip': _ResponsiveTooltip2.default,
        'show-more-options': _ShowMoreOptions2.default,
        slick: _Slick2.default,
        'update-cart': _UpdateCart2.default,
        'load-more': _LoadMore2.default,
        'product-info-accordion': _ProductInfoAccordion2.default
      };

      var pages = {
        // 'customers/addresses': Addresses,
        // 'customers/login': Login
      };

      if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
      }

      var Theme = (function () {
        function Theme() {
          (0, _classCallCheck3.default)(this, Theme);

          this._components = [];
          this._componentsById = {};
        }

        (0, _createClass3.default)(Theme, [
          {
            key: 'registerComponents',
            value: function registerComponents() {
              var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

              for (var key in components) {
                var ComponentConstructor = components[key];
                var elements = container.querySelectorAll('.js-component__' + key + ', [data-' + key + ']');
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (
                    var _iterator = (0, _getIterator3.default)(elements), _step;
                    !(_iteratorNormalCompletion = (_step = _iterator.next()).done);
                    _iteratorNormalCompletion = true
                  ) {
                    var elem = _step.value;

                    var instance = new ComponentConstructor(this, elem);
                    this._components.push(instance);
                    var id = elem.dataset.componentId;
                    if (id) {
                      this._componentsById[id] = instance;
                    }
                    instance.onInit();
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              }
              window.ThemeComponents = this._components;
              window.ThemeComponentsId = this._componentsById;
              window.__Theme = this;
            }
          },
          {
            key: 'registerPages',
            value: function registerPages() {
              var context = _context2.default.getTemplate();
              for (var page in pages) {
                if (page === context) {
                  var instance = new pages[page](this);
                  instance.onInit();
                }
              }
            }
          },
          {
            key: 'getComponents',
            value: function getComponents() {
              return this._components;
            }
          },
          {
            key: 'getComponentsById',
            value: function getComponentsById(id) {
              return this._componentsById[id];
            }
          },
          {
            key: 'getComponentsByType',
            value: function getComponentsByType(componentConst) {
              var includeSubclasses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

              var r = [];
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (
                  var _iterator2 = (0, _getIterator3.default)(this._components), _step2;
                  !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done);
                  _iteratorNormalCompletion2 = true
                ) {
                  var c = _step2.value;

                  if (includeSubclasses && c instanceof componentConst) {
                    r.push(c);
                  } else if (c.constructor === componentConst) {
                    r.push(c);
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }

              return r;
            }
          }
        ]);
        return Theme;
      })();

      exports.default = Theme;

      /***/
    },
    /* 366 */
    /***/ function (module, exports, __webpack_require__) {
      module.exports = { default: __webpack_require__(367), __esModule: true };

      /***/
    },
    /* 367 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(151);
      __webpack_require__(112);
      module.exports = __webpack_require__(380);

      /***/
    },
    /* 368 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var addToUnscopables = __webpack_require__(369);
      var step = __webpack_require__(370);
      var Iterators = __webpack_require__(63);
      var toIObject = __webpack_require__(105);

      // 22.1.3.4 Array.prototype.entries()
      // 22.1.3.13 Array.prototype.keys()
      // 22.1.3.29 Array.prototype.values()
      // 22.1.3.30 Array.prototype[@@iterator]()
      module.exports = __webpack_require__(153)(
        Array,
        'Array',
        function (iterated, kind) {
          this._t = toIObject(iterated); // target
          this._i = 0; // next index
          this._k = kind; // kind
          // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
        },
        function () {
          var O = this._t;
          var kind = this._k;
          var index = this._i++;
          if (!O || index >= O.length) {
            this._t = undefined;
            return step(1);
          }
          if (kind == 'keys') return step(0, index);
          if (kind == 'values') return step(0, O[index]);
          return step(0, [index, O[index]]);
        },
        'values'
      );

      // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
      Iterators.Arguments = Iterators.Array;

      addToUnscopables('keys');
      addToUnscopables('values');
      addToUnscopables('entries');

      /***/
    },
    /* 369 */
    /***/ function (module, exports) {
      module.exports = function () {
        /* empty */
      };

      /***/
    },
    /* 370 */
    /***/ function (module, exports) {
      module.exports = function (done, value) {
        return { value: value, done: !!done };
      };

      /***/
    },
    /* 371 */
    /***/ function (module, exports, __webpack_require__) {
      module.exports = __webpack_require__(55);

      /***/
    },
    /* 372 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var create = __webpack_require__(373);
      var descriptor = __webpack_require__(104);
      var setToStringTag = __webpack_require__(110);
      var IteratorPrototype = {};

      // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
      __webpack_require__(55)(IteratorPrototype, __webpack_require__(22)('iterator'), function () {
        return this;
      });

      module.exports = function (Constructor, NAME, next) {
        Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
        setToStringTag(Constructor, NAME + ' Iterator');
      };

      /***/
    },
    /* 373 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
      var anObject = __webpack_require__(35);
      var dPs = __webpack_require__(374);
      var enumBugKeys = __webpack_require__(158);
      var IE_PROTO = __webpack_require__(109)('IE_PROTO');
      var Empty = function () {
        /* empty */
      };
      var PROTOTYPE = 'prototype';

      // Create object with fake `null` prototype: use iframe Object with cleared prototype
      var createDict = function () {
        // Thrash, waste and sodomy: IE GC bug
        var iframe = __webpack_require__(103)('iframe');
        var i = enumBugKeys.length;
        var lt = '<';
        var gt = '>';
        var iframeDocument;
        iframe.style.display = 'none';
        __webpack_require__(159).appendChild(iframe);
        iframe.src = 'javascript:'; // eslint-disable-line no-script-url
        // createDict = iframe.contentWindow.Object;
        // html.removeChild(iframe);
        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
        iframeDocument.close();
        createDict = iframeDocument.F;
        while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
        return createDict();
      };

      module.exports =
        Object.create ||
        function create(O, Properties) {
          var result;
          if (O !== null) {
            Empty[PROTOTYPE] = anObject(O);
            result = new Empty();
            Empty[PROTOTYPE] = null;
            // add "__proto__" for Object.getPrototypeOf polyfill
            result[IE_PROTO] = O;
          } else result = createDict();
          return Properties === undefined ? result : dPs(result, Properties);
        };

      /***/
    },
    /* 374 */
    /***/ function (module, exports, __webpack_require__) {
      var dP = __webpack_require__(56);
      var anObject = __webpack_require__(35);
      var getKeys = __webpack_require__(155);

      module.exports = __webpack_require__(57)
        ? Object.defineProperties
        : function defineProperties(O, Properties) {
            anObject(O);
            var keys = getKeys(Properties);
            var length = keys.length;
            var i = 0;
            var P;
            while (length > i) dP.f(O, (P = keys[i++]), Properties[P]);
            return O;
          };

      /***/
    },
    /* 375 */
    /***/ function (module, exports, __webpack_require__) {
      var has = __webpack_require__(76);
      var toIObject = __webpack_require__(105);
      var arrayIndexOf = __webpack_require__(376)(false);
      var IE_PROTO = __webpack_require__(109)('IE_PROTO');

      module.exports = function (object, names) {
        var O = toIObject(object);
        var i = 0;
        var result = [];
        var key;
        for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
        // Don't enum bug & hidden keys
        while (names.length > i)
          if (has(O, (key = names[i++]))) {
            ~arrayIndexOf(result, key) || result.push(key);
          }
        return result;
      };

      /***/
    },
    /* 376 */
    /***/ function (module, exports, __webpack_require__) {
      // false -> Array#indexOf
      // true  -> Array#includes
      var toIObject = __webpack_require__(105);
      var toLength = __webpack_require__(107);
      var toAbsoluteIndex = __webpack_require__(377);
      module.exports = function (IS_INCLUDES) {
        return function ($this, el, fromIndex) {
          var O = toIObject($this);
          var length = toLength(O.length);
          var index = toAbsoluteIndex(fromIndex, length);
          var value;
          // Array#includes uses SameValueZero equality algorithm
          // eslint-disable-next-line no-self-compare
          if (IS_INCLUDES && el != el)
            while (length > index) {
              value = O[index++];
              // eslint-disable-next-line no-self-compare
              if (value != value) return true;
              // Array#indexOf ignores holes, Array#includes - not
            }
          else
            for (; length > index; index++)
              if (IS_INCLUDES || index in O) {
                if (O[index] === el) return IS_INCLUDES || index || 0;
              }
          return !IS_INCLUDES && -1;
        };
      };

      /***/
    },
    /* 377 */
    /***/ function (module, exports, __webpack_require__) {
      var toInteger = __webpack_require__(108);
      var max = Math.max;
      var min = Math.min;
      module.exports = function (index, length) {
        index = toInteger(index);
        return index < 0 ? max(index + length, 0) : min(index, length);
      };

      /***/
    },
    /* 378 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
      var has = __webpack_require__(76);
      var toObject = __webpack_require__(111);
      var IE_PROTO = __webpack_require__(109)('IE_PROTO');
      var ObjectProto = Object.prototype;

      module.exports =
        Object.getPrototypeOf ||
        function (O) {
          O = toObject(O);
          if (has(O, IE_PROTO)) return O[IE_PROTO];
          if (typeof O.constructor == 'function' && O instanceof O.constructor) {
            return O.constructor.prototype;
          }
          return O instanceof Object ? ObjectProto : null;
        };

      /***/
    },
    /* 379 */
    /***/ function (module, exports, __webpack_require__) {
      var toInteger = __webpack_require__(108);
      var defined = __webpack_require__(106);
      // true  -> String#at
      // false -> String#codePointAt
      module.exports = function (TO_STRING) {
        return function (that, pos) {
          var s = String(defined(that));
          var i = toInteger(pos);
          var l = s.length;
          var a, b;
          if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
          a = s.charCodeAt(i);
          return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
            ? TO_STRING
              ? s.charAt(i)
              : a
            : TO_STRING
              ? s.slice(i, i + 2)
              : ((a - 0xd800) << 10) + (b - 0xdc00) + 0x10000;
        };
      };

      /***/
    },
    /* 380 */
    /***/ function (module, exports, __webpack_require__) {
      var anObject = __webpack_require__(35);
      var get = __webpack_require__(113);
      module.exports = __webpack_require__(21).getIterator = function (it) {
        var iterFn = get(it);
        if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
        return anObject(iterFn.call(it));
      };

      /***/
    },
    /* 381 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true
      });

      var _toConsumableArray2 = __webpack_require__(77);

      var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

      var _classCallCheck2 = __webpack_require__(10);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(11);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _log = __webpack_require__(36);

      var _log2 = _interopRequireDefault(_log);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var Accordion = (function () {
        function Accordion(theme, elem) {
          (0, _classCallCheck3.default)(this, Accordion);

          this._name = this.constructor.name;
          this._theme = theme;
          this._accordionBtn = elem;
          this._accordionContent = this._accordionBtn.nextElementSibling;
          this._accordion = this._accordionBtn.parentElement;

          // _log2.default.debug(this.constructor.name, 'Constructed', this);
        }

        (0, _createClass3.default)(Accordion, [
          {
            key: 'onInit',
            value: function onInit() {
              var _this = this;

              if (!this._accordionContent) return;

              this._accordionBtn.addEventListener('click', function () {
                if (_this._accordion.classList.contains('size-guide__single-accordion-container--active')) {
                  _this._accordion.classList.remove('size-guide__single-accordion-container--active');
                  _this._accordionContent.style.height = 0;
                } else {
                  _this._addHorizontalOverflowStyle();

                  _this._accordion.classList.add('size-guide__single-accordion-container--active');
                  _this._accordionContent.style.height = _this._accordionContent.scrollHeight + 'px';
                }
              });

              window.addEventListener('resize', function () {
                if (_this._accordion.classList.contains('size-guide__single-accordion-container--active')) {
                  _this._addHorizontalOverflowStyle();
                }

                _this._accordion.classList.remove('size-guide__single-accordion-container--active');
                _this._accordionContent.style.height = 0;
              });
            }
          },
          {
            key: '_addHorizontalOverflowStyle',
            value: function _addHorizontalOverflowStyle() {
              var _this2 = this;

              if (!_this2._accordionContent) return;

              var addHorizontalOverflowStyle = []
                .concat(
                  (0, _toConsumableArray3.default)(_this2._accordionContent.querySelectorAll('.size-guide__table'))
                )
                .some(function (table) {
                  return table.offsetWidth > _this2._accordion.offsetWidth;
                });

              if (addHorizontalOverflowStyle) {
                _this2._accordionContent.classList.add('size-guide__accordion-content--table-larger-than-container');
              }
            }
          }
        ]);
        return Accordion;
      })();

      exports.default = Accordion;

      /***/
    },
    /* 382 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(112);
      __webpack_require__(383);
      module.exports = __webpack_require__(21).Array.from;

      /***/
    },
    /* 383 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var ctx = __webpack_require__(61);
      var $export = __webpack_require__(34);
      var toObject = __webpack_require__(111);
      var call = __webpack_require__(162);
      var isArrayIter = __webpack_require__(163);
      var toLength = __webpack_require__(107);
      var createProperty = __webpack_require__(384);
      var getIterFn = __webpack_require__(113);

      $export(
        $export.S +
          $export.F *
            !__webpack_require__(164)(function (iter) {
              Array.from(iter);
            }),
        'Array',
        {
          // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
          from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
            var O = toObject(arrayLike);
            var C = typeof this == 'function' ? this : Array;
            var aLen = arguments.length;
            var mapfn = aLen > 1 ? arguments[1] : undefined;
            var mapping = mapfn !== undefined;
            var index = 0;
            var iterFn = getIterFn(O);
            var length, result, step, iterator;
            if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
            // if object isn't iterable or it's array with default iterator - use simple case
            if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
              for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
                createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
              }
            } else {
              length = toLength(O.length);
              for (result = new C(length); length > index; index++) {
                createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
              }
            }
            result.length = index;
            return result;
          }
        }
      );

      /***/
    },
    /* 384 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var $defineProperty = __webpack_require__(56);
      var createDesc = __webpack_require__(104);

      module.exports = function (object, index, value) {
        if (index in object) $defineProperty.f(object, index, createDesc(0, value));
        else object[index] = value;
      };

      /***/
    },
    /* 385 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true
      });

      var _toConsumableArray2 = __webpack_require__(77);

      var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

      var _extends2 = __webpack_require__(58);

      var _extends3 = _interopRequireDefault(_extends2);

      var _classCallCheck2 = __webpack_require__(10);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(11);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _log = __webpack_require__(36);

      var _log2 = _interopRequireDefault(_log);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var ChangeClass = (function () {
        function ChangeClass(theme, elem) {
          (0, _classCallCheck3.default)(this, ChangeClass);

          this._theme = theme;
          this._elem = elem;
          this._instances = JSON.parse(elem.getAttribute('data-change-class') || '{}');
          this._instanceDefaults = {
            action: 'toggle',
            class: 'active',
            delay: 0,
            elem: 'self',
            event: 'click',
            maxWidth: 9999999,
            minWidth: 0,
            preventDefault: false,
            targetOnly: false
          };

          // _log2.default.debug(this.constructor.name, 'Constructed', this);
        }

        (0, _createClass3.default)(ChangeClass, [
          {
            key: 'onInit',
            value: function onInit() {
              var _this = this;

              if (this._instances.length > 0) {
                this._instances.forEach(function (instance) {
                  instance = (0, _extends3.default)({}, _this._instanceDefaults, instance);

                  if (instance.action === 'addOnLoad') {
                    _this._setup(instance);
                  } else {
                    _this._elem.addEventListener(instance.event, function (event) {
                      _this._setup(instance, event);
                    });
                  }
                });
              }
            }
          },
          {
            key: '_setup',
            value: function _setup(instance, event) {
              var _this2 = this;

              // Check if the changing element involves grandchildren links
              if (this._elem.dataset.grandchildren) {
                this._setupGrandchildrenLinks(event);
              }

              var elemToChange = this._getElement(instance.elem);

              if (window.innerWidth > instance.maxWidth || window.innerWidth < instance.minWidth) return;

              if (event) {
                if (instance.targetOnly && event.target !== this._elem) return;

                if (instance.preventDefault) event.preventDefault();
              }

              if (elemToChange) {
                setTimeout(function () {
                  if (Array.isArray(instance.class)) {
                    instance.class.forEach(function (instanceClass) {
                      if (elemToChange.length) {
                        elemToChange.forEach(function (element) {
                          _this2._changeClass(element, instanceClass, instance.action);
                        });
                      } else {
                        _this2._changeClass(elemToChange, instanceClass, instance.action);
                      }
                    });
                  } else {
                    if (elemToChange.length) {
                      elemToChange.forEach(function (element) {
                        _this2._changeClass(element, instance.class, instance.action);
                      });
                    } else {
                      _this2._changeClass(elemToChange, instance.class, instance.action);
                    }
                  }

                  if (instance.removeFromSiblings) {
                    if (elemToChange.length) {
                      elemToChange.forEach(function (element) {
                        _this2._removeClassFromSiblings(elemToChange, instance.class, instance.removeFromSiblings);
                      });
                    } else {
                      _this2._removeClassFromSiblings(elemToChange, instance.class, instance.removeFromSiblings);
                    }
                  }
                }, instance.delay);
              }
            }
          },
          {
            key: '_getElement',
            value: function _getElement(elemToChange) {
              switch (elemToChange) {
                case 'self':
                  return this._elem;
                case 'parent':
                  return this._elem.parentNode;
                case 'child':
                  return this._elem.childElementSibling;
                case 'next':
                  return this._elem.nextElementSibling;
                case 'prev':
                  return this._elem.previousElementSibling;
                default:
                  return document.querySelectorAll(elemToChange);
              }
            }
          },
          {
            key: '_changeClass',
            value: function _changeClass(elemToChange, className, action) {
              if (elemToChange.classList.contains(className)) {
                if (action !== 'add') elemToChange.classList.remove(className);
              } else {
                if (action !== 'remove') elemToChange.classList.add(className);
              }
            }
          },
          {
            key: '_removeClassFromSiblings',
            value: function _removeClassFromSiblings(elemToChange, className, data) {
              var parent = data.parentSiblings ? elemToChange.parentNode.parentNode : elemToChange.parentNode;
              var siblings = data.selector
                ? parent.querySelectorAll(data.selector)
                : [].concat((0, _toConsumableArray3.default)(parent.children));

              siblings.forEach(function (sibling) {
                return sibling !== elemToChange && sibling.classList.remove(className);
              });
            }
            // This is a special case whereby in addition to changing the class
            // on the submenu section, we need to also populate it with the corresponding grandchildren links
          },
          {
            key: '_setupGrandchildrenLinks',
            value: function _setupGrandchildrenLinks(event) {
              // Get the title for the grandchild menu
              var grandchildrenTitle = event.target
                .closest('.site-header__side-nav-sub-link-wrapper')
                .querySelector('.site-header__side-nav-sub-link-item').innerText;
              // Get the grandchildren links from the button that was clicked
              var grandchildrenContent = event.target
                .closest('.site-header__side-nav-sub-link-wrapper')
                .querySelector('.site-header__side-nav-grandchild-links');
              // Clone the HTML element
              var cln = grandchildrenContent.cloneNode(true);
              // Remove visually hidden class
              cln.classList.remove('visually-hidden');
              // Get the grandchildren off canvas menu
              var elemToChange = document.querySelector('.site-header__side-nav-sub-link-container--grandchildren');
              // Get the title element
              var grandChildrenNavTitleElement = elemToChange.querySelector(
                '.site-header__side-nav-sub-links-parent-link'
              );
              // Set the title
              grandChildrenNavTitleElement.innerText = grandchildrenTitle;
              // Get the menu element to populate
              var grandChildrenNavWrapper = elemToChange.querySelector('.site-header__side-nav-sub-link-main');
              // Clear any existing content
              grandChildrenNavWrapper.innerHTML = '';
              // Append the menu items
              grandChildrenNavWrapper.appendChild(cln);
            }
          }
        ]);
        return ChangeClass;
      })();

      exports.default = ChangeClass;

      /***/
    },
    /* 386 */
    /***/ function (module, exports, __webpack_require__) {
      module.exports = { default: __webpack_require__(387), __esModule: true };

      /***/
    },
    /* 387 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(388);
      module.exports = __webpack_require__(21).Object.assign;

      /***/
    },
    /* 388 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.3.1 Object.assign(target, source)
      var $export = __webpack_require__(34);

      $export($export.S + $export.F, 'Object', { assign: __webpack_require__(389) });

      /***/
    },
    /* 389 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // 19.1.2.1 Object.assign(target, source, ...)
      var getKeys = __webpack_require__(155);
      var gOPS = __webpack_require__(390);
      var pIE = __webpack_require__(391);
      var toObject = __webpack_require__(111);
      var IObject = __webpack_require__(152);
      var $assign = Object.assign;

      // should work with symbols and should have deterministic property order (V8 bug)
      module.exports =
        !$assign ||
        __webpack_require__(102)(function () {
          var A = {};
          var B = {};
          // eslint-disable-next-line no-undef
          var S = Symbol();
          var K = 'abcdefghijklmnopqrst';
          A[S] = 7;
          K.split('').forEach(function (k) {
            B[k] = k;
          });
          return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
        })
          ? function assign(target, source) {
              // eslint-disable-line no-unused-vars
              var T = toObject(target);
              var aLen = arguments.length;
              var index = 1;
              var getSymbols = gOPS.f;
              var isEnum = pIE.f;
              while (aLen > index) {
                var S = IObject(arguments[index++]);
                var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
                var length = keys.length;
                var j = 0;
                var key;
                while (length > j) if (isEnum.call(S, (key = keys[j++]))) T[key] = S[key];
              }
              return T;
            }
          : $assign;

      /***/
    },
    /* 390 */
    /***/ function (module, exports) {
      exports.f = Object.getOwnPropertySymbols;

      /***/
    },
    /* 391 */
    /***/ function (module, exports) {
      exports.f = {}.propertyIsEnumerable;

      /***/
    },
    /* 392 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true
      });

      var _toConsumableArray2 = __webpack_require__(77);

      var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

      var _classCallCheck2 = __webpack_require__(10);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(11);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _log = __webpack_require__(36);

      var _log2 = _interopRequireDefault(_log);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var ChangeMasterSelect = (function () {
        function ChangeMasterSelect(theme, elem) {
          (0, _classCallCheck3.default)(this, ChangeMasterSelect);

          this._theme = theme;
          this._elem = elem;
          this._radioButtons = [].concat(
            (0, _toConsumableArray3.default)(this._elem.querySelectorAll('[data-option-radio-button]'))
          );
          this._masterSelect = this._elem.querySelector('[data-product-select]');

          // _log2.default.debug(this.constructor.name, 'Constructed', this);
        }

        (0, _createClass3.default)(ChangeMasterSelect, [
          {
            key: 'onInit',
            value: function onInit() {
              var _this = this;

              this._radioButtons.forEach(function (radioButton) {
                radioButton.addEventListener('change', function () {
                  _this._masterSelect.value = radioButton.getAttribute('data-variant-id');
                });
              });
            }
          }
        ]);
        return ChangeMasterSelect;
      })();

      exports.default = ChangeMasterSelect;

      /***/
    },
    /* 393 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true
      });

      var _classCallCheck2 = __webpack_require__(10);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(11);

      var _createClass3 = _interopRequireDefault(_createClass2);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var CustomVideoContainer = (function () {
        function CustomVideoContainer(theme, elem) {
          (0, _classCallCheck3.default)(this, CustomVideoContainer);

          this._theme = theme;
          this._videoContainer = elem;
          this._video = this._videoContainer.querySelector('[data-video]');
          this._playPauseButton = this._videoContainer.querySelector('[data-custom-button]');
        }

        (0, _createClass3.default)(CustomVideoContainer, [
          {
            key: 'onInit',
            value: function onInit() {
              var _this = this;
              if (!this._playPauseButton) {
                return;
              }
              this._playPauseButton.addEventListener('click', function () {
                if (_this._video.paused) {
                  _this._video.play();
                  _this._videoContainer.classList.remove('custom-landing__image-or-video-video-button--paused');
                  _this._videoContainer.classList.add('custom-landing__image-or-video-video-button--playing');
                } else {
                  _this._video.pause();
                  _this._videoContainer.classList.remove('custom-landing__image-or-video-video-button--playing');
                  _this._videoContainer.classList.add('custom-landing__image-or-video-video-button--paused');
                }
              });
            }
          }
        ]);
        return CustomVideoContainer;
      })();

      exports.default = CustomVideoContainer;

      /***/
    },
    /* 394 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true
      });

      var _toConsumableArray2 = __webpack_require__(77);

      var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

      var _classCallCheck2 = __webpack_require__(10);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(11);

      var _createClass3 = _interopRequireDefault(_createClass2);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var FadeInImages = (function () {
        function FadeInImages(theme, elem) {
          (0, _classCallCheck3.default)(this, FadeInImages);

          this._theme = theme;
          this._elem = elem;
          this._pageImages = [].concat((0, _toConsumableArray3.default)(this._elem.querySelectorAll('img')));
        }

        (0, _createClass3.default)(FadeInImages, [
          {
            key: 'onInit',
            value: function onInit() {
              var _this = this;

              this._pageImages.forEach(function (image) {
                image.classList.add('fade-in-images', 'fade-in-images--hidden');
              });

              this._showImages(this._pageImages);

              document.addEventListener('scroll', function () {
                _this._showImages(_this._pageImages);
              });
              document.addEventListener('resize', this._showImages(this._pageImages));
            }
          },
          {
            key: '_showImages',
            value: function _showImages(pageImages) {
              pageImages.forEach(function (image) {
                if (!image.classList.contains('fade-in-images--visible')) {
                  if (
                    image.getBoundingClientRect().top + 200 <=
                    (window.innerHeight || document.documentElement.clientHeight)
                  ) {
                    image.classList.remove('fade-in-images--hidden');
                  }
                }
              });
            }
          }
        ]);
        return FadeInImages;
      })();

      exports.default = FadeInImages;

      /***/
    },
    /* 395 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true
      });

      var _extends2 = __webpack_require__(58);

      var _extends3 = _interopRequireDefault(_extends2);

      var _classCallCheck2 = __webpack_require__(10);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(11);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _flickity = __webpack_require__(396);

      var _flickity2 = _interopRequireDefault(_flickity);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var FlickitySlider = (function () {
        function FlickitySlider(theme, elem) {
          (0, _classCallCheck3.default)(this, FlickitySlider);

          this._theme = theme;
          this._elem = elem;
          this._options = (0, _extends3.default)(
            {
              cellAlign: 'left',
              freeScroll: true,
              friction: 0.8,
              imagesLoaded: true,
              wrapAround: true,
              percentPosition: true,
              resize: true
            },
            JSON.parse(this._elem.getAttribute('data-flickity-slider') || '{}')
          );
          this._slider = null;
          this._requestID = '';
          this._playStatus = false;
        }

        (0, _createClass3.default)(FlickitySlider, [
          {
            key: 'onInit',
            value: function onInit() {
              var _this = this;

              setTimeout(function () {
                if (_this._options.desktopOnly && !_this._options.mobileOnly) {
                  if (window.innerWidth > 768) {
                    _this._setSlider();
                  }
                } else if (!_this._options.desktopOnly && _this._options.mobileOnly) {
                  if (window.innerWidth < 769) {
                    _this._setSlider();
                  }
                } else {
                  _this._setSlider();
                }
              });
            }
          },
          {
            key: '_setSlider',
            value: function _setSlider() {
              var _this2 = this;

              this._slider = new _flickity2.default(this._elem, this._options);

              this._slider.element.addEventListener('mouseover', function (e) {
                _this2._playStatus = false;

                _this2._pause();
              });

              this._slider.element.addEventListener('mouseleave', function (e) {
                if (!_this2._playStatus && window.outerWidth > 768) {
                  _this2._playStatus = true;

                  _this2._play();
                } else {
                  _this2._playStatus = false;

                  _this2._pause();
                }
              });

              window.addEventListener('resize', function () {
                if (_this2._playStatus && window.innerWidth < 768) {
                  _this2._pause();
                }
              });

              if (window.innerWidth > 768) {
                this._play();
              }
            }
          },
          {
            key: '_play',
            value: function _play() {
              this._slider.x = this._slider.x - 2;
              this._slider.settle(this._slider.x);
              this._requestID = window.requestAnimationFrame(this._play.bind(this));
            }
          },
          {
            key: '_pause',
            value: function _pause() {
              if (this._requestID) {
                window.cancelAnimationFrame(this._requestID);
                this._requestID = undefined;
              }
            }
          }
        ]);
        return FlickitySlider;
      })();

      exports.default = FlickitySlider;

      /***/
    },
    /* 396 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
       * Flickity v2.2.2
       * Touch, responsive, flickable carousels
       *
       * Licensed GPLv3 for open source use
       * or Flickity Commercial License for commercial use
       *
       * https://flickity.metafizzy.co
       * Copyright 2015-2021 Metafizzy
       */

      (function (window, factory) {
        // universal module definition
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(46),
            __webpack_require__(401),
            __webpack_require__(403),
            __webpack_require__(404),
            __webpack_require__(405),
            __webpack_require__(406),
            __webpack_require__(407)
          ]),
          (__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function'
              ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof module == 'object' && module.exports) {
          // CommonJS
          module.exports = factory(
            require('./flickity'),
            require('./drag'),
            require('./prev-next-button'),
            require('./page-dots'),
            require('./player'),
            require('./add-remove-cell'),
            require('./lazyload')
          );
        }
      })(window, function factory(Flickity) {
        return Flickity;
      });

      /***/
    },
    /* 397 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__; /**
       * matchesSelector v2.0.2
       * matchesSelector( element, '.selector' )
       * MIT license
       */

      /*jshint browser: true, strict: true, undef: true, unused: true */

      (function (window, factory) {
        /*global define: false, module: false */
        'use strict';
        // universal module definition
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function'
              ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof module == 'object' && module.exports) {
          // CommonJS
          module.exports = factory();
        } else {
          // browser global
          window.matchesSelector = factory();
        }
      })(window, function factory() {
        'use strict';

        var matchesMethod = (function () {
          var ElemProto = window.Element.prototype;
          // check for the standard method name first
          if (ElemProto.matches) {
            return 'matches';
          }
          // check un-prefixed
          if (ElemProto.matchesSelector) {
            return 'matchesSelector';
          }
          // check vendor prefixes
          var prefixes = ['webkit', 'moz', 'ms', 'o'];

          for (var i = 0; i < prefixes.length; i++) {
            var prefix = prefixes[i];
            var method = prefix + 'MatchesSelector';
            if (ElemProto[method]) {
              return method;
            }
          }
        })();

        return function matchesSelector(elem, selector) {
          return elem[matchesMethod](selector);
        };
      });

      /***/
    },
    /* 398 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // Flickity.Cell
      (function (window, factory) {
        // universal module definition
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(165)]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (getSize) {
            return factory(window, getSize);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof module == 'object' && module.exports) {
          // CommonJS
          module.exports = factory(window, require('get-size'));
        } else {
          // browser global
          window.Flickity = window.Flickity || {};
          window.Flickity.Cell = factory(window, window.getSize);
        }
      })(window, function factory(window, getSize) {
        'use strict';

        function Cell(elem, parent) {
          this.element = elem;
          this.parent = parent;

          this.create();
        }

        var proto = Cell.prototype;

        proto.create = function () {
          this.element.style.position = 'absolute';
          this.element.setAttribute('aria-hidden', 'true');
          this.x = 0;
          this.shift = 0;
        };

        proto.destroy = function () {
          // reset style
          this.unselect();
          this.element.style.position = '';
          var side = this.parent.originSide;
          this.element.style[side] = '';
          this.element.removeAttribute('aria-hidden');
        };

        proto.getSize = function () {
          this.size = getSize(this.element);
        };

        proto.setPosition = function (x) {
          this.x = x;
          this.updateTarget();
          this.renderPosition(x);
        };

        // setDefaultTarget v1 method, backwards compatibility, remove in v3
        proto.updateTarget = proto.setDefaultTarget = function () {
          var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
          this.target = this.x + this.size[marginProperty] + this.size.width * this.parent.cellAlign;
        };

        proto.renderPosition = function (x) {
          // render position of cell with in slider
          var side = this.parent.originSide;
          this.element.style[side] = this.parent.getPositionValue(x);
        };

        proto.select = function () {
          this.element.classList.add('is-selected');
          this.element.removeAttribute('aria-hidden');
        };

        proto.unselect = function () {
          this.element.classList.remove('is-selected');
          this.element.setAttribute('aria-hidden', 'true');
        };

        /**
         * @param {Integer} shift - 0, 1, or -1
         */
        proto.wrapShift = function (shift) {
          this.shift = shift;
          this.renderPosition(this.x + this.parent.slideableWidth * shift);
        };

        proto.remove = function () {
          this.element.parentNode.removeChild(this.element);
        };

        return Cell;
      });

      /***/
    },
    /* 399 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__; // slide
      (function (window, factory) {
        // universal module definition
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function'
              ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof module == 'object' && module.exports) {
          // CommonJS
          module.exports = factory();
        } else {
          // browser global
          window.Flickity = window.Flickity || {};
          window.Flickity.Slide = factory();
        }
      })(window, function factory() {
        'use strict';

        function Slide(parent) {
          this.parent = parent;
          this.isOriginLeft = parent.originSide == 'left';
          this.cells = [];
          this.outerWidth = 0;
          this.height = 0;
        }

        var proto = Slide.prototype;

        proto.addCell = function (cell) {
          this.cells.push(cell);
          this.outerWidth += cell.size.outerWidth;
          this.height = Math.max(cell.size.outerHeight, this.height);
          // first cell stuff
          if (this.cells.length == 1) {
            this.x = cell.x; // x comes from first cell
            var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
            this.firstMargin = cell.size[beginMargin];
          }
        };

        proto.updateTarget = function () {
          var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
          var lastCell = this.getLastCell();
          var lastMargin = lastCell ? lastCell.size[endMargin] : 0;
          var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
          this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
        };

        proto.getLastCell = function () {
          return this.cells[this.cells.length - 1];
        };

        proto.select = function () {
          this.cells.forEach(function (cell) {
            cell.select();
          });
        };

        proto.unselect = function () {
          this.cells.forEach(function (cell) {
            cell.unselect();
          });
        };

        proto.getCellElements = function () {
          return this.cells.map(function (cell) {
            return cell.element;
          });
        };

        return Slide;
      });

      /***/
    },
    /* 400 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // animate
      (function (window, factory) {
        // universal module definition
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(37)]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (utils) {
            return factory(window, utils);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof module == 'object' && module.exports) {
          // CommonJS
          module.exports = factory(window, require('fizzy-ui-utils'));
        } else {
          // browser global
          window.Flickity = window.Flickity || {};
          window.Flickity.animatePrototype = factory(window, window.fizzyUIUtils);
        }
      })(window, function factory(window, utils) {
        'use strict';

        // -------------------------- animate -------------------------- //

        var proto = {};

        proto.startAnimation = function () {
          if (this.isAnimating) {
            return;
          }

          this.isAnimating = true;
          this.restingFrames = 0;
          this.animate();
        };

        proto.animate = function () {
          this.applyDragForce();
          this.applySelectedAttraction();

          var previousX = this.x;

          this.integratePhysics();
          this.positionSlider();
          this.settle(previousX);
          // animate next frame
          if (this.isAnimating) {
            var _this = this;
            requestAnimationFrame(function animateFrame() {
              _this.animate();
            });
          }
        };

        proto.positionSlider = function () {
          var x = this.x;
          // wrap position around
          if (this.options.wrapAround && this.cells.length > 1) {
            x = utils.modulo(x, this.slideableWidth);
            x -= this.slideableWidth;
            this.shiftWrapCells(x);
          }

          this.setTranslateX(x, this.isAnimating);
          this.dispatchScrollEvent();
        };

        proto.setTranslateX = function (x, is3d) {
          x += this.cursorPosition;
          // reverse if right-to-left and using transform
          x = this.options.rightToLeft ? -x : x;
          var translateX = this.getPositionValue(x);
          // use 3D transforms for hardware acceleration on iOS
          // but use 2D when settled, for better font-rendering
          this.slider.style.transform = is3d ? 'translate3d(' + translateX + ',0,0)' : 'translateX(' + translateX + ')';
        };

        proto.dispatchScrollEvent = function () {
          var firstSlide = this.slides[0];
          if (!firstSlide) {
            return;
          }
          var positionX = -this.x - firstSlide.target;
          var progress = positionX / this.slidesWidth;
          this.dispatchEvent('scroll', null, [progress, positionX]);
        };

        proto.positionSliderAtSelected = function () {
          if (!this.cells.length) {
            return;
          }
          this.x = -this.selectedSlide.target;
          this.velocity = 0; // stop wobble
          this.positionSlider();
        };

        proto.getPositionValue = function (position) {
          if (this.options.percentPosition) {
            // percent position, round to 2 digits, like 12.34%
            return Math.round((position / this.size.innerWidth) * 10000) * 0.01 + '%';
          } else {
            // pixel positioning
            return Math.round(position) + 'px';
          }
        };

        proto.settle = function (previousX) {
          // keep track of frames where x hasn't moved
          var isResting = !this.isPointerDown && Math.round(this.x * 100) == Math.round(previousX * 100);
          if (isResting) {
            this.restingFrames++;
          }
          // stop animating if resting for 3 or more frames
          if (this.restingFrames > 2) {
            this.isAnimating = false;
            delete this.isFreeScrolling;
            // render position with translateX when settled
            this.positionSlider();
            this.dispatchEvent('settle', null, [this.selectedIndex]);
          }
        };

        proto.shiftWrapCells = function (x) {
          // shift before cells
          var beforeGap = this.cursorPosition + x;
          this._shiftCells(this.beforeShiftCells, beforeGap, -1);
          // shift after cells
          var afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
          this._shiftCells(this.afterShiftCells, afterGap, 1);
        };

        proto._shiftCells = function (cells, gap, shift) {
          for (var i = 0; i < cells.length; i++) {
            var cell = cells[i];
            var cellShift = gap > 0 ? shift : 0;
            cell.wrapShift(cellShift);
            gap -= cell.size.outerWidth;
          }
        };

        proto._unshiftCells = function (cells) {
          if (!cells || !cells.length) {
            return;
          }
          for (var i = 0; i < cells.length; i++) {
            cells[i].wrapShift(0);
          }
        };

        // -------------------------- physics -------------------------- //

        proto.integratePhysics = function () {
          this.x += this.velocity;
          this.velocity *= this.getFrictionFactor();
        };

        proto.applyForce = function (force) {
          this.velocity += force;
        };

        proto.getFrictionFactor = function () {
          return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
        };

        proto.getRestingPosition = function () {
          // my thanks to Steven Wittens, who simplified this math greatly
          return this.x + this.velocity / (1 - this.getFrictionFactor());
        };

        proto.applyDragForce = function () {
          if (!this.isDraggable || !this.isPointerDown) {
            return;
          }
          // change the position to drag position by applying force
          var dragVelocity = this.dragX - this.x;
          var dragForce = dragVelocity - this.velocity;
          this.applyForce(dragForce);
        };

        proto.applySelectedAttraction = function () {
          // do not attract if pointer down or no slides
          var dragDown = this.isDraggable && this.isPointerDown;
          if (dragDown || this.isFreeScrolling || !this.slides.length) {
            return;
          }
          var distance = this.selectedSlide.target * -1 - this.x;
          var force = distance * this.options.selectedAttraction;
          this.applyForce(force);
        };

        return proto;
      });

      /***/
    },
    /* 401 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // drag
      (function (window, factory) {
        // universal module definition
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(46),
            __webpack_require__(402),
            __webpack_require__(37)
          ]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (Flickity, Unidragger, utils) {
            return factory(window, Flickity, Unidragger, utils);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof module == 'object' && module.exports) {
          // CommonJS
          module.exports = factory(window, require('./flickity'), require('unidragger'), require('fizzy-ui-utils'));
        } else {
          // browser global
          window.Flickity = factory(window, window.Flickity, window.Unidragger, window.fizzyUIUtils);
        }
      })(window, function factory(window, Flickity, Unidragger, utils) {
        'use strict';

        // ----- defaults ----- //

        utils.extend(Flickity.defaults, {
          draggable: '>1',
          dragThreshold: 3
        });

        // ----- create ----- //

        Flickity.createMethods.push('_createDrag');

        // -------------------------- drag prototype -------------------------- //

        var proto = Flickity.prototype;
        utils.extend(proto, Unidragger.prototype);
        proto._touchActionValue = 'pan-y';

        // --------------------------  -------------------------- //

        var isTouch = 'createTouch' in document;
        var isTouchmoveScrollCanceled = false;

        proto._createDrag = function () {
          this.on('activate', this.onActivateDrag);
          this.on('uiChange', this._uiChangeDrag);
          this.on('deactivate', this.onDeactivateDrag);
          this.on('cellChange', this.updateDraggable);
          // TODO updateDraggable on resize? if groupCells & slides change
          // HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
          // #457, RubaXa/Sortable#973
          if (isTouch && !isTouchmoveScrollCanceled) {
            window.addEventListener('touchmove', function () {});
            isTouchmoveScrollCanceled = true;
          }
        };

        proto.onActivateDrag = function () {
          this.handles = [this.viewport];
          this.bindHandles();
          this.updateDraggable();
        };

        proto.onDeactivateDrag = function () {
          this.unbindHandles();
          this.element.classList.remove('is-draggable');
        };

        proto.updateDraggable = function () {
          // disable dragging if less than 2 slides. #278
          if (this.options.draggable == '>1') {
            this.isDraggable = this.slides.length > 1;
          } else {
            this.isDraggable = this.options.draggable;
          }
          if (this.isDraggable) {
            this.element.classList.add('is-draggable');
          } else {
            this.element.classList.remove('is-draggable');
          }
        };

        // backwards compatibility
        proto.bindDrag = function () {
          this.options.draggable = true;
          this.updateDraggable();
        };

        proto.unbindDrag = function () {
          this.options.draggable = false;
          this.updateDraggable();
        };

        proto._uiChangeDrag = function () {
          delete this.isFreeScrolling;
        };

        // -------------------------- pointer events -------------------------- //

        proto.pointerDown = function (event, pointer) {
          if (!this.isDraggable) {
            this._pointerDownDefault(event, pointer);
            return;
          }
          var isOkay = this.okayPointerDown(event);
          if (!isOkay) {
            return;
          }

          this._pointerDownPreventDefault(event);
          this.pointerDownFocus(event);
          // blur
          if (document.activeElement != this.element) {
            // do not blur if already focused
            this.pointerDownBlur();
          }

          // stop if it was moving
          this.dragX = this.x;
          this.viewport.classList.add('is-pointer-down');
          // track scrolling
          this.pointerDownScroll = getScrollPosition();
          window.addEventListener('scroll', this);

          this._pointerDownDefault(event, pointer);
        };

        // default pointerDown logic, used for staticClick
        proto._pointerDownDefault = function (event, pointer) {
          // track start event position
          // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
          this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY
          };
          // bind move and end events
          this._bindPostStartEvents(event);
          this.dispatchEvent('pointerDown', event, [pointer]);
        };

        var focusNodes = {
          INPUT: true,
          TEXTAREA: true,
          SELECT: true
        };

        proto.pointerDownFocus = function (event) {
          var isFocusNode = focusNodes[event.target.nodeName];
          if (!isFocusNode) {
            this.focus();
          }
        };

        proto._pointerDownPreventDefault = function (event) {
          var isTouchStart = event.type == 'touchstart';
          var isTouchPointer = event.pointerType == 'touch';
          var isFocusNode = focusNodes[event.target.nodeName];
          if (!isTouchStart && !isTouchPointer && !isFocusNode) {
            event.preventDefault();
          }
        };

        // ----- move ----- //

        proto.hasDragStarted = function (moveVector) {
          return Math.abs(moveVector.x) > this.options.dragThreshold;
        };

        // ----- up ----- //

        proto.pointerUp = function (event, pointer) {
          delete this.isTouchScrolling;
          this.viewport.classList.remove('is-pointer-down');
          this.dispatchEvent('pointerUp', event, [pointer]);
          this._dragPointerUp(event, pointer);
        };

        proto.pointerDone = function () {
          window.removeEventListener('scroll', this);
          delete this.pointerDownScroll;
        };

        // -------------------------- dragging -------------------------- //

        proto.dragStart = function (event, pointer) {
          if (!this.isDraggable) {
            return;
          }
          this.dragStartPosition = this.x;
          this.startAnimation();
          window.removeEventListener('scroll', this);
          this.dispatchEvent('dragStart', event, [pointer]);
        };

        proto.pointerMove = function (event, pointer) {
          var moveVector = this._dragPointerMove(event, pointer);
          this.dispatchEvent('pointerMove', event, [pointer, moveVector]);
          this._dragMove(event, pointer, moveVector);
        };

        proto.dragMove = function (event, pointer, moveVector) {
          if (!this.isDraggable) {
            return;
          }
          event.preventDefault();

          this.previousDragX = this.dragX;
          // reverse if right-to-left
          var direction = this.options.rightToLeft ? -1 : 1;
          if (this.options.wrapAround) {
            // wrap around move. #589
            moveVector.x %= this.slideableWidth;
          }
          var dragX = this.dragStartPosition + moveVector.x * direction;

          if (!this.options.wrapAround && this.slides.length) {
            // slow drag
            var originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
            dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
            var endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
          }

          this.dragX = dragX;

          this.dragMoveTime = new Date();
          this.dispatchEvent('dragMove', event, [pointer, moveVector]);
        };

        proto.dragEnd = function (event, pointer) {
          if (!this.isDraggable) {
            return;
          }
          if (this.options.freeScroll) {
            this.isFreeScrolling = true;
          }
          // set selectedIndex based on where flick will end up
          var index = this.dragEndRestingSelect();

          if (this.options.freeScroll && !this.options.wrapAround) {
            // if free-scroll & not wrap around
            // do not free-scroll if going outside of bounding slides
            // so bounding slides can attract slider, and keep it in bounds
            var restingX = this.getRestingPosition();
            this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
          } else if (!this.options.freeScroll && index == this.selectedIndex) {
            // boost selection if selected index has not changed
            index += this.dragEndBoostSelect();
          }
          delete this.previousDragX;
          // apply selection
          // TODO refactor this, selecting here feels weird
          // HACK, set flag so dragging stays in correct direction
          this.isDragSelect = this.options.wrapAround;
          this.select(index);
          delete this.isDragSelect;
          this.dispatchEvent('dragEnd', event, [pointer]);
        };

        proto.dragEndRestingSelect = function () {
          var restingX = this.getRestingPosition();
          // how far away from selected slide
          var distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
          // get closet resting going up and going down
          var positiveResting = this._getClosestResting(restingX, distance, 1);
          var negativeResting = this._getClosestResting(restingX, distance, -1);
          // use closer resting for wrap-around
          var index =
            positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
          return index;
        };

        /**
         * given resting X and distance to selected cell
         * get the distance and index of the closest cell
         * @param {Number} restingX - estimated post-flick resting position
         * @param {Number} distance - distance to selected cell
         * @param {Integer} increment - +1 or -1, going up or down
         * @returns {Object} - { distance: {Number}, index: {Integer} }
         */
        proto._getClosestResting = function (restingX, distance, increment) {
          var index = this.selectedIndex;
          var minDistance = Infinity;
          var condition =
            this.options.contain && !this.options.wrapAround
              ? // if contain, keep going if distance is equal to minDistance
                function (dist, minDist) {
                  return dist <= minDist;
                }
              : function (dist, minDist) {
                  return dist < minDist;
                };
          while (condition(distance, minDistance)) {
            // measure distance to next cell
            index += increment;
            minDistance = distance;
            distance = this.getSlideDistance(-restingX, index);
            if (distance === null) {
              break;
            }
            distance = Math.abs(distance);
          }
          return {
            distance: minDistance,
            // selected was previous index
            index: index - increment
          };
        };

        /**
         * measure distance between x and a slide target
         * @param {Number} x - horizontal position
         * @param {Integer} index - slide index
         * @returns {Number} - slide distance
         */
        proto.getSlideDistance = function (x, index) {
          var len = this.slides.length;
          // wrap around if at least 2 slides
          var isWrapAround = this.options.wrapAround && len > 1;
          var slideIndex = isWrapAround ? utils.modulo(index, len) : index;
          var slide = this.slides[slideIndex];
          if (!slide) {
            return null;
          }
          // add distance for wrap-around slides
          var wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
          return x - (slide.target + wrap);
        };

        proto.dragEndBoostSelect = function () {
          // do not boost if no previousDragX or dragMoveTime
          if (
            this.previousDragX === undefined ||
            !this.dragMoveTime ||
            // or if drag was held for 100 ms
            new Date() - this.dragMoveTime > 100
          ) {
            return 0;
          }

          var distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
          var delta = this.previousDragX - this.dragX;
          if (distance > 0 && delta > 0) {
            // boost to next if moving towards the right, and positive velocity
            return 1;
          } else if (distance < 0 && delta < 0) {
            // boost to previous if moving towards the left, and negative velocity
            return -1;
          }
          return 0;
        };

        // ----- staticClick ----- //

        proto.staticClick = function (event, pointer) {
          // get clickedCell, if cell was clicked
          var clickedCell = this.getParentCell(event.target);
          var cellElem = clickedCell && clickedCell.element;
          var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
          this.dispatchEvent('staticClick', event, [pointer, cellElem, cellIndex]);
        };

        // ----- scroll ----- //

        proto.onscroll = function () {
          var scroll = getScrollPosition();
          var scrollMoveX = this.pointerDownScroll.x - scroll.x;
          var scrollMoveY = this.pointerDownScroll.y - scroll.y;
          // cancel click/tap if scroll is too much
          if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
            this._pointerDone();
          }
        };

        // ----- utils ----- //

        function getScrollPosition() {
          return {
            x: window.pageXOffset,
            y: window.pageYOffset
          };
        }

        // -----  ----- //

        return Flickity;
      });

      /***/
    },
    /* 402 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
       * Unidragger v2.3.1
       * Draggable base class
       * MIT license
       */

      /*jshint browser: true, unused: true, undef: true, strict: true */

      (function (window, factory) {
        // universal module definition
        /*jshint strict: false */ /*globals define, module, require */

        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(115)]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (Unipointer) {
            return factory(window, Unipointer);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof module == 'object' && module.exports) {
          // CommonJS
          module.exports = factory(window, require('unipointer'));
        } else {
          // browser global
          window.Unidragger = factory(window, window.Unipointer);
        }
      })(window, function factory(window, Unipointer) {
        'use strict';

        // -------------------------- Unidragger -------------------------- //

        function Unidragger() {}

        // inherit Unipointer & EvEmitter
        var proto = (Unidragger.prototype = Object.create(Unipointer.prototype));

        // ----- bind start ----- //

        proto.bindHandles = function () {
          this._bindHandles(true);
        };

        proto.unbindHandles = function () {
          this._bindHandles(false);
        };

        /**
         * Add or remove start event
         * @param {Boolean} isAdd
         */
        proto._bindHandles = function (isAdd) {
          // munge isAdd, default to true
          isAdd = isAdd === undefined ? true : isAdd;
          // bind each handle
          var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
          var touchAction = isAdd ? this._touchActionValue : '';
          for (var i = 0; i < this.handles.length; i++) {
            var handle = this.handles[i];
            this._bindStartEvent(handle, isAdd);
            handle[bindMethod]('click', this);
            // touch-action: none to override browser touch gestures. metafizzy/flickity#540
            if (window.PointerEvent) {
              handle.style.touchAction = touchAction;
            }
          }
        };

        // prototype so it can be overwriteable by Flickity
        proto._touchActionValue = 'none';

        // ----- start event ----- //

        /**
         * pointer start
         * @param {Event} event
         * @param {Event or Touch} pointer
         */
        proto.pointerDown = function (event, pointer) {
          var isOkay = this.okayPointerDown(event);
          if (!isOkay) {
            return;
          }
          // track start event position
          // Safari 9 overrides pageX and pageY. These values needs to be copied. flickity#842
          this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY
          };

          event.preventDefault();
          this.pointerDownBlur();
          // bind move and end events
          this._bindPostStartEvents(event);
          this.emitEvent('pointerDown', [event, pointer]);
        };

        // nodes that have text fields
        var cursorNodes = {
          TEXTAREA: true,
          INPUT: true,
          SELECT: true,
          OPTION: true
        };

        // input types that do not have text fields
        var clickTypes = {
          radio: true,
          checkbox: true,
          button: true,
          submit: true,
          image: true,
          file: true
        };

        // dismiss inputs with text fields. flickity#403, flickity#404
        proto.okayPointerDown = function (event) {
          var isCursorNode = cursorNodes[event.target.nodeName];
          var isClickType = clickTypes[event.target.type];
          var isOkay = !isCursorNode || isClickType;
          if (!isOkay) {
            this._pointerReset();
          }
          return isOkay;
        };

        // kludge to blur previously focused input
        proto.pointerDownBlur = function () {
          var focused = document.activeElement;
          // do not blur body for IE10, metafizzy/flickity#117
          var canBlur = focused && focused.blur && focused != document.body;
          if (canBlur) {
            focused.blur();
          }
        };

        // ----- move event ----- //

        /**
         * drag move
         * @param {Event} event
         * @param {Event or Touch} pointer
         */
        proto.pointerMove = function (event, pointer) {
          var moveVector = this._dragPointerMove(event, pointer);
          this.emitEvent('pointerMove', [event, pointer, moveVector]);
          this._dragMove(event, pointer, moveVector);
        };

        // base pointer move logic
        proto._dragPointerMove = function (event, pointer) {
          var moveVector = {
            x: pointer.pageX - this.pointerDownPointer.pageX,
            y: pointer.pageY - this.pointerDownPointer.pageY
          };
          // start drag if pointer has moved far enough to start drag
          if (!this.isDragging && this.hasDragStarted(moveVector)) {
            this._dragStart(event, pointer);
          }
          return moveVector;
        };

        // condition if pointer has moved far enough to start drag
        proto.hasDragStarted = function (moveVector) {
          return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
        };

        // ----- end event ----- //

        /**
         * pointer up
         * @param {Event} event
         * @param {Event or Touch} pointer
         */
        proto.pointerUp = function (event, pointer) {
          this.emitEvent('pointerUp', [event, pointer]);
          this._dragPointerUp(event, pointer);
        };

        proto._dragPointerUp = function (event, pointer) {
          if (this.isDragging) {
            this._dragEnd(event, pointer);
          } else {
            // pointer didn't move enough for drag to start
            this._staticClick(event, pointer);
          }
        };

        // -------------------------- drag -------------------------- //

        // dragStart
        proto._dragStart = function (event, pointer) {
          this.isDragging = true;
          // prevent clicks
          this.isPreventingClicks = true;
          this.dragStart(event, pointer);
        };

        proto.dragStart = function (event, pointer) {
          this.emitEvent('dragStart', [event, pointer]);
        };

        // dragMove
        proto._dragMove = function (event, pointer, moveVector) {
          // do not drag if not dragging yet
          if (!this.isDragging) {
            return;
          }

          this.dragMove(event, pointer, moveVector);
        };

        proto.dragMove = function (event, pointer, moveVector) {
          event.preventDefault();
          this.emitEvent('dragMove', [event, pointer, moveVector]);
        };

        // dragEnd
        proto._dragEnd = function (event, pointer) {
          // set flags
          this.isDragging = false;
          // re-enable clicking async
          setTimeout(
            function () {
              delete this.isPreventingClicks;
            }.bind(this)
          );

          this.dragEnd(event, pointer);
        };

        proto.dragEnd = function (event, pointer) {
          this.emitEvent('dragEnd', [event, pointer]);
        };

        // ----- onclick ----- //

        // handle all clicks and prevent clicks when dragging
        proto.onclick = function (event) {
          if (this.isPreventingClicks) {
            event.preventDefault();
          }
        };

        // ----- staticClick ----- //

        // triggered after pointer down & up with no/tiny movement
        proto._staticClick = function (event, pointer) {
          // ignore emulated mouse up clicks
          if (this.isIgnoringMouseUp && event.type == 'mouseup') {
            return;
          }

          this.staticClick(event, pointer);

          // set flag for emulated clicks 300ms after touchend
          if (event.type != 'mouseup') {
            this.isIgnoringMouseUp = true;
            // reset flag after 300ms
            setTimeout(
              function () {
                delete this.isIgnoringMouseUp;
              }.bind(this),
              400
            );
          }
        };

        proto.staticClick = function (event, pointer) {
          this.emitEvent('staticClick', [event, pointer]);
        };

        // ----- utils ----- //

        Unidragger.getPointerPoint = Unipointer.getPointerPoint;

        // -----  ----- //

        return Unidragger;
      });

      /***/
    },
    /* 403 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // prev/next buttons
      (function (window, factory) {
        // universal module definition
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(46),
            __webpack_require__(115),
            __webpack_require__(37)
          ]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (Flickity, Unipointer, utils) {
            return factory(window, Flickity, Unipointer, utils);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof module == 'object' && module.exports) {
          // CommonJS
          module.exports = factory(window, require('./flickity'), require('unipointer'), require('fizzy-ui-utils'));
        } else {
          // browser global
          factory(window, window.Flickity, window.Unipointer, window.fizzyUIUtils);
        }
      })(window, function factory(window, Flickity, Unipointer, utils) {
        'use strict';

        var svgURI = 'http://www.w3.org/2000/svg';

        // -------------------------- PrevNextButton -------------------------- //

        function PrevNextButton(direction, parent) {
          this.direction = direction;
          this.parent = parent;
          this._create();
        }

        PrevNextButton.prototype = Object.create(Unipointer.prototype);

        PrevNextButton.prototype._create = function () {
          // properties
          this.isEnabled = true;
          this.isPrevious = this.direction == -1;
          var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
          this.isLeft = this.direction == leftDirection;

          var element = (this.element = document.createElement('button'));
          element.className = 'flickity-button flickity-prev-next-button';
          element.className += this.isPrevious ? ' previous' : ' next';
          // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
          element.setAttribute('type', 'button');
          // init as disabled
          this.disable();

          element.setAttribute('aria-label', this.isPrevious ? 'Previous' : 'Next');

          // create arrow
          var svg = this.createSVG();
          element.appendChild(svg);
          // events
          this.parent.on('select', this.update.bind(this));
          this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
        };

        PrevNextButton.prototype.activate = function () {
          this.bindStartEvent(this.element);
          this.element.addEventListener('click', this);
          // add to DOM
          this.parent.element.appendChild(this.element);
        };

        PrevNextButton.prototype.deactivate = function () {
          // remove from DOM
          this.parent.element.removeChild(this.element);
          // click events
          this.unbindStartEvent(this.element);
          this.element.removeEventListener('click', this);
        };

        PrevNextButton.prototype.createSVG = function () {
          var svg = document.createElementNS(svgURI, 'svg');
          svg.setAttribute('class', 'flickity-button-icon');
          svg.setAttribute('viewBox', '0 0 100 100');
          var path = document.createElementNS(svgURI, 'path');
          var pathMovements = getArrowMovements(this.parent.options.arrowShape);
          path.setAttribute('d', pathMovements);
          path.setAttribute('class', 'arrow');
          // rotate arrow
          if (!this.isLeft) {
            path.setAttribute('transform', 'translate(100, 100) rotate(180) ');
          }
          svg.appendChild(path);
          return svg;
        };

        // get SVG path movmement
        function getArrowMovements(shape) {
          // use shape as movement if string
          if (typeof shape == 'string') {
            return shape;
          }
          // create movement string
          return (
            'M ' +
            shape.x0 +
            ',50' +
            ' L ' +
            shape.x1 +
            ',' +
            (shape.y1 + 50) +
            ' L ' +
            shape.x2 +
            ',' +
            (shape.y2 + 50) +
            ' L ' +
            shape.x3 +
            ',50 ' +
            ' L ' +
            shape.x2 +
            ',' +
            (50 - shape.y2) +
            ' L ' +
            shape.x1 +
            ',' +
            (50 - shape.y1) +
            ' Z'
          );
        }

        PrevNextButton.prototype.handleEvent = utils.handleEvent;

        PrevNextButton.prototype.onclick = function () {
          if (!this.isEnabled) {
            return;
          }
          this.parent.uiChange();
          var method = this.isPrevious ? 'previous' : 'next';
          this.parent[method]();
        };

        // -----  ----- //

        PrevNextButton.prototype.enable = function () {
          if (this.isEnabled) {
            return;
          }
          this.element.disabled = false;
          this.isEnabled = true;
        };

        PrevNextButton.prototype.disable = function () {
          if (!this.isEnabled) {
            return;
          }
          this.element.disabled = true;
          this.isEnabled = false;
        };

        PrevNextButton.prototype.update = function () {
          // index of first or last slide, if previous or next
          var slides = this.parent.slides;
          // enable is wrapAround and at least 2 slides
          if (this.parent.options.wrapAround && slides.length > 1) {
            this.enable();
            return;
          }
          var lastIndex = slides.length ? slides.length - 1 : 0;
          var boundIndex = this.isPrevious ? 0 : lastIndex;
          var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
          this[method]();
        };

        PrevNextButton.prototype.destroy = function () {
          this.deactivate();
          this.allOff();
        };

        // -------------------------- Flickity prototype -------------------------- //

        utils.extend(Flickity.defaults, {
          prevNextButtons: true,
          arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
          }
        });

        Flickity.createMethods.push('_createPrevNextButtons');
        var proto = Flickity.prototype;

        proto._createPrevNextButtons = function () {
          if (!this.options.prevNextButtons) {
            return;
          }

          this.prevButton = new PrevNextButton(-1, this);
          this.nextButton = new PrevNextButton(1, this);

          this.on('activate', this.activatePrevNextButtons);
        };

        proto.activatePrevNextButtons = function () {
          this.prevButton.activate();
          this.nextButton.activate();
          this.on('deactivate', this.deactivatePrevNextButtons);
        };

        proto.deactivatePrevNextButtons = function () {
          this.prevButton.deactivate();
          this.nextButton.deactivate();
          this.off('deactivate', this.deactivatePrevNextButtons);
        };

        // --------------------------  -------------------------- //

        Flickity.PrevNextButton = PrevNextButton;

        return Flickity;
      });

      /***/
    },
    /* 404 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // page dots
      (function (window, factory) {
        // universal module definition
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(46),
            __webpack_require__(115),
            __webpack_require__(37)
          ]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (Flickity, Unipointer, utils) {
            return factory(window, Flickity, Unipointer, utils);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof module == 'object' && module.exports) {
          // CommonJS
          module.exports = factory(window, require('./flickity'), require('unipointer'), require('fizzy-ui-utils'));
        } else {
          // browser global
          factory(window, window.Flickity, window.Unipointer, window.fizzyUIUtils);
        }
      })(window, function factory(window, Flickity, Unipointer, utils) {
        // -------------------------- PageDots -------------------------- //

        'use strict';

        function PageDots(parent) {
          this.parent = parent;
          this._create();
        }

        PageDots.prototype = Object.create(Unipointer.prototype);

        PageDots.prototype._create = function () {
          // create holder element
          this.holder = document.createElement('ol');
          this.holder.className = 'flickity-page-dots';
          // create dots, array of elements
          this.dots = [];
          // events
          this.handleClick = this.onClick.bind(this);
          this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
        };

        PageDots.prototype.activate = function () {
          this.setDots();
          this.holder.addEventListener('click', this.handleClick);
          this.bindStartEvent(this.holder);
          // add to DOM
          this.parent.element.appendChild(this.holder);
        };

        PageDots.prototype.deactivate = function () {
          this.holder.removeEventListener('click', this.handleClick);
          this.unbindStartEvent(this.holder);
          // remove from DOM
          this.parent.element.removeChild(this.holder);
        };

        PageDots.prototype.setDots = function () {
          // get difference between number of slides and number of dots
          var delta = this.parent.slides.length - this.dots.length;
          if (delta > 0) {
            this.addDots(delta);
          } else if (delta < 0) {
            this.removeDots(-delta);
          }
        };

        PageDots.prototype.addDots = function (count) {
          var fragment = document.createDocumentFragment();
          var newDots = [];
          var length = this.dots.length;
          var max = length + count;

          for (var i = length; i < max; i++) {
            var dot = document.createElement('li');
            dot.className = 'dot';
            dot.setAttribute('aria-label', 'Page dot ' + (i + 1));
            fragment.appendChild(dot);
            newDots.push(dot);
          }

          this.holder.appendChild(fragment);
          this.dots = this.dots.concat(newDots);
        };

        PageDots.prototype.removeDots = function (count) {
          // remove from this.dots collection
          var removeDots = this.dots.splice(this.dots.length - count, count);
          // remove from DOM
          removeDots.forEach(function (dot) {
            this.holder.removeChild(dot);
          }, this);
        };

        PageDots.prototype.updateSelected = function () {
          // remove selected class on previous
          if (this.selectedDot) {
            this.selectedDot.className = 'dot';
            this.selectedDot.removeAttribute('aria-current');
          }
          // don't proceed if no dots
          if (!this.dots.length) {
            return;
          }
          this.selectedDot = this.dots[this.parent.selectedIndex];
          this.selectedDot.className = 'dot is-selected';
          this.selectedDot.setAttribute('aria-current', 'step');
        };

        PageDots.prototype.onTap = // old method name, backwards-compatible
          PageDots.prototype.onClick = function (event) {
            var target = event.target;
            // only care about dot clicks
            if (target.nodeName != 'LI') {
              return;
            }

            this.parent.uiChange();
            var index = this.dots.indexOf(target);
            this.parent.select(index);
          };

        PageDots.prototype.destroy = function () {
          this.deactivate();
          this.allOff();
        };

        Flickity.PageDots = PageDots;

        // -------------------------- Flickity -------------------------- //

        utils.extend(Flickity.defaults, {
          pageDots: true
        });

        Flickity.createMethods.push('_createPageDots');

        var proto = Flickity.prototype;

        proto._createPageDots = function () {
          if (!this.options.pageDots) {
            return;
          }
          this.pageDots = new PageDots(this);
          // events
          this.on('activate', this.activatePageDots);
          this.on('select', this.updateSelectedPageDots);
          this.on('cellChange', this.updatePageDots);
          this.on('resize', this.updatePageDots);
          this.on('deactivate', this.deactivatePageDots);
        };

        proto.activatePageDots = function () {
          this.pageDots.activate();
        };

        proto.updateSelectedPageDots = function () {
          this.pageDots.updateSelected();
        };

        proto.updatePageDots = function () {
          this.pageDots.setDots();
        };

        proto.deactivatePageDots = function () {
          this.pageDots.deactivate();
        };

        // -----  ----- //

        Flickity.PageDots = PageDots;

        return Flickity;
      });

      /***/
    },
    /* 405 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // player & autoPlay
      (function (window, factory) {
        // universal module definition
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(114),
            __webpack_require__(37),
            __webpack_require__(46)
          ]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (EvEmitter, utils, Flickity) {
            return factory(EvEmitter, utils, Flickity);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof module == 'object' && module.exports) {
          // CommonJS
          module.exports = factory(require('ev-emitter'), require('fizzy-ui-utils'), require('./flickity'));
        } else {
          // browser global
          factory(window.EvEmitter, window.fizzyUIUtils, window.Flickity);
        }
      })(window, function factory(EvEmitter, utils, Flickity) {
        'use strict';

        // -------------------------- Player -------------------------- //

        function Player(parent) {
          this.parent = parent;
          this.state = 'stopped';
          // visibility change event handler
          this.onVisibilityChange = this.visibilityChange.bind(this);
          this.onVisibilityPlay = this.visibilityPlay.bind(this);
        }

        Player.prototype = Object.create(EvEmitter.prototype);

        // start play
        Player.prototype.play = function () {
          if (this.state == 'playing') {
            return;
          }
          // do not play if page is hidden, start playing when page is visible
          var isPageHidden = document.hidden;
          if (isPageHidden) {
            document.addEventListener('visibilitychange', this.onVisibilityPlay);
            return;
          }

          this.state = 'playing';
          // listen to visibility change
          document.addEventListener('visibilitychange', this.onVisibilityChange);
          // start ticking
          this.tick();
        };

        Player.prototype.tick = function () {
          // do not tick if not playing
          if (this.state != 'playing') {
            return;
          }

          var time = this.parent.options.autoPlay;
          // default to 3 seconds
          time = typeof time == 'number' ? time : 3000;
          var _this = this;
          // HACK: reset ticks if stopped and started within interval
          this.clear();
          this.timeout = setTimeout(function () {
            _this.parent.next(true);
            _this.tick();
          }, time);
        };

        Player.prototype.stop = function () {
          this.state = 'stopped';
          this.clear();
          // remove visibility change event
          document.removeEventListener('visibilitychange', this.onVisibilityChange);
        };

        Player.prototype.clear = function () {
          clearTimeout(this.timeout);
        };

        Player.prototype.pause = function () {
          if (this.state == 'playing') {
            this.state = 'paused';
            this.clear();
          }
        };

        Player.prototype.unpause = function () {
          // re-start play if paused
          if (this.state == 'paused') {
            this.play();
          }
        };

        // pause if page visibility is hidden, unpause if visible
        Player.prototype.visibilityChange = function () {
          var isPageHidden = document.hidden;
          this[isPageHidden ? 'pause' : 'unpause']();
        };

        Player.prototype.visibilityPlay = function () {
          this.play();
          document.removeEventListener('visibilitychange', this.onVisibilityPlay);
        };

        // -------------------------- Flickity -------------------------- //

        utils.extend(Flickity.defaults, {
          pauseAutoPlayOnHover: true
        });

        Flickity.createMethods.push('_createPlayer');
        var proto = Flickity.prototype;

        proto._createPlayer = function () {
          this.player = new Player(this);

          this.on('activate', this.activatePlayer);
          this.on('uiChange', this.stopPlayer);
          this.on('pointerDown', this.stopPlayer);
          this.on('deactivate', this.deactivatePlayer);
        };

        proto.activatePlayer = function () {
          if (!this.options.autoPlay) {
            return;
          }
          this.player.play();
          this.element.addEventListener('mouseenter', this);
        };

        // Player API, don't hate the ... thanks I know where the door is

        proto.playPlayer = function () {
          this.player.play();
        };

        proto.stopPlayer = function () {
          this.player.stop();
        };

        proto.pausePlayer = function () {
          this.player.pause();
        };

        proto.unpausePlayer = function () {
          this.player.unpause();
        };

        proto.deactivatePlayer = function () {
          this.player.stop();
          this.element.removeEventListener('mouseenter', this);
        };

        // ----- mouseenter/leave ----- //

        // pause auto-play on hover
        proto.onmouseenter = function () {
          if (!this.options.pauseAutoPlayOnHover) {
            return;
          }
          this.player.pause();
          this.element.addEventListener('mouseleave', this);
        };

        // resume auto-play on hover off
        proto.onmouseleave = function () {
          this.player.unpause();
          this.element.removeEventListener('mouseleave', this);
        };

        // -----  ----- //

        Flickity.Player = Player;

        return Flickity;
      });

      /***/
    },
    /* 406 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // add, remove cell
      (function (window, factory) {
        // universal module definition
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(46), __webpack_require__(37)]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (Flickity, utils) {
            return factory(window, Flickity, utils);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof module == 'object' && module.exports) {
          // CommonJS
          module.exports = factory(window, require('./flickity'), require('fizzy-ui-utils'));
        } else {
          // browser global
          factory(window, window.Flickity, window.fizzyUIUtils);
        }
      })(window, function factory(window, Flickity, utils) {
        'use strict';

        // append cells to a document fragment
        function getCellsFragment(cells) {
          var fragment = document.createDocumentFragment();
          cells.forEach(function (cell) {
            fragment.appendChild(cell.element);
          });
          return fragment;
        }

        // -------------------------- add/remove cell prototype -------------------------- //

        var proto = Flickity.prototype;

        /**
         * Insert, prepend, or append cells
         * @param {[Element, Array, NodeList]} elems - Elements to insert
         * @param {Integer} index - Zero-based number to insert
         */
        proto.insert = function (elems, index) {
          var cells = this._makeCells(elems);
          if (!cells || !cells.length) {
            return;
          }
          var len = this.cells.length;
          // default to append
          index = index === undefined ? len : index;
          // add cells with document fragment
          var fragment = getCellsFragment(cells);
          // append to slider
          var isAppend = index == len;
          if (isAppend) {
            this.slider.appendChild(fragment);
          } else {
            var insertCellElement = this.cells[index].element;
            this.slider.insertBefore(fragment, insertCellElement);
          }
          // add to this.cells
          if (index === 0) {
            // prepend, add to start
            this.cells = cells.concat(this.cells);
          } else if (isAppend) {
            // append, add to end
            this.cells = this.cells.concat(cells);
          } else {
            // insert in this.cells
            var endCells = this.cells.splice(index, len - index);
            this.cells = this.cells.concat(cells).concat(endCells);
          }

          this._sizeCells(cells);
          this.cellChange(index, true);
        };

        proto.append = function (elems) {
          this.insert(elems, this.cells.length);
        };

        proto.prepend = function (elems) {
          this.insert(elems, 0);
        };

        /**
         * Remove cells
         * @param {[Element, Array, NodeList]} elems - ELements to remove
         */
        proto.remove = function (elems) {
          var cells = this.getCells(elems);
          if (!cells || !cells.length) {
            return;
          }

          var minCellIndex = this.cells.length - 1;
          // remove cells from collection & DOM
          cells.forEach(function (cell) {
            cell.remove();
            var index = this.cells.indexOf(cell);
            minCellIndex = Math.min(index, minCellIndex);
            utils.removeFrom(this.cells, cell);
          }, this);

          this.cellChange(minCellIndex, true);
        };

        /**
         * logic to be run after a cell's size changes
         * @param {Element} elem - cell's element
         */
        proto.cellSizeChange = function (elem) {
          var cell = this.getCell(elem);
          if (!cell) {
            return;
          }
          cell.getSize();

          var index = this.cells.indexOf(cell);
          this.cellChange(index);
        };

        /**
         * logic any time a cell is changed: added, removed, or size changed
         * @param {Integer} changedCellIndex - index of the changed cell, optional
         * @param {Boolean} isPositioningSlider - Positions slider after selection
         */
        proto.cellChange = function (changedCellIndex, isPositioningSlider) {
          var prevSelectedElem = this.selectedElement;
          this._positionCells(changedCellIndex);
          this._getWrapShiftCells();
          this.setGallerySize();
          // update selectedIndex
          // try to maintain position & select previous selected element
          var cell = this.getCell(prevSelectedElem);
          if (cell) {
            this.selectedIndex = this.getCellSlideIndex(cell);
          }
          this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);

          this.emitEvent('cellChange', [changedCellIndex]);
          // position slider
          this.select(this.selectedIndex);
          // do not position slider after lazy load
          if (isPositioningSlider) {
            this.positionSliderAtSelected();
          }
        };

        // -----  ----- //

        return Flickity;
      });

      /***/
    },
    /* 407 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // lazyload
      (function (window, factory) {
        // universal module definition
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(46), __webpack_require__(37)]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (Flickity, utils) {
            return factory(window, Flickity, utils);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof module == 'object' && module.exports) {
          // CommonJS
          module.exports = factory(window, require('./flickity'), require('fizzy-ui-utils'));
        } else {
          // browser global
          factory(window, window.Flickity, window.fizzyUIUtils);
        }
      })(window, function factory(window, Flickity, utils) {
        'use strict';

        Flickity.createMethods.push('_createLazyload');
        var proto = Flickity.prototype;

        proto._createLazyload = function () {
          this.on('select', this.lazyLoad);
        };

        proto.lazyLoad = function () {
          var lazyLoad = this.options.lazyLoad;
          if (!lazyLoad) {
            return;
          }
          // get adjacent cells, use lazyLoad option for adjacent count
          var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
          var cellElems = this.getAdjacentCellElements(adjCount);
          // get lazy images in those cells
          var lazyImages = [];
          cellElems.forEach(function (cellElem) {
            var lazyCellImages = getCellLazyImages(cellElem);
            lazyImages = lazyImages.concat(lazyCellImages);
          });
          // load lazy images
          lazyImages.forEach(function (img) {
            new LazyLoader(img, this);
          }, this);
        };

        function getCellLazyImages(cellElem) {
          // check if cell element is lazy image
          if (cellElem.nodeName == 'IMG') {
            var lazyloadAttr = cellElem.getAttribute('data-flickity-lazyload');
            var srcAttr = cellElem.getAttribute('data-flickity-lazyload-src');
            var srcsetAttr = cellElem.getAttribute('data-flickity-lazyload-srcset');
            if (lazyloadAttr || srcAttr || srcsetAttr) {
              return [cellElem];
            }
          }
          // select lazy images in cell
          var lazySelector =
            'img[data-flickity-lazyload], ' + 'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
          var imgs = cellElem.querySelectorAll(lazySelector);
          return utils.makeArray(imgs);
        }

        // -------------------------- LazyLoader -------------------------- //

        /**
         * class to handle loading images
         * @param {Image} img - Image element
         * @param {Flickity} flickity - Flickity instance
         */
        function LazyLoader(img, flickity) {
          this.img = img;
          this.flickity = flickity;
          this.load();
        }

        LazyLoader.prototype.handleEvent = utils.handleEvent;

        LazyLoader.prototype.load = function () {
          this.img.addEventListener('load', this);
          this.img.addEventListener('error', this);
          // get src & srcset
          var src =
            this.img.getAttribute('data-flickity-lazyload') || this.img.getAttribute('data-flickity-lazyload-src');
          var srcset = this.img.getAttribute('data-flickity-lazyload-srcset');
          // set src & serset
          this.img.src = src;
          if (srcset) {
            this.img.setAttribute('srcset', srcset);
          }
          // remove attr
          this.img.removeAttribute('data-flickity-lazyload');
          this.img.removeAttribute('data-flickity-lazyload-src');
          this.img.removeAttribute('data-flickity-lazyload-srcset');
        };

        LazyLoader.prototype.onload = function (event) {
          this.complete(event, 'flickity-lazyloaded');
        };

        LazyLoader.prototype.onerror = function (event) {
          this.complete(event, 'flickity-lazyerror');
        };

        LazyLoader.prototype.complete = function (event, className) {
          // unbind events
          this.img.removeEventListener('load', this);
          this.img.removeEventListener('error', this);

          var cell = this.flickity.getParentCell(this.img);
          var cellElem = cell && cell.element;
          this.flickity.cellSizeChange(cellElem);

          this.img.classList.add(className);
          this.flickity.dispatchEvent('lazyLoad', event, cellElem);
        };

        // -----  ----- //

        Flickity.LazyLoader = LazyLoader;

        return Flickity;
      });

      /***/
    },
    /* 408 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true
      });

      var _classCallCheck2 = __webpack_require__(10);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(11);

      var _createClass3 = _interopRequireDefault(_createClass2);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var ResponsiveTooltip = (function () {
        function ResponsiveTooltip(theme, elem) {
          (0, _classCallCheck3.default)(this, ResponsiveTooltip);

          this._theme = theme;
          this._tooltip = elem;
          this._container = this._tooltip.parentElement;
          this._gutter = 20;
        }

        (0, _createClass3.default)(ResponsiveTooltip, [
          {
            key: 'onInit',
            value: function onInit() {
              var _this = this;

              this._placement();

              window.addEventListener('resize', function () {
                _this._placement();
              });
            }
          },
          {
            key: '_placement',
            value: function _placement() {
              var containerWidth = this._container.offsetWidth;
              var containerRect = this._container.getBoundingClientRect();
              var containerLeft = containerRect.left - window.scrollX;
              var tooltipWidth = this._tooltip.offsetWidth;

              if (containerLeft + containerWidth / 2 + tooltipWidth / 2 > window.innerWidth - this._gutter) {
                // return 'left'
                this._tooltip.classList.add('custom-landing__shoppable-image-annotation-link--left');
              } else {
                this._tooltip.classList.remove('custom-landing__shoppable-image-annotation-link--left');
              }
            }
          }
        ]);
        return ResponsiveTooltip;
      })();

      exports.default = ResponsiveTooltip;

      /***/
    },
    /* 409 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true
      });

      var _from = __webpack_require__(161);

      var _from2 = _interopRequireDefault(_from);

      var _extends2 = __webpack_require__(58);

      var _extends3 = _interopRequireDefault(_extends2);

      var _classCallCheck2 = __webpack_require__(10);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(11);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _log = __webpack_require__(36);

      var _log2 = _interopRequireDefault(_log);

      var _SwipeEvents = __webpack_require__(410);

      var _SwipeEvents2 = _interopRequireDefault(_SwipeEvents);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var ShowMoreOptions = (function () {
        function ShowMoreOptions(theme, elem) {
          (0, _classCallCheck3.default)(this, ShowMoreOptions);

          this._theme = theme;
          this._elem = elem;
          this._container = Element;
          this._containerCount = 0;
          this._settings = (0, _extends3.default)(
            {
              options: 'product-information__option',
              containerClasses: ['flex', 'f-space-between', 'f-vertical-center'],
              sizeToBreak: 7
            },
            JSON.parse(elem.getAttribute('data-show-more-options') || '{}')
          );
          this._options = this._elem.querySelectorAll('.' + this._settings.options);

          // _log2.default.debug(this.constructor.name, 'Constructed', this);
        }

        (0, _createClass3.default)(ShowMoreOptions, [
          {
            key: 'onInit',
            value: function onInit() {
              this._initComponent();
              this._mobileSwipe();
            }
          },
          {
            key: '_mobileSwipe',
            value: function _mobileSwipe() {
              this._carouselSwipe = new _SwipeEvents2.default(this._elem, this._handleSwipe.bind(this));
            }
          },
          {
            key: '_handleSwipe',
            value: function _handleSwipe(dist) {
              var activeContainer = this._elem.querySelector('.show-more-options__container--active');
              var activeIndex = parseInt(activeContainer.dataset.index);

              if (dist < 0) {
                // Swipe Right
                if (activeIndex >= 1) {
                  this._elem
                    .querySelector('.show-more-options__container--' + activeIndex)
                    .classList.add('show-more-options__container--hidden');
                  this._elem
                    .querySelector('.show-more-options__container--' + activeIndex)
                    .classList.remove('show-more-options__container--active');
                  this._elem
                    .querySelector('.show-more-options__container--' + (activeIndex - 1))
                    .classList.remove('show-more-options__container--hidden');
                  this._elem
                    .querySelector('.show-more-options__container--' + (activeIndex - 1))
                    .classList.add('show-more-options__container--active');
                }
              } else {
                // Swipe Left
                if (activeIndex < this._containerCount - 1) {
                  this._elem
                    .querySelector('.show-more-options__container--' + activeIndex)
                    .classList.add('show-more-options__container--hidden');
                  this._elem
                    .querySelector('.show-more-options__container--' + activeIndex)
                    .classList.remove('show-more-options__container--active');
                  this._elem
                    .querySelector('.show-more-options__container--' + (activeIndex + 1))
                    .classList.remove('show-more-options__container--hidden');
                  this._elem
                    .querySelector('.show-more-options__container--' + (activeIndex + 1))
                    .classList.add('show-more-options__container--active');
                }
              }
            }
          },
          {
            key: '_initComponent',
            value: function _initComponent() {
              var _this = this;

              if (this._options.length > this._settings.sizeToBreak) {
                this._elem.classList.remove('product-information__options--mobile');
                this._createContainer();

                (0, _from2.default)(this._options).forEach(function (option, index) {
                  if (index !== 0 && (index + 1) % _this._settings.sizeToBreak === 0) {
                    if (_this._options.length > index + 1) {
                      var currentContainer = _this._containerCount;

                      var forwardArrow = document.createElement('span');
                      forwardArrow.classList.add('show-more-options__arrow', 'show-more-options__arrow--forward');
                      forwardArrow.addEventListener('click', function () {
                        _this._elem
                          .querySelector('.show-more-options__container--' + (currentContainer - 1))
                          .classList.add('show-more-options__container--hidden');
                        _this._elem
                          .querySelector('.show-more-options__container--' + (currentContainer - 1))
                          .classList.remove('show-more-options__container--active');
                        _this._elem
                          .querySelector('.show-more-options__container--' + currentContainer)
                          .classList.remove('show-more-options__container--hidden');
                        _this._elem
                          .querySelector('.show-more-options__container--' + currentContainer)
                          .classList.add('show-more-options__container--active');
                      });
                      _this._container.insertAdjacentElement('beforeend', forwardArrow);

                      _this._elem.insertAdjacentElement('beforeend', _this._container);

                      _this._createContainer();

                      var backArrow = document.createElement('span');
                      backArrow.classList.add('show-more-options__arrow', 'show-more-options__arrow--back');
                      backArrow.addEventListener('click', function () {
                        _this._elem
                          .querySelector('.show-more-options__container--' + currentContainer)
                          .classList.add('show-more-options__container--hidden');
                        _this._elem
                          .querySelector('.show-more-options__container--' + currentContainer)
                          .classList.remove('show-more-options__container--active');
                        _this._elem
                          .querySelector('.show-more-options__container--' + (currentContainer - 1))
                          .classList.remove('show-more-options__container--hidden');
                        _this._elem
                          .querySelector('.show-more-options__container--' + (currentContainer - 1))
                          .classList.add('show-more-options__container--active');
                      });
                      _this._container.insertAdjacentElement('beforeend', backArrow);

                      _this._container.insertAdjacentElement('beforeend', option);
                    } else {
                      _this._container.insertAdjacentElement('beforeend', option);
                    }
                  } else {
                    _this._container.insertAdjacentElement('beforeend', option);
                  }

                  if (_this._options.length === index + 1) {
                    while (_this._container.children.length < _this._settings.sizeToBreak) {
                      var spacer = document.createElement('span');
                      spacer.classList.add('show-more-options__spacer');

                      _this._container.insertAdjacentElement('beforeend', spacer);
                    }

                    _this._elem.insertAdjacentElement('beforeend', _this._container);
                  }
                });
              }
            }
          },
          {
            key: '_createContainer',
            value: function _createContainer() {
              var _this2 = this;

              this._container = document.createElement('div');
              this._container.classList.add(
                'show-more-options__container',
                'show-more-options__container--' + this._containerCount
              );
              this._container.dataset.index = this._containerCount;

              if (this._containerCount > 0) {
                this._container.classList.add('show-more-options__container--hidden');
              } else {
                this._container.classList.add('show-more-options__container--active');
              }

              this._settings.containerClasses.forEach(function (containerClass) {
                _this2._container.classList.add(containerClass);
              });

              this._containerCount++;
            }
          }
        ]);
        return ShowMoreOptions;
      })();

      exports.default = ShowMoreOptions;

      /***/
    },
    /* 410 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true
      });

      var _classCallCheck2 = __webpack_require__(10);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(11);

      var _createClass3 = _interopRequireDefault(_createClass2);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      // A helper class that detects swipe events
      var SwipeEvents = (function () {
        function SwipeEvents(element, handleM) {
          var _this = this;

          (0, _classCallCheck3.default)(this, SwipeEvents);

          this._startX = null;
          this._startY = null;
          this._prevX = null;
          this._verticalOffset = 40;
          this._handleMove = handleM;
          this._touchSurface = element;
          this._lock = false;
          this._touchSurface.addEventListener('touchstart', function (event) {
            _this._handleTouchStart(event);
          });
          this._touchSurface.addEventListener('touchend', function (event) {
            _this._lock = false;
          });
          this._touchSurface.addEventListener('touchmove', function (event) {
            if (!_this._lock) {
              _this._handleTouchMoves(event);
            }
          });
        }

        (0, _createClass3.default)(SwipeEvents, [
          {
            key: '_handleTouchStart',
            value: function _handleTouchStart(event) {
              var touchObj = event.changedTouches[0];
              this._startX = touchObj.pageX;
              this._prevX = this._startX;
              this._startY = touchObj.pageY;
            }
          },
          {
            key: '_handleTouchMoves',
            value: function _handleTouchMoves(event) {
              this._lock = true;
              var touchObj = event.changedTouches[0];
              var flag = Math.abs(this._startY - touchObj.pageY) <= this._verticalOffset;
              if (!flag || !this._handleMove) return;
              var dist = this._prevX - touchObj.pageX;
              this._prevX = touchObj.pageX;
              this._handleMove(dist);
            }
          }
        ]);
        return SwipeEvents;
      })();

      exports.default = SwipeEvents;

      /***/
    },
    /* 411 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true
      });

      var _extends2 = __webpack_require__(58);

      var _extends3 = _interopRequireDefault(_extends2);

      var _classCallCheck2 = __webpack_require__(10);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(11);

      var _createClass3 = _interopRequireDefault(_createClass2);

      __webpack_require__(412);

      var _jquery = __webpack_require__(116);

      var _jquery2 = _interopRequireDefault(_jquery);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var Slick = (function () {
        function Slick(theme, elem) {
          (0, _classCallCheck3.default)(this, Slick);

          this._theme = theme;
          this._name = this.constructor.name;
          this._elem = elem;
          this._options = (0, _extends3.default)(
            {
              arrows: false,
              dots: false,
              autoplay: false,
              infinite: true,
              draggable: false,
              slidesToShow: 1,
              mobileOnly: false,
              swipe: true,
              dontInit: false,
              showAbove: null,
              showBelow: null
            },
            JSON.parse(this._elem.getAttribute('data-slick') || '{}')
          );
          if (this._options.mobileOnly) this._options.showBelow = 769;
        }

        (0, _createClass3.default)(Slick, [
          {
            key: 'onInit',
            value: function onInit() {
              if (!this._options.dontInit) {
                if (this._options.showAbove && window.innerWidth <= this._options.showAbove) return false;
                if (this._options.showBelow && window.innerWidth >= this._options.showBelow) return false;
                this._slick();
              }
            }
          },
          {
            key: '_slick',
            value: function _slick() {
              (0, _jquery2.default)(this._elem).not('.slick-initialized').slick(this._options);
              this._elem.querySelector('video') && this._handleVideo();
            }
          },
          {
            key: '_handleVideo',
            value: function _handleVideo() {
              (0, _jquery2.default)(this._elem).on('init', function (e, slick) {
                var vid = slick.$slides.length ? slick.$slides[0].querySelector('video') : false;
                if (vid) {
                  vid.play();
                  vid.removeAttribute('poster');
                }
              });

              (0, _jquery2.default)(this._elem).on('beforeChange', function (e, slick, curSlide, nextSlide) {
                var vid = slick.$slides[curSlide] ? slick.$slides[curSlide].querySelector('video') : null;
                if (vid) vid.pause();
              });

              (0, _jquery2.default)(this._elem).on('afterChange', function (e, slick, curSlide) {
                var vid = slick.$slides[curSlide] ? slick.$slides[curSlide].querySelector('video') : null;
                if (vid) {
                  vid.play();
                  vid.removeAttribute('poster');
                }
              });
            }
          }
        ]);
        return Slick;
      })();

      exports.default = Slick;

      /***/
    },
    /* 412 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
      /* global window, document, define, jQuery, setInterval, clearInterval */
      (function (factory) {
        'use strict';
        if (true) {
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(116)]),
          (__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function'
              ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof exports !== 'undefined') {
          module.exports = factory(require('jquery'));
        } else {
          factory(jQuery);
        }
      })(function ($) {
        'use strict';
        var Slick = window.Slick || {};

        Slick = (function () {
          var instanceUid = 0;

          function Slick(element, settings) {
            var _ = this,
              dataSettings;

            _.defaults = {
              accessibility: true,
              adaptiveHeight: false,
              appendArrows: $(element),
              appendDots: $(element),
              arrows: true,
              asNavFor: null,
              prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
              nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
              autoplay: false,
              autoplaySpeed: 3000,
              centerMode: false,
              centerPadding: '50px',
              cssEase: 'ease',
              customPaging: function (slider, i) {
                return $('<button type="button" />').text(i + 1);
              },
              dots: false,
              dotsClass: 'slick-dots',
              draggable: true,
              easing: 'linear',
              edgeFriction: 0.35,
              fade: false,
              focusOnSelect: false,
              focusOnChange: false,
              infinite: true,
              initialSlide: 0,
              lazyLoad: 'ondemand',
              mobileFirst: false,
              pauseOnHover: true,
              pauseOnFocus: true,
              pauseOnDotsHover: false,
              respondTo: 'window',
              responsive: null,
              rows: 1,
              rtl: false,
              slide: '',
              slidesPerRow: 1,
              slidesToShow: 1,
              slidesToScroll: 1,
              speed: 500,
              swipe: true,
              swipeToSlide: false,
              touchMove: true,
              touchThreshold: 5,
              useCSS: true,
              useTransform: true,
              variableWidth: false,
              vertical: false,
              verticalSwiping: false,
              waitForAnimate: true,
              zIndex: 1000
            };

            _.initials = {
              animating: false,
              dragging: false,
              autoPlayTimer: null,
              currentDirection: 0,
              currentLeft: null,
              currentSlide: 0,
              direction: 1,
              $dots: null,
              listWidth: null,
              listHeight: null,
              loadIndex: 0,
              $nextArrow: null,
              $prevArrow: null,
              scrolling: false,
              slideCount: null,
              slideWidth: null,
              $slideTrack: null,
              $slides: null,
              sliding: false,
              slideOffset: 0,
              swipeLeft: null,
              swiping: false,
              $list: null,
              touchObject: {},
              transformsEnabled: false,
              unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
              _.hidden = 'mozHidden';
              _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
              _.hidden = 'webkitHidden';
              _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;

            _.registerBreakpoints();
            _.init(true);
          }

          return Slick;
        })();

        Slick.prototype.activateADA = function () {
          var _ = this;

          _.$slideTrack
            .find('.slick-active')
            .attr({
              'aria-hidden': 'false'
            })
            .find('a, input, button, select')
            .attr({
              tabindex: '0'
            });
        };

        Slick.prototype.addSlide = Slick.prototype.slickAdd = function (markup, index, addBefore) {
          var _ = this;

          if (typeof index === 'boolean') {
            addBefore = index;
            index = null;
          } else if (index < 0 || index >= _.slideCount) {
            return false;
          }

          _.unload();

          if (typeof index === 'number') {
            if (index === 0 && _.$slides.length === 0) {
              $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
              $(markup).insertBefore(_.$slides.eq(index));
            } else {
              $(markup).insertAfter(_.$slides.eq(index));
            }
          } else {
            if (addBefore === true) {
              $(markup).prependTo(_.$slideTrack);
            } else {
              $(markup).appendTo(_.$slideTrack);
            }
          }

          _.$slides = _.$slideTrack.children(this.options.slide);

          _.$slideTrack.children(this.options.slide).detach();

          _.$slideTrack.append(_.$slides);

          _.$slides.each(function (index, element) {
            $(element).attr('data-slick-index', index);
          });

          _.$slidesCache = _.$slides;

          _.reinit();
        };

        Slick.prototype.animateHeight = function () {
          var _ = this;
          if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate(
              {
                height: targetHeight
              },
              _.options.speed
            );
          }
        };

        Slick.prototype.animateSlide = function (targetLeft, callback) {
          var animProps = {},
            _ = this;

          _.animateHeight();

          if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
          }
          if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
              _.$slideTrack.animate(
                {
                  left: targetLeft
                },
                _.options.speed,
                _.options.easing,
                callback
              );
            } else {
              _.$slideTrack.animate(
                {
                  top: targetLeft
                },
                _.options.speed,
                _.options.easing,
                callback
              );
            }
          } else {
            if (_.cssTransitions === false) {
              if (_.options.rtl === true) {
                _.currentLeft = -_.currentLeft;
              }
              $({
                animStart: _.currentLeft
              }).animate(
                {
                  animStart: targetLeft
                },
                {
                  duration: _.options.speed,
                  easing: _.options.easing,
                  step: function (now) {
                    now = Math.ceil(now);
                    if (_.options.vertical === false) {
                      animProps[_.animType] = 'translate(' + now + 'px, 0px)';
                      _.$slideTrack.css(animProps);
                    } else {
                      animProps[_.animType] = 'translate(0px,' + now + 'px)';
                      _.$slideTrack.css(animProps);
                    }
                  },
                  complete: function () {
                    if (callback) {
                      callback.call();
                    }
                  }
                }
              );
            } else {
              _.applyTransition();
              targetLeft = Math.ceil(targetLeft);

              if (_.options.vertical === false) {
                animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
              } else {
                animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
              }
              _.$slideTrack.css(animProps);

              if (callback) {
                setTimeout(function () {
                  _.disableTransition();

                  callback.call();
                }, _.options.speed);
              }
            }
          }
        };

        Slick.prototype.getNavTarget = function () {
          var _ = this,
            asNavFor = _.options.asNavFor;

          if (asNavFor && asNavFor !== null) {
            asNavFor = $(asNavFor).not(_.$slider);
          }

          return asNavFor;
        };

        Slick.prototype.asNavFor = function (index) {
          var _ = this,
            asNavFor = _.getNavTarget();

          if (asNavFor !== null && typeof asNavFor === 'object') {
            asNavFor.each(function () {
              var target = $(this).slick('getSlick');
              if (!target.unslicked) {
                target.slideHandler(index, true);
              }
            });
          }
        };

        Slick.prototype.applyTransition = function (slide) {
          var _ = this,
            transition = {};

          if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
          } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
          }

          if (_.options.fade === false) {
            _.$slideTrack.css(transition);
          } else {
            _.$slides.eq(slide).css(transition);
          }
        };

        Slick.prototype.autoPlay = function () {
          var _ = this;

          _.autoPlayClear();

          if (_.slideCount > _.options.slidesToShow) {
            _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
          }
        };

        Slick.prototype.autoPlayClear = function () {
          var _ = this;

          if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
          }
        };

        Slick.prototype.autoPlayIterator = function () {
          var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

          if (!_.paused && !_.interrupted && !_.focussed) {
            if (_.options.infinite === false) {
              if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) {
                _.direction = 0;
              } else if (_.direction === 0) {
                slideTo = _.currentSlide - _.options.slidesToScroll;

                if (_.currentSlide - 1 === 0) {
                  _.direction = 1;
                }
              }
            }

            _.slideHandler(slideTo);
          }
        };

        Slick.prototype.buildArrows = function () {
          var _ = this;

          if (_.options.arrows === true) {
            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if (_.slideCount > _.options.slidesToShow) {
              _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
              _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

              if (_.htmlExpr.test(_.options.prevArrow)) {
                _.$prevArrow.prependTo(_.options.appendArrows);
              }

              if (_.htmlExpr.test(_.options.nextArrow)) {
                _.$nextArrow.appendTo(_.options.appendArrows);
              }

              if (_.options.infinite !== true) {
                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
              }
            } else {
              _.$prevArrow
                .add(_.$nextArrow)

                .addClass('slick-hidden')
                .attr({
                  'aria-disabled': 'true',
                  tabindex: '-1'
                });
            }
          }
        };

        Slick.prototype.buildDots = function () {
          var _ = this,
            i,
            dot;

          if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
              dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active');
          }
        };

        Slick.prototype.buildOut = function () {
          var _ = this;

          _.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');

          _.slideCount = _.$slides.length;

          _.$slides.each(function (index, element) {
            $(element)
              .attr('data-slick-index', index)
              .data('originalStyling', $(element).attr('style') || '');
          });

          _.$slider.addClass('slick-slider');

          _.$slideTrack =
            _.slideCount === 0
              ? $('<div class="slick-track"/>').appendTo(_.$slider)
              : _.$slides.wrapAll('<div class="slick-track"/>').parent();

          _.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent();
          _.$slideTrack.css('opacity', 0);

          if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
          }

          $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

          _.setupInfinite();

          _.buildArrows();

          _.buildDots();

          _.updateDots();

          _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

          if (_.options.draggable === true) {
            _.$list.addClass('draggable');
          }
        };

        Slick.prototype.buildRows = function () {
          var _ = this,
            a,
            b,
            c,
            newSlides,
            numOfSlides,
            originalSlides,
            slidesPerSection;

          newSlides = document.createDocumentFragment();
          originalSlides = _.$slider.children();

          if (_.options.rows > 0) {
            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);

            for (a = 0; a < numOfSlides; a++) {
              var slide = document.createElement('div');
              for (b = 0; b < _.options.rows; b++) {
                var row = document.createElement('div');
                for (c = 0; c < _.options.slidesPerRow; c++) {
                  var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
                  if (originalSlides.get(target)) {
                    row.appendChild(originalSlides.get(target));
                  }
                }
                slide.appendChild(row);
              }
              newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider
              .children()
              .children()
              .children()
              .css({
                width: 100 / _.options.slidesPerRow + '%',
                display: 'inline-block'
              });
          }
        };

        Slick.prototype.checkResponsive = function (initial, forceUpdate) {
          var _ = this,
            breakpoint,
            targetBreakpoint,
            respondToWidth,
            triggerBreakpoint = false;
          var sliderWidth = _.$slider.width();
          var windowWidth = window.innerWidth || $(window).width();

          if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
          } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
          } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
          }

          if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {
            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
              if (_.breakpoints.hasOwnProperty(breakpoint)) {
                if (_.originalSettings.mobileFirst === false) {
                  if (respondToWidth < _.breakpoints[breakpoint]) {
                    targetBreakpoint = _.breakpoints[breakpoint];
                  }
                } else {
                  if (respondToWidth > _.breakpoints[breakpoint]) {
                    targetBreakpoint = _.breakpoints[breakpoint];
                  }
                }
              }
            }

            if (targetBreakpoint !== null) {
              if (_.activeBreakpoint !== null) {
                if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                  _.activeBreakpoint = targetBreakpoint;
                  if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                    _.unslick(targetBreakpoint);
                  } else {
                    _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                    if (initial === true) {
                      _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                  }
                  triggerBreakpoint = targetBreakpoint;
                }
              } else {
                _.activeBreakpoint = targetBreakpoint;
                if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                  _.unslick(targetBreakpoint);
                } else {
                  _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                  if (initial === true) {
                    _.currentSlide = _.options.initialSlide;
                  }
                  _.refresh(initial);
                }
                triggerBreakpoint = targetBreakpoint;
              }
            } else {
              if (_.activeBreakpoint !== null) {
                _.activeBreakpoint = null;
                _.options = _.originalSettings;
                if (initial === true) {
                  _.currentSlide = _.options.initialSlide;
                }
                _.refresh(initial);
                triggerBreakpoint = targetBreakpoint;
              }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if (!initial && triggerBreakpoint !== false) {
              _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
          }
        };

        Slick.prototype.changeSlide = function (event, dontAnimate) {
          var _ = this,
            $target = $(event.currentTarget),
            indexOffset,
            slideOffset,
            unevenOffset;

          // If target is a link, prevent default action.
          if ($target.is('a')) {
            event.preventDefault();
          }

          // If target is not the <li> element (ie: a child), find the <li>.
          if (!$target.is('li')) {
            $target = $target.closest('li');
          }

          unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
          indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

          switch (event.data.message) {
            case 'previous':
              slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
              if (_.slideCount > _.options.slidesToShow) {
                _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
              }
              break;

            case 'next':
              slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
              if (_.slideCount > _.options.slidesToShow) {
                _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
              }
              break;

            case 'index':
              var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;

              _.slideHandler(_.checkNavigable(index), false, dontAnimate);
              $target.children().trigger('focus');
              break;

            default:
              return;
          }
        };

        Slick.prototype.checkNavigable = function (index) {
          var _ = this,
            navigables,
            prevNavigable;

          navigables = _.getNavigableIndexes();
          prevNavigable = 0;
          if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
          } else {
            for (var n in navigables) {
              if (index < navigables[n]) {
                index = prevNavigable;
                break;
              }
              prevNavigable = navigables[n];
            }
          }

          return index;
        };

        Slick.prototype.cleanUpEvents = function () {
          var _ = this;

          if (_.options.dots && _.$dots !== null) {
            $('li', _.$dots)
              .off('click.slick', _.changeSlide)
              .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
              .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

            if (_.options.accessibility === true) {
              _.$dots.off('keydown.slick', _.keyHandler);
            }
          }

          _.$slider.off('focus.slick blur.slick');

          if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

            if (_.options.accessibility === true) {
              _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
              _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
          }

          _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
          _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
          _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
          _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

          _.$list.off('click.slick', _.clickHandler);

          $(document).off(_.visibilityChange, _.visibility);

          _.cleanUpSlideEvents();

          if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
          }

          if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
          }

          $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

          $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

          $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

          $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
        };

        Slick.prototype.cleanUpSlideEvents = function () {
          var _ = this;

          _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
          _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
        };

        Slick.prototype.cleanUpRows = function () {
          var _ = this,
            originalSlides;

          if (_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
          }
        };

        Slick.prototype.clickHandler = function (event) {
          var _ = this;

          if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
          }
        };

        Slick.prototype.destroy = function (refresh) {
          var _ = this;

          _.autoPlayClear();

          _.touchObject = {};

          _.cleanUpEvents();

          $('.slick-cloned', _.$slider).detach();

          if (_.$dots) {
            _.$dots.remove();
          }

          if (_.$prevArrow && _.$prevArrow.length) {
            _.$prevArrow
              .removeClass('slick-disabled slick-arrow slick-hidden')
              .removeAttr('aria-hidden aria-disabled tabindex')
              .css('display', '');

            if (_.htmlExpr.test(_.options.prevArrow)) {
              _.$prevArrow.remove();
            }
          }

          if (_.$nextArrow && _.$nextArrow.length) {
            _.$nextArrow
              .removeClass('slick-disabled slick-arrow slick-hidden')
              .removeAttr('aria-hidden aria-disabled tabindex')
              .css('display', '');

            if (_.htmlExpr.test(_.options.nextArrow)) {
              _.$nextArrow.remove();
            }
          }

          if (_.$slides) {
            _.$slides
              .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
              .removeAttr('aria-hidden')
              .removeAttr('data-slick-index')
              .each(function () {
                $(this).attr('style', $(this).data('originalStyling'));
              });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
          }

          _.cleanUpRows();

          _.$slider.removeClass('slick-slider');
          _.$slider.removeClass('slick-initialized');
          _.$slider.removeClass('slick-dotted');

          _.unslicked = true;

          if (!refresh) {
            _.$slider.trigger('destroy', [_]);
          }
        };

        Slick.prototype.disableTransition = function (slide) {
          var _ = this,
            transition = {};

          transition[_.transitionType] = '';

          if (_.options.fade === false) {
            _.$slideTrack.css(transition);
          } else {
            _.$slides.eq(slide).css(transition);
          }
        };

        Slick.prototype.fadeSlide = function (slideIndex, callback) {
          var _ = this;

          if (_.cssTransitions === false) {
            _.$slides.eq(slideIndex).css({
              zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate(
              {
                opacity: 1
              },
              _.options.speed,
              _.options.easing,
              callback
            );
          } else {
            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
              opacity: 1,
              zIndex: _.options.zIndex
            });

            if (callback) {
              setTimeout(function () {
                _.disableTransition(slideIndex);

                callback.call();
              }, _.options.speed);
            }
          }
        };

        Slick.prototype.fadeSlideOut = function (slideIndex) {
          var _ = this;

          if (_.cssTransitions === false) {
            _.$slides.eq(slideIndex).animate(
              {
                opacity: 0,
                zIndex: _.options.zIndex - 2
              },
              _.options.speed,
              _.options.easing
            );
          } else {
            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
              opacity: 0,
              zIndex: _.options.zIndex - 2
            });
          }
        };

        Slick.prototype.filterSlides = Slick.prototype.slickFilter = function (filter) {
          var _ = this;

          if (filter !== null) {
            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();
          }
        };

        Slick.prototype.focusHandler = function () {
          var _ = this;

          _.$slider.off('focus.slick blur.slick').on('focus.slick blur.slick', '*', function (event) {
            event.stopImmediatePropagation();
            var $sf = $(this);

            setTimeout(function () {
              if (_.options.pauseOnFocus) {
                _.focussed = $sf.is(':focus');
                _.autoPlay();
              }
            }, 0);
          });
        };

        Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function () {
          var _ = this;
          return _.currentSlide;
        };

        Slick.prototype.getDotCount = function () {
          var _ = this;

          var breakPoint = 0;
          var counter = 0;
          var pagerQty = 0;

          if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) {
              ++pagerQty;
            } else {
              while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter +=
                  _.options.slidesToScroll <= _.options.slidesToShow
                    ? _.options.slidesToScroll
                    : _.options.slidesToShow;
              }
            }
          } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
          } else if (!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
          } else {
            while (breakPoint < _.slideCount) {
              ++pagerQty;
              breakPoint = counter + _.options.slidesToScroll;
              counter +=
                _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
          }

          return pagerQty - 1;
        };

        Slick.prototype.getLeft = function (slideIndex) {
          var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide,
            coef;

          _.slideOffset = 0;
          verticalHeight = _.$slides.first().outerHeight(true);

          if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
              _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
              coef = -1;

              if (_.options.vertical === true && _.options.centerMode === true) {
                if (_.options.slidesToShow === 2) {
                  coef = -1.5;
                } else if (_.options.slidesToShow === 1) {
                  coef = -2;
                }
              }
              verticalOffset = verticalHeight * _.options.slidesToShow * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
              if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                if (slideIndex > _.slideCount) {
                  _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
                  verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
                } else {
                  _.slideOffset = (_.slideCount % _.options.slidesToScroll) * _.slideWidth * -1;
                  verticalOffset = (_.slideCount % _.options.slidesToScroll) * verticalHeight * -1;
                }
              }
            }
          } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
              _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
              verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
            }
          }

          if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
          }

          if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
            _.slideOffset = (_.slideWidth * Math.floor(_.options.slidesToShow)) / 2 - (_.slideWidth * _.slideCount) / 2;
          } else if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
          } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
          }

          if (_.options.vertical === false) {
            targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
          } else {
            targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
          }

          if (_.options.variableWidth === true) {
            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
              targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
              targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
              if (targetSlide[0]) {
                targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
              } else {
                targetLeft = 0;
              }
            } else {
              targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
              if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
              } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
              }

              if (_.options.rtl === true) {
                if (targetSlide[0]) {
                  targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                  targetLeft = 0;
                }
              } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
              }

              targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
          }

          return targetLeft;
        };

        Slick.prototype.getOption = Slick.prototype.slickGetOption = function (option) {
          var _ = this;

          return _.options[option];
        };

        Slick.prototype.getNavigableIndexes = function () {
          var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

          if (_.options.infinite === false) {
            max = _.slideCount;
          } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
          }

          while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter +=
              _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
          }

          return indexes;
        };

        Slick.prototype.getSlick = function () {
          return this;
        };

        Slick.prototype.getSlideCount = function () {
          var _ = this,
            slidesTraversed,
            swipedSlide,
            centerOffset;

          centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

          if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function (index, slide) {
              if (slide.offsetLeft - centerOffset + $(slide).outerWidth() / 2 > _.swipeLeft * -1) {
                swipedSlide = slide;
                return false;
              }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;
          } else {
            return _.options.slidesToScroll;
          }
        };

        Slick.prototype.goTo = Slick.prototype.slickGoTo = function (slide, dontAnimate) {
          var _ = this;

          _.changeSlide(
            {
              data: {
                message: 'index',
                index: parseInt(slide)
              }
            },
            dontAnimate
          );
        };

        Slick.prototype.init = function (creation) {
          var _ = this;

          if (!$(_.$slider).hasClass('slick-initialized')) {
            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();
          }

          if (creation) {
            _.$slider.trigger('init', [_]);
          }

          if (_.options.accessibility === true) {
            _.initADA();
          }

          if (_.options.autoplay) {
            _.paused = false;
            _.autoPlay();
          }
        };

        Slick.prototype.initADA = function () {
          var _ = this,
            numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
            tabControlIndexes = _.getNavigableIndexes().filter(function (val) {
              return val >= 0 && val < _.slideCount;
            });

          _.$slides
            .add(_.$slideTrack.find('.slick-cloned'))
            .attr({
              'aria-hidden': 'true',
              tabindex: '-1'
            })
            .find('a, input, button, select')
            .attr({
              tabindex: '-1'
            });

          if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function (i) {
              var slideControlIndex = tabControlIndexes.indexOf(i);

              $(this).attr({
                role: 'tabpanel',
                id: 'slick-slide' + _.instanceUid + i,
                tabindex: -1
              });

              if (slideControlIndex !== -1) {
                var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex;
                if ($('#' + ariaButtonControl).length) {
                  $(this).attr({
                    'aria-describedby': ariaButtonControl
                  });
                }
              }
            });

            _.$dots
              .attr('role', 'tablist')
              .find('li')
              .each(function (i) {
                var mappedSlideIndex = tabControlIndexes[i];

                $(this).attr({
                  role: 'presentation'
                });

                $(this)
                  .find('button')
                  .first()
                  .attr({
                    role: 'tab',
                    id: 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': i + 1 + ' of ' + numDotGroups,
                    'aria-selected': null,
                    tabindex: '-1'
                  });
              })
              .eq(_.currentSlide)
              .find('button')
              .attr({
                'aria-selected': 'true',
                tabindex: '0'
              })
              .end();
          }

          for (var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++) {
            if (_.options.focusOnChange) {
              _.$slides.eq(i).attr({ tabindex: '0' });
            } else {
              _.$slides.eq(i).removeAttr('tabindex');
            }
          }

          _.activateADA();
        };

        Slick.prototype.initArrowEvents = function () {
          var _ = this;

          if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.off('click.slick').on(
              'click.slick',
              {
                message: 'previous'
              },
              _.changeSlide
            );
            _.$nextArrow.off('click.slick').on(
              'click.slick',
              {
                message: 'next'
              },
              _.changeSlide
            );

            if (_.options.accessibility === true) {
              _.$prevArrow.on('keydown.slick', _.keyHandler);
              _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
          }
        };

        Slick.prototype.initDotEvents = function () {
          var _ = this;

          if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on(
              'click.slick',
              {
                message: 'index'
              },
              _.changeSlide
            );

            if (_.options.accessibility === true) {
              _.$dots.on('keydown.slick', _.keyHandler);
            }
          }

          if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots)
              .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
              .on('mouseleave.slick', $.proxy(_.interrupt, _, false));
          }
        };

        Slick.prototype.initSlideEvents = function () {
          var _ = this;

          if (_.options.pauseOnHover) {
            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
          }
        };

        Slick.prototype.initializeEvents = function () {
          var _ = this;

          _.initArrowEvents();

          _.initDotEvents();
          _.initSlideEvents();

          _.$list.on(
            'touchstart.slick mousedown.slick',
            {
              action: 'start'
            },
            _.swipeHandler
          );
          _.$list.on(
            'touchmove.slick mousemove.slick',
            {
              action: 'move'
            },
            _.swipeHandler
          );
          _.$list.on(
            'touchend.slick mouseup.slick',
            {
              action: 'end'
            },
            _.swipeHandler
          );
          _.$list.on(
            'touchcancel.slick mouseleave.slick',
            {
              action: 'end'
            },
            _.swipeHandler
          );

          _.$list.on('click.slick', _.clickHandler);

          $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

          if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
          }

          if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
          }

          $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

          $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

          $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

          $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
          $(_.setPosition);
        };

        Slick.prototype.initUI = function () {
          var _ = this;

          if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.show();
            _.$nextArrow.show();
          }

          if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            _.$dots.show();
          }
        };

        Slick.prototype.keyHandler = function (event) {
          var _ = this;
          //Dont slide if the cursor is inside the form fields and arrow keys are pressed
          if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
              _.changeSlide({
                data: {
                  message: _.options.rtl === true ? 'next' : 'previous'
                }
              });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
              _.changeSlide({
                data: {
                  message: _.options.rtl === true ? 'previous' : 'next'
                }
              });
            }
          }
        };

        Slick.prototype.lazyLoad = function () {
          var _ = this,
            loadRange,
            cloneRange,
            rangeStart,
            rangeEnd;

          function loadImages(imagesScope) {
            $('img[data-lazy]', imagesScope).each(function () {
              var image = $(this),
                imageSource = $(this).attr('data-lazy'),
                imageSrcSet = $(this).attr('data-srcset'),
                imageSizes = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                imageToLoad = document.createElement('img');

              imageToLoad.onload = function () {
                image.animate({ opacity: 0 }, 100, function () {
                  if (imageSrcSet) {
                    image.attr('srcset', imageSrcSet);

                    if (imageSizes) {
                      image.attr('sizes', imageSizes);
                    }
                  }

                  image.attr('src', imageSource).animate({ opacity: 1 }, 200, function () {
                    image.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
                  });
                  _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                });
              };

              imageToLoad.onerror = function () {
                image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');

                _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
              };

              imageToLoad.src = imageSource;
            });
          }

          if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
              rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
              rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
              rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
              rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
          } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
              if (rangeStart > 0) rangeStart--;
              if (rangeEnd <= _.slideCount) rangeEnd++;
            }
          }

          loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

          if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1,
              nextSlide = rangeEnd,
              $slides = _.$slider.find('.slick-slide');

            for (var i = 0; i < _.options.slidesToScroll; i++) {
              if (prevSlide < 0) prevSlide = _.slideCount - 1;
              loadRange = loadRange.add($slides.eq(prevSlide));
              loadRange = loadRange.add($slides.eq(nextSlide));
              prevSlide--;
              nextSlide++;
            }
          }

          loadImages(loadRange);

          if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
          } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
          } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
          }
        };

        Slick.prototype.loadSlider = function () {
          var _ = this;

          _.setPosition();

          _.$slideTrack.css({
            opacity: 1
          });

          _.$slider.removeClass('slick-loading');

          _.initUI();

          if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
          }
        };

        Slick.prototype.next = Slick.prototype.slickNext = function () {
          var _ = this;

          _.changeSlide({
            data: {
              message: 'next'
            }
          });
        };

        Slick.prototype.orientationChange = function () {
          var _ = this;

          _.checkResponsive();
          _.setPosition();
        };

        Slick.prototype.pause = Slick.prototype.slickPause = function () {
          var _ = this;

          _.autoPlayClear();
          _.paused = true;
        };

        Slick.prototype.play = Slick.prototype.slickPlay = function () {
          var _ = this;

          _.autoPlay();
          _.options.autoplay = true;
          _.paused = false;
          _.focussed = false;
          _.interrupted = false;
        };

        Slick.prototype.postSlide = function (index) {
          var _ = this;

          if (!_.unslicked) {
            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            if (_.slideCount > _.options.slidesToShow) {
              _.setPosition();
            }

            _.swipeLeft = null;

            if (_.options.autoplay) {
              _.autoPlay();
            }

            if (_.options.accessibility === true) {
              _.initADA();

              if (_.options.focusOnChange) {
                var $currentSlide = $(_.$slides.get(_.currentSlide));
                $currentSlide.attr('tabindex', 0).focus();
              }
            }
          }
        };

        Slick.prototype.prev = Slick.prototype.slickPrev = function () {
          var _ = this;

          _.changeSlide({
            data: {
              message: 'previous'
            }
          });
        };

        Slick.prototype.preventDefault = function (event) {
          event.preventDefault();
        };

        Slick.prototype.progressiveLazyLoad = function (tryCount) {
          tryCount = tryCount || 1;

          var _ = this,
            $imgsToLoad = $('img[data-lazy]', _.$slider),
            image,
            imageSource,
            imageSrcSet,
            imageSizes,
            imageToLoad;

          if ($imgsToLoad.length) {
            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function () {
              if (imageSrcSet) {
                image.attr('srcset', imageSrcSet);

                if (imageSizes) {
                  image.attr('sizes', imageSizes);
                }
              }

              image
                .attr('src', imageSource)
                .removeAttr('data-lazy data-srcset data-sizes')
                .removeClass('slick-loading');

              if (_.options.adaptiveHeight === true) {
                _.setPosition();
              }

              _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
              _.progressiveLazyLoad();
            };

            imageToLoad.onerror = function () {
              if (tryCount < 3) {
                /**
                 * try to load the image 3 times,
                 * leave a slight delay so we don't get
                 * servers blocking the request.
                 */
                setTimeout(function () {
                  _.progressiveLazyLoad(tryCount + 1);
                }, 500);
              } else {
                image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');

                _.$slider.trigger('lazyLoadError', [_, image, imageSource]);

                _.progressiveLazyLoad();
              }
            };

            imageToLoad.src = imageSource;
          } else {
            _.$slider.trigger('allImagesLoaded', [_]);
          }
        };

        Slick.prototype.refresh = function (initializing) {
          var _ = this,
            currentSlide,
            lastVisibleIndex;

          lastVisibleIndex = _.slideCount - _.options.slidesToShow;

          // in non-infinite sliders, we don't want to go past the
          // last visible index.
          if (!_.options.infinite && _.currentSlide > lastVisibleIndex) {
            _.currentSlide = lastVisibleIndex;
          }

          // if less slides than to show, go to start.
          if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
          }

          currentSlide = _.currentSlide;

          _.destroy(true);

          $.extend(_, _.initials, { currentSlide: currentSlide });

          _.init();

          if (!initializing) {
            _.changeSlide(
              {
                data: {
                  message: 'index',
                  index: currentSlide
                }
              },
              false
            );
          }
        };

        Slick.prototype.registerBreakpoints = function () {
          var _ = this,
            breakpoint,
            currentBreakpoint,
            l,
            responsiveSettings = _.options.responsive || null;

          if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {
            _.respondTo = _.options.respondTo || 'window';

            for (breakpoint in responsiveSettings) {
              l = _.breakpoints.length - 1;

              if (responsiveSettings.hasOwnProperty(breakpoint)) {
                currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                // loop through the breakpoints and cut out any existing
                // ones with the same breakpoint number, we don't want dupes.
                while (l >= 0) {
                  if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
                    _.breakpoints.splice(l, 1);
                  }
                  l--;
                }

                _.breakpoints.push(currentBreakpoint);
                _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
              }
            }

            _.breakpoints.sort(function (a, b) {
              return _.options.mobileFirst ? a - b : b - a;
            });
          }
        };

        Slick.prototype.reinit = function () {
          var _ = this;

          _.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');

          _.slideCount = _.$slides.length;

          if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
          }

          if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
          }

          _.registerBreakpoints();

          _.setProps();
          _.setupInfinite();
          _.buildArrows();
          _.updateArrows();
          _.initArrowEvents();
          _.buildDots();
          _.updateDots();
          _.initDotEvents();
          _.cleanUpSlideEvents();
          _.initSlideEvents();

          _.checkResponsive(false, true);

          if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
          }

          _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

          _.setPosition();
          _.focusHandler();

          _.paused = !_.options.autoplay;
          _.autoPlay();

          _.$slider.trigger('reInit', [_]);
        };

        Slick.prototype.resize = function () {
          var _ = this;

          if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function () {
              _.windowWidth = $(window).width();
              _.checkResponsive();
              if (!_.unslicked) {
                _.setPosition();
              }
            }, 50);
          }
        };

        Slick.prototype.removeSlide = Slick.prototype.slickRemove = function (index, removeBefore, removeAll) {
          var _ = this;

          if (typeof index === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
          } else {
            index = removeBefore === true ? --index : index;
          }

          if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
          }

          _.unload();

          if (removeAll === true) {
            _.$slideTrack.children().remove();
          } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
          }

          _.$slides = _.$slideTrack.children(this.options.slide);

          _.$slideTrack.children(this.options.slide).detach();

          _.$slideTrack.append(_.$slides);

          _.$slidesCache = _.$slides;

          _.reinit();
        };

        Slick.prototype.setCSS = function (position) {
          var _ = this,
            positionProps = {},
            x,
            y;

          if (_.options.rtl === true) {
            position = -position;
          }
          x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
          y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

          positionProps[_.positionProp] = position;

          if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
          } else {
            positionProps = {};
            if (_.cssTransitions === false) {
              positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
              _.$slideTrack.css(positionProps);
            } else {
              positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
              _.$slideTrack.css(positionProps);
            }
          }
        };

        Slick.prototype.setDimensions = function () {
          var _ = this;

          if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
              _.$list.css({
                padding: '0px ' + _.options.centerPadding
              });
            }
          } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
              _.$list.css({
                padding: _.options.centerPadding + ' 0px'
              });
            }
          }

          _.listWidth = _.$list.width();
          _.listHeight = _.$list.height();

          if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children('.slick-slide').length));
          } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
          } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(
              Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)
            );
          }

          var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
          if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
        };

        Slick.prototype.setFade = function () {
          var _ = this,
            targetLeft;

          _.$slides.each(function (index, element) {
            targetLeft = _.slideWidth * index * -1;
            if (_.options.rtl === true) {
              $(element).css({
                position: 'relative',
                right: targetLeft,
                top: 0,
                zIndex: _.options.zIndex - 2,
                opacity: 0
              });
            } else {
              $(element).css({
                position: 'relative',
                left: targetLeft,
                top: 0,
                zIndex: _.options.zIndex - 2,
                opacity: 0
              });
            }
          });

          _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
          });
        };

        Slick.prototype.setHeight = function () {
          var _ = this;

          if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
          }
        };

        Slick.prototype.setOption = Slick.prototype.slickSetOption = function () {
          /**
           * accepts arguments in format of:
           *
           *  - for changing a single option's value:
           *     .slick("setOption", option, value, refresh )
           *
           *  - for changing a set of responsive options:
           *     .slick("setOption", 'responsive', [{}, ...], refresh )
           *
           *  - for updating multiple values at once (not responsive)
           *     .slick("setOption", { 'option': value, ... }, refresh )
           */

          var _ = this,
            l,
            item,
            option,
            value,
            refresh = false,
            type;

          if ($.type(arguments[0]) === 'object') {
            option = arguments[0];
            refresh = arguments[1];
            type = 'multiple';
          } else if ($.type(arguments[0]) === 'string') {
            option = arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') {
              type = 'responsive';
            } else if (typeof arguments[1] !== 'undefined') {
              type = 'single';
            }
          }

          if (type === 'single') {
            _.options[option] = value;
          } else if (type === 'multiple') {
            $.each(option, function (opt, val) {
              _.options[opt] = val;
            });
          } else if (type === 'responsive') {
            for (item in value) {
              if ($.type(_.options.responsive) !== 'array') {
                _.options.responsive = [value[item]];
              } else {
                l = _.options.responsive.length - 1;

                // loop through the responsive object and splice out duplicates.
                while (l >= 0) {
                  if (_.options.responsive[l].breakpoint === value[item].breakpoint) {
                    _.options.responsive.splice(l, 1);
                  }

                  l--;
                }

                _.options.responsive.push(value[item]);
              }
            }
          }

          if (refresh) {
            _.unload();
            _.reinit();
          }
        };

        Slick.prototype.setPosition = function () {
          var _ = this;

          _.setDimensions();

          _.setHeight();

          if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
          } else {
            _.setFade();
          }

          _.$slider.trigger('setPosition', [_]);
        };

        Slick.prototype.setProps = function () {
          var _ = this,
            bodyStyle = document.body.style;

          _.positionProp = _.options.vertical === true ? 'top' : 'left';

          if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
          } else {
            _.$slider.removeClass('slick-vertical');
          }

          if (
            bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined
          ) {
            if (_.options.useCSS === true) {
              _.cssTransitions = true;
            }
          }

          if (_.options.fade) {
            if (typeof _.options.zIndex === 'number') {
              if (_.options.zIndex < 3) {
                _.options.zIndex = 3;
              }
            } else {
              _.options.zIndex = _.defaults.zIndex;
            }
          }

          if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined)
              _.animType = false;
          }
          if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined)
              _.animType = false;
          }
          if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined)
              _.animType = false;
          }
          if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
          }
          if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
          }
          _.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
        };

        Slick.prototype.setSlideClasses = function (index) {
          var _ = this,
            centerOffset,
            allSlides,
            indexOffset,
            remainder;

          allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true');

          _.$slides.eq(index).addClass('slick-current');

          if (_.options.centerMode === true) {
            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {
              if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) {
                _.$slides
                  .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
                  .addClass('slick-active')
                  .attr('aria-hidden', 'false');
              } else {
                indexOffset = _.options.slidesToShow + index;
                allSlides
                  .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
                  .addClass('slick-active')
                  .attr('aria-hidden', 'false');
              }

              if (index === 0) {
                allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass('slick-center');
              } else if (index === _.slideCount - 1) {
                allSlides.eq(_.options.slidesToShow).addClass('slick-center');
              }
            }

            _.$slides.eq(index).addClass('slick-center');
          } else {
            if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) {
              _.$slides
                .slice(index, index + _.options.slidesToShow)
                .addClass('slick-active')
                .attr('aria-hidden', 'false');
            } else if (allSlides.length <= _.options.slidesToShow) {
              allSlides.addClass('slick-active').attr('aria-hidden', 'false');
            } else {
              remainder = _.slideCount % _.options.slidesToShow;
              indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

              if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) {
                allSlides
                  .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                  .addClass('slick-active')
                  .attr('aria-hidden', 'false');
              } else {
                allSlides
                  .slice(indexOffset, indexOffset + _.options.slidesToShow)
                  .addClass('slick-active')
                  .attr('aria-hidden', 'false');
              }
            }
          }

          if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
            _.lazyLoad();
          }
        };

        Slick.prototype.setupInfinite = function () {
          var _ = this,
            i,
            slideIndex,
            infiniteCount;

          if (_.options.fade === true) {
            _.options.centerMode = false;
          }

          if (_.options.infinite === true && _.options.fade === false) {
            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {
              if (_.options.centerMode === true) {
                infiniteCount = _.options.slidesToShow + 1;
              } else {
                infiniteCount = _.options.slidesToShow;
              }

              for (i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1) {
                slideIndex = i - 1;
                $(_.$slides[slideIndex])
                  .clone(true)
                  .attr('id', '')
                  .attr('data-slick-index', slideIndex - _.slideCount)
                  .prependTo(_.$slideTrack)
                  .addClass('slick-cloned');
              }
              for (i = 0; i < infiniteCount + _.slideCount; i += 1) {
                slideIndex = i;
                $(_.$slides[slideIndex])
                  .clone(true)
                  .attr('id', '')
                  .attr('data-slick-index', slideIndex + _.slideCount)
                  .appendTo(_.$slideTrack)
                  .addClass('slick-cloned');
              }
              _.$slideTrack
                .find('.slick-cloned')
                .find('[id]')
                .each(function () {
                  $(this).attr('id', '');
                });
            }
          }
        };

        Slick.prototype.interrupt = function (toggle) {
          var _ = this;

          if (!toggle) {
            _.autoPlay();
          }
          _.interrupted = toggle;
        };

        Slick.prototype.selectHandler = function (event) {
          var _ = this;

          var targetElement = $(event.target).is('.slick-slide')
            ? $(event.target)
            : $(event.target).parents('.slick-slide');

          var index = parseInt(targetElement.attr('data-slick-index'));

          if (!index) index = 0;

          if (_.slideCount <= _.options.slidesToShow) {
            _.slideHandler(index, false, true);
            return;
          }

          _.slideHandler(index);
        };

        Slick.prototype.slideHandler = function (index, sync, dontAnimate) {
          var targetSlide,
            animSlide,
            oldSlide,
            slideLeft,
            targetLeft = null,
            _ = this,
            navTarget;

          sync = sync || false;

          if (_.animating === true && _.options.waitForAnimate === true) {
            return;
          }

          if (_.options.fade === true && _.currentSlide === index) {
            return;
          }

          if (sync === false) {
            _.asNavFor(index);
          }

          targetSlide = index;
          targetLeft = _.getLeft(targetSlide);
          slideLeft = _.getLeft(_.currentSlide);

          _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

          if (
            _.options.infinite === false &&
            _.options.centerMode === false &&
            (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)
          ) {
            if (_.options.fade === false) {
              targetSlide = _.currentSlide;
              if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                _.animateSlide(slideLeft, function () {
                  _.postSlide(targetSlide);
                });
              } else {
                _.postSlide(targetSlide);
              }
            }
            return;
          } else if (
            _.options.infinite === false &&
            _.options.centerMode === true &&
            (index < 0 || index > _.slideCount - _.options.slidesToScroll)
          ) {
            if (_.options.fade === false) {
              targetSlide = _.currentSlide;
              if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                _.animateSlide(slideLeft, function () {
                  _.postSlide(targetSlide);
                });
              } else {
                _.postSlide(targetSlide);
              }
            }
            return;
          }

          if (_.options.autoplay) {
            clearInterval(_.autoPlayTimer);
          }

          if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
              animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
              animSlide = _.slideCount + targetSlide;
            }
          } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
              animSlide = 0;
            } else {
              animSlide = targetSlide - _.slideCount;
            }
          } else {
            animSlide = targetSlide;
          }

          _.animating = true;

          _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

          oldSlide = _.currentSlide;
          _.currentSlide = animSlide;

          _.setSlideClasses(_.currentSlide);

          if (_.options.asNavFor) {
            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if (navTarget.slideCount <= navTarget.options.slidesToShow) {
              navTarget.setSlideClasses(_.currentSlide);
            }
          }

          _.updateDots();
          _.updateArrows();

          if (_.options.fade === true) {
            if (dontAnimate !== true) {
              _.fadeSlideOut(oldSlide);

              _.fadeSlide(animSlide, function () {
                _.postSlide(animSlide);
              });
            } else {
              _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
          }

          if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
            _.animateSlide(targetLeft, function () {
              _.postSlide(animSlide);
            });
          } else {
            _.postSlide(animSlide);
          }
        };

        Slick.prototype.startLoad = function () {
          var _ = this;

          if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.hide();
            _.$nextArrow.hide();
          }

          if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            _.$dots.hide();
          }

          _.$slider.addClass('slick-loading');
        };

        Slick.prototype.swipeDirection = function () {
          var xDist,
            yDist,
            r,
            swipeAngle,
            _ = this;

          xDist = _.touchObject.startX - _.touchObject.curX;
          yDist = _.touchObject.startY - _.touchObject.curY;
          r = Math.atan2(yDist, xDist);

          swipeAngle = Math.round((r * 180) / Math.PI);
          if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
          }

          if (swipeAngle <= 45 && swipeAngle >= 0) {
            return _.options.rtl === false ? 'left' : 'right';
          }
          if (swipeAngle <= 360 && swipeAngle >= 315) {
            return _.options.rtl === false ? 'left' : 'right';
          }
          if (swipeAngle >= 135 && swipeAngle <= 225) {
            return _.options.rtl === false ? 'right' : 'left';
          }
          if (_.options.verticalSwiping === true) {
            if (swipeAngle >= 35 && swipeAngle <= 135) {
              return 'down';
            } else {
              return 'up';
            }
          }

          return 'vertical';
        };

        Slick.prototype.swipeEnd = function (event) {
          var _ = this,
            slideCount,
            direction;

          _.dragging = false;
          _.swiping = false;

          if (_.scrolling) {
            _.scrolling = false;
            return false;
          }

          _.interrupted = false;
          _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;

          if (_.touchObject.curX === undefined) {
            return false;
          }

          if (_.touchObject.edgeHit === true) {
            _.$slider.trigger('edge', [_, _.swipeDirection()]);
          }

          if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {
            direction = _.swipeDirection();

            switch (direction) {
              case 'left':
              case 'down':
                slideCount = _.options.swipeToSlide
                  ? _.checkNavigable(_.currentSlide + _.getSlideCount())
                  : _.currentSlide + _.getSlideCount();

                _.currentDirection = 0;

                break;

              case 'right':
              case 'up':
                slideCount = _.options.swipeToSlide
                  ? _.checkNavigable(_.currentSlide - _.getSlideCount())
                  : _.currentSlide - _.getSlideCount();

                _.currentDirection = 1;

                break;

              default:
            }

            if (direction != 'vertical') {
              _.slideHandler(slideCount);
              _.touchObject = {};
              _.$slider.trigger('swipe', [_, direction]);
            }
          } else {
            if (_.touchObject.startX !== _.touchObject.curX) {
              _.slideHandler(_.currentSlide);
              _.touchObject = {};
            }
          }
        };

        Slick.prototype.swipeHandler = function (event) {
          var _ = this;

          if (_.options.swipe === false || ('ontouchend' in document && _.options.swipe === false)) {
            return;
          } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
          }

          _.touchObject.fingerCount =
            event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;

          _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;

          if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
          }

          switch (event.data.action) {
            case 'start':
              _.swipeStart(event);
              break;

            case 'move':
              _.swipeMove(event);
              break;

            case 'end':
              _.swipeEnd(event);
              break;
          }
        };

        Slick.prototype.swipeMove = function (event) {
          var _ = this,
            edgeWasHit = false,
            curLeft,
            swipeDirection,
            swipeLength,
            positionOffset,
            touches,
            verticalSwipeLength;

          touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

          if (!_.dragging || _.scrolling || (touches && touches.length !== 1)) {
            return false;
          }

          curLeft = _.getLeft(_.currentSlide);

          _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
          _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

          _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

          verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

          if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
          }

          if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = verticalSwipeLength;
          }

          swipeDirection = _.swipeDirection();

          if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
          }

          positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
          if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
          }

          swipeLength = _.touchObject.swipeLength;

          _.touchObject.edgeHit = false;

          if (_.options.infinite === false) {
            if (
              (_.currentSlide === 0 && swipeDirection === 'right') ||
              (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')
            ) {
              swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
              _.touchObject.edgeHit = true;
            }
          }

          if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
          } else {
            _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
          }
          if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
          }

          if (_.options.fade === true || _.options.touchMove === false) {
            return false;
          }

          if (_.animating === true) {
            _.swipeLeft = null;
            return false;
          }

          _.setCSS(_.swipeLeft);
        };

        Slick.prototype.swipeStart = function (event) {
          var _ = this,
            touches;

          _.interrupted = true;

          if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
          }

          if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
          }

          _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
          _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

          _.dragging = true;
        };

        Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function () {
          var _ = this;

          if (_.$slidesCache !== null) {
            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();
          }
        };

        Slick.prototype.unload = function () {
          var _ = this;

          $('.slick-cloned', _.$slider).remove();

          if (_.$dots) {
            _.$dots.remove();
          }

          if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
          }

          if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
          }

          _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');
        };

        Slick.prototype.unslick = function (fromBreakpoint) {
          var _ = this;
          _.$slider.trigger('unslick', [_, fromBreakpoint]);
          _.destroy();
        };

        Slick.prototype.updateArrows = function () {
          var _ = this,
            centerOffset;

          centerOffset = Math.floor(_.options.slidesToShow / 2);

          if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {
            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {
              _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
              _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
              _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
              _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
              _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
              _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            }
          }
        };

        Slick.prototype.updateDots = function () {
          var _ = this;

          if (_.$dots !== null) {
            _.$dots.find('li').removeClass('slick-active').end();

            _.$dots
              .find('li')
              .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
              .addClass('slick-active');
          }
        };

        Slick.prototype.visibility = function () {
          var _ = this;

          if (_.options.autoplay) {
            if (document[_.hidden]) {
              _.interrupted = true;
            } else {
              _.interrupted = false;
            }
          }
        };

        $.fn.slick = function () {
          var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
          for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined') _[i].slick = new Slick(_[i], opt);
            else ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
          }
          return _;
        };
      });

      /***/
    },
    /* 413 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true
      });

      var _extends2 = __webpack_require__(58);

      var _extends3 = _interopRequireDefault(_extends2);

      var _classCallCheck2 = __webpack_require__(10);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(11);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _log = __webpack_require__(36);

      var _log2 = _interopRequireDefault(_log);

      var _jquery = __webpack_require__(116);

      var _jquery2 = _interopRequireDefault(_jquery);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      // This component is just for updating the cart text on the pdp
      // Add to cart functionality is controlled by original-theme.js - ES 07/11/2021

      var UpdateCart = (function () {
        function UpdateCart(theme, elem) {
          (0, _classCallCheck3.default)(this, UpdateCart);

          this._theme = theme;
          this._elem = elem;
          this._settings = (0, _extends3.default)(
            {
              type: 'add'
            },
            JSON.parse(elem.getAttribute('data-update-cart') || '{}')
          );

          // _log2.default.debug(this.constructor.name, 'Constructed', this);
        }

        (0, _createClass3.default)(UpdateCart, [
          {
            key: 'onInit',
            value: function onInit() {
              this._cartWatch();
              // DEV NOTE:
              // i have left the code below and only commented it out as i was unsure
              // if removing it would contain breaking changes, though i don't believe
              // it is required now.

              // const cartTotalContainer = document.querySelector('.product-half__icons-cart-total-container')

              // if (cartTotalContainer) {
              //     this._updateCart(cartTotalContainer)
              // }
            }

            // _updateCart(container) {
            //     const cartTotal = container.querySelector('.product-half__cart-total')

            //     this._elem.addEventListener('click', () => {
            //         if (this._settings.type === 'add') {
            //             const newTotal = parseInt(cartTotal.innerHTML) + 1
            //             cartTotal.innerHTML = newTotal
            //         }
            //     })
            // }
          },
          {
            key: '_cartWatch',
            value: function _cartWatch() {
              var cart = document.querySelector('.cart');
              var count = document.querySelector('#cart-count');
              var cartTotal = document.querySelector('.product-half__cart-total');
              var smile = document.querySelector('.product-half__cart-total-smile');
              var observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                  if (mutation.addedNodes.length) {
                    var newCount = count.textContent;
                    cartTotal.textContent = newCount;
                    if (newCount > 0) {
                      smile.textContent = ':)';
                      smile.style.display = 'inline-block';
                    } else {
                      smile.textContent = ':(';
                      smile.style.display = 'inline-block';
                    }
                  }
                });
              });
              observer.observe(cart, {
                childList: true,
                subtree: true
              });
            }
          }
        ]);
        return UpdateCart;
      })();

      exports.default = UpdateCart;

      /***/
    },
    /* 414 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true
      });

      var _regenerator = __webpack_require__(415);

      var _regenerator2 = _interopRequireDefault(_regenerator);

      var _asyncToGenerator2 = __webpack_require__(417);

      var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

      var _extends2 = __webpack_require__(58);

      var _extends3 = _interopRequireDefault(_extends2);

      var _classCallCheck2 = __webpack_require__(10);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(11);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _log = __webpack_require__(36);

      var _log2 = _interopRequireDefault(_log);

      var _axios = __webpack_require__(430);

      var _axios2 = _interopRequireDefault(_axios);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var LoadMore = (function () {
        function LoadMore(theme, elem) {
          (0, _classCallCheck3.default)(this, LoadMore);

          this._theme = theme;
          this._elem = elem;
          this._data = (0, _extends3.default)(
            {
              gridClass: '',
              productClass: '',
              nextPage: ''
            },
            JSON.parse(elem.getAttribute('data-load-more') || '{}')
          );

          // _log2.default.debug(this.constructor.name, 'Constructed', this);
        }

        (0, _createClass3.default)(LoadMore, [
          {
            key: 'onInit',
            value: function onInit() {
              this._attachEvent(this._elem);
            }
          },
          {
            key: '_attachEvent',
            value: function _attachEvent(elem) {
              var _this = this;

              var productsClass = this._data.productClass;
              var nextPageUrl = JSON.parse(elem.getAttribute('data-load-more')).nextPage;

              elem.addEventListener('click', function () {
                console.log('init loadmore');
                console.log(nextPageUrl);
                _this._loadMore(nextPageUrl, productsClass);
              });
            }
          },
          {
            key: '_loadMore',
            value: (function () {
              var _ref = (0, _asyncToGenerator3.default)(
                /*#__PURE__*/ _regenerator2.default.mark(function _callee(nextUrl, productsClass) {
                  var buttonwrapper, btn, response, newElementsWrapper, newMoreButton, newElements;
                  return _regenerator2.default.wrap(
                    function _callee$(_context) {
                      while (1) {
                        switch ((_context.prev = _context.next)) {
                          case 0:
                            buttonwrapper = document.querySelector('.load-more-wrapper');

                            if (buttonwrapper) {
                              buttonwrapper.classList.add('loading');
                              btn = buttonwrapper.querySelector('button span');

                              if (btn) {
                                btn.textContent = 'Loading...';
                              }
                            }

                            _context.next = 4;
                            return _axios2.default.get(nextUrl);

                          case 4:
                            response = _context.sent;

                            if (response.status === 200) {
                              // get new elements from response data
                              newElementsWrapper = document.createElement('div');

                              newElementsWrapper.innerHTML = response.data;
                              newMoreButton = newElementsWrapper.querySelector('[data-load-more]');
                              newElements = newElementsWrapper.querySelectorAll(productsClass);

                              // update next page url

                              this._updateNextPageUrl(newMoreButton);

                              // add new elements to page
                              this._addNewElements(newElements, nextUrl);
                            }

                          case 6:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    },
                    _callee,
                    this
                  );
                })
              );

              function _loadMore(_x, _x2) {
                return _ref.apply(this, arguments);
              }

              return _loadMore;
            })()
          },
          {
            key: '_updateNextPageUrl',
            value: function _updateNextPageUrl(newMoreButton) {
              document.querySelector('.load-more-wrapper').classList.remove('loading');
              if (newMoreButton) {
                document.querySelector('.load-more-wrapper').innerHTML = '';
                document.querySelector('.load-more-wrapper').appendChild(newMoreButton);
                this._attachEvent(newMoreButton);
              } else {
                document.querySelector('.load-more-wrapper').remove();
              }
            }
          },
          {
            key: '_addNewElements',
            value: function _addNewElements(els, url) {
              for (var i = 0; i < els.length; i++) {
                els[i].setAttribute('data-page', url);
                document.querySelector(this._data.gridClass).appendChild(els[i]);
              }
            }
          }
        ]);
        return LoadMore;
      })();

      exports.default = LoadMore;

      /***/
    },
    /* 415 */
    /***/ function (module, exports, __webpack_require__) {
      module.exports = __webpack_require__(416);

      /***/
    },
    /* 416 */
    /***/ function (module, exports, __webpack_require__) {
      /**
       * Copyright (c) 2014-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      // This method of obtaining a reference to the global object needs to be
      // kept identical to the way it is obtained in runtime.js
      var g =
        (function () {
          return this;
        })() || Function('return this')();

      // Use `getOwnPropertyNames` because not all browsers support calling
      // `hasOwnProperty` on the global `self` object in a worker. See #183.
      var hadRuntime = g.regeneratorRuntime && Object.getOwnPropertyNames(g).indexOf('regeneratorRuntime') >= 0;

      // Save the old regeneratorRuntime in case it needs to be restored later.
      var oldRuntime = hadRuntime && g.regeneratorRuntime;

      // Force reevalutation of runtime.js.
      g.regeneratorRuntime = undefined;

      module.exports = __webpack_require__(149);

      if (hadRuntime) {
        // Restore the original runtime.
        g.regeneratorRuntime = oldRuntime;
      } else {
        // Remove the global property added by runtime.js.
        try {
          delete g.regeneratorRuntime;
        } catch (e) {
          g.regeneratorRuntime = undefined;
        }
      }

      /***/
    },
    /* 417 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      exports.__esModule = true;

      var _promise = __webpack_require__(418);

      var _promise2 = _interopRequireDefault(_promise);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      exports.default = function (fn) {
        return function () {
          var gen = fn.apply(this, arguments);
          return new _promise2.default(function (resolve, reject) {
            function step(key, arg) {
              try {
                var info = gen[key](arg);
                var value = info.value;
              } catch (error) {
                reject(error);
                return;
              }

              if (info.done) {
                resolve(value);
              } else {
                return _promise2.default.resolve(value).then(
                  function (value) {
                    step('next', value);
                  },
                  function (err) {
                    step('throw', err);
                  }
                );
              }
            }

            return step('next');
          });
        };
      };

      /***/
    },
    /* 418 */
    /***/ function (module, exports, __webpack_require__) {
      module.exports = { default: __webpack_require__(419), __esModule: true };

      /***/
    },
    /* 419 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(420);
      __webpack_require__(112);
      __webpack_require__(151);
      __webpack_require__(421);
      __webpack_require__(428);
      __webpack_require__(429);
      module.exports = __webpack_require__(21).Promise;

      /***/
    },
    /* 420 */
    /***/ function (module, exports) {
      /***/
    },
    /* 421 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var LIBRARY = __webpack_require__(154);
      var global = __webpack_require__(18);
      var ctx = __webpack_require__(61);
      var classof = __webpack_require__(160);
      var $export = __webpack_require__(34);
      var isObject = __webpack_require__(62);
      var aFunction = __webpack_require__(74);
      var anInstance = __webpack_require__(422);
      var forOf = __webpack_require__(423);
      var speciesConstructor = __webpack_require__(166);
      var task = __webpack_require__(167).set;
      var microtask = __webpack_require__(425)();
      var newPromiseCapabilityModule = __webpack_require__(117);
      var perform = __webpack_require__(168);
      var promiseResolve = __webpack_require__(169);
      var PROMISE = 'Promise';
      var TypeError = global.TypeError;
      var process = global.process;
      var $Promise = global[PROMISE];
      var isNode = classof(process) == 'process';
      var empty = function () {
        /* empty */
      };
      var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
      var newPromiseCapability = (newGenericPromiseCapability = newPromiseCapabilityModule.f);

      var USE_NATIVE = !!(function () {
        try {
          // correct subclassing with @@species support
          var promise = $Promise.resolve(1);
          var FakePromise = ((promise.constructor = {})[__webpack_require__(22)('species')] = function (exec) {
            exec(empty, empty);
          });
          // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
          return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
        } catch (e) {
          /* empty */
        }
      })();

      // helpers
      var isThenable = function (it) {
        var then;
        return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
      };
      var notify = function (promise, isReject) {
        if (promise._n) return;
        promise._n = true;
        var chain = promise._c;
        microtask(function () {
          var value = promise._v;
          var ok = promise._s == 1;
          var i = 0;
          var run = function (reaction) {
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then;
            try {
              if (handler) {
                if (!ok) {
                  if (promise._h == 2) onHandleUnhandled(promise);
                  promise._h = 1;
                }
                if (handler === true) result = value;
                else {
                  if (domain) domain.enter();
                  result = handler(value);
                  if (domain) domain.exit();
                }
                if (result === reaction.promise) {
                  reject(TypeError('Promise-chain cycle'));
                } else if ((then = isThenable(result))) {
                  then.call(result, resolve, reject);
                } else resolve(result);
              } else reject(value);
            } catch (e) {
              reject(e);
            }
          };
          while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
          promise._c = [];
          promise._n = false;
          if (isReject && !promise._h) onUnhandled(promise);
        });
      };
      var onUnhandled = function (promise) {
        task.call(global, function () {
          var value = promise._v;
          var unhandled = isUnhandled(promise);
          var result, handler, console;
          if (unhandled) {
            result = perform(function () {
              if (isNode) {
                process.emit('unhandledRejection', value, promise);
              } else if ((handler = global.onunhandledrejection)) {
                handler({ promise: promise, reason: value });
              } else if ((console = global.console) && console.error) {
                console.error('Unhandled promise rejection', value);
              }
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            promise._h = isNode || isUnhandled(promise) ? 2 : 1;
          }
          promise._a = undefined;
          if (unhandled && result.e) throw result.v;
        });
      };
      var isUnhandled = function (promise) {
        if (promise._h == 1) return false;
        var chain = promise._a || promise._c;
        var i = 0;
        var reaction;
        while (chain.length > i) {
          reaction = chain[i++];
          if (reaction.fail || !isUnhandled(reaction.promise)) return false;
        }
        return true;
      };
      var onHandleUnhandled = function (promise) {
        task.call(global, function () {
          var handler;
          if (isNode) {
            process.emit('rejectionHandled', promise);
          } else if ((handler = global.onrejectionhandled)) {
            handler({ promise: promise, reason: promise._v });
          }
        });
      };
      var $reject = function (value) {
        var promise = this;
        if (promise._d) return;
        promise._d = true;
        promise = promise._w || promise; // unwrap
        promise._v = value;
        promise._s = 2;
        if (!promise._a) promise._a = promise._c.slice();
        notify(promise, true);
      };
      var $resolve = function (value) {
        var promise = this;
        var then;
        if (promise._d) return;
        promise._d = true;
        promise = promise._w || promise; // unwrap
        try {
          if (promise === value) throw TypeError("Promise can't be resolved itself");
          if ((then = isThenable(value))) {
            microtask(function () {
              var wrapper = { _w: promise, _d: false }; // wrap
              try {
                then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
              } catch (e) {
                $reject.call(wrapper, e);
              }
            });
          } else {
            promise._v = value;
            promise._s = 1;
            notify(promise, false);
          }
        } catch (e) {
          $reject.call({ _w: promise, _d: false }, e); // wrap
        }
      };

      // constructor polyfill
      if (!USE_NATIVE) {
        // 25.4.3.1 Promise(executor)
        $Promise = function Promise(executor) {
          anInstance(this, $Promise, PROMISE, '_h');
          aFunction(executor);
          Internal.call(this);
          try {
            executor(ctx($resolve, this, 1), ctx($reject, this, 1));
          } catch (err) {
            $reject.call(this, err);
          }
        };
        // eslint-disable-next-line no-unused-vars
        Internal = function Promise(executor) {
          this._c = []; // <- awaiting reactions
          this._a = undefined; // <- checked in isUnhandled reactions
          this._s = 0; // <- state
          this._d = false; // <- done
          this._v = undefined; // <- value
          this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
          this._n = false; // <- notify
        };
        Internal.prototype = __webpack_require__(426)($Promise.prototype, {
          // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
          then: function then(onFulfilled, onRejected) {
            var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
            reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
            reaction.fail = typeof onRejected == 'function' && onRejected;
            reaction.domain = isNode ? process.domain : undefined;
            this._c.push(reaction);
            if (this._a) this._a.push(reaction);
            if (this._s) notify(this, false);
            return reaction.promise;
          },
          // 25.4.5.1 Promise.prototype.catch(onRejected)
          catch: function (onRejected) {
            return this.then(undefined, onRejected);
          }
        });
        OwnPromiseCapability = function () {
          var promise = new Internal();
          this.promise = promise;
          this.resolve = ctx($resolve, promise, 1);
          this.reject = ctx($reject, promise, 1);
        };
        newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
          return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
        };
      }

      $export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
      __webpack_require__(110)($Promise, PROMISE);
      __webpack_require__(427)(PROMISE);
      Wrapper = __webpack_require__(21)[PROMISE];

      // statics
      $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
        // 25.4.4.5 Promise.reject(r)
        reject: function reject(r) {
          var capability = newPromiseCapability(this);
          var $$reject = capability.reject;
          $$reject(r);
          return capability.promise;
        }
      });
      $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
        // 25.4.4.6 Promise.resolve(x)
        resolve: function resolve(x) {
          return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
        }
      });
      $export(
        $export.S +
          $export.F *
            !(
              USE_NATIVE &&
              __webpack_require__(164)(function (iter) {
                $Promise.all(iter)['catch'](empty);
              })
            ),
        PROMISE,
        {
          // 25.4.4.1 Promise.all(iterable)
          all: function all(iterable) {
            var C = this;
            var capability = newPromiseCapability(C);
            var resolve = capability.resolve;
            var reject = capability.reject;
            var result = perform(function () {
              var values = [];
              var index = 0;
              var remaining = 1;
              forOf(iterable, false, function (promise) {
                var $index = index++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                C.resolve(promise).then(function (value) {
                  if (alreadyCalled) return;
                  alreadyCalled = true;
                  values[$index] = value;
                  --remaining || resolve(values);
                }, reject);
              });
              --remaining || resolve(values);
            });
            if (result.e) reject(result.v);
            return capability.promise;
          },
          // 25.4.4.4 Promise.race(iterable)
          race: function race(iterable) {
            var C = this;
            var capability = newPromiseCapability(C);
            var reject = capability.reject;
            var result = perform(function () {
              forOf(iterable, false, function (promise) {
                C.resolve(promise).then(capability.resolve, reject);
              });
            });
            if (result.e) reject(result.v);
            return capability.promise;
          }
        }
      );

      /***/
    },
    /* 422 */
    /***/ function (module, exports) {
      module.exports = function (it, Constructor, name, forbiddenField) {
        if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
          throw TypeError(name + ': incorrect invocation!');
        }
        return it;
      };

      /***/
    },
    /* 423 */
    /***/ function (module, exports, __webpack_require__) {
      var ctx = __webpack_require__(61);
      var call = __webpack_require__(162);
      var isArrayIter = __webpack_require__(163);
      var anObject = __webpack_require__(35);
      var toLength = __webpack_require__(107);
      var getIterFn = __webpack_require__(113);
      var BREAK = {};
      var RETURN = {};
      var exports = (module.exports = function (iterable, entries, fn, that, ITERATOR) {
        var iterFn = ITERATOR
          ? function () {
              return iterable;
            }
          : getIterFn(iterable);
        var f = ctx(fn, that, entries ? 2 : 1);
        var index = 0;
        var length, step, iterator, result;
        if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
        // fast case for arrays with default iterator
        if (isArrayIter(iterFn))
          for (length = toLength(iterable.length); length > index; index++) {
            result = entries ? f(anObject((step = iterable[index]))[0], step[1]) : f(iterable[index]);
            if (result === BREAK || result === RETURN) return result;
          }
        else
          for (iterator = iterFn.call(iterable); !(step = iterator.next()).done; ) {
            result = call(iterator, f, step.value, entries);
            if (result === BREAK || result === RETURN) return result;
          }
      });
      exports.BREAK = BREAK;
      exports.RETURN = RETURN;

      /***/
    },
    /* 424 */
    /***/ function (module, exports) {
      // fast apply, http://jsperf.lnkit.com/fast-apply/5
      module.exports = function (fn, args, that) {
        var un = that === undefined;
        switch (args.length) {
          case 0:
            return un ? fn() : fn.call(that);
          case 1:
            return un ? fn(args[0]) : fn.call(that, args[0]);
          case 2:
            return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
          case 3:
            return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
          case 4:
            return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
        }
        return fn.apply(that, args);
      };

      /***/
    },
    /* 425 */
    /***/ function (module, exports, __webpack_require__) {
      var global = __webpack_require__(18);
      var macrotask = __webpack_require__(167).set;
      var Observer = global.MutationObserver || global.WebKitMutationObserver;
      var process = global.process;
      var Promise = global.Promise;
      var isNode = __webpack_require__(75)(process) == 'process';

      module.exports = function () {
        var head, last, notify;

        var flush = function () {
          var parent, fn;
          if (isNode && (parent = process.domain)) parent.exit();
          while (head) {
            fn = head.fn;
            head = head.next;
            try {
              fn();
            } catch (e) {
              if (head) notify();
              else last = undefined;
              throw e;
            }
          }
          last = undefined;
          if (parent) parent.enter();
        };

        // Node.js
        if (isNode) {
          notify = function () {
            process.nextTick(flush);
          };
          // browsers with MutationObserver
        } else if (Observer) {
          var toggle = true;
          var node = document.createTextNode('');
          new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
          notify = function () {
            node.data = toggle = !toggle;
          };
          // environments with maybe non-completely correct, but existent Promise
        } else if (Promise && Promise.resolve) {
          var promise = Promise.resolve();
          notify = function () {
            promise.then(flush);
          };
          // for other environments - macrotask based on:
          // - setImmediate
          // - MessageChannel
          // - window.postMessag
          // - onreadystatechange
          // - setTimeout
        } else {
          notify = function () {
            // strange IE + webpack dev server bug - use .call(global)
            macrotask.call(global, flush);
          };
        }

        return function (fn) {
          var task = { fn: fn, next: undefined };
          if (last) last.next = task;
          if (!head) {
            head = task;
            notify();
          }
          last = task;
        };
      };

      /***/
    },
    /* 426 */
    /***/ function (module, exports, __webpack_require__) {
      var hide = __webpack_require__(55);
      module.exports = function (target, src, safe) {
        for (var key in src) {
          if (safe && target[key]) target[key] = src[key];
          else hide(target, key, src[key]);
        }
        return target;
      };

      /***/
    },
    /* 427 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var global = __webpack_require__(18);
      var core = __webpack_require__(21);
      var dP = __webpack_require__(56);
      var DESCRIPTORS = __webpack_require__(57);
      var SPECIES = __webpack_require__(22)('species');

      module.exports = function (KEY) {
        var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
        if (DESCRIPTORS && C && !C[SPECIES])
          dP.f(C, SPECIES, {
            configurable: true,
            get: function () {
              return this;
            }
          });
      };

      /***/
    },
    /* 428 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';
      // https://github.com/tc39/proposal-promise-finally

      var $export = __webpack_require__(34);
      var core = __webpack_require__(21);
      var global = __webpack_require__(18);
      var speciesConstructor = __webpack_require__(166);
      var promiseResolve = __webpack_require__(169);

      $export($export.P + $export.R, 'Promise', {
        finally: function (onFinally) {
          var C = speciesConstructor(this, core.Promise || global.Promise);
          var isFunction = typeof onFinally == 'function';
          return this.then(
            isFunction
              ? function (x) {
                  return promiseResolve(C, onFinally()).then(function () {
                    return x;
                  });
                }
              : onFinally,
            isFunction
              ? function (e) {
                  return promiseResolve(C, onFinally()).then(function () {
                    throw e;
                  });
                }
              : onFinally
          );
        }
      });

      /***/
    },
    /* 429 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // https://github.com/tc39/proposal-promise-try
      var $export = __webpack_require__(34);
      var newPromiseCapability = __webpack_require__(117);
      var perform = __webpack_require__(168);

      $export($export.S, 'Promise', {
        try: function (callbackfn) {
          var promiseCapability = newPromiseCapability.f(this);
          var result = perform(callbackfn);
          (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
          return promiseCapability.promise;
        }
      });

      /***/
    },
    /* 430 */
    /***/ function (module, exports, __webpack_require__) {
      module.exports = __webpack_require__(431);

      /***/
    },
    /* 431 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var utils = __webpack_require__(19);
      var bind = __webpack_require__(170);
      var Axios = __webpack_require__(433);
      var defaults = __webpack_require__(118);

      /**
       * Create an instance of Axios
       *
       * @param {Object} defaultConfig The default config for the instance
       * @return {Axios} A new instance of Axios
       */
      function createInstance(defaultConfig) {
        var context = new Axios(defaultConfig);
        var instance = bind(Axios.prototype.request, context);

        // Copy axios.prototype to instance
        utils.extend(instance, Axios.prototype, context);

        // Copy context to instance
        utils.extend(instance, context);

        return instance;
      }

      // Create the default instance to be exported
      var axios = createInstance(defaults);

      // Expose Axios class to allow class inheritance
      axios.Axios = Axios;

      // Factory for creating new instances
      axios.create = function create(instanceConfig) {
        return createInstance(utils.merge(defaults, instanceConfig));
      };

      // Expose Cancel & CancelToken
      axios.Cancel = __webpack_require__(175);
      axios.CancelToken = __webpack_require__(447);
      axios.isCancel = __webpack_require__(174);

      // Expose all/spread
      axios.all = function all(promises) {
        return Promise.all(promises);
      };
      axios.spread = __webpack_require__(448);

      module.exports = axios;

      // Allow use of default import syntax in TypeScript
      module.exports.default = axios;

      /***/
    },
    /* 432 */
    /***/ function (module, exports) {
      /*!
       * Determine if an object is a Buffer
       *
       * @author   Feross Aboukhadijeh <https://feross.org>
       * @license  MIT
       */

      // The _isBuffer check is for Safari 5-7 support, because it's missing
      // Object.prototype.constructor. Remove this eventually
      module.exports = function (obj) {
        return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
      };

      function isBuffer(obj) {
        return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
      }

      // For Node v0.10 support. Remove this eventually.
      function isSlowBuffer(obj) {
        return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0));
      }

      /***/
    },
    /* 433 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var defaults = __webpack_require__(118);
      var utils = __webpack_require__(19);
      var InterceptorManager = __webpack_require__(442);
      var dispatchRequest = __webpack_require__(443);

      /**
       * Create a new instance of Axios
       *
       * @param {Object} instanceConfig The default config for the instance
       */
      function Axios(instanceConfig) {
        this.defaults = instanceConfig;
        this.interceptors = {
          request: new InterceptorManager(),
          response: new InterceptorManager()
        };
      }

      /**
       * Dispatch a request
       *
       * @param {Object} config The config specific for this request (merged with this.defaults)
       */
      Axios.prototype.request = function request(config) {
        /*eslint no-param-reassign:0*/
        // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof config === 'string') {
          config = utils.merge(
            {
              url: arguments[0]
            },
            arguments[1]
          );
        }

        config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
        config.method = config.method.toLowerCase();

        // Hook up interceptors middleware
        var chain = [dispatchRequest, undefined];
        var promise = Promise.resolve(config);

        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
          chain.unshift(interceptor.fulfilled, interceptor.rejected);
        });

        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
          chain.push(interceptor.fulfilled, interceptor.rejected);
        });

        while (chain.length) {
          promise = promise.then(chain.shift(), chain.shift());
        }

        return promise;
      };

      // Provide aliases for supported request methods
      utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
        /*eslint func-names:0*/
        Axios.prototype[method] = function (url, config) {
          return this.request(
            utils.merge(config || {}, {
              method: method,
              url: url
            })
          );
        };
      });

      utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
        /*eslint func-names:0*/
        Axios.prototype[method] = function (url, data, config) {
          return this.request(
            utils.merge(config || {}, {
              method: method,
              url: url,
              data: data
            })
          );
        };
      });

      module.exports = Axios;

      /***/
    },
    /* 434 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var utils = __webpack_require__(19);

      module.exports = function normalizeHeaderName(headers, normalizedName) {
        utils.forEach(headers, function processHeader(value, name) {
          if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
          }
        });
      };

      /***/
    },
    /* 435 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var createError = __webpack_require__(173);

      /**
       * Resolve or reject a Promise based on response status.
       *
       * @param {Function} resolve A function that resolves the promise.
       * @param {Function} reject A function that rejects the promise.
       * @param {object} response The response.
       */
      module.exports = function settle(resolve, reject, response) {
        var validateStatus = response.config.validateStatus;
        // Note: status is not exposed by XDomainRequest
        if (!response.status || !validateStatus || validateStatus(response.status)) {
          resolve(response);
        } else {
          reject(
            createError(
              'Request failed with status code ' + response.status,
              response.config,
              null,
              response.request,
              response
            )
          );
        }
      };

      /***/
    },
    /* 436 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      /**
       * Update an Error with the specified config, error code, and response.
       *
       * @param {Error} error The error to update.
       * @param {Object} config The config.
       * @param {string} [code] The error code (for example, 'ECONNABORTED').
       * @param {Object} [request] The request.
       * @param {Object} [response] The response.
       * @returns {Error} The error.
       */
      module.exports = function enhanceError(error, config, code, request, response) {
        error.config = config;
        if (code) {
          error.code = code;
        }
        error.request = request;
        error.response = response;
        return error;
      };

      /***/
    },
    /* 437 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var utils = __webpack_require__(19);

      function encode(val) {
        return encodeURIComponent(val)
          .replace(/%40/gi, '@')
          .replace(/%3A/gi, ':')
          .replace(/%24/g, '$')
          .replace(/%2C/gi, ',')
          .replace(/%20/g, '+')
          .replace(/%5B/gi, '[')
          .replace(/%5D/gi, ']');
      }

      /**
       * Build a URL by appending params to the end
       *
       * @param {string} url The base of the url (e.g., http://www.google.com)
       * @param {object} [params] The params to be appended
       * @returns {string} The formatted url
       */
      module.exports = function buildURL(url, params, paramsSerializer) {
        /*eslint no-param-reassign:0*/
        if (!params) {
          return url;
        }

        var serializedParams;
        if (paramsSerializer) {
          serializedParams = paramsSerializer(params);
        } else if (utils.isURLSearchParams(params)) {
          serializedParams = params.toString();
        } else {
          var parts = [];

          utils.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') {
              return;
            }

            if (utils.isArray(val)) {
              key = key + '[]';
            }

            if (!utils.isArray(val)) {
              val = [val];
            }

            utils.forEach(val, function parseValue(v) {
              if (utils.isDate(v)) {
                v = v.toISOString();
              } else if (utils.isObject(v)) {
                v = JSON.stringify(v);
              }
              parts.push(encode(key) + '=' + encode(v));
            });
          });

          serializedParams = parts.join('&');
        }

        if (serializedParams) {
          url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
        }

        return url;
      };

      /***/
    },
    /* 438 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var utils = __webpack_require__(19);

      // Headers whose duplicates are ignored by node
      // c.f. https://nodejs.org/api/http.html#http_message_headers
      var ignoreDuplicateOf = [
        'age',
        'authorization',
        'content-length',
        'content-type',
        'etag',
        'expires',
        'from',
        'host',
        'if-modified-since',
        'if-unmodified-since',
        'last-modified',
        'location',
        'max-forwards',
        'proxy-authorization',
        'referer',
        'retry-after',
        'user-agent'
      ];

      /**
       * Parse headers into an object
       *
       * ```
       * Date: Wed, 27 Aug 2014 08:58:49 GMT
       * Content-Type: application/json
       * Connection: keep-alive
       * Transfer-Encoding: chunked
       * ```
       *
       * @param {String} headers Headers needing to be parsed
       * @returns {Object} Headers parsed into an object
       */
      module.exports = function parseHeaders(headers) {
        var parsed = {};
        var key;
        var val;
        var i;

        if (!headers) {
          return parsed;
        }

        utils.forEach(headers.split('\n'), function parser(line) {
          i = line.indexOf(':');
          key = utils.trim(line.substr(0, i)).toLowerCase();
          val = utils.trim(line.substr(i + 1));

          if (key) {
            if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
              return;
            }
            if (key === 'set-cookie') {
              parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
            } else {
              parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
            }
          }
        });

        return parsed;
      };

      /***/
    },
    /* 439 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var utils = __webpack_require__(19);

      module.exports = utils.isStandardBrowserEnv()
        ? // Standard browser envs have full support of the APIs needed to test
          // whether the request URL is of the same origin as current location.
          (function standardBrowserEnv() {
            var msie = /(msie|trident)/i.test(navigator.userAgent);
            var urlParsingNode = document.createElement('a');
            var originURL;

            /**
             * Parse a URL to discover it's components
             *
             * @param {String} url The URL to be parsed
             * @returns {Object}
             */
            function resolveURL(url) {
              var href = url;

              if (msie) {
                // IE needs attribute set twice to normalize properties
                urlParsingNode.setAttribute('href', href);
                href = urlParsingNode.href;
              }

              urlParsingNode.setAttribute('href', href);

              // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
              return {
                href: urlParsingNode.href,
                protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
                host: urlParsingNode.host,
                search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
                hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
                hostname: urlParsingNode.hostname,
                port: urlParsingNode.port,
                pathname:
                  urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
              };
            }

            originURL = resolveURL(window.location.href);

            /**
             * Determine if a URL shares the same origin as the current location
             *
             * @param {String} requestURL The URL to test
             * @returns {boolean} True if URL shares the same origin, otherwise false
             */
            return function isURLSameOrigin(requestURL) {
              var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
              return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
            };
          })()
        : // Non standard browser envs (web workers, react-native) lack needed support.
          (function nonStandardBrowserEnv() {
            return function isURLSameOrigin() {
              return true;
            };
          })();

      /***/
    },
    /* 440 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      // btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

      var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

      function E() {
        this.message = 'String contains an invalid character';
      }
      E.prototype = new Error();
      E.prototype.code = 5;
      E.prototype.name = 'InvalidCharacterError';

      function btoa(input) {
        var str = String(input);
        var output = '';
        for (
          // initialize result and counter
          var block, charCode, idx = 0, map = chars;
          // if the next str index does not exist:
          //   change the mapping table to "="
          //   check if d has no fractional digits
          str.charAt(idx | 0) || ((map = '='), idx % 1);
          // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
          output += map.charAt(63 & (block >> (8 - (idx % 1) * 8)))
        ) {
          charCode = str.charCodeAt((idx += 3 / 4));
          if (charCode > 0xff) {
            throw new E();
          }
          block = (block << 8) | charCode;
        }
        return output;
      }

      module.exports = btoa;

      /***/
    },
    /* 441 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var utils = __webpack_require__(19);

      module.exports = utils.isStandardBrowserEnv()
        ? // Standard browser envs support document.cookie
          (function standardBrowserEnv() {
            return {
              write: function write(name, value, expires, path, domain, secure) {
                var cookie = [];
                cookie.push(name + '=' + encodeURIComponent(value));

                if (utils.isNumber(expires)) {
                  cookie.push('expires=' + new Date(expires).toGMTString());
                }

                if (utils.isString(path)) {
                  cookie.push('path=' + path);
                }

                if (utils.isString(domain)) {
                  cookie.push('domain=' + domain);
                }

                if (secure === true) {
                  cookie.push('secure');
                }

                document.cookie = cookie.join('; ');
              },

              read: function read(name) {
                var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
                return match ? decodeURIComponent(match[3]) : null;
              },

              remove: function remove(name) {
                this.write(name, '', Date.now() - 86400000);
              }
            };
          })()
        : // Non standard browser env (web workers, react-native) lack needed support.
          (function nonStandardBrowserEnv() {
            return {
              write: function write() {},
              read: function read() {
                return null;
              },
              remove: function remove() {}
            };
          })();

      /***/
    },
    /* 442 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var utils = __webpack_require__(19);

      function InterceptorManager() {
        this.handlers = [];
      }

      /**
       * Add a new interceptor to the stack
       *
       * @param {Function} fulfilled The function to handle `then` for a `Promise`
       * @param {Function} rejected The function to handle `reject` for a `Promise`
       *
       * @return {Number} An ID used to remove interceptor later
       */
      InterceptorManager.prototype.use = function use(fulfilled, rejected) {
        this.handlers.push({
          fulfilled: fulfilled,
          rejected: rejected
        });
        return this.handlers.length - 1;
      };

      /**
       * Remove an interceptor from the stack
       *
       * @param {Number} id The ID that was returned by `use`
       */
      InterceptorManager.prototype.eject = function eject(id) {
        if (this.handlers[id]) {
          this.handlers[id] = null;
        }
      };

      /**
       * Iterate over all the registered interceptors
       *
       * This method is particularly useful for skipping over any
       * interceptors that may have become `null` calling `eject`.
       *
       * @param {Function} fn The function to call for each interceptor
       */
      InterceptorManager.prototype.forEach = function forEach(fn) {
        utils.forEach(this.handlers, function forEachHandler(h) {
          if (h !== null) {
            fn(h);
          }
        });
      };

      module.exports = InterceptorManager;

      /***/
    },
    /* 443 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var utils = __webpack_require__(19);
      var transformData = __webpack_require__(444);
      var isCancel = __webpack_require__(174);
      var defaults = __webpack_require__(118);
      var isAbsoluteURL = __webpack_require__(445);
      var combineURLs = __webpack_require__(446);

      /**
       * Throws a `Cancel` if cancellation has been requested.
       */
      function throwIfCancellationRequested(config) {
        if (config.cancelToken) {
          config.cancelToken.throwIfRequested();
        }
      }

      /**
       * Dispatch a request to the server using the configured adapter.
       *
       * @param {object} config The config that is to be used for the request
       * @returns {Promise} The Promise to be fulfilled
       */
      module.exports = function dispatchRequest(config) {
        throwIfCancellationRequested(config);

        // Support baseURL config
        if (config.baseURL && !isAbsoluteURL(config.url)) {
          config.url = combineURLs(config.baseURL, config.url);
        }

        // Ensure headers exist
        config.headers = config.headers || {};

        // Transform request data
        config.data = transformData(config.data, config.headers, config.transformRequest);

        // Flatten headers
        config.headers = utils.merge(
          config.headers.common || {},
          config.headers[config.method] || {},
          config.headers || {}
        );

        utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
          delete config.headers[method];
        });

        var adapter = config.adapter || defaults.adapter;

        return adapter(config).then(
          function onAdapterResolution(response) {
            throwIfCancellationRequested(config);

            // Transform response data
            response.data = transformData(response.data, response.headers, config.transformResponse);

            return response;
          },
          function onAdapterRejection(reason) {
            if (!isCancel(reason)) {
              throwIfCancellationRequested(config);

              // Transform response data
              if (reason && reason.response) {
                reason.response.data = transformData(
                  reason.response.data,
                  reason.response.headers,
                  config.transformResponse
                );
              }
            }

            return Promise.reject(reason);
          }
        );
      };

      /***/
    },
    /* 444 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var utils = __webpack_require__(19);

      /**
       * Transform the data for a request or a response
       *
       * @param {Object|String} data The data to be transformed
       * @param {Array} headers The headers for the request or response
       * @param {Array|Function} fns A single function or Array of functions
       * @returns {*} The resulting transformed data
       */
      module.exports = function transformData(data, headers, fns) {
        /*eslint no-param-reassign:0*/
        utils.forEach(fns, function transform(fn) {
          data = fn(data, headers);
        });

        return data;
      };

      /***/
    },
    /* 445 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      /**
       * Determines whether the specified URL is absolute
       *
       * @param {string} url The URL to test
       * @returns {boolean} True if the specified URL is absolute, otherwise false
       */
      module.exports = function isAbsoluteURL(url) {
        // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
        // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
        // by any combination of letters, digits, plus, period, or hyphen.
        return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
      };

      /***/
    },
    /* 446 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      /**
       * Creates a new URL by combining the specified URLs
       *
       * @param {string} baseURL The base URL
       * @param {string} relativeURL The relative URL
       * @returns {string} The combined URL
       */
      module.exports = function combineURLs(baseURL, relativeURL) {
        return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
      };

      /***/
    },
    /* 447 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      var Cancel = __webpack_require__(175);

      /**
       * A `CancelToken` is an object that can be used to request cancellation of an operation.
       *
       * @class
       * @param {Function} executor The executor function.
       */
      function CancelToken(executor) {
        if (typeof executor !== 'function') {
          throw new TypeError('executor must be a function.');
        }

        var resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
          resolvePromise = resolve;
        });

        var token = this;
        executor(function cancel(message) {
          if (token.reason) {
            // Cancellation has already been requested
            return;
          }

          token.reason = new Cancel(message);
          resolvePromise(token.reason);
        });
      }

      /**
       * Throws a `Cancel` if cancellation has been requested.
       */
      CancelToken.prototype.throwIfRequested = function throwIfRequested() {
        if (this.reason) {
          throw this.reason;
        }
      };

      /**
       * Returns an object that contains a new `CancelToken` and a function that, when called,
       * cancels the `CancelToken`.
       */
      CancelToken.source = function source() {
        var cancel;
        var token = new CancelToken(function executor(c) {
          cancel = c;
        });
        return {
          token: token,
          cancel: cancel
        };
      };

      module.exports = CancelToken;

      /***/
    },
    /* 448 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      /**
       * Syntactic sugar for invoking a function and expanding an array for arguments.
       *
       * Common use case would be to use `Function.prototype.apply`.
       *
       *  ```js
       *  function f(x, y, z) {}
       *  var args = [1, 2, 3];
       *  f.apply(null, args);
       *  ```
       *
       * With `spread` this example can be re-written.
       *
       *  ```js
       *  spread(function(x, y, z) {})([1, 2, 3]);
       *  ```
       *
       * @param {Function} callback
       * @returns {Function}
       */
      module.exports = function spread(callback) {
        return function wrap(arr) {
          return callback.apply(null, arr);
        };
      };

      /***/
    },
    /* 449 */
    /***/ function (module, exports, __webpack_require__) {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true
      });

      var _classCallCheck2 = __webpack_require__(10);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(11);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _log = __webpack_require__(36);

      var _log2 = _interopRequireDefault(_log);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var ProductInfoAccordion = (function () {
        function ProductInfoAccordion(theme, elem) {
          (0, _classCallCheck3.default)(this, ProductInfoAccordion);

          this._name = this.constructor.name;
          this._theme = theme;

          // _log2.default.debug(this.constructor.name, 'Constructed', this);
          // _log2.default.debug(this._name, 'Initiated', this);
        }

        (0, _createClass3.default)(ProductInfoAccordion, [
          {
            key: 'onInit',
            value: function onInit() {
              this._accordion();
            }
          },
          {
            key: '_accordion',
            value: function _accordion() {
              var headers = document.querySelectorAll('.product-information__accordion .accordion-header');
              headers.forEach(function (header) {
                header.addEventListener('click', function () {
                  headers.forEach(function (remove) {
                    remove.classList.remove('open');
                  });
                  header.classList.add('open');
                  var selection = header.getAttribute('data-tab');
                  var tabs = document.querySelectorAll('.accordion-item .accordion-content');
                  tabs.forEach(function (tab) {
                    tab.style.display = 'none';
                    if (tab.getAttribute('data-content') == selection) {
                      tab.style.display = 'block';
                    }
                  });
                });
              });
            }
          }
        ]);
        return ProductInfoAccordion;
      })();

      exports.default = ProductInfoAccordion;

      /***/
    },
    /* 450 */
    /***/ function (module, exports) {
      /*!
Copyright (C) 2013-2015 by Andrea Giammarchi - @WebReflection

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
      (function (window) {
        'use strict';
        /* jshint loopfunc: true, noempty: false*/
        // http://www.w3.org/TR/dom/#element

        function createDocumentFragment() {
          return document.createDocumentFragment();
        }

        function createElement(nodeName) {
          return document.createElement(nodeName);
        }

        function enoughArguments(length, name) {
          if (!length) throw new Error('Failed to construct ' + name + ': 1 argument required, but only 0 present.');
        }

        function mutationMacro(nodes) {
          if (nodes.length === 1) {
            return textNodeIfString(nodes[0]);
          }
          for (var fragment = createDocumentFragment(), list = slice.call(nodes), i = 0; i < nodes.length; i++) {
            fragment.appendChild(textNodeIfString(list[i]));
          }
          return fragment;
        }

        function textNodeIfString(node) {
          return typeof node === 'string' ? document.createTextNode(node) : node;
        }

        for (
          var head,
            property,
            TemporaryPrototype,
            TemporaryTokenList,
            wrapVerifyToken,
            document = window.document,
            hOP = Object.prototype.hasOwnProperty,
            defineProperty =
              Object.defineProperty ||
              function (object, property, descriptor) {
                if (hOP.call(descriptor, 'value')) {
                  object[property] = descriptor.value;
                } else {
                  if (hOP.call(descriptor, 'get')) object.__defineGetter__(property, descriptor.get);
                  if (hOP.call(descriptor, 'set')) object.__defineSetter__(property, descriptor.set);
                }
                return object;
              },
            indexOf =
              [].indexOf ||
              function indexOf(value) {
                var length = this.length;
                while (length--) {
                  if (this[length] === value) {
                    break;
                  }
                }
                return length;
              },
            // http://www.w3.org/TR/domcore/#domtokenlist
            verifyToken = function (token) {
              if (!token) {
                throw 'SyntaxError';
              } else if (spaces.test(token)) {
                throw 'InvalidCharacterError';
              }
              return token;
            },
            DOMTokenList = function (node) {
              var noClassName = typeof node.className === 'undefined',
                className = noClassName ? node.getAttribute('class') || '' : node.className,
                isSVG = noClassName || typeof className === 'object',
                value = (isSVG ? (noClassName ? className : className.baseVal) : className).replace(trim, '');
              if (value.length) {
                properties.push.apply(this, value.split(spaces));
              }
              this._isSVG = isSVG;
              this._ = node;
            },
            classListDescriptor = {
              get: function get() {
                return new DOMTokenList(this);
              },
              set: function () {}
            },
            uid = 'dom4-tmp-'.concat(Math.random() * +new Date()).replace('.', '-'),
            trim = /^\s+|\s+$/g,
            spaces = /\s+/,
            SPACE = '\x20',
            CLASS_LIST = 'classList',
            toggle = function toggle(token, force) {
              if (this.contains(token)) {
                if (!force) {
                  // force is not true (either false or omitted)
                  this.remove(token);
                }
              } else if (force === undefined || force) {
                force = true;
                this.add(token);
              }
              return !!force;
            },
            DocumentFragmentPrototype = window.DocumentFragment && DocumentFragment.prototype,
            Node = window.Node,
            NodePrototype = (Node || Element).prototype,
            CharacterData = window.CharacterData || Node,
            CharacterDataPrototype = CharacterData && CharacterData.prototype,
            DocumentType = window.DocumentType,
            DocumentTypePrototype = DocumentType && DocumentType.prototype,
            ElementPrototype = (window.Element || Node || window.HTMLElement).prototype,
            HTMLSelectElement = window.HTMLSelectElement || createElement('select').constructor,
            selectRemove = HTMLSelectElement.prototype.remove,
            ShadowRoot = window.ShadowRoot,
            SVGElement = window.SVGElement,
            // normalizes multiple ids as CSS query
            idSpaceFinder = / /g,
            idSpaceReplacer = '\\ ',
            createQueryMethod = function (methodName) {
              var createArray = methodName === 'querySelectorAll';
              return function (css) {
                var a,
                  i,
                  id,
                  query,
                  nl,
                  selectors,
                  node = this.parentNode;
                if (node) {
                  for (
                    id = this.getAttribute('id') || uid,
                      query = id === uid ? id : id.replace(idSpaceFinder, idSpaceReplacer),
                      selectors = css.split(','),
                      i = 0;
                    i < selectors.length;
                    i++
                  ) {
                    selectors[i] = '#' + query + ' ' + selectors[i];
                  }
                  css = selectors.join(',');
                }
                if (id === uid) this.setAttribute('id', id);
                nl = (node || this)[methodName](css);
                if (id === uid) this.removeAttribute('id');
                // return a list
                if (createArray) {
                  i = nl.length;
                  a = new Array(i);
                  while (i--) a[i] = nl[i];
                }
                // return node or null
                else {
                  a = nl;
                }
                return a;
              };
            },
            addQueryAndAll = function (where) {
              if (!('query' in where)) {
                where.query = ElementPrototype.query;
              }
              if (!('queryAll' in where)) {
                where.queryAll = ElementPrototype.queryAll;
              }
            },
            properties = [
              'matches',
              ElementPrototype.matchesSelector ||
                ElementPrototype.webkitMatchesSelector ||
                ElementPrototype.khtmlMatchesSelector ||
                ElementPrototype.mozMatchesSelector ||
                ElementPrototype.msMatchesSelector ||
                ElementPrototype.oMatchesSelector ||
                function matches(selector) {
                  var parentNode = this.parentNode;
                  return !!parentNode && -1 < indexOf.call(parentNode.querySelectorAll(selector), this);
                },
              'closest',
              function closest(selector) {
                var parentNode = this,
                  matches;
                while (
                  // document has no .matches
                  (matches = parentNode && parentNode.matches) &&
                  !parentNode.matches(selector)
                ) {
                  parentNode = parentNode.parentNode;
                }
                return matches ? parentNode : null;
              },
              'prepend',
              function prepend() {
                var firstChild = this.firstChild,
                  node = mutationMacro(arguments);
                if (firstChild) {
                  this.insertBefore(node, firstChild);
                } else {
                  this.appendChild(node);
                }
              },
              'append',
              function append() {
                this.appendChild(mutationMacro(arguments));
              },
              'before',
              function before() {
                var parentNode = this.parentNode;
                if (parentNode) {
                  parentNode.insertBefore(mutationMacro(arguments), this);
                }
              },
              'after',
              function after() {
                var parentNode = this.parentNode,
                  nextSibling = this.nextSibling,
                  node = mutationMacro(arguments);
                if (parentNode) {
                  if (nextSibling) {
                    parentNode.insertBefore(node, nextSibling);
                  } else {
                    parentNode.appendChild(node);
                  }
                }
              },
              // WARNING - DEPRECATED - use .replaceWith() instead
              'replace',
              function replace() {
                this.replaceWith.apply(this, arguments);
              },
              'replaceWith',
              function replaceWith() {
                var parentNode = this.parentNode;
                if (parentNode) {
                  parentNode.replaceChild(mutationMacro(arguments), this);
                }
              },
              'remove',
              function remove() {
                var parentNode = this.parentNode;
                if (parentNode) {
                  parentNode.removeChild(this);
                }
              },
              'query',
              createQueryMethod('querySelector'),
              'queryAll',
              createQueryMethod('querySelectorAll')
            ],
            slice = properties.slice,
            i = properties.length;
          i;
          i -= 2
        ) {
          property = properties[i - 2];
          if (!(property in ElementPrototype)) {
            ElementPrototype[property] = properties[i - 1];
          }
          if (property === 'remove') {
            // see https://github.com/WebReflection/dom4/issues/19
            HTMLSelectElement.prototype[property] = function () {
              return 0 < arguments.length ? selectRemove.apply(this, arguments) : ElementPrototype.remove.call(this);
            };
          }
          // see https://github.com/WebReflection/dom4/issues/18
          if (/^(?:before|after|replace|replaceWith|remove)$/.test(property)) {
            if (CharacterData && !(property in CharacterDataPrototype)) {
              CharacterDataPrototype[property] = properties[i - 1];
            }
            if (DocumentType && !(property in DocumentTypePrototype)) {
              DocumentTypePrototype[property] = properties[i - 1];
            }
          }
          // see https://github.com/WebReflection/dom4/pull/26
          if (/^(?:append|prepend)$/.test(property)) {
            if (DocumentFragmentPrototype) {
              if (!(property in DocumentFragmentPrototype)) {
                DocumentFragmentPrototype[property] = properties[i - 1];
              }
            } else {
              try {
                createDocumentFragment().constructor.prototype[property] = properties[i - 1];
              } catch (o_O) {}
            }
          }
        }

        // bring query and queryAll to the document too
        addQueryAndAll(document);

        // brings query and queryAll to fragments as well
        if (DocumentFragmentPrototype) {
          addQueryAndAll(DocumentFragmentPrototype);
        } else {
          try {
            addQueryAndAll(createDocumentFragment().constructor.prototype);
          } catch (o_O) {}
        }

        // bring query and queryAll to the ShadowRoot too
        if (ShadowRoot) {
          addQueryAndAll(ShadowRoot.prototype);
        }

        // most likely an IE9 only issue
        // see https://github.com/WebReflection/dom4/issues/6
        if (!createElement('a').matches('a')) {
          ElementPrototype[property] = (function (matches) {
            return function (selector) {
              return matches.call(this.parentNode ? this : createDocumentFragment().appendChild(this), selector);
            };
          })(ElementPrototype[property]);
        }

        // used to fix both old webkit and SVG
        DOMTokenList.prototype = {
          length: 0,
          add: function add() {
            for (var j = 0, token; j < arguments.length; j++) {
              token = arguments[j];
              if (!this.contains(token)) {
                properties.push.call(this, property);
              }
            }
            if (this._isSVG) {
              this._.setAttribute('class', '' + this);
            } else {
              this._.className = '' + this;
            }
          },
          contains: (function (indexOf) {
            return function contains(token) {
              i = indexOf.call(this, (property = verifyToken(token)));
              return -1 < i;
            };
          })(
            [].indexOf ||
              function (token) {
                i = this.length;
                while (i-- && this[i] !== token) {}
                return i;
              }
          ),
          item: function item(i) {
            return this[i] || null;
          },
          remove: function remove() {
            for (var j = 0, token; j < arguments.length; j++) {
              token = arguments[j];
              if (this.contains(token)) {
                properties.splice.call(this, i, 1);
              }
            }
            if (this._isSVG) {
              this._.setAttribute('class', '' + this);
            } else {
              this._.className = '' + this;
            }
          },
          toggle: toggle,
          toString: function toString() {
            return properties.join.call(this, SPACE);
          }
        };

        if (SVGElement && !(CLASS_LIST in SVGElement.prototype)) {
          defineProperty(SVGElement.prototype, CLASS_LIST, classListDescriptor);
        }

        // http://www.w3.org/TR/dom/#domtokenlist
        // iOS 5.1 has completely screwed this property
        // classList in ElementPrototype is false
        // but it's actually there as getter
        if (!(CLASS_LIST in document.documentElement)) {
          defineProperty(ElementPrototype, CLASS_LIST, classListDescriptor);
        } else {
          // iOS 5.1 and Nokia ASHA do not support multiple add or remove
          // trying to detect and fix that in here
          TemporaryTokenList = createElement('div')[CLASS_LIST];
          TemporaryTokenList.add('a', 'b', 'a');
          if ('a\x20b' != TemporaryTokenList) {
            // no other way to reach original methods in iOS 5.1
            TemporaryPrototype = TemporaryTokenList.constructor.prototype;
            if (!('add' in TemporaryPrototype)) {
              // ASHA double fails in here
              TemporaryPrototype = window.TemporaryTokenList.prototype;
            }
            wrapVerifyToken = function (original) {
              return function () {
                var i = 0;
                while (i < arguments.length) {
                  original.call(this, arguments[i++]);
                }
              };
            };
            TemporaryPrototype.add = wrapVerifyToken(TemporaryPrototype.add);
            TemporaryPrototype.remove = wrapVerifyToken(TemporaryPrototype.remove);
            // toggle is broken too ^_^ ... let's fix it
            TemporaryPrototype.toggle = toggle;
          }
        }

        if (!('contains' in NodePrototype)) {
          defineProperty(NodePrototype, 'contains', {
            value: function (el) {
              while (el && el !== this) el = el.parentNode;
              return this === el;
            }
          });
        }

        if (!('head' in document)) {
          defineProperty(document, 'head', {
            get: function () {
              return head || (head = document.getElementsByTagName('head')[0]);
            }
          });
        }

        // requestAnimationFrame partial polyfill
        (function () {
          for (
            var raf,
              rAF = window.requestAnimationFrame,
              cAF = window.cancelAnimationFrame,
              prefixes = ['o', 'ms', 'moz', 'webkit'],
              i = prefixes.length;
            !cAF && i--;

          ) {
            rAF = rAF || window[prefixes[i] + 'RequestAnimationFrame'];
            cAF = window[prefixes[i] + 'CancelAnimationFrame'] || window[prefixes[i] + 'CancelRequestAnimationFrame'];
          }
          if (!cAF) {
            // some FF apparently implemented rAF but no cAF
            if (rAF) {
              raf = rAF;
              rAF = function (callback) {
                var goOn = true;
                raf(function () {
                  if (goOn) callback.apply(this, arguments);
                });
                return function () {
                  goOn = false;
                };
              };
              cAF = function (id) {
                id();
              };
            } else {
              rAF = function (callback) {
                return setTimeout(callback, 15, 15);
              };
              cAF = function (id) {
                clearTimeout(id);
              };
            }
          }
          window.requestAnimationFrame = rAF;
          window.cancelAnimationFrame = cAF;
        })();

        // http://www.w3.org/TR/dom/#customevent
        try {
          new window.CustomEvent('?');
        } catch (o_O) {
          window.CustomEvent = (function (eventName, defaultInitDict) {
            // the infamous substitute
            function CustomEvent(type, eventInitDict) {
              /*jshint eqnull:true */
              var event = document.createEvent(eventName);
              if (typeof type != 'string') {
                throw new Error('An event name must be provided');
              }
              if (eventName == 'Event') {
                event.initCustomEvent = initCustomEvent;
              }
              if (eventInitDict == null) {
                eventInitDict = defaultInitDict;
              }
              event.initCustomEvent(type, eventInitDict.bubbles, eventInitDict.cancelable, eventInitDict.detail);
              return event;
            }

            // attached at runtime
            function initCustomEvent(type, bubbles, cancelable, detail) {
              /*jshint validthis:true*/
              this.initEvent(type, bubbles, cancelable);
              this.detail = detail;
            }

            // that's it
            return CustomEvent;
          })(
            // is this IE9 or IE10 ?
            // where CustomEvent is there
            // but not usable as construtor ?
            window.CustomEvent
              ? // use the CustomEvent interface in such case
                'CustomEvent'
              : 'Event',
            // otherwise the common compatible one
            {
              bubbles: false,
              cancelable: false,
              detail: null
            }
          );
        }

        // window.Event as constructor
        try {
          new Event('_');
        } catch (o_O) {
          /* jshint -W022 */
          o_O = (function ($Event) {
            function Event(type, init) {
              enoughArguments(arguments.length, 'Event');
              var out = document.createEvent('Event');
              if (!init) init = {};
              out.initEvent(type, !!init.bubbles, !!init.cancelable);
              return out;
            }
            Event.prototype = $Event.prototype;
            return Event;
          })(window.Event || function Event() {});
          defineProperty(window, 'Event', { value: o_O });
          // Android 4 gotcha
          if (Event !== o_O) Event = o_O;
        }

        // window.KeyboardEvent as constructor
        try {
          new KeyboardEvent('_', {});
        } catch (o_O) {
          /* jshint -W022 */
          o_O = (function ($KeyboardEvent) {
            // code inspired by https://gist.github.com/termi/4654819
            var initType = 0,
              defaults = {
                char: '',
                key: '',
                location: 0,
                ctrlKey: false,
                shiftKey: false,
                altKey: false,
                metaKey: false,
                altGraphKey: false,
                repeat: false,
                locale: navigator.language,
                detail: 0,
                bubbles: false,
                cancelable: false,
                keyCode: 0,
                charCode: 0,
                which: 0
              },
              eventType;
            try {
              var e = document.createEvent('KeyboardEvent');
              e.initKeyboardEvent('keyup', false, false, window, '+', 3, true, false, true, false, false);
              initType =
                ((e.keyIdentifier || e.key) == '+' &&
                  (e.keyLocation || e.location) == 3 &&
                  (e.ctrlKey ? (e.altKey ? 1 : 3) : e.shiftKey ? 2 : 4)) ||
                9;
            } catch (o_O) {}
            eventType = 0 < initType ? 'KeyboardEvent' : 'Event';

            function getModifier(init) {
              for (
                var out = [],
                  keys = [
                    'ctrlKey',
                    'Control',
                    'shiftKey',
                    'Shift',
                    'altKey',
                    'Alt',
                    'metaKey',
                    'Meta',
                    'altGraphKey',
                    'AltGraph'
                  ],
                  i = 0;
                i < keys.length;
                i += 2
              ) {
                if (init[keys[i]]) out.push(keys[i + 1]);
              }
              return out.join(' ');
            }

            function withDefaults(target, source) {
              for (var key in source) {
                if (source.hasOwnProperty(key) && !source.hasOwnProperty.call(target, key)) target[key] = source[key];
              }
              return target;
            }

            function withInitValues(key, out, init) {
              try {
                out[key] = init[key];
              } catch (o_O) {}
            }

            function KeyboardEvent(type, init) {
              enoughArguments(arguments.length, 'KeyboardEvent');
              init = withDefaults(init || {}, defaults);
              var out = document.createEvent(eventType),
                ctrlKey = init.ctrlKey,
                shiftKey = init.shiftKey,
                altKey = init.altKey,
                metaKey = init.metaKey,
                altGraphKey = init.altGraphKey,
                modifiers = initType > 3 ? getModifier(init) : null,
                key = String(init.key),
                chr = String(init.char),
                location = init.location,
                keyCode = init.keyCode || ((init.keyCode = key) && key.charCodeAt(0)) || 0,
                charCode = init.charCode || ((init.charCode = chr) && chr.charCodeAt(0)) || 0,
                bubbles = init.bubbles,
                cancelable = init.cancelable,
                repeat = init.repeat,
                locale = init.locale,
                view = init.view || window,
                args;
              if (!init.which) init.which = init.keyCode;
              if ('initKeyEvent' in out) {
                out.initKeyEvent(
                  type,
                  bubbles,
                  cancelable,
                  view,
                  ctrlKey,
                  altKey,
                  shiftKey,
                  metaKey,
                  keyCode,
                  charCode
                );
              } else if (0 < initType && 'initKeyboardEvent' in out) {
                args = [type, bubbles, cancelable, view];
                switch (initType) {
                  case 1:
                    args.push(key, location, ctrlKey, shiftKey, altKey, metaKey, altGraphKey);
                    break;
                  case 2:
                    args.push(ctrlKey, altKey, shiftKey, metaKey, keyCode, charCode);
                    break;
                  case 3:
                    args.push(key, location, ctrlKey, altKey, shiftKey, metaKey, altGraphKey);
                    break;
                  case 4:
                    args.push(key, location, modifiers, repeat, locale);
                    break;
                  default:
                    args.push(char, key, location, modifiers, repeat, locale);
                }
                out.initKeyboardEvent.apply(out, args);
              } else {
                out.initEvent(type, bubbles, cancelable);
              }
              for (key in out) {
                if (defaults.hasOwnProperty(key) && out[key] !== init[key]) {
                  withInitValues(key, out, init);
                }
              }
              return out;
            }
            KeyboardEvent.prototype = $KeyboardEvent.prototype;
            return KeyboardEvent;
          })(window.KeyboardEvent || function KeyboardEvent() {});
          defineProperty(window, 'KeyboardEvent', { value: o_O });
          // Android 4 gotcha
          if (KeyboardEvent !== o_O) KeyboardEvent = o_O;
        }

        // window.MouseEvent as constructor
        try {
          new MouseEvent('_', {});
        } catch (o_O) {
          /* jshint -W022 */
          o_O = (function ($MouseEvent) {
            function MouseEvent(type, init) {
              enoughArguments(arguments.length, 'MouseEvent');
              var out = document.createEvent('MouseEvent');
              if (!init) init = {};
              out.initMouseEvent(
                type,
                !!init.bubbles,
                !!init.cancelable,
                init.view || window,
                init.detail || 1,
                init.screenX || 0,
                init.screenY || 0,
                init.clientX || 0,
                init.clientY || 0,
                !!init.ctrlKey,
                !!init.altKey,
                !!init.shiftKey,
                !!init.metaKey,
                init.button || 0,
                init.relatedTarget || null
              );
              return out;
            }
            MouseEvent.prototype = $MouseEvent.prototype;
            return MouseEvent;
          })(window.MouseEvent || function MouseEvent() {});
          defineProperty(window, 'MouseEvent', { value: o_O });
          // Android 4 gotcha
          if (MouseEvent !== o_O) MouseEvent = o_O;
        }
      })(window);
      (function (global) {
        'use strict';

        // a WeakMap fallback for DOM nodes only used as key
        var DOMMap =
          global.WeakMap ||
          (function () {
            var counter = 0,
              dispatched = false,
              drop = false,
              value;

            function dispatch(key, ce, shouldDrop) {
              drop = shouldDrop;
              dispatched = false;
              value = undefined;
              key.dispatchEvent(ce);
            }

            function Handler(value) {
              this.value = value;
            }

            Handler.prototype.handleEvent = function handleEvent(e) {
              dispatched = true;
              if (drop) {
                e.currentTarget.removeEventListener(e.type, this, false);
              } else {
                value = this.value;
              }
            };

            function DOMMap() {
              counter++; // make id clashing highly improbable
              this.__ce__ = new Event('@DOMMap:' + counter + Math.random());
            }

            DOMMap.prototype = {
              constructor: DOMMap,
              delete: function del(key) {
                return dispatch(key, this.__ce__, true), dispatched;
              },
              get: function get(key) {
                dispatch(key, this.__ce__, false);
                var v = value;
                value = undefined;
                return v;
              },
              has: function has(key) {
                return dispatch(key, this.__ce__, false), dispatched;
              },
              set: function set(key, value) {
                dispatch(key, this.__ce__, true);
                key.addEventListener(this.__ce__.type, new Handler(value), false);
                return this;
              }
            };

            return DOMMap;
          })();

        function Dict() {}
        Dict.prototype = (Object.create || Object)(null);

        // https://dom.spec.whatwg.org/#interface-eventtarget

        function createEventListener(type, callback, options) {
          function eventListener(e) {
            if (eventListener.once) {
              e.currentTarget.removeEventListener(e.type, callback, eventListener);
              eventListener.removed = true;
            }
            if (eventListener.passive) {
              e.preventDefault = createEventListener.preventDefault;
            }
            if (typeof eventListener.callback === 'function') {
              /* jshint validthis: true */
              eventListener.callback.call(this, e);
            } else if (eventListener.callback) {
              eventListener.callback.handleEvent(e);
            }
            if (eventListener.passive) {
              delete e.preventDefault;
            }
          }
          eventListener.type = type;
          eventListener.callback = callback;
          eventListener.capture = !!options.capture;
          eventListener.passive = !!options.passive;
          eventListener.once = !!options.once;
          // currently pointless but specs say to use it, so ...
          eventListener.removed = false;
          return eventListener;
        }

        createEventListener.preventDefault = function preventDefault() {};

        var Event = global.CustomEvent,
          hOP = Object.prototype.hasOwnProperty,
          dE = global.dispatchEvent,
          aEL = global.addEventListener,
          rEL = global.removeEventListener,
          counter = 0,
          increment = function () {
            counter++;
          },
          indexOf =
            [].indexOf ||
            function indexOf(value) {
              var length = this.length;
              while (length--) {
                if (this[length] === value) {
                  break;
                }
              }
              return length;
            },
          getListenerKey = function (options) {
            return ''.concat(options.capture ? '1' : '0', options.passive ? '1' : '0', options.once ? '1' : '0');
          },
          augment,
          proto;

        try {
          aEL('_', increment, { once: true });
          dE(new Event('_'));
          dE(new Event('_'));
          rEL('_', increment, { once: true });
        } catch (o_O) {}

        if (counter !== 1) {
          (function () {
            var dm = new DOMMap();
            function createAEL(aEL) {
              return function addEventListener(type, handler, options) {
                if (options && typeof options !== 'boolean') {
                  var info = dm.get(this),
                    key = getListenerKey(options),
                    i,
                    tmp,
                    wrap;
                  if (!info) dm.set(this, (info = new Dict()));
                  if (!(type in info))
                    info[type] = {
                      handler: [],
                      wrap: []
                    };
                  tmp = info[type];
                  i = indexOf.call(tmp.handler, handler);
                  if (i < 0) {
                    i = tmp.handler.push(handler) - 1;
                    tmp.wrap[i] = wrap = new Dict();
                  } else {
                    wrap = tmp.wrap[i];
                  }
                  if (!(key in wrap)) {
                    wrap[key] = createEventListener(type, handler, options);
                    aEL.call(this, type, wrap[key], wrap[key].capture);
                  }
                } else {
                  aEL.call(this, type, handler, options);
                }
              };
            }
            function createREL(rEL) {
              return function removeEventListener(type, handler, options) {
                if (options && typeof options !== 'boolean') {
                  var info = dm.get(this),
                    key,
                    i,
                    tmp,
                    wrap;
                  if (info && type in info) {
                    tmp = info[type];
                    i = indexOf.call(tmp.handler, handler);
                    if (-1 < i) {
                      key = getListenerKey(options);
                      wrap = tmp.wrap[i];
                      if (key in wrap) {
                        rEL.call(this, type, wrap[key], wrap[key].capture);
                        delete wrap[key];
                        // return if there are other wraps
                        for (key in wrap) return;
                        // otherwise remove all the things
                        tmp.handler.splice(i, 1);
                        tmp.wrap.splice(i, 1);
                        // if there are no other handlers
                        if (tmp.handler.length === 0)
                          // drop the info[type] entirely
                          delete info[type];
                      }
                    }
                  }
                } else {
                  rEL.call(this, type, handler, options);
                }
              };
            }

            augment = function (Constructor) {
              if (!Constructor) return;
              var proto = Constructor.prototype;
              proto.addEventListener = createAEL(proto.addEventListener);
              proto.removeEventListener = createREL(proto.removeEventListener);
            };

            if (global.EventTarget) {
              augment(EventTarget);
            } else {
              augment(global.Text);
              augment(global.Element || global.HTMLElement);
              augment(global.HTMLDocument);
              augment(global.Window || { prototype: global });
              augment(global.XMLHttpRequest);
            }
          })();
        }
      })(self);

      /***/
    }
    /******/
  ]
);
